import Ca, { useState as vt, useEffect as kt, useRef as Nt, useContext as Ui, createElement as Hs, useCallback as $o, forwardRef as Nn, useImperativeHandle as Zs, useMemo as Ho } from "react";
import { useVideoConfig as za, useCurrentFrame as sa, spring as Mn, interpolate as yt, Img as pt, interpolateColors as Js, Audio as ra, Sequence as gt, delayRender as Ma, continueRender as bt, Video as Vn, getRemotionEnvironment as Gs, AbsoluteFill as Qs } from "remotion";
var va = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function er(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var ui = { exports: {} }, da = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Zn, so;
function Zo() {
  if (so) return Zn;
  so = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
  function n(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, r = 0; r < 10; r++)
        s["_" + String.fromCharCode(r)] = r;
      var c = Object.getOwnPropertyNames(s).map(function(f) {
        return s[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        l[f] = f;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Zn = i() ? Object.assign : function(o, s) {
    for (var r, c = n(o), l, f = 1; f < arguments.length; f++) {
      r = Object(arguments[f]);
      for (var m in r)
        e.call(r, m) && (c[m] = r[m]);
      if (t) {
        l = t(r);
        for (var v = 0; v < l.length; v++)
          a.call(r, l[v]) && (c[l[v]] = r[l[v]]);
      }
    }
    return c;
  }, Zn;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ro;
function tr() {
  if (ro) return da;
  ro = 1, Zo();
  var t = Ca, e = 60103;
  if (da.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var a = Symbol.for;
    e = a("react.element"), da.Fragment = a("react.fragment");
  }
  var n = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = Object.prototype.hasOwnProperty, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(r, c, l) {
    var f, m = {}, v = null, k = null;
    l !== void 0 && (v = "" + l), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (f in c) i.call(c, f) && !o.hasOwnProperty(f) && (m[f] = c[f]);
    if (r && r.defaultProps) for (f in c = r.defaultProps, c) m[f] === void 0 && (m[f] = c[f]);
    return { $$typeof: e, type: r, key: v, ref: k, props: m, _owner: n.current };
  }
  return da.jsx = s, da.jsxs = s, da;
}
var Jn = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lo;
function ar() {
  return lo || (lo = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      var e = Ca, a = Zo(), n = 60103, i = 60106;
      t.Fragment = 60107;
      var o = 60108, s = 60114, r = 60109, c = 60110, l = 60112, f = 60113, m = 60120, v = 60115, k = 60116, C = 60121, E = 60122, b = 60117, D = 60129, j = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var x = Symbol.for;
        n = x("react.element"), i = x("react.portal"), t.Fragment = x("react.fragment"), o = x("react.strict_mode"), s = x("react.profiler"), r = x("react.provider"), c = x("react.context"), l = x("react.forward_ref"), f = x("react.suspense"), m = x("react.suspense_list"), v = x("react.memo"), k = x("react.lazy"), C = x("react.block"), E = x("react.server.block"), b = x("react.fundamental"), x("react.scope"), x("react.opaque.id"), D = x("react.debug_trace_mode"), x("react.offscreen"), j = x("react.legacy_hidden");
      }
      var _ = typeof Symbol == "function" && Symbol.iterator, y = "@@iterator";
      function H(d) {
        if (d === null || typeof d != "object")
          return null;
        var T = _ && d[_] || d[y];
        return typeof T == "function" ? T : null;
      }
      var $ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function Y(d) {
        {
          for (var T = arguments.length, O = new Array(T > 1 ? T - 1 : 0), ie = 1; ie < T; ie++)
            O[ie - 1] = arguments[ie];
          ae("error", d, O);
        }
      }
      function ae(d, T, O) {
        {
          var ie = $.ReactDebugCurrentFrame, Ue = ie.getStackAddendum();
          Ue !== "" && (T += "%s", O = O.concat([Ue]));
          var Ce = O.map(function(ye) {
            return "" + ye;
          });
          Ce.unshift("Warning: " + T), Function.prototype.apply.call(console[d], console, Ce);
        }
      }
      var ve = !1;
      function de(d) {
        return !!(typeof d == "string" || typeof d == "function" || d === t.Fragment || d === s || d === D || d === o || d === f || d === m || d === j || ve || typeof d == "object" && d !== null && (d.$$typeof === k || d.$$typeof === v || d.$$typeof === r || d.$$typeof === c || d.$$typeof === l || d.$$typeof === b || d.$$typeof === C || d[0] === E));
      }
      function N(d, T, O) {
        var ie = T.displayName || T.name || "";
        return d.displayName || (ie !== "" ? O + "(" + ie + ")" : O);
      }
      function P(d) {
        return d.displayName || "Context";
      }
      function M(d) {
        if (d == null)
          return null;
        if (typeof d.tag == "number" && Y("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof d == "function")
          return d.displayName || d.name || null;
        if (typeof d == "string")
          return d;
        switch (d) {
          case t.Fragment:
            return "Fragment";
          case i:
            return "Portal";
          case s:
            return "Profiler";
          case o:
            return "StrictMode";
          case f:
            return "Suspense";
          case m:
            return "SuspenseList";
        }
        if (typeof d == "object")
          switch (d.$$typeof) {
            case c:
              var T = d;
              return P(T) + ".Consumer";
            case r:
              var O = d;
              return P(O._context) + ".Provider";
            case l:
              return N(d, d.render, "ForwardRef");
            case v:
              return M(d.type);
            case C:
              return M(d._render);
            case k: {
              var ie = d, Ue = ie._payload, Ce = ie._init;
              try {
                return M(Ce(Ue));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var V = 0, be, Z, oe, ke, we, re, A;
      function w() {
      }
      w.__reactDisabledLog = !0;
      function I() {
        {
          if (V === 0) {
            be = console.log, Z = console.info, oe = console.warn, ke = console.error, we = console.group, re = console.groupCollapsed, A = console.groupEnd;
            var d = {
              configurable: !0,
              enumerable: !0,
              value: w,
              writable: !0
            };
            Object.defineProperties(console, {
              info: d,
              log: d,
              warn: d,
              error: d,
              group: d,
              groupCollapsed: d,
              groupEnd: d
            });
          }
          V++;
        }
      }
      function B() {
        {
          if (V--, V === 0) {
            var d = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: a({}, d, {
                value: be
              }),
              info: a({}, d, {
                value: Z
              }),
              warn: a({}, d, {
                value: oe
              }),
              error: a({}, d, {
                value: ke
              }),
              group: a({}, d, {
                value: we
              }),
              groupCollapsed: a({}, d, {
                value: re
              }),
              groupEnd: a({}, d, {
                value: A
              })
            });
          }
          V < 0 && Y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var g = $.ReactCurrentDispatcher, ne;
      function z(d, T, O) {
        {
          if (ne === void 0)
            try {
              throw Error();
            } catch (Ue) {
              var ie = Ue.stack.trim().match(/\n( *(at )?)/);
              ne = ie && ie[1] || "";
            }
          return `
` + ne + d;
        }
      }
      var me = !1, Q;
      {
        var G = typeof WeakMap == "function" ? WeakMap : Map;
        Q = new G();
      }
      function F(d, T) {
        if (!d || me)
          return "";
        {
          var O = Q.get(d);
          if (O !== void 0)
            return O;
        }
        var ie;
        me = !0;
        var Ue = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Ce;
        Ce = g.current, g.current = null, I();
        try {
          if (T) {
            var ye = function() {
              throw Error();
            };
            if (Object.defineProperty(ye.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(ye, []);
              } catch (K) {
                ie = K;
              }
              Reflect.construct(d, [], ye);
            } else {
              try {
                ye.call();
              } catch (K) {
                ie = K;
              }
              d.call(ye.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (K) {
              ie = K;
            }
            d();
          }
        } catch (K) {
          if (K && ie && typeof K.stack == "string") {
            for (var he = K.stack.split(`
`), Re = ie.stack.split(`
`), Oe = he.length - 1, Ne = Re.length - 1; Oe >= 1 && Ne >= 0 && he[Oe] !== Re[Ne]; )
              Ne--;
            for (; Oe >= 1 && Ne >= 0; Oe--, Ne--)
              if (he[Oe] !== Re[Ne]) {
                if (Oe !== 1 || Ne !== 1)
                  do
                    if (Oe--, Ne--, Ne < 0 || he[Oe] !== Re[Ne]) {
                      var it = `
` + he[Oe].replace(" at new ", " at ");
                      return typeof d == "function" && Q.set(d, it), it;
                    }
                  while (Oe >= 1 && Ne >= 0);
                break;
              }
          }
        } finally {
          me = !1, g.current = Ce, B(), Error.prepareStackTrace = Ue;
        }
        var zt = d ? d.displayName || d.name : "", ln = zt ? z(zt) : "";
        return typeof d == "function" && Q.set(d, ln), ln;
      }
      function Fe(d, T, O) {
        return F(d, !1);
      }
      function R(d) {
        var T = d.prototype;
        return !!(T && T.isReactComponent);
      }
      function le(d, T, O) {
        if (d == null)
          return "";
        if (typeof d == "function")
          return F(d, R(d));
        if (typeof d == "string")
          return z(d);
        switch (d) {
          case f:
            return z("Suspense");
          case m:
            return z("SuspenseList");
        }
        if (typeof d == "object")
          switch (d.$$typeof) {
            case l:
              return Fe(d.render);
            case v:
              return le(d.type, T, O);
            case C:
              return Fe(d._render);
            case k: {
              var ie = d, Ue = ie._payload, Ce = ie._init;
              try {
                return le(Ce(Ue), T, O);
              } catch {
              }
            }
          }
        return "";
      }
      var Ae = {}, ue = $.ReactDebugCurrentFrame;
      function De(d) {
        if (d) {
          var T = d._owner, O = le(d.type, d._source, T ? T.type : null);
          ue.setExtraStackFrame(O);
        } else
          ue.setExtraStackFrame(null);
      }
      function tt(d, T, O, ie, Ue) {
        {
          var Ce = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var ye in d)
            if (Ce(d, ye)) {
              var he = void 0;
              try {
                if (typeof d[ye] != "function") {
                  var Re = Error((ie || "React class") + ": " + O + " type `" + ye + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof d[ye] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Re.name = "Invariant Violation", Re;
                }
                he = d[ye](T, ye, ie, O, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Oe) {
                he = Oe;
              }
              he && !(he instanceof Error) && (De(Ue), Y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ie || "React class", O, ye, typeof he), De(null)), he instanceof Error && !(he.message in Ae) && (Ae[he.message] = !0, De(Ue), Y("Failed %s type: %s", O, he.message), De(null));
            }
        }
      }
      var Be = $.ReactCurrentOwner, rt = Object.prototype.hasOwnProperty, Ft = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Xe, ee, xe;
      xe = {};
      function at(d) {
        if (rt.call(d, "ref")) {
          var T = Object.getOwnPropertyDescriptor(d, "ref").get;
          if (T && T.isReactWarning)
            return !1;
        }
        return d.ref !== void 0;
      }
      function Dt(d) {
        if (rt.call(d, "key")) {
          var T = Object.getOwnPropertyDescriptor(d, "key").get;
          if (T && T.isReactWarning)
            return !1;
        }
        return d.key !== void 0;
      }
      function Ge(d, T) {
        if (typeof d.ref == "string" && Be.current && T && Be.current.stateNode !== T) {
          var O = M(Be.current.type);
          xe[O] || (Y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', M(Be.current.type), d.ref), xe[O] = !0);
        }
      }
      function tn(d, T) {
        {
          var O = function() {
            Xe || (Xe = !0, Y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", T));
          };
          O.isReactWarning = !0, Object.defineProperty(d, "key", {
            get: O,
            configurable: !0
          });
        }
      }
      function Ta(d, T) {
        {
          var O = function() {
            ee || (ee = !0, Y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", T));
          };
          O.isReactWarning = !0, Object.defineProperty(d, "ref", {
            get: O,
            configurable: !0
          });
        }
      }
      var an = function(d, T, O, ie, Ue, Ce, ye) {
        var he = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: d,
          key: T,
          ref: O,
          props: ye,
          // Record the component responsible for creating this element.
          _owner: Ce
        };
        return he._store = {}, Object.defineProperty(he._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(he, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: ie
        }), Object.defineProperty(he, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Ue
        }), Object.freeze && (Object.freeze(he.props), Object.freeze(he)), he;
      };
      function ua(d, T, O, ie, Ue) {
        {
          var Ce, ye = {}, he = null, Re = null;
          O !== void 0 && (he = "" + O), Dt(T) && (he = "" + T.key), at(T) && (Re = T.ref, Ge(T, Ue));
          for (Ce in T)
            rt.call(T, Ce) && !Ft.hasOwnProperty(Ce) && (ye[Ce] = T[Ce]);
          if (d && d.defaultProps) {
            var Oe = d.defaultProps;
            for (Ce in Oe)
              ye[Ce] === void 0 && (ye[Ce] = Oe[Ce]);
          }
          if (he || Re) {
            var Ne = typeof d == "function" ? d.displayName || d.name || "Unknown" : d;
            he && tn(ye, Ne), Re && Ta(ye, Ne);
          }
          return an(d, he, Re, Ue, ie, Be.current, ye);
        }
      }
      var Bt = $.ReactCurrentOwner, nt = $.ReactDebugCurrentFrame;
      function Qe(d) {
        if (d) {
          var T = d._owner, O = le(d.type, d._source, T ? T.type : null);
          nt.setExtraStackFrame(O);
        } else
          nt.setExtraStackFrame(null);
      }
      var $t;
      $t = !1;
      function Ht(d) {
        return typeof d == "object" && d !== null && d.$$typeof === n;
      }
      function nn() {
        {
          if (Bt.current) {
            var d = M(Bt.current.type);
            if (d)
              return `

Check the render method of \`` + d + "`.";
          }
          return "";
        }
      }
      function fa(d) {
        return "";
      }
      var Zt = {};
      function Yn(d) {
        {
          var T = nn();
          if (!T) {
            var O = typeof d == "string" ? d : d.displayName || d.name;
            O && (T = `

Check the top-level render call using <` + O + ">.");
          }
          return T;
        }
      }
      function Rt(d, T) {
        {
          if (!d._store || d._store.validated || d.key != null)
            return;
          d._store.validated = !0;
          var O = Yn(T);
          if (Zt[O])
            return;
          Zt[O] = !0;
          var ie = "";
          d && d._owner && d._owner !== Bt.current && (ie = " It was passed a child from " + M(d._owner.type) + "."), Qe(d), Y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', O, ie), Qe(null);
        }
      }
      function on(d, T) {
        {
          if (typeof d != "object")
            return;
          if (Array.isArray(d))
            for (var O = 0; O < d.length; O++) {
              var ie = d[O];
              Ht(ie) && Rt(ie, T);
            }
          else if (Ht(d))
            d._store && (d._store.validated = !0);
          else if (d) {
            var Ue = H(d);
            if (typeof Ue == "function" && Ue !== d.entries)
              for (var Ce = Ue.call(d), ye; !(ye = Ce.next()).done; )
                Ht(ye.value) && Rt(ye.value, T);
          }
        }
      }
      function $n(d) {
        {
          var T = d.type;
          if (T == null || typeof T == "string")
            return;
          var O;
          if (typeof T == "function")
            O = T.propTypes;
          else if (typeof T == "object" && (T.$$typeof === l || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          T.$$typeof === v))
            O = T.propTypes;
          else
            return;
          if (O) {
            var ie = M(T);
            tt(O, d.props, "prop", ie, d);
          } else if (T.PropTypes !== void 0 && !$t) {
            $t = !0;
            var Ue = M(T);
            Y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ue || "Unknown");
          }
          typeof T.getDefaultProps == "function" && !T.getDefaultProps.isReactClassApproved && Y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Ve(d) {
        {
          for (var T = Object.keys(d.props), O = 0; O < T.length; O++) {
            var ie = T[O];
            if (ie !== "children" && ie !== "key") {
              Qe(d), Y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ie), Qe(null);
              break;
            }
          }
          d.ref !== null && (Qe(d), Y("Invalid attribute `ref` supplied to `React.Fragment`."), Qe(null));
        }
      }
      function Ct(d, T, O, ie, Ue, Ce) {
        {
          var ye = de(d);
          if (!ye) {
            var he = "";
            (d === void 0 || typeof d == "object" && d !== null && Object.keys(d).length === 0) && (he += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Re = fa();
            Re ? he += Re : he += nn();
            var Oe;
            d === null ? Oe = "null" : Array.isArray(d) ? Oe = "array" : d !== void 0 && d.$$typeof === n ? (Oe = "<" + (M(d.type) || "Unknown") + " />", he = " Did you accidentally export a JSX literal instead of a component?") : Oe = typeof d, Y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Oe, he);
          }
          var Ne = ua(d, T, O, Ue, Ce);
          if (Ne == null)
            return Ne;
          if (ye) {
            var it = T.children;
            if (it !== void 0)
              if (ie)
                if (Array.isArray(it)) {
                  for (var zt = 0; zt < it.length; zt++)
                    on(it[zt], d);
                  Object.freeze && Object.freeze(it);
                } else
                  Y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                on(it, d);
          }
          return d === t.Fragment ? Ve(Ne) : $n(Ne), Ne;
        }
      }
      function Hn(d, T, O) {
        return Ct(d, T, O, !0);
      }
      function sn(d, T, O) {
        return Ct(d, T, O, !1);
      }
      var ja = sn, rn = Hn;
      t.jsx = ja, t.jsxs = rn;
    }();
  }(Jn)), Jn;
}
process.env.NODE_ENV === "production" ? ui.exports = tr() : ui.exports = ar();
var h = ui.exports, _e;
(function(t) {
  t.assertEqual = (i) => i;
  function e(i) {
  }
  t.assertIs = e;
  function a(i) {
    throw new Error();
  }
  t.assertNever = a, t.arrayToEnum = (i) => {
    const o = {};
    for (const s of i)
      o[s] = s;
    return o;
  }, t.getValidEnumValues = (i) => {
    const o = t.objectKeys(i).filter((r) => typeof i[i[r]] != "number"), s = {};
    for (const r of o)
      s[r] = i[r];
    return t.objectValues(s);
  }, t.objectValues = (i) => t.objectKeys(i).map(function(o) {
    return i[o];
  }), t.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const o = [];
    for (const s in i)
      Object.prototype.hasOwnProperty.call(i, s) && o.push(s);
    return o;
  }, t.find = (i, o) => {
    for (const s of i)
      if (o(s))
        return s;
  }, t.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && isFinite(i) && Math.floor(i) === i;
  function n(i, o = " | ") {
    return i.map((s) => typeof s == "string" ? `'${s}'` : s).join(o);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (i, o) => typeof o == "bigint" ? o.toString() : o;
})(_e || (_e = {}));
var fi;
(function(t) {
  t.mergeShapes = (e, a) => ({
    ...e,
    ...a
    // second overwrites first
  });
})(fi || (fi = {}));
const X = _e.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Ot = (t) => {
  switch (typeof t) {
    case "undefined":
      return X.undefined;
    case "string":
      return X.string;
    case "number":
      return isNaN(t) ? X.nan : X.number;
    case "boolean":
      return X.boolean;
    case "function":
      return X.function;
    case "bigint":
      return X.bigint;
    case "symbol":
      return X.symbol;
    case "object":
      return Array.isArray(t) ? X.array : t === null ? X.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? X.promise : typeof Map < "u" && t instanceof Map ? X.map : typeof Set < "u" && t instanceof Set ? X.set : typeof Date < "u" && t instanceof Date ? X.date : X.object;
    default:
      return X.unknown;
  }
}, U = _e.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), nr = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class ft extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const a = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, a) : this.__proto__ = a, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const a = e || function(o) {
      return o.message;
    }, n = { _errors: [] }, i = (o) => {
      for (const s of o.issues)
        if (s.code === "invalid_union")
          s.unionErrors.map(i);
        else if (s.code === "invalid_return_type")
          i(s.returnTypeError);
        else if (s.code === "invalid_arguments")
          i(s.argumentsError);
        else if (s.path.length === 0)
          n._errors.push(a(s));
        else {
          let r = n, c = 0;
          for (; c < s.path.length; ) {
            const l = s.path[c];
            c === s.path.length - 1 ? (r[l] = r[l] || { _errors: [] }, r[l]._errors.push(a(s))) : r[l] = r[l] || { _errors: [] }, r = r[l], c++;
          }
        }
    };
    return i(this), n;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, _e.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (a) => a.message) {
    const a = {}, n = [];
    for (const i of this.issues)
      i.path.length > 0 ? (a[i.path[0]] = a[i.path[0]] || [], a[i.path[0]].push(e(i))) : n.push(e(i));
    return { formErrors: n, fieldErrors: a };
  }
  get formErrors() {
    return this.flatten();
  }
}
ft.create = (t) => new ft(t);
const Va = (t, e) => {
  let a;
  switch (t.code) {
    case U.invalid_type:
      t.received === X.undefined ? a = "Required" : a = `Expected ${t.expected}, received ${t.received}`;
      break;
    case U.invalid_literal:
      a = `Invalid literal value, expected ${JSON.stringify(t.expected, _e.jsonStringifyReplacer)}`;
      break;
    case U.unrecognized_keys:
      a = `Unrecognized key(s) in object: ${_e.joinValues(t.keys, ", ")}`;
      break;
    case U.invalid_union:
      a = "Invalid input";
      break;
    case U.invalid_union_discriminator:
      a = `Invalid discriminator value. Expected ${_e.joinValues(t.options)}`;
      break;
    case U.invalid_enum_value:
      a = `Invalid enum value. Expected ${_e.joinValues(t.options)}, received '${t.received}'`;
      break;
    case U.invalid_arguments:
      a = "Invalid function arguments";
      break;
    case U.invalid_return_type:
      a = "Invalid function return type";
      break;
    case U.invalid_date:
      a = "Invalid date";
      break;
    case U.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (a = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (a = `${a} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? a = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? a = `Invalid input: must end with "${t.validation.endsWith}"` : _e.assertNever(t.validation) : t.validation !== "regex" ? a = `Invalid ${t.validation}` : a = "Invalid";
      break;
    case U.too_small:
      t.type === "array" ? a = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? a = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? a = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? a = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : a = "Invalid input";
      break;
    case U.too_big:
      t.type === "array" ? a = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? a = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? a = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? a = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? a = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : a = "Invalid input";
      break;
    case U.custom:
      a = "Invalid input";
      break;
    case U.invalid_intersection_types:
      a = "Intersection results could not be merged";
      break;
    case U.not_multiple_of:
      a = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case U.not_finite:
      a = "Number must be finite";
      break;
    default:
      a = e.defaultError, _e.assertNever(t);
  }
  return { message: a };
};
let Jo = Va;
function ir(t) {
  Jo = t;
}
function Fn() {
  return Jo;
}
const Cn = (t) => {
  const { data: e, path: a, errorMaps: n, issueData: i } = t, o = [...a, ...i.path || []], s = {
    ...i,
    path: o
  };
  let r = "";
  const c = n.filter((l) => !!l).slice().reverse();
  for (const l of c)
    r = l(s, { data: e, defaultError: r }).message;
  return {
    ...i,
    path: o,
    message: i.message || r
  };
}, or = [];
function L(t, e) {
  const a = Cn({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      Fn(),
      Va
      // then global default map
    ].filter((n) => !!n)
  });
  t.common.issues.push(a);
}
class We {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, a) {
    const n = [];
    for (const i of a) {
      if (i.status === "aborted")
        return ce;
      i.status === "dirty" && e.dirty(), n.push(i.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, a) {
    const n = [];
    for (const i of a)
      n.push({
        key: await i.key,
        value: await i.value
      });
    return We.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, a) {
    const n = {};
    for (const i of a) {
      const { key: o, value: s } = i;
      if (o.status === "aborted" || s.status === "aborted")
        return ce;
      o.status === "dirty" && e.dirty(), s.status === "dirty" && e.dirty(), o.value !== "__proto__" && (typeof s.value < "u" || i.alwaysSet) && (n[o.value] = s.value);
    }
    return { status: e.value, value: n };
  }
}
const ce = Object.freeze({
  status: "aborted"
}), Go = (t) => ({ status: "dirty", value: t }), He = (t) => ({ status: "valid", value: t }), di = (t) => t.status === "aborted", mi = (t) => t.status === "dirty", Xa = (t) => t.status === "valid", zn = (t) => typeof Promise < "u" && t instanceof Promise;
var te;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(te || (te = {}));
class wt {
  constructor(e, a, n, i) {
    this._cachedPath = [], this.parent = e, this.data = a, this._path = n, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const co = (t, e) => {
  if (Xa(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const a = new ft(t.common.issues);
      return this._error = a, this._error;
    }
  };
};
function fe(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: a, required_error: n, description: i } = t;
  if (e && (a || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: i } : { errorMap: (s, r) => s.code !== "invalid_type" ? { message: r.defaultError } : typeof r.data > "u" ? { message: n ?? r.defaultError } : { message: a ?? r.defaultError }, description: i };
}
class pe {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Ot(e.data);
  }
  _getOrReturnCtx(e, a) {
    return a || {
      common: e.parent.common,
      data: e.data,
      parsedType: Ot(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new We(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Ot(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const a = this._parse(e);
    if (zn(a))
      throw new Error("Synchronous parse encountered promise.");
    return a;
  }
  _parseAsync(e) {
    const a = this._parse(e);
    return Promise.resolve(a);
  }
  parse(e, a) {
    const n = this.safeParse(e, a);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, a) {
    var n;
    const i = {
      common: {
        issues: [],
        async: (n = a == null ? void 0 : a.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: a == null ? void 0 : a.errorMap
      },
      path: (a == null ? void 0 : a.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Ot(e)
    }, o = this._parseSync({ data: e, path: i.path, parent: i });
    return co(i, o);
  }
  async parseAsync(e, a) {
    const n = await this.safeParseAsync(e, a);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, a) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: a == null ? void 0 : a.errorMap,
        async: !0
      },
      path: (a == null ? void 0 : a.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Ot(e)
    }, i = this._parse({ data: e, path: n.path, parent: n }), o = await (zn(i) ? i : Promise.resolve(i));
    return co(n, o);
  }
  refine(e, a) {
    const n = (i) => typeof a == "string" || typeof a > "u" ? { message: a } : typeof a == "function" ? a(i) : a;
    return this._refinement((i, o) => {
      const s = e(i), r = () => o.addIssue({
        code: U.custom,
        ...n(i)
      });
      return typeof Promise < "u" && s instanceof Promise ? s.then((c) => c ? !0 : (r(), !1)) : s ? !0 : (r(), !1);
    });
  }
  refinement(e, a) {
    return this._refinement((n, i) => e(n) ? !0 : (i.addIssue(typeof a == "function" ? a(n, i) : a), !1));
  }
  _refinement(e) {
    return new mt({
      schema: this,
      typeName: se.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return Ut.create(this, this._def);
  }
  nullable() {
    return na.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return dt.create(this, this._def);
  }
  promise() {
    return xa.create(this, this._def);
  }
  or(e) {
    return Wa.create([this, e], this._def);
  }
  and(e) {
    return Ya.create(this, e, this._def);
  }
  transform(e) {
    return new mt({
      ...fe(this._def),
      schema: this,
      typeName: se.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const a = typeof e == "function" ? e : () => e;
    return new Ga({
      ...fe(this._def),
      innerType: this,
      defaultValue: a,
      typeName: se.ZodDefault
    });
  }
  brand() {
    return new es({
      typeName: se.ZodBranded,
      type: this,
      ...fe(this._def)
    });
  }
  catch(e) {
    const a = typeof e == "function" ? e : () => e;
    return new Un({
      ...fe(this._def),
      innerType: this,
      catchValue: a,
      typeName: se.ZodCatch
    });
  }
  describe(e) {
    const a = this.constructor;
    return new a({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return en.create(this, e);
  }
  readonly() {
    return An.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const sr = /^c[^\s-]{8,}$/i, rr = /^[a-z][a-z0-9]*$/, lr = /^[0-9A-HJKMNP-TV-Z]{26}$/, cr = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, ur = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, fr = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Gn;
const dr = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, mr = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, pr = (t) => t.precision ? t.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}Z$`) : t.precision === 0 ? t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function hr(t, e) {
  return !!((e === "v4" || !e) && dr.test(t) || (e === "v6" || !e) && mr.test(t));
}
class ut extends pe {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== X.string) {
      const o = this._getOrReturnCtx(e);
      return L(
        o,
        {
          code: U.invalid_type,
          expected: X.string,
          received: o.parsedType
        }
        //
      ), ce;
    }
    const n = new We();
    let i;
    for (const o of this._def.checks)
      if (o.kind === "min")
        e.data.length < o.value && (i = this._getOrReturnCtx(e, i), L(i, {
          code: U.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), n.dirty());
      else if (o.kind === "max")
        e.data.length > o.value && (i = this._getOrReturnCtx(e, i), L(i, {
          code: U.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), n.dirty());
      else if (o.kind === "length") {
        const s = e.data.length > o.value, r = e.data.length < o.value;
        (s || r) && (i = this._getOrReturnCtx(e, i), s ? L(i, {
          code: U.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }) : r && L(i, {
          code: U.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }), n.dirty());
      } else if (o.kind === "email")
        ur.test(e.data) || (i = this._getOrReturnCtx(e, i), L(i, {
          validation: "email",
          code: U.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "emoji")
        Gn || (Gn = new RegExp(fr, "u")), Gn.test(e.data) || (i = this._getOrReturnCtx(e, i), L(i, {
          validation: "emoji",
          code: U.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "uuid")
        cr.test(e.data) || (i = this._getOrReturnCtx(e, i), L(i, {
          validation: "uuid",
          code: U.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "cuid")
        sr.test(e.data) || (i = this._getOrReturnCtx(e, i), L(i, {
          validation: "cuid",
          code: U.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "cuid2")
        rr.test(e.data) || (i = this._getOrReturnCtx(e, i), L(i, {
          validation: "cuid2",
          code: U.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "ulid")
        lr.test(e.data) || (i = this._getOrReturnCtx(e, i), L(i, {
          validation: "ulid",
          code: U.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "url")
        try {
          new URL(e.data);
        } catch {
          i = this._getOrReturnCtx(e, i), L(i, {
            validation: "url",
            code: U.invalid_string,
            message: o.message
          }), n.dirty();
        }
      else o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(e.data) || (i = this._getOrReturnCtx(e, i), L(i, {
        validation: "regex",
        code: U.invalid_string,
        message: o.message
      }), n.dirty())) : o.kind === "trim" ? e.data = e.data.trim() : o.kind === "includes" ? e.data.includes(o.value, o.position) || (i = this._getOrReturnCtx(e, i), L(i, {
        code: U.invalid_string,
        validation: { includes: o.value, position: o.position },
        message: o.message
      }), n.dirty()) : o.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : o.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : o.kind === "startsWith" ? e.data.startsWith(o.value) || (i = this._getOrReturnCtx(e, i), L(i, {
        code: U.invalid_string,
        validation: { startsWith: o.value },
        message: o.message
      }), n.dirty()) : o.kind === "endsWith" ? e.data.endsWith(o.value) || (i = this._getOrReturnCtx(e, i), L(i, {
        code: U.invalid_string,
        validation: { endsWith: o.value },
        message: o.message
      }), n.dirty()) : o.kind === "datetime" ? pr(o).test(e.data) || (i = this._getOrReturnCtx(e, i), L(i, {
        code: U.invalid_string,
        validation: "datetime",
        message: o.message
      }), n.dirty()) : o.kind === "ip" ? hr(e.data, o.version) || (i = this._getOrReturnCtx(e, i), L(i, {
        validation: "ip",
        code: U.invalid_string,
        message: o.message
      }), n.dirty()) : _e.assertNever(o);
    return { status: n.value, value: e.data };
  }
  _regex(e, a, n) {
    return this.refinement((i) => e.test(i), {
      validation: a,
      code: U.invalid_string,
      ...te.errToObj(n)
    });
  }
  _addCheck(e) {
    return new ut({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...te.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...te.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...te.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...te.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...te.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...te.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...te.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...te.errToObj(e) });
  }
  datetime(e) {
    var a;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (a = e == null ? void 0 : e.offset) !== null && a !== void 0 ? a : !1,
      ...te.errToObj(e == null ? void 0 : e.message)
    });
  }
  regex(e, a) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...te.errToObj(a)
    });
  }
  includes(e, a) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: a == null ? void 0 : a.position,
      ...te.errToObj(a == null ? void 0 : a.message)
    });
  }
  startsWith(e, a) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...te.errToObj(a)
    });
  }
  endsWith(e, a) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...te.errToObj(a)
    });
  }
  min(e, a) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...te.errToObj(a)
    });
  }
  max(e, a) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...te.errToObj(a)
    });
  }
  length(e, a) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...te.errToObj(a)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(e) {
    return this.min(1, te.errToObj(e));
  }
  trim() {
    return new ut({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ut({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ut({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get minLength() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "min" && (e === null || a.value > e) && (e = a.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "max" && (e === null || a.value < e) && (e = a.value);
    return e;
  }
}
ut.create = (t) => {
  var e;
  return new ut({
    checks: [],
    typeName: se.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...fe(t)
  });
};
function gr(t, e) {
  const a = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, i = a > n ? a : n, o = parseInt(t.toFixed(i).replace(".", "")), s = parseInt(e.toFixed(i).replace(".", ""));
  return o % s / Math.pow(10, i);
}
class Mt extends pe {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== X.number) {
      const o = this._getOrReturnCtx(e);
      return L(o, {
        code: U.invalid_type,
        expected: X.number,
        received: o.parsedType
      }), ce;
    }
    let n;
    const i = new We();
    for (const o of this._def.checks)
      o.kind === "int" ? _e.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), L(n, {
        code: U.invalid_type,
        expected: "integer",
        received: "float",
        message: o.message
      }), i.dirty()) : o.kind === "min" ? (o.inclusive ? e.data < o.value : e.data <= o.value) && (n = this._getOrReturnCtx(e, n), L(n, {
        code: U.too_small,
        minimum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), i.dirty()) : o.kind === "max" ? (o.inclusive ? e.data > o.value : e.data >= o.value) && (n = this._getOrReturnCtx(e, n), L(n, {
        code: U.too_big,
        maximum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), i.dirty()) : o.kind === "multipleOf" ? gr(e.data, o.value) !== 0 && (n = this._getOrReturnCtx(e, n), L(n, {
        code: U.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), i.dirty()) : o.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), L(n, {
        code: U.not_finite,
        message: o.message
      }), i.dirty()) : _e.assertNever(o);
    return { status: i.value, value: e.data };
  }
  gte(e, a) {
    return this.setLimit("min", e, !0, te.toString(a));
  }
  gt(e, a) {
    return this.setLimit("min", e, !1, te.toString(a));
  }
  lte(e, a) {
    return this.setLimit("max", e, !0, te.toString(a));
  }
  lt(e, a) {
    return this.setLimit("max", e, !1, te.toString(a));
  }
  setLimit(e, a, n, i) {
    return new Mt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: a,
          inclusive: n,
          message: te.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Mt({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: te.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: te.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: te.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: te.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: te.toString(e)
    });
  }
  multipleOf(e, a) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: te.toString(a)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: te.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: te.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: te.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "min" && (e === null || a.value > e) && (e = a.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "max" && (e === null || a.value < e) && (e = a.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && _e.isInteger(e.value));
  }
  get isFinite() {
    let e = null, a = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (a === null || n.value > a) && (a = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(a) && Number.isFinite(e);
  }
}
Mt.create = (t) => new Mt({
  checks: [],
  typeName: se.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...fe(t)
});
class Vt extends pe {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== X.bigint) {
      const o = this._getOrReturnCtx(e);
      return L(o, {
        code: U.invalid_type,
        expected: X.bigint,
        received: o.parsedType
      }), ce;
    }
    let n;
    const i = new We();
    for (const o of this._def.checks)
      o.kind === "min" ? (o.inclusive ? e.data < o.value : e.data <= o.value) && (n = this._getOrReturnCtx(e, n), L(n, {
        code: U.too_small,
        type: "bigint",
        minimum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), i.dirty()) : o.kind === "max" ? (o.inclusive ? e.data > o.value : e.data >= o.value) && (n = this._getOrReturnCtx(e, n), L(n, {
        code: U.too_big,
        type: "bigint",
        maximum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), i.dirty()) : o.kind === "multipleOf" ? e.data % o.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), L(n, {
        code: U.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), i.dirty()) : _e.assertNever(o);
    return { status: i.value, value: e.data };
  }
  gte(e, a) {
    return this.setLimit("min", e, !0, te.toString(a));
  }
  gt(e, a) {
    return this.setLimit("min", e, !1, te.toString(a));
  }
  lte(e, a) {
    return this.setLimit("max", e, !0, te.toString(a));
  }
  lt(e, a) {
    return this.setLimit("max", e, !1, te.toString(a));
  }
  setLimit(e, a, n, i) {
    return new Vt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: a,
          inclusive: n,
          message: te.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Vt({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: te.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: te.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: te.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: te.toString(e)
    });
  }
  multipleOf(e, a) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: te.toString(a)
    });
  }
  get minValue() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "min" && (e === null || a.value > e) && (e = a.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "max" && (e === null || a.value < e) && (e = a.value);
    return e;
  }
}
Vt.create = (t) => {
  var e;
  return new Vt({
    checks: [],
    typeName: se.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...fe(t)
  });
};
class Ka extends pe {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== X.boolean) {
      const n = this._getOrReturnCtx(e);
      return L(n, {
        code: U.invalid_type,
        expected: X.boolean,
        received: n.parsedType
      }), ce;
    }
    return He(e.data);
  }
}
Ka.create = (t) => new Ka({
  typeName: se.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...fe(t)
});
class ta extends pe {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== X.date) {
      const o = this._getOrReturnCtx(e);
      return L(o, {
        code: U.invalid_type,
        expected: X.date,
        received: o.parsedType
      }), ce;
    }
    if (isNaN(e.data.getTime())) {
      const o = this._getOrReturnCtx(e);
      return L(o, {
        code: U.invalid_date
      }), ce;
    }
    const n = new We();
    let i;
    for (const o of this._def.checks)
      o.kind === "min" ? e.data.getTime() < o.value && (i = this._getOrReturnCtx(e, i), L(i, {
        code: U.too_small,
        message: o.message,
        inclusive: !0,
        exact: !1,
        minimum: o.value,
        type: "date"
      }), n.dirty()) : o.kind === "max" ? e.data.getTime() > o.value && (i = this._getOrReturnCtx(e, i), L(i, {
        code: U.too_big,
        message: o.message,
        inclusive: !0,
        exact: !1,
        maximum: o.value,
        type: "date"
      }), n.dirty()) : _e.assertNever(o);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new ta({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, a) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: te.toString(a)
    });
  }
  max(e, a) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: te.toString(a)
    });
  }
  get minDate() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "min" && (e === null || a.value > e) && (e = a.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const a of this._def.checks)
      a.kind === "max" && (e === null || a.value < e) && (e = a.value);
    return e != null ? new Date(e) : null;
  }
}
ta.create = (t) => new ta({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: se.ZodDate,
  ...fe(t)
});
class En extends pe {
  _parse(e) {
    if (this._getType(e) !== X.symbol) {
      const n = this._getOrReturnCtx(e);
      return L(n, {
        code: U.invalid_type,
        expected: X.symbol,
        received: n.parsedType
      }), ce;
    }
    return He(e.data);
  }
}
En.create = (t) => new En({
  typeName: se.ZodSymbol,
  ...fe(t)
});
class La extends pe {
  _parse(e) {
    if (this._getType(e) !== X.undefined) {
      const n = this._getOrReturnCtx(e);
      return L(n, {
        code: U.invalid_type,
        expected: X.undefined,
        received: n.parsedType
      }), ce;
    }
    return He(e.data);
  }
}
La.create = (t) => new La({
  typeName: se.ZodUndefined,
  ...fe(t)
});
class qa extends pe {
  _parse(e) {
    if (this._getType(e) !== X.null) {
      const n = this._getOrReturnCtx(e);
      return L(n, {
        code: U.invalid_type,
        expected: X.null,
        received: n.parsedType
      }), ce;
    }
    return He(e.data);
  }
}
qa.create = (t) => new qa({
  typeName: se.ZodNull,
  ...fe(t)
});
class wa extends pe {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return He(e.data);
  }
}
wa.create = (t) => new wa({
  typeName: se.ZodAny,
  ...fe(t)
});
class ea extends pe {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return He(e.data);
  }
}
ea.create = (t) => new ea({
  typeName: se.ZodUnknown,
  ...fe(t)
});
class St extends pe {
  _parse(e) {
    const a = this._getOrReturnCtx(e);
    return L(a, {
      code: U.invalid_type,
      expected: X.never,
      received: a.parsedType
    }), ce;
  }
}
St.create = (t) => new St({
  typeName: se.ZodNever,
  ...fe(t)
});
class Tn extends pe {
  _parse(e) {
    if (this._getType(e) !== X.undefined) {
      const n = this._getOrReturnCtx(e);
      return L(n, {
        code: U.invalid_type,
        expected: X.void,
        received: n.parsedType
      }), ce;
    }
    return He(e.data);
  }
}
Tn.create = (t) => new Tn({
  typeName: se.ZodVoid,
  ...fe(t)
});
class dt extends pe {
  _parse(e) {
    const { ctx: a, status: n } = this._processInputParams(e), i = this._def;
    if (a.parsedType !== X.array)
      return L(a, {
        code: U.invalid_type,
        expected: X.array,
        received: a.parsedType
      }), ce;
    if (i.exactLength !== null) {
      const s = a.data.length > i.exactLength.value, r = a.data.length < i.exactLength.value;
      (s || r) && (L(a, {
        code: s ? U.too_big : U.too_small,
        minimum: r ? i.exactLength.value : void 0,
        maximum: s ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), n.dirty());
    }
    if (i.minLength !== null && a.data.length < i.minLength.value && (L(a, {
      code: U.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), n.dirty()), i.maxLength !== null && a.data.length > i.maxLength.value && (L(a, {
      code: U.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), n.dirty()), a.common.async)
      return Promise.all([...a.data].map((s, r) => i.type._parseAsync(new wt(a, s, a.path, r)))).then((s) => We.mergeArray(n, s));
    const o = [...a.data].map((s, r) => i.type._parseSync(new wt(a, s, a.path, r)));
    return We.mergeArray(n, o);
  }
  get element() {
    return this._def.type;
  }
  min(e, a) {
    return new dt({
      ...this._def,
      minLength: { value: e, message: te.toString(a) }
    });
  }
  max(e, a) {
    return new dt({
      ...this._def,
      maxLength: { value: e, message: te.toString(a) }
    });
  }
  length(e, a) {
    return new dt({
      ...this._def,
      exactLength: { value: e, message: te.toString(a) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
dt.create = (t, e) => new dt({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: se.ZodArray,
  ...fe(e)
});
function pa(t) {
  if (t instanceof Me) {
    const e = {};
    for (const a in t.shape) {
      const n = t.shape[a];
      e[a] = Ut.create(pa(n));
    }
    return new Me({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof dt ? new dt({
    ...t._def,
    type: pa(t.element)
  }) : t instanceof Ut ? Ut.create(pa(t.unwrap())) : t instanceof na ? na.create(pa(t.unwrap())) : t instanceof xt ? xt.create(t.items.map((e) => pa(e))) : t;
}
class Me extends pe {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), a = _e.objectKeys(e);
    return this._cached = { shape: e, keys: a };
  }
  _parse(e) {
    if (this._getType(e) !== X.object) {
      const l = this._getOrReturnCtx(e);
      return L(l, {
        code: U.invalid_type,
        expected: X.object,
        received: l.parsedType
      }), ce;
    }
    const { status: n, ctx: i } = this._processInputParams(e), { shape: o, keys: s } = this._getCached(), r = [];
    if (!(this._def.catchall instanceof St && this._def.unknownKeys === "strip"))
      for (const l in i.data)
        s.includes(l) || r.push(l);
    const c = [];
    for (const l of s) {
      const f = o[l], m = i.data[l];
      c.push({
        key: { status: "valid", value: l },
        value: f._parse(new wt(i, m, i.path, l)),
        alwaysSet: l in i.data
      });
    }
    if (this._def.catchall instanceof St) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const f of r)
          c.push({
            key: { status: "valid", value: f },
            value: { status: "valid", value: i.data[f] }
          });
      else if (l === "strict")
        r.length > 0 && (L(i, {
          code: U.unrecognized_keys,
          keys: r
        }), n.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const f of r) {
        const m = i.data[f];
        c.push({
          key: { status: "valid", value: f },
          value: l._parse(
            new wt(i, m, i.path, f)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: f in i.data
        });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const f of c) {
        const m = await f.key;
        l.push({
          key: m,
          value: await f.value,
          alwaysSet: f.alwaysSet
        });
      }
      return l;
    }).then((l) => We.mergeObjectSync(n, l)) : We.mergeObjectSync(n, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return te.errToObj, new Me({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (a, n) => {
          var i, o, s, r;
          const c = (s = (o = (i = this._def).errorMap) === null || o === void 0 ? void 0 : o.call(i, a, n).message) !== null && s !== void 0 ? s : n.defaultError;
          return a.code === "unrecognized_keys" ? {
            message: (r = te.errToObj(e).message) !== null && r !== void 0 ? r : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new Me({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Me({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Me({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Me({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: se.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, a) {
    return this.augment({ [e]: a });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Me({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const a = {};
    return _e.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (a[n] = this.shape[n]);
    }), new Me({
      ...this._def,
      shape: () => a
    });
  }
  omit(e) {
    const a = {};
    return _e.objectKeys(this.shape).forEach((n) => {
      e[n] || (a[n] = this.shape[n]);
    }), new Me({
      ...this._def,
      shape: () => a
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return pa(this);
  }
  partial(e) {
    const a = {};
    return _e.objectKeys(this.shape).forEach((n) => {
      const i = this.shape[n];
      e && !e[n] ? a[n] = i : a[n] = i.optional();
    }), new Me({
      ...this._def,
      shape: () => a
    });
  }
  required(e) {
    const a = {};
    return _e.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        a[n] = this.shape[n];
      else {
        let o = this.shape[n];
        for (; o instanceof Ut; )
          o = o._def.innerType;
        a[n] = o;
      }
    }), new Me({
      ...this._def,
      shape: () => a
    });
  }
  keyof() {
    return Qo(_e.objectKeys(this.shape));
  }
}
Me.create = (t, e) => new Me({
  shape: () => t,
  unknownKeys: "strip",
  catchall: St.create(),
  typeName: se.ZodObject,
  ...fe(e)
});
Me.strictCreate = (t, e) => new Me({
  shape: () => t,
  unknownKeys: "strict",
  catchall: St.create(),
  typeName: se.ZodObject,
  ...fe(e)
});
Me.lazycreate = (t, e) => new Me({
  shape: t,
  unknownKeys: "strip",
  catchall: St.create(),
  typeName: se.ZodObject,
  ...fe(e)
});
class Wa extends pe {
  _parse(e) {
    const { ctx: a } = this._processInputParams(e), n = this._def.options;
    function i(o) {
      for (const r of o)
        if (r.result.status === "valid")
          return r.result;
      for (const r of o)
        if (r.result.status === "dirty")
          return a.common.issues.push(...r.ctx.common.issues), r.result;
      const s = o.map((r) => new ft(r.ctx.common.issues));
      return L(a, {
        code: U.invalid_union,
        unionErrors: s
      }), ce;
    }
    if (a.common.async)
      return Promise.all(n.map(async (o) => {
        const s = {
          ...a,
          common: {
            ...a.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await o._parseAsync({
            data: a.data,
            path: a.path,
            parent: s
          }),
          ctx: s
        };
      })).then(i);
    {
      let o;
      const s = [];
      for (const c of n) {
        const l = {
          ...a,
          common: {
            ...a.common,
            issues: []
          },
          parent: null
        }, f = c._parseSync({
          data: a.data,
          path: a.path,
          parent: l
        });
        if (f.status === "valid")
          return f;
        f.status === "dirty" && !o && (o = { result: f, ctx: l }), l.common.issues.length && s.push(l.common.issues);
      }
      if (o)
        return a.common.issues.push(...o.ctx.common.issues), o.result;
      const r = s.map((c) => new ft(c));
      return L(a, {
        code: U.invalid_union,
        unionErrors: r
      }), ce;
    }
  }
  get options() {
    return this._def.options;
  }
}
Wa.create = (t, e) => new Wa({
  options: t,
  typeName: se.ZodUnion,
  ...fe(e)
});
const yn = (t) => t instanceof Ha ? yn(t.schema) : t instanceof mt ? yn(t.innerType()) : t instanceof Za ? [t.value] : t instanceof Xt ? t.options : t instanceof Ja ? Object.keys(t.enum) : t instanceof Ga ? yn(t._def.innerType) : t instanceof La ? [void 0] : t instanceof qa ? [null] : null;
class Xn extends pe {
  _parse(e) {
    const { ctx: a } = this._processInputParams(e);
    if (a.parsedType !== X.object)
      return L(a, {
        code: U.invalid_type,
        expected: X.object,
        received: a.parsedType
      }), ce;
    const n = this.discriminator, i = a.data[n], o = this.optionsMap.get(i);
    return o ? a.common.async ? o._parseAsync({
      data: a.data,
      path: a.path,
      parent: a
    }) : o._parseSync({
      data: a.data,
      path: a.path,
      parent: a
    }) : (L(a, {
      code: U.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), ce);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, a, n) {
    const i = /* @__PURE__ */ new Map();
    for (const o of a) {
      const s = yn(o.shape[e]);
      if (!s)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const r of s) {
        if (i.has(r))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(r)}`);
        i.set(r, o);
      }
    }
    return new Xn({
      typeName: se.ZodDiscriminatedUnion,
      discriminator: e,
      options: a,
      optionsMap: i,
      ...fe(n)
    });
  }
}
function pi(t, e) {
  const a = Ot(t), n = Ot(e);
  if (t === e)
    return { valid: !0, data: t };
  if (a === X.object && n === X.object) {
    const i = _e.objectKeys(e), o = _e.objectKeys(t).filter((r) => i.indexOf(r) !== -1), s = { ...t, ...e };
    for (const r of o) {
      const c = pi(t[r], e[r]);
      if (!c.valid)
        return { valid: !1 };
      s[r] = c.data;
    }
    return { valid: !0, data: s };
  } else if (a === X.array && n === X.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const i = [];
    for (let o = 0; o < t.length; o++) {
      const s = t[o], r = e[o], c = pi(s, r);
      if (!c.valid)
        return { valid: !1 };
      i.push(c.data);
    }
    return { valid: !0, data: i };
  } else return a === X.date && n === X.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class Ya extends pe {
  _parse(e) {
    const { status: a, ctx: n } = this._processInputParams(e), i = (o, s) => {
      if (di(o) || di(s))
        return ce;
      const r = pi(o.value, s.value);
      return r.valid ? ((mi(o) || mi(s)) && a.dirty(), { status: a.value, value: r.data }) : (L(n, {
        code: U.invalid_intersection_types
      }), ce);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([o, s]) => i(o, s)) : i(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Ya.create = (t, e, a) => new Ya({
  left: t,
  right: e,
  typeName: se.ZodIntersection,
  ...fe(a)
});
class xt extends pe {
  _parse(e) {
    const { status: a, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== X.array)
      return L(n, {
        code: U.invalid_type,
        expected: X.array,
        received: n.parsedType
      }), ce;
    if (n.data.length < this._def.items.length)
      return L(n, {
        code: U.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), ce;
    !this._def.rest && n.data.length > this._def.items.length && (L(n, {
      code: U.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), a.dirty());
    const o = [...n.data].map((s, r) => {
      const c = this._def.items[r] || this._def.rest;
      return c ? c._parse(new wt(n, s, n.path, r)) : null;
    }).filter((s) => !!s);
    return n.common.async ? Promise.all(o).then((s) => We.mergeArray(a, s)) : We.mergeArray(a, o);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new xt({
      ...this._def,
      rest: e
    });
  }
}
xt.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new xt({
    items: t,
    typeName: se.ZodTuple,
    rest: null,
    ...fe(e)
  });
};
class $a extends pe {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: a, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== X.object)
      return L(n, {
        code: U.invalid_type,
        expected: X.object,
        received: n.parsedType
      }), ce;
    const i = [], o = this._def.keyType, s = this._def.valueType;
    for (const r in n.data)
      i.push({
        key: o._parse(new wt(n, r, n.path, r)),
        value: s._parse(new wt(n, n.data[r], n.path, r))
      });
    return n.common.async ? We.mergeObjectAsync(a, i) : We.mergeObjectSync(a, i);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, a, n) {
    return a instanceof pe ? new $a({
      keyType: e,
      valueType: a,
      typeName: se.ZodRecord,
      ...fe(n)
    }) : new $a({
      keyType: ut.create(),
      valueType: e,
      typeName: se.ZodRecord,
      ...fe(a)
    });
  }
}
class jn extends pe {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: a, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== X.map)
      return L(n, {
        code: U.invalid_type,
        expected: X.map,
        received: n.parsedType
      }), ce;
    const i = this._def.keyType, o = this._def.valueType, s = [...n.data.entries()].map(([r, c], l) => ({
      key: i._parse(new wt(n, r, n.path, [l, "key"])),
      value: o._parse(new wt(n, c, n.path, [l, "value"]))
    }));
    if (n.common.async) {
      const r = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of s) {
          const l = await c.key, f = await c.value;
          if (l.status === "aborted" || f.status === "aborted")
            return ce;
          (l.status === "dirty" || f.status === "dirty") && a.dirty(), r.set(l.value, f.value);
        }
        return { status: a.value, value: r };
      });
    } else {
      const r = /* @__PURE__ */ new Map();
      for (const c of s) {
        const l = c.key, f = c.value;
        if (l.status === "aborted" || f.status === "aborted")
          return ce;
        (l.status === "dirty" || f.status === "dirty") && a.dirty(), r.set(l.value, f.value);
      }
      return { status: a.value, value: r };
    }
  }
}
jn.create = (t, e, a) => new jn({
  valueType: e,
  keyType: t,
  typeName: se.ZodMap,
  ...fe(a)
});
class aa extends pe {
  _parse(e) {
    const { status: a, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== X.set)
      return L(n, {
        code: U.invalid_type,
        expected: X.set,
        received: n.parsedType
      }), ce;
    const i = this._def;
    i.minSize !== null && n.data.size < i.minSize.value && (L(n, {
      code: U.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), a.dirty()), i.maxSize !== null && n.data.size > i.maxSize.value && (L(n, {
      code: U.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), a.dirty());
    const o = this._def.valueType;
    function s(c) {
      const l = /* @__PURE__ */ new Set();
      for (const f of c) {
        if (f.status === "aborted")
          return ce;
        f.status === "dirty" && a.dirty(), l.add(f.value);
      }
      return { status: a.value, value: l };
    }
    const r = [...n.data.values()].map((c, l) => o._parse(new wt(n, c, n.path, l)));
    return n.common.async ? Promise.all(r).then((c) => s(c)) : s(r);
  }
  min(e, a) {
    return new aa({
      ...this._def,
      minSize: { value: e, message: te.toString(a) }
    });
  }
  max(e, a) {
    return new aa({
      ...this._def,
      maxSize: { value: e, message: te.toString(a) }
    });
  }
  size(e, a) {
    return this.min(e, a).max(e, a);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
aa.create = (t, e) => new aa({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: se.ZodSet,
  ...fe(e)
});
class ka extends pe {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: a } = this._processInputParams(e);
    if (a.parsedType !== X.function)
      return L(a, {
        code: U.invalid_type,
        expected: X.function,
        received: a.parsedType
      }), ce;
    function n(r, c) {
      return Cn({
        data: r,
        path: a.path,
        errorMaps: [
          a.common.contextualErrorMap,
          a.schemaErrorMap,
          Fn(),
          Va
        ].filter((l) => !!l),
        issueData: {
          code: U.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function i(r, c) {
      return Cn({
        data: r,
        path: a.path,
        errorMaps: [
          a.common.contextualErrorMap,
          a.schemaErrorMap,
          Fn(),
          Va
        ].filter((l) => !!l),
        issueData: {
          code: U.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const o = { errorMap: a.common.contextualErrorMap }, s = a.data;
    if (this._def.returns instanceof xa) {
      const r = this;
      return He(async function(...c) {
        const l = new ft([]), f = await r._def.args.parseAsync(c, o).catch((k) => {
          throw l.addIssue(n(c, k)), l;
        }), m = await Reflect.apply(s, this, f);
        return await r._def.returns._def.type.parseAsync(m, o).catch((k) => {
          throw l.addIssue(i(m, k)), l;
        });
      });
    } else {
      const r = this;
      return He(function(...c) {
        const l = r._def.args.safeParse(c, o);
        if (!l.success)
          throw new ft([n(c, l.error)]);
        const f = Reflect.apply(s, this, l.data), m = r._def.returns.safeParse(f, o);
        if (!m.success)
          throw new ft([i(f, m.error)]);
        return m.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new ka({
      ...this._def,
      args: xt.create(e).rest(ea.create())
    });
  }
  returns(e) {
    return new ka({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, a, n) {
    return new ka({
      args: e || xt.create([]).rest(ea.create()),
      returns: a || ea.create(),
      typeName: se.ZodFunction,
      ...fe(n)
    });
  }
}
class Ha extends pe {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: a } = this._processInputParams(e);
    return this._def.getter()._parse({ data: a.data, path: a.path, parent: a });
  }
}
Ha.create = (t, e) => new Ha({
  getter: t,
  typeName: se.ZodLazy,
  ...fe(e)
});
class Za extends pe {
  _parse(e) {
    if (e.data !== this._def.value) {
      const a = this._getOrReturnCtx(e);
      return L(a, {
        received: a.data,
        code: U.invalid_literal,
        expected: this._def.value
      }), ce;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Za.create = (t, e) => new Za({
  value: t,
  typeName: se.ZodLiteral,
  ...fe(e)
});
function Qo(t, e) {
  return new Xt({
    values: t,
    typeName: se.ZodEnum,
    ...fe(e)
  });
}
class Xt extends pe {
  _parse(e) {
    if (typeof e.data != "string") {
      const a = this._getOrReturnCtx(e), n = this._def.values;
      return L(a, {
        expected: _e.joinValues(n),
        received: a.parsedType,
        code: U.invalid_type
      }), ce;
    }
    if (this._def.values.indexOf(e.data) === -1) {
      const a = this._getOrReturnCtx(e), n = this._def.values;
      return L(a, {
        received: a.data,
        code: U.invalid_enum_value,
        options: n
      }), ce;
    }
    return He(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const a of this._def.values)
      e[a] = a;
    return e;
  }
  get Values() {
    const e = {};
    for (const a of this._def.values)
      e[a] = a;
    return e;
  }
  get Enum() {
    const e = {};
    for (const a of this._def.values)
      e[a] = a;
    return e;
  }
  extract(e) {
    return Xt.create(e);
  }
  exclude(e) {
    return Xt.create(this.options.filter((a) => !e.includes(a)));
  }
}
Xt.create = Qo;
class Ja extends pe {
  _parse(e) {
    const a = _e.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== X.string && n.parsedType !== X.number) {
      const i = _e.objectValues(a);
      return L(n, {
        expected: _e.joinValues(i),
        received: n.parsedType,
        code: U.invalid_type
      }), ce;
    }
    if (a.indexOf(e.data) === -1) {
      const i = _e.objectValues(a);
      return L(n, {
        received: n.data,
        code: U.invalid_enum_value,
        options: i
      }), ce;
    }
    return He(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ja.create = (t, e) => new Ja({
  values: t,
  typeName: se.ZodNativeEnum,
  ...fe(e)
});
class xa extends pe {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: a } = this._processInputParams(e);
    if (a.parsedType !== X.promise && a.common.async === !1)
      return L(a, {
        code: U.invalid_type,
        expected: X.promise,
        received: a.parsedType
      }), ce;
    const n = a.parsedType === X.promise ? a.data : Promise.resolve(a.data);
    return He(n.then((i) => this._def.type.parseAsync(i, {
      path: a.path,
      errorMap: a.common.contextualErrorMap
    })));
  }
}
xa.create = (t, e) => new xa({
  type: t,
  typeName: se.ZodPromise,
  ...fe(e)
});
class mt extends pe {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === se.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: a, ctx: n } = this._processInputParams(e), i = this._def.effect || null, o = {
      addIssue: (s) => {
        L(n, s), s.fatal ? a.abort() : a.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (o.addIssue = o.addIssue.bind(o), i.type === "preprocess") {
      const s = i.transform(n.data, o);
      return n.common.issues.length ? {
        status: "dirty",
        value: n.data
      } : n.common.async ? Promise.resolve(s).then((r) => this._def.schema._parseAsync({
        data: r,
        path: n.path,
        parent: n
      })) : this._def.schema._parseSync({
        data: s,
        path: n.path,
        parent: n
      });
    }
    if (i.type === "refinement") {
      const s = (r) => {
        const c = i.refinement(r, o);
        if (n.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return r;
      };
      if (n.common.async === !1) {
        const r = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return r.status === "aborted" ? ce : (r.status === "dirty" && a.dirty(), s(r.value), { status: a.value, value: r.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((r) => r.status === "aborted" ? ce : (r.status === "dirty" && a.dirty(), s(r.value).then(() => ({ status: a.value, value: r.value }))));
    }
    if (i.type === "transform")
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!Xa(s))
          return s;
        const r = i.transform(s.value, o);
        if (r instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: a.value, value: r };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => Xa(s) ? Promise.resolve(i.transform(s.value, o)).then((r) => ({ status: a.value, value: r })) : s);
    _e.assertNever(i);
  }
}
mt.create = (t, e, a) => new mt({
  schema: t,
  typeName: se.ZodEffects,
  effect: e,
  ...fe(a)
});
mt.createWithPreprocess = (t, e, a) => new mt({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: se.ZodEffects,
  ...fe(a)
});
class Ut extends pe {
  _parse(e) {
    return this._getType(e) === X.undefined ? He(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ut.create = (t, e) => new Ut({
  innerType: t,
  typeName: se.ZodOptional,
  ...fe(e)
});
class na extends pe {
  _parse(e) {
    return this._getType(e) === X.null ? He(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
na.create = (t, e) => new na({
  innerType: t,
  typeName: se.ZodNullable,
  ...fe(e)
});
class Ga extends pe {
  _parse(e) {
    const { ctx: a } = this._processInputParams(e);
    let n = a.data;
    return a.parsedType === X.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: a.path,
      parent: a
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Ga.create = (t, e) => new Ga({
  innerType: t,
  typeName: se.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...fe(e)
});
class Un extends pe {
  _parse(e) {
    const { ctx: a } = this._processInputParams(e), n = {
      ...a,
      common: {
        ...a.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return zn(i) ? i.then((o) => ({
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new ft(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new ft(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Un.create = (t, e) => new Un({
  innerType: t,
  typeName: se.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...fe(e)
});
class Sn extends pe {
  _parse(e) {
    if (this._getType(e) !== X.nan) {
      const n = this._getOrReturnCtx(e);
      return L(n, {
        code: U.invalid_type,
        expected: X.nan,
        received: n.parsedType
      }), ce;
    }
    return { status: "valid", value: e.data };
  }
}
Sn.create = (t) => new Sn({
  typeName: se.ZodNaN,
  ...fe(t)
});
const br = Symbol("zod_brand");
class es extends pe {
  _parse(e) {
    const { ctx: a } = this._processInputParams(e), n = a.data;
    return this._def.type._parse({
      data: n,
      path: a.path,
      parent: a
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class en extends pe {
  _parse(e) {
    const { status: a, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const o = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? ce : o.status === "dirty" ? (a.dirty(), Go(o.value)) : this._def.out._parseAsync({
          data: o.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return i.status === "aborted" ? ce : i.status === "dirty" ? (a.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, a) {
    return new en({
      in: e,
      out: a,
      typeName: se.ZodPipeline
    });
  }
}
class An extends pe {
  _parse(e) {
    const a = this._def.innerType._parse(e);
    return Xa(a) && (a.value = Object.freeze(a.value)), a;
  }
}
An.create = (t, e) => new An({
  innerType: t,
  typeName: se.ZodReadonly,
  ...fe(e)
});
const ts = (t, e = {}, a) => t ? wa.create().superRefine((n, i) => {
  var o, s;
  if (!t(n)) {
    const r = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, c = (s = (o = r.fatal) !== null && o !== void 0 ? o : a) !== null && s !== void 0 ? s : !0, l = typeof r == "string" ? { message: r } : r;
    i.addIssue({ code: "custom", ...l, fatal: c });
  }
}) : wa.create(), yr = {
  object: Me.lazycreate
};
var se;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(se || (se = {}));
const vr = (t, e = {
  message: `Input not instance of ${t.name}`
}) => ts((a) => a instanceof t, e), as = ut.create, ns = Mt.create, kr = Sn.create, wr = Vt.create, is = Ka.create, xr = ta.create, _r = En.create, Fr = La.create, Cr = qa.create, zr = wa.create, Er = ea.create, Tr = St.create, jr = Tn.create, Ur = dt.create, Sr = Me.create, Ar = Me.strictCreate, Ir = Wa.create, Dr = Xn.create, Br = Ya.create, Rr = xt.create, Or = $a.create, Pr = jn.create, Nr = aa.create, Mr = ka.create, Vr = Ha.create, Xr = Za.create, Kr = Xt.create, Lr = Ja.create, qr = xa.create, uo = mt.create, Wr = Ut.create, Yr = na.create, $r = mt.createWithPreprocess, Hr = en.create, Zr = () => as().optional(), Jr = () => ns().optional(), Gr = () => is().optional(), Qr = {
  string: (t) => ut.create({ ...t, coerce: !0 }),
  number: (t) => Mt.create({ ...t, coerce: !0 }),
  boolean: (t) => Ka.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => Vt.create({ ...t, coerce: !0 }),
  date: (t) => ta.create({ ...t, coerce: !0 })
}, e1 = ce;
var u = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Va,
  setErrorMap: ir,
  getErrorMap: Fn,
  makeIssue: Cn,
  EMPTY_PATH: or,
  addIssueToContext: L,
  ParseStatus: We,
  INVALID: ce,
  DIRTY: Go,
  OK: He,
  isAborted: di,
  isDirty: mi,
  isValid: Xa,
  isAsync: zn,
  get util() {
    return _e;
  },
  get objectUtil() {
    return fi;
  },
  ZodParsedType: X,
  getParsedType: Ot,
  ZodType: pe,
  ZodString: ut,
  ZodNumber: Mt,
  ZodBigInt: Vt,
  ZodBoolean: Ka,
  ZodDate: ta,
  ZodSymbol: En,
  ZodUndefined: La,
  ZodNull: qa,
  ZodAny: wa,
  ZodUnknown: ea,
  ZodNever: St,
  ZodVoid: Tn,
  ZodArray: dt,
  ZodObject: Me,
  ZodUnion: Wa,
  ZodDiscriminatedUnion: Xn,
  ZodIntersection: Ya,
  ZodTuple: xt,
  ZodRecord: $a,
  ZodMap: jn,
  ZodSet: aa,
  ZodFunction: ka,
  ZodLazy: Ha,
  ZodLiteral: Za,
  ZodEnum: Xt,
  ZodNativeEnum: Ja,
  ZodPromise: xa,
  ZodEffects: mt,
  ZodTransformer: mt,
  ZodOptional: Ut,
  ZodNullable: na,
  ZodDefault: Ga,
  ZodCatch: Un,
  ZodNaN: Sn,
  BRAND: br,
  ZodBranded: es,
  ZodPipeline: en,
  ZodReadonly: An,
  custom: ts,
  Schema: pe,
  ZodSchema: pe,
  late: yr,
  get ZodFirstPartyTypeKind() {
    return se;
  },
  coerce: Qr,
  any: zr,
  array: Ur,
  bigint: wr,
  boolean: is,
  date: xr,
  discriminatedUnion: Dr,
  effect: uo,
  enum: Kr,
  function: Mr,
  instanceof: vr,
  intersection: Br,
  lazy: Vr,
  literal: Xr,
  map: Pr,
  nan: kr,
  nativeEnum: Lr,
  never: Tr,
  null: Cr,
  nullable: Yr,
  number: ns,
  object: Sr,
  oboolean: Gr,
  onumber: Jr,
  optional: Wr,
  ostring: Zr,
  pipeline: Hr,
  preprocess: $r,
  promise: qr,
  record: Or,
  set: Nr,
  strictObject: Ar,
  string: as,
  symbol: _r,
  transformer: uo,
  tuple: Rr,
  undefined: Fr,
  union: Ir,
  unknown: Er,
  void: jr,
  NEVER: e1,
  ZodIssueCode: U,
  quotelessJson: nr,
  ZodError: ft
});
function t1(t, e, a, n) {
  const { extrapolateLeft: i, extrapolateRight: o, easing: s } = n;
  let r = t;
  const [c, l] = e, [f, m] = a;
  if (r < c) {
    if (i === "identity")
      return r;
    i === "clamp" && (r = c);
  }
  if (r > l) {
    if (o === "identity")
      return r;
    o === "clamp" && (r = l);
  }
  return f === m ? f : (r = (r - c) / (l - c), r = s(r), r = r * (m - f) + f, r);
}
function a1(t, e) {
  let a;
  for (a = 1; a < e.length - 1 && !(e[a] >= t); ++a)
    ;
  return a - 1;
}
function n1(t) {
  for (let e = 1; e < t.length; ++e)
    if (!(t[e] > t[e - 1]))
      throw new Error(`inputRange must be strictly monotonically non-decreasing but got [${t.join(",")}]`);
}
function fo(t, e) {
  if (e.length < 2)
    throw new Error(t + " must have at least 2 elements");
  for (const a in e) {
    if (typeof e[a] != "number")
      throw new Error(`${t} must contain only numbers`);
    if (e[a] === -1 / 0 || e[a] === 1 / 0)
      throw new Error(`${t} must contain only finite numbers, but got [${e.join(",")}]`);
  }
}
function i1(t, e, a, n) {
  var i;
  if (typeof t > "u")
    throw new Error("input can not be undefined");
  if (typeof e > "u")
    throw new Error("inputRange can not be undefined");
  if (typeof a > "u")
    throw new Error("outputRange can not be undefined");
  if (e.length !== a.length)
    throw new Error("inputRange (" + e.length + ") and outputRange (" + a.length + ") must have the same length");
  fo("inputRange", e), fo("outputRange", a), n1(e);
  const o = (i = void 0) !== null && i !== void 0 ? i : (l) => l;
  let s = "extend", r = "extend";
  if (typeof t != "number")
    throw new TypeError("Cannot interpolate an input which is not a number");
  const c = a1(t, e);
  return t1(t, [e[c], e[c + 1]], [a[c], a[c + 1]], {
    easing: o,
    extrapolateLeft: s,
    extrapolateRight: r
  });
}
function o1(t) {
  return !!t;
}
typeof window < "u" && (window.remotion_renderReady = !1);
typeof window < "u" && (window.remotion_delayRenderTimeouts = {});
const s1 = "The delayRender was called:", r1 = {
  "%3A": ":",
  "%2F": "/",
  "%3F": "?",
  "%23": "#",
  "%5B": "[",
  "%5D": "]",
  "%40": "@",
  "%21": "!",
  "%24": "$",
  "%26": "&",
  "%27": "'",
  "%28": "(",
  "%29": ")",
  "%2A": "*",
  "%2B": "+",
  "%2C": ",",
  "%3B": ";"
}, mo = {}, l1 = (t) => {
  mo[t] || (console.warn(t), mo[t] = !0);
}, c1 = (t) => {
  for (const e of Object.keys(r1))
    if (t.includes(e))
      return { containsHex: !0, hexCode: e };
  return { containsHex: !1 };
}, hi = (t) => t.startsWith("/") ? hi(t.substring(1)) : t, u1 = (t) => {
  if (typeof window < "u" && window.remotion_staticBase) {
    if (t.startsWith(window.remotion_staticBase))
      throw new Error(`The value "${t}" is already prefixed with the static base ${window.remotion_staticBase}. You don't need to call staticFile() on it.`);
    return `${window.remotion_staticBase}/${hi(t)}`;
  }
  return `/${hi(t)}`;
}, f1 = (t) => t.split("/").map((i) => encodeURIComponent(i)).join("/"), d1 = (t) => {
  if (t.startsWith("http://") || t.startsWith("https://"))
    throw new TypeError(`staticFile() does not support remote URLs - got "${t}". Instead, pass the URL without wrapping it in staticFile(). See: https://remotion.dev/docs/staticfile-remote-urls`);
  if (t.startsWith("..") || t.startsWith("./"))
    throw new TypeError(`staticFile() does not support relative paths - got "${t}". Instead, pass the name of a file that is inside the public/ folder. See: https://remotion.dev/docs/staticfile-relative-paths`);
  if (t.startsWith("/Users") || t.startsWith("/home") || t.startsWith("/tmp") || t.startsWith("/etc") || t.startsWith("/opt") || t.startsWith("/var") || t.startsWith("C:") || t.startsWith("D:") || t.startsWith("E:"))
    throw new TypeError(`staticFile() does not support absolute paths - got "${t}". Instead, pass the name of a file that is inside the public/ folder. See: https://remotion.dev/docs/staticfile-relative-paths`);
  if (t.startsWith("public/"))
    throw new TypeError(`Do not include the public/ prefix when using staticFile() - got "${t}". See: https://remotion.dev/docs/staticfile-relative-paths`);
  const e = c1(t);
  e.containsHex && l1(`WARNING: You seem to pass an already encoded path (path contains ${e.hexCode}). Since Remotion 4.0, the encoding is done by staticFile() itself. You may want to remove a encodeURIComponent() wrapping.`);
  const a = f1(t), n = u1(a);
  return n.startsWith("/") ? n : `/${n}`;
}, gi = "remotion-date:", bi = "remotion-file:", m1 = ({ data: t, indent: e, staticBase: a }) => {
  let n = !1, i = !1, o = !1, s = !1;
  return { serializedString: JSON.stringify(t, function(c, l) {
    const f = this[c];
    return f instanceof Date ? (n = !0, `${gi}${f.toISOString()}`) : f instanceof Map ? (o = !0, l) : f instanceof Set ? (s = !0, l) : typeof f == "string" && a !== null && f.startsWith(a) ? (i = !0, `${bi}${f.replace(a + "/", "")}`) : l;
  }, e), customDateUsed: n, customFileUsed: i, mapUsed: o, setUsed: s };
}, p1 = (t) => JSON.parse(t, (e, a) => typeof a == "string" && a.startsWith(gi) ? new Date(a.replace(gi, "")) : typeof a == "string" && a.startsWith(bi) ? d1(a.replace(bi, "")) : a), lt = "[-+]?\\d*\\.?\\d+", cn = lt + "%";
function un(...t) {
  return "\\(\\s*(" + t.join(")\\s*,\\s*(") + ")\\s*\\)";
}
function h1() {
  const t = {
    rgb: void 0,
    rgba: void 0,
    hsl: void 0,
    hsla: void 0,
    hex3: void 0,
    hex4: void 0,
    hex5: void 0,
    hex6: void 0,
    hex8: void 0
  };
  return t.rgb === void 0 && (t.rgb = new RegExp("rgb" + un(lt, lt, lt)), t.rgba = new RegExp("rgba" + un(lt, lt, lt, lt)), t.hsl = new RegExp("hsl" + un(lt, cn, cn)), t.hsla = new RegExp("hsla" + un(lt, cn, cn, lt)), t.hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, t.hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, t.hex6 = /^#([0-9a-fA-F]{6})$/, t.hex8 = /^#([0-9a-fA-F]{8})$/), t;
}
function Qn(t, e, a) {
  return a < 0 && (a += 1), a > 1 && (a -= 1), a < 1 / 6 ? t + (e - t) * 6 * a : a < 1 / 2 ? e : a < 2 / 3 ? t + (e - t) * (2 / 3 - a) * 6 : t;
}
function po(t, e, a) {
  const n = a < 0.5 ? a * (1 + e) : a + e - a * e, i = 2 * a - n, o = Qn(i, n, t + 1 / 3), s = Qn(i, n, t), r = Qn(i, n, t - 1 / 3);
  return Math.round(o * 255) << 24 | Math.round(s * 255) << 16 | Math.round(r * 255) << 8;
}
function ma(t) {
  const e = Number.parseInt(t, 10);
  return e < 0 ? 0 : e > 255 ? 255 : e;
}
function ho(t) {
  return (Number.parseFloat(t) % 360 + 360) % 360 / 360;
}
function go(t) {
  const e = Number.parseFloat(t);
  return e < 0 ? 0 : e > 1 ? 255 : Math.round(e * 255);
}
function fn(t) {
  const e = Number.parseFloat(t);
  return e < 0 ? 0 : e > 100 ? 1 : e / 100;
}
const bo = {
  transparent: 0,
  // http://www.w3.org/TR/css3-color/#svg-color
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
};
function g1(t) {
  const e = h1();
  let a;
  if (e.hex6 && (a = e.hex6.exec(t)))
    return Number.parseInt(a[1] + "ff", 16) >>> 0;
  if (bo[t] !== void 0)
    return bo[t];
  if (e.rgb && (a = e.rgb.exec(t)))
    return (
      // b
      (ma(a[1]) << 24 | // r
      ma(a[2]) << 16 | // g
      ma(a[3]) << 8 | 255) >>> // a
      0
    );
  if (e.rgba && (a = e.rgba.exec(t)))
    return (
      // b
      (ma(a[1]) << 24 | // r
      ma(a[2]) << 16 | // g
      ma(a[3]) << 8 | go(a[4])) >>> // a
      0
    );
  if (e.hex3 && (a = e.hex3.exec(t)))
    return Number.parseInt(
      a[1] + a[1] + // r
      a[2] + a[2] + // g
      a[3] + a[3] + // b
      "ff",
      // a
      16
    ) >>> 0;
  if (e.hex8 && (a = e.hex8.exec(t)))
    return Number.parseInt(a[1], 16) >>> 0;
  if (e.hex4 && (a = e.hex4.exec(t)))
    return Number.parseInt(
      a[1] + a[1] + // r
      a[2] + a[2] + // g
      a[3] + a[3] + // b
      a[4] + a[4],
      // a
      16
    ) >>> 0;
  if (e.hsl && (a = e.hsl.exec(t)))
    return (po(
      ho(a[1]),
      // h
      fn(a[2]),
      // s
      fn(a[3])
    ) | 255) >>> // a
    0;
  if (e.hsla && (a = e.hsla.exec(t)))
    return (po(
      ho(a[1]),
      // h
      fn(a[2]),
      // s
      fn(a[3])
    ) | go(a[4])) >>> // a
    0;
  throw new Error(`invalid color string ${t} provided`);
}
function b1(t) {
  const e = g1(t);
  return (e << 24 | e >>> 8) >>> 0;
}
const y1 = ({ allowFloats: t, durationInFrames: e, frame: a }) => {
  if (typeof a > "u")
    throw new TypeError('Argument missing for parameter "frame"');
  if (typeof a != "number")
    throw new TypeError(`Argument passed for "frame" is not a number: ${a}`);
  if (!Number.isFinite(a))
    throw new RangeError(`Frame ${a} is not finite`);
  if (a % 1 !== 0 && !t)
    throw new RangeError(`Argument for frame must be an integer, but got ${a}`);
  if (a < 0 && a < -e)
    throw new RangeError(`Cannot use frame ${a}: Duration of composition is ${e}, therefore the lowest frame that can be rendered is ${-e}`);
  if (a > e - 1)
    throw new RangeError(`Cannot use frame ${a}: Duration of composition is ${e}, therefore the highest frame that can be rendered is ${e - 1}`);
}, v1 = (t, e, a) => {
  if (t) {
    if (typeof t != "object")
      throw new Error(`"${e}" must be an object, but you passed a value of type ${typeof t}`);
    if (Array.isArray(t))
      throw new Error(`"${e}" must be an object, an array was passed ${a ? `for composition "${a}"` : ""}`);
  }
};
function k1(t, e, a) {
  if (typeof t != "number")
    throw new Error(`The "${e}" prop ${a} must be a number, but you passed a value of type ${typeof t}`);
  if (isNaN(t))
    throw new TypeError(`The "${e}" prop ${a} must not be NaN, but is NaN.`);
  if (!Number.isFinite(t))
    throw new TypeError(`The "${e}" prop ${a} must be finite, but is ${t}.`);
  if (t % 1 !== 0)
    throw new TypeError(`The "${e}" prop ${a} must be an integer, but is ${t}.`);
  if (t <= 0)
    throw new TypeError(`The "${e}" prop ${a} must be positive, but got ${t}.`);
}
function w1(t, e) {
  const { allowFloats: a, component: n } = e;
  if (typeof t > "u")
    throw new Error(`The "durationInFrames" prop ${n} is missing.`);
  if (typeof t != "number")
    throw new Error(`The "durationInFrames" prop ${n} must be a number, but you passed a value of type ${typeof t}`);
  if (t <= 0)
    throw new TypeError(`The "durationInFrames" prop ${n} must be positive, but got ${t}.`);
  if (!a && t % 1 !== 0)
    throw new TypeError(`The "durationInFrames" prop ${n} must be an integer, but got ${t}.`);
  if (!Number.isFinite(t))
    throw new TypeError(`The "durationInFrames" prop ${n} must be finite, but got ${t}.`);
}
function x1(t, e, a) {
  if (typeof t != "number")
    throw new Error(`"fps" must be a number, but you passed a value of type ${typeof t} ${e}`);
  if (!Number.isFinite(t))
    throw new Error(`"fps" must be a finite, but you passed ${t} ${e}`);
  if (isNaN(t))
    throw new Error(`"fps" must not be NaN, but got ${t} ${e}`);
  if (t <= 0)
    throw new TypeError(`"fps" must be positive, but got ${t} ${e}`);
  if (a && t > 50)
    throw new TypeError("The FPS for a GIF cannot be higher than 50. Use the --every-nth-frame option to lower the FPS: https://remotion.dev/docs/render-as-gif");
}
const _1 = ({ frame: t, playbackRate: e, startFrom: a }) => i1(t, [-1, a, a + 1], [-1, a, a + e]), F1 = (t) => typeof window > "u" ? t : new URL(t, window.origin).href, C1 = ({ src: t, transparent: e, currentTime: a, toneMapped: n }) => `http://localhost:${window.remotion_proxyPort}/proxy?src=${encodeURIComponent(F1(t))}&time=${encodeURIComponent(a)}&transparent=${String(e)}&toneMapped=${String(n)}`, z1 = {
  processColor: b1,
  truthy: o1,
  validateFps: x1,
  validateDimension: k1,
  validateDurationInFrames: w1,
  validateDefaultAndInputProps: v1,
  validateFrame: y1,
  serializeJSONWithDate: m1,
  bundleName: "bundle.js",
  bundleMapName: "bundle.js.map",
  deserializeJSONWithCustomFields: p1,
  DELAY_RENDER_CALLSTACK_TOKEN: s1,
  getOffthreadVideoSource: C1,
  getExpectedMediaFrameUncorrected: _1
}, E1 = "__remotion-color", T1 = (t) => {
  const e = z1.processColor(t).toString(16).padStart(8, "0"), a = parseInt(e.slice(0, 2), 16), n = parseInt(e.slice(2, 4), 16), i = parseInt(e.slice(4, 6), 16), o = parseInt(e.slice(6, 8), 16);
  return { a, r: n, g: i, b: o };
}, W = () => u.string().refine((t) => {
  try {
    return T1(t), !0;
  } catch {
    return !1;
  }
}, { message: "Invalid color" }).describe(E1), j1 = ({
  titleText: t,
  titleColor: e
}) => {
  const a = za(), n = sa();
  return /* @__PURE__ */ h.jsxs("ul", { style: {
    fontFamily: "Nunito, sans-serif",
    fontWeight: 700,
    fontSize: 100,
    padding: 20,
    color: e,
    textAlign: "left",
    position: "absolute",
    width: "100%",
    maxWidth: 900,
    top: a.height / 2 - t.length * 300,
    left: a.width / 2 - 500
  }, children: [
    "Wir bieten:",
    /* @__PURE__ */ h.jsx("br", {}),
    t.map((i, o) => /* @__PURE__ */ h.jsxs("li", { style: {
      color: e,
      padding: 30,
      marginLeft: 10,
      marginRight: 10,
      fontFamily: "Nunito, sans-serif",
      fontWeight: 700,
      fontSize: 60,
      transform: `scale(${Mn({
        fps: a.fps,
        frame: n - o * 50,
        config: {
          damping: 100,
          stiffness: 200,
          mass: 0.5
        }
      })})`,
      display: "inline-block"
    }, children: [
      "🌟 ",
      i
    ] }, i))
  ] });
}, Sa = 600, yo = ({
  titleText: t,
  titleColor: e,
  animateIn: a
}) => {
  const n = sa(), {
    width: i,
    height: o,
    fps: s
  } = za(), r = Mn({
    frame: n,
    fps: s
  }), c = yt(n, [400, 490, 491, 520], [1, 1, 0, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp"
  }), l = yt(r, [0, 1], [4, 1]), f = yt(r, [0, 1], [1, 50]);
  return /* @__PURE__ */ h.jsx("div", { style: {
    opacity: c,
    width: Sa,
    height: Sa,
    borderRadius: Sa / 2,
    background: "#222f3e",
    position: "absolute",
    left: i / 2 - Sa / 2,
    top: o / 2 - Sa / 2,
    display: "flex",
    justifyContent: "center",
    justifyItems: "center",
    transform: `scale(${a ? l : f})`
  }, children: /* @__PURE__ */ h.jsx("h1", { style: {
    opacity: c,
    fontSize: 90,
    color: `${e}`,
    fontFamily: "Nunito, sans-serif",
    fontWeight: 700,
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0"
  }, children: t }) });
}, U1 = ({
  imageUrl: t
}) => {
  const e = sa(), a = yt(e, [0, 60], [0, 1], {
    extrapolateRight: "clamp"
  }), n = yt(a, [0, 1], [1.19, 1]);
  return t ? /* @__PURE__ */ h.jsx("div", { style: {
    transform: `scale(${n})`,
    height: "100%"
  }, children: /* @__PURE__ */ h.jsx(pt, { src: t, style: {
    height: "100%",
    width: "100%",
    objectFit: "cover"
  } }) }) : /* @__PURE__ */ h.jsx(h.Fragment, {});
}, S1 = ({
  logoUrl: t
}) => {
  const e = sa(), {
    width: a,
    fps: n
  } = za(), i = Mn({
    frame: e,
    fps: n
  }), o = yt(i, [0, 1], [4, 1]);
  return t ? /* @__PURE__ */ h.jsx("div", { style: {
    width: 500,
    height: 500,
    background: "white",
    padding: 20,
    borderRadius: 5,
    position: "absolute",
    top: 150,
    left: a / 2 - 250,
    transform: `scale(${o})`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, children: /* @__PURE__ */ h.jsx(pt, { src: t, style: {
    width: "100%"
  } }) }) : /* @__PURE__ */ h.jsx(h.Fragment, {});
}, vo = ({
  titleText: t = "",
  titleColor: e
}) => {
  const a = za(), n = sa(), i = t.split(" ").map((o) => ` ${o} `);
  return /* @__PURE__ */ h.jsx("h1", { style: {
    fontFamily: "Nunito, sans-serif",
    fontWeight: 700,
    fontSize: 100,
    textAlign: "center",
    position: "absolute",
    width: "100%",
    maxWidth: 800,
    top: a.height / 2 - t.split(" ").length / 2 * 100,
    left: a.width / 2 - 400
  }, children: i.map((o, s) => /* @__PURE__ */ h.jsx("span", { style: {
    color: e,
    marginLeft: 10,
    marginRight: 10,
    fontWeight: 700,
    transform: `scale(${Mn({
      fps: a.fps,
      frame: n - s * 5,
      config: {
        damping: 100,
        stiffness: 200,
        mass: 0.5
      }
    })})`,
    display: "inline-block"
  }, children: o }, o)) });
};
u.object({
  title: u.string(),
  primaryTextColor: W(),
  primaryBackgroundColor: W(),
  titleColor: W().optional(),
  mainColor: W().optional(),
  outroText: u.string(),
  CTAText: u.string(),
  benefits: u.array(u.string()),
  imageUrl: u.string().url(),
  logoUrl: u.string().url().optional(),
  audioUrl: u.string().url().optional()
});
const A1 = ({
  title: t,
  primaryTextColor: e,
  primaryBackgroundColor: a,
  titleColor: n,
  mainColor: i,
  outroText: o,
  CTAText: s,
  benefits: r,
  imageUrl: c,
  logoUrl: l,
  audioUrl: f
}) => {
  const m = n || e, v = i || a, k = sa(), C = yt(k, [65, 105], [1, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp"
  }), E = yt(k, [85, 120, 175, 190], [0, 1, 1, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp"
  }), b = yt(k, [195, 250, 377, 400], [0, 1, 1, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp"
  }), D = yt(k, [400, 420, 460, 500], [0, 1, 1, 0]), j = Js(k, [420, 450], [m, "#222f3e"]), x = 25, _ = `linear-gradient(0deg, #020024 0%, ${v} 50%)`;
  return /* @__PURE__ */ h.jsxs("div", { style: {
    flex: 1,
    background: _,
    height: "100%",
    lineHeight: "1"
    // set for onlyfy-web
  }, children: [
    f && /* @__PURE__ */ h.jsx(ra, { src: f, volume: 1, startFrom: 0 }),
    /* @__PURE__ */ h.jsx("div", { style: {
      opacity: C
    }, children: /* @__PURE__ */ h.jsx(gt, { name: "Title Sequence", from: 0, durationInFrames: x + 60, children: /* @__PURE__ */ h.jsx(vo, { titleText: t, titleColor: m }) }) }),
    /* @__PURE__ */ h.jsx(gt, { name: "Image Sequence", from: 85, durationInFrames: 120, children: /* @__PURE__ */ h.jsx("div", { style: {
      opacity: E
    }, children: /* @__PURE__ */ h.jsx(U1, { imageUrl: c }) }) }),
    /* @__PURE__ */ h.jsx("div", { style: {
      opacity: b
    }, children: /* @__PURE__ */ h.jsx(gt, { name: "Benefits Sequence", from: 195, durationInFrames: 400, children: /* @__PURE__ */ h.jsx(j1, { titleText: r, titleColor: m }) }) }),
    /* @__PURE__ */ h.jsxs("div", { style: {
      opacity: D
    }, children: [
      /* @__PURE__ */ h.jsx(gt, { name: "CTA fadein", from: 400, durationInFrames: 450, children: /* @__PURE__ */ h.jsx(yo, { animateIn: !0, titleText: s, titleColor: m }) }),
      /* @__PURE__ */ h.jsx(gt, { name: "CTA cover", from: 450, durationInFrames: 480, children: /* @__PURE__ */ h.jsx(yo, { animateIn: !1, titleText: s, titleColor: j }) })
    ] }),
    /* @__PURE__ */ h.jsx("div", { style: {
      background: _
    }, children: /* @__PURE__ */ h.jsxs(gt, { name: "Outro sequence", from: 470, durationInFrames: 600, children: [
      /* @__PURE__ */ h.jsx(vo, { titleText: o, titleColor: m }),
      /* @__PURE__ */ h.jsx(S1, { logoUrl: l })
    ] }) })
  ] });
}, ei = {}, Le = (t, e, a) => {
  var n, i, o, s;
  const r = [], c = e ? [e] : Object.keys(t.fonts);
  for (const l of c) {
    if (typeof FontFace > "u")
      continue;
    if (!t.fonts[l])
      throw new Error(`The font ${t.fontFamily} does not have a style ${l}`);
    const f = (n = a == null ? void 0 : a.weights) !== null && n !== void 0 ? n : Object.keys(t.fonts[l]);
    for (const m of f) {
      if (!t.fonts[l][m])
        throw new Error(`The font ${t.fontFamily} does not have a weight ${m} in style ${l}`);
      const v = (i = a == null ? void 0 : a.subsets) !== null && i !== void 0 ? i : Object.keys(t.fonts[l][m]);
      for (const k of v) {
        let C = (s = (o = t.fonts[l]) === null || o === void 0 ? void 0 : o[m]) === null || s === void 0 ? void 0 : s[k];
        if (!C)
          throw new Error(`weight: ${m} subset: ${k} is not available for '${t.fontFamily}'`);
        let E = `${t.fontFamily}-${l}-${m}-${k}`;
        if (ei[E])
          continue;
        ei[E] = !0;
        const b = Ma(`Fetching ${t.fontFamily} font ${JSON.stringify({
          style: l,
          weight: m,
          subset: k
        })}`), D = new FontFace(t.fontFamily, `url(${C}) format('woff2')`, {
          weight: m,
          style: l,
          unicodeRange: t.unicodeRanges[k]
        }), j = D.load().then(() => {
          var x;
          ((x = a == null ? void 0 : a.document) !== null && x !== void 0 ? x : document).fonts.add(D), bt(b);
        }).catch((x) => {
          throw ei[E] = !1, x;
        });
        r.push(j);
      }
    }
  }
  return {
    fontFamily: t.fontFamily,
    fonts: t.fonts,
    unicodeRanges: t.unicodeRanges,
    waitUntilDone: () => Promise.all(r).then(() => {
    })
  };
}, Si = () => ({
  fontFamily: "Roboto",
  importName: "Roboto",
  version: "v30",
  url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900",
  unicodeRanges: {
    "cyrillic-ext": "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
    cyrillic: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    "greek-ext": "U+1F00-1FFF",
    greek: "U+0370-03FF",
    vietnamese: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    italic: {
      100: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOiCnqEu92Fr1Mu51QrEz0dL_nz.woff2",
        cyrillic: "https://fonts.gstatic.com/s/roboto/v30/KFOiCnqEu92Fr1Mu51QrEzQdL_nz.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOiCnqEu92Fr1Mu51QrEzwdL_nz.woff2",
        greek: "https://fonts.gstatic.com/s/roboto/v30/KFOiCnqEu92Fr1Mu51QrEzMdL_nz.woff2",
        vietnamese: "https://fonts.gstatic.com/s/roboto/v30/KFOiCnqEu92Fr1Mu51QrEz8dL_nz.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOiCnqEu92Fr1Mu51QrEz4dL_nz.woff2",
        latin: "https://fonts.gstatic.com/s/roboto/v30/KFOiCnqEu92Fr1Mu51QrEzAdLw.woff2"
      },
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TjASc3CsTKlA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TjASc-CsTKlA.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TjASc2CsTKlA.woff2",
        greek: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TjASc5CsTKlA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TjASc1CsTKlA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TjASc0CsTKlA.woff2",
        latin: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TjASc6CsQ.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1Mu51xFIzIFKw.woff2",
        cyrillic: "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1Mu51xMIzIFKw.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1Mu51xEIzIFKw.woff2",
        greek: "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1Mu51xLIzIFKw.woff2",
        vietnamese: "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1Mu51xHIzIFKw.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1Mu51xGIzIFKw.woff2",
        latin: "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1Mu51xIIzI.woff2"
      },
      500: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51S7ACc3CsTKlA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51S7ACc-CsTKlA.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51S7ACc2CsTKlA.woff2",
        greek: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51S7ACc5CsTKlA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51S7ACc1CsTKlA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51S7ACc0CsTKlA.woff2",
        latin: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51S7ACc6CsQ.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TzBic3CsTKlA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TzBic-CsTKlA.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TzBic2CsTKlA.woff2",
        greek: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TzBic5CsTKlA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TzBic1CsTKlA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TzBic0CsTKlA.woff2",
        latin: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TzBic6CsQ.woff2"
      },
      900: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TLBCc3CsTKlA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TLBCc-CsTKlA.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TLBCc2CsTKlA.woff2",
        greek: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TLBCc5CsTKlA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TLBCc1CsTKlA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TLBCc0CsTKlA.woff2",
        latin: "https://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TLBCc6CsQ.woff2"
      }
    },
    normal: {
      100: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1MmgVxFIzIFKw.woff2",
        cyrillic: "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1MmgVxMIzIFKw.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1MmgVxEIzIFKw.woff2",
        greek: "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1MmgVxLIzIFKw.woff2",
        vietnamese: "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1MmgVxHIzIFKw.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1MmgVxGIzIFKw.woff2",
        latin: "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1MmgVxIIzI.woff2"
      },
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmSU5fCRc4EsA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmSU5fABc4EsA.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmSU5fCBc4EsA.woff2",
        greek: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmSU5fBxc4EsA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmSU5fCxc4EsA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmSU5fChc4EsA.woff2",
        latin: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmSU5fBBc4.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu72xKOzY.woff2",
        cyrillic: "https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu5mxKOzY.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu7mxKOzY.woff2",
        greek: "https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu4WxKOzY.woff2",
        vietnamese: "https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu7WxKOzY.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu7GxKOzY.woff2",
        latin: "https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu4mxK.woff2"
      },
      500: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmEU9fCRc4EsA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmEU9fABc4EsA.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmEU9fCBc4EsA.woff2",
        greek: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmEU9fBxc4EsA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmEU9fCxc4EsA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmEU9fChc4EsA.woff2",
        latin: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmEU9fBBc4.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlfCRc4EsA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlfABc4EsA.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlfCBc4EsA.woff2",
        greek: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlfBxc4EsA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlfCxc4EsA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlfChc4EsA.woff2",
        latin: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlfBBc4.woff2"
      },
      900: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmYUtfCRc4EsA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmYUtfABc4EsA.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmYUtfCBc4EsA.woff2",
        greek: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmYUtfBxc4EsA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmYUtfCxc4EsA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmYUtfChc4EsA.woff2",
        latin: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmYUtfBBc4.woff2"
      }
    }
  }
}), I1 = Si().fontFamily, D1 = (t, e) => Le(Si(), t, e), B1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: I1,
  getInfo: Si,
  loadFont: D1
}, Symbol.toStringTag, { value: "Module" })), Ai = () => ({
  fontFamily: "Open Sans",
  importName: "OpenSans",
  version: "v36",
  url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800",
  unicodeRanges: {
    "cyrillic-ext": "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
    cyrillic: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    "greek-ext": "U+1F00-1FFF",
    greek: "U+0370-03FF",
    hebrew: "U+0590-05FF, U+200C-2010, U+20AA, U+25CC, U+FB1D-FB4F",
    vietnamese: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    italic: {
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtE6F15M.woff2",
        cyrillic: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWvU6F15M.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtU6F15M.woff2",
        greek: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuk6F15M.woff2",
        hebrew: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWu06F15M.woff2",
        vietnamese: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtk6F15M.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWt06F15M.woff2",
        latin: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuU6F.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtE6F15M.woff2",
        cyrillic: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWvU6F15M.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtU6F15M.woff2",
        greek: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuk6F15M.woff2",
        hebrew: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWu06F15M.woff2",
        vietnamese: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtk6F15M.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWt06F15M.woff2",
        latin: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuU6F.woff2"
      },
      500: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtE6F15M.woff2",
        cyrillic: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWvU6F15M.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtU6F15M.woff2",
        greek: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuk6F15M.woff2",
        hebrew: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWu06F15M.woff2",
        vietnamese: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtk6F15M.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWt06F15M.woff2",
        latin: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuU6F.woff2"
      },
      600: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtE6F15M.woff2",
        cyrillic: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWvU6F15M.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtU6F15M.woff2",
        greek: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuk6F15M.woff2",
        hebrew: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWu06F15M.woff2",
        vietnamese: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtk6F15M.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWt06F15M.woff2",
        latin: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuU6F.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtE6F15M.woff2",
        cyrillic: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWvU6F15M.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtU6F15M.woff2",
        greek: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuk6F15M.woff2",
        hebrew: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWu06F15M.woff2",
        vietnamese: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtk6F15M.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWt06F15M.woff2",
        latin: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuU6F.woff2"
      },
      800: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtE6F15M.woff2",
        cyrillic: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWvU6F15M.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtU6F15M.woff2",
        greek: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuk6F15M.woff2",
        hebrew: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWu06F15M.woff2",
        vietnamese: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtk6F15M.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWt06F15M.woff2",
        latin: "https://fonts.gstatic.com/s/opensans/v36/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuU6F.woff2"
      }
    },
    normal: {
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSKmu1aB.woff2",
        cyrillic: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSumu1aB.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSOmu1aB.woff2",
        greek: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSymu1aB.woff2",
        hebrew: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS2mu1aB.woff2",
        vietnamese: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSCmu1aB.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu1aB.woff2",
        latin: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSKmu1aB.woff2",
        cyrillic: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSumu1aB.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSOmu1aB.woff2",
        greek: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSymu1aB.woff2",
        hebrew: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS2mu1aB.woff2",
        vietnamese: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSCmu1aB.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu1aB.woff2",
        latin: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.woff2"
      },
      500: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSKmu1aB.woff2",
        cyrillic: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSumu1aB.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSOmu1aB.woff2",
        greek: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSymu1aB.woff2",
        hebrew: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS2mu1aB.woff2",
        vietnamese: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSCmu1aB.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu1aB.woff2",
        latin: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.woff2"
      },
      600: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSKmu1aB.woff2",
        cyrillic: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSumu1aB.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSOmu1aB.woff2",
        greek: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSymu1aB.woff2",
        hebrew: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS2mu1aB.woff2",
        vietnamese: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSCmu1aB.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu1aB.woff2",
        latin: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSKmu1aB.woff2",
        cyrillic: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSumu1aB.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSOmu1aB.woff2",
        greek: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSymu1aB.woff2",
        hebrew: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS2mu1aB.woff2",
        vietnamese: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSCmu1aB.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu1aB.woff2",
        latin: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.woff2"
      },
      800: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSKmu1aB.woff2",
        cyrillic: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSumu1aB.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSOmu1aB.woff2",
        greek: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSymu1aB.woff2",
        hebrew: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS2mu1aB.woff2",
        vietnamese: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSCmu1aB.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu1aB.woff2",
        latin: "https://fonts.gstatic.com/s/opensans/v36/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.woff2"
      }
    }
  }
}), R1 = Ai().fontFamily, os = (t, e) => Le(Ai(), t, e), O1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: R1,
  getInfo: Ai,
  loadFont: os
}, Symbol.toStringTag, { value: "Module" })), Ii = () => ({
  fontFamily: "Lato",
  importName: "Lato",
  version: "v24",
  url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900",
  unicodeRanges: {
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    italic: {
      100: {
        "latin-ext": "https://fonts.gstatic.com/s/lato/v24/S6u-w4BMUTPHjxsIPx-mPCLQ7A.woff2",
        latin: "https://fonts.gstatic.com/s/lato/v24/S6u-w4BMUTPHjxsIPx-oPCI.woff2"
      },
      300: {
        "latin-ext": "https://fonts.gstatic.com/s/lato/v24/S6u_w4BMUTPHjxsI9w2_FQft1dw.woff2",
        latin: "https://fonts.gstatic.com/s/lato/v24/S6u_w4BMUTPHjxsI9w2_Gwft.woff2"
      },
      400: {
        "latin-ext": "https://fonts.gstatic.com/s/lato/v24/S6u8w4BMUTPHjxsAUi-qJCY.woff2",
        latin: "https://fonts.gstatic.com/s/lato/v24/S6u8w4BMUTPHjxsAXC-q.woff2"
      },
      700: {
        "latin-ext": "https://fonts.gstatic.com/s/lato/v24/S6u_w4BMUTPHjxsI5wq_FQft1dw.woff2",
        latin: "https://fonts.gstatic.com/s/lato/v24/S6u_w4BMUTPHjxsI5wq_Gwft.woff2"
      },
      900: {
        "latin-ext": "https://fonts.gstatic.com/s/lato/v24/S6u_w4BMUTPHjxsI3wi_FQft1dw.woff2",
        latin: "https://fonts.gstatic.com/s/lato/v24/S6u_w4BMUTPHjxsI3wi_Gwft.woff2"
      }
    },
    normal: {
      100: {
        "latin-ext": "https://fonts.gstatic.com/s/lato/v24/S6u8w4BMUTPHh30AUi-qJCY.woff2",
        latin: "https://fonts.gstatic.com/s/lato/v24/S6u8w4BMUTPHh30AXC-q.woff2"
      },
      300: {
        "latin-ext": "https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh7USSwaPGR_p.woff2",
        latin: "https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh7USSwiPGQ.woff2"
      },
      400: {
        "latin-ext": "https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjxAwXjeu.woff2",
        latin: "https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjx4wXg.woff2"
      },
      700: {
        "latin-ext": "https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVSwaPGR_p.woff2",
        latin: "https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVSwiPGQ.woff2"
      },
      900: {
        "latin-ext": "https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh50XSwaPGR_p.woff2",
        latin: "https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh50XSwiPGQ.woff2"
      }
    }
  }
}), P1 = Ii().fontFamily, N1 = (t, e) => Le(Ii(), t, e), M1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: P1,
  getInfo: Ii,
  loadFont: N1
}, Symbol.toStringTag, { value: "Module" })), Di = () => ({
  fontFamily: "Montserrat",
  importName: "Montserrat",
  version: "v26",
  url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900",
  unicodeRanges: {
    "cyrillic-ext": "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
    cyrillic: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    vietnamese: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    italic: {
      100: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxC7mw9c.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRzS7mw9c.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxi7mw9c.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxy7mw9c.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRyS7m.woff2"
      },
      200: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxC7mw9c.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRzS7mw9c.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxi7mw9c.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxy7mw9c.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRyS7m.woff2"
      },
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxC7mw9c.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRzS7mw9c.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxi7mw9c.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxy7mw9c.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRyS7m.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxC7mw9c.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRzS7mw9c.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxi7mw9c.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxy7mw9c.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRyS7m.woff2"
      },
      500: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxC7mw9c.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRzS7mw9c.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxi7mw9c.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxy7mw9c.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRyS7m.woff2"
      },
      600: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxC7mw9c.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRzS7mw9c.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxi7mw9c.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxy7mw9c.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRyS7m.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxC7mw9c.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRzS7mw9c.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxi7mw9c.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxy7mw9c.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRyS7m.woff2"
      },
      800: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxC7mw9c.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRzS7mw9c.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxi7mw9c.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxy7mw9c.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRyS7m.woff2"
      },
      900: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxC7mw9c.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRzS7mw9c.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxi7mw9c.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRxy7mw9c.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUQjIg1_i6t8kCHKm459WxRyS7m.woff2"
      }
    },
    normal: {
      100: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WRhyzbi.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459W1hyzbi.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WZhyzbi.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wdhyzbi.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wlhyw.woff2"
      },
      200: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WRhyzbi.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459W1hyzbi.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WZhyzbi.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wdhyzbi.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wlhyw.woff2"
      },
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WRhyzbi.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459W1hyzbi.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WZhyzbi.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wdhyzbi.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wlhyw.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WRhyzbi.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459W1hyzbi.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WZhyzbi.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wdhyzbi.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wlhyw.woff2"
      },
      500: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WRhyzbi.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459W1hyzbi.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WZhyzbi.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wdhyzbi.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wlhyw.woff2"
      },
      600: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WRhyzbi.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459W1hyzbi.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WZhyzbi.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wdhyzbi.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wlhyw.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WRhyzbi.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459W1hyzbi.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WZhyzbi.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wdhyzbi.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wlhyw.woff2"
      },
      800: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WRhyzbi.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459W1hyzbi.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WZhyzbi.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wdhyzbi.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wlhyw.woff2"
      },
      900: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WRhyzbi.woff2",
        cyrillic: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459W1hyzbi.woff2",
        vietnamese: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WZhyzbi.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wdhyzbi.woff2",
        latin: "https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459Wlhyw.woff2"
      }
    }
  }
}), V1 = Di().fontFamily, X1 = (t, e) => Le(Di(), t, e), K1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: V1,
  getInfo: Di,
  loadFont: X1
}, Symbol.toStringTag, { value: "Module" })), Bi = () => ({
  fontFamily: "Raleway",
  importName: "Raleway",
  version: "v29",
  url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900",
  unicodeRanges: {
    "cyrillic-ext": "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
    cyrillic: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    vietnamese: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    italic: {
      100: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QIFqPfE.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4SYFqPfE.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QoFqPfE.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4Q4FqPfE.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4TYFq.woff2"
      },
      200: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QIFqPfE.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4SYFqPfE.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QoFqPfE.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4Q4FqPfE.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4TYFq.woff2"
      },
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QIFqPfE.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4SYFqPfE.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QoFqPfE.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4Q4FqPfE.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4TYFq.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QIFqPfE.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4SYFqPfE.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QoFqPfE.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4Q4FqPfE.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4TYFq.woff2"
      },
      500: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QIFqPfE.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4SYFqPfE.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QoFqPfE.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4Q4FqPfE.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4TYFq.woff2"
      },
      600: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QIFqPfE.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4SYFqPfE.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QoFqPfE.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4Q4FqPfE.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4TYFq.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QIFqPfE.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4SYFqPfE.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QoFqPfE.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4Q4FqPfE.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4TYFq.woff2"
      },
      800: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QIFqPfE.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4SYFqPfE.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QoFqPfE.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4Q4FqPfE.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4TYFq.woff2"
      },
      900: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QIFqPfE.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4SYFqPfE.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QoFqPfE.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4Q4FqPfE.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4TYFq.woff2"
      }
    },
    normal: {
      100: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCAIT5lu.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCkIT5lu.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCIIT5lu.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCMIT5lu.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyC0ITw.woff2"
      },
      200: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCAIT5lu.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCkIT5lu.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCIIT5lu.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCMIT5lu.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyC0ITw.woff2"
      },
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCAIT5lu.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCkIT5lu.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCIIT5lu.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCMIT5lu.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyC0ITw.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCAIT5lu.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCkIT5lu.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCIIT5lu.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCMIT5lu.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyC0ITw.woff2"
      },
      500: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCAIT5lu.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCkIT5lu.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCIIT5lu.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCMIT5lu.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyC0ITw.woff2"
      },
      600: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCAIT5lu.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCkIT5lu.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCIIT5lu.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCMIT5lu.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyC0ITw.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCAIT5lu.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCkIT5lu.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCIIT5lu.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCMIT5lu.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyC0ITw.woff2"
      },
      800: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCAIT5lu.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCkIT5lu.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCIIT5lu.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCMIT5lu.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyC0ITw.woff2"
      },
      900: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCAIT5lu.woff2",
        cyrillic: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCkIT5lu.woff2",
        vietnamese: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCIIT5lu.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCMIT5lu.woff2",
        latin: "https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyC0ITw.woff2"
      }
    }
  }
}), L1 = Bi().fontFamily, q1 = (t, e) => Le(Bi(), t, e), W1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: L1,
  getInfo: Bi,
  loadFont: q1
}, Symbol.toStringTag, { value: "Module" })), Ri = () => ({
  fontFamily: "Poppins",
  importName: "Poppins",
  version: "v20",
  url: "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900",
  unicodeRanges: {
    devanagari: "U+0900-097F, U+1CD0-1CF9, U+200C-200D, U+20A8, U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FF",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    italic: {
      100: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE0tDMPKzSQ.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE0tMMPKzSQ.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE0tCMPI.woff2"
      },
      200: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1pVFteOcEg.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1pVGdeOcEg.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1pVF9eO.woff2"
      },
      300: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21lVFteOcEg.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21lVGdeOcEg.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21lVF9eO.woff2"
      },
      400: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLucXtAKPY.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLufntAKPY.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLucHtA.woff2"
      },
      500: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hVFteOcEg.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hVGdeOcEg.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hVF9eO.woff2"
      },
      600: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19VFteOcEg.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19VGdeOcEg.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19VF9eO.woff2"
      },
      700: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15VFteOcEg.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15VGdeOcEg.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15VF9eO.woff2"
      },
      800: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111VFteOcEg.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111VGdeOcEg.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111VF9eO.woff2"
      },
      900: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xVFteOcEg.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xVGdeOcEg.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xVF9eO.woff2"
      }
    },
    normal: {
      100: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTucXtAKPY.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTufntAKPY.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTucHtA.woff2"
      },
      200: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_Z11lFc-K.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_Z1JlFc-K.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_Z1xlFQ.woff2"
      },
      300: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8Z11lFc-K.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8Z1JlFc-K.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8Z1xlFQ.woff2"
      },
      400: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrJJbecmNE.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrJJnecmNE.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrJJfecg.woff2"
      },
      500: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9Z11lFc-K.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9Z1JlFc-K.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9Z1xlFQ.woff2"
      },
      600: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6Z11lFc-K.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6Z1JlFc-K.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6Z1xlFQ.woff2"
      },
      700: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7Z11lFc-K.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7Z1JlFc-K.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7Z1xlFQ.woff2"
      },
      800: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4Z11lFc-K.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4Z1JlFc-K.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4Z1xlFQ.woff2"
      },
      900: {
        devanagari: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5Z11lFc-K.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5Z1JlFc-K.woff2",
        latin: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5Z1xlFQ.woff2"
      }
    }
  }
}), Y1 = Ri().fontFamily, $1 = (t, e) => Le(Ri(), t, e), H1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: Y1,
  getInfo: Ri,
  loadFont: $1
}, Symbol.toStringTag, { value: "Module" })), Oi = () => ({
  fontFamily: "Ubuntu",
  importName: "Ubuntu",
  version: "v20",
  url: "https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700",
  unicodeRanges: {
    "cyrillic-ext": "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
    cyrillic: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    "greek-ext": "U+1F00-1FFF",
    greek: "U+0370-03FF",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    italic: {
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejZftVyCN4Ffgg.woff2",
        cyrillic: "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejZftVyLN4Ffgg.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejZftVyDN4Ffgg.woff2",
        greek: "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejZftVyMN4Ffgg.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejZftVyBN4Ffgg.woff2",
        latin: "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejZftVyPN4E.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCu6KVjbNBYlgoKej75l0mwFg.woff2",
        cyrillic: "https://fonts.gstatic.com/s/ubuntu/v20/4iCu6KVjbNBYlgoKej7wl0mwFg.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCu6KVjbNBYlgoKej74l0mwFg.woff2",
        greek: "https://fonts.gstatic.com/s/ubuntu/v20/4iCu6KVjbNBYlgoKej73l0mwFg.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCu6KVjbNBYlgoKej76l0mwFg.woff2",
        latin: "https://fonts.gstatic.com/s/ubuntu/v20/4iCu6KVjbNBYlgoKej70l0k.woff2"
      },
      500: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejYHtFyCN4Ffgg.woff2",
        cyrillic: "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejYHtFyLN4Ffgg.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejYHtFyDN4Ffgg.woff2",
        greek: "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejYHtFyMN4Ffgg.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejYHtFyBN4Ffgg.woff2",
        latin: "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejYHtFyPN4E.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejZPslyCN4Ffgg.woff2",
        cyrillic: "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejZPslyLN4Ffgg.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejZPslyDN4Ffgg.woff2",
        greek: "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejZPslyMN4Ffgg.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejZPslyBN4Ffgg.woff2",
        latin: "https://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejZPslyPN4E.woff2"
      }
    },
    normal: {
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoC1CzjvWyNL4U.woff2",
        cyrillic: "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoC1CzjtGyNL4U.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoC1CzjvGyNL4U.woff2",
        greek: "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoC1Czjs2yNL4U.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoC1CzjvmyNL4U.woff2",
        latin: "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoC1CzjsGyN.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCs6KVjbNBYlgoKcg72j00.woff2",
        cyrillic: "https://fonts.gstatic.com/s/ubuntu/v20/4iCs6KVjbNBYlgoKew72j00.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCs6KVjbNBYlgoKcw72j00.woff2",
        greek: "https://fonts.gstatic.com/s/ubuntu/v20/4iCs6KVjbNBYlgoKfA72j00.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCs6KVjbNBYlgoKcQ72j00.woff2",
        latin: "https://fonts.gstatic.com/s/ubuntu/v20/4iCs6KVjbNBYlgoKfw72.woff2"
      },
      500: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCjC3jvWyNL4U.woff2",
        cyrillic: "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCjC3jtGyNL4U.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCjC3jvGyNL4U.woff2",
        greek: "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCjC3js2yNL4U.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCjC3jvmyNL4U.woff2",
        latin: "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCjC3jsGyN.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCxCvjvWyNL4U.woff2",
        cyrillic: "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCxCvjtGyNL4U.woff2",
        "greek-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCxCvjvGyNL4U.woff2",
        greek: "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCxCvjs2yNL4U.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCxCvjvmyNL4U.woff2",
        latin: "https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCxCvjsGyN.woff2"
      }
    }
  }
}), Z1 = Oi().fontFamily, J1 = (t, e) => Le(Oi(), t, e), G1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: Z1,
  getInfo: Oi,
  loadFont: J1
}, Symbol.toStringTag, { value: "Module" })), Pi = () => ({
  fontFamily: "Playfair Display",
  importName: "PlayfairDisplay",
  version: "v36",
  url: "https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900",
  unicodeRanges: {
    cyrillic: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    vietnamese: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    italic: {
      400: {
        cyrillic: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnohkk72xU.woff2",
        vietnamese: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnojUk72xU.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnojEk72xU.woff2",
        latin: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnogkk7.woff2"
      },
      500: {
        cyrillic: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnohkk72xU.woff2",
        vietnamese: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnojUk72xU.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnojEk72xU.woff2",
        latin: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnogkk7.woff2"
      },
      600: {
        cyrillic: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnohkk72xU.woff2",
        vietnamese: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnojUk72xU.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnojEk72xU.woff2",
        latin: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnogkk7.woff2"
      },
      700: {
        cyrillic: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnohkk72xU.woff2",
        vietnamese: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnojUk72xU.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnojEk72xU.woff2",
        latin: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnogkk7.woff2"
      },
      800: {
        cyrillic: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnohkk72xU.woff2",
        vietnamese: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnojUk72xU.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnojEk72xU.woff2",
        latin: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnogkk7.woff2"
      },
      900: {
        cyrillic: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnohkk72xU.woff2",
        vietnamese: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnojUk72xU.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnojEk72xU.woff2",
        latin: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFkD-vYSZviVYUb_rj3ij__anPXDTnogkk7.woff2"
      }
    },
    normal: {
      400: {
        cyrillic: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTjYgFE_.woff2",
        vietnamese: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTPYgFE_.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTLYgFE_.woff2",
        latin: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTzYgA.woff2"
      },
      500: {
        cyrillic: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTjYgFE_.woff2",
        vietnamese: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTPYgFE_.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTLYgFE_.woff2",
        latin: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTzYgA.woff2"
      },
      600: {
        cyrillic: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTjYgFE_.woff2",
        vietnamese: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTPYgFE_.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTLYgFE_.woff2",
        latin: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTzYgA.woff2"
      },
      700: {
        cyrillic: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTjYgFE_.woff2",
        vietnamese: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTPYgFE_.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTLYgFE_.woff2",
        latin: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTzYgA.woff2"
      },
      800: {
        cyrillic: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTjYgFE_.woff2",
        vietnamese: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTPYgFE_.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTLYgFE_.woff2",
        latin: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTzYgA.woff2"
      },
      900: {
        cyrillic: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTjYgFE_.woff2",
        vietnamese: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTPYgFE_.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTLYgFE_.woff2",
        latin: "https://fonts.gstatic.com/s/playfairdisplay/v36/nuFiD-vYSZviVYUb_rj3ij__anPXDTzYgA.woff2"
      }
    }
  }
}), Q1 = Pi().fontFamily, e2 = (t, e) => Le(Pi(), t, e), t2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: Q1,
  getInfo: Pi,
  loadFont: e2
}, Symbol.toStringTag, { value: "Module" })), Ni = () => ({
  fontFamily: "Merriweather",
  importName: "Merriweather",
  version: "v30",
  url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900",
  unicodeRanges: {
    "cyrillic-ext": "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
    cyrillic: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    vietnamese: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    italic: {
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR7lXff1jvzRPA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR7lXff8jvzRPA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR7lXff3jvzRPA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR7lXff2jvzRPA.woff2",
        latin: "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR7lXff4jvw.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-4m0qyriQwlOrhSvowK_l5-eRZDf-LHrw.woff2",
        cyrillic: "https://fonts.gstatic.com/s/merriweather/v30/u-4m0qyriQwlOrhSvowK_l5-eRZKf-LHrw.woff2",
        vietnamese: "https://fonts.gstatic.com/s/merriweather/v30/u-4m0qyriQwlOrhSvowK_l5-eRZBf-LHrw.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-4m0qyriQwlOrhSvowK_l5-eRZAf-LHrw.woff2",
        latin: "https://fonts.gstatic.com/s/merriweather/v30/u-4m0qyriQwlOrhSvowK_l5-eRZOf-I.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR71Wvf1jvzRPA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR71Wvf8jvzRPA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR71Wvf3jvzRPA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR71Wvf2jvzRPA.woff2",
        latin: "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR71Wvf4jvw.woff2"
      },
      900: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR7NWPf1jvzRPA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR7NWPf8jvzRPA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR7NWPf3jvzRPA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR7NWPf2jvzRPA.woff2",
        latin: "https://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR7NWPf4jvw.woff2"
      }
    },
    normal: {
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l521wRZVcf6lvg.woff2",
        cyrillic: "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l521wRZXMf6lvg.woff2",
        vietnamese: "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l521wRZV8f6lvg.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l521wRZVsf6lvg.woff2",
        latin: "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l521wRZWMf6.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-440qyriQwlOrhSvowK_l5-cSZMZ-Y.woff2",
        cyrillic: "https://fonts.gstatic.com/s/merriweather/v30/u-440qyriQwlOrhSvowK_l5-eCZMZ-Y.woff2",
        vietnamese: "https://fonts.gstatic.com/s/merriweather/v30/u-440qyriQwlOrhSvowK_l5-cyZMZ-Y.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-440qyriQwlOrhSvowK_l5-ciZMZ-Y.woff2",
        latin: "https://fonts.gstatic.com/s/merriweather/v30/u-440qyriQwlOrhSvowK_l5-fCZM.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l52xwNZVcf6lvg.woff2",
        cyrillic: "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l52xwNZXMf6lvg.woff2",
        vietnamese: "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l52xwNZV8f6lvg.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l52xwNZVsf6lvg.woff2",
        latin: "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l52xwNZWMf6.woff2"
      },
      900: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l52_wFZVcf6lvg.woff2",
        cyrillic: "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l52_wFZXMf6lvg.woff2",
        vietnamese: "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l52_wFZV8f6lvg.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l52_wFZVsf6lvg.woff2",
        latin: "https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l52_wFZWMf6.woff2"
      }
    }
  }
}), a2 = Ni().fontFamily, n2 = (t, e) => Le(Ni(), t, e), i2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: a2,
  getInfo: Ni,
  loadFont: n2
}, Symbol.toStringTag, { value: "Module" })), Mi = () => ({
  fontFamily: "Nunito",
  importName: "Nunito",
  version: "v26",
  url: "https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900",
  unicodeRanges: {
    "cyrillic-ext": "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
    cyrillic: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    vietnamese: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    italic: {
      200: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaORs71cA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaHRs71cA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaMRs71cA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaNRs71cA.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaDRs4.woff2"
      },
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaORs71cA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaHRs71cA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaMRs71cA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaNRs71cA.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaDRs4.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaORs71cA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaHRs71cA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaMRs71cA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaNRs71cA.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaDRs4.woff2"
      },
      500: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaORs71cA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaHRs71cA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaMRs71cA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaNRs71cA.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaDRs4.woff2"
      },
      600: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaORs71cA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaHRs71cA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaMRs71cA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaNRs71cA.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaDRs4.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaORs71cA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaHRs71cA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaMRs71cA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaNRs71cA.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaDRs4.woff2"
      },
      800: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaORs71cA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaHRs71cA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaMRs71cA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaNRs71cA.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaDRs4.woff2"
      },
      900: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaORs71cA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaHRs71cA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaMRs71cA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaNRs71cA.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXX3I6Li01BKofIMNaDRs4.woff2"
      }
    },
    normal: {
      200: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOOaBXso.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIMeaBXso.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOuaBXso.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIO-aBXso.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofINeaB.woff2"
      },
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOOaBXso.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIMeaBXso.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOuaBXso.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIO-aBXso.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofINeaB.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOOaBXso.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIMeaBXso.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOuaBXso.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIO-aBXso.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofINeaB.woff2"
      },
      500: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOOaBXso.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIMeaBXso.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOuaBXso.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIO-aBXso.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofINeaB.woff2"
      },
      600: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOOaBXso.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIMeaBXso.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOuaBXso.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIO-aBXso.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofINeaB.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOOaBXso.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIMeaBXso.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOuaBXso.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIO-aBXso.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofINeaB.woff2"
      },
      800: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOOaBXso.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIMeaBXso.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOuaBXso.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIO-aBXso.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofINeaB.woff2"
      },
      900: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOOaBXso.woff2",
        cyrillic: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIMeaBXso.woff2",
        vietnamese: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIOuaBXso.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofIO-aBXso.woff2",
        latin: "https://fonts.gstatic.com/s/nunito/v26/XRXV3I6Li01BKofINeaB.woff2"
      }
    }
  }
}), o2 = Mi().fontFamily, s2 = (t, e) => Le(Mi(), t, e), r2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: o2,
  getInfo: Mi,
  loadFont: s2
}, Symbol.toStringTag, { value: "Module" })), Vi = () => ({
  fontFamily: "Quicksand",
  importName: "Quicksand",
  version: "v31",
  url: "https://fonts.googleapis.com/css2?family=Quicksand:ital,wght@0,300;0,400;0,500;0,600;0,700",
  unicodeRanges: {
    vietnamese: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    normal: {
      300: {
        vietnamese: "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hJFQNcOM.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hJVQNcOM.woff2",
        latin: "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hK1QN.woff2"
      },
      400: {
        vietnamese: "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hJFQNcOM.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hJVQNcOM.woff2",
        latin: "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hK1QN.woff2"
      },
      500: {
        vietnamese: "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hJFQNcOM.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hJVQNcOM.woff2",
        latin: "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hK1QN.woff2"
      },
      600: {
        vietnamese: "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hJFQNcOM.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hJVQNcOM.woff2",
        latin: "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hK1QN.woff2"
      },
      700: {
        vietnamese: "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hJFQNcOM.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hJVQNcOM.woff2",
        latin: "https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM9iE8KbpRA_hK1QN.woff2"
      }
    }
  }
}), l2 = Vi().fontFamily, c2 = (t, e) => Le(Vi(), t, e), u2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: l2,
  getInfo: Vi,
  loadFont: c2
}, Symbol.toStringTag, { value: "Module" })), Xi = () => ({
  fontFamily: "Oswald",
  importName: "Oswald",
  version: "v53",
  url: "https://fonts.googleapis.com/css2?family=Oswald:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700",
  unicodeRanges: {
    "cyrillic-ext": "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
    cyrillic: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    vietnamese: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    normal: {
      200: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752FD8Ghe4.woff2",
        cyrillic: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752HT8Ghe4.woff2",
        vietnamese: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752Fj8Ghe4.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752Fz8Ghe4.woff2",
        latin: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752GT8G.woff2"
      },
      300: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752FD8Ghe4.woff2",
        cyrillic: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752HT8Ghe4.woff2",
        vietnamese: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752Fj8Ghe4.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752Fz8Ghe4.woff2",
        latin: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752GT8G.woff2"
      },
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752FD8Ghe4.woff2",
        cyrillic: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752HT8Ghe4.woff2",
        vietnamese: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752Fj8Ghe4.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752Fz8Ghe4.woff2",
        latin: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752GT8G.woff2"
      },
      500: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752FD8Ghe4.woff2",
        cyrillic: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752HT8Ghe4.woff2",
        vietnamese: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752Fj8Ghe4.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752Fz8Ghe4.woff2",
        latin: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752GT8G.woff2"
      },
      600: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752FD8Ghe4.woff2",
        cyrillic: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752HT8Ghe4.woff2",
        vietnamese: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752Fj8Ghe4.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752Fz8Ghe4.woff2",
        latin: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752GT8G.woff2"
      },
      700: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752FD8Ghe4.woff2",
        cyrillic: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752HT8Ghe4.woff2",
        vietnamese: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752Fj8Ghe4.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752Fz8Ghe4.woff2",
        latin: "https://fonts.gstatic.com/s/oswald/v53/TK3iWkUHHAIjg752GT8G.woff2"
      }
    }
  }
}), f2 = Xi().fontFamily, d2 = (t, e) => Le(Xi(), t, e), m2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: f2,
  getInfo: Xi,
  loadFont: d2
}, Symbol.toStringTag, { value: "Module" })), Ki = () => ({
  fontFamily: "Dancing Script",
  importName: "DancingScript",
  version: "v25",
  url: "https://fonts.googleapis.com/css2?family=Dancing+Script:ital,wght@0,400;0,500;0,600;0,700",
  unicodeRanges: {
    vietnamese: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    normal: {
      400: {
        vietnamese: "https://fonts.gstatic.com/s/dancingscript/v25/If2RXTr6YS-zF4S-kcSWSVi_szLviuEViw.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/dancingscript/v25/If2RXTr6YS-zF4S-kcSWSVi_szLuiuEViw.woff2",
        latin: "https://fonts.gstatic.com/s/dancingscript/v25/If2RXTr6YS-zF4S-kcSWSVi_szLgiuE.woff2"
      },
      500: {
        vietnamese: "https://fonts.gstatic.com/s/dancingscript/v25/If2RXTr6YS-zF4S-kcSWSVi_szLviuEViw.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/dancingscript/v25/If2RXTr6YS-zF4S-kcSWSVi_szLuiuEViw.woff2",
        latin: "https://fonts.gstatic.com/s/dancingscript/v25/If2RXTr6YS-zF4S-kcSWSVi_szLgiuE.woff2"
      },
      600: {
        vietnamese: "https://fonts.gstatic.com/s/dancingscript/v25/If2RXTr6YS-zF4S-kcSWSVi_szLviuEViw.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/dancingscript/v25/If2RXTr6YS-zF4S-kcSWSVi_szLuiuEViw.woff2",
        latin: "https://fonts.gstatic.com/s/dancingscript/v25/If2RXTr6YS-zF4S-kcSWSVi_szLgiuE.woff2"
      },
      700: {
        vietnamese: "https://fonts.gstatic.com/s/dancingscript/v25/If2RXTr6YS-zF4S-kcSWSVi_szLviuEViw.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/dancingscript/v25/If2RXTr6YS-zF4S-kcSWSVi_szLuiuEViw.woff2",
        latin: "https://fonts.gstatic.com/s/dancingscript/v25/If2RXTr6YS-zF4S-kcSWSVi_szLgiuE.woff2"
      }
    }
  }
}), p2 = Ki().fontFamily, h2 = (t, e) => Le(Ki(), t, e), g2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: p2,
  getInfo: Ki,
  loadFont: h2
}, Symbol.toStringTag, { value: "Module" })), Li = () => ({
  fontFamily: "Pacifico",
  importName: "Pacifico",
  version: "v22",
  url: "https://fonts.googleapis.com/css2?family=Pacifico:ital,wght@0,400",
  unicodeRanges: {
    "cyrillic-ext": "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
    cyrillic: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    vietnamese: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    normal: {
      400: {
        "cyrillic-ext": "https://fonts.gstatic.com/s/pacifico/v22/FwZY7-Qmy14u9lezJ-6K6MmTpA.woff2",
        cyrillic: "https://fonts.gstatic.com/s/pacifico/v22/FwZY7-Qmy14u9lezJ-6D6MmTpA.woff2",
        vietnamese: "https://fonts.gstatic.com/s/pacifico/v22/FwZY7-Qmy14u9lezJ-6I6MmTpA.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/pacifico/v22/FwZY7-Qmy14u9lezJ-6J6MmTpA.woff2",
        latin: "https://fonts.gstatic.com/s/pacifico/v22/FwZY7-Qmy14u9lezJ-6H6Mk.woff2"
      }
    }
  }
}), b2 = Li().fontFamily, y2 = (t, e) => Le(Li(), t, e), v2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: b2,
  getInfo: Li,
  loadFont: y2
}, Symbol.toStringTag, { value: "Module" })), qi = () => ({
  fontFamily: "Rubik",
  importName: "Rubik",
  version: "v28",
  url: "https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900",
  unicodeRanges: {
    arabic: "U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0898-08E1, U+08E3-08FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC",
    "cyrillic-ext": "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
    cyrillic: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    hebrew: "U+0590-05FF, U+200C-2010, U+20AA, U+25CC, U+FB1D-FB4F",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    italic: {
      300: {
        arabic: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXu61F3f.woff2",
        "cyrillic-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXO61F3f.woff2",
        cyrillic: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXq61F3f.woff2",
        hebrew: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXy61F3f.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXC61F3f.woff2",
        latin: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnX661A.woff2"
      },
      400: {
        arabic: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXu61F3f.woff2",
        "cyrillic-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXO61F3f.woff2",
        cyrillic: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXq61F3f.woff2",
        hebrew: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXy61F3f.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXC61F3f.woff2",
        latin: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnX661A.woff2"
      },
      500: {
        arabic: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXu61F3f.woff2",
        "cyrillic-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXO61F3f.woff2",
        cyrillic: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXq61F3f.woff2",
        hebrew: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXy61F3f.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXC61F3f.woff2",
        latin: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnX661A.woff2"
      },
      600: {
        arabic: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXu61F3f.woff2",
        "cyrillic-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXO61F3f.woff2",
        cyrillic: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXq61F3f.woff2",
        hebrew: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXy61F3f.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXC61F3f.woff2",
        latin: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnX661A.woff2"
      },
      700: {
        arabic: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXu61F3f.woff2",
        "cyrillic-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXO61F3f.woff2",
        cyrillic: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXq61F3f.woff2",
        hebrew: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXy61F3f.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXC61F3f.woff2",
        latin: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnX661A.woff2"
      },
      800: {
        arabic: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXu61F3f.woff2",
        "cyrillic-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXO61F3f.woff2",
        cyrillic: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXq61F3f.woff2",
        hebrew: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXy61F3f.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXC61F3f.woff2",
        latin: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnX661A.woff2"
      },
      900: {
        arabic: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXu61F3f.woff2",
        "cyrillic-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXO61F3f.woff2",
        cyrillic: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXq61F3f.woff2",
        hebrew: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXy61F3f.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnXC61F3f.woff2",
        latin: "https://fonts.gstatic.com/s/rubik/v28/iJWEBXyIfDnIV7nEnX661A.woff2"
      }
    },
    normal: {
      300: {
        arabic: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nErXyi0A.woff2",
        "cyrillic-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nMrXyi0A.woff2",
        cyrillic: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nFrXyi0A.woff2",
        hebrew: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nDrXyi0A.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nPrXyi0A.woff2",
        latin: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nBrXw.woff2"
      },
      400: {
        arabic: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nErXyi0A.woff2",
        "cyrillic-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nMrXyi0A.woff2",
        cyrillic: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nFrXyi0A.woff2",
        hebrew: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nDrXyi0A.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nPrXyi0A.woff2",
        latin: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nBrXw.woff2"
      },
      500: {
        arabic: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nErXyi0A.woff2",
        "cyrillic-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nMrXyi0A.woff2",
        cyrillic: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nFrXyi0A.woff2",
        hebrew: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nDrXyi0A.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nPrXyi0A.woff2",
        latin: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nBrXw.woff2"
      },
      600: {
        arabic: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nErXyi0A.woff2",
        "cyrillic-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nMrXyi0A.woff2",
        cyrillic: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nFrXyi0A.woff2",
        hebrew: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nDrXyi0A.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nPrXyi0A.woff2",
        latin: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nBrXw.woff2"
      },
      700: {
        arabic: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nErXyi0A.woff2",
        "cyrillic-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nMrXyi0A.woff2",
        cyrillic: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nFrXyi0A.woff2",
        hebrew: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nDrXyi0A.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nPrXyi0A.woff2",
        latin: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nBrXw.woff2"
      },
      800: {
        arabic: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nErXyi0A.woff2",
        "cyrillic-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nMrXyi0A.woff2",
        cyrillic: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nFrXyi0A.woff2",
        hebrew: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nDrXyi0A.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nPrXyi0A.woff2",
        latin: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nBrXw.woff2"
      },
      900: {
        arabic: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nErXyi0A.woff2",
        "cyrillic-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nMrXyi0A.woff2",
        cyrillic: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nFrXyi0A.woff2",
        hebrew: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nDrXyi0A.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nPrXyi0A.woff2",
        latin: "https://fonts.gstatic.com/s/rubik/v28/iJWKBXyIfDnIV7nBrXw.woff2"
      }
    }
  }
}), k2 = qi().fontFamily, w2 = (t, e) => Le(qi(), t, e), x2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: k2,
  getInfo: qi,
  loadFont: w2
}, Symbol.toStringTag, { value: "Module" })), Wi = () => ({
  fontFamily: "Atkinson Hyperlegible",
  importName: "AtkinsonHyperlegible",
  version: "v11",
  url: "https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700",
  unicodeRanges: {
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    italic: {
      400: {
        "latin-ext": "https://fonts.gstatic.com/s/atkinsonhyperlegible/v11/9Bt43C1KxNDXMspQ1lPyU89-1h6ONRlW45G056IkUwCybQ.woff2",
        latin: "https://fonts.gstatic.com/s/atkinsonhyperlegible/v11/9Bt43C1KxNDXMspQ1lPyU89-1h6ONRlW45G056IqUwA.woff2"
      },
      700: {
        "latin-ext": "https://fonts.gstatic.com/s/atkinsonhyperlegible/v11/9Bt93C1KxNDXMspQ1lPyU89-1h6ONRlW45G056qRdhWDTFieFA.woff2",
        latin: "https://fonts.gstatic.com/s/atkinsonhyperlegible/v11/9Bt93C1KxNDXMspQ1lPyU89-1h6ONRlW45G056qRdhWNTFg.woff2"
      }
    },
    normal: {
      400: {
        "latin-ext": "https://fonts.gstatic.com/s/atkinsonhyperlegible/v11/9Bt23C1KxNDXMspQ1lPyU89-1h6ONRlW45G07JIoSwQ.woff2",
        latin: "https://fonts.gstatic.com/s/atkinsonhyperlegible/v11/9Bt23C1KxNDXMspQ1lPyU89-1h6ONRlW45G04pIo.woff2"
      },
      700: {
        "latin-ext": "https://fonts.gstatic.com/s/atkinsonhyperlegible/v11/9Bt73C1KxNDXMspQ1lPyU89-1h6ONRlW45G8Wbc9eiWPVFw.woff2",
        latin: "https://fonts.gstatic.com/s/atkinsonhyperlegible/v11/9Bt73C1KxNDXMspQ1lPyU89-1h6ONRlW45G8Wbc9dCWP.woff2"
      }
    }
  }
}), _2 = Wi().fontFamily, F2 = (t, e) => Le(Wi(), t, e), C2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: _2,
  getInfo: Wi,
  loadFont: F2
}, Symbol.toStringTag, { value: "Module" })), Yi = () => ({
  fontFamily: "Space Grotesk",
  importName: "SpaceGrotesk",
  version: "v16",
  url: "https://fonts.googleapis.com/css2?family=Space+Grotesk:ital,wght@0,300;0,400;0,500;0,600;0,700",
  unicodeRanges: {
    vietnamese: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB",
    "latin-ext": "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    latin: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
  },
  fonts: {
    normal: {
      300: {
        vietnamese: "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPb54C-s0.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPb94C-s0.woff2",
        latin: "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPbF4Cw.woff2"
      },
      400: {
        vietnamese: "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPb54C-s0.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPb94C-s0.woff2",
        latin: "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPbF4Cw.woff2"
      },
      500: {
        vietnamese: "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPb54C-s0.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPb94C-s0.woff2",
        latin: "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPbF4Cw.woff2"
      },
      600: {
        vietnamese: "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPb54C-s0.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPb94C-s0.woff2",
        latin: "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPbF4Cw.woff2"
      },
      700: {
        vietnamese: "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPb54C-s0.woff2",
        "latin-ext": "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPb94C-s0.woff2",
        latin: "https://fonts.gstatic.com/s/spacegrotesk/v16/V8mDoQDjQSkFtoMM3T6r8E7mPbF4Cw.woff2"
      }
    }
  }
}), z2 = Yi().fontFamily, E2 = (t, e) => Le(Yi(), t, e), T2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontFamily: z2,
  getInfo: Yi,
  loadFont: E2
}, Symbol.toStringTag, { value: "Module" })), j2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AtkinsonHyperlegible: C2,
  DancingScript: g2,
  Lato: M1,
  Merriweather: i2,
  Montserrat: K1,
  Nunito: r2,
  OpenSans: O1,
  Oswald: m2,
  Pacifico: v2,
  PlayfairDisplay: t2,
  Poppins: H1,
  Quicksand: u2,
  Raleway: W1,
  Roboto: B1,
  Rubik: x2,
  SpaceGrotesk: T2,
  Ubuntu: G1
}, Symbol.toStringTag, { value: "Module" })), U2 = async (t) => {
  const e = j2[t];
  if (!e || !e.loadFont)
    throw new Error(`Font ${t} is not available.`);
  return await e.loadFont();
}, Lt = (t) => {
  const [e, a] = vt(null);
  return kt(() => {
    if (!t) return;
    let n = !0;
    return (async () => {
      if (t)
        try {
          const {
            fontFamily: o
          } = await U2(t);
          n && a(o);
        } catch (o) {
          n && console.error("Error loading font:", o);
        }
    })(), () => {
      n = !1;
    };
  }, [t]), e;
};
var yi = { exports: {} }, ze = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ko;
function S2() {
  if (ko) return ze;
  ko = 1;
  var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), r = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), C;
  C = Symbol.for("react.module.reference");
  function E(b) {
    if (typeof b == "object" && b !== null) {
      var D = b.$$typeof;
      switch (D) {
        case t:
          switch (b = b.type, b) {
            case a:
            case i:
            case n:
            case l:
            case f:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case r:
                case s:
                case c:
                case v:
                case m:
                case o:
                  return b;
                default:
                  return D;
              }
          }
        case e:
          return D;
      }
    }
  }
  return ze.ContextConsumer = s, ze.ContextProvider = o, ze.Element = t, ze.ForwardRef = c, ze.Fragment = a, ze.Lazy = v, ze.Memo = m, ze.Portal = e, ze.Profiler = i, ze.StrictMode = n, ze.Suspense = l, ze.SuspenseList = f, ze.isAsyncMode = function() {
    return !1;
  }, ze.isConcurrentMode = function() {
    return !1;
  }, ze.isContextConsumer = function(b) {
    return E(b) === s;
  }, ze.isContextProvider = function(b) {
    return E(b) === o;
  }, ze.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, ze.isForwardRef = function(b) {
    return E(b) === c;
  }, ze.isFragment = function(b) {
    return E(b) === a;
  }, ze.isLazy = function(b) {
    return E(b) === v;
  }, ze.isMemo = function(b) {
    return E(b) === m;
  }, ze.isPortal = function(b) {
    return E(b) === e;
  }, ze.isProfiler = function(b) {
    return E(b) === i;
  }, ze.isStrictMode = function(b) {
    return E(b) === n;
  }, ze.isSuspense = function(b) {
    return E(b) === l;
  }, ze.isSuspenseList = function(b) {
    return E(b) === f;
  }, ze.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === a || b === i || b === n || b === l || b === f || b === k || typeof b == "object" && b !== null && (b.$$typeof === v || b.$$typeof === m || b.$$typeof === o || b.$$typeof === s || b.$$typeof === c || b.$$typeof === C || b.getModuleId !== void 0);
  }, ze.typeOf = E, ze;
}
var Ee = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wo;
function A2() {
  return wo || (wo = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), r = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), C = !1, E = !1, b = !1, D = !1, j = !1, x;
    x = Symbol.for("react.module.reference");
    function _(R) {
      return !!(typeof R == "string" || typeof R == "function" || R === a || R === i || j || R === n || R === l || R === f || D || R === k || C || E || b || typeof R == "object" && R !== null && (R.$$typeof === v || R.$$typeof === m || R.$$typeof === o || R.$$typeof === s || R.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      R.$$typeof === x || R.getModuleId !== void 0));
    }
    function y(R) {
      if (typeof R == "object" && R !== null) {
        var le = R.$$typeof;
        switch (le) {
          case t:
            var Ae = R.type;
            switch (Ae) {
              case a:
              case i:
              case n:
              case l:
              case f:
                return Ae;
              default:
                var ue = Ae && Ae.$$typeof;
                switch (ue) {
                  case r:
                  case s:
                  case c:
                  case v:
                  case m:
                  case o:
                    return ue;
                  default:
                    return le;
                }
            }
          case e:
            return le;
        }
      }
    }
    var H = s, $ = o, Y = t, ae = c, ve = a, de = v, N = m, P = e, M = i, V = n, be = l, Z = f, oe = !1, ke = !1;
    function we(R) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function re(R) {
      return ke || (ke = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function A(R) {
      return y(R) === s;
    }
    function w(R) {
      return y(R) === o;
    }
    function I(R) {
      return typeof R == "object" && R !== null && R.$$typeof === t;
    }
    function B(R) {
      return y(R) === c;
    }
    function g(R) {
      return y(R) === a;
    }
    function ne(R) {
      return y(R) === v;
    }
    function z(R) {
      return y(R) === m;
    }
    function me(R) {
      return y(R) === e;
    }
    function Q(R) {
      return y(R) === i;
    }
    function G(R) {
      return y(R) === n;
    }
    function F(R) {
      return y(R) === l;
    }
    function Fe(R) {
      return y(R) === f;
    }
    Ee.ContextConsumer = H, Ee.ContextProvider = $, Ee.Element = Y, Ee.ForwardRef = ae, Ee.Fragment = ve, Ee.Lazy = de, Ee.Memo = N, Ee.Portal = P, Ee.Profiler = M, Ee.StrictMode = V, Ee.Suspense = be, Ee.SuspenseList = Z, Ee.isAsyncMode = we, Ee.isConcurrentMode = re, Ee.isContextConsumer = A, Ee.isContextProvider = w, Ee.isElement = I, Ee.isForwardRef = B, Ee.isFragment = g, Ee.isLazy = ne, Ee.isMemo = z, Ee.isPortal = me, Ee.isProfiler = Q, Ee.isStrictMode = G, Ee.isSuspense = F, Ee.isSuspenseList = Fe, Ee.isValidElementType = _, Ee.typeOf = y;
  }()), Ee;
}
process.env.NODE_ENV === "production" ? yi.exports = S2() : yi.exports = A2();
var $i = yi.exports;
function I2(t) {
  function e(A, w, I, B, g) {
    for (var ne = 0, z = 0, me = 0, Q = 0, G, F, Fe = 0, R = 0, le, Ae = le = G = 0, ue = 0, De = 0, tt = 0, Be = 0, rt = I.length, Ft = rt - 1, Xe, ee = "", xe = "", at = "", Dt = "", Ge; ue < rt; ) {
      if (F = I.charCodeAt(ue), ue === Ft && z + Q + me + ne !== 0 && (z !== 0 && (F = z === 47 ? 10 : 47), Q = me = ne = 0, rt++, Ft++), z + Q + me + ne === 0) {
        if (ue === Ft && (0 < De && (ee = ee.replace(v, "")), 0 < ee.trim().length)) {
          switch (F) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              ee += I.charAt(ue);
          }
          F = 59;
        }
        switch (F) {
          case 123:
            for (ee = ee.trim(), G = ee.charCodeAt(0), le = 1, Be = ++ue; ue < rt; ) {
              switch (F = I.charCodeAt(ue)) {
                case 123:
                  le++;
                  break;
                case 125:
                  le--;
                  break;
                case 47:
                  switch (F = I.charCodeAt(ue + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (Ae = ue + 1; Ae < Ft; ++Ae)
                          switch (I.charCodeAt(Ae)) {
                            case 47:
                              if (F === 42 && I.charCodeAt(Ae - 1) === 42 && ue + 2 !== Ae) {
                                ue = Ae + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (F === 47) {
                                ue = Ae + 1;
                                break e;
                              }
                          }
                        ue = Ae;
                      }
                  }
                  break;
                case 91:
                  F++;
                case 40:
                  F++;
                case 34:
                case 39:
                  for (; ue++ < Ft && I.charCodeAt(ue) !== F; )
                    ;
              }
              if (le === 0) break;
              ue++;
            }
            switch (le = I.substring(Be, ue), G === 0 && (G = (ee = ee.replace(m, "").trim()).charCodeAt(0)), G) {
              case 64:
                switch (0 < De && (ee = ee.replace(v, "")), F = ee.charCodeAt(1), F) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    De = w;
                    break;
                  default:
                    De = be;
                }
                if (le = e(w, De, le, F, g + 1), Be = le.length, 0 < oe && (De = a(be, ee, tt), Ge = r(3, le, De, w, P, N, Be, F, g, B), ee = De.join(""), Ge !== void 0 && (Be = (le = Ge.trim()).length) === 0 && (F = 0, le = "")), 0 < Be) switch (F) {
                  case 115:
                    ee = ee.replace(H, s);
                  case 100:
                  case 109:
                  case 45:
                    le = ee + "{" + le + "}";
                    break;
                  case 107:
                    ee = ee.replace(j, "$1 $2"), le = ee + "{" + le + "}", le = V === 1 || V === 2 && o("@" + le, 3) ? "@-webkit-" + le + "@" + le : "@" + le;
                    break;
                  default:
                    le = ee + le, B === 112 && (le = (xe += le, ""));
                }
                else le = "";
                break;
              default:
                le = e(w, a(w, ee, tt), le, B, g + 1);
            }
            at += le, le = tt = De = Ae = G = 0, ee = "", F = I.charCodeAt(++ue);
            break;
          case 125:
          case 59:
            if (ee = (0 < De ? ee.replace(v, "") : ee).trim(), 1 < (Be = ee.length)) switch (Ae === 0 && (G = ee.charCodeAt(0), G === 45 || 96 < G && 123 > G) && (Be = (ee = ee.replace(" ", ":")).length), 0 < oe && (Ge = r(1, ee, w, A, P, N, xe.length, B, g, B)) !== void 0 && (Be = (ee = Ge.trim()).length) === 0 && (ee = "\0\0"), G = ee.charCodeAt(0), F = ee.charCodeAt(1), G) {
              case 0:
                break;
              case 64:
                if (F === 105 || F === 99) {
                  Dt += ee + I.charAt(ue);
                  break;
                }
              default:
                ee.charCodeAt(Be - 1) !== 58 && (xe += i(ee, G, F, ee.charCodeAt(2)));
            }
            tt = De = Ae = G = 0, ee = "", F = I.charCodeAt(++ue);
        }
      }
      switch (F) {
        case 13:
        case 10:
          z === 47 ? z = 0 : 1 + G === 0 && B !== 107 && 0 < ee.length && (De = 1, ee += "\0"), 0 < oe * we && r(0, ee, w, A, P, N, xe.length, B, g, B), N = 1, P++;
          break;
        case 59:
        case 125:
          if (z + Q + me + ne === 0) {
            N++;
            break;
          }
        default:
          switch (N++, Xe = I.charAt(ue), F) {
            case 9:
            case 32:
              if (Q + ne + z === 0) switch (Fe) {
                case 44:
                case 58:
                case 9:
                case 32:
                  Xe = "";
                  break;
                default:
                  F !== 32 && (Xe = " ");
              }
              break;
            case 0:
              Xe = "\\0";
              break;
            case 12:
              Xe = "\\f";
              break;
            case 11:
              Xe = "\\v";
              break;
            case 38:
              Q + z + ne === 0 && (De = tt = 1, Xe = "\f" + Xe);
              break;
            case 108:
              if (Q + z + ne + M === 0 && 0 < Ae) switch (ue - Ae) {
                case 2:
                  Fe === 112 && I.charCodeAt(ue - 3) === 58 && (M = Fe);
                case 8:
                  R === 111 && (M = R);
              }
              break;
            case 58:
              Q + z + ne === 0 && (Ae = ue);
              break;
            case 44:
              z + me + Q + ne === 0 && (De = 1, Xe += "\r");
              break;
            case 34:
            case 39:
              z === 0 && (Q = Q === F ? 0 : Q === 0 ? F : Q);
              break;
            case 91:
              Q + z + me === 0 && ne++;
              break;
            case 93:
              Q + z + me === 0 && ne--;
              break;
            case 41:
              Q + z + ne === 0 && me--;
              break;
            case 40:
              if (Q + z + ne === 0) {
                if (G === 0) switch (2 * Fe + 3 * R) {
                  case 533:
                    break;
                  default:
                    G = 1;
                }
                me++;
              }
              break;
            case 64:
              z + me + Q + ne + Ae + le === 0 && (le = 1);
              break;
            case 42:
            case 47:
              if (!(0 < Q + ne + me)) switch (z) {
                case 0:
                  switch (2 * F + 3 * I.charCodeAt(ue + 1)) {
                    case 235:
                      z = 47;
                      break;
                    case 220:
                      Be = ue, z = 42;
                  }
                  break;
                case 42:
                  F === 47 && Fe === 42 && Be + 2 !== ue && (I.charCodeAt(Be + 2) === 33 && (xe += I.substring(Be, ue + 1)), Xe = "", z = 0);
              }
          }
          z === 0 && (ee += Xe);
      }
      R = Fe, Fe = F, ue++;
    }
    if (Be = xe.length, 0 < Be) {
      if (De = w, 0 < oe && (Ge = r(2, xe, De, A, P, N, Be, B, g, B), Ge !== void 0 && (xe = Ge).length === 0)) return Dt + xe + at;
      if (xe = De.join(",") + "{" + xe + "}", V * M !== 0) {
        switch (V !== 2 || o(xe, 2) || (M = 0), M) {
          case 111:
            xe = xe.replace(_, ":-moz-$1") + xe;
            break;
          case 112:
            xe = xe.replace(x, "::-webkit-input-$1") + xe.replace(x, "::-moz-$1") + xe.replace(x, ":-ms-input-$1") + xe;
        }
        M = 0;
      }
    }
    return Dt + xe + at;
  }
  function a(A, w, I) {
    var B = w.trim().split(b);
    w = B;
    var g = B.length, ne = A.length;
    switch (ne) {
      case 0:
      case 1:
        var z = 0;
        for (A = ne === 0 ? "" : A[0] + " "; z < g; ++z)
          w[z] = n(A, w[z], I).trim();
        break;
      default:
        var me = z = 0;
        for (w = []; z < g; ++z)
          for (var Q = 0; Q < ne; ++Q)
            w[me++] = n(A[Q] + " ", B[z], I).trim();
    }
    return w;
  }
  function n(A, w, I) {
    var B = w.charCodeAt(0);
    switch (33 > B && (B = (w = w.trim()).charCodeAt(0)), B) {
      case 38:
        return w.replace(D, "$1" + A.trim());
      case 58:
        return A.trim() + w.replace(D, "$1" + A.trim());
      default:
        if (0 < 1 * I && 0 < w.indexOf("\f")) return w.replace(D, (A.charCodeAt(0) === 58 ? "" : "$1") + A.trim());
    }
    return A + w;
  }
  function i(A, w, I, B) {
    var g = A + ";", ne = 2 * w + 3 * I + 4 * B;
    if (ne === 944) {
      A = g.indexOf(":", 9) + 1;
      var z = g.substring(A, g.length - 1).trim();
      return z = g.substring(0, A).trim() + z + ";", V === 1 || V === 2 && o(z, 1) ? "-webkit-" + z + z : z;
    }
    if (V === 0 || V === 2 && !o(g, 1)) return g;
    switch (ne) {
      case 1015:
        return g.charCodeAt(10) === 97 ? "-webkit-" + g + g : g;
      case 951:
        return g.charCodeAt(3) === 116 ? "-webkit-" + g + g : g;
      case 963:
        return g.charCodeAt(5) === 110 ? "-webkit-" + g + g : g;
      case 1009:
        if (g.charCodeAt(4) !== 100) break;
      case 969:
      case 942:
        return "-webkit-" + g + g;
      case 978:
        return "-webkit-" + g + "-moz-" + g + g;
      case 1019:
      case 983:
        return "-webkit-" + g + "-moz-" + g + "-ms-" + g + g;
      case 883:
        if (g.charCodeAt(8) === 45) return "-webkit-" + g + g;
        if (0 < g.indexOf("image-set(", 11)) return g.replace(de, "$1-webkit-$2") + g;
        break;
      case 932:
        if (g.charCodeAt(4) === 45) switch (g.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + g.replace("-grow", "") + "-webkit-" + g + "-ms-" + g.replace("grow", "positive") + g;
          case 115:
            return "-webkit-" + g + "-ms-" + g.replace("shrink", "negative") + g;
          case 98:
            return "-webkit-" + g + "-ms-" + g.replace("basis", "preferred-size") + g;
        }
        return "-webkit-" + g + "-ms-" + g + g;
      case 964:
        return "-webkit-" + g + "-ms-flex-" + g + g;
      case 1023:
        if (g.charCodeAt(8) !== 99) break;
        return z = g.substring(g.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + z + "-webkit-" + g + "-ms-flex-pack" + z + g;
      case 1005:
        return C.test(g) ? g.replace(k, ":-webkit-") + g.replace(k, ":-moz-") + g : g;
      case 1e3:
        switch (z = g.substring(13).trim(), w = z.indexOf("-") + 1, z.charCodeAt(0) + z.charCodeAt(w)) {
          case 226:
            z = g.replace(y, "tb");
            break;
          case 232:
            z = g.replace(y, "tb-rl");
            break;
          case 220:
            z = g.replace(y, "lr");
            break;
          default:
            return g;
        }
        return "-webkit-" + g + "-ms-" + z + g;
      case 1017:
        if (g.indexOf("sticky", 9) === -1) break;
      case 975:
        switch (w = (g = A).length - 10, z = (g.charCodeAt(w) === 33 ? g.substring(0, w) : g).substring(A.indexOf(":", 7) + 1).trim(), ne = z.charCodeAt(0) + (z.charCodeAt(7) | 0)) {
          case 203:
            if (111 > z.charCodeAt(8)) break;
          case 115:
            g = g.replace(z, "-webkit-" + z) + ";" + g;
            break;
          case 207:
          case 102:
            g = g.replace(z, "-webkit-" + (102 < ne ? "inline-" : "") + "box") + ";" + g.replace(z, "-webkit-" + z) + ";" + g.replace(z, "-ms-" + z + "box") + ";" + g;
        }
        return g + ";";
      case 938:
        if (g.charCodeAt(5) === 45) switch (g.charCodeAt(6)) {
          case 105:
            return z = g.replace("-items", ""), "-webkit-" + g + "-webkit-box-" + z + "-ms-flex-" + z + g;
          case 115:
            return "-webkit-" + g + "-ms-flex-item-" + g.replace(Y, "") + g;
          default:
            return "-webkit-" + g + "-ms-flex-line-pack" + g.replace("align-content", "").replace(Y, "") + g;
        }
        break;
      case 973:
      case 989:
        if (g.charCodeAt(3) !== 45 || g.charCodeAt(4) === 122) break;
      case 931:
      case 953:
        if (ve.test(A) === !0) return (z = A.substring(A.indexOf(":") + 1)).charCodeAt(0) === 115 ? i(A.replace("stretch", "fill-available"), w, I, B).replace(":fill-available", ":stretch") : g.replace(z, "-webkit-" + z) + g.replace(z, "-moz-" + z.replace("fill-", "")) + g;
        break;
      case 962:
        if (g = "-webkit-" + g + (g.charCodeAt(5) === 102 ? "-ms-" + g : "") + g, I + B === 211 && g.charCodeAt(13) === 105 && 0 < g.indexOf("transform", 10)) return g.substring(0, g.indexOf(";", 27) + 1).replace(E, "$1-webkit-$2") + g;
    }
    return g;
  }
  function o(A, w) {
    var I = A.indexOf(w === 1 ? ":" : "{"), B = A.substring(0, w !== 3 ? I : 10);
    return I = A.substring(I + 1, A.length - 1), ke(w !== 2 ? B : B.replace(ae, "$1"), I, w);
  }
  function s(A, w) {
    var I = i(w, w.charCodeAt(0), w.charCodeAt(1), w.charCodeAt(2));
    return I !== w + ";" ? I.replace($, " or ($1)").substring(4) : "(" + w + ")";
  }
  function r(A, w, I, B, g, ne, z, me, Q, G) {
    for (var F = 0, Fe = w, R; F < oe; ++F)
      switch (R = Z[F].call(f, A, Fe, I, B, g, ne, z, me, Q, G)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          Fe = R;
      }
    if (Fe !== w) return Fe;
  }
  function c(A) {
    switch (A) {
      case void 0:
      case null:
        oe = Z.length = 0;
        break;
      default:
        if (typeof A == "function") Z[oe++] = A;
        else if (typeof A == "object") for (var w = 0, I = A.length; w < I; ++w)
          c(A[w]);
        else we = !!A | 0;
    }
    return c;
  }
  function l(A) {
    return A = A.prefix, A !== void 0 && (ke = null, A ? typeof A != "function" ? V = 1 : (V = 2, ke = A) : V = 0), l;
  }
  function f(A, w) {
    var I = A;
    if (33 > I.charCodeAt(0) && (I = I.trim()), re = I, I = [re], 0 < oe) {
      var B = r(-1, w, I, I, P, N, 0, 0, 0, 0);
      B !== void 0 && typeof B == "string" && (w = B);
    }
    var g = e(be, I, w, 0, 0);
    return 0 < oe && (B = r(-2, g, I, I, P, N, g.length, 0, 0, 0), B !== void 0 && (g = B)), re = "", M = 0, N = P = 1, g;
  }
  var m = /^\0+/g, v = /[\0\r\f]/g, k = /: */g, C = /zoo|gra/, E = /([,: ])(transform)/g, b = /,\r+?/g, D = /([\t\r\n ])*\f?&/g, j = /@(k\w+)\s*(\S*)\s*/, x = /::(place)/g, _ = /:(read-only)/g, y = /[svh]\w+-[tblr]{2}/, H = /\(\s*(.*)\s*\)/g, $ = /([\s\S]*?);/g, Y = /-self|flex-/g, ae = /[^]*?(:[rp][el]a[\w-]+)[^]*/, ve = /stretch|:\s*\w+\-(?:conte|avail)/, de = /([^-])(image-set\()/, N = 1, P = 1, M = 0, V = 1, be = [], Z = [], oe = 0, ke = null, we = 0, re = "";
  return f.use = c, f.set = l, t !== void 0 && l(t), f;
}
var D2 = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function B2(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(a) {
    return e[a] === void 0 && (e[a] = t(a)), e[a];
  };
}
var R2 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, xo = /* @__PURE__ */ B2(
  function(t) {
    return R2.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), vi = { exports: {} }, Te = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _o;
function O2() {
  if (_o) return Te;
  _o = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, a = t ? Symbol.for("react.portal") : 60106, n = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, r = t ? Symbol.for("react.context") : 60110, c = t ? Symbol.for("react.async_mode") : 60111, l = t ? Symbol.for("react.concurrent_mode") : 60111, f = t ? Symbol.for("react.forward_ref") : 60112, m = t ? Symbol.for("react.suspense") : 60113, v = t ? Symbol.for("react.suspense_list") : 60120, k = t ? Symbol.for("react.memo") : 60115, C = t ? Symbol.for("react.lazy") : 60116, E = t ? Symbol.for("react.block") : 60121, b = t ? Symbol.for("react.fundamental") : 60117, D = t ? Symbol.for("react.responder") : 60118, j = t ? Symbol.for("react.scope") : 60119;
  function x(y) {
    if (typeof y == "object" && y !== null) {
      var H = y.$$typeof;
      switch (H) {
        case e:
          switch (y = y.type, y) {
            case c:
            case l:
            case n:
            case o:
            case i:
            case m:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case r:
                case f:
                case C:
                case k:
                case s:
                  return y;
                default:
                  return H;
              }
          }
        case a:
          return H;
      }
    }
  }
  function _(y) {
    return x(y) === l;
  }
  return Te.AsyncMode = c, Te.ConcurrentMode = l, Te.ContextConsumer = r, Te.ContextProvider = s, Te.Element = e, Te.ForwardRef = f, Te.Fragment = n, Te.Lazy = C, Te.Memo = k, Te.Portal = a, Te.Profiler = o, Te.StrictMode = i, Te.Suspense = m, Te.isAsyncMode = function(y) {
    return _(y) || x(y) === c;
  }, Te.isConcurrentMode = _, Te.isContextConsumer = function(y) {
    return x(y) === r;
  }, Te.isContextProvider = function(y) {
    return x(y) === s;
  }, Te.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, Te.isForwardRef = function(y) {
    return x(y) === f;
  }, Te.isFragment = function(y) {
    return x(y) === n;
  }, Te.isLazy = function(y) {
    return x(y) === C;
  }, Te.isMemo = function(y) {
    return x(y) === k;
  }, Te.isPortal = function(y) {
    return x(y) === a;
  }, Te.isProfiler = function(y) {
    return x(y) === o;
  }, Te.isStrictMode = function(y) {
    return x(y) === i;
  }, Te.isSuspense = function(y) {
    return x(y) === m;
  }, Te.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === l || y === o || y === i || y === m || y === v || typeof y == "object" && y !== null && (y.$$typeof === C || y.$$typeof === k || y.$$typeof === s || y.$$typeof === r || y.$$typeof === f || y.$$typeof === b || y.$$typeof === D || y.$$typeof === j || y.$$typeof === E);
  }, Te.typeOf = x, Te;
}
var je = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fo;
function P2() {
  return Fo || (Fo = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, a = t ? Symbol.for("react.portal") : 60106, n = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, r = t ? Symbol.for("react.context") : 60110, c = t ? Symbol.for("react.async_mode") : 60111, l = t ? Symbol.for("react.concurrent_mode") : 60111, f = t ? Symbol.for("react.forward_ref") : 60112, m = t ? Symbol.for("react.suspense") : 60113, v = t ? Symbol.for("react.suspense_list") : 60120, k = t ? Symbol.for("react.memo") : 60115, C = t ? Symbol.for("react.lazy") : 60116, E = t ? Symbol.for("react.block") : 60121, b = t ? Symbol.for("react.fundamental") : 60117, D = t ? Symbol.for("react.responder") : 60118, j = t ? Symbol.for("react.scope") : 60119;
    function x(F) {
      return typeof F == "string" || typeof F == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      F === n || F === l || F === o || F === i || F === m || F === v || typeof F == "object" && F !== null && (F.$$typeof === C || F.$$typeof === k || F.$$typeof === s || F.$$typeof === r || F.$$typeof === f || F.$$typeof === b || F.$$typeof === D || F.$$typeof === j || F.$$typeof === E);
    }
    function _(F) {
      if (typeof F == "object" && F !== null) {
        var Fe = F.$$typeof;
        switch (Fe) {
          case e:
            var R = F.type;
            switch (R) {
              case c:
              case l:
              case n:
              case o:
              case i:
              case m:
                return R;
              default:
                var le = R && R.$$typeof;
                switch (le) {
                  case r:
                  case f:
                  case C:
                  case k:
                  case s:
                    return le;
                  default:
                    return Fe;
                }
            }
          case a:
            return Fe;
        }
      }
    }
    var y = c, H = l, $ = r, Y = s, ae = e, ve = f, de = n, N = C, P = k, M = a, V = o, be = i, Z = m, oe = !1;
    function ke(F) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), we(F) || _(F) === c;
    }
    function we(F) {
      return _(F) === l;
    }
    function re(F) {
      return _(F) === r;
    }
    function A(F) {
      return _(F) === s;
    }
    function w(F) {
      return typeof F == "object" && F !== null && F.$$typeof === e;
    }
    function I(F) {
      return _(F) === f;
    }
    function B(F) {
      return _(F) === n;
    }
    function g(F) {
      return _(F) === C;
    }
    function ne(F) {
      return _(F) === k;
    }
    function z(F) {
      return _(F) === a;
    }
    function me(F) {
      return _(F) === o;
    }
    function Q(F) {
      return _(F) === i;
    }
    function G(F) {
      return _(F) === m;
    }
    je.AsyncMode = y, je.ConcurrentMode = H, je.ContextConsumer = $, je.ContextProvider = Y, je.Element = ae, je.ForwardRef = ve, je.Fragment = de, je.Lazy = N, je.Memo = P, je.Portal = M, je.Profiler = V, je.StrictMode = be, je.Suspense = Z, je.isAsyncMode = ke, je.isConcurrentMode = we, je.isContextConsumer = re, je.isContextProvider = A, je.isElement = w, je.isForwardRef = I, je.isFragment = B, je.isLazy = g, je.isMemo = ne, je.isPortal = z, je.isProfiler = me, je.isStrictMode = Q, je.isSuspense = G, je.isValidElementType = x, je.typeOf = _;
  }()), je;
}
process.env.NODE_ENV === "production" ? vi.exports = O2() : vi.exports = P2();
var N2 = vi.exports, Hi = N2, M2 = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, V2 = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, X2 = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, ss = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Zi = {};
Zi[Hi.ForwardRef] = X2;
Zi[Hi.Memo] = ss;
function Co(t) {
  return Hi.isMemo(t) ? ss : Zi[t.$$typeof] || M2;
}
var K2 = Object.defineProperty, L2 = Object.getOwnPropertyNames, zo = Object.getOwnPropertySymbols, q2 = Object.getOwnPropertyDescriptor, W2 = Object.getPrototypeOf, Eo = Object.prototype;
function rs(t, e, a) {
  if (typeof e != "string") {
    if (Eo) {
      var n = W2(e);
      n && n !== Eo && rs(t, n, a);
    }
    var i = L2(e);
    zo && (i = i.concat(zo(e)));
    for (var o = Co(t), s = Co(e), r = 0; r < i.length; ++r) {
      var c = i[r];
      if (!V2[c] && !(a && a[c]) && !(s && s[c]) && !(o && o[c])) {
        var l = q2(e, c);
        try {
          K2(t, c, l);
        } catch {
        }
      }
    }
  }
  return t;
}
var Y2 = rs;
const $2 = /* @__PURE__ */ er(Y2);
function Et() {
  return (Et = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];
      for (var n in a) Object.prototype.hasOwnProperty.call(a, n) && (t[n] = a[n]);
    }
    return t;
  }).apply(this, arguments);
}
var To = function(t, e) {
  for (var a = [t[0]], n = 0, i = e.length; n < i; n += 1) a.push(e[n], t[n + 1]);
  return a;
}, ki = function(t) {
  return t !== null && typeof t == "object" && (t.toString ? t.toString() : Object.prototype.toString.call(t)) === "[object Object]" && !$i.typeOf(t);
}, In = Object.freeze([]), Pt = Object.freeze({});
function Qa(t) {
  return typeof t == "function";
}
function wi(t) {
  return process.env.NODE_ENV !== "production" && typeof t == "string" && t || t.displayName || t.name || "Component";
}
function Ji(t) {
  return t && typeof t.styledComponentId == "string";
}
var _a = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", Gi = typeof window < "u" && "HTMLElement" in window, H2 = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production")), Z2 = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
` } : {};
function J2() {
  for (var t = arguments.length <= 0 ? void 0 : arguments[0], e = [], a = 1, n = arguments.length; a < n; a += 1) e.push(a < 0 || arguments.length <= a ? void 0 : arguments[a]);
  return e.forEach(function(i) {
    t = t.replace(/%[a-z]/, i);
  }), t;
}
function Ea(t) {
  for (var e = arguments.length, a = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) a[n - 1] = arguments[n];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://git.io/JUIaE#" + t + " for more information." + (a.length > 0 ? " Args: " + a.join(", ") : "")) : new Error(J2.apply(void 0, [Z2[t]].concat(a)).trim());
}
var G2 = function() {
  function t(a) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = a;
  }
  var e = t.prototype;
  return e.indexOfGroup = function(a) {
    for (var n = 0, i = 0; i < a; i++) n += this.groupSizes[i];
    return n;
  }, e.insertRules = function(a, n) {
    if (a >= this.groupSizes.length) {
      for (var i = this.groupSizes, o = i.length, s = o; a >= s; ) (s <<= 1) < 0 && Ea(16, "" + a);
      this.groupSizes = new Uint32Array(s), this.groupSizes.set(i), this.length = s;
      for (var r = o; r < s; r++) this.groupSizes[r] = 0;
    }
    for (var c = this.indexOfGroup(a + 1), l = 0, f = n.length; l < f; l++) this.tag.insertRule(c, n[l]) && (this.groupSizes[a]++, c++);
  }, e.clearGroup = function(a) {
    if (a < this.length) {
      var n = this.groupSizes[a], i = this.indexOfGroup(a), o = i + n;
      this.groupSizes[a] = 0;
      for (var s = i; s < o; s++) this.tag.deleteRule(i);
    }
  }, e.getGroup = function(a) {
    var n = "";
    if (a >= this.length || this.groupSizes[a] === 0) return n;
    for (var i = this.groupSizes[a], o = this.indexOfGroup(a), s = o + i, r = o; r < s; r++) n += this.tag.getRule(r) + `/*!sc*/
`;
    return n;
  }, t;
}(), vn = /* @__PURE__ */ new Map(), Dn = /* @__PURE__ */ new Map(), Na = 1, dn = function(t) {
  if (vn.has(t)) return vn.get(t);
  for (; Dn.has(Na); ) Na++;
  var e = Na++;
  return process.env.NODE_ENV !== "production" && ((0 | e) < 0 || e > 1 << 30) && Ea(16, "" + e), vn.set(t, e), Dn.set(e, t), e;
}, Q2 = function(t) {
  return Dn.get(t);
}, el = function(t, e) {
  e >= Na && (Na = e + 1), vn.set(t, e), Dn.set(e, t);
}, tl = "style[" + _a + '][data-styled-version="5.3.11"]', al = new RegExp("^" + _a + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), nl = function(t, e, a) {
  for (var n, i = a.split(","), o = 0, s = i.length; o < s; o++) (n = i[o]) && t.registerName(e, n);
}, il = function(t, e) {
  for (var a = (e.textContent || "").split(`/*!sc*/
`), n = [], i = 0, o = a.length; i < o; i++) {
    var s = a[i].trim();
    if (s) {
      var r = s.match(al);
      if (r) {
        var c = 0 | parseInt(r[1], 10), l = r[2];
        c !== 0 && (el(l, c), nl(t, l, r[3]), t.getTag().insertRules(c, n)), n.length = 0;
      } else n.push(s);
    }
  }
}, ol = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, ls = function(t) {
  var e = document.head, a = t || e, n = document.createElement("style"), i = function(r) {
    for (var c = r.childNodes, l = c.length; l >= 0; l--) {
      var f = c[l];
      if (f && f.nodeType === 1 && f.hasAttribute(_a)) return f;
    }
  }(a), o = i !== void 0 ? i.nextSibling : null;
  n.setAttribute(_a, "active"), n.setAttribute("data-styled-version", "5.3.11");
  var s = ol();
  return s && n.setAttribute("nonce", s), a.insertBefore(n, o), n;
}, sl = function() {
  function t(a) {
    var n = this.element = ls(a);
    n.appendChild(document.createTextNode("")), this.sheet = function(i) {
      if (i.sheet) return i.sheet;
      for (var o = document.styleSheets, s = 0, r = o.length; s < r; s++) {
        var c = o[s];
        if (c.ownerNode === i) return c;
      }
      Ea(17);
    }(n), this.length = 0;
  }
  var e = t.prototype;
  return e.insertRule = function(a, n) {
    try {
      return this.sheet.insertRule(n, a), this.length++, !0;
    } catch {
      return !1;
    }
  }, e.deleteRule = function(a) {
    this.sheet.deleteRule(a), this.length--;
  }, e.getRule = function(a) {
    var n = this.sheet.cssRules[a];
    return n !== void 0 && typeof n.cssText == "string" ? n.cssText : "";
  }, t;
}(), rl = function() {
  function t(a) {
    var n = this.element = ls(a);
    this.nodes = n.childNodes, this.length = 0;
  }
  var e = t.prototype;
  return e.insertRule = function(a, n) {
    if (a <= this.length && a >= 0) {
      var i = document.createTextNode(n), o = this.nodes[a];
      return this.element.insertBefore(i, o || null), this.length++, !0;
    }
    return !1;
  }, e.deleteRule = function(a) {
    this.element.removeChild(this.nodes[a]), this.length--;
  }, e.getRule = function(a) {
    return a < this.length ? this.nodes[a].textContent : "";
  }, t;
}(), ll = function() {
  function t(a) {
    this.rules = [], this.length = 0;
  }
  var e = t.prototype;
  return e.insertRule = function(a, n) {
    return a <= this.length && (this.rules.splice(a, 0, n), this.length++, !0);
  }, e.deleteRule = function(a) {
    this.rules.splice(a, 1), this.length--;
  }, e.getRule = function(a) {
    return a < this.length ? this.rules[a] : "";
  }, t;
}(), jo = Gi, cl = { isServer: !Gi, useCSSOMInjection: !H2 }, cs = function() {
  function t(a, n, i) {
    a === void 0 && (a = Pt), n === void 0 && (n = {}), this.options = Et({}, cl, {}, a), this.gs = n, this.names = new Map(i), this.server = !!a.isServer, !this.server && Gi && jo && (jo = !1, function(o) {
      for (var s = document.querySelectorAll(tl), r = 0, c = s.length; r < c; r++) {
        var l = s[r];
        l && l.getAttribute(_a) !== "active" && (il(o, l), l.parentNode && l.parentNode.removeChild(l));
      }
    }(this));
  }
  t.registerId = function(a) {
    return dn(a);
  };
  var e = t.prototype;
  return e.reconstructWithOptions = function(a, n) {
    return n === void 0 && (n = !0), new t(Et({}, this.options, {}, a), this.gs, n && this.names || void 0);
  }, e.allocateGSInstance = function(a) {
    return this.gs[a] = (this.gs[a] || 0) + 1;
  }, e.getTag = function() {
    return this.tag || (this.tag = (i = (n = this.options).isServer, o = n.useCSSOMInjection, s = n.target, a = i ? new ll(s) : o ? new sl(s) : new rl(s), new G2(a)));
    var a, n, i, o, s;
  }, e.hasNameForId = function(a, n) {
    return this.names.has(a) && this.names.get(a).has(n);
  }, e.registerName = function(a, n) {
    if (dn(a), this.names.has(a)) this.names.get(a).add(n);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(n), this.names.set(a, i);
    }
  }, e.insertRules = function(a, n, i) {
    this.registerName(a, n), this.getTag().insertRules(dn(a), i);
  }, e.clearNames = function(a) {
    this.names.has(a) && this.names.get(a).clear();
  }, e.clearRules = function(a) {
    this.getTag().clearGroup(dn(a)), this.clearNames(a);
  }, e.clearTag = function() {
    this.tag = void 0;
  }, e.toString = function() {
    return function(a) {
      for (var n = a.getTag(), i = n.length, o = "", s = 0; s < i; s++) {
        var r = Q2(s);
        if (r !== void 0) {
          var c = a.names.get(r), l = n.getGroup(s);
          if (c && l && c.size) {
            var f = _a + ".g" + s + '[id="' + r + '"]', m = "";
            c !== void 0 && c.forEach(function(v) {
              v.length > 0 && (m += v + ",");
            }), o += "" + l + f + '{content:"' + m + `"}/*!sc*/
`;
          }
        }
      }
      return o;
    }(this);
  }, t;
}(), ul = /(a)(d)/gi, Uo = function(t) {
  return String.fromCharCode(t + (t > 25 ? 39 : 97));
};
function xi(t) {
  var e, a = "";
  for (e = Math.abs(t); e > 52; e = e / 52 | 0) a = Uo(e % 52) + a;
  return (Uo(e % 52) + a).replace(ul, "$1-$2");
}
var Gt = function(t, e) {
  for (var a = e.length; a; ) t = 33 * t ^ e.charCodeAt(--a);
  return t;
}, us = function(t) {
  return Gt(5381, t);
};
function fl(t) {
  for (var e = 0; e < t.length; e += 1) {
    var a = t[e];
    if (Qa(a) && !Ji(a)) return !1;
  }
  return !0;
}
var dl = us("5.3.11"), ml = function() {
  function t(e, a, n) {
    this.rules = e, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (n === void 0 || n.isStatic) && fl(e), this.componentId = a, this.baseHash = Gt(dl, a), this.baseStyle = n, cs.registerId(a);
  }
  return t.prototype.generateAndInjectStyles = function(e, a, n) {
    var i = this.componentId, o = [];
    if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, a, n)), this.isStatic && !n.hash) if (this.staticRulesId && a.hasNameForId(i, this.staticRulesId)) o.push(this.staticRulesId);
    else {
      var s = Fa(this.rules, e, a, n).join(""), r = xi(Gt(this.baseHash, s) >>> 0);
      if (!a.hasNameForId(i, r)) {
        var c = n(s, "." + r, void 0, i);
        a.insertRules(i, r, c);
      }
      o.push(r), this.staticRulesId = r;
    }
    else {
      for (var l = this.rules.length, f = Gt(this.baseHash, n.hash), m = "", v = 0; v < l; v++) {
        var k = this.rules[v];
        if (typeof k == "string") m += k, process.env.NODE_ENV !== "production" && (f = Gt(f, k + v));
        else if (k) {
          var C = Fa(k, e, a, n), E = Array.isArray(C) ? C.join("") : C;
          f = Gt(f, E + v), m += E;
        }
      }
      if (m) {
        var b = xi(f >>> 0);
        if (!a.hasNameForId(i, b)) {
          var D = n(m, "." + b, void 0, i);
          a.insertRules(i, b, D);
        }
        o.push(b);
      }
    }
    return o.join(" ");
  }, t;
}(), pl = /^\s*\/\/.*$/gm, hl = [":", "[", ".", "#"];
function gl(t) {
  var e, a, n, i, o = Pt, s = o.options, r = s === void 0 ? Pt : s, c = o.plugins, l = c === void 0 ? In : c, f = new I2(r), m = [], v = /* @__PURE__ */ function(E) {
    function b(D) {
      if (D) try {
        E(D + "}");
      } catch {
      }
    }
    return function(D, j, x, _, y, H, $, Y, ae, ve) {
      switch (D) {
        case 1:
          if (ae === 0 && j.charCodeAt(0) === 64) return E(j + ";"), "";
          break;
        case 2:
          if (Y === 0) return j + "/*|*/";
          break;
        case 3:
          switch (Y) {
            case 102:
            case 112:
              return E(x[0] + j), "";
            default:
              return j + (ve === 0 ? "/*|*/" : "");
          }
        case -2:
          j.split("/*|*/}").forEach(b);
      }
    };
  }(function(E) {
    m.push(E);
  }), k = function(E, b, D) {
    return b === 0 && hl.indexOf(D[a.length]) !== -1 || D.match(i) ? E : "." + e;
  };
  function C(E, b, D, j) {
    j === void 0 && (j = "&");
    var x = E.replace(pl, ""), _ = b && D ? D + " " + b + " { " + x + " }" : x;
    return e = j, a = b, n = new RegExp("\\" + a + "\\b", "g"), i = new RegExp("(\\" + a + "\\b){2,}"), f(D || !b ? "" : b, _);
  }
  return f.use([].concat(l, [function(E, b, D) {
    E === 2 && D.length && D[0].lastIndexOf(a) > 0 && (D[0] = D[0].replace(n, k));
  }, v, function(E) {
    if (E === -2) {
      var b = m;
      return m = [], b;
    }
  }])), C.hash = l.length ? l.reduce(function(E, b) {
    return b.name || Ea(15), Gt(E, b.name);
  }, 5381).toString() : "", C;
}
var fs = Ca.createContext();
fs.Consumer;
var ds = Ca.createContext(), bl = (ds.Consumer, new cs()), _i = gl();
function yl() {
  return Ui(fs) || bl;
}
function vl() {
  return Ui(ds) || _i;
}
var kl = function() {
  function t(e, a) {
    var n = this;
    this.inject = function(i, o) {
      o === void 0 && (o = _i);
      var s = n.name + o.hash;
      i.hasNameForId(n.id, s) || i.insertRules(n.id, s, o(n.rules, s, "@keyframes"));
    }, this.toString = function() {
      return Ea(12, String(n.name));
    }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = a;
  }
  return t.prototype.getName = function(e) {
    return e === void 0 && (e = _i), this.name + e.hash;
  }, t;
}(), wl = /([A-Z])/, xl = /([A-Z])/g, _l = /^ms-/, Fl = function(t) {
  return "-" + t.toLowerCase();
};
function So(t) {
  return wl.test(t) ? t.replace(xl, Fl).replace(_l, "-ms-") : t;
}
var Ao = function(t) {
  return t == null || t === !1 || t === "";
};
function Fa(t, e, a, n) {
  if (Array.isArray(t)) {
    for (var i, o = [], s = 0, r = t.length; s < r; s += 1) (i = Fa(t[s], e, a, n)) !== "" && (Array.isArray(i) ? o.push.apply(o, i) : o.push(i));
    return o;
  }
  if (Ao(t)) return "";
  if (Ji(t)) return "." + t.styledComponentId;
  if (Qa(t)) {
    if (typeof (l = t) != "function" || l.prototype && l.prototype.isReactComponent || !e) return t;
    var c = t(e);
    return process.env.NODE_ENV !== "production" && $i.isElement(c) && console.warn(wi(t) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), Fa(c, e, a, n);
  }
  var l;
  return t instanceof kl ? a ? (t.inject(a, n), t.getName(n)) : t : ki(t) ? function f(m, v) {
    var k, C, E = [];
    for (var b in m) m.hasOwnProperty(b) && !Ao(m[b]) && (Array.isArray(m[b]) && m[b].isCss || Qa(m[b]) ? E.push(So(b) + ":", m[b], ";") : ki(m[b]) ? E.push.apply(E, f(m[b], b)) : E.push(So(b) + ": " + (k = b, (C = m[b]) == null || typeof C == "boolean" || C === "" ? "" : typeof C != "number" || C === 0 || k in D2 || k.startsWith("--") ? String(C).trim() : C + "px") + ";"));
    return v ? [v + " {"].concat(E, ["}"]) : E;
  }(t) : t.toString();
}
var Io = function(t) {
  return Array.isArray(t) && (t.isCss = !0), t;
};
function Se(t) {
  for (var e = arguments.length, a = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) a[n - 1] = arguments[n];
  return Qa(t) || ki(t) ? Io(Fa(To(In, [t].concat(a)))) : a.length === 0 && t.length === 1 && typeof t[0] == "string" ? t : Io(Fa(To(t, a)));
}
var Do = /invalid hook call/i, mn = /* @__PURE__ */ new Set(), Cl = function(t, e) {
  if (process.env.NODE_ENV !== "production") {
    var a = "The component " + t + (e ? ' with the id of "' + e + '"' : "") + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, n = console.error;
    try {
      var i = !0;
      console.error = function(o) {
        if (Do.test(o)) i = !1, mn.delete(a);
        else {
          for (var s = arguments.length, r = new Array(s > 1 ? s - 1 : 0), c = 1; c < s; c++) r[c - 1] = arguments[c];
          n.apply(void 0, [o].concat(r));
        }
      }, Nt(), i && !mn.has(a) && (console.warn(a), mn.add(a));
    } catch (o) {
      Do.test(o.message) && mn.delete(a);
    } finally {
      console.error = n;
    }
  }
}, zl = function(t, e, a) {
  return a === void 0 && (a = Pt), t.theme !== a.theme && t.theme || e || a.theme;
}, El = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, Tl = /(^-|-$)/g;
function ti(t) {
  return t.replace(El, "-").replace(Tl, "");
}
var jl = function(t) {
  return xi(us(t) >>> 0);
};
function pn(t) {
  return typeof t == "string" && (process.env.NODE_ENV === "production" || t.charAt(0) === t.charAt(0).toLowerCase());
}
var Fi = function(t) {
  return typeof t == "function" || typeof t == "object" && t !== null && !Array.isArray(t);
}, Ul = function(t) {
  return t !== "__proto__" && t !== "constructor" && t !== "prototype";
};
function Sl(t, e, a) {
  var n = t[a];
  Fi(e) && Fi(n) ? ms(n, e) : t[a] = e;
}
function ms(t) {
  for (var e = arguments.length, a = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) a[n - 1] = arguments[n];
  for (var i = 0, o = a; i < o.length; i++) {
    var s = o[i];
    if (Fi(s)) for (var r in s) Ul(r) && Sl(t, s[r], r);
  }
  return t;
}
var ps = Ca.createContext();
ps.Consumer;
var ai = {};
function hs(t, e, a) {
  var n = Ji(t), i = !pn(t), o = e.attrs, s = o === void 0 ? In : o, r = e.componentId, c = r === void 0 ? function(j, x) {
    var _ = typeof j != "string" ? "sc" : ti(j);
    ai[_] = (ai[_] || 0) + 1;
    var y = _ + "-" + jl("5.3.11" + _ + ai[_]);
    return x ? x + "-" + y : y;
  }(e.displayName, e.parentComponentId) : r, l = e.displayName, f = l === void 0 ? function(j) {
    return pn(j) ? "styled." + j : "Styled(" + wi(j) + ")";
  }(t) : l, m = e.displayName && e.componentId ? ti(e.displayName) + "-" + e.componentId : e.componentId || c, v = n && t.attrs ? Array.prototype.concat(t.attrs, s).filter(Boolean) : s, k = e.shouldForwardProp;
  n && t.shouldForwardProp && (k = e.shouldForwardProp ? function(j, x, _) {
    return t.shouldForwardProp(j, x, _) && e.shouldForwardProp(j, x, _);
  } : t.shouldForwardProp);
  var C, E = new ml(a, m, n ? t.componentStyle : void 0), b = E.isStatic && s.length === 0, D = function(j, x) {
    return function(_, y, H, $) {
      var Y = _.attrs, ae = _.componentStyle, ve = _.defaultProps, de = _.foldedComponentIds, N = _.shouldForwardProp, P = _.styledComponentId, M = _.target, V = function(B, g, ne) {
        B === void 0 && (B = Pt);
        var z = Et({}, g, { theme: B }), me = {};
        return ne.forEach(function(Q) {
          var G, F, Fe, R = Q;
          for (G in Qa(R) && (R = R(z)), R) z[G] = me[G] = G === "className" ? (F = me[G], Fe = R[G], F && Fe ? F + " " + Fe : F || Fe) : R[G];
        }), [z, me];
      }(zl(y, Ui(ps), ve) || Pt, y, Y), be = V[0], Z = V[1], oe = function(B, g, ne, z) {
        var me = yl(), Q = vl(), G = g ? B.generateAndInjectStyles(Pt, me, Q) : B.generateAndInjectStyles(ne, me, Q);
        return process.env.NODE_ENV !== "production" && !g && z && z(G), G;
      }(ae, $, be, process.env.NODE_ENV !== "production" ? _.warnTooManyClasses : void 0), ke = H, we = Z.$as || y.$as || Z.as || y.as || M, re = pn(we), A = Z !== y ? Et({}, y, {}, Z) : y, w = {};
      for (var I in A) I[0] !== "$" && I !== "as" && (I === "forwardedAs" ? w.as = A[I] : (N ? N(I, xo, we) : !re || xo(I)) && (w[I] = A[I]));
      return y.style && Z.style !== y.style && (w.style = Et({}, y.style, {}, Z.style)), w.className = Array.prototype.concat(de, P, oe !== P ? oe : null, y.className, Z.className).filter(Boolean).join(" "), w.ref = ke, Hs(we, w);
    }(C, j, x, b);
  };
  return D.displayName = f, (C = Ca.forwardRef(D)).attrs = v, C.componentStyle = E, C.displayName = f, C.shouldForwardProp = k, C.foldedComponentIds = n ? Array.prototype.concat(t.foldedComponentIds, t.styledComponentId) : In, C.styledComponentId = m, C.target = n ? t.target : t, C.withComponent = function(j) {
    var x = e.componentId, _ = function(H, $) {
      if (H == null) return {};
      var Y, ae, ve = {}, de = Object.keys(H);
      for (ae = 0; ae < de.length; ae++) Y = de[ae], $.indexOf(Y) >= 0 || (ve[Y] = H[Y]);
      return ve;
    }(e, ["componentId"]), y = x && x + "-" + (pn(j) ? j : ti(wi(j)));
    return hs(j, Et({}, _, { attrs: v, componentId: y }), a);
  }, Object.defineProperty(C, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(j) {
    this._foldedDefaultProps = n ? ms({}, t.defaultProps, j) : j;
  } }), process.env.NODE_ENV !== "production" && (Cl(f, m), C.warnTooManyClasses = /* @__PURE__ */ function(j, x) {
    var _ = {}, y = !1;
    return function(H) {
      if (!y && (_[H] = !0, Object.keys(_).length >= 200)) {
        var $ = x ? ' with the id of "' + x + '"' : "";
        console.warn("Over 200 classes were generated for component " + j + $ + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), y = !0, _ = {};
      }
    };
  }(f, m)), Object.defineProperty(C, "toString", { value: function() {
    return "." + C.styledComponentId;
  } }), i && $2(C, t, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), C;
}
var q = function(t) {
  return function e(a, n, i) {
    if (i === void 0 && (i = Pt), !$i.isValidElementType(n)) return Ea(1, String(n));
    var o = function() {
      return a(n, i, Se.apply(void 0, arguments));
    };
    return o.withConfig = function(s) {
      return e(a, n, Et({}, i, {}, s));
    }, o.attrs = function(s) {
      return e(a, n, Et({}, i, { attrs: Array.prototype.concat(i.attrs, s).filter(Boolean) }));
    }, o;
  }(hs, t);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(t) {
  q[t] = q(t);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
const Al = (t) => {
  let e;
  return t < 30 ? e = 115 : t >= 30 && t < 40 ? e = 110 : t >= 40 && t <= 50 ? e = 105 : e = 95, `${e}px`;
}, Il = q.div.withConfig({
  displayName: "MainWrapper",
  componentId: "sc-z0kmps-0"
})(["position:relative;width:100%;height:100%;"]), Dl = q(pt).withConfig({
  displayName: "BackgroundImage",
  componentId: "sc-z0kmps-1"
})(["width:100%;height:100%;object-fit:cover;"]), Bl = q.span.withConfig({
  displayName: "JobTitle",
  componentId: "sc-z0kmps-2"
})(["font-size:", ";color:", ";line-height:1.6;background-color:", ";border-radius:30px 0 0 30px;padding:25px 40px;text-align:right;box-decoration-break:clone;&&&{font-family:", ',"Nunito",sans-serif;font-weight:700;}'], ({
  textSize: t,
  textLength: e
}) => t ? `${t}px` : Al(e), ({
  color: t
}) => t || "white", ({
  backgroundColor: t
}) => t || "white", ({
  fontFamily: t
}) => t), Rl = q.div.withConfig({
  displayName: "TitleWrapper",
  componentId: "sc-z0kmps-3"
})(["position:absolute;right:0;bottom:0;transform:translateY(-40%);text-align:right;min-width:75%;max-width:90%;"]), qt = (t, e) => {
  kt(() => {
    if (!e || (e == null ? void 0 : e.name) !== t) return;
    const {
      name: a,
      url: n
    } = e;
    new FontFace(t, `url(${n})`, {
      display: "swap",
      weight: "normal",
      style: "normal"
    }).load().then((o) => {
      document.fonts.add(o);
    }).catch((o) => {
      console.error(`Failed to load font: ${a}`, o);
    });
  }, [e, t]);
};
/*! @license DOMPurify 3.2.1 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.1/LICENSE */
const {
  entries: gs,
  setPrototypeOf: Bo,
  isFrozen: Ol,
  getPrototypeOf: Pl,
  getOwnPropertyDescriptor: Nl
} = Object;
let {
  freeze: Ze,
  seal: st,
  create: bs
} = Object, {
  apply: Ci,
  construct: zi
} = typeof Reflect < "u" && Reflect;
Ze || (Ze = function(e) {
  return e;
});
st || (st = function(e) {
  return e;
});
Ci || (Ci = function(e, a, n) {
  return e.apply(a, n);
});
zi || (zi = function(e, a) {
  return new e(...a);
});
const hn = et(Array.prototype.forEach), Ro = et(Array.prototype.pop), Aa = et(Array.prototype.push), kn = et(String.prototype.toLowerCase), ni = et(String.prototype.toString), Oo = et(String.prototype.match), Ia = et(String.prototype.replace), Ml = et(String.prototype.indexOf), Vl = et(String.prototype.trim), ct = et(Object.prototype.hasOwnProperty), $e = et(RegExp.prototype.test), Da = Xl(TypeError);
function et(t) {
  return function(e) {
    for (var a = arguments.length, n = new Array(a > 1 ? a - 1 : 0), i = 1; i < a; i++)
      n[i - 1] = arguments[i];
    return Ci(t, e, n);
  };
}
function Xl(t) {
  return function() {
    for (var e = arguments.length, a = new Array(e), n = 0; n < e; n++)
      a[n] = arguments[n];
    return zi(t, a);
  };
}
function ge(t, e) {
  let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : kn;
  Bo && Bo(t, null);
  let n = e.length;
  for (; n--; ) {
    let i = e[n];
    if (typeof i == "string") {
      const o = a(i);
      o !== i && (Ol(e) || (e[n] = o), i = o);
    }
    t[i] = !0;
  }
  return t;
}
function Kl(t) {
  for (let e = 0; e < t.length; e++)
    ct(t, e) || (t[e] = null);
  return t;
}
function Jt(t) {
  const e = bs(null);
  for (const [a, n] of gs(t))
    ct(t, a) && (Array.isArray(n) ? e[a] = Kl(n) : n && typeof n == "object" && n.constructor === Object ? e[a] = Jt(n) : e[a] = n);
  return e;
}
function Ba(t, e) {
  for (; t !== null; ) {
    const n = Nl(t, e);
    if (n) {
      if (n.get)
        return et(n.get);
      if (typeof n.value == "function")
        return et(n.value);
    }
    t = Pl(t);
  }
  function a() {
    return null;
  }
  return a;
}
const Po = Ze(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), ii = Ze(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), oi = Ze(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Ll = Ze(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), si = Ze(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), ql = Ze(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), No = Ze(["#text"]), Mo = Ze(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), ri = Ze(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Vo = Ze(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), gn = Ze(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Wl = st(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Yl = st(/<%[\w\W]*|[\w\W]*%>/gm), $l = st(/\${[\w\W]*}/gm), Hl = st(/^data-[\-\w.\u00B7-\uFFFF]/), Zl = st(/^aria-[\-\w]+$/), ys = st(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Jl = st(/^(?:\w+script|data):/i), Gl = st(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), vs = st(/^html$/i), Ql = st(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Xo = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: Zl,
  ATTR_WHITESPACE: Gl,
  CUSTOM_ELEMENT: Ql,
  DATA_ATTR: Hl,
  DOCTYPE_NAME: vs,
  ERB_EXPR: Yl,
  IS_ALLOWED_URI: ys,
  IS_SCRIPT_OR_DATA: Jl,
  MUSTACHE_EXPR: Wl,
  TMPLIT_EXPR: $l
});
const Ra = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, e0 = function() {
  return typeof window > "u" ? null : window;
}, t0 = function(e, a) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let n = null;
  const i = "data-tt-policy-suffix";
  a && a.hasAttribute(i) && (n = a.getAttribute(i));
  const o = "dompurify" + (n ? "#" + n : "");
  try {
    return e.createPolicy(o, {
      createHTML(s) {
        return s;
      },
      createScriptURL(s) {
        return s;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + o + " could not be created."), null;
  }
};
function ks() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e0();
  const e = (K) => ks(K);
  if (e.version = "3.2.1", e.removed = [], !t || !t.document || t.document.nodeType !== Ra.document)
    return e.isSupported = !1, e;
  let {
    document: a
  } = t;
  const n = a, i = n.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: r,
    Element: c,
    NodeFilter: l,
    NamedNodeMap: f = t.NamedNodeMap || t.MozNamedAttrMap,
    HTMLFormElement: m,
    DOMParser: v,
    trustedTypes: k
  } = t, C = c.prototype, E = Ba(C, "cloneNode"), b = Ba(C, "remove"), D = Ba(C, "nextSibling"), j = Ba(C, "childNodes"), x = Ba(C, "parentNode");
  if (typeof s == "function") {
    const K = a.createElement("template");
    K.content && K.content.ownerDocument && (a = K.content.ownerDocument);
  }
  let _, y = "";
  const {
    implementation: H,
    createNodeIterator: $,
    createDocumentFragment: Y,
    getElementsByTagName: ae
  } = a, {
    importNode: ve
  } = n;
  let de = {};
  e.isSupported = typeof gs == "function" && typeof x == "function" && H && H.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: N,
    ERB_EXPR: P,
    TMPLIT_EXPR: M,
    DATA_ATTR: V,
    ARIA_ATTR: be,
    IS_SCRIPT_OR_DATA: Z,
    ATTR_WHITESPACE: oe,
    CUSTOM_ELEMENT: ke
  } = Xo;
  let {
    IS_ALLOWED_URI: we
  } = Xo, re = null;
  const A = ge({}, [...Po, ...ii, ...oi, ...si, ...No]);
  let w = null;
  const I = ge({}, [...Mo, ...ri, ...Vo, ...gn]);
  let B = Object.seal(bs(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), g = null, ne = null, z = !0, me = !0, Q = !1, G = !0, F = !1, Fe = !0, R = !1, le = !1, Ae = !1, ue = !1, De = !1, tt = !1, Be = !0, rt = !1;
  const Ft = "user-content-";
  let Xe = !0, ee = !1, xe = {}, at = null;
  const Dt = ge({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Ge = null;
  const tn = ge({}, ["audio", "video", "img", "source", "image", "track"]);
  let Ta = null;
  const an = ge({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), ua = "http://www.w3.org/1998/Math/MathML", Bt = "http://www.w3.org/2000/svg", nt = "http://www.w3.org/1999/xhtml";
  let Qe = nt, $t = !1, Ht = null;
  const nn = ge({}, [ua, Bt, nt], ni);
  let fa = ge({}, ["mi", "mo", "mn", "ms", "mtext"]), Zt = ge({}, ["annotation-xml"]);
  const Yn = ge({}, ["title", "style", "font", "a", "script"]);
  let Rt = null;
  const on = ["application/xhtml+xml", "text/html"], $n = "text/html";
  let Ve = null, Ct = null;
  const Hn = a.createElement("form"), sn = function(p) {
    return p instanceof RegExp || p instanceof Function;
  }, ja = function() {
    let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Ct && Ct === p)) {
      if ((!p || typeof p != "object") && (p = {}), p = Jt(p), Rt = // eslint-disable-next-line unicorn/prefer-includes
      on.indexOf(p.PARSER_MEDIA_TYPE) === -1 ? $n : p.PARSER_MEDIA_TYPE, Ve = Rt === "application/xhtml+xml" ? ni : kn, re = ct(p, "ALLOWED_TAGS") ? ge({}, p.ALLOWED_TAGS, Ve) : A, w = ct(p, "ALLOWED_ATTR") ? ge({}, p.ALLOWED_ATTR, Ve) : I, Ht = ct(p, "ALLOWED_NAMESPACES") ? ge({}, p.ALLOWED_NAMESPACES, ni) : nn, Ta = ct(p, "ADD_URI_SAFE_ATTR") ? ge(Jt(an), p.ADD_URI_SAFE_ATTR, Ve) : an, Ge = ct(p, "ADD_DATA_URI_TAGS") ? ge(Jt(tn), p.ADD_DATA_URI_TAGS, Ve) : tn, at = ct(p, "FORBID_CONTENTS") ? ge({}, p.FORBID_CONTENTS, Ve) : Dt, g = ct(p, "FORBID_TAGS") ? ge({}, p.FORBID_TAGS, Ve) : {}, ne = ct(p, "FORBID_ATTR") ? ge({}, p.FORBID_ATTR, Ve) : {}, xe = ct(p, "USE_PROFILES") ? p.USE_PROFILES : !1, z = p.ALLOW_ARIA_ATTR !== !1, me = p.ALLOW_DATA_ATTR !== !1, Q = p.ALLOW_UNKNOWN_PROTOCOLS || !1, G = p.ALLOW_SELF_CLOSE_IN_ATTR !== !1, F = p.SAFE_FOR_TEMPLATES || !1, Fe = p.SAFE_FOR_XML !== !1, R = p.WHOLE_DOCUMENT || !1, ue = p.RETURN_DOM || !1, De = p.RETURN_DOM_FRAGMENT || !1, tt = p.RETURN_TRUSTED_TYPE || !1, Ae = p.FORCE_BODY || !1, Be = p.SANITIZE_DOM !== !1, rt = p.SANITIZE_NAMED_PROPS || !1, Xe = p.KEEP_CONTENT !== !1, ee = p.IN_PLACE || !1, we = p.ALLOWED_URI_REGEXP || ys, Qe = p.NAMESPACE || nt, fa = p.MATHML_TEXT_INTEGRATION_POINTS || fa, Zt = p.HTML_INTEGRATION_POINTS || Zt, B = p.CUSTOM_ELEMENT_HANDLING || {}, p.CUSTOM_ELEMENT_HANDLING && sn(p.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (B.tagNameCheck = p.CUSTOM_ELEMENT_HANDLING.tagNameCheck), p.CUSTOM_ELEMENT_HANDLING && sn(p.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (B.attributeNameCheck = p.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), p.CUSTOM_ELEMENT_HANDLING && typeof p.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (B.allowCustomizedBuiltInElements = p.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), F && (me = !1), De && (ue = !0), xe && (re = ge({}, No), w = [], xe.html === !0 && (ge(re, Po), ge(w, Mo)), xe.svg === !0 && (ge(re, ii), ge(w, ri), ge(w, gn)), xe.svgFilters === !0 && (ge(re, oi), ge(w, ri), ge(w, gn)), xe.mathMl === !0 && (ge(re, si), ge(w, Vo), ge(w, gn))), p.ADD_TAGS && (re === A && (re = Jt(re)), ge(re, p.ADD_TAGS, Ve)), p.ADD_ATTR && (w === I && (w = Jt(w)), ge(w, p.ADD_ATTR, Ve)), p.ADD_URI_SAFE_ATTR && ge(Ta, p.ADD_URI_SAFE_ATTR, Ve), p.FORBID_CONTENTS && (at === Dt && (at = Jt(at)), ge(at, p.FORBID_CONTENTS, Ve)), Xe && (re["#text"] = !0), R && ge(re, ["html", "head", "body"]), re.table && (ge(re, ["tbody"]), delete g.tbody), p.TRUSTED_TYPES_POLICY) {
        if (typeof p.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Da('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof p.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Da('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        _ = p.TRUSTED_TYPES_POLICY, y = _.createHTML("");
      } else
        _ === void 0 && (_ = t0(k, i)), _ !== null && typeof y == "string" && (y = _.createHTML(""));
      Ze && Ze(p), Ct = p;
    }
  }, rn = ge({}, [...ii, ...oi, ...Ll]), d = ge({}, [...si, ...ql]), T = function(p) {
    let S = x(p);
    (!S || !S.tagName) && (S = {
      namespaceURI: Qe,
      tagName: "template"
    });
    const J = kn(p.tagName), Pe = kn(S.tagName);
    return Ht[p.namespaceURI] ? p.namespaceURI === Bt ? S.namespaceURI === nt ? J === "svg" : S.namespaceURI === ua ? J === "svg" && (Pe === "annotation-xml" || fa[Pe]) : !!rn[J] : p.namespaceURI === ua ? S.namespaceURI === nt ? J === "math" : S.namespaceURI === Bt ? J === "math" && Zt[Pe] : !!d[J] : p.namespaceURI === nt ? S.namespaceURI === Bt && !Zt[Pe] || S.namespaceURI === ua && !fa[Pe] ? !1 : !d[J] && (Yn[J] || !rn[J]) : !!(Rt === "application/xhtml+xml" && Ht[p.namespaceURI]) : !1;
  }, O = function(p) {
    Aa(e.removed, {
      element: p
    });
    try {
      x(p).removeChild(p);
    } catch {
      b(p);
    }
  }, ie = function(p, S) {
    try {
      Aa(e.removed, {
        attribute: S.getAttributeNode(p),
        from: S
      });
    } catch {
      Aa(e.removed, {
        attribute: null,
        from: S
      });
    }
    if (S.removeAttribute(p), p === "is" && !w[p])
      if (ue || De)
        try {
          O(S);
        } catch {
        }
      else
        try {
          S.setAttribute(p, "");
        } catch {
        }
  }, Ue = function(p) {
    let S = null, J = null;
    if (Ae)
      p = "<remove></remove>" + p;
    else {
      const Ke = Oo(p, /^[\r\n\t ]+/);
      J = Ke && Ke[0];
    }
    Rt === "application/xhtml+xml" && Qe === nt && (p = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + p + "</body></html>");
    const Pe = _ ? _.createHTML(p) : p;
    if (Qe === nt)
      try {
        S = new v().parseFromString(Pe, Rt);
      } catch {
      }
    if (!S || !S.documentElement) {
      S = H.createDocument(Qe, "template", null);
      try {
        S.documentElement.innerHTML = $t ? y : Pe;
      } catch {
      }
    }
    const qe = S.body || S.documentElement;
    return p && J && qe.insertBefore(a.createTextNode(J), qe.childNodes[0] || null), Qe === nt ? ae.call(S, R ? "html" : "body")[0] : R ? S.documentElement : qe;
  }, Ce = function(p) {
    return $.call(
      p.ownerDocument || p,
      p,
      // eslint-disable-next-line no-bitwise
      l.SHOW_ELEMENT | l.SHOW_COMMENT | l.SHOW_TEXT | l.SHOW_PROCESSING_INSTRUCTION | l.SHOW_CDATA_SECTION,
      null
    );
  }, ye = function(p) {
    return p instanceof m && (typeof p.nodeName != "string" || typeof p.textContent != "string" || typeof p.removeChild != "function" || !(p.attributes instanceof f) || typeof p.removeAttribute != "function" || typeof p.setAttribute != "function" || typeof p.namespaceURI != "string" || typeof p.insertBefore != "function" || typeof p.hasChildNodes != "function");
  }, he = function(p) {
    return typeof r == "function" && p instanceof r;
  };
  function Re(K, p, S) {
    de[K] && hn(de[K], (J) => {
      J.call(e, p, S, Ct);
    });
  }
  const Oe = function(p) {
    let S = null;
    if (Re("beforeSanitizeElements", p, null), ye(p))
      return O(p), !0;
    const J = Ve(p.nodeName);
    if (Re("uponSanitizeElement", p, {
      tagName: J,
      allowedTags: re
    }), p.hasChildNodes() && !he(p.firstElementChild) && $e(/<[/\w]/g, p.innerHTML) && $e(/<[/\w]/g, p.textContent) || p.nodeType === Ra.progressingInstruction || Fe && p.nodeType === Ra.comment && $e(/<[/\w]/g, p.data))
      return O(p), !0;
    if (!re[J] || g[J]) {
      if (!g[J] && it(J) && (B.tagNameCheck instanceof RegExp && $e(B.tagNameCheck, J) || B.tagNameCheck instanceof Function && B.tagNameCheck(J)))
        return !1;
      if (Xe && !at[J]) {
        const Pe = x(p) || p.parentNode, qe = j(p) || p.childNodes;
        if (qe && Pe) {
          const Ke = qe.length;
          for (let Je = Ke - 1; Je >= 0; --Je) {
            const ht = E(qe[Je], !0);
            ht.__removalCount = (p.__removalCount || 0) + 1, Pe.insertBefore(ht, D(p));
          }
        }
      }
      return O(p), !0;
    }
    return p instanceof c && !T(p) || (J === "noscript" || J === "noembed" || J === "noframes") && $e(/<\/no(script|embed|frames)/i, p.innerHTML) ? (O(p), !0) : (F && p.nodeType === Ra.text && (S = p.textContent, hn([N, P, M], (Pe) => {
      S = Ia(S, Pe, " ");
    }), p.textContent !== S && (Aa(e.removed, {
      element: p.cloneNode()
    }), p.textContent = S)), Re("afterSanitizeElements", p, null), !1);
  }, Ne = function(p, S, J) {
    if (Be && (S === "id" || S === "name") && (J in a || J in Hn))
      return !1;
    if (!(me && !ne[S] && $e(V, S))) {
      if (!(z && $e(be, S))) {
        if (!w[S] || ne[S]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(it(p) && (B.tagNameCheck instanceof RegExp && $e(B.tagNameCheck, p) || B.tagNameCheck instanceof Function && B.tagNameCheck(p)) && (B.attributeNameCheck instanceof RegExp && $e(B.attributeNameCheck, S) || B.attributeNameCheck instanceof Function && B.attributeNameCheck(S)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            S === "is" && B.allowCustomizedBuiltInElements && (B.tagNameCheck instanceof RegExp && $e(B.tagNameCheck, J) || B.tagNameCheck instanceof Function && B.tagNameCheck(J)))
          ) return !1;
        } else if (!Ta[S]) {
          if (!$e(we, Ia(J, oe, ""))) {
            if (!((S === "src" || S === "xlink:href" || S === "href") && p !== "script" && Ml(J, "data:") === 0 && Ge[p])) {
              if (!(Q && !$e(Z, Ia(J, oe, "")))) {
                if (J)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, it = function(p) {
    return p !== "annotation-xml" && Oo(p, ke);
  }, zt = function(p) {
    Re("beforeSanitizeAttributes", p, null);
    const {
      attributes: S
    } = p;
    if (!S)
      return;
    const J = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: w,
      forceKeepAttr: void 0
    };
    let Pe = S.length;
    for (; Pe--; ) {
      const qe = S[Pe], {
        name: Ke,
        namespaceURI: Je,
        value: ht
      } = qe, Ua = Ve(Ke);
      let Ye = Ke === "value" ? ht : Vl(ht);
      if (J.attrName = Ua, J.attrValue = Ye, J.keepAttr = !0, J.forceKeepAttr = void 0, Re("uponSanitizeAttribute", p, J), Ye = J.attrValue, rt && (Ua === "id" || Ua === "name") && (ie(Ke, p), Ye = Ft + Ye), Fe && $e(/((--!?|])>)|<\/(style|title)/i, Ye)) {
        ie(Ke, p);
        continue;
      }
      if (J.forceKeepAttr || (ie(Ke, p), !J.keepAttr))
        continue;
      if (!G && $e(/\/>/i, Ye)) {
        ie(Ke, p);
        continue;
      }
      F && hn([N, P, M], (oo) => {
        Ye = Ia(Ye, oo, " ");
      });
      const io = Ve(p.nodeName);
      if (Ne(io, Ua, Ye)) {
        if (_ && typeof k == "object" && typeof k.getAttributeType == "function" && !Je)
          switch (k.getAttributeType(io, Ua)) {
            case "TrustedHTML": {
              Ye = _.createHTML(Ye);
              break;
            }
            case "TrustedScriptURL": {
              Ye = _.createScriptURL(Ye);
              break;
            }
          }
        try {
          Je ? p.setAttributeNS(Je, Ke, Ye) : p.setAttribute(Ke, Ye), ye(p) ? O(p) : Ro(e.removed);
        } catch {
        }
      }
    }
    Re("afterSanitizeAttributes", p, null);
  }, ln = function K(p) {
    let S = null;
    const J = Ce(p);
    for (Re("beforeSanitizeShadowDOM", p, null); S = J.nextNode(); )
      Re("uponSanitizeShadowNode", S, null), !Oe(S) && (S.content instanceof o && K(S.content), zt(S));
    Re("afterSanitizeShadowDOM", p, null);
  };
  return e.sanitize = function(K) {
    let p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, S = null, J = null, Pe = null, qe = null;
    if ($t = !K, $t && (K = "<!-->"), typeof K != "string" && !he(K))
      if (typeof K.toString == "function") {
        if (K = K.toString(), typeof K != "string")
          throw Da("dirty is not a string, aborting");
      } else
        throw Da("toString is not a function");
    if (!e.isSupported)
      return K;
    if (le || ja(p), e.removed = [], typeof K == "string" && (ee = !1), ee) {
      if (K.nodeName) {
        const ht = Ve(K.nodeName);
        if (!re[ht] || g[ht])
          throw Da("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (K instanceof r)
      S = Ue("<!---->"), J = S.ownerDocument.importNode(K, !0), J.nodeType === Ra.element && J.nodeName === "BODY" || J.nodeName === "HTML" ? S = J : S.appendChild(J);
    else {
      if (!ue && !F && !R && // eslint-disable-next-line unicorn/prefer-includes
      K.indexOf("<") === -1)
        return _ && tt ? _.createHTML(K) : K;
      if (S = Ue(K), !S)
        return ue ? null : tt ? y : "";
    }
    S && Ae && O(S.firstChild);
    const Ke = Ce(ee ? K : S);
    for (; Pe = Ke.nextNode(); )
      Oe(Pe) || (Pe.content instanceof o && ln(Pe.content), zt(Pe));
    if (ee)
      return K;
    if (ue) {
      if (De)
        for (qe = Y.call(S.ownerDocument); S.firstChild; )
          qe.appendChild(S.firstChild);
      else
        qe = S;
      return (w.shadowroot || w.shadowrootmode) && (qe = ve.call(n, qe, !0)), qe;
    }
    let Je = R ? S.outerHTML : S.innerHTML;
    return R && re["!doctype"] && S.ownerDocument && S.ownerDocument.doctype && S.ownerDocument.doctype.name && $e(vs, S.ownerDocument.doctype.name) && (Je = "<!DOCTYPE " + S.ownerDocument.doctype.name + `>
` + Je), F && hn([N, P, M], (ht) => {
      Je = Ia(Je, ht, " ");
    }), _ && tt ? _.createHTML(Je) : Je;
  }, e.setConfig = function() {
    let K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ja(K), le = !0;
  }, e.clearConfig = function() {
    Ct = null, le = !1;
  }, e.isValidAttribute = function(K, p, S) {
    Ct || ja({});
    const J = Ve(K), Pe = Ve(p);
    return Ne(J, Pe, S);
  }, e.addHook = function(K, p) {
    typeof p == "function" && (de[K] = de[K] || [], Aa(de[K], p));
  }, e.removeHook = function(K) {
    if (de[K])
      return Ro(de[K]);
  }, e.removeHooks = function(K) {
    de[K] && (de[K] = []);
  }, e.removeAllHooks = function() {
    de = {};
  }, e;
}
var a0 = ks();
const n0 = '<span style="visibility:hidden;">nbsp</span>', Kt = (t) => {
  if (!t) return "";
  const e = t.replace(/&nbsp;/g, n0).replace(/\\n/g, "<br />"), a = a0.sanitize(e);
  return /* @__PURE__ */ h.jsx("span", { dangerouslySetInnerHTML: {
    __html: a
  }, style: {
    fontWeight: "inherit"
  } });
}, ws = (t) => {
  const e = t == null ? void 0 : t.split(" ").filter((a) => a.trim());
  return (t == null ? void 0 : t.length) <= 12 && (e == null ? void 0 : e.length) === 1 ? "boxoneline" : "box";
};
function Wt(t, e, a, n) {
  const i = a / t, o = n / e;
  return Math.min(i, o);
}
q.main.withConfig({
  displayName: "AppContainer",
  componentId: "sc-oibtpg-0"
})(["padding:0;margin:0;"]);
q.div.withConfig({
  displayName: "Page",
  componentId: "sc-oibtpg-1"
})(["display:grid;grid-template-columns:1fr;width:100%;max-width:2000px;margin:1rem auto;padding:0 2rem;"]);
q.div.withConfig({
  displayName: "Container",
  componentId: "sc-oibtpg-2"
})(["padding:1rem;display:flex;flex-direction:row;flex-wrap:wrap;gap:1rem;"]);
q.div.withConfig({
  displayName: "TemplateContainer",
  componentId: "sc-oibtpg-3"
})(["width:100%;aspect-ratio:", ';display:flex;justify-content:center;align-items:center;cursor:pointer;&:hover::before{content:"Edit";position:absolute;inset:0;background:rgba(0,0,0,0.5);color:white;display:flex;justify-content:center;align-items:center;font-size:1.5rem;z-index:10;}'], ({
  aspectRatio: t
}) => t);
const Yt = q.div.withConfig({
  displayName: "Scaler",
  componentId: "sc-oibtpg-4"
})(["width:", "px;height:", "px;transform:", ";display:flex;position:absolute;z-index:0;@media print{contain:size;}"], ({
  originalWidth: t
}) => t, ({
  originalHeight: t
}) => t, ({
  scaleFactor: t
}) => `scale(${t})`);
q.div.withConfig({
  displayName: "TemplateWrapper",
  componentId: "sc-oibtpg-5"
})(["height:", "px;width:", "px;display:flex;justify-content:center;align-items:center;> div > div{box-shadow:0px 0px 75px 0px rgba(0,0,0,0.49);}"], ({
  height: t
}) => t, ({
  width: t
}) => t);
q.div.withConfig({
  displayName: "InputBox",
  componentId: "sc-oibtpg-6"
})(["flex-wrap:wrap;display:flex;align-items:center;flex-direction:row;gap:1.5rem;"]);
const Ie = {
  portrait: {
    width: 2e3,
    height: 2e3,
    aspectRatio: 1
  },
  landscape: {
    width: 1952,
    height: 1022,
    aspectRatio: 1.91
  },
  vertical: {
    width: 1080,
    height: 1920,
    aspectRatio: 0.5625
  }
}, At = [{
  value: "small",
  label: "Small"
}, {
  value: "mid",
  label: "Medium"
}, {
  value: "big",
  label: "Big"
}], i0 = (t = "mid", e = "square", a = "portrait") => {
  var r, c;
  const n = {
    square: {
      small: 400,
      mid: 500,
      big: 600,
      default: 500
    },
    landscape: {
      small: 400,
      mid: 600,
      big: 800,
      default: 600
    }
  }, i = {
    portrait: 1,
    landscape: 0.9,
    vertical: 0.75
  }, s = (((r = n[e]) == null ? void 0 : r[t]) || ((c = n[e]) == null ? void 0 : c.default)) * i[a];
  return `
      max-width: ${s}px;
      min-width: ${s}px;
    `;
}, It = [{
  value: "top-left",
  label: "Top Left"
}, {
  value: "top-right",
  label: "Top Right"
}, {
  value: "bottom-left",
  label: "Bottom Left"
}, {
  value: "bottom-right",
  label: "Bottom Right"
}], o0 = (t, e = 2) => {
  switch (t) {
    case "top-left":
      return `
          top: ${e}%;
          left: ${e}%;
          justify-content: flex-start;
        `;
    case "top-right":
      return `
          top: ${e}%;
          right: ${e}%;
          justify-content: flex-end;
        `;
    case "bottom-left":
      return `
          bottom: ${e}%;
          left: ${e}%;
          justify-content: flex-start;
        `;
    case "bottom-right":
      return `
          bottom: ${e}%;
          right: ${e}%;
          justify-content: flex-end;
        `;
    default:
      return `
          top: ${e}%;
          left: ${e}%;
          justify-content: flex-start;
        `;
  }
}, ha = (
  /** @type {const} */
  {
    type: "image",
    id: "PortraitImage",
    preview: "/images/mediaTemplatePreviews/preview__ImageLogoText.svg",
    label: "Portrait",
    height: Ie.portrait.height,
    width: Ie.portrait.width,
    aspectRatio: 1,
    orientation: "portrait",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [{
        key: "backgroundImage",
        type: "image",
        label: "Hintergrund Bild"
      }, {
        key: "logo",
        type: "image",
        label: "Logo",
        isLogo: !0
      }, {
        key: "logoPosition",
        type: "select",
        label: "Logo Position",
        options: It
      }, {
        key: "logoSize",
        type: "select",
        label: "Logo Size",
        options: At
      }, {
        key: "text",
        type: "text",
        label: "Teaser Text"
      }, {
        key: "primaryTextColor",
        type: "color",
        label: "Text Farbe"
      }, {
        key: "primaryBackgroundColor",
        type: "color",
        label: "Hintergrund Farbe"
      }]
    }]
  }
), s0 = q.div.withConfig({
  displayName: "LogoWrapper",
  componentId: "sc-i6ywx2-0"
})(["position:absolute;height:auto;width:auto;display:flex;", " ", " z-index:10 !important;"], ({
  elementSize: t,
  logoFormat: e,
  orientation: a
}) => i0(t, e, a), ({
  logoPosition: t,
  offset: e
}) => o0(t, e)), r0 = q(pt).withConfig({
  displayName: "LogoImage",
  componentId: "sc-i6ywx2-1"
})(["object-fit:contain;height:100%;width:100%;flex-grow:1;align-self:start;object-position:left;"]), la = ({
  logo: t,
  logoPosition: e,
  offset: a = 2,
  elementSize: n,
  logoFormat: i,
  orientation: o
}) => t ? /* @__PURE__ */ h.jsx(s0, { logoPosition: e, offset: a, elementSize: n, logoFormat: i, orientation: o, children: /* @__PURE__ */ h.jsx(r0, { src: t }) }) : null;
u.object({
  top: u.number().default(1).optional(),
  left: u.number().default(1).optional(),
  primaryTextColor: W().optional(),
  primaryBackgroundColor: W().optional(),
  textColor: W().optional(),
  backgroundColor: W().optional(),
  text: u.string().optional(),
  textSize: u.number().default(80).optional(),
  backgroundImage: u.string().url(),
  logo: u.string().url().optional(),
  logoFormat: u.enum(["square", "landscape"]).optional(),
  logoPosition: u.enum(["top-left", "top-right", "bottom-left", "bottom-right"]).optional(),
  logoSize: u.enum(["small", "mid", "big"]).optional(),
  width: u.number().default(400).optional(),
  isVideo: u.boolean().default(!1).optional(),
  fontFamily: u.string().optional(),
  customFont: u.object({
    name: u.string(),
    url: u.string()
  }).optional()
});
const l0 = ({
  backgroundImage: t,
  logo: e,
  primaryTextColor: a,
  primaryBackgroundColor: n,
  textColor: i,
  backgroundColor: o,
  text: s,
  textSize: r,
  logoFormat: c = "square",
  logoPosition: l = "top-left",
  logoSize: f = "mid",
  width: m,
  isVideo: v = !1,
  fontFamily: k = "Nunito",
  customFont: C
}) => {
  const E = m / ha.aspectRatio, b = Wt(ha.width, ha.height, m, E);
  qt(k, C);
  const D = (C == null ? void 0 : C.name) === k, j = Lt(D ? null : k), x = D ? k : j, _ = t ? /* @__PURE__ */ h.jsx(Dl, { src: t }) : null, y = s ? /* @__PURE__ */ h.jsx(Rl, { children: /* @__PURE__ */ h.jsx(Bl, { color: i || a, backgroundColor: o || n, textSize: r, textLength: s == null ? void 0 : s.length, fontFamily: x, children: Kt(s) }) }) : null, H = /* @__PURE__ */ h.jsxs(Il, { children: [
    /* @__PURE__ */ h.jsx(la, { logo: e, logoPosition: l, elementSize: f, logoFormat: c }),
    _,
    y
  ] });
  return v ? H : /* @__PURE__ */ h.jsx(Yt, { originalWidth: ha.width, originalHeight: ha.height, scaleFactor: b, children: H });
}, c0 = (t) => {
  let e;
  return t < 30 ? e = 100 : t >= 30 && t < 40 ? e = 90 : t >= 40 && t <= 50 ? e = 80 : e = 70, `${e}px`;
}, u0 = q.div.withConfig({
  displayName: "MainWrapper",
  componentId: "sc-ijbxtw-0"
})(["position:relative;width:100%;height:100%;font-family:Lato;"]), f0 = q(pt).withConfig({
  displayName: "BackgroundImage",
  componentId: "sc-ijbxtw-1"
})(["width:100%;height:100%;object-fit:cover;"]), d0 = q.span.withConfig({
  displayName: "JobTitle",
  componentId: "sc-ijbxtw-2"
})(["font-size:", ";color:", ";line-height:1.6;background-color:", ";border-radius:30px 0 0 30px;padding:20px 30px;text-align:right;box-decoration-break:clone;&&&{font-family:", ",sans-serif;font-weight:700;}"], ({
  textSize: t,
  textLength: e
}) => t ? `${t}px` : c0(e), ({
  color: t
}) => t || "white", ({
  backgroundColor: t
}) => t || "white", ({
  fontFamily: t
}) => t || "Nunito"), m0 = q.div.withConfig({
  displayName: "TitleWrapper",
  componentId: "sc-ijbxtw-3"
})(["position:absolute;right:0;bottom:0;transform:translateY(-50%);text-align:right;min-width:75%;max-width:90%;"]), ga = (
  /** @type {const} */
  {
    type: "image",
    id: "LandscapeImage",
    preview: "/images/mediaTemplatePreviews/preview__LandscapeLogo.svg",
    label: "Landscape",
    height: Ie.landscape.height,
    width: Ie.landscape.width,
    aspectRatio: 1.91,
    orientation: "landscape",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [{
        key: "backgroundImage",
        type: "image",
        label: "Hintergrund Bild"
      }, {
        key: "logo",
        type: "image",
        label: "Logo",
        isLogo: !0
      }, {
        key: "logoPosition",
        type: "select",
        label: "Logo Position",
        options: It
      }, {
        key: "logoSize",
        type: "select",
        label: "Logo Size",
        options: At
      }, {
        key: "text",
        type: "text",
        label: "Teaser Text"
      }, {
        key: "primaryTextColor",
        type: "color",
        label: "Text Farbe"
      }, {
        key: "primaryBackgroundColor",
        type: "color",
        label: "Hintergrund Farbe"
      }]
    }]
  }
);
u.object({
  backgroundImage: u.string().url(),
  primaryTextColor: W().optional(),
  primaryBackgroundColor: W().optional(),
  textColor: W().optional(),
  backgroundColor: W().optional(),
  text: u.string().optional(),
  textSize: u.number().default(80).optional(),
  logo: u.string().url().optional(),
  logoFormat: u.enum(["square", "landscape"]).optional(),
  logoPosition: u.enum(["top-left", "top-right", "bottom-left", "bottom-right"]).optional(),
  logoSize: u.enum(["small", "mid", "big"]).optional(),
  width: u.number().optional(),
  isVideo: u.boolean().default(!1).optional(),
  fontFamily: u.string().optional(),
  customFont: u.object({
    name: u.string(),
    url: u.string()
  }).optional()
});
const p0 = ({
  backgroundImage: t,
  primaryTextColor: e,
  primaryBackgroundColor: a,
  textColor: n,
  backgroundColor: i,
  text: o,
  textSize: s,
  logo: r,
  logoFormat: c = "square",
  logoPosition: l = "top-left",
  logoSize: f = "mid",
  width: m,
  isVideo: v = !1,
  fontFamily: k = "Nunito",
  customFont: C
}) => {
  const E = m / ga.aspectRatio, b = Wt(ga.width, ga.height, m, E);
  qt(k, C);
  const D = (C == null ? void 0 : C.name) === k, j = Lt(D ? null : k), x = D ? k : j, _ = t ? /* @__PURE__ */ h.jsx(f0, { src: t }) : null, y = o ? /* @__PURE__ */ h.jsx(m0, { children: /* @__PURE__ */ h.jsx(d0, { color: n || e, backgroundColor: i || a, textSize: s, textLength: o == null ? void 0 : o.length, fontFamily: x, children: Kt(o) }) }) : null, H = /* @__PURE__ */ h.jsxs(u0, { children: [
    /* @__PURE__ */ h.jsx(la, { logo: r, logoPosition: l, elementSize: f, logoFormat: c, orientation: "landscape" }),
    _,
    y
  ] });
  return v ? H : /* @__PURE__ */ h.jsx(Yt, { originalWidth: ga.width, originalHeight: ga.height, scaleFactor: b, children: H });
}, h0 = (t) => {
  let e;
  return t < 30 ? e = 85 : t >= 30 && t < 40 ? e = 80 : t >= 40 && t <= 50 ? e = 75 : e = 70, `${e}px`;
}, g0 = q.div.withConfig({
  displayName: "MainWrapper",
  componentId: "sc-aymng-0"
})(["position:relative;width:100%;height:100%;font-family:Lato,sans-serif;"]), b0 = q(pt).withConfig({
  displayName: "BackgroundImage",
  componentId: "sc-aymng-1"
})(["width:100%;height:100%;object-fit:cover;"]), y0 = q.span.withConfig({
  displayName: "JobTitle",
  componentId: "sc-aymng-2"
})(["font-size:", ";color:", ";line-height:1.6;background-color:", ";border-radius:30px 0 0 30px;padding:25px 40px;text-align:right;box-decoration-break:clone;&&&{font-family:", ",sans-serif;font-weight:700;}"], ({
  textSize: t,
  textLength: e
}) => t ? `${t}px` : h0(e), ({
  color: t
}) => t || "white", ({
  backgroundColor: t
}) => t || "white", ({
  fontFamily: t
}) => t || "Nunito"), v0 = q.div.withConfig({
  displayName: "TitleWrapper",
  componentId: "sc-aymng-3"
})(["position:absolute;right:0;bottom:0;transform:translateY(-80%);text-align:right;min-width:75%;max-width:95%;"]), ba = (
  /** @type {const} */
  {
    type: "image",
    id: "VerticalImage",
    preview: "/images/mediaTemplatePreviews/preview__ImageLogo.svg",
    label: "Vertical",
    height: Ie.vertical.height,
    width: Ie.vertical.width,
    aspectRatio: 0.5625,
    orientation: "vertical",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [{
        key: "backgroundImage",
        type: "image",
        label: "Hintergrund Bild"
      }, {
        key: "logo",
        type: "image",
        label: "Logo",
        isLogo: !0
      }, {
        key: "logoPosition",
        type: "select",
        label: "Logo Position",
        options: It
      }, {
        key: "logoSize",
        type: "select",
        label: "Logo Size",
        options: At
      }, {
        key: "text",
        type: "text",
        label: "Teaser Text"
      }, {
        key: "primaryTextColor",
        type: "color",
        label: "Text Farbe"
      }, {
        key: "primaryBackgroundColor",
        type: "color",
        label: "Hintergrund Farbe"
      }]
    }]
  }
);
u.object({
  backgroundImage: u.string().url(),
  primaryTextColor: W().optional(),
  primaryBackgroundColor: W().optional(),
  textColor: W().optional(),
  backgroundColor: W().optional(),
  text: u.string().optional(),
  textSize: u.number().default(80).optional(),
  logo: u.string().url().optional(),
  logoFormat: u.enum(["square", "landscape"]).optional(),
  logoPosition: u.enum(["top-left", "top-right", "bottom-left", "bottom-right"]).optional(),
  logoSize: u.enum(["small", "mid", "big"]).optional(),
  width: u.number().default(400).optional(),
  isVideo: u.boolean().default(!1).optional(),
  fontFamily: u.string().optional(),
  customFont: u.object({
    name: u.string(),
    url: u.string()
  }).optional()
});
const k0 = ({
  backgroundImage: t,
  logo: e,
  primaryTextColor: a,
  primaryBackgroundColor: n,
  textColor: i,
  backgroundColor: o,
  text: s,
  textSize: r,
  logoFormat: c = "square",
  logoPosition: l = "top-left",
  logoSize: f = "mid",
  width: m,
  isVideo: v = !1,
  fontFamily: k = "Nunito",
  customFont: C
}) => {
  const E = m / ba.aspectRatio, b = Wt(ba.width, ba.height, m, E);
  qt(k, C);
  const D = C && C.name === k, j = Lt(D ? null : k), x = D ? k : j, _ = t ? /* @__PURE__ */ h.jsx(b0, { src: t }) : null, y = s ? /* @__PURE__ */ h.jsx(v0, { children: /* @__PURE__ */ h.jsx(y0, { color: i || a, backgroundColor: o || n, textSize: r, textLength: s == null ? void 0 : s.length, fontFamily: x, children: Kt(s) }) }) : null, H = /* @__PURE__ */ h.jsxs(g0, { children: [
    /* @__PURE__ */ h.jsx(la, { logo: e, logoPosition: l, elementSize: f, logoFormat: c, orientation: "vertical" }),
    _,
    y
  ] });
  return v ? H : /* @__PURE__ */ h.jsx(Yt, { originalWidth: ba.width, originalHeight: ba.height, scaleFactor: b, children: H });
}, {
  fontFamily: Qi
} = os(), w0 = [{
  max: 30,
  size: 80
}, {
  max: 40,
  size: 74
}, {
  max: 50,
  size: 64
}, {
  max: 60,
  size: 60
}, {
  max: 1 / 0,
  size: 55
}], x0 = (t) => `${w0.find(({
  max: a
}) => t < a).size}px`, _0 = q.div.withConfig({
  displayName: "MainWrapper",
  componentId: "sc-1anl81e-0"
})(["position:relative;width:100%;height:100%;border-radius:inherit;z-index:0;overflow:hidden;aspect-ratio:0.56;"]);
q.div.withConfig({
  displayName: "LogoWrapper",
  componentId: "sc-1anl81e-1"
})(["position:absolute;height:15%;top:", "%;left:", "%;width:60%;z-index:1;display:flex;"], ({
  logoVertical: t
}) => t || 2, ({
  logoHorizontal: t
}) => t || 2);
q(pt).withConfig({
  displayName: "LogoImage",
  componentId: "sc-1anl81e-2"
})(["object-fit:contain;max-width:100%;max-height:100%;flex-grow:1;align-self:start;object-position:left;"]);
const F0 = q.div.withConfig({
  displayName: "SpeechContainer",
  componentId: "sc-1anl81e-3"
})(["position:relative;width:100%;height:100%;display:flex;justify-content:center;align-items:center;svg{position:absolute;height:auto;width:70%;z-index:5;top:", "%;left:", "%;transform:translate(-50%,-50%);}"], ({
  blobVertical: t
}) => t, ({
  blobHorizontal: t
}) => t), C0 = q.div.withConfig({
  displayName: "TextContent",
  componentId: "sc-1anl81e-4"
})(["position:absolute;z-index:6;width:100%;top:", "%;left:", "%;transform:translate(-50%,-50%);text-align:center;width:50%;max-height:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:0.4rem;"], ({
  textBoxVertical: t
}) => t, ({
  textBoxHorizontal: t
}) => t), z0 = q.h2.withConfig({
  displayName: "Header",
  componentId: "sc-1anl81e-5"
})(["z-index:4;margin:0;color:", ";text-align:center;text-wrap:balance;opacity:0.7;", " &&&{font-family:", ",", ",sans-serif;font-weight:300;}"], ({
  headerColor: t
}) => t, ({
  headerSize: t
}) => Se(["font-size:", ";letter-spacing:2px;"], t ? `${t}rem` : "calc(2.8rem + 0.390625vw)"), ({
  fontFamily: t
}) => t || "Roboto", Qi), E0 = q.p.withConfig({
  displayName: "Title",
  componentId: "sc-1anl81e-6"
})(["z-index:4;margin:0;color:", ";text-align:center;text-wrap:pretty;width:100%;line-height:1.2;letter-spacing:normal;font-size:", ";&&&{font-family:", ",", ",sans-serif;font-weight:700;}"], ({
  color: t
}) => t, ({
  textLength: t,
  titleSize: e
}) => e || x0(t), ({
  fontFamily: t
}) => t || "Roboto", Qi);
q.p.withConfig({
  displayName: "CtaComponent",
  componentId: "sc-1anl81e-7"
})(["color:#000000;background-color:#ffffff;z-index:3;position:absolute;left:50%;bottom:2%;transform:translate(-50%,-2%);font-family:", ",", ",sans-serif;max-width:90%;margin:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:1rem 4rem;border-radius:1.2rem;letter-spacing:1px;", ";"], ({
  fontFamily: t
}) => t || "Roboto", Qi, ({
  CTASize: t
}) => Se(["font-size:", ";"], t ? `${t}rem` : "4.2rem"));
const T0 = q.div.withConfig({
  displayName: "WaveBackground",
  componentId: "sc-1anl81e-8"
})(["z-index:2;position:absolute;border-radius:inherit;left:0;bottom:0;height:100%;width:100%;background-color:", ";", ";"], ({
  waveColor: t
}) => t, ({
  clip: t
}) => t), j0 = ({
  blobColor: t
}) => /* @__PURE__ */ h.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", version: "1.1", viewBox: "0 0 600 600", children: /* @__PURE__ */ h.jsx("path", { d: "M23.560209274291992,353.7958068847656C25.654450098673504,421.20418548583984,39.005233446756996,532.9842987060547,102.87957763671875,572.1204223632812C166.7539218266805,611.2565460205078,326.4397786458333,610.0785166422526,406.8062744140625,588.612548828125C487.1727701822917,567.1465810139974,555.4973958333334,506.1518376668294,585.0785522460938,443.3246154785156C614.6597086588541,380.49739329020184,613.2199198404948,284.68586627642316,584.293212890625,211.6492156982422C555.3665059407552,138.61256512006122,457.7225036621094,21.72774871190389,411.518310546875,5.104712009429932C365.3141174316406,-11.518324693044026,360.60208384195965,84.81675569216411,307.06805419921875,111.91099548339844C253.53402455647787,139.00523527463278,137.56544017791748,127.35601552327475,90.31413269042969,167.67015075683594C43.062825202941895,207.98428599039713,21.46596844991048,286.3874282836914,23.560209274291992,353.7958068847656C25.654450098673504,421.20418548583984,39.005233446756996,532.9842987060547,102.87957763671875,572.1204223632812", fill: t, transform: "matrix(0.9974999999999999,0,0,0.9975000000000002,-14.240338554382333,-2.5668666279316312)" }) });
u.object({
  amplitude: u.number(),
  frequency: u.number(),
  height: u.number(),
  offset: u.number(),
  phase: u.number()
});
const U0 = ({
  amplitude: t,
  frequency: e,
  height: a,
  offset: n,
  phase: i
}) => {
  const s = i * Math.PI / 180, r = 2 * Math.PI * e / 50;
  let c = "clip-path: polygon(100% 100%, 0% 100%";
  for (let l = 0; l <= 50; l++) {
    const m = ((n + t * Math.cos(l * r + s)) / a * 100).toFixed(2), v = (l * 100 / 50).toFixed(2);
    c += `, ${v}% ${m}%`;
  }
  return c += ");", c;
}, ya = (
  /** @type {const} */
  {
    type: "image",
    id: "ShapeImage",
    preview: "/images/mediaTemplatePreviews/preview__ImageLogoText.svg",
    label: "Shape",
    height: 1920,
    width: 1080,
    aspectRatio: 0.5625,
    orientation: "vertical",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [{
        key: "backgroundImage",
        type: "image",
        label: "Hintergrund Bild"
      }, {
        key: "logo",
        type: "image",
        label: "Logo",
        isLogo: !0
      }, {
        key: "text",
        type: "text",
        label: "Title"
      }, {
        key: "secondaryText",
        type: "text",
        label: "Überschrift"
      }, {
        key: "CTAText",
        type: "text",
        label: "CTA"
      }, {
        key: "primaryTextColor",
        type: "color",
        label: "Text Farbe"
      }, {
        key: "primaryBackgroundColor",
        type: "color",
        label: "Hintergrund Farbe"
      }, {
        key: "secondaryBackgroundColor",
        type: "color",
        label: "Sekundär Farbe"
      }]
    }]
  }
), S0 = q.div.withConfig({
  displayName: "ImgWrapper",
  componentId: "sc-nmyvqy-0"
})(["position:absolute;top:0;height:100%;width:100%;z-index:2;border-radius:inherit;", ";img{width:100%;height:100%;object-fit:cover;object-position:", ";transform:scale(", ");}"], ({
  orientation: t,
  height: e
}) => t === "landscape" ? Se(["right:0;width:68%;"]) : t === "portrait" ? Se(["right:0;width:63%;"]) : Se(["height:", ";left:0;"], e || "70%"), ({
  imageHorizontal: t,
  imageVertical: e
}) => t && e ? `${t}% ${e}%` : "center", ({
  zoom: t
}) => t || 1), A0 = q(Vn).withConfig({
  displayName: "VideoRemotionPlayer",
  componentId: "sc-nmyvqy-1"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:100%;object-fit:cover;"]), xs = ({
  src: t,
  orientation: e,
  imageVertical: a,
  imageHorizontal: n,
  zoom: i,
  height: o,
  isVideo: s
}) => t ? /* @__PURE__ */ h.jsx(S0, { orientation: e, imageVertical: a, imageHorizontal: n, zoom: i, height: o, children: s ? /* @__PURE__ */ h.jsx(A0, { src: t, alt: "background video" }) : /* @__PURE__ */ h.jsx(pt, { src: t, alt: "background image" }) }) : null, I0 = ({
  size: t = 20,
  color: e = "#198E93"
}) => /* @__PURE__ */ h.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: t, height: t, viewBox: "0 0 24 24", fill: "none", stroke: e, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", style: {
  minWidth: `${t}px`,
  minHeight: `${t}px`
}, children: [
  /* @__PURE__ */ h.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
  /* @__PURE__ */ h.jsx("path", { d: "M9 15l6 -6" }),
  /* @__PURE__ */ h.jsx("path", { d: "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" }),
  /* @__PURE__ */ h.jsx("path", { d: "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" })
] }), D0 = (t) => {
  t = t.replace(/^#/, "");
  let e = parseInt(t.substring(0, 2), 16), a = parseInt(t.substring(2, 4), 16), n = parseInt(t.substring(4, 6), 16);
  return (0.2126 * e + 0.7152 * a + 0.0722 * n) / 255 > 0.85;
}, B0 = q.div.withConfig({
  displayName: "CtaComponent",
  componentId: "sc-ymloev-0"
})(["color:#121214;background-color:#ffffff;position:absolute;left:50%;bottom:0;transform:translate(-50%,0);display:flex;flex-direction:row;gap:15px;align-items:center;font-family:Roboto,sans-serif;font-weight:500;margin-bottom:80px;padding:20px 42px;border-radius:30px;z-index:4;p{margin:0;white-space:nowrap;max-width:90%;overflow:hidden;text-overflow:ellipsis;letter-spacing:1px;font-weight:normal;", ";}"], ({
  CTASize: t
}) => Se(["font-size:", ";"], t || "54px")), eo = ({
  CTASize: t,
  CTAText: e,
  blobColor: a,
  orientation: n
}) => {
  if (!e || n !== "vertical")
    return null;
  const i = D0(a) ? "#121214" : a;
  return /* @__PURE__ */ h.jsxs(B0, { CTASize: t, children: [
    /* @__PURE__ */ h.jsx(I0, { size: 78, color: i }),
    /* @__PURE__ */ h.jsx("p", { children: e })
  ] });
};
u.object({
  backgroundImage: u.string().url(),
  secondaryText: u.string().default("Bist du bereit?").optional(),
  text: u.string().optional(),
  titleSize: u.number().default(4).optional(),
  headerSize: u.number().default(3).optional(),
  CTAText: u.string().optional(),
  CTASize: u.number().default(4).optional(),
  blobSize: u.number().default(70).optional(),
  primaryTextColor: W().optional(),
  primaryBackgroundColor: W().optional(),
  secondaryBackgroundColor: W().optional(),
  titleColor: W().optional(),
  blobColor: W().optional(),
  waveColor: W().optional(),
  textBoxVertical: u.number().default(55).optional(),
  textBoxHorizontal: u.number().default(50).optional(),
  blobVertical: u.number().default(35).optional(),
  blobHorizontal: u.number().default(50).optional(),
  width: u.number().default(400).optional(),
  fontFamily: u.string().optional(),
  customFont: u.object({
    name: u.string(),
    url: u.string()
  }).optional()
});
const R0 = ({
  backgroundImage: t,
  text: e = "Wir suchen Dich",
  secondaryText: a = "Bist du bereit?",
  titleSize: n,
  headerSize: i,
  CTAText: o,
  CTASize: s,
  blobSize: r = 70,
  primaryTextColor: c = "#1e1e1e",
  primaryBackgroundColor: l,
  secondaryBackgroundColor: f = "#ebebeb",
  titleColor: m,
  waveColor: v,
  blobColor: k,
  textBoxVertical: C = 55,
  textBoxHorizontal: E = 50,
  blobVertical: b = 52,
  blobHorizontal: D = 50,
  width: j,
  fontFamily: x = "Nunito",
  customFont: _,
  // wave props - non customizable
  amplitude: y = 35,
  frequency: H = 0.6,
  height: $ = 580,
  offset: Y = 300,
  phase: ae = -20
}) => {
  const ve = m || c, de = v || l, N = k || f, P = j / ya.aspectRatio, M = Wt(ya.width, ya.height, j, P);
  qt(x, _);
  const V = _ && _.name === x, be = Lt(V ? null : x), Z = V ? x : be, oe = (a == null ? void 0 : a.length) > 0, ke = (e == null ? void 0 : e.length) > 0, we = () => !e && !a ? null : /* @__PURE__ */ h.jsxs(F0, { blobVertical: b, blobHorizontal: D, textLength: e == null ? void 0 : e.length, blobSize: r, children: [
    /* @__PURE__ */ h.jsx(j0, { blobColor: N }),
    /* @__PURE__ */ h.jsxs(C0, { textBoxVertical: C, textBoxHorizontal: E, children: [
      oe && /* @__PURE__ */ h.jsx(z0, { headerColor: ve, headerSize: i, fontFamily: Z, children: a }),
      ke && /* @__PURE__ */ h.jsx(E0, { color: ve, textLength: e == null ? void 0 : e.length, titleSize: n, fontFamily: Z, children: Kt(e) })
    ] })
  ] }), re = /* @__PURE__ */ h.jsx(T0, { clip: U0({
    amplitude: y,
    frequency: H,
    height: $,
    offset: Y,
    phase: ae
  }), waveColor: de });
  return /* @__PURE__ */ h.jsx(Yt, { originalWidth: ya.width, originalHeight: ya.height, scaleFactor: M, children: /* @__PURE__ */ h.jsxs(_0, { children: [
    we(),
    /* @__PURE__ */ h.jsx(eo, { CTASize: s, CTAText: o, blobColor: de, orientation: "vertical" }),
    /* @__PURE__ */ h.jsx(xs, { src: t, orientation: "vertical", height: "60%" }),
    re
  ] }) });
}, O0 = ({
  blobColor: t,
  orientation: e
}) => e === "portrait" ? /* @__PURE__ */ h.jsxs("svg", { width: "163", height: "147", viewBox: "0 0 163 147", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ h.jsx("path", { d: "M129.317 68.8077C129.317 101.725 116.917 128.898 85.3492 128.898C53.7813 128.898 15 101.725 15 68.8077C15 35.8908 40.8924 18 72.1587 18C103.425 18 129.317 35.8908 129.317 68.8077Z", fill: t }),
  /* @__PURE__ */ h.jsx("path", { d: "M136.435 84.86C142.779 82.7731 147.14 74.5419 144.197 74.4213C134.704 74.0323 129.456 74.489 125.794 58.5097C122.977 63.6097 110.468 86.1427 112.277 89.7372C114.537 94.2304 128.505 87.4687 136.435 84.86Z", fill: t })
] }) : e === "landscape" ? /* @__PURE__ */ h.jsxs("svg", { width: "143", height: "131", viewBox: "0 0 143 131", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ h.jsx("path", { d: "M117.356 61.6214C117.356 90.8062 106.362 114.898 78.3731 114.898C50.3844 114.898 16 90.8062 16 61.6214C16 32.4365 38.9568 16.5741 66.6782 16.5741C94.3996 16.5741 117.356 32.4365 117.356 61.6214Z", fill: t }),
  /* @__PURE__ */ h.jsx("path", { d: "M119.606 88.6418C125.231 86.7915 129.097 79.4936 126.488 79.3867C118.071 79.0417 113.418 79.4467 110.171 65.2791C107.674 69.8008 96.5832 89.7791 98.1866 92.9661C100.191 96.9498 112.575 90.9547 119.606 88.6418Z", fill: t })
] }) : /* @__PURE__ */ h.jsxs("svg", { viewBox: "0 0 172 187", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ h.jsx("path", { d: "M151.269 97.4808C151.269 135.057 137.113 166.077 101.077 166.077C65.0402 166.077 20.769 135.057 20.769 97.4808C20.769 59.9042 50.3267 39.4808 86.019 39.4808C121.711 39.4808 151.269 59.9042 151.269 97.4808Z", fill: t }),
  /* @__PURE__ */ h.jsx("path", { d: "M110.558 30.0156C107.881 22.8771 98.2885 18.2885 98.2885 21.6502C98.2885 32.4958 99.0548 38.4607 81 43.3847C86.9487 46.3591 113.235 59.5733 117.25 57.3425C122.269 54.5541 113.904 38.9386 110.558 30.0156Z", fill: t })
] });
function P0(t) {
  let e = !1;
  return () => {
    e || (e = !0, requestAnimationFrame(() => {
      t(), e = !1;
    }));
  };
}
const _s = ({
  fontSizePx: t,
  minFontSizePx: e,
  fontSizePrecisionPx: a,
  updateFontSizePx: n,
  breakPredicate: i
}) => {
  const o = Math.ceil(1 / a);
  let s = 0;
  for (; t > e && s < o && !i(); )
    t = n(t - a), s++;
}, ia = (t) => {
  const e = getComputedStyle(t);
  return t.clientWidth - parseFloat(e.paddingLeft) - parseFloat(e.paddingRight);
}, Bn = (t) => {
  const e = getComputedStyle(t);
  return t.clientHeight - parseFloat(e.paddingTop) - parseFloat(e.paddingBottom);
}, N0 = (t) => {
  t.innerEl.style.whiteSpace = "nowrap", Fs(t), t.innerEl.scrollWidth > ia(t.containerEl) && (t.innerEl.style.whiteSpace = "normal");
}, Fs = ({
  innerEl: t,
  containerEl: e,
  fontSizePx: a,
  minFontSizePx: n,
  maxFontSizePx: i,
  fontSizePrecisionPx: o,
  updateFontSizePx: s
}) => {
  let c = 0, l = 1;
  for (; c < 10; ) {
    const f = t.scrollWidth, m = ia(e), v = a < i && f < m, k = a > n && f > m, C = f / m;
    if (l === C || !(v || k))
      break;
    const E = a / C - a, b = a;
    if (a = s(a + E), Math.abs(a - b) <= o)
      break;
    l = C, c++;
  }
  _s({
    fontSizePx: a,
    minFontSizePx: n,
    updateFontSizePx: s,
    fontSizePrecisionPx: o,
    breakPredicate: () => t.scrollWidth <= ia(e)
  });
}, Ko = ({
  innerEl: t,
  containerEl: e,
  fontSizePx: a,
  minFontSizePx: n,
  maxFontSizePx: i,
  fontSizePrecisionPx: o,
  updateFontSizePx: s
}) => {
  t.style.wordBreak = "keep-all", t.style.overflowWrap = "normal";
  const r = 100;
  a = s((i - n) * 0.5);
  let c = (i - n) * 0.25, l = 0;
  for (; c > o && l < r; ) {
    const f = t.scrollWidth, m = ia(e), v = t.scrollHeight, k = Bn(e);
    if (f === m && v === k) break;
    a < i && f <= m && v <= k ? a = s(a + c) : a > n && (f > m || v > k) && (a = s(a - c)), c *= 0.5, l++;
  }
  _s({
    fontSizePx: a,
    minFontSizePx: n,
    updateFontSizePx: s,
    fontSizePrecisionPx: o,
    breakPredicate: () => t.scrollWidth <= ia(e) && t.scrollHeight <= Bn(e)
  });
};
function M0({
  innerEl: t,
  containerEl: e,
  mode: a = "multiline",
  minFontSizePx: n = 20,
  maxFontSizePx: i = 150,
  fontSizePrecisionPx: o = 0.1
}) {
  if (!isFinite(n))
    throw new Error(`Invalid minFontSizePx (${n})`);
  if (!isFinite(n))
    throw new Error(`Invalid maxFontSizePx (${i})`);
  if (!isFinite(o) || o === 0)
    throw new Error(`Invalid fontSizePrecisionPx (${o})`);
  e.children.length > 1 && console.warn(`AutoTextSize has ${e.children.length - 1} siblings. This may interfere with the algorithm.`);
  const s = {
    // Necessary to correctly compute the dimensions `innerEl`.
    display: "flex",
    alignItems: "flex-start"
  }, r = {
    display: "block"
    // Necessary to compute dimensions.
  };
  a === "oneline" ? r.whiteSpace = "nowrap" : a === "multiline" ? r.wordBreak = "break-word" : a === "box" ? (r.whiteSpace = "pre-wrap", r.wordBreak = "break-word") : a === "boxoneline" && (r.whiteSpace = "nowrap"), Object.assign(e.style, s), Object.assign(t.style, r);
  const c = window.getComputedStyle(t, null).getPropertyValue("font-size");
  let l = parseFloat(c);
  const f = (v) => (v = Math.min(Math.max(v, n), i), l = v, t.style.fontSize = `${l}px`, l);
  (l > i || l < n) && f(l);
  const m = {
    innerEl: t,
    containerEl: e,
    fontSizePx: l,
    minFontSizePx: n,
    maxFontSizePx: i,
    fontSizePrecisionPx: o,
    updateFontSizePx: f
  };
  a === "oneline" ? Fs(m) : a === "multiline" ? N0(m) : (a === "box" || a === "boxoneline") && Ko(m);
}
function V0({
  innerEl: t,
  containerEl: e,
  mode: a,
  minFontSizePx: n,
  maxFontSizePx: i,
  fontSizePrecisionPx: o
}) {
  let s;
  const r = P0(() => {
    M0({
      innerEl: t,
      containerEl: e,
      mode: a,
      maxFontSizePx: i,
      minFontSizePx: n,
      fontSizePrecisionPx: o
    }), s = [ia(e), Bn(e)];
  }), c = new ResizeObserver(() => {
    const l = s;
    s = [ia(e), Bn(e)], ((l == null ? void 0 : l[0]) !== s[0] || (l == null ? void 0 : l[1]) !== s[1]) && r();
  });
  return c.observe(e), r.disconnect = () => c.disconnect(), r;
}
function Kn({
  mode: t,
  minFontSizePx: e,
  maxFontSizePx: a,
  fontSizePrecisionPx: n,
  as: i = "div",
  children: o,
  ...s
}) {
  const r = Nt();
  kt(() => {
    var l;
    return (l = r.current) == null ? void 0 : l.call(r);
  }, [o]);
  const c = $o((l) => {
    var m;
    (m = r.current) == null || m.disconnect();
    const f = l == null ? void 0 : l.parentElement;
    !l || !f || (r.current = V0({
      innerEl: l,
      containerEl: f,
      mode: t,
      minFontSizePx: e,
      maxFontSizePx: a,
      fontSizePrecisionPx: n
    }));
  }, [t, e, a, n]);
  return /* @__PURE__ */ h.jsx(i, { ref: c, ...s, children: o });
}
const X0 = (t) => t === "portrait" ? 60 : t === "landscape" ? 40 : 34, K0 = (t) => t === "portrait" ? {
  size: 560,
  boxMargins: "200px 3px 3px 120px"
} : t === "landscape" ? {
  size: 380,
  boxMargins: "70px 3px 3px 190px"
} : {
  size: 320,
  boxMargins: "130px 3px 3px 90px"
}, Lo = {
  portrait: [
    {
      max: 20,
      size: 115
    },
    // Meiterbeiter (m/w/d)
    {
      max: 30,
      size: 100
    },
    // frontend developer (m/w/d)
    {
      max: 40,
      size: 93
    },
    // Elektroniker:in für Betriebs-technik
    {
      max: 50,
      size: 76
    },
    // Stellvertretende:r Werksleiter:in Champignonzucht
    {
      max: 60,
      size: 73
    },
    // Referent (alle Menschen) für Norm- und Verbandsarbeit
    {
      max: 1 / 0,
      size: 65
    }
    // Vertriebsmanager*in mit regionaler Gebietsverantwortung (w/m/d)
  ],
  landscape: [{
    max: 20,
    size: 80
  }, {
    max: 30,
    size: 72
  }, {
    max: 40,
    size: 64
  }, {
    max: 50,
    size: 50
  }, {
    max: 60,
    size: 47
  }, {
    max: 1 / 0,
    size: 40
  }],
  vertical: [{
    max: 20,
    size: 70
  }, {
    max: 30,
    size: 60
  }, {
    max: 40,
    size: 53
  }, {
    max: 50,
    size: 48
  }, {
    max: 60,
    size: 46
  }, {
    max: 1 / 0,
    size: 36
  }]
}, L0 = (t = 30, e) => (Lo[e] || Lo.landscape).find(({
  max: i
}) => t <= i).size, q0 = q.div.withConfig({
  displayName: "TextPositioner",
  componentId: "sc-13mm52b-0"
})(["position:absolute;z-index:12;display:flex;flex-direction:column;", " > svg{position:absolute;top:0;left:0;width:100%;height:100%;transform:scale(1.4);filter:drop-shadow(0px 0px 75px rgba(0,0,0,0.49));z-index:1;}"], ({
  orientation: t
}) => Se(t === "portrait" ? ["height:1050px;width:890px;left:180px;bottom:390px;"] : t === "landscape" ? ["height:550px;width:800px;left:180px;bottom:200px;"] : ["width:486px;height:540px;right:95px;bottom:400px;"])), Cs = q.p.withConfig({
  displayName: "TextHeader",
  componentId: "sc-13mm52b-1"
})(["opacity:0.7;font-weight:400;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:95%;flex-shrink:0;font-size:", ";line-height:1.3;font-family:", ',"Rubik",sans-serif;&&&{font-family:', ',"Rubik",sans-serif;}'], ({
  headerSize: t,
  headerHeight: e
}) => t || `${e}px`, ({
  fontFamily: t
}) => t, ({
  fontFamily: t
}) => t), zs = q.h1.withConfig({
  displayName: "Title",
  componentId: "sc-13mm52b-2"
})(["line-height:1.2;font-weight:500;overflow-wrap:break-word;font-family:", ',"Rubik",sans-serif;&&&{font-family:', ',"Rubik",sans-serif;}'], ({
  fontFamily: t
}) => t, ({
  fontFamily: t
}) => t), Es = q.div.withConfig({
  displayName: "TitleContainer",
  componentId: "sc-13mm52b-3"
})(["width:100%;"]), W0 = q.div.withConfig({
  displayName: "TextBox",
  componentId: "sc-13mm52b-4"
})(["display:flex;flex-direction:column;justify-content:center;z-index:2;gap:15px;text-align:left;", " ", ",", "{color:", ";margin:0;font-style:normal;}", "{height:", ";margin-top:", ";}"], ({
  boxMargins: t,
  size: e
}) => Se(["margin:", ";height:", "px;width:", "px;"], t, e, e), zs, Cs, ({
  color: t
}) => t, Es, ({
  headerHeight: t,
  size: e
}) => `${e - t - 50}px`, ({
  headerLength: t,
  headerHeight: e
}) => t === 0 ? `${e}px` : "0");
var Ts = { exports: {} };
(function(t) {
  (function(e, a) {
    t.exports ? t.exports = a() : e.createHyphenator = a();
  })(va, function() {
    function e(N) {
      var P = "", M = "", V = 0, be = N();
      return function(Z) {
        for (; V < Z.length; ) {
          P = Z.charAt(V++), M = Z.charAt(V);
          var oe = be(P, M);
          if (oe !== void 0)
            return oe;
        }
      };
    }
    var a = RegExp.prototype.test.bind(
      /\s|(?![\'])[\!-\@\[-\`\{-\~\u2013-\u203C]/
    );
    function n() {
      var N = !1;
      return function(P, M) {
        return N ? M[0] === ">" && (P(), N = !1) : M[0] === "<" && (!a(M[1]) || M[1] === "/") && (N = !0), N;
      };
    }
    function i(N) {
      var P = !1;
      return function(M, V) {
        return P ? !a(V[0]) && a(V[1]) && (M(), P = !1) : !a(V[0]) && V[1] === N && (P = !0), P;
      };
    }
    function o(N, P) {
      return function() {
        var M = "", V = "";
        function be() {
          M += V, V = "";
        }
        function Z(oe) {
          return M = "", V = "", oe;
        }
        return function(oe, ke) {
          V += oe;
          var we = N.reduce(function(re, A) {
            return re || A(be, [oe, ke]);
          }, !1);
          if (!we && (a(oe) && !a(ke) && be(), !a(oe) && a(ke))) {
            if (V.length >= P)
              return Z([M, V]);
            be();
          }
          if (ke === "")
            return (V.length < P || we) && be(), Z([M, V]);
        };
      };
    }
    function s(N) {
      var P = 0;
      function M() {
        return N[P++];
      }
      return M;
    }
    function r(N) {
      var P = 0, M = N;
      function V() {
        if (M = N.slice(P++), !(M.length < 3))
          return M;
      }
      function be() {
        return P === 2;
      }
      return [V, be];
    }
    function c(N, P, M, V, be) {
      for (var Z = new Array(N.length + 1), oe = ("." + N.toLocaleLowerCase() + ".").split(""), ke, we, re, A, w, I, B = -1, g, ne, z, me, Q = Z.length; Q--; ) Z[Q] = 0;
      for (g = r(oe), ne = g[0], z = g[1]; ke = ne(); )
        for (B++, z() && B--, re = M, me = s(ke); (we = me()) && (A = re[we]) !== void 0; ) {
          switch (re = {}, w = -1, Object.prototype.toString.call(A)) {
            case "[object Array]":
              re = A[0], w = A[1];
              break;
            case "[object Object]":
              re = A;
              break;
            case "[object Number]":
              w = A;
              break;
          }
          if (!(w < 0)) {
            P[w].splice || (P[w] = P[w].slice("")), I = P[w];
            for (var G = 0; G < I.length; G++)
              Z[B + G] = Math.max(
                I[G],
                Z[B + G]
              );
          }
        }
      Z[0] = Z[1] = Z[Z.length - 1] = Z[Z.length - 2] = 0;
      for (var F = "", Q = 0; Q < Z.length; Q++)
        F += (Z[Q] % 2 === 1 ? be : "") + N.charAt(Q);
      return F;
    }
    function l(N, P, M, V, be, Z, oe, ke, we) {
      function re() {
        B(A);
      }
      var A = "", w, I = e(
        o(
          (oe ? [n()] : []).concat(
            i(Z)
          ),
          ke
        )
      ), B = function() {
      };
      function g() {
        for (var ne = /* @__PURE__ */ new Date(); (!we || /* @__PURE__ */ new Date() - ne < 10) && (w = I(N)); ) {
          if (w[1]) {
            var z = w[1].length ? "~" + w[1] : "";
            V[z] === void 0 && (V[z] = c(
              w[1],
              P,
              M,
              be,
              Z
            )), w[1] = V[z];
          }
          A += w[0] + w[1];
        }
        w ? setTimeout(g) : re();
      }
      return we ? (setTimeout(g), new Promise(function(ne) {
        B = ne;
      })) : (g(), A);
    }
    var f = !1, m = !1, v = [], k = !0, C = "­", E = 5, b = "async", D = "debug", j = "exceptions", x = "html", _ = "hyphenChar", y = "minWordLength", H = typeof va == "object" ? va : typeof window == "object" ? window : typeof self == "object" ? self : {};
    function $(N, P) {
      N = N || {};
      for (var M in P)
        N[M] = P[M];
      return N;
    }
    function Y(N) {
      return N instanceof Array;
    }
    function ae(N, P, M, V) {
      return P in N && (!V || V(N[P])) ? N[P] : M;
    }
    function ve(N, P) {
      return N.reduce(function(M, V) {
        return M["~" + V.replace(/\-/g, "")] = V.replace(
          /\-/g,
          P
        ), M;
      }, {});
    }
    function de(N, P) {
      P = P || {};
      var M = ae(
        P,
        b,
        f
      ), V = {}, be = ae(P, D, m), Z = {}, oe = ae(
        P,
        _,
        C
      ), ke = N[0].split(","), we = JSON.parse(N[1]), re = ae(
        P,
        y,
        E
      ) >> 0, A = ae(P, x, k), w = ae(
        P,
        j,
        v,
        Y
      ), I = oe + re;
      if (Z[I] = {}, N[2] && (Z[I] = ve(
        N[2],
        oe
      )), w && w.length && (Z[I] = $(
        Z[I],
        ve(w, oe)
      )), V[I] = $({}, Z[I]), M && !("Promise" in H))
        throw new Error(
          "Failed to create hyphenator: Could not find global Promise object, needed for hyphenator to work in async mode"
        );
      return function(B, g) {
        g = g || {};
        var ne = ae(g, D, be), z = ae(
          g,
          _,
          oe
        ), me = ae(g, y, re) >> 0, Q = ae(
          g,
          j,
          v,
          Y
        ), G = z + me;
        return !Z[G] && N[2] && (Z[G] = ve(
          N[2],
          z
        ), V[G] = $(V[G], Z[G])), Q && Q.length && (Z[G] = $(
          Z[G],
          ve(Q, z)
        ), V[G] = $(V[G], Z[G])), l(
          B,
          ke,
          we,
          V[G],
          ne,
          z,
          A,
          me,
          M
        );
      };
    }
    return de;
  });
})(Ts);
var Y0 = Ts.exports, bn = Y0, to = function(t) {
  return {
    hyphenate: bn(t, { async: !0 }),
    hyphenateHTML: bn(t, { async: !0, html: !0 }),
    hyphenateHTMLSync: bn(t, { html: !0 }),
    hyphenateSync: bn(t),
    patterns: t
  };
}, js = { exports: {} };
(function(t) {
  (function(e, a) {
    t.exports ? t.exports = a() : e.hyphenationPatternsDe1996 = a();
  })(va, function() {
    return [
      "001,003,0002,0032,0003,004,002,005,0000065,00034,00004,00021,0004,0001,0043,000006,0034,000003,0056,000004,0065,0021,00002,0023,006,00003,0006,00043,000656,0000006,00008,008,0012,00006,00000078,0005,00202,00032,0025,004304,007,0041,004004,00302,0033,00007,00065,0052,00001,00404,000808,00008708,0008,0000005,000005,00005,008008,00304,000065,00045,0060006,0000087,000000008,000007,0000008,0000808,00000008,00087,008007,0000506,000087,01,012,02,22,1,23,2,3,032,202,000202,03,00102,4,12,023,303,32,04,105,1032,101,21,02014,0403,2003,02002,4003,00041,00012,4001,0000004,43223,021,000002,43,203,2002,2021,00402,211,32021,0212,041,014,0078,02102,00232,00036,0014,00303,0434,0054,034,00212,00204,201,043,02104,343,0214,000001,004305,234,00441,00052,2001,000212,402,05,054,121,3032,40002,3214,103,34,20004,0000034,00214,0105,212,223,20002,20032,02004,02003,2004,000034,000041,232,00023,000021,06,04003,0600006,0232,00203,0503,324,0303,405,2032,002121,000008,00412,00434,2043,00074,2025,4032,00342,0234,00014,000074,00403,3002,321,41,252,0000043,1004,323,5,00054,02032,000304,0045,000434,3202,254,030004,250004,452,214,024,24,0000304,65,00343,0301,00605,006005,45,302,00323,0102,022,2012,403,6,4014,2034,4024,4004,0024,102,401,40304,304,205,0022,122,0402,00042,14,0204,0103,000078,0044,01002,00022,432,2302,21003,414,0000003,412,0000007,4304,00124,54,216,00234,25,03002,0302,2121,2103,004003,020002,03052,0007,000201,0605,000032,0008708,40323,4002,1023,00024,0421,006006,000506,0304,06506,000043,04004,00000005,300004,04143,10004,04002,0404,0121,0104,0324,00044,0202,08,000301,2404,00121,000412,016,0412,00000007,00101,03021,2105,2125,00201,305,301,6006,000323,000044,50003,434,1402,0101,00000006,2123,0000303,00432,00306,454,000045,0004303,20043,2102,00006006,421,056,0006506,3003,00056,03032,0506,000023,000205,06304,02001,0432,0122,06006,03023,065,02163,002102,0004004,0321,03212,04304,0306,0203,1202,0221,03214,03004,0006006,02142,000343,02302,033,0036,03003,040034,20421,087,00025,004321,000404,00063,00321,00078,000402,000124,21004,20232,2023,204,00000065,0414,000076,56,000203,3004,00506,000056,21002,04103,0323,4023,1022,0004304,000042,2124,0042,2144,30034,000234,00301,322,00000056,02324,002002,404,43002,03201,200002,52032,52,20034,4102,41002,30303,004002,632,004021,04104,025,052,32004,060506,0000000008,00104,00103,01003,23001,004005,000102,00632,002032,04102,222,1223,06005,00542,1002,1054,30002,004001,3034,10052,02103,0000404,3001,00221,20001,000054,74,341,143,3014,34052,0201,02321,01004,00061,61,07,000214,01034,400305,3402,5403,541,3204,243,042,7,40021,3404,306,4432,3023,3043,32032,2104,3005,30004,63,72,26,3012,436,0004003,00341,30102,124,02123,4104,00401,000432,063,000101,0502,030002,01054,0343,002303,20214,000232,000504,10023,104,000024,1041,1232,422,4344,02101",
      '{".":{"a":{"b":{"a":0,"l":1,"o":[{"l":1,"r":0},2],"s":3,"u":1},"d":{"e":{"n":4}},"e":1,"f":{"t":2},"g":{"r":5,"u":6},"i":{"s":6},"k":{"t":{"a":2}},"l":{"e":6,"k":1,"l":{"e":{"i":1,"n":7},"i":1},"s":{"e":1},"t":{"e":{"i":5,"l":5,"r":{"s":8}},"s":9,"u":5}},"m":{"p":{"e":10},"t":{"s":[{"c":12},11]}},"n":{"a":{"c":13,"t":14},"d":[{"e":{"n":{"k":15}}},3],"e":{"r":0},"g":[{"l":{"i":16},"o":1,"s":[{"t":17},10]},2],"i":{"s":2},"k":16,"n":{"a":1},"s":[{"i":{".":5}},3],"t":{"a":{"r":5}},"z":3},"p":{"p":{"l":{"e":{".":18}}}},"r":{"i":{"e":13},"k":{"a":3},"m":{"a":{"c":14},"u":{"n":5}},"s":{"c":6},"t":{"a":{"n":5},"e":{"i":14,"r":[{"h":20},19]},"r":21},"z":2},"s":{"b":{"e":22},"t":{"a":5,"r":1}},"t":{"a":13,"h":6,"r":5},"u":{"d":1,"f":14,"s":23,"ß":2},"x":6},"ä":{"m":1,"r":{"s":{"c":{"h":{"l":24}}}},"t":{"h":6,"s":6}},"b":{"a":{"h":{"n":[{"e":{"r":26}},25]},"l":{"t":4},"u":{"s":10}},"e":{"e":{"r":{"b":1}},"i":{"g":{"e":19}},"l":{"a":2},"r":{"a":3,"e":2,"g":{"a":27,"e":{"b":28},"r":27},"t":{"r":12}}},"i":{"o":{"s":5},"t":[{"a":13},6]},"l":{"a":{"u":25}},"o":{"g":{"e":[{"n":[{"s":29},17]},22]},"s":{"k":14}},"u":{"s":{"e":{"r":5}},"t":{"a":1}},"y":{"t":5}},"c":{"a":{"s":{"t":23}},"e":{"r":{"a":6}},"h":[{"a":{"r":{"m":{"e":{"s":30}}}},"i":{"e":{"r":4}}},24]},"d":{"a":{"b":12,"r":[{"i":{"n":4},"m":11},21],"t":{"e":{".":5,"s":5}}},"e":{"a":{"l":6},"i":[{"n":22},0],"l":{"o":1},"m":{"e":{"n":{"t":{"s":31}}}},"n":{"a":1,"k":{"a":12,"l":12,"o":12}},"o":32,"r":{"e":{"n":16}},"s":[{"k":1,"t":2},0]},"i":{"e":{"l":1,"n":[{"e":10,"s":{"t":[{"a":{"d":34}},33]}},5]}},"o":{"b":1,"m":{"o":6},"p":{"e":0},"r":{"f":11},"t":{"r":6}},"y":{"s":23}},"e":{"b":{"e":{"r":11}},"g":{"o":6},"h":{"e":[{"i":13,"n":35},6]},"i":{"e":3,"f":{"e":3},"k":1,"n":{"a":5,"d":4,"e":[{"b":4,"r":{"l":26}},36],"s":{"p":4}},"s":{"e":10,"p":6,"s":37,"t":38},"t":{"r":5}},"k":{"e":2,"l":{"i":1}},"l":{"a":6,"b":{"i":6,"l":6,"s":4},"f":{"e":{"i":5},"l":6}},"m":{"m":3},"n":[{"d":{"a":5,"e":{"r":39},"r":23,"s":4,"ü":5},"g":{"a":1,"l":6},"k":2,"n":[{"s":25},2],"t":[{"a":6,"e":{"i":5},"h":{"a":{"l":{"p":40}}},"i":{"o":5},"r":[{"o":{"p":7}},41],"s":10},4]},0],"r":{"b":{"e":{"i":5},"r":{"e":{"c":{"h":{"t":31}}}},"u":6},"d":{"a":{"n":5},"e":{"n":{"k":15},"r":14}},"e":[{"c":4,"m":6},0],"f":12,"i":0,"s":[{"t":{"e":{"i":{"n":31},"r":29},"r":{"i":{"t":{"t":{".":31,"e":{"n":{".":31}}}}}}}},2],"z":{"e":{"l":14,"n":42}}},"s":{"p":1,"t":{"a":43,"e":26,"h":1,"r":44}},"t":{"s":6},"u":[{"g":12,"r":12},1],"x":{"t":12}},"f":{"e":{"l":{"a":1},"r":{"n":{"o":12}}},"i":{"d":1,"e":{"s":{"t":1}},"l":{"e":{".":5,"n":5}},"s":6},"l":{"u":{"g":11}},"s":5,"u":{"s":{"c":6}}},"g":{"a":{"m":{"e":6},"n":{"g":{"a":12}},"s":[{"e":4,"p":5},21],"t":5},"d":6,"e":{"b":{"e":{"a":10},"l":2},"e":12,"l":{"b":{"r":27},"d":11,"u":1},"m":1,"n":{"a":{"r":7},"e":[{"c":{"k":{"e":45}}},16],"o":3},"r":{"a":16,"e":2,"o":1,"s":12},"s":{"a":1}},"l":{"a":{"n":[{"z":17},22]}},"o":{"l":{"d":{"e":{"r":26}}}},"s":5,"u":{"s":2}},"h":{"a":{"l":{"t":{"e":10}},"u":{"t":11}},"e":[{"b":{"e":{"i":5}},"f":{"e":1},"l":{"e":1},"r":{"a":{"n":14,"t":1},"b":{"r":{"a":46}},"e":{"r":1},"i":[{"n":{"n":20}},1]}},6],"i":{"n":{"u":4},"p":{"s":10},"s":5},"o":{"f":[{"e":{"n":5}},13],"m":{"e":{"t":5}}}},"i":{"a":5,"m":{"a":[{"g":{"e":12}},6],"m":47},"n":[{"d":2,"g":{"l":1},"k":2,"n":{"e":3},"s":{"k":1},"t":3,"u":13},0],"o":{"d":5,"n":{"i":48}},"r":{"e":4},"s":{"a":6,"t":{"a":1}},"t":{"h":6},"v":6},"j":{"o":{"n":{"i":48}}},"k":{"a":{"b":{"l":23},"i":6,"l":{"a":2,"e":1},"t":{"a":3,"i":[{"o":49},4]}},"i":{"e":5},"l":{"a":{"n":{"g":17}}},"o":{"b":1,"p":{"f":48},"r":{"d":{"a":12}}},"r":{"a":{"f":22}},"s":5,"u":{"s":2}},"l":{"a":{"b":{"e":1},"n":{"d":{"e":{"m":{"i":50}}}}},"e":{"a":{"r":5},"g":{"a":{"s":5}},"n":{"i":3}},"i":{"c":{"h":{"t":{"e":{"r":{"s":51}}}}},"f":6,"v":{"e":{".":5}}},"o":{"g":{"i":{"n":14}},"s":{"c":6,"s":9},"t":{"r":6},"v":{"e":{"r":1}}},"u":{"s":{"t":{"e":{"r":29},"r":12}},"t":{"h":2}},"y":{"s":23}},"m":{"a":{"d":1,"g":{"e":1},"l":{"e":12},"s":{"t":6},"t":{"c":12,"r":7,"u":25}},"d":6,"e":{"l":{"a":2},"n":{"e":1,"o":1,"s":{"c":{"h":{"l":52,"w":52}}}},"s":{"s":{"p":12}}},"i":{"f":6,"k":12,"l":{"z":11},"s":6,"t":41},"m":6,"u":{"t":{"t":{"e":{"r":53}}}}},"n":{"a":{"n":{"o":1},"t":1},"ä":{"s":{"c":13}},"e":{"b":{"e":{"n":10}},"r":{"f":2,"o":0},"s":6},"i":{"c":{"h":[{"t":{"e":54}},22]},"e":5,"k":{"l":16}},"o":{"t":{"h":6}},"u":{"l":2,"s":2}},"o":{"a":1,"b":{"a":0,"e":[{"r":{"e":{"i":55}}},2],"i":{"t":16}},"c":{"h":4},"f":{"e":6},"p":{"e":{"r":10}},"r":{"a":6,"d":{"e":12},"g":1,"k":3,"t":[{"s":{"e":25}},2]},"s":{"s":1,"t":{"a":49,"e":[{"n":{"d":[{"e":56},35]},"r":{"e":33,"w":{"e":31}},"s":5},22],"i":[{"g":5},23],"r":14,"u":5}},"t":{"a":0},"u":{"t":[{"e":5},6]},"z":{"o":12}},"ö":{"d":6,"l":{"l":1}},"p":{"a":{"b":12,"r":{"t":{"h":10}}},"e":{"c":6,"l":{"a":1,"e":1},"n":{"a":1}},"f":5,"h":5,"o":{"k":{"a":22},"s":{"t":[{"e":{"i":29}},5]}},"r":{"o":13},"s":6},"r":{"a":{"b":{"e":10},"c":{"h":{"e":57}},"m":{"e":1},"u":{"m":2,"s":{"c":{"h":{"l":52}}}}},"ä":{"u":{"s":{"c":4}}},"e":{"a":{"l":{"e":1}},"b":{"s":37},"c":{"h":{"a":1}},"i":{"n":{"s":{"z":7}},"s":{"e":{"i":58},"t":59}},"l":{"i":48},"s":{"t":{"r":26}}},"i":{"a":{"s":5},"c":{"h":{"t":{"e":15}}}},"o":{"a":5,"b":{"e":1},"e":6,"h":6,"m":[{"a":12},1],"s":{"t":6},"t":{"r":23}},"ö":{"s":6},"u":{"f":{"s":4},"h":{"r":11},"n":{"d":{"e":{"r":29}}}},"ü":{"b":0,"c":{"k":{"e":{"r":60}}}}},"s":{"a":{"b":{"r":1},"l":{"i":{"e":25}},"m":{"i":48},"u":{"c":13,"e":{"r":[{".":35},12]}}},"c":{"h":[{"a":{"f":{"t":{"e":{"n":{"d":61}}}}},"e":{"i":{"n":{"e":{"r":62}}}}},12]},"e":{"c":{"k":1},"e":[{"i":{"n":19}},6],"h":{"a":6},"n":{"f":12,"s":35},"r":{"e":1,"o":0},"t":21},"h":{"a":2},"i":{"e":{"n":5},"g":{"n":1},"t":{"e":5}},"k":{"i":{"e":13,"s":22}},"o":{"u":{"r":22}},"p":{"a":{"n":{"i":{"e":{"r":{".":63}}}}},"i":{"e":{"g":{"e":{"l":{"e":{"i":64}}}}}}},"t":[{"a":{"u":{"b":{"e":{"c":{"k":{"e":{"n":{".":65}}}}}}}},"e":{"i":[{"n":{"e":{"r":{"k":66}}}},2]},"o":{"r":{"e":12}},"r":{"o":{"m":{"a":33}}}},5],"u":{"c":{"h":{"e":{"r":29}}}}},"t":{"a":{"g":{"e":{"s":10}},"m":{"i":1},"n":{"k":{"a":27,"l":27}},"r":{"a":1,"t":37},"t":{"h":21,"o":[{"r":5},6],"u":21}},"e":{"e":6,"f":6,"h":{"e":25},"i":{"l":{"e":{"r":{"s":[{"c":67},64]}}}},"l":{"e":1},"n":{"o":1},"r":{"a":0},"s":[{"t":[{"r":25},5]},6]},"h":5,"i":{"a":6,"e":6,"m":{"e":[{"s":5},6]},"r":1,"s":[{"c":{"h":{"e":{"n":[{"d":68},66]}}}},6],"t":{"e":10}},"o":{"d":{"e":[{"r":5,"s":17},10]},"n":[{"a":{"t":5},"i":[{"n":5},4],"s":22},6],"p":{"l":5,"r":6},"w":6},"r":{"i":{"e":{"s":4}},"o":{"s":2}},"s":[{"e":4},5],"u":{"r":{"a":1,"i":1,"m":[{"a":12},48]}}},"u":{"b":6,"f":{"e":[{"r":25},2]},"l":{"b":23},"m":[{"a":2,"e":2,"o":2},1],"n":{"a":3,"d":1,"g":3,"i":{"t":12},"s":[{"t":12},1]},"r":{"a":{"d":3,"n":{"f":{"a":33}}},"c":0,"e":0,"i":{"n":{"f":5}},"o":{"m":16,"p":32},"s":3},"t":{"a":6,"r":1}},"v":{"e":{"n":{"e":47}},"o":{"l":{"l":48},"r":5}},"w":{"a":{"h":{"l":12},"s":6},"e":{"g":{"s":35},"i":{"n":{"e":19},"t":{"a":12}},"l":{"t":{"e":{"r":{"e":64,"k":64}}}},"r":{"k":{"e":{"r":26},"r":12},"t":{"r":12}},"t":{"t":{"e":{"r":{"e":{"r":62}}}}}},"i":{"e":5},"o":{"r":[{"t":{"e":{"n":[{"d":52},69]},"u":12}},2]},"u":{"r":{"f":11}}},"x":{"e":1},"y":{"a":{"l":5}},"z":{"e":{"l":{"l":{"a":12,"e":[{"b":26},19]}},"u":{"g":{"i":10}}},"i":{"e":[{"l":{"u":27}},6],"n":{"k":{"a":12},"s":{"c":27,"t":12}}},"u":{"c":{"h":22},"g":{"l":4,"r":{"a":5}},"p":{"f":6}},"w":{"e":[{"i":{"g":{"e":{"n":[{"d":70},66]}}}},2]}}},"a":{"a":{"b":[{"e":6},71],"c":[{"e":72},0],"g":{"r":6},"k":{"t":71},"l":{"s":{"t":22}},"n":[{"s":73},72],"q":71,"r":[{"a":23,"b":4,"d":4,"e":{"a":1,"i":6},"f":10,"g":37,"k":9,"t":10},74],"s":[{"t":35},75],"t":{"a":22,"h":6,"r":14,"s":27},"u":76},"ä":71,"b":[{"a":[{"d":78,"i":{"s":19},"l":{"t":0},"m":79,"n":{"t":6},"u":0},77],"ä":[{"r":6,"u":6},0],"b":{"a":{"t":77},"i":{"n":77}},"d":75,"e":{".":76,"c":76,"e":77,"i":{"c":0,"d":9,"l":0,"n":0},"l":[{"a":81},80],"n":{".":76,"t":75},"r":[{"d":73,"e":82,"i":82,"k":83,"r":83,"z":83},77],"s":[{"e":11,"s":{"e":1}},84],"t":77,"w":77},"f":75,"g":[{"a":78},75],"h":75,"i":[{"l":84,"n":{"s":0},"r":0,"s":{"t":4},"t":[{"u":{"r":12}},0]},77],"k":75,"l":[{"a":[{"t":82},85],"ä":85,"e":{"d":86,"i":87,"m":82,"t":77},"i":[{"n":73,"t":5},1],"o":77,"ö":85,"u":73},0],"n":75,"o":[{".":88,"f":6,"n":88,"t":84},77],"ö":77,"r":[{"ä":89,"e":73,"o":{"s":5},"ö":77},1],"s":[{"c":90,"p":91,"t":[{"a":78,"u":75},22],"z":1},89],"t":{"e":{"i":75,"s":22},"r":78},"u":[{"g":9,"m":73,"r":0},77],"ü":77,"w":75,"y":[{"t":12},77],"z":78},71],"c":{".":77,"a":76,"c":[{"i":77},92],"e":{"m":71,"n":71,"o":73},"h":{"a":[{"l":71,"r":{"i":82},"s":4,"u":4},13],"b":77,"e":[{"c":94,"i":[{".":12},13],"p":73,"r":{"f":[{"a":35},89],"h":95,"l":95,"ö":89,"w":95}},93],"f":77,"i":[{"m":73},93],"l":4,"m":96,"n":4,"o":[{".":82,"r":97},71],"ö":{"f":4},"r":98,"s":{"c":77,"e":{"l":10},"i":37,"k":{"r":4},"o":{"r":10},"u":4},"t":[{"a":{"k":12},"e":{"r":{"f":26,"s":{"p":52},"w":46}},"o":99,"r":{"a":{"t":55,"u":{"m":52}},"ä":{"u":{"m":{"e":{".":52,"n":{".":52}}}}},"i":{"t":26}},"s":{"a":{"l":58}},"u":{"m":12}},89],"u":[{"f":100},71],"ü":4,"v":77,"w":101,"y":73},"i":71,"k":{"a":{"r":71},"e":{"l":82},"i":{"n":73},"s":{"p":2,"t":{"a":102}}},"l":93,"o":{"n":{"n":10}},"u":77},"ç":71,"d":[{".":77,"a":{".":77,"b":[{"r":6},84],"g":6,"n":0,"p":78,"r":103,"s":77,"t":77,"u":[{".":82},104]},"ä":85,"c":0,"d":75,"e":{".":77,"a":{"l":2},"c":82,"e":82,"f":{"i":105},"g":77,"l":{"l":82},"n":[{"a":[{"t":12},48]},106],"o":22,"r":{"a":13,"k":104},"s":[{"p":37,"s":10},101]},"f":77,"h":84,"i":[{"e":{"n":4,"r":{".":4},"s":{"c":10}},"s":{"t":12}},84],"j":78,"l":{"i":77},"m":{"i":78,"u":84},"o":{"b":6,"n":[{"a":12},2],"p":73,"s":6},"p":77,"q":77,"r":{"e":[{"c":107,"i":1},73],"u":{"n":1}},"s":[{"t":1,"z":1},108],"t":[{"e":110},109],"v":75,"y":76},71],"e":[{"b":6,"c":[{"k":6},73],"d":6,"i":6,"k":73,"l":[{".":82,"a":89,"e":89,"i":89,"s":82},73],"m":6,"o":[{"p":22},23],"p":6,"r":{".":82,"o":112},"s":{"a":2,"c":6,"t":35},"w":73,"x":6},111],"f":{"a":[{"b":0,"n":113,"r":82,"u":104},77],"ä":[{"n":104},77],"e":[{"c":104,"n":{"t":{"l":89}},"p":114},77],"f":{"a":12,"l":23,"s":2,"t":{"h":12}},"i":[{"k":{"a":{"n":{"z":26},"t":12}},"t":2},77],"l":[{"a":0,"u":115},107],"o":[{"c":86,"r":{"d":73,"t":104},"s":13},77],"r":{"a":[{"u":1},77],"ä":1,"e":1,"o":77,"ö":1,"ü":5},"s":{"a":3,"h":3,"i":6,"p":6,"t":12},"t":{"a":[{"t":1},21],"e":{"i":6,"l":36,"r":{"k":12}},"o":21,"ö":6,"r":[{"a":6,"e":{"i":35}},4],"s":{"t":{"ä":12}},"u":{"r":6}},"u":{"r":86},"ü":[{"r":25},77]},"g":[{".":77,"a":[{"b":32,"d":32,"r":0,"u":104},77],"d":{"e":{"l":6},"r":6,"u":6},"e":{".":84,"l":{"e":{"i":27,"r":12}},"n":{".":106,"e":{"b":12},"t":73},"s":[{"a":{"m":12},"i":{"n":27},"p":25,"s":{"e":{"n":33}},"t":{"i":25}},77]},"g":{"r":78},"i":{"d":104,"m":73},"l":[{"a":{"n":5,"s":5},"e":1,"ö":89},74],"m":77,"n":[{"a":{"t":5},"ä":89,"e":{".":5},"u":5},6],"o":{"b":4},"r":{"a":{"t":1},"e":86,"i":[{"e":1,"n":1},73]},"s":[{"a":{"h":3,"m":5},"e":{"i":{"d":16}},"p":{"o":{"r":{"t":{"a":116}}}},"t":[{"e":0,"ö":1},22]},77],"t":[{"h":6},77],"u":[{"n":{"d":73}},77]},71],"h":{".":77,"a":[{"n":6,"t":5},93],"ä":71,"e":[{"i":{"n":13},"r":{"h":117},"s":13,"u":4},93],"i":[{"n":25},72],"l":{"a":118,"ä":21,"e":{"i":21,"l":6,"n":{"a":10},"r":{"d":14,"h":14}},"o":100,"ö":6,"s":{"z":4}},"m":{"e":{"i":48,"s":25},"u":1},"n":{"a":14,"e":{"e":1,"f":6,"l":4,"r":{"d":5,"e":19,"l":{"e":15},"n":19}},"i":{"n":6},"o":6},"o":{"r":85,"s":0},"ö":{"s":1},"r":[{"a":13,"e":[{"n":{"s":{"c":15}},"s":10},3],"t":{"a":{"g":{"e":26}},"e":{"n":{"g":26}},"i":2,"r":{"o":12},"u":{"n":12}}},84],"t":{"a":6,"e":{"l":36,"x":21},"r":14,"s":119},"u":71,"w":0,"y":71},"i":{".":77,"a":[{".":71},120],"b":[{"l":6},77],"d":{"s":2},"e":[{"n":121},120],"f":[{"r":0},12],"g":122,"k":{".":82,"e":1},"l":{"a":{"r":6},"d":9,"e":{"i":6},"g":4,"o":6},"n":[{"a":2,"d":71,"e":123,"s":[{"p":22},4]},84],"r":{"b":78},"s":{"a":6,"c":{"h":{".":82,"w":7}},"e":3,"s":{"e":{".":12}}},"t":12,"v":{".":82,"l":82,"s":82}},"j":[{"a":{"t":73},"e":[{"k":{"t":{"o":19}}},2]},71],"k":{".":77,"a":{".":77,"b":[{"r":10},96],"d":73,"l":77,"m":76,"n":77,"r":77,"t":[{"a":[{"k":12},48]},5],"z":75},"ä":84,"b":77,"c":77,"d":77,"e":[{"f":73,"m":104,"n":{"t":73},"s":73,"t":6,"u":73},93],"i":[{"n":{"s":0},"s":13},93],"k":{"u":75},"l":[{"a":115,"i":5,"ö":78},107],"n":{"a":71},"o":77,"r":[{"a":84,"e":{"s":1},"i":124,"o":78,"ü":1},93],"s":[{"h":1},77],"t":{"a":{"b":125},"b":77,"e":{"l":6,"r":2},"g":77,"i":{"k":77,"s":77},"m":77,"o":{"b":126},"ö":6,"r":[{"i":123},23],"s":{"i":77,"p":77,"t":77},"w":77},"u":[{"n":77,"p":73,"r":77,"s":2},71],"ü":84,"z":[{"e":78},75]},"l":{"a":[{".":77,"b":{"o":77},"f":0,"g":{"e":0},"i":77,"k":{"r":0},"m":0,"n":{"a":0,"d":77,"g":73,"z":0},"p":{"p":0},"r":{".":82,"c":1,"e":82,"r":127,"t":73},"s":[{"i":0,"s":0},2],"t":{".":82,"m":5,"z":25},"u":[{"g":1},0]},71],"ä":[{"m":104,"n":0,"r":{"m":0},"u":0},71],"b":{"a":{"t":78},"ä":{"r":6},"e":{"r":{"e":19,"h":5,"w":39}},"l":21,"o":{"h":6,"n":6},"r":{"u":4},"s":{"t":4}},"d":{"a":{"n":5},"ä":6,"e":{"r":{"l":14,"n":14},"s":22},"i":{"n":{"n":4}},"r":{"a":6,"ä":6},"s":22},"e":[{".":106,"a":{"r":12},"b":113,"c":{"k":0},"f":114,"i":[{"c":79,"n":89},104],"l":104,"m":{"a":88,"i":113},"n":{".":106,"d":{"e":102,"r":1,"s":128},"g":73,"n":6},"p":[{"o":0},2],"r":{".":84,"b":104,"e":22,"f":104,"h":117,"k":{"l":10},"l":86,"m":[{"i":10},0],"r":129,"s":6,"t":104,"w":{"ä":130}},"s":[{"k":131,"s":73},84],"t":{"h":89},"u":104},77],"f":{"r":12},"g":{"i":78,"l":{"i":6,"o":1},"o":[{"r":78},75],"r":12},"i":[{"m":{"b":6,"m":0},"n":{"a":{"l":12},"d":0,"g":{"e":10},"q":117,"s":0}},77],"k":{"e":{"n":132},"l":{"ö":6},"n":{"e":6},"o":{"f":6,"h":75},"s":[{"t":10},37]},"l":{"a":{"b":6,"d":1,"n":21,"r":125},"e":{".":1,"c":5,"e":78,"n":{"d":1},"r":{"k":4,"z":19},"s":1},"i":{"d":6,"e":{"r":{".":55,"s":{".":45}}}},"o":{"b":6,"p":6},"ö":{"f":6}},"m":{"a":{"p":6,"s":{"t":14}},"o":{"d":{"e":{".":33}}}},"o":{".":77,"b":104,"e":88,"f":104,"g":[{"a":2,"r":2},84],"n":{"t":0},"r":{"t":0},"s":77},"ö":[{"s":6},104],"p":{".":78,"e":{".":78},"h":[{"o":6},75]},"r":{"a":{"t":19}},"s":{"a":{"k":1},"c":{"h":{"e":{"i":24},"s":17}},"k":{"a":1},"t":{"e":{"r":{"b":18}},"u":6},"u":{"m":6}},"t":{"a":{"k":21,"l":{"g":4},"m":1,"n":6,"t":6,"u":6},"ä":75,"e":{"i":{"s":4},"l":{"t":4},"m":{"u":5},"r":{"f":133},"u":6},"i":{"d":6,"n":6},"o":{"p":13},"ö":6,"r":{"a":{"t":14},"e":6,"i":14,"o":23},"s":{"t":{"ü":12}}},"u":[{"b":9,"f":23,"g":4,"k":32,"m":[{"b":0},73],"r":104,"s":82},71],"y":84,"z":{"a":{"r":6,"u":6},"e":{"n":1,"r":{"k":12}},"w":6}},"m":{".":77,"a":[{"b":{"a":2},"d":37,"g":4,"l":{"g":73},"n":134,"z":85},6],"ä":77,"e":{".":84,"b":73,"l":77,"n":[{"s":{"p":{"r":33}}},135],"r":{"a":[{"u":17},37],"f":104,"i":85,"u":136},"s":[{"h":89},137],"t":76},"f":77,"i":{".":82,"e":82,"k":2,"n":{"g":5},"r":76,"s":76,"t":77},"k":77,"l":77,"m":{".":77,"a":{"b":6,"c":21,"l":77,"n":{"t":5},"r":6},"e":{"i":6,"s":17},"i":{"d":6,"e":22,"n":6},"o":{"r":6},"ö":21,"u":22},"n":{"i":48},"ö":73,"p":{"e":{".":77,"n":77},"f":[{"a":138},5],"l":{"e":80},"o":77,"r":1,"s":37},"s":[{"a":1,"c":[{"h":{"l":5}},84],"e":78,"h":3,"o":1,"p":1,"u":1},80],"t":{".":75,"a":[{"u":5},125],"ä":21,"e":{"i":[{"g":4},6],"l":5,"m":6,"r":[{"h":5,"n":14},19],"x":21},"i":{"s":6,"t":6},"o":[{"u":24},6],"ö":6,"r":[{"e":5,"i":5},23],"u":21,"v":77},"u":[{"l":88},77]},"n":{"a":{".":77,"b":77,"c":4,"d":[{"i":132},139],"g":6,"k":76,"l":{"g":0,"i":{"n":12}},"m":[{"a":23},77],"n":[{"d":5},77],"s":137,"t":{".":140,"h":12,"m":141,"o":73,"r":12,"s":140},"u":{"g":1}},"ä":{"s":142},"b":[{"a":{"s":77},"ö":77,"u":77},75],"c":{"h":1},"d":{".":77,"a":{"c":143,"r":{"m":4}},"e":{"i":4,"n":{"g":{"a":15},"t":14},"r":{"o":{"b":35}},"s":{"c":10},"x":21},"s":{"a":{"s":12},"e":{"h":12},"o":2,"p":{"a":{"r":26,"s":26}},"u":2},"u":[{"r":21},144],"y":48},"e":[{"c":3,"e":82,"i":{".":6,"f":1,"g":78,"s":89},"k":145,"l":2,"m":{"i":32,"o":73},"r":{"f":{"a":10},"g":82,"h":6,"k":{"e":89},"n":84,"z":{".":89,"e":5}},"t":{"h":0},"x":78},77],"f":[{".":77,"a":{"b":77},"ä":78,"e":1,"i":77,"j":5,"l":{"e":4},"o":{"r":{"s":84}},"r":{"a":{"u":35}},"s":77,"u":3},75],"g":{".":84,"a":[{".":77,"r":21,"s":77},75],"e":{".":77,"b":75,"i":21,"r":{"f":14,"h":39,"w":39,"z":14}},"h":77,"i":{"e":77},"l":[{"a":6},13],"n":35,"r":[{"a":4,"i":146},13],"s":{".":77,"t":{"o":12}},"t":22},"h":75,"i":[{"d":23,"e":{"l":{"s":4},"r":{"s":{".":35}}},"g":22,"k":{"e":4},"m":147,"n":{"d":89},"o":[{"n":16},2],"s":{"o":89}},76],"j":77,"k":{".":77,"a":{"b":6,"k":21,"n":6},"e":{"i":6,"n":107,"r":{"f":{"a":35}},"s":1},"i":[{"d":6},77],"l":{"ö":6,"u":6},"n":{"o":4},"o":{"p":{"f":14},"r":6},"r":[{"a":[{"s":5},4],"ä":4,"o":6},13],"s":[{"e":4,"p":22},77],"t":148},"l":[{"a":{"d":77,"g":78}},75],"m":{"o":77,"u":75},"n":{".":77,"a":{"h":75,"r":6},"e":[{"f":5,"i":5,"n":{"e":5,"s":149},"r":2},1],"s":[{"p":27},77],"t":77},"o":{".":77,"d":92,"f":77,"g":77,"l":[{"a":2},76],"m":[{".":82},85],"o":77,"r":[{"i":2},104],"s":76},"ö":93,"p":{"u":77},"r":[{"ö":77},75],"s":{"a":{"m":{"e":5},"r":1},"ä":91,"c":{"h":{"r":78}},"k":{"r":1},"p":{"a":13,"o":{"n":4},"r":75},"t":75,"z":3},"t":{".":77,"a":{"r":[{"e":10},4]},"ä":3,"á":75,"e":{"i":78},"h":{"a":1},"i":{"e":77,"s":{"e":78}},"o":{"n":105},"r":[{"i":{"n":4}},75],"w":75},"u":[{"r":4,"s":13},77],"ü":71,"w":[{"i":77},75],"z":{"ä":6,"b":77,"d":77,"e":{"i":75,"l":{"f":4},"n":22,"s":77},"g":77,"h":77,"i":{"d":22,"n":150},"k":77,"m":77,"r":77,"s":77,"t":77,"ü":[{"n":78},75],"v":77,"w":[{"i":6},77],"y":77}},"o":[{"f":12,"i":1,"p":[{"f":10},71],"r":71,"s":[{"t":22},151],"t":{".":82,"s":16}},77],"ö":152,"p":[{".":84,"a":[{"b":4},5],"e":{".":73,"l":82},"é":73,"f":[{"a":6,"e":{"l":75,"s":77},"l":82},73],"h":{"t":73},"i":77,"l":[{"a":5,"ä":82,"e":1,"i":1},77],"n":6,"o":{"s":88,"t":73},"p":{"u":1},"r":77,"s":{"o":6,"t":{"e":{"r":12}}},"t":47,"u":76},71],"r":{".":77,"a":[{".":82,"b":[{"b":107,"f":1,"t":1},6],"d":[{"r":1},37],"g":{"e":4},"l":[{"e":124,"i":82,"o":82},153],"n":[{"g":104,"z":104},77],"p":[{"p":128},77],"r":74,"s":{"t":2,"y":6},"t":84,"u":104},71],"ä":[{"s":0},71],"b":[{".":77,"a":[{"k":6,"t":23,"u":6},77],"e":{"f":84,"i":{"n":14},"k":77,"n":77,"r":[{"l":4},77]},"i":84,"l":80,"o":77,"r":137,"s":[{"k":4,"o":4},154],"t":155,"u":77},75],"c":[{"h":{"l":77,"r":77}},92],"d":{"a":{"u":6},"e":{"i":10},"o":{"p":6},"r":23,"u":6},"e":{"a":[{"l":{"e":{"r":35}}},73],"b":156,"e":22,"f":{"f":0},"h":[{"r":0},73],"i":[{".":82,"d":0,"e":82,"h":82,"m":17,"n":[{"b":19,"s":19,"t":19},73]},77],"l":{"e":73},"m":84,"n":{".":84,"s":{"e":{"m":33}}},"r":{"a":37,"e":[{"i":128},22],"g":73,"h":157,"i":73,"k":73,"l":73,"t":73,"w":6},"s":77,"t":6,"u":4,"v":73},"f":{"r":[{"a":4},13],"s":{"p":2}},"g":{".":84,"a":{"n":1},"l":6,"n":5,"o":158,"r":16,"s":12},"h":77,"i":[{"a":6,"d":73,"e":{"n":37,"r":{"d":4,"g":4}},"n":{"i":{"t":25},"s":159,"t":0},"o":124,"r":6,"s":[{"u":2},5],"u":82},77],"k":{"a":{"l":6,"r":21,"u":{"e":4}},"e":{"r":105},"i":{"l":6},"l":[{"a":{"g":5},"e":6,"o":6,"ö":12},96],"o":{"a":6,"r":6},"s":{"a":9,"e":2,"h":{"e":4}},"t":{"r":{"e":12}}},"l":{"e":{"s":6}},"m":{"a":{"d":1,"u":13},"ä":3,"e":{"g":21,"i":21},"o":{"r":2},"u":{"m":6},"ü":84},"n":[{"a":{"n":6},"e":{"l":2},"i":1},84],"o":[{"b":22,"c":[{"k":{"e":{"n":{"g":52}}}},84],"d":32,"f":[{"e":2},0],"l":76,"m":4,"p":104,"r":73,"s":[{"t":12},25],"u":85},71],"ö":131,"p":77,"r":{"a":{"c":13,"d":21,"s":21},"e":{"n":160},"h":6,"i":77,"o":{"r":23}},"s":{"e":1,"h":3,"i":3,"k":{"a":[{"t":12},4]},"t":{"a":1}},"t":{"a":{"u":6},"b":77,"e":[{"i":77,"x":77},3],"i":3,"o":77,"r":[{"e":{"s":12},"i":6},4],"s":[{"k":{"e":4},"p":2},77],"u":{"c":77},"y":77},"u":[{"h":104,"m":[{"m":82},0]},77],"ü":73,"v":77,"w":{"a":22},"y":161,"z":{"a":[{"u":6},77],"ä":6,"e":77,"i":77,"ö":6,"t":[{"e":{"i":12,"m":12},"i":12,"r":162},75],"u":77,"w":21}},"s":{"a":[{"a":128,"f":86,"g":82,"l":[{"t":163},79],"m":0,"r":{"t":1},"s":2,"t":1,"u":{"f":10,"g":128}},77],"ä":[{"t":1},73],"b":{"e":{"s":105}},"c":{"a":164,"h":{"e":{"c":89,"f":89,"i":165,"r":{"g":166}},"i":124,"m":73,"t":77,"u":[{"m":89},82]}},"d":77,"e":[{"b":73,"c":73,"f":104,"i":{"e":0},"m":{"i":0},"n":{".":82,"a":12,"o":27,"s":{"e":{"m":33}}},"r":[{"d":5,"e":2,"g":{"e":{"b":33}},"k":{"e":128}},6],"s":5,"t":12,"x":73},84],"f":77,"g":{"e":{"s":19}},"h":[{"i":[{"r":1},79]},77],"i":{"g":77,"k":167,"m":77,"n":{"g":22,"n":0},"s":77},"k":{"a":{"s":25},"u":1},"o":[{"b":1,"f":0,"l":82,"m":82,"p":32,"r":0,"z":89},77],"ö":73,"p":[{"e":{"k":{"t":{"o":15}}},"h":6,"i":[{"k":1,"o":1,"r":89},79],"r":[{"a":6},77]},104],"s":{"a":[{"b":162,"u":{"s":{".":26}}},107],"e":[{"i":{"n":4},"l":{"e":25}},2],"i":2,"k":{"i":1},"o":1,"p":{"o":6,"r":6},"t":[{"a":1,"e":{"i":1},"i":1,"r":1,"u":1},6]},"t":{"a":[{"d":82,"s":71,"t":1},77],"ä":82,"e":[{"l":2,"r":2,"s":{"e":14},"x":5},1],"h":6,"i":{"d":2,"e":1,"l":1},"o":[{"f":5,"r":{"c":4}},1],"r":[{"e":[{"n":16},4],"i":{"t":{"t":20}},"o":{"l":{"l":35}}},71],"u":{"b":1}},"u":[{"r":6,"s":27},77],"ü":73,"w":{"a":{"s":22}},"y":[{"l":78,"s":77},75]},"ß":[{"e":[{"n":168},12]},71],"t":[{"a":[{"b":{"e":0,"r":0},"f":21,"g":[{"o":6},169],"l":{"a":4},"m":82,"p":{"f":0},"s":{"t":6},"t":{"t":1},"u":104},84],"ä":{"n":0},"b":84,"c":6,"e":{"b":73,"c":82,"i":{"e":{"n":{"d":29}},"g":0},"l":{"i":88},"m":{"g":88},"n":[{"a":12,"s":{"e":159}},6],"p":73,"r":[{"a":{"l":9,"n":4},"e":5,"n":105,"s":{"t":25},"u":2},84],"s":[{"s":{"a":10}},84],"t":82,"u":6,"w":73},"h":{"a":[{"g":1,"l":1},84],"e":{"b":79},"i":{"n":{".":4}},"l":78,"r":89,"u":6,"ü":1},"i":[{"k":{"a":{"b":12},"e":{"r":{"w":46}}},"n":{"f":89},"s":[{"a":2,"e":2,"o":89,"s":25},6],"v":{"e":{"r":{"f":46}}}},106],"l":{"a":78,"i":84},"m":[{"a":84,"ä":84,"u":{"s":84}},78],"o":{"b":104,"m":[{"e":48,"o":2},170],"p":0,"r":{"t":0},"s":171},"r":{"a":{"t":10,"u":86},"ä":86,"e":1,"i":{"n":1},"o":{"m":1,"n":5,"t":1},"ü":1},"s":{"a":6,"c":{"h":{"n":5}},"e":[{"h":100},6],"i":[{"n":13},6],"o":21,"p":21,"t":{"ä":{"t":4}},"u":6},"t":{"a":[{"c":78,"d":5,"k":41,"l":[{"e":5,"s":5},22],"n":{"g":5},"r":5,"u":5},1],"ä":6,"e":{".":84,"c":23,"i":6,"l":3,"r":172},"h":{"ä":1},"i":1,"o":[{"b":6},84],"r":{"ä":23},"s":37,"u":3},"u":[{"b":82,"n":2},84],"ü":82,"z":{"e":{"l":[{"a":4,"t":4},10],"m":6,"r":[{"e":82},21]},"i":{"n":21},"t":37,"w":21}},93],"u":[{".":77,"a":173,"b":[{"a":{"b":6,"n":6,"u":21},"e":{"n":10,"u":6},"l":{"ä":6,"i":6,"o":6,"u":6},"s":{"i":2}},77],"c":77,"d":{"r":6},"e":[{"b":2,"r":{"e":[{"i":4},6],"ö":25,"s":{"t":{".":7}},"t":1},"s":2},77],"f":{"a":[{"k":13,"n":13},6],"e":{".":77,"h":77,"n":{".":84,"t":78},"r":[{"k":42},13],"u":6},"f":10,"i":{"n":{"d":4}},"l":{"a":75},"n":75,"o":77,"s":{"k":{"i":4}},"t":[{".":77},37]},"g":[{"a":[{"r":3},6],"e":{"b":84,"h":84,"l":84,"r":2},"l":84,"r":84,"u":1},77],"h":1,"i":[{"s":6},127],"j":84,"k":{"t":4},"l":{"e":{"s":22},"l":{"e":{"s":12}},"ü":1},"m":[{"a":{"l":6},"e":{"n":[{"t":14},10],"r":[{"i":4},174]},"i":{"d":21,"l":5,"t":5},"o":[{"r":22},21],"p":37,"s":119,"u":{"n":5}},84],"n":[{"a":3,"e":[{"i":14},2],"i":{"o":6},"o":6,"u":1,"z":89},84],"p":108,"r":[{"h":0,"ü":25},108],"s":{"a":{"h":21,"n":{"n":{"e":{".":175}}},"s":6,"u":6},"c":[{"h":{"m":{"i":24}}},77],"d":75,"e":{".":77,"h":41,"n":77,"r":{"b":14,"f":5,"k":14,"p":4,"w":5}},"g":75,"i":{"n":6,"s":6},"l":75,"o":[{"r":13},6],"p":{"r":6},"r":75,"s":[{"a":{"g":78},"e":{".":12},"t":4},22],"t":{"a":22,"e":[{"i":{"n":7}},77],"o":22,"r":{"i":35}},"ü":78,"w":75,"z":75},"ß":{"e":22},"t":{".":77,"a":{"b":6},"ä":{"u":21},"b":77,"e":[{"l":176,"n":{"g":42},"r":{"h":14,"o":35}},77],"g":77,"h":{"y":6},"o":75,"r":{"ö":5},"s":77},"u":77,"v":[{"e":10},77],"w":77,"x":77,"z":[{"w":2},77]},73],"ü":93,"v":[{"a":[{"n":{"g":82},"s":10,"t":37},6],"e":{"n":{"e":{"r":102}}},"i":77,"r":86},71],"w":[{"i":{"e":4},"r":73},93],"x":[{"a":{"m":6,"n":{"s":73}},"e":79,"i":{"d":82,"o":73,"s":48}},71],"y":{"a":93,"e":{"u":71},"m":{"a":10},"o":{"f":0},"s":[{"i":48},2],"t":1},"z":[{"a":[{"d":171,"l":78},5],"i":79,"o":6,"u":79,"z":{"e":{"n":6},"w":6}},71]},"ä":{"a":71,"ä":75,"b":[{"l":86,"s":6,"t":{"e":48}},93],"c":{"e":71,"h":{"e":[{"e":48,"n":10},71],"i":71,"l":4,"r":73,"s":{"a":12,"o":11,"p":2,"t":2},"t":{"e":10},"u":71},"k":71},"d":[{"a":73,"e":{"s":100},"i":{"a":104},"r":86,"s":6,"t":{"e":1}},71],"e":[{"k":5,"u":82,"x":6},93],"f":{"e":{"n":12},"f":{"l":6},"i":{"g":25},"l":1,"r":[{"o":5},1],"s":6,"t":{"e":3,"s":27}},"g":[{"a":104,"ä":85,"d":2,"e":{"n":{"e":10},"r":{"a":162},"s":4},"l":86,"n":6,"r":[{"a":5},86],"s":{"t":[{"a":1,"r":1},22]},"y":85},71],"h":{"a":0,"e":[{"i":114,"r":{"g":{"e":{"b":{"n":30}}},"t":55}},76],"i":[{"n":0},71],"l":{"a":13,"e":[{"b":{"e":177},"r":7},3]},"m":77,"n":{"a":1,"e":1,"l":75},"r":[{"e":{"l":6},"i":1},77],"s":77,"t":77,"u":71,"w":0},"i":[{"m":71,"s":[{".":82,"c":{"h":{".":82}},"k":82},73]},77],"j":71,"k":[{"a":{"l":{"a":2}},"l":[{"e":73,"i":5},1],"r":86},71],"l":{"a":71,"b":{"e":22,"l":5},"k":[{"s":10},4],"l":{"a":21},"p":23,"s":{"c":{"h":{"l":5}},"t":6},"t":{"e":[{"i":48},2]},"u":71},"m":{"a":178,"e":[{"r":{"s":22}},82],"i":{"e":{"n":4}},"l":77,"o":{"n":{"i":{"e":17}}},"p":[{"f":{"e":179}},77],"s":6,"t":{"e":[{"r":17},2]}},"n":{".":77,"d":{"r":6},"e":[{"n":11,"s":13},80],"f":[{"t":22},180],"g":{"e":[{"r":{"a":10}},181],"l":[{"e":4},80],"r":6,"s":{"e":4}},"i":76,"k":{"e":3,"l":23,"r":6,"s":2},"n":[{"e":182},77],"s":[{"a":41,"c":21,"e":2},77],"z":77},"o":{"n":71,"s":3},"p":{"a":71,"f":{"e":{"l":75}},"p":{"l":6,"r":6},"s":{"c":21,"t":5}},"q":75,"r":{"a":[{"f":5},183],"ä":0,"b":{"l":{"e":23}},"c":0,"d":[{"e":{"s":10}},77],"e":[{"i":104,"l":113,"m":[{"i":0},2],"n":[{"e":73},2],"r":{"h":73},"s":6},77],"f":{"s":2},"g":{"e":1,"s":12},"i":{"n":{"d":104,"t":0}},"k":{"e":1,"s":2},"m":{"a":{"r":{"m":4},"t":4},"e":{"e":48,"n":{"t":4}},"s":2},"o":{"b":0,"f":0},"ö":71,"r":{"e":1},"s":{"e":[{"b":6,"h":5,"r":13},22],"i":6,"p":{"u":1},"t":[{"r":1},6]},"t":[{"e":12,"h":6,"s":162},77],"ü":73,"z":[{"u":6,"w":6},75]},"s":{"e":[{"g":4,"i":184,"r":{"e":{"f":35,"i":10,"n":12},"i":22}},161],"k":{"r":79},"p":104,"s":{"c":109,"e":[{"r":{"k":{"r":35},"s":{"a":35},"w":4}},2],"p":6,"t":23},"t":[{"e":12,"h":75,"r":5},128],"u":82},"ß":[{"e":{"r":{"k":0,"s":0}}},71],"t":{"a":167,"e":[{"a":4,"e":13,"i":13,"l":37,"n":2,"o":22,"r":{"b":{"l":10}},"t":6},76],"i":{"d":0},"o":{"b":0},"r":86,"s":{"a":14,"ä":6,"c":{"h":{"l":5,"r":5}},"i":125,"l":4,"o":{"r":13},"p":21,"t":23,"u":6},"t":{"e":{"i":6,"n":10},"r":5},"z":{"e":{"l":25},"w":6}},"u":{"b":[{"l":23,"r":6},77],"c":0,"d":[{"e":[{"r":105},25]},1],"f":74,"g":[{"l":4},75],"l":77,"m":[{"a":6,"p":[{"f":19},4],"s":59},77],"n":[{"e":2,"u":1},74],"r":[{"e":48},173],"s":{".":76,"c":[{"h":{"i":5,"m":5}},77],"e":[{"i":48},3],"g":82,"k":82,"n":82,"p":21,"s":{"c":11}},"ß":75,"t":{"e":2,"r":6}},"v":[{"i":73},71],"x":75,"z":[{"e":82},71]},"â":{"t":71},"á":{"n":71},"b":{"a":{".":78,"a":73,"b":{"a":79,"f":77,"g":77,"l":6,"r":6,"s":93},"c":{"h":{"t":{"e":185}},"k":{"e":{"r":186},"s":159}},"d":{"e":[{"i":48,"l":93},3],"l":93,"m":93,"r":72,"u":6},"f":93,"h":[{"n":{"e":{"n":{"e":26}}}},78],"i":{"d":4,"s":22},"k":[{"a":6,"e":{"r":21},"i":21,"l":38,"r":23},73],"l":{"a":{"b":6,"k":21,"l":1,"u":6},"e":{"r":[{"k":14},105]},"k":{"a":10,"e":19},"l":{"e":{"h":27,"i":27,"r":{"g":26,"k":33}}}},"m":[{"a":86,"e":6,"t":84},93],"n":{"a":2,"d":[{"a":[{"l":12,"n":12,"r":12},48],"e":{"n":{"g":26}},"r":2},88],"e":3,"f":77,"g":[{"l":4},71],"k":{"a":99,"e":{"r":102},"l":2,"n":2,"r":2,"u":2},"l":77,"n":{"a":71},"o":2,"s":93,"t":71,"w":77,"z":71},"r":{"a":{"b":23,"d":6,"s":{"t":4},"t":6},"d":{"e":4},"e":{"i":6,"n":3,"r":{"e":{"i":54},"t":19}},"f":10,"s":[{"c":4},187],"z":[{"w":4},71]},"s":[{"a":1,"c":6,"i":2,"s":{"a":12,"t":12},"t":6},88],"t":{"e":{"n":{"t":14}},"o":2},"u":{".":78,"b":4,"e":{"r":{"l":19,"s":19,"w":19}},"f":{"l":13,"r":13},"g":37,"k":73,"r":4,"s":[{"k":37,"t":10},13]},"x":72,"y":{"o":0}},"ä":{"c":188,"d":88,"h":93,"l":73,"r":{"z":77},"s":73,"u":{"g":77}},"b":[{"e":[{"n":[{"s":105},27],"p":12},82],"l":{"e":{".":1},"ö":6},"r":{"e":{"c":82},"u":[{"c":22},82]},"s":6,"u":13},189],"c":189,"d":[{"ä":[{"n":25},12],"e":{"s":13},"o":{"m":{"e":19}}},190],"e":{".":75,"a":[{"b":1,"n":1,"t":{"m":22},"u":[{".":5},1]},78],"b":[{"b":71},78],"c":[{"h":{"t":77}},92],"d":{"e":{"l":152},"i":10},"e":{"h":32,"l":[{"a":1},2],"r":{"e":{"i":12},"h":0,"l":0,"t":0},"t":{"a":0}},"f":[{"f":93},12],"g":16,"h":{"e":{".":6},"r":{"i":35}},"i":{"b":4,"e":{"r":93},"f":184,"g":{"e":{".":12,"l":19,"p":19}},"k":9,"l":{"a":37},"m":{"e":93},"n":{"d":0,"h":[{"a":{"l":33},"i":10},0]},"s":{"c":4,"e":22,"t":184},"t":{"e":10,"s":[{"k":10,"p":17},22]}},"k":78,"l":[{"a":{"g":1,"s":1},"d":4,"e":{"c":1,"k":139,"n":21,"r":{"e":4},"t":6},"f":4,"i":{"e":10},"l":{"a":4,"e":{"n":191},"i":4},"o":{"m":4},"ö":{"f":6},"s":{"z":4},"t":22,"u":{"n":12}},78],"m":[{".":88,"a":193,"p":93,"u":{"l":77}},192],"n":[{"a":{"b":{"e":7},"r":4,"s":5,"t":5},"ä":6,"e":[{"i":1,"n":{"d":14},"r":{"s":5},"u":2},73],"g":78,"i":{"d":6,"s":5},"n":4,"p":194,"s":[{"p":{"a":27,"r":12},"t":19,"z":78},73],"t":{"b":93,"d":77,"e":{"u":84},"f":77,"h":[{"e":{"i":26}},4],"r":195,"s":93,"w":76},"u":{"n":4},"z":196},75],"o":0,"p":{"i":93,"o":{"c":77}},"r":{"a":[{"k":6,"m":23,"n":6,"s":22},0],"b":[{"l":{"a":102}},22],"d":4,"e":{"b":125,"c":{"k":5},"i":{"w":14},"m":22,"n":{"e":5},"r":{"g":12,"w":12},"s":{"c":10},"t":10},"f":10,"g":{"a":{"f":27,"l":12},"l":{"i":12}},"h":{"a":{"b":12}},"i":{"d":22,"n":{".":12,"n":{"e":18},"s":19},"o":126,"s":{"s":4}},"k":{"o":4,"r":4},"n":{"a":37,"e":22,"t":71},"ö":6,"s":{".":78,"e":35,"t":{"a":197}},"t":{"a":22,"e":22,"i":22},"z":[{"e":4,"ö":2},22]},"s":[{"a":[{"b":{"b":12},"m":2,"n":2,"p":5,"r":5,"u":2},1],"e":{"p":6,"r":21},"i":{"d":21},"p":{"o":2},"s":{"a":4,"e":10,"t":{".":82},"z":4},"t":{"a":{"b":5},"e":[{"i":{"n":24},"r":[{"h":26},102]},105],"o":{"l":198,"r":199,"s":4},"r":[{"ä":14},10],"u":{"r":14}},"u":{"r":6},"z":{"e":16}},188],"t":[{"a":{"m":1},"h":{"a":1,"i":1},"s":{"p":2}},78],"u":{"n":0,"r":0},"v":78,"w":200,"x":161,"z":88},"f":[{"a":{"l":[{"t":25},22]}},201],"g":[{"a":140,"e":[{"l":{"e":22},"n":35,"s":10},4]},152],"h":[{"ä":140},152],"i":[{"a":{"k":0,"r":6},"b":[{"e":[{"r":132},22]},187],"c":6,"d":{"o":1},"e":{"n":{"s":25},"r":{"e":{"s":102}},"s":2,"t":{"s":22,"u":78}},"g":{"a":48},"k":{"a":2,"e":{".":6,"s":6},"r":{"e":6}},"l":[{"a":{"n":[{"s":4},2]},"d":{"e":{"b":12}},"e":{"i":6},"l":{"u":84},"u":6},78],"m":{"p":77},"n":{"b":93,"e":[{"n":10},2],"f":[{"o":12},71],"g":{"a":162},"h":93,"o":{"k":23,"l":12},"t":93,"v":93},"o":[{"i":22},23],"r":{"i":48},"s":[{"i":1,"o":71,"p":6,"s":{"c":11},"t":[{"a":1,"r":120},6]},78],"t":{".":73,"a":73,"e":73,"i":73,"r":12,"u":6},"z":3},75],"j":[{"e":{"k":{"t":{"o":10}}}},189],"k":201,"l":[{".":77,"a":{"b":9,"c":93,"d":82,"n":{"c":73},"s":{"e":{"r":25}},"t":{"t":73},"u":{".":73,"s":202},"w":76},"ä":{"n":93,"s":{"e":73},"t":78},"e":[{"a":187,"b":82,"c":78,"g":82,"h":84,"i":{".":89,"d":76,"h":77,"n":82,"s":{"c":25},"t":77},"l":4,"n":[{"k":82},2],"s":{"e":82,"u":77,"z":9},"t":78,"u":82},73],"i":{"c":{"h":77,"k":78},"e":[{"f":77},73],"g":84,"n":{"d":73,"g":203},"s":[{".":77},73],"t":[{"e":82},73]},"o":[{".":89,"c":147,"i":89,"s":82},73],"u":{"m":147,"n":77,"s":73,"t":[{"e":{"m":12},"o":48},78]},"ü":78},5],"m":93,"n":[{"a":{"s":10},"i":[{"s":48},2]},204],"o":{"a":[{"s":7},5],"b":[{"e":{"n":1},"r":4},72],"c":[{"h":43},6],"d":3,"e":[{"i":23},13],"f":[{"e":1},93],"h":{"e":1,"r":{"a":2,"e":{"r":4}},"u":2},"i":{"s":0},"l":{"a":{"n":6,"u":6},"l":{"e":35}},"n":{".":78,"a":3,"d":{"a":2,"e":11},"e":6,"s":78},"o":{"l":12,"t":{"i":2}},"p":71,"r":{".":78,"a":[{"n":2,"s":23,"u":6},0],"ä":5,"d":{"a":2,"r":162},"e":{"i":6},"i":{"g":5},"m":4,"s":2,"t":[{"e":{"r":12},"r":{"a":{"t":46}}},71],"u":{"h":5}},"s":{"c":6,"e":1,"p":14,"t":4},"t":[{"e":{"n":{"e":159}},"h":1,"s":{"t":2},"t":35},78],"x":{"o":6},"z":71},"ö":{"b":23,"f":77,"l":[{"k":25},93]},"p":[{"a":{"g":2}},205],"q":93,"r":[{".":77,"a":{".":89,"d":76,"h":207,"k":95,"s":{"t":19},"t":{".":76,"e":{"r":[{"g":26},208]},"g":76}},"ä":[{"d":84,"u":12},78],"e":{".":77,"c":{"h":{"t":{"e":209}}},"d":76,"f":76,"g":77,"i":{"f":82},"k":77,"l":{"i":132},"m":89,"n":{".":89,"t":76},"o":77,"p":76,"r":89,"s":{".":89,"t":82},"t":[{"t":{"e":{"n":58}}},89],"z":89},"i":{"d":{"a":2},"e":{"f":{"a":10},"m":76,"n":89,"r":2,"s":82},"g":{"k":77},"n":{"a":89,"d":76},"o":89,"s":{"c":89},"t":{"t":82}},"o":{"b":22,"h":76,"l":76,"m":{"a":2},"n":89,"s":{"t":76},"t":{"r":12,"t":159},"u":76},"ö":147,"u":{"c":89,"f":77,"m":89,"n":{"d":76},"s":[{"t":17},10],"t":{"h":2}},"ü":[{"b":106},78]},206],"s":[{"a":{"d":104,"m":[{"b":1,"t":128},6],"u":{"r":22}},"ä":{"r":128,"u":79},"c":[{"h":[{"a":{"n":89},"e":{"f":164},"i":6},22],"o":89,"u":6},82],"e":{"b":2,"l":{".":82},"n":[{".":82,"t":104},11],"r":{"f":0,"g":0,"i":{"n":210},"k":0,"s":0},"s":79},"i":{"m":73,"t":12},"k":{"i":89,"u":6},"o":{"f":104,"h":79,"l":82,"p":89,"r":2},"ö":73,"p":{"i":79,"l":6,"u":6},"s":2,"t":[{"a":{"b":100,"k":13,"n":{"k":4},"s":41},"ä":[{"t":1},82],"e":{"m":{"i":4},"r":13},"h":13,"i":{"n":{"k":4},"p":73},"o":[{"b":89,"d":89,"l":5,"r":89},82],"ö":82,"r":{"a":{"c":89},"ä":86,"e":{"u":128},"i":5,"o":4},"ü":[{"b":89},82]},6],"u":{"n":104},"z":{"e":{"p":6},"i":6}},93],"t":[{"a":[{"s":[{"t":{"r":17}},2]},79],"e":140,"h":104,"i":[{"s":2},6],"r":[{"a":{"n":105}},5],"s":2,"ü":211},189],"u":{"c":{"h":{"e":[{"c":5,"r":[{"s":212},102]},19],"i":6,"s":{"p":159}}},"e":23,"f":6,"g":[{"r":6},4],"l":{"l":{"a":162}},"m":{"f":77,"k":76,"l":77,"r":76},"n":{"a":12,"d":{"e":{"r":27,"s":19}},"e":71,"g":[{"n":171},10],"h":93},"r":{"c":13,"e":73,"g":[{"a":[{"n":12,"r":12},48],"i":{"n":12},"r":2},73],"i":3,"n":77,"s":{"a":82},"t":{"s":17}},"s":{"a":6,"c":[{"h":{"a":4,"e":[{"i":24,"l":213},1],"w":17}},6],"h":{"i":1},"i":{"n":6},"p":21,"t":{"e":{"r":102}},"u":6},"t":{"a":2,"o":{"r":{"e":25}}}},"ü":{"b":77,"c":0,"g":{"e":{"l":{"e":17}}}},"v":93,"w":214,"y":[{"a":2,"o":2,"p":3,"s":12},188],"z":[{"e":[{"i":{"t":132}},140]},205]},"c":{"a":[{"b":[{"l":1},12],"c":215,"e":23,"g":3,"h":0,"l":{"a":[{"b":25},2],"f":162,"t":4},"m":78,"n":[{"a":25},77],"p":{"e":6},"r":{"n":136,"r":{"i":132},"s":2},"s":{"a":216,"t":{"o":35}},"t":{"h":3},"y":32},85],"ä":[{"s":2},1],"b":71,"c":[{"e":71,"h":217},77],"d":[{"o":82},218],"e":{"c":77,"d":[{"r":6},75],"f":77,"i":[{"n":1},0],"k":77,"l":{"s":78},"n":{"a":4,"u":[{"n":4},1]},"o":2,"r":[{"a":4,"e":[{"u":25},48],"i":[{"s":5},3],"o":0},75],"s":{"h":16},"t":[{"a":[{"m":13},22]},75],"u":0},"é":75,"f":71,"g":115,"h":[{".":84,"a":{"b":[{"i":216},77],"c":{"k":2},"f":77,"g":219,"k":127,"l":{"l":{"e":{"i":58}}},"n":{"a":10,"c":78,"f":25,"g":0,"l":84,"z":84},"o":78,"r":{".":84,"a":78,"d":78,"t":{"a":78}},"s":{"c":2,"i":132},"t":{"o":75,"t":77},"u":{"s":{"t":{"r":7}},"t":25}},"ä":{"h":0,"r":{"m":0},"s":0},"â":75,"b":77,"c":77,"d":77,"e":{"b":[{"e":{"n":16}},9],"c":{"h":{"t":1}},"d":{"i":0},"e":{"l":2},"f":[{".":78,"e":{"r":12},"s":78},75],"h":77,"i":[{"m":0},77],"l":{"e":{"m":84,"r":12}},"m":{"i":78,"p":77},"n":{"e":{"b":12},"i":{"d":12},"o":2,"t":{"s":84,"w":84}},"r":{"a":162,"b":{"s":220},"g":{"e":{"b":221}},"k":{"e":84},"z":{"i":{"e":33}}},"s":{"s":57,"t":55},"t":{"a":222},"x":223},"é":75,"f":77,"g":77,"h":77,"i":{"a":75,"n":{"a":4,"d":84,"e":{"s":78},"f":77,"h":77,"s":127,"t":127,"v":127},"p":{".":75},"r":{"u":75},"s":{"o":77}},"j":77,"k":77,"l":[{"e":[{"i":[{"n":1},22],"n":5},6],"i":84,"u":6},158],"m":224,"n":[{"e":{"r":{"e":{"i":{".":175}}}}},225],"o":{"b":77,"f":[{"f":0,"s":10},2],"h":0,"l":{"a":37},"r":{"c":0,"e":{"i":12},"i":0},"s":6},"ö":{"l":1,"r":78},"p":77,"r":[{"a":[{"d":1},77],"e":77,"h":1,"i":{"t":84},"o":{"m":{"o":78},"n":78,"s":7}},226],"s":[{"p":{"o":6},"t":{"a":{"l":5}}},84],"t":[{"r":{"u":6}},77],"u":{"f":77,"h":77,"m":77,"n":{"f":127,"m":77,"t":77},"r":[{"s":0},77],"t":[{"t":10},77]},"ü":84,"v":77,"w":84,"y":75,"z":77},73],"i":{"c":0,"e":{"s":0},"n":{"d":71,"s":22,"t":71},"s":21,"t":91},"j":71,"k":[{".":84,"a":[{".":75,"b":108,"c":108,"d":6,"g":227,"l":77,"m":2,"n":77,"p":77,"r":99,"t":75},114],"ä":0,"b":77,"c":77,"d":77,"e":[{"c":108,"f":[{"f":84},127],"h":127,"i":228,"m":{"p":77},"n":{"a":12,"s":{"e":{"m":221}},"t":{"f":84,"w":84}},"r":{"a":2,"e":6,"g":{"e":{"b":221}},"h":{"ö":229},"k":19,"l":{"a":{"u":33}},"n":6,"o":108,"r":0,"z":{"e":{"u":221}}},"s":{"e":84},"t":6,"x":84},75],"f":77,"g":77,"h":77,"i":[{"d":219,"n":[{"t":84},0],"s":230},75],"k":77,"l":107,"m":77,"n":231,"o":[{"s":{"t":33}},173],"ö":3,"p":77,"r":107,"s":[{"a":{"l":2},"p":{"e":{"n":5}}},84],"t":[{"e":1,"i":3},77],"u":[{"h":127,"m":0,"n":{"t":77},"p":127},75],"ü":77,"v":77,"w":77,"y":75,"z":77},73],"l":[{"e":{"a":12,"t":10},"i":{"n":{"g":22},"p":[{"a":25},11]},"o":{"c":[{"k":2},13],"f":4},"u":[{"b":12},75]},218],"m":[{"e":82,"u":82},218],"o":[{"c":[{"h":1},6],"d":[{"i":1},232],"f":{"f":37},"i":[{"t":0},12],"k":{"e":6},"l":{"a":121,"e":{"u":6},"o":3},"m":{"t":{"e":{".":12,"s":102}}},"n":{"n":{"e":2}},"o":[{"p":13},6],"p":0,"r":{"a":0,"d":{"a":2},"e":5,"t":4},"s":{"t":4},"t":{"e":5},"u":{"s":{"i":4}}},85],"ô":5,"p":77,"q":93,"r":[{"ä":82,"e":[{"m":{"e":{"s":12}},"w":78},234],"i":77,"o":{"s":10},"y":77},233],"s":[{"a":6,"f":5,"i":89,"t":[{"i":72,"r":115},2]},77],"t":[{"i":[{"o":[{"n":17},235]},2],"u":{"r":33},"z":164},214],"u":[{"a":77,"e":6,"p":[{"e":13},23],"s":{"s":{"i":19}}},236],"w":71,"x":77,"y":75,"z":71},"d":{"a":{".":78,"a":0,"b":[{"a":{"k":79},"ä":73,"e":[{"n":79},73],"i":79,"l":{"u":1},"o":79,"r":{"a":12,"i":[{"e":1},6],"ü":237}},93],"c":[{"h":{"a":25,"o":6,"s":{"e":106}}},71],"d":[{"e":6,"o":6,"r":226},93],"f":[{"f":77,"l":120,"o":{"n":10}},71],"g":[{"i":10,"o":2},71],"h":[{"l":4},0],"i":{"l":55,"n":0,"r":93,"s":0},"k":{"r":{"o":6}},"l":{"a":[{"r":152},2],"b":37,"l":189,"o":{"p":6},"ö":1,"p":93,"t":[{"e":77},238],"ü":0},"m":[{"e":{"i":6},"m":{"a":71,"ä":189},"o":25,"p":[{"f":{"e":{"r":{"f":239}}}},73],"t":189},78],"n":{".":88,"a":[{"n":6,"t":240},71],"b":77,"c":{"e":{".":12}},"d":[{"a":77,"y":73},241],"e":[{"i":106},78],"f":77,"g":71,"h":77,"k":{"l":2,"o":11,"r":2},"l":77,"n":[{"a":77},71],"o":72,"s":93,"t":{"w":77},"w":77,"z":[{".":73,"i":77,"ü":77},71]},"p":[{"a":73,"h":73,"o":[{"s":1},6],"p":84,"t":{"e":82}},93],"q":84,"r":{"a":41,"b":154,"c":76,"d":{"e":11},"e":[{"n":132},22],"g":4,"k":{"a":22},"l":78,"m":{"a":11,"i":11,"u":12},"o":23,"s":78,"t":[{"h":2,"r":2},93],"u":6,"z":71},"s":[{"h":1,"p":238,"s":4,"t":12},32],"t":{"e":[{"i":1,"l":243,"n":10},242],"h":6,"l":76,"m":84,"o":82,"s":{"t":2},"t":{"a":76}},"u":{"b":78,"d":77,"e":[{"r":{"e":[{"i":33},17]}},37],"f":244,"g":76,"k":77,"n":{"t":1},"s":245,"ß":2},"w":78,"x":71},"ä":{"c":78,"g":93,"h":93,"m":{"t":93},"n":{"a":4,"d":93},"p":93,"q":77,"r":{"z":77},"u":[{"s":1},152],"x":77},"b":[{"a":{"u":{"c":[{"h":247},22]}},"e":{"e":2},"u":{"c":2}},246],"c":[{"h":82},77],"d":[{"a":82,"ä":82,"e":82,"h":82},248],"e":[{"a":{"d":2,"r":1,"t":3},"b":[{"ü":78},12],"c":[{"a":{".":5},"k":{"a":6}},0],"d":{"e":{"l":6},"i":{"t":6}},"e":223,"f":{"a":[{".":6},12],"f":93,"l":12},"g":[{"e":{"n":{"e":249}},"l":1},2],"h":{"a":2,"e":22,"n":78,"o":1,"r":93},"i":[{"c":88,"d":{"e":{"n":16}},"l":1,"m":[{"e":84},88],"n":{"d":22,"s":{"e":1,"t":[{"a":33,"i":33},1]},"w":106},"o":1,"s":{"e":77,"m":114,"p":2}},71],"k":{"z":77},"l":{"a":{"c":21,"d":{"e":12},"k":1,"u":{"g":14}},"ä":{"n":{"d":4}},"b":37,"d":4,"e":{"c":13,"g":87,"i":{"g":19},"k":77,"m":77,"n":6,"r":[{"r":19},105]},"f":{".":77,"m":77},"i":{"k":78},"l":{"a":[{"u":25},2],"ä":11,"e":[{"b":27,"i":12,"r":27},105]},"o":{"b":21,"p":6},"s":{"e":2,"o":2,"p":11},"t":9},"m":{"a":{"r":2},"b":93,"e":{"n":{"t":[{"g":24,"s":35},102]}},"i":{"n":1},"o":{"t":93},"p":93,"u":73},"n":{".":89,"a":{"m":2},"d":22,"e":{"d":125,"n":{"d":14},"p":6,"r":{"g":84},"s":3},"g":{"e":{".":250}},"i":6,"k":{"l":{"i":25}},"s":{"a":{"m":10},"c":{"h":{"o":26}},"e":[{"m":225,"r":{"e":26}},105],"t":{"a":{"u":46}}},"t":{"d":77,"f":77,"g":77,"h":4,"n":77,"w":77,"z":77},"z":{"e":{"r":{"s":26}}}},"o":{"b":6,"l":77},"p":{"l":12,"o":{"c":77}},"r":{".":89,"a":{"f":4,"k":6,"n":[{"d":1},22],"p":23,"s":[{"i":14},251]},"b":{"l":2,"s":189},"d":{"b":77},"e":{"b":125,"c":{"k":5},"i":{"s":39},"m":252,"n":[{"d":14},89],"r":[{"f":12,"n":17,"o":4,"t":19,"z":{"e":15}},252],"s":252,"u":23},"f":[{"l":89},10],"h":{"e":{"b":82},"ü":73},"i":{"d":23,"n":{"f":19,"n":{"u":24},"t":{"e":{"g":175}}}},"k":[{"l":{"ä":84}},37],"m":73,"o":0,"ö":22,"r":4,"s":{"t":[{"a":4},105]},"t":{"e":{"n":{"d":{"e":{".":45}}},"r":{"e":29}},"r":{"a":[{"g":[{"e":52},221]},10]}},"u":[{"h":5,"m":5},87],"z":{".":93,"v":93}},"s":{".":73,"a":[{"h":13,"m":5},6],"ä":{"n":21},"e":{"b":6,"h":110,"i":[{"l":5},6],"l":[{"t":4},93],"m":1,"n":{"d":16,"e":17},"t":6},"i":{"n":6},"o":[{"r":6},13],"p":[{"e":1,"u":1},21],"s":[{"t":10},22],"t":{"a":{"l":{"t":55}},"e":{"m":{"p":26},"r":{"n":7},"x":12},"o":0,"r":{"a":{"t":55},"i":1},"u":{"m":12}},"u":[{"n":13},6],"w":78},"t":[{"a":1,"e":{"n":{"t":19}},"h":152,"w":93},2],"u":{"l":93,"n":0,"r":{"l":0},"s":1},"v":{"i":{"d":152,"l":105}},"x":{"a":32,"e":{"r":6},"i":{"s":6},"p":{"e":77,"o":77}}},75],"f":253,"g":[{"a":{"s":{"t":{"r":25}}},"e":{".":73,"r":22,"s":[{"h":73},4],"t":{"a":162,"e":99}}},152],"h":[{"a":{"s":184},"o":84,"u":82},152],"i":[{"a":{"p":5,"s":254,"t":[{"h":5},10]},"c":[{"e":0,"h":{"l":1,"t":{"e":{"r":15}}},"k":{"e":{"l":186}},"o":243},78],"d":{"a":78,"e":[{"e":77,"n":6},71],"y":77},"e":[{"d":16,"n":{"b":1,"e":{"b":12,"r":{"l":29}},"i":3,"s":{"t":{"r":53}}},"p":2,"r":{"s":{".":1}},"s":{"c":48},"t":{"h":16}},6],"f":78,"g":[{"e":{"s":22},"n":12},78],"k":{"a":2},"l":{"s":162},"m":{"b":93,"p":77},"n":{"a":12,"d":93,"e":3,"f":93,"g":78,"h":93,"i":1,"j":93,"k":93,"s":93,"t":76,"v":93},"o":{"b":23,"n":{"i":{"n":25},"s":159},"r":{"a":1},"s":[{"k":6},22]},"p":[{"t":1},32],"r":{"a":72,"e":{".":5,"n":6},"i":{"n":6,"s":6},"l":93,"r":93},"s":{"a":125,"o":93,"p":[{"e":{"r":16}},6],"r":93,"t":[{"a":120,"e":23,"r":{"a":5}},22],"z":5},"t":{"a":6,"e":{"c":48,"r":{"l":14,"m":14,"s":14}},"h":{"e":0},"i":{"n":6},"o":{"b":6},"r":14,"s":4,"u":21},"v":47,"z":3},75],"j":[{"a":{"r":73}},93],"k":205,"l":[{"a":[{"g":4,"p":10},82],"e":[{"r":{"a":2}},82],"i":{"f":12},"m":1,"s":1},248],"m":161,"n":[{"i":[{"s":48},2]},243],"o":{"a":{"t":7},"b":[{"a":88,"s":2},93],"f":[{"e":6},71],"h":[{"a":1},93],"l":{"e":10,"l":[{"a":4},22],"y":79},"m":[{"a":{"l":6,"r":6},"e":{"n":132},"i":{"n":{"g":5}},"n":84,"u":6},78],"n":{"a":[{"n":1},2],"i":{"e":48},"y":84},"p":{"e":77,"f":93},"r":{"a":120,"c":93,"d":93,"f":{"a":11,"ä":2,"i":11,"l":2,"o":2,"r":2,"u":162},"g":93,"n":73,"t":[{"e":{"r":12},"r":12},77]},"s":[{".":73,"m":76,"s":4,"t":[{"a":25,"e":{"n":102},"u":5},99]},217],"t":{"a":1,"o":{"f":6}},"u":{"n":1},"w":{"s":2},"x":167},"ö":[{"d":6,"f":6,"l":[{"l":22},13],"n":73,"r":88,"s":{"c":21}},71],"p":[{"a":{"s":{"s":17}},"o":{"l":{"n":10},"s":{"t":132}}},243],"q":93,"r":[{"a":{".":147,"b":147,"d":106,"h":{"m":77},"k":76,"l":147,"m":{"p":82},"n":{"d":82,"k":25},"s":{"t":76},"t":{"i":{"n":12}},"u":{"b":77,"c":76,"f":89,"m":77,"p":77}},"ä":{"d":77,"h":89,"t":76,"u":76},"e":{".":84,"a":[{".":89,"s":89},76],"c":{"k":147},"f":76,"g":84,"h":[{"a":2},147],"i":{"c":76,"e":147,"v":89},"j":89,"l":{"i":132},"m":84,"n":106,"o":89,"p":106,"r":106,"s":{".":84,"c":89,"s":{"e":{"i":33,"l":33}}},"w":89,"z":77},"h":76,"i":{"a":89,"c":106,"e":{"g":82},"f":[{"f":106,"t":89},78],"n":{"d":106},"p":76,"s":{"i":76,"s":77},"t":{"u":76}},"o":{"b":76,"d":82,"g":{"g":77},"h":{"r":77,"u":147},"l":{"l":76},"s":{"e":76,"s":89,"t":76},"t":76,"u":76,"v":76,"w":82},"ö":{"s":{"c":2}},"u":{"b":140,"c":147,"d":76,"h":76,"t":255},"ü":{"b":13,"c":{"k":{"e":35}},"s":147}},206],"s":[{".":84,"a":[{"b":1,"d":104,"l":[{"k":73,"l":73},0],"m":{"t":114},"n":[{"e":1},73],"s":{"s":{"i":1}},"u":[{"t":73},22]},84],"ä":{"n":0,"u":6},"b":84,"c":{"h":{"e":{"f":89},"i":{"n":89}},"o":124,"r":73},"e":{"b":113,"e":2,"f":104,"h":{"r":0},"i":{"g":{"n":5},"n":73},"m":{"b":104},"n":{"e":{"r":25},"g":104,"t":104},"r":{"f":104,"h":73,"k":104,"l":104,"r":0,"s":104,"t":104,"z":73},"t":[{"a":104},12],"v":104,"x":73},"h":{"a":[{"k":6,"l":89},256],"o":[{"r":89},82]},"i":[{"d":73,"m":104,"n":{"f":79}},84],"k":{"a":{"l":6},"e":{"l":79},"o":89},"l":[{"i":89},84],"o":{"h":82,"p":73,"r":[{"i":0},2]},"ö":73,"p":{"a":{"s":0,"t":104},"ä":73,"e":{"c":104,"n":6,"r":{"i":89}},"h":86,"i":79,"o":{"r":[{"t":{"o":164}},6]},"r":{"i":82,"o":73},"u":6},"s":12,"t":[{"a":{"g":89,"s":73,"u":{"f":1}},"ä":{"t":{"i":128}},"e":[{"c":82,"i":[{"l":89},82],"l":{"l":140},"m":89,"n":89,"r":{"n":124}},73],"i":[{"l":5},6],"o":{"c":{"h":89},"l":5},"r":{"e":{"i":140},"o":124},"u":{"r":6}},2],"u":{"m":2,"n":73,"r":{"l":0}},"z":{"e":{"n":6}}},93],"t":[{"a":{"b":{"e":2},"c":[{"h":17},79],"d":2,"g":6,"n":[{"e":1},2],"s":79,"x":6},"e":{"a":140,"m":{"o":4},"t":6},"h":[{"e":{"i":89}},73],"o":[{"b":89,"p":6},257],"ö":82,"r":[{"a":{"n":105}},1],"s":{"a":1,"t":7},"t":12,"u":{"n":6,"r":79},"ü":82,"y":82},93],"u":[{"a":{"l":{"v":0},"r":0},"b":{"l":{"i":23}},"c":{"e":0},"e":{"l":{"l":{"a":25}}},"f":[{"e":93,"t":{"e":{"r":12},"o":12,"r":2}},6],"h":93,"i":[{"n":6},0],"k":{"r":6},"l":{"a":{"r":{"t":4}}},"m":{"b":93,"d":77,"e":258,"f":77,"g":77,"k":106,"l":77,"p":73,"r":77,"s":[{".":73},93],"v":93},"n":[{"d":76,"f":93,"g":[{"l":77},10],"i":93,"k":{"e":4,"l":2},"r":77,"s":[{"i":77,"t":{"r":17}},2],"t":77,"w":77,"z":76},6],"o":{"s":0},"p":12,"r":[{"a":{"u":4},"c":{"h":17},"k":93,"l":93,"n":93,"s":{"a":93},"t":259},2],"s":{"c":{"h":{"n":5,"r":5,"w":260}}}},75],"ü":[{"b":[{"e":{"r":82}},77]},75],"v":152,"w":[{"a":[{"r":12},2],"e":{"r":{"t":{"e":25}},"s":[{"t":132},22]}},93],"y":[{"l":21,"m":4,"n":78,"s":{"c":21,"p":6}},75],"z":243},"e":{"a":[{"b":{"e":6,"l":23,"r":5},"c":6,"d":{"l":{"i":19},"r":79},"g":[{"a":57,"l":16},6],"k":{"t":[{"a":73,"o":82},22]},"l":{"a":6,"e":{"i":82,"m":89,"n":{"t":14,"z":19},"r":[{"g":124},105],"x":82},"i":{"n":79},"o":[{"n":6,"p":6},13],"t":{"i":261,"r":4},"u":118},"m":[{"e":237,"o":13,"t":22},4],"n":{"a":[{"r":37},5],"f":82,"o":73},"r":{".":82,"a":[{"t":1},6],"e":[{".":89,"i":21,"n":{"e":5},"r":89,"s":89},73],"o":6,"z":82},"s":{"c":79,"f":82,"i":{"n":19},"p":5,"s":4},"t":{"e":[{"r":132},22],"m":{"e":{"s":12},"u":[{"n":12},2]},"r":7,"s":37,"t":262,"u":22},"u":{"e":82,"f":[{"e":2,"l":12,"o":89},82],"n":4},"v":73,"z":73},93],"ä":79,"b":[{"a":[{"k":82,"p":2},77],"ä":{"n":82},"e":{"c":77,"e":{"r":13},"i":{"n":{"h":63}},"l":[{"e":{"r":12},"o":2,"s":{"t":[{"e":55},19]}},6],"n":{"e":{"n":247}},"r":{"a":{"s":12},"t":19},"s":{"e":[{"h":27},105],"o":2},"t":[{"s":10},77]},"h":77,"i":77,"l":[{"ä":82,"e":{".":1,"r":1,"u":5},"i":{"e":82},"o":1,"ö":6},77],"o":[{"b":73,"t":22},77],"ö":{"s":2},"r":[{"a":{"u":140},"e":{"a":5}},77],"s":[{"c":{"h":{"e":5}},"e":22,"p":{"a":{"n":{"n":{"e":263}}}},"t":{"a":{"u":4},"ä":{"t":5},"e":{"m":4},"h":37,"i":4,"r":1}},21],"u":[{"n":{"t":73},"t":162},77],"y":{"t":12}},71],"c":{"a":76,"e":76,"h":{"a":{"m":13},"ä":13,"e":[{"i":13,"n":264,"r":{"z":{"i":265}}},93],"i":71,"l":4,"m":4,"n":4,"o":{".":73},"ö":37,"r":[{"i":12},4],"s":{"e":{"r":10},"t":{"r":{"e":54}}},"t":{"a":{"b":4},"e":{"i":9,"r":{"h":[{"a":64},26]}}},"u":71,"w":13,"z":77},"i":[{"a":2},71],"k":[{"e":{"n":160,"r":{"r":89}},"s":{"e":{"r":4},"t":{"a":12}},"t":[{"y":78},77]},5],"l":93,"o":77,"r":76,"s":0,"t":77},"d":[{"a":6,"d":{"r":6},"e":[{"a":{"l":2},"n":{"e":{"r":9},"s":[{"a":10,"e":10,"p":10},132]},"o":22,"r":[{"a":[{"t":4},25],"t":266},2],"s":{"t":22}},5],"i":[{".":82,"p":77,"t":{"e":{"n":{"g":26}}}},6],"o":79,"ö":6,"r":{"e":{"i":82},"ö":5},"s":{"a":{"l":6},"e":{"h":5,"s":21},"i":6,"o":21,"p":21,"t":{"o":6,"r":23},"u":21},"u":{"n":[{"d":105},25]},"y":[{"s":10},171]},71],"e":[{"a":16,"b":{"l":2},"c":[{"e":5,"h":{"o":6},"k":72},0],"d":{"e":[{"s":48},25],"s":37},"e":32,"f":{"f":71,"l":12},"g":12,"i":[{"e":23,"n":{"s":{"e":10}},"s":{"c":12,"s":25}},71],"l":{"a":73,"e":[{"k":79,"n":10},2],"ö":2},"m":{"a":167,"b":71,"i":{"n":1},"p":71},"n":[{"a":{"g":22},"ä":73,"c":73,"e":13,"g":82,"i":1,"k":82,"l":82,"o":156,"s":4,"z":2},71],"o":1,"p":[{"o":1},73],"r":{"a":{"t":12},"b":{"t":71},"d":71,"e":[{"i":13,"n":{"g":39},"s":242,"t":[{"i":4},22]},1],"m":{"ä":71},"o":0,"ö":[{"f":71,"s":2},0],"u":{"n":3},"z":71},"s":[{"h":1,"k":4,"p":1,"t":16},32],"t":{".":73,"a":[{"t":5},3],"h":6,"i":2,"r":16,"u":6},"u":32,"w":{"a":{"r":10}},"x":72},77],"f":[{"a":{"d":104,"h":82,"n":{"a":0},"r":[{"c":73,"m":1},0],"t":73},"ä":[{"l":6,"u":73},77],"e":[{"b":113,"f":82,"l":{"e":{"i":27}},"m":[{"i":73},0],"n":[{"e":188,"t":73},11],"r":{"f":55,"i":{"n":{"d":29}}},"u":{"i":{"l":102}}},77],"f":{"e":{"k":78},"i":75,"l":[{"u":1},6]},"i":[{"d":0,"n":{"s":104},"s":2},77],"l":[{"e":5,"u":124,"ü":82},77],"o":161,"r":[{"e":{"i":{"h":5}},"o":{"l":1,"m":1},"u":5,"ü":5},77],"s":[{"c":12,"o":1,"p":1},2],"t":{"a":{"n":6},"e":{"i":6},"r":{"o":6}},"u":[{"m":73},77]},71],"g":[{"a":{"m":2,"n":{"z":79}},"d":12,"e":[{"i":{"n":17},"l":{"a":{"n":12,"u":27},"e":{"i":{"e":{"r":267}},"r":12},"o":2},"n":[{"a":99,"e":{"r":{"o":26}}},6],"r":{"a":2},"s":{"t":{"a":{"l":35},"r":27}},"u":13},82],"i":77,"l":[{"o":73,"u":73},77],"n":[{"ä":1,"i":1},73],"o":{"p":13},"s":{"a":{"l":5,"u":{"g":17}},"e":[{"i":5,"l":25},1],"i":1,"k":5,"t":[{"o":5},22]},"t":{"h":6},"u":{"n":{"g":19},"s":25}},71],"h":{"a":[{"c":{"h":0},"d":[{"e":6},0],"h":79,"l":[{"t":{"s":19}},6],"n":{"d":82},"r":{"z":73},"u":{"t":82}},93],"ä":71,"e":[{"f":{"f":0},"i":{"n":0},"l":{"t":0},"n":{"s":{"e":89},"t":{"e":128,"r":33}},"o":4,"p":85,"r":[{"a":13,"f":117,"l":117},77],"s":{"t":{"r":4}}},71],"i":[{"m":1},93],"l":{"a":{"m":0,"u":23},"ä":0,"e":{"i":{"n":4},"n":{"t":5},"r":47},"o":[{"r":13},22],"ö":6,"s":{"e":2,"t":22}},"m":[{"a":{"b":6,"n":{"t":5}},"u":1},77],"n":{"a":1,"o":1},"o":[{"f":2,"l":[{"y":1},2]},93],"ö":[{"r":{"e":{"r":12}}},76],"r":{"a":125,"ä":13,"e":{"c":100,"i":6,"l":6,"r":{"l":{"e":26},"n":12},"s":25},"i":{"n":5},"o":{"c":0,"f":13},"ö":0},"s":[{"h":1,"t":{"e":0}},2],"t":[{"h":4,"r":12},173],"u":[{"m":73,"n":{"f":0,"i":73},"r":82},93],"ü":[{"b":1},71],"w":0,"y":71},"i":{"a":[{"t":12},173],"b":{"a":{"r":6},"l":{"i":6,"u":5},"u":{"t":[{"e":14},10]}},"c":[{"e":0,"h":{"o":6}},89],"d":[{"a":21,"e":[{"i":{"s":5},"r":{"r":{"e":35}}},1],"n":77,"o":1,"r":1},73],"e":[{"b":2,"d":2,"l":3,"m":2,"n":[{"g":{"e":102}},268],"s":1,"t":2},0],"f":{".":84,"l":{"o":0},"r":75,"t":4},"g":{".":77,"a":[{"r":2},77],"ä":77,"e":{".":77,"b":77,"h":77,"n":{"o":84,"s":{"c":194}},"r":269,"s":77,"w":77},"i":77,"n":270,"o":6,"r":{"a":{"t":14},"e":77,"ö":77,"u":77,"ü":77},"s":77,"t":77,"u":77},"h":[{"u":{"m":6}},84],"k":{"a":{"b":6,"k":6,"m":12,"r":2},"i":2,"l":[{"a":16,"ä":1},2],"o":2},"l":[{".":84,"a":{"b":14,"m":6,"n":[{"e":14,"g":5,"z":5},22],"r":6},"b":77,"d":9,"e":{"i":{"n":5},"n":163,"t":6},"f":9,"m":22,"o":{"b":6},"ö":2},73],"m":{".":77,"a":{"b":6,"g":21,"l":{"l":4,"p":4}},"o":{"r":21},"ö":77,"p":[{"l":271},77],"s":{"a":4},"u":{"r":6}},"n":{"a":[{"d":110,"e":5,"n":14,"s":49,"t":14},272],"ä":23,"d":{"e":[{"r":{"k":26}},37],"u":71},"e":{"b":77,"n":{"e":19,"g":39,"s":{"e":273}},"r":{"b":{"e":35},"f":5,"k":5,"l":{"a":274},"s":{"c":15}},"u":6},"f":{"i":{"z":12},"o":[{".":12,"s":12},77]},"g":[{"e":{"r":78},"r":73},37],"h":{"ä":73},"i":{"e":6,"t":71},"k":[{"a":{"r":{"n":26}},"ä":78},9],"l":73,"n":[{"a":78},37],"o":125,"r":{"i":75},"s":{"a":[{"t":78},164],"c":[{"h":{"ä":194}},73],"t":{"a":{"l":26}}},"t":{"e":{"r":{"v":26}},"ö":78},"u":75},"o":[{"p":2,"s":12},1],"p":[{"f":2},0],"r":[{"c":2,"e":1,"r":71},77],"s":{".":89,"a":[{"s":1},6],"c":{"h":{"w":{"u":24}}},"e":[{"r":{"g":42,"l":39,"s":{"t":20},"w":14}},89],"h":{"o":75},"k":{"y":3},"o":6,"p":{"e":2},"s":[{"e":{"r":{"s":29}}},73],"t":{"o":228},"u":{"m":6,"r":6},"w":{"o":75}},"t":[{"a":{"b":125,"l":6,"n":21,"p":6,"r":6,"t":5},"ä":[{"n":6},77],"e":{"r":{"a":10},"s":{"s":5}},"h":21,"i":{"n":6},"o":22,"r":{"a":{"u":5},"o":5},"s":{"a":{"g":19}},"t":9,"u":[{"m":41,"r":21},84],"z":37},73],"v":[{"e":10},2],"z":{"a":{"r":6},"i":{"n":13}}},"j":76,"k":[{".":77,"a":161,"d":75,"e":[{".":82,"n":275,"s":82,"y":82},6],"l":[{"o":5},79],"n":5,"o":[{"r":{"d":{"a":10}}},79],"r":76,"s":{"p":41},"t":[{"a":{"n":[{"t":{"e":18}},6],"t":4},"ä":21,"e":{"l":36,"r":{"f":4,"k":4,"z":39}},"o":[{"b":254},2],"r":{"i":7}},84],"u":[{"r":{"a":22}},76],"w":79,"z":75},71],"l":{"a":[{"b":{"t":6,"u":1},"c":{"k":2},"d":{"e":{"r":1}},"f":0,"h":12,"k":104,"m":[{"i":23,"p":82},113],"n":{"a":0,"d":{"a":89},"m":73,"s":114,"t":104,"w":89,"z":0},"o":77,"p":104,"r":[{"i":3},104],"s":[{"i":120,"p":0,"u":4},2],"u":{"f":{"w":1}}},71],"ä":93,"b":{"i":{"l":77},"r":77},"d":[{"a":{"r":[{"i":4,"m":12},22]},"e":{"r":{"f":14,"p":19,"s":[{"t":35},19]},"s":1},"s":22},77],"e":{".":106,"a":[{"r":22},76],"b":76,"c":[{"h":0},269],"f":{"a":75},"g":{"s":25},"h":[{"e":{".":1}},84],"i":[{"e":{"r":{"n":276}},"n":[{"e":82},104],"t":140},77],"k":[{"o":77},75],"l":104,"m":[{".":76,"a":82,"i":2,"m":82,"p":127},85],"n":{".":76,"k":{"l":277},"s":{"e":89},"t":104},"p":82,"r":[{".":82,"a":22,"d":0,"e":{"i":{"g":164}},"f":[{"a":278,"i":89},0],"g":73,"h":0,"k":0,"l":104,"n":{"ä":128},"ö":22,"r":104,"u":1,"w":0},77],"s":{"s":104},"t":{"a":131,"i":2,"t":{"a":10}},"x":[{".":82},127]},"f":{".":75,"e":{"r":2},"m":75,"r":12,"t":75},"g":{"i":{"e":{"r":{".":55,"s":55}}},"l":3,"r":12},"i":{"d":104,"e":[{"f":{".":4}},76],"g":77,"m":73,"n":{"a":25,"o":4,"s":0}},"k":77,"l":{"a":{"r":{"b":5,"t":19}},"ä":{"r":1},"e":{".":7,"i":[{"n":4,"s":4},2],"l":5,"n":{"d":7,"e":{"n":279}},"r":[{"f":{"a":{"s":175}},"g":63,"h":4},2],"s":1},"i":{"m":6,"p":75},"o":{"r":6},"ö":2,"s":{"p":4}},"m":{"a":1,"e":[{"i":{"n":4}},2]},"n":[{"a":1},77],"o":[{"a":86,"f":73,"l":73,"m":73,"n":{"k":73},"p":{"f":0},"r":[{"e":82,"i":2},104],"t":82,"v":79},77],"ö":[{"s":2},77],"p":16,"s":{"e":{"i":{"n":198},"n":1},"t":{"r":{"i":12}},"u":{"m":6}},"t":{"a":{"n":{"s":5}},"e":{"m":10,"n":{".":7,"t":14},"r":{"b":19,"f":19,"h":4,"l":{"e":15},"n":280,"o":35,"s":{"c":15}},"s":[{"c":5},22],"t":{"h":4}},"h":{"e":1},"r":{"i":7},"s":{"p":{"a":25}}},"u":[{"f":0,"m":104,"r":167,"s":[{"e":1},2],"t":[{"o":1},2]},93],"ü":71,"y":[{"a":73},77],"z":{"a":{"c":3,"r":6},"e":{"n":{"e":5}},"i":{"n":13},"w":{"a":6},"y":77}},"m":[{"a":{"b":167,"l":{"k":104},"n":{"f":1,"o":104,"s":0,"z":75},"s":{"p":281},"u":0},"ä":[{"h":6},76],"b":{"a":75,"o":75,"r":{"y":75}},"d":{"ä":6,"r":[{"a":6},13]},"e":[{"b":113,"f":73,"i":2,"l":{"e":73},"n":[{"g":{"e":{"l":33}},"t":{"h":277}},6],"r":{"i":37,"l":117,"w":0},"s":{"u":89},"t":{"i":88}},77],"i":{"d":113,"e":{"i":2},"g":73,"k":22,"m":0,"n":[{"a":37,"d":82,"t":0},77],"r":85,"s":{"c":82},"t":{"r":4}},"m":{"a":{"u":25},"e":{"i":21}},"o":{"a":73,"l":82,"s":4},"p":{"f":[{"l":1},282],"o":[{"s":48},1]},"s":{"a":6,"c":{"h":{"a":5}},"e":{"i":5},"i":{"m":6},"p":{"r":6},"t":[{"r":[{"o":4},35]},6]},"t":3,"u":{"l":[{"s":78},85],"n":{"e":63},"r":82},"ü":77},71],"n":{"a":[{".":84,"b":[{"a":1,"o":1},234],"c":[{"h":{"e":1},"k":128},269],"d":{"i":19},"f":89,"h":84,"k":1,"l":[{"a":22,"b":89,"e":82,"g":6,"i":37,"k":89,"m":89,"o":89,"p":25},0],"m":228,"n":[{"d":89,"e":1,"t":89,"z":89},12],"p":[{"a":2},0],"r":{"e":1,"k":1,"o":1},"s":[{"c":2,"t":89},0],"t":[{"i":214,"l":89,"s":10,"t":128,"u":84},77],"u":{"f":283,"g":1,"r":128,"s":{"t":{"a":164}},"t":89},"x":32,"z":120},73],"ä":[{"b":1,"i":82,"r":73,"s":[{"t":1},23]},0],"c":{"e":{".":6}},"d":{"a":{"c":2,"l":6,"n":{"g":5}},"e":{"l":[{"ä":10},77],"s":{"s":39},"x":6},"i":{"d":6},"o":{"r":{"t":16}},"s":{"a":{"u":9},"l":37,"p":37,"z":4},"u":{"m":3},"ü":3},"e":{".":77,"b":{"e":{"n":16}},"c":32,"f":{"f":73},"h":2,"i":{"d":6,"e":{"n":82},"g":{"e":89,"u":84},"n":89,"s":89},"l":[{"e":12},104],"m":[{"i":104},108],"n":[{"s":{"e":89},"t":[{"r":5},114],"v":{"i":1}},77],"p":0,"r":{".":106,"a":6,"d":104,"e":{"i":1},"f":[{"r":5},73],"g":75,"h":73,"k":73,"l":104,"m":{"i":89,"o":128},"n":[{"e":128},84],"o":2,"r":104,"s":[{".":84},0],"t":[{".":5},104],"u":86,"w":104},"s":[{".":82,"c":113,"k":104,"s":104},77],"t":{"a":0,"h":104},"u":{"l":0},"v":113,"x":234},"f":[{"u":2},1],"g":{"a":{"d":75,"g":75,"l":3},"e":{"r":{"a":159}},"i":3,"n":1,"o":3,"p":75,"r":{"a":12},"s":{"e":4}},"i":[{".":82,"c":82,"e":[{"r":{".":4,"p":4,"s":{".":35}}},106],"k":{"o":3},"l":{"l":1},"m":[{"a":0,"i":0},12],"n":104,"o":82,"ö":2,"r":73,"s":{"a":12,"o":128},"t":256,"v":82},77],"k":{"a":{"u":{"s":4}},"e":{"l":{"i":78},"r":{"g":4,"k":14}},"ü":3},"n":{"e":{"f":6,"l":6,"r":{"f":42,"g":4,"l":14}},"i":[{"g":{"e":{"r":33}},"v":77},2],"s":[{"t":{"e":4}},22]},"o":{"a":86,"b":[{"e":{"l":82},"r":2},104],"f":73,"l":{"m":1},"m":{"a":2},"n":12,"p":104,"r":[{"a":6,"i":12,"m":84},113],"s":{"t":104},"t":106,"w":2},"ö":[{"d":32},93],"s":{"a":{"b":{"b":1},"n":6},"c":{"h":{"e":7}},"e":{"b":6,"m":75,"n":{"e":17},"r":{"e":4}},"p":{"o":[{"r":12},1]},"t":{"a":{"l":{"t":55}},"ä":{"t":14},"e":{"l":12,"m":{"p":26}},"h":2,"o":77,"ü":22}},"t":{"a":{"g":47,"n":{"m":5,"w":5},"r":{"k":16}},"d":75,"e":{"l":3,"n":22,"r":{"a":78,"b":5}},"f":[{"o":77},75],"g":[{"e":{"g":78}},75],"h":{"i":6,"u":75,"ü":75},"i":{"d":41},"l":{"a":78},"n":75,"o":{"b":6,"p":{"f":247},"s":21},"ö":77,"r":{"o":{"l":14}},"s":{"c":75,"o":75,"t":{"o":12}},"w":[{"e":{"t":84},"i":{"c":78}},75],"z":75},"u":[{".":82,"r":284,"t":[{"o":89},158]},104],"ü":[{"s":{"t":13}},71],"w":{"ü":84},"y":93,"z":{"a":{"r":{"e":1}},"ä":{"p":2},"e":{"p":75,"r":{"g":4,"k":14,"l":5,"m":14,"s":{"c":35}}},"i":{"d":22},"l":{"a":{"n":102}},"o":{"l":22},"y":75}},"ñ":71,"o":[{"b":[{"e":{"n":1},"l":1,"o":1,"r":1},285],"c":[{"h":22},0],"d":{"r":1},"f":71,"g":3,"h":71,"l":{"a":1,"y":79},"n":[{"a":{"t":79}},71],"o":0,"p":{"f":71,"r":12},"r":[{".":82,"a":0,"b":82,"g":{"i":132},"s":82,"t":22,"w":82},71],"s":[{".":82,"e":1,"t":{"e":71}},32],"u":[{"l":0},286]},84],"ö":115,"p":[{"a":[{"g":2,"s":{"s":{"e":{"r":33}}}},80],"e":{"r":77},"f":[{"i":140},287],"i":{"d":85,"g":73,"k":73,"l":{"e":85},"o":82,"s":[{"t":77},75],"t":85},"l":{"e":1},"o":{"c":75,"r":{"t":19},"s":{".":85}},"p":{"a":21,"e":{"l":25},"l":6,"r":6},"r":77,"s":{"h":1},"t":{"a":{"l":6,"n":2,"u":6}},"u":[{"s":2},76]},71],"q":106,"r":{"a":[{".":82,"b":{"e":2},"c":{"h":167},"d":{".":82,"i":82,"j":73,"m":[{"i":89},73],"r":128},"f":{"a":10},"g":2,"h":71,"i":[{"c":1},71],"k":{"e":82},"l":{"d":71,"e":{"b":10},"k":{"e":1},"l":86},"n":{".":6,"a":288,"d":[{".":82},25],"g":{"r":89},"h":73,"o":73},"p":[{"a":1,"f":1},71],"r":[{"e":1,"i":82},73],"s":{".":82,"i":2,"t":71},"ß":2,"t":{"e":{"l":89},"l":73},"u":{"b":71,"c":71,"e":1,"f":22,"g":1},"v":289,"w":71,"x":86,"z":71},0],"ä":[{"f":0,"h":0,"m":32,"p":0,"s":104,"t":{"z":0}},71],"b":{"a":{"r":{"m":78},"u":2},"e":2,"r":{"u":77},"s":{"p":2}},"c":[{"h":{"l":1,"o":22}},0],"d":{"a":{"m":[{"e":25},2]},"b":75,"e":{"c":77,"l":77,"n":{"g":39},"r":{"w":4},"s":{"t":19},"u":105},"g":75,"s":{"t":4},"y":77},"e":{".":84,"b":{"e":{"n":16}},"c":{"h":[{"s":1},79],"k":32},"d":{"i":[{"t":12},0]},"f":{"f":0},"h":113,"i":[{".":106,"b":82,"g":0,"h":84,"m":{"e":128},"n":{"k":89},"s":{".":1,"a":{"r":7},"b":1,"f":1,"r":1,"t":{"r":55}}},12],"k":89,"l":[{"e":[{"v":4},73],"i":132},32],"m":[{".":84,"i":[{"s":12},0],"p":73},77],"n":[{".":106,"a":82,"e":48,"s":{"e":89},"t":{"n":89,"s":89},"z":[{"e":{"n":{"d":51}}},82]},77],"p":{"e":0},"r":{".":84,"b":77,"f":{"a":25,"o":128},"h":73,"k":73,"l":[{"a":{"u":55}},97],"n":{".":84,"e":89},"o":97,"r":{"i":10},"s":[{".":84,"c":{"h":{"e":290}}},0],"t":73,"v":77,"w":77},"s":[{".":84,"p":2,"s":[{"k":25},0]},77],"t":{"a":0},"u":0,"v":{"i":{"d":12}}},"f":{"e":2,"o":{"r":{"m":84}},"r":12,"ü":{"r":84}},"g":{"a":{"r":{"e":14}},"e":{"b":{"i":84,"n":78,"ü":84},"h":{"a":84,"ä":84},"l":{"s":[{"t":35},191]},"n":{"i":84}},"n":77,"o":{"p":6},"r":{"e":{"m":84}},"s":[{"o":37,"p":22,"t":10},13]},"h":[{"a":{"b":75,"g":1,"i":77,"l":{"s":84},"m":77,"n":77,"s":77},"e":{"i":1,"r":77},"u":1},89],"i":[{"a":{"t":73},"b":82,"c":[{"o":128},106],"d":0,"e":[{"n":291},106],"k":[{"l":10},171],"n":{".":106,"d":104,"i":104,"k":0,"l":0,"t":0,"z":0},"o":{"n":289},"s":[{"o":73,"r":73},84],"t":{"a":0,"r":78},"v":82},77],"k":{".":77,"a":{"j":77},"e":{"r":1},"l":{"ä":75},"m":77,"r":{"e":77},"t":195,"u":{"m":6}},"l":{".":77,"a":{"g":77},"e":{"b":{"n":78},"h":84},"n":77},"m":[{"e":{"n":{"s":19},"r":{"s":14}}},3],"n":{"a":{"l":{"t":14}},"e":[{"n":{"e":5},"r":{"f":5,"k":5},"u":{"e":78}},1],"o":{"b":6,"r":22,"s":13}},"o":{".":93,"a":71,"b":[{"l":2,"r":2},0],"f":113,"g":71,"h":71,"k":71,"l":[{"y":1},71],"m":[{"b":1},71],"n":76,"o":104,"p":0,"r":[{"a":22},292],"s":[{"i":[{"t":82},75]},71],"u":71,"w":71,"x":32,"z":0},"ö":{"d":2,"h":77,"l":12,"s":[{"c":2},0]},"p":1,"r":{"ä":1,"e":{"n":77},"o":1,"ü":77},"s":{"a":[{"n":{"a":12}},3],"c":{"h":[{"n":7},19]},"e":{"i":84,"l":2,"n":1},"i":47,"k":1,"t":{"e":{"d":84,"l":1,"r":{"s":55}},"i":{"l":84},"o":{"d":12},"r":26},"w":{"i":1},"z":1},"t":{"a":{"b":13,"t":1},"e":{"r":{"f":14,"g":39,"h":42,"k":42,"s":5}},"h":[{"o":6},13],"ö":84,"r":{"i":7,"u":84},"s":{"e":22,"p":22}},"u":[{"f":{"s":277},"h":{"r":128},"m":293,"n":{"d":[{"u":89},0],"g":19},"p":{".":0},"r":1,"s":{"e":1},"z":86},77],"ü":{"b":12},"w":{"e":{"c":{"k":78}}},"z":{"e":{"r":{"k":5,"s":14}}}},"s":{"a":{"b":[{"e":89},1],"d":113,"f":82,"k":1,"l":{"l":128},"m":{"i":0,"p":{"l":1}},"n":{"k":6,"m":6,"r":6,"z":1},"p":[{"a":6},82],"r":{"a":2},"s":[{"t":6},257],"v":2,"x":0},"b":[{"i":{"e":{"r":{".":55}}}},77],"c":{"e":79,"h":[{"i":5},22]},"e":{"c":86,"h":{"r":0},"i":{"n":{"s":19}},"l":6,"n":{"a":{"l":12},"e":{"u":12},"o":25,"s":[{"k":25},6],"t":{"h":25}},"r":{"a":{"t":10},"u":294},"s":{"k":22},"x":167},"f":77,"h":[{"a":{"r":6},"e":1},77],"i":[{"e":{"r":13},"k":167,"l":104,"s":{"t":2}},77],"k":{"a":{"t":6},"e":128,"l":128,"u":1,"y":128},"l":1,"m":77,"o":{"a":86,"b":128,"d":104,"h":6,"r":[{"a":0,"e":4,"t":6},2],"t":82},"ö":79,"p":[{"a":{"l":82,"r":{"k":5}},"e":{"k":6,"r":{"s":89}},"h":73,"i":79,"o":{"r":79}},84],"r":77,"s":{".":77,"a":{"g":21,"l":{"i":247},"u":{"s":19},"y":75},"ä":77,"c":107,"e":{"r":{"e":26,"f":12,"g":4,"l":{"a":274}}},"k":77,"o":[{"f":6},77],"p":[{"a":21,"u":6},77],"t":{"a":{"b":5},"i":{"e":4},"u":1}},"t":{"a":{"b":{"b":19},"g":{"e":25},"k":13,"n":{"b":5,"g":5,"t":89},"p":286,"r":[{"b":89},71],"s":94,"t":[{".":89},71],"u":{"m":89,"s":89}},"e":{"c":6,"i":[{"n":{"g":35,"k":35,"l":35}},10],"l":241,"m":{"i":14},"n":[{"g":14,"t":{"r":35}},89],"r":{"h":{"a":35},"ö":42,"z":14},"s":{"s":14}},"h":6,"i":{"d":6,"g":89,"l":71,"p":73,"s":6},"m":{"o":{"d":{"e":15}}},"n":75,"o":{"m":73},"r":{"e":{"c":82},"i":5,"ö":71},"u":[{"m":{"s":4},"r":6},71],"ü":295,"y":82},"u":{"h":82,"m":[{"s":1},104],"n":{"t":1},"r":0,"s":12},"w":107,"y":82,"z":[{"e":{"n":{"e":5}}},1]},"ß":[{"e":{"l":104,"n":{"t":73},"r":{"e":4,"g":117,"l":104}},"t":1},93],"t":[{"a":{"b":10,"c":2,"f":76,"l":77,"m":{"i":0},"n":{".":5},"t":[{"r":25},5]},"ä":{"h":0},"e":[{"e":2,"f":114,"i":{"n":114},"k":{"e":4},"n":{"d":266},"o":2,"r":{"h":{"ö":10},"o":13,"t":{"r":10}},"s":2},76],"h":{".":77,"a":[{"l":128},6],"e":82,"i":[{"k":89},6],"n":78,"u":6},"i":{"d":296,"m":2,"n":[{"i":0},48],"t":[{"a":2,"h":2},6]},"l":1,"o":[{"b":73,"f":296,"n":[{"a":{"l":27},"s":19},5],"r":{"g":89},"s":2},76],"r":[{"a":{"d":1,"u":{"m":89}},"e":{"c":1,"s":86},"o":{"s":5}},77],"s":{"c":[{"h":{"e":{"r":{"e":297}},"w":17}},2],"p":[{"e":6},13],"t":{"e":6}},"t":{"a":[{"b":36,"d":6,"k":6,"n":{"s":5},"s":2,"u":6},13],"e":{"i":6,"n":160,"r":12},"h":21,"r":23,"u":{"m":21}},"u":{"i":88,"r":82},"ü":82,"w":{"a":{"r":10}},"y":{"m":85},"z":[{"w":6},77]},71],"u":{"a":32,"b":16,"c":[{"h":{"t":{"a":10}}},77],"d":[{"e":{"s":48},"i":{"e":10}},77],"e":[{"b":6,"r":{"e":{"i":{"f":46,"s":26},"r":{"s":29,"t":29}},"i":1,"k":1,"r":1},"s":{"c":6}},77],"f":[{"e":{"r":6}},84],"g":{"a":21,"e":{"m":{"i":10},"n":{"s":{"e":24}},"r":3},"i":{"n":[{"f":19,"g":42},105]},"r":{"e":6,"i":6},"s":[{"p":4},10]},"h":1,"i":{"d":0,"n":298},"k":[{"a":{"l":75},"ä":6},89],"l":{"a":{"n":[{"d":247},105]},"e":3,"i":2},"m":[{".":82,"a":16,"b":82,"f":82,"l":82,"s":[{"t":35},299],"w":82},93],"n":[{"a":6,"e":[{"i":5},2],"g":257,"i":{"o":6,"s":5},"k":[{"a":4},22]},77],"o":32,"p":[{".":71,"f":3,"g":82},0],"r":{"a":{"n":41,"s":{"t":14},"t":25,"u":6},"c":13,"e":[{"n":[{"s":5},105],"r":12},73],"f":9,"o":75},"s":[{"a":{"r":82},"c":{"h":{"o":19}},"i":2,"k":5,"p":1,"t":[{"a":0,"o":0,"r":120},10]},77],"t":[{"e":2,"h":[{"a":87},2],"i":2,"o":47,"s":{"c":{"h":{"a":26,"n":26,"r":26}}}},77],"x":77,"z":{"a":6,"o":6,"w":21}},"ü":82,"v":[{"a":{"k":73,"r":82,"s":27},"e":[{"r":{"i":35}},80],"i":{"e":{"l":{"e":25}}},"o":{"r":76}},71],"w":[{"ä":{"s":2},"e":{".":73,"i":{"s":{"c":10}},"r":{"t":[{"e":25},19]}},"i":{"r":82,"s":2,"t":82}},71],"x":{".":77,"a":{"m":75,"t":1},"c":77,"d":77,"e":{"l":73,"r":0,"s":77},"i":[{"k":77,"l":73,"n":104,"o":82,"s":75},71],"l":1,"p":[{"u":77},75],"s":77,"t":{".":77,"a":80,"i":{"n":6},"r":75,"u":77,"v":77},"u":[{"m":73},77],"y":93},"y":[{"l":2,"n":[{"o":1},6],"s":12},127],"z":[{"a":79,"ä":6,"e":{"n":{"n":104}},"i":[{"s":2},82],"o":79,"w":6,"z":3},71]},"é":{"b":71,"c":71,"g":[{"i":2},71],"h":71,"l":[{"u":2},72],"m":72,"n":71,"o":71,"p":71,"r":72,"s":[{"i":{"s":2}},71],"t":71,"u":72,"v":71,"z":72},"è":{"c":71,"m":71,"n":{"e":[{"s":10},13]},"r":71},"ë":{"n":75,"t":71},"ê":{"p":71,"t":89},"f":{"a":[{"b":[{"b":300,"e":{"n":6},"f":77,"g":77,"l":301,"n":77,"r":88,"s":300,"w":77},12],"c":{"h":{"e":{"b":5,"l":5},"i":302,"o":6,"s":{"p":159}}},"d":{"a":{"n":6},"e":{"l":6,"r":71},"i":6,"r":6},"e":1,"h":{"l":{"e":{"n":{"t":46}}},"r":{"e":78,"t":194}},"i":{"b":4},"k":{"a":72,"e":6,"t":{"i":{"o":82},"o":89},"u":88},"l":{"a":1,"e":1,"k":{"l":2},"l":{"a":11,"e":{"i":27,"n":{"t":55},"r":{"k":26,"s":29}}},"s":{"c":{"h":{"a":26,"l":26,"m":26}}},"t":{"r":2}},"m":{"e":{"i":6},"p":71,"t":71},"n":{".":88,"a":{"r":6},"d":{"a":22},"f":73,"g":{"a":2,"r":2},"k":259,"l":77,"n":84,"p":71,"r":77,"w":77,"z":259},"p":152,"r":[{"b":{"a":11,"e":{"l":12,"r":27},"i":{"n":12},"l":48,"o":2,"r":162,"u":162},"c":82,"i":303,"r":{"a":11,"s":25},"t":76,"z":76},73],"s":{"a":16,"h":1,"t":[{"r":93},6]},"ß":6,"t":[{".":89,"o":6,"s":89},82],"u":{"f":93,"g":82,"s":[{"b":71,"t":{"r":277}},2]},"v":147,"x":{"a":6}},75],"ä":[{"c":304,"h":{"r":{"i":{"n":12},"u":2}},"l":{"t":{"e":71}},"q":77,"r":{"b":78,"m":93,"z":77},"s":{"s":{"e":{"r":[{"k":26,"w":26},102]}}},"ß":{"e":{"r":6}},"t":{"z":93},"u":{"g":77},"x":77},75],"b":[{"a":{"u":48},"e":{"r":22}},246],"c":[{"h":82},93],"d":[{"i":{"e":{"n":105}}},134],"e":[{".":78,"a":{"t":{"u":19}},"c":[{"h":[{"e":1},73]},6],"d":{"e":{"l":6},"r":6},"e":{"i":[{"n":54},21],"m":0},"h":{"e":152,"l":{"e":[{"i":12},105]}},"i":{"e":73,"n":{"d":73,"g":93,"i":1,"s":{".":1},"u":12,"w":93},"s":71},"k":{"t":{"i":{"n":12}}},"l":{"a":118,"ä":21,"d":{"a":2,"e":{"m":19,"r":{"h":33}},"r":2},"e":{"k":80,"m":77,"r":21,"s":6},"o":21,"s":{"o":{"h":27},"t":22},"t":[{"e":{"r":{"n":305}}},10]},"m":{".":73,"b":77,"m":12,"p":77},"n":{"a":4,"ä":6,"d":22,"e":{"r":{"g":84}},"i":6,"o":6,"s":{"a":37,"c":136,"t":105},"t":[{"a":37,"f":76,"i":73,"l":{"a":84},"o":73,"w":76,"z":106},71]},"p":[{"i":6},78],"r":{".":73,"a":[{"b":6,"d":37,"l":6,"n":{"g":5,"t":12,"z":5},"u":6},0],"ä":21,"d":{".":77,"a":4,"e":306},"e":[{"b":125,"c":6,"i":[{"g":106,"s":4},187],"l":[{"l":4},89],"r":{"g":42}},73],"f":{"a":{"h":12},"o":{"l":12}},"g":[{"r":89},10],"i":{"d":22,"e":{"n":191},"o":{"n":10}},"l":{"e":{"b":225}},"n":{".":73,"e":{"i":12}},"ö":6,"p":{"a":89,"f":89,"l":89},"r":{"a":89,"e":{"g":12},"i":105},"s":{".":73},"t":[{"r":10},73],"z":73},"s":{"s":{"e":22},"t":[{"a":{"b":159,"n":25},"e":{"i":25,"l":12},"o":99,"r":27},6]},"t":{"a":[{"g":5},152],"e":78,"h":6,"t":{"a":27,"i":{"s":17}}},"u":{".":77,"e":{"r":{"ö":17}}},"w":78,"x":93,"y":32,"z":78},75],"é":75,"f":[{"a":{"b":{"s":33},"d":32,"k":79,"r":1,"s":82,"t":2,"u":0},"e":{"b":113,"e":2,"f":104,"i":[{"n":{".":4}},104],"k":140,"m":[{"i":73},32],"n":6,"r":{"l":{"e":1}}},"f":12,"i":{"k":4,"m":73,"n":{"s":25}},"l":{"a":{"g":0},"e":1,"i":1,"ü":82},"o":{"r":2,"x":0},"r":{"ä":124,"o":1},"s":{"a":{"m":2},"p":21,"t":{"i":{"e":4},"u":{"t":4},"ü":1}},"t":3,"u":{"s":{"s":25}},"y":73},189],"g":[{"e":{"b":22,"s":4},"l":{"i":{"m":105}}},243],"h":243,"i":[{".":78,"a":{"k":5,"r":6,"t":1},"d":[{"o":6},12],"e":[{"i":21,"n":25,"r":{"f":83}},73],"g":{"r":6},"k":{"a":{"s":21},"e":{"l":6},"i":{"n":6},"n":6,"o":150,"r":14},"l":[{"a":{"n":21},"d":4,"e":{"s":6,"t":2},"g":10,"i":[{"n":5,"p":2},1],"m":{"a":2,"ä":2,"e":{"d":12,"i":12}},"o":6},73],"m":{"p":77},"n":{"a":200,"e":2,"f":93,"g":[{"s":307},22],"i":1,"k":73,"s":[{"c":4,"t":{"i":4}},2],"t":93},"o":[{"l":1},6],"r":[{"a":1,"e":5,"m":{"e":4}},6],"s":{"a":3,"c":{"h":{"a":260,"e":{"i":24},"o":17,"r":5,"w":260}},"h":3,"o":93,"p":2,"t":23},"t":{"e":22,"i":{"n":6},"o":[{"r":5},100]},"v":{"e":10},"x":{"e":{"l":6}},"z":{"a":6}},75],"j":[{"o":88},93],"k":[{"a":{"t":27}},246],"l":[{".":77,"a":{"d":82,"n":{"d":140,"s":89},"p":82,"s":{"c":89},"t":{"s":82},"u":{"m":{"a":102}}},"ä":[{"c":147,"d":84,"h":77,"n":76,"r":77,"u":76},75],"e":{".":140,"b":76,"e":89,"i":{"n":255},"k":[{"t":105},25],"r":82,"x":89},"i":{".":82,"m":147,"n":{"d":82,"e":12,"g":82,"s":76}},"o":{"n":255,"p":236,"ß":75,"t":236,"w":2},"ö":[{"f":84,"g":89},82],"u":{"c":147,"f":82,"g":236,"s":{"s":236},"t":[{"o":48},89]},"ü":[{"m":140},89],"y":13},218],"m":[{"a":{"c":{"h":{"e":35}},"d":2}},243],"n":[{"i":{"s":2}},243],"o":[{"b":[{"e":[{"r":77},6],"l":2},71],"f":152,"l":{"i":308},"n":{"a":[{"n":5,"u":4},6],"d":{"r":4},"i":{"n":14},"o":{"p":6},"s":10,"u":6},"p":93,"r":{"g":106,"m":[{"a":{"g":199,"s":12},"e":{"i":27},"i":{"n":12}},78],"n":{"i":{"e":{"r":{".":63}}}},"s":{"c":{"h":{"l":26}},"t":12},"t":{"e":{"i":27,"r":12},"h":11,"r":162,"s":266,"u":4},"u":2},"t":{"r":12}},75],"ö":[{"f":80,"k":93,"l":189,"r":{"s":59}},75],"p":309,"q":93,"r":[{"a":{".":82,"c":{"h":{"t":{"r":15}}},"d":76,"h":76,"m":12,"n":{"d":82},"p":140,"s":{"t":{"a":25}},"t":82,"u":{".":75,"c":82}},"ä":{"d":77,"n":236},"e":{".":77,"c":82,"d":82,"f":77,"i":{".":89,"c":82,"e":89,"f":48,"g":89,"k":266,"n":77},"k":77,"p":76,"s":{"t":77},"u":147},"i":{"c":[{"h":{"t":{"e":29}}},76],"d":4,"e":2,"g":77,"k":95,"p":82,"s":[{"c":89,"t":89},75]},"o":{"c":76,"l":77,"n":[{"a":99},310],"p":89,"s":2,"t":82},"ö":{"s":22},"u":[{"c":89},82],"ü":82},206],"s":[{"a":{"l":104,"n":[{"e":1},289],"r":128,"s":113,"t":[{"e":1},2],"u":{"t":73}},"ä":{"n":6},"c":[{"a":89,"e":89,"h":{"a":{"n":89},"e":{"f":89},"r":{"o":89}},"r":89},82],"e":{"b":113,"e":{"i":2},"h":{"r":114},"n":[{"e":298,"t":104},2],"r":104,"t":[{"a":104},12]},"i":{"d":131},"k":{"y":79},"o":[{"h":82,"l":82},113],"p":{"a":{"n":{"n":82},"s":104},"h":73,"l":79,"o":{"r":79},"r":{"e":73,"o":73},"u":{"l":6}},"s":16,"t":[{"a":[{"k":1,"s":73,"t":82},2],"ä":{"t":[{"i":89},1]},"e":{"l":82,"r":{"n":82}},"h":1,"i":{"p":73},"o":{"l":5,"r":5},"r":[{"e":{"s":128},"ü":1},12],"ü":{"t":{"e":89}}},6],"u":{"n":104},"y":82},189],"t":[{"a":{".":89,"b":{"e":32,"l":0},"f":0,"g":6,"l":{"a":0},"n":0,"p":104,"r":32,"t":{"t":1}},"ä":{"u":104},"e":{"c":[{"k":0},2],"d":{"i":0},"h":[{"e":2},0],"i":{"g":0,"n":0,"s":0},"l":{"i":0},"m":{"a":4,"i":0},"n":{"t":114},"r":{"f":{"ü":1},"k":0,"l":104,"z":104},"t":{"i":113},"x":104},"h":[{"e":{"i":128}},104],"i":{"d":104,"k":82,"m":73,"n":[{"g":6},104]},"o":[{"f":104,"t":86},2],"r":{"a":{"n":124},"e":{"s":86,"u":82},"i":{"t":5},"o":1,"u":{"h":1}},"s":[{"a":{"m":5},"c":[{"h":{"e":5}},3],"e":[{"h":5,"n":132},22],"t":[{"a":{"f":5},"ä":{"t":4},"e":{"i":5,"m":5},"i":{"e":{"r":24}},"r":{"e":{"u":20},"o":102,"u":5}},1]},21],"u":{"m":73,"r":{"k":0,"l":0}},"ü":82,"w":{"a":[{"r":33},10]},"z":[{"e":{"d":25}},3]},189],"u":[{"c":78,"g":78,"h":73,"k":{"u":25},"l":{"b":10},"m":[{"e":{"i":6},"m":73},311],"n":{"d":{"e":{"r":[{"g":26,"h":26},25]}},"f":93,"g":[{"l":77},10],"i":152,"k":{"l":2,"o":2,"r":162,"u":2},"m":93,"r":77,"t":77},"r":[{"c":{"h":105},"e":{".":5},"l":76},73],"s":{"s":{"a":2,"p":11,"t":2}},"ß":{"e":{"r":21}},"t":78},75],"ü":[{"b":77,"h":{"l":{"s":{"c":10}}},"n":2,"r":6},75],"v":93,"w":189,"y":71,"z":[{"a":6,"e":{"i":{"t":{"e":{"n":[{"d":70},312]}}}},"ö":6,"u":{"g":{"a":2}},"w":6},189]},"g":{"a":{".":78,"b":{"f":77,"g":77,"l":313,"o":2,"r":[{"i":12},71],"s":{"c":77},"t":{".":73,"r":77},"u":1,"w":77,"z":77},"c":0,"d":{"e":{"r":22},"i":[{"e":10},3],"r":6},"e":2,"f":{"l":0},"g":{".":194},"k":[{"a":6,"u":6},0],"l":{"a":[{"f":1,"r":6,"u":93},2],"b":93,"g":93,"l":{"o":4},"p":93,"t":{"a":93,"d":93},"u":72},"m":{"e":{"c":6,"l":1},"m":{"a":4},"o":252,"t":93},"n":{"a":[{"l":77},72],"d":9,"f":77,"g":{"a":77,"e":{"b":84},"r":2,"s":{"p":10},"u":11},"k":93,"l":77,"m":{"u":77},"o":[{"b":6},88],"r":77,"s":[{".":73,"i":93,"t":77},22],"w":77,"y":0,"z":93},"p":{"e":1,"p":93},"q":0,"r":{".":78,"a":73,"c":77,"d":88,"e":{"t":1},"i":3,"m":76,"o":3,"s":2,"t":{"i":93},"u":1,"z":93},"s":{".":73,"a":[{"l":14,"m":5},6],"c":{"h":{"e":102}},"e":[{"i":6,"l":6,"m":126},22],"i":6,"o":{"r":6},"s":[{"e":{".":252,"s":[{"s":221},82]}},37],"t":[{"e":[{"l":27},5],"r":[{"ä":25},5]},6]},"t":{"a":3,"m":77,"r":12},"u":{"c":13,"f":93,"g":76,"k":73,"n":{"e":35},"s":93,"t":93},"z":1},"ä":{"p":93,"r":{"t":{"h":4},"z":77},"u":5},"b":[{"e":{"r":22},"i":2,"y":{"t":12}},201],"c":93,"d":[{"a":[{"d":[{"e":4},79],"k":104,"n":104,"r":104,"u":104},71],"ä":311,"e":{"i":156,"l":{"s":0},"n":{"t":73},"r":104,"t":104},"i":{"n":104},"o":[{"p":73},71],"ö":71,"r":[{"e":1,"u":1},71],"s":3,"t":12},77],"e":{"a":[{"t":{"e":5}},3],"b":{"a":2,"l":{"e":1,"i":{"n":12},"o":12},"o":{"t":19},"ü":78},"c":[{"k":1},0],"e":[{"c":1,"s":[{"t":17},6]},32],"f":{"a":7,"ä":78,"f":189,"l":12,"r":12,"u":1},"g":[{"e":{"n":[{"e":102,"s":149},163]},"l":3,"r":12},89],"h":{"e":{"r":{"l":17}},"o":1},"i":{"d":93,"e":110,"g":5,"l":73,"n":[{"f":6,"h":10,"r":93,"s":22,"v":22},298],"r":0,"s":{"e":93,"h":4,"s":{"c":277},"t":[{"r":17},2]}},"k":{".":77},"l":{"a":{"n":{"z":5}},"b":{"r":[{"a":27},48],"s":25},"d":{"e":{"n":12,"r":[{"h":26,"s":26},102]}},"e":{"c":[{"k":{"e":55}},1],"f":6,"k":80,"m":77,"n":[{"e":5},132],"r":{"e":4,"k":5,"ö":17,"s":14},"v":21},"f":4,"i":{"m":184},"l":{"a":4,"i":22},"ö":2,"s":{"a":4,"p":22,"t":[{"e":4},22],"z":4},"t":{"a":4,"r":10},"z":37},"m":[{"a":{".":5},"e":26,"p":189,"u":1},2],"n":{".":89,"a":[{"c":41,"d":5,"k":5,"l":14,"m":5,"p":5,"r":5,"t":5,"u":{"g":12}},1],"d":{"a":{".":84},"i":{"n":314},"m":{"o":106},"r":162},"e":{"i":{"d":4},"r":{"f":19,"g":84,"n":14,"w":{"e":26},"z":19}},"i":{"m":6},"k":9,"n":4,"o":{"c":6},"s":{"a":{"m":12},"e":{"m":{"b":26}},"k":4,"z":4},"t":{"ä":4,"f":77,"h":37,"r":35,"w":77},"z":{"w":4}},"o":{"o":0,"r":{"i":2}},"p":[{"l":1,"o":1},237],"r":{"a":[{"b":6,"k":6,"l":23,"n":{"n":1,"t":5},"r":315,"s":2},0],"d":{"g":77},"e":{"m":1,"n":{"e":5,"g":5,"s":42,"t":14},"r":2},"i":{"n":{"d":19,"f":19,"n":12,"t":19}},"k":{"l":{"ä":225}},"l":{"a":{"s":82}},"m":{"e":35},"n":{"o":4,"t":93},"o":[{"b":6},0],"ö":32,"s":{"a":{"t":12},"e":{"h":250}},"u":3},"s":[{".":89,"a":{"u":{"f":4}},"c":[{"h":[{"e":{".":24}},19]},87],"e":{"b":23,"l":{".":309,"t":4},"r":23},"h":{"a":1},"i":1,"o":1,"p":{"a":1,"i":12},"s":{"e":4,"t":9},"t":[{"a":[{"k":1,"n":12},10],"e":[{"r":14},316],"h":4,"i":{"e":{"r":26}},"u":{"r":14}},22]},32],"t":{"a":[{"n":{"g":5,"t":5},"p":71},3],"h":{"i":6},"r":{"e":{"i":7},"i":7},"u":123},"u":{"l":111,"n":{"k":1},"r":{"t":0},"t":16},"x":248},"f":[{"i":{"l":2}},201],"g":[{"a":{"t":12},"e":[{"n":{"e":2}},140],"l":[{"a":82,"o":82},6],"n":86,"r":5,"s":2},93],"h":[{".":84,"a":[{"l":{"e":78}},6],"e":[{"t":88},6],"i":{"e":88},"l":0,"r":215,"s":[{"c":1},12],"u":73,"w":0},93],"i":{"a":{"l":{"o":1}},"c":{"h":[{"t":132},22]},"e":{"g":4,"i":21,"l":[{"a":22},23],"n":{"e":136,"o":5},"r":{"e":{"s":4}},"s":{"t":13}},"f":{"t":{"s":55}},"g":{"u":6},"k":{"e":{"l":6}},"l":{"l":93},"m":{"e":{".":6,"s":5,"t":6},"p":77},"n":{"d":108,"e":1,"f":93,"h":158,"s":[{"a":2},93],"t":76,"v":108},"o":{"b":6,"k":77},"s":{"e":{"l":76}},"t":{"a":2,"t":{"e":10},"u":1},"u":{"s":5}},"j":93,"k":317,"l":[{".":84,"a":{"b":189,"c":93,"d":{"u":77},"g":93,"m":93,"n":{"d":77},"s":{"c":11,"t":159},"u":{"b":88,"f":93}},"ä":{"n":{"d":77},"u":{"f":77}},"b":1,"e":[{".":76,"a":78,"b":76,"c":82,"d":106,"e":82,"g":76,"h":77,"i":{"c":89,"n":106,"t":{"e":{"r":{"s":66}},"r":318}},"n":[{"k":84},82],"r":[{"e":{"i":102}},106],"s":[{".":78,"e":82},77]},206],"i":{"a":73,"b":77,"d":88,"e":[{"b":106},88],"f":77,"k":73,"l":84,"m":73,"n":77,"o":73,"s":77,"t":[{"e":82},73],"z":[{"e":82},73]},"o":{"a":73,"b":73,"c":[{"h":76},73],"k":73,"m":73,"p":73,"r":{"b":77},"s":77,"t":73},"ö":{"c":{"h":77},"s":77,"w":77},"s":77,"u":[{"f":76,"k":77,"n":76,"t":73},71],"ü":[{"g":82},88],"w":77,"y":88},6],"m":[{"e":{"n":{"t":{"r":10}}},"i":{"s":2}},152],"n":[{".":77,"a":[{".":89,"c":77,"d":89,"h":255,"l":[{"e":{"r":319}},5],"n":{"l":77}},218],"ä":88,"b":77,"c":77,"d":77,"e":[{"h":82,"n":{"t":107},"t":{"r":2},"u":48},6],"f":77,"g":77,"h":77,"i":{"e":73,"f":73,"n":[{"t":77},89],"s":[{"e":105},320]},"k":77,"l":77,"m":77,"o":[{"n":147,"r":13,"t":82},73],"p":77,"r":77,"s":77,"t":77,"u":[{"m":{".":88}},77],"ü":73,"v":77,"w":77,"y":73,"z":77},71],"o":{"a":[{"l":{"i":4}},5],"b":[{"e":{"l":25},"j":77,"l":289,"s":2},71],"f":152,"g":77,"h":[{"r":{"e":{"n":4}}},321],"i":0,"l":{"a":2,"d":{"a":2},"f":{"r":2}},"n":{".":78,"a":{"t":5},"e":2,"s":78},"p":{"a":88,"f":10,"o":{"s":6},"t":77},"r":{"a":2,"d":93,"g":93},"s":{"i":6,"p":23,"t":{"e":0},"z":93},"t":{"h":3,"t":{"e":{"r":{"b":26,"g":46},"s":19}}},"u":78,"y":0},"ö":{"f":6,"l":71,"t":78},"p":134,"q":93,"r":[{"a":{"b":[{"a":2,"i":2,"l":12},89],"d":{"l":76},"h":76,"k":76,"m":[{"m":{"e":{"n":[{"d":70},312],"r":33}}},48],"n":{"d":{".":82}},"r":[{"e":48},108],"s":{"a":27,"h":12,"p":12,"t":2},"u":{"b":76,"f":25,"m":77,"s":{"k":25}}},"ä":{"d":77,"s":{"c":48},"u":82},"e":{".":255,"b":89,"c":76,"d":{"e":82},"e":234,"f":[{"r":2},76],"g":{"e":77},"i":{"c":76,"f":{"r":10},"h":76,"n":82,"t":82},"m":147,"n":[{"n":106,"o":4,"z":{"e":{"i":58},"w":17}},78],"r":89,"s":{"e":77,"s":{"e":{"r":322}}},"t":82,"v":82},"i":{"c":76,"e":[{"m":76,"s":{"e":82}},2],"g":77,"l":{"l":{"a":10}},"n":{"g":106,"n":106}},"o":{"b":{"a":162,"e":{"r":4},"l":2,"r":162},"c":77,"h":77,"l":76,"s":{"e":76,"s":[{"e":{"l":33}},89]},"t":89},"ö":{"h":77},"u":{"f":{".":77,"t":89},"h":76,"i":82,"m":76,"n":{"g":22},"p":78,"s":78,"ß":78,"t":76},"ü":{"c":76}},206],"s":[{"a":{"b":3,"c":[{"k":140},89],"d":2,"k":3,"l":[{"b":128,"l":89,"m":89,"t":89},82],"m":[{"a":128,"b":1,"p":128},6],"p":16,"r":3,"t":82,"u":{"g":22,"r":10},"v":2},"ä":{"u":82},"c":[{"a":89,"e":128,"h":[{"e":{"f":89},"i":5},10],"o":89},79],"e":[{"h":23,"i":{"l":5},"k":{"l":12},"l":{".":82,"a":89,"n":82},"m":1,"n":[{"t":128},48],"r":[{"e":82,"i":48},128],"s":284,"t":12,"u":89},2],"f":{"i":{"l":22}},"g":{"e":{"n":{"e":102}}},"h":{"a":1},"i":{"d":2,"k":3,"l":82,"o":1,"t":{"a":128}},"k":{"i":{"e":302},"r":1},"o":[{"b":122,"l":82,"n":5,"p":128,"r":{"g":{"e":141}}},2],"p":{"a":{"n":{"t":5},"s":128},"e":{"i":82,"k":79},"i":[{"e":324},79],"l":128,"o":{"r":{"t":{".":324}}},"r":{"u":128}},"r":{"a":{"t":19},"ü":{"c":22}},"s":16,"t":{"a":[{"d":124,"g":89,"n":[{"z":89},124],"r":82,"t":{"i":5}},1],"ä":1,"e":{"h":82,"i":{"n":124},"l":[{"l":5},257],"r":[{"r":4},22],"u":71},"h":{"y":6},"i":{"f":82,"l":82,"m":82,"r":82},"o":[{"c":{"h":89},"d":89,"r":89},82],"ö":[{"r":5},1],"r":[{"a":[{"s":5,"t":5},12],"e":{"i":{"t":35},"s":12,"u":89},"i":{"t":4},"o":{"s":4}},1],"u":{"n":82},"ü":1},"u":{"n":1},"y":82},323],"t":[{"e":[{"i":{"s":25}},82],"h":[{"y":6},0],"i":[{"m":2},6],"o":82,"r":5,"s":5,"ü":82},93],"u":{"a":{"l":{"e":5},"m":1,"n":{".":0,"t":0},"s":0},"c":0,"d":{"r":14},"e":[{"d":77,"t":10},6],"f":152,"h":93,"i":{"n":{"s":1},"s":0},"m":{"e":2,"m":[{"i":132},78]},"n":{"e":2,"f":93,"g":{"e":[{"w":84},105],"l":77},"i":152,"k":76,"r":77,"s":2,"t":77},"r":[{"e":10,"l":189,"t":{"h":162,"r":2,"s":25},"u":48},78],"s":[{"a":14,"c":[{"h":{"i":53}},1],"e":1,"s":{"o":48,"p":2,"t":2},"t":[{"a":{"b":159},"e":[{"n":{"d":325},"r":{"l":26}},4],"r":12},5]},6],"t":[{"a":13,"e":{"r":{"h":197}},"h":13,"s":{"p":162}},6]},"ü":{"b":77,"r":326,"s":23},"v":93,"w":93,"y":{"n":[{"a":5},1]},"z":[{"e":{"u":{"g":{"i":10}}}},161]},"h":{"a":{".":77,"b":{"a":2,"e":2,"f":82,"i":2,"l":{"u":71},"n":77,"r":72,"s":71,"w":77},"c":{"h":{"e":{"n":186},"o":6},"k":{"s":19}},"d":{"a":77,"e":{"l":6,"n":22},"l":{"e":71},"r":[{"i":1},72]},"e":[{"l":1},77],"f":{"a":{"r":5},"e":2,"f":{"ä":71,"l":9},"t":[{"o":12,"r":[{"e":12},2],"s":{"p":277}},73]},"g":{"a":2,"g":73},"h":[{"a":1,"s":73},71],"i":[{".":78},73],"j":73,"k":{"a":77,"l":0},"l":{".":74,"a":{"l":3,"n":{"c":19},"r":72,"u":6},"b":{"a":2,"e":{"l":12},"i":{"n":12},"r":162,"u":2},"e":77,"h":77,"i":2,"l":{"a":11,"e":{"r":{"e":26,"f":29,"g":26}}},"o":1,"p":84,"s":{"k":12,"p":2},"t":{"a":{"l":12},"e":{"i":12},"r":162}},"m":{"o":{"t":19},"t":93},"n":{".":73,"a":[{"l":6,"n":6,"u":2},77],"b":[{"e":73},77],"d":[{"a":2,"e":{"r":27},"r":162,"s":25},73],"e":{"m":6},"f":11,"g":{"e":{"n":{"d":46}},"r":{"o":12}},"k":11,"l":77,"o":77,"r":77,"s":{"c":71},"z":77},"p":[{"e":88,"l":6,"o":6,"r":6},93],"r":{"a":[{"b":5},86],"b":77,"c":77,"d":73,"f":{"r":2},"m":{".":71,"a":4,"e":[{".":12},73]},"n":{"e":12},"o":{"m":6},"s":77,"t":{"e":10,"h":2,"i":71,"r":12},"z":{"a":2}},"s":[{".":77,"a":107,"c":12,"h":162,"s":{"a":12,"e":{"r":102},"t":27},"t":{"r":6}},73],"ß":72,"t":{"a":6,"i":2,"l":82,"r":23,"s":77,"t":[{"r":82},136]},"u":{"d":{"i":71},"f":{"b":71,"l":{"i":{"e":327},"o":9},"m":93,"s":71},"g":328,"k":{"t":71},"s":{"a":[{"n":12},2],"c":11,"e":[{"l":12,"n":{"t":46}},73],"p":{"a":12,"e":12},"s":{"e":{"n":312}},"u":{"r":12}},"t":{"a":11,"r":27}},"v":{"e":{".":6}}},"ä":{"d":{"e":22},"f":{"f":71},"i":77,"k":{"l":6},"r":{"z":77},"s":{"c":{"h":{"e":{"n":20}}},"t":93},"u":{"g":77,"s":{"c":11,"p":1}}},"b":[{"a":{"r":{"a":{"s":12}}},"e":{"r":{"e":22}}},134],"c":93,"d":[{"a":{"n":22}},161],"e":{"a":[{"d":6},77],"b":{"e":[{"i":{"s":4}},1],"l":23,"r":1,"u":1},"c":{"h":{"e":43,"i":1,"o":0,"s":82},"k":{"e":1}},"d":{"g":2,"i":{"t":6}},"e":{"m":120,"n":2,"s":2,"t":32},"f":{".":73,"a":{"n":6,"u":6},"e":{"i":21,"m":3,"r":{"m":4}},"f":77,"i":{"d":6,"n":{"g":39}},"l":{"e":38},"r":[{"a":12,"e":6},77],"t":78,"u":6},"g":{"u":1},"h":{"e":{"l":6}},"i":{"a":12,"b":89,"e":71,"f":71,"g":71,"m":[{"a":{"l":12,"n":12,"r":12},"e":{"i":12},"p":25,"u":12},6],"n":[{"a":12,"e":[{"b":27,"n":{"e":26},"r":27},105],"t":{"r":82}},77],"o":77,"s":{"m":127,"t":0},"t":[{"s":277},73],"w":71},"k":{"t":{"a":25}},"l":{"a":[{"g":1,"n":13,"u":4},6],"e":{"c":13,"k":6,"m":82,"n":6},"f":73,"i":1,"l":{"a":[{"u":27},22]},"m":{"e":{"i":12}},"o":[{"f":5,"r":2},1],"ö":6,"t":84},"m":{".":89,"a":77,"b":2,"d":75,"e":154,"i":[{"a":5,"s":{"s":124}},167],"m":75,"p":76},"n":{".":73,"a":315,"ä":6,"e":{"b":{"e":4},"n":[{"d":4,"e":5,"s":5},132],"r":{"g":4,"m":5},"t":150},"g":{"a":[{"g":12},77]},"k":{"a":{"n":12,"u":12}},"o":[{"t":25},77],"s":{"e":{"m":12},"t":[{"r":4},105]},"t":{"a":22,"e":[{"r":12},4],"r":[{"i":12},35],"s":71,"w":76,"z":82},"u":14,"z":37},"o":[{"n":1,"p":1},80],"p":{"a":1,"h":1,"i":72,"t":22},"r":{".":73,"a":{"b":37,"d":6,"p":77,"r":315,"u":105},"b":22,"e":{"b":125,"c":{"k":5},"i":{"f":12,"g":220,"s":{".":24,"e":{"s":263}}},"l":6,"n":{"e":5},"r":{"s":{"c":24},"w":5}},"f":{"o":[{"l":12},71]},"g":{"e":{"b":{"n":221}}},"i":{"f":77,"n":{"d":19,"f":19,"n":{"u":273},"s":19}},"k":{"e":71,"l":{"ä":12},"r":{"a":{"n":329}}},"l":{"a":{"d":164}},"m":77,"o":[{"b":315,"f":5,"p":5,"t":5},1],"ö":{"r":71},"t":[{"h":4},10],"u":{"m":4},"z":{"a":{"p":12},"e":{"n":{"g":26},"u":82},"w":11}},"s":{"a":16,"e":77,"i":1,"p":3,"t":{"ä":26}},"t":{"a":{"p":6},"ä":1,"e":{"r":105},"h":1,"i":2,"s":16},"u":[{"g":4,"n":{"t":1},"s":{"c":78}},6],"x":[{"a":32,"p":77},1],"y":[{"e":0},2]},"è":75,"f":[{"a":{"l":{"l":{"e":{"r":312}}},"n":22},"e":{"l":{"l":330}},"i":{"s":2},"l":{"e":{"i":105}}},134],"g":[{"a":{"s":11}},134],"h":[{"o":{"h":22}},152],"i":{".":84,"a":[{"r":6,"t":71},77],"c":[{"e":0,"h":{"t":{"e":{"r":58},"s":{"p":15}}}},77],"d":[{"e":12,"i":{"o":5},"o":77},1],"e":[{"n":{"s":1},"r":{"e":{"i":12},"i":[{"n":12},25],"s":105}},6],"f":{"f":{"r":9}},"k":{"r":23},"l":{"a":254,"e":{"n":266},"f":{"r":2}},"m":[{"a":77,"i":{"t":124},"m":89,"p":{"e":82}},73],"n":[{"a":{"k":1,"m":1,"p":1,"s":47},"d":{"e":73},"e":{"i":22,"l":1,"n":331},"f":71,"h":71,"i":173,"n":37,"o":3,"s":37,"t":{"a":11}},6],"o":[{"b":1,"n":5},77],"p":[{"l":5,"s":22,"u":5},23],"r":[{"a":1,"e":107,"i":1,"m":{"a":11,"i":2},"n":[{"e":{"r":12}},48],"s":2,"t":75},6],"s":{".":77,"a":2,"e":5,"o":72},"t":{"a":{"c":1,"n":6},"e":{"l":6},"h":0,"i":3,"r":[{"o":6},13],"z":{"e":37}},"v":{"o":21}},"j":93,"k":[{"a":{"m":{"p":105}},"e":{"u":73},"i":{"n":11},"ö":82},205],"l":[{"a":{"f":89,"g":[{"r":2},6],"n":{"d":{"a":277},"s":0,"z":0},"s":71,"t":71,"u":{"t":71},"y":71},"ä":{"c":{"h":{"e":82}},"s":71,"u":71},"b":12,"d":16,"e":{".":82,"a":4,"b":82,"d":82,"e":4,"i":{"s":[{"t":82},73]},"l":0,"n":{".":140,"a":{"s":12},"e":{"n":247},"n":6,"t":{"r":128,"s":89},"z":6},"r":[{"a":162,"e":5,"g":73,"h":{"ö":10},"k":6,"n":{"ä":332},"u":{"n":4},"w":0,"z":89},82],"s":[{"i":89},82],"u":{"d":89}},"f":12,"g":12,"i":{"e":[{"d":82},73],"f":73,"m":73,"n":{"d":0,"g":{"s":191}},"p":73,"s":73,"t":333},"l":3,"m":3,"o":[{"b":0,"c":82,"f":32,"g":82,"r":[{"a":2},89],"s":{".":82,"i":82,"s":[{"t":10},89]}},73],"ö":{"s":73},"s":{"a":{"r":5},"e":{"r":6},"k":{"a":1},"l":{"o":3},"t":{"e":{"r":{"n":18}},"i":{"e":4},"r":7},"u":6},"t":3,"u":{"f":82,"k":82,"m":{"p":{"e":82}}},"ü":{"f":71},"z":2},77],"m":[{"a":[{"b":{"l":1},"d":82,"g":82,"k":82,"n":[{"t":73},82],"r":[{"c":128},82]},6],"ä":[{"c":89,"h":89,"l":89},82],"e":[{".":82,"d":82,"e":[{"r":{"s":19}},184],"i":{"n":82},"l":{"d":82,"e":4},"n":[{"s":22},82],"r":{"a":{"n":12},"e":{"i":12}},"s":{"t":100},"x":82},6],"i":{"e":2,"n":{"d":82,"i":82,"z":82},"r":{"r":82}},"o":[{"p":82,"t":82},73],"ö":[{"l":89},79],"p":3,"s":[{"a":1,"p":13},6],"u":[{"l":82,"t":{"s":10}},73]},93],"n":[{"a":[{"c":2,"g":82,"m":82,"r":89,"t":{"e":3,"t":89},"u":{".":82}},73],"ä":[{"h":0,"s":82},73],"d":16,"e":[{"b":4,"e":162,"f":{"f":1},"i":{"g":1,"n":1},"l":73,"n":[{"g":5},12],"p":{"f":12},"r":[{"d":{"e":10},"e":{"i":25},"o":334,"s":{"a":128}},82],"x":1},6],"f":[{"l":{"e":{"i":102}}},16],"h":{"o":{"f":{"s":{"t":{"r":{"a":{"s":175}}}}}}},"i":{"c":73,"d":73,"e":73,"m":0,"n":0,"p":73,"s":{"a":12}},"k":12,"n":{"o":22},"o":{"r":289},"r":{"a":22},"s":{"a":1,"p":3,"t":[{"o":12},22],"u":{"c":{"h":102}}},"t":{"s":22},"u":{"l":73,"n":{"f":104}},"z":3},77],"o":{"a":{"r":5},"b":{"e":{"r":{"n":1}},"l":23},"c":{"h":[{"a":5,"e":105},168],"k":{"a":6,"e":{"r":{"l":24}},"t":25}},"d":77,"e":[{"n":4,"r":1},80],"f":{"a":125,"ä":6,"e":{"d":6,"u":6},"f":{"a":9},"l":23,"o":21,"r":23,"u":6},"i":77,"l":{"a":[{"r":4},125],"e":[{"i":21,"m":6},75],"g":9,"k":4,"l":10,"s":4,"y":[{"m":82},77],"z":[{"e":{"n":{"e":26}}},75]},"m":{"e":[{".":6,"c":6,"d":6},2]},"n":[{"e":{"r":2}},73],"o":{"n":0,"r":2},"p":77,"r":{"a":[{"n":335,"u":6},0],"d":238,"e":[{"n":{"s":5},"t":1},77],"g":93,"t":{"a":4,"e":{"r":12},"u":71}},"s":{".":73,"e":[{"i":6},22],"l":[{"a":5},1],"p":[{"r":1},6]},"ß":{"e":{"n":{"e":5}}},"t":{".":77,"h":1,"r":77,"s":155},"u":[{"s":12},75],"w":109,"x":71,"y":32},"ö":[{".":77,"c":[{"k":1},6],"h":{"e":194},"s":[{"t":82},109]},85],"p":134,"q":71,"r":[{"a":{"b":2,"c":3,"d":1,"g":32,"h":115,"i":71,"n":{"e":71},"p":1},"ä":{"u":82},"b":12,"c":0,"d":1,"e":{"c":[{"h":79},73],"d":82,"f":[{"f":1},82],"h":104,"i":{".":89,"b":{"a":10,"r":10},"c":82,"f":82,"g":128,"n":{"i":5,"l":89},"t":{"h":25}},"l":{"i":132},"p":82,"r":{"g":{"e":{"b":33}},"h":6,"k":6,"l":{"a":89,"e":{"b":336}},"m":6,"s":[{"a":10},25],"w":6,"z":6},"s":[{"s":105,"t":105},337],"t":[{"a":104},2],"u":104,"v":73},"g":2,"i":[{"c":[{"k":89},82],"e":[{"s":{"l":82}},12],"n":[{"d":114,"t":0},82],"s":{"t":89},"t":{"t":{"e":{"r":140}}}},73],"l":1,"m":3,"o":{"g":82,"h":82,"l":217,"m":{"a":{"t":89},"e":89,"i":89,"o":89},"n":89,"p":{"a":71},"r":12,"u":82},"ö":{"s":257},"r":12,"s":{"a":{"c":41,"n":{"d":14}},"c":{"h":{"l":1}},"e":{"m":21,"n":6,"r":21,"t":6},"h":5,"i":{"n":6},"k":4,"l":4,"o":{"f":41},"t":22,"u":6},"t":{"a":{"b":6,"n":6},"e":{"l":36},"h":6,"o":{"p":6},"r":{"i":{"c":4}},"s":2},"u":{"h":82,"m":{"s":0},"t":82},"ü":[{"b":89},82],"y":89,"z":2},77],"s":[{"a":{"c":{"h":{"t":128}},"d":113,"l":{"k":104,"l":73},"m":{"t":89},"n":[{"d":1},73],"s":104,"t":{"h":73,"o":73},"u":{"d":73,"r":128,"t":73}},"ä":{"h":73,"u":{"g":73}},"c":{"h":{"a":{"n":89}},"r":6},"e":{"c":86,"e":12,"h":{"r":114},"i":{"e":104,"n":{"d":89,"s":{"t":164}}},"l":{"e":82,"i":{"n":12}},"m":{"i":0},"n":{"d":{"w":89},"e":{"r":{"g":55}},"t":104},"r":{"f":104,"g":0,"h":73,"k":{"l":89},"l":104,"n":[{"ä":89,"e":5},0],"ö":73,"w":104,"z":73},"x":[{"t":79},73]},"h":{"a":{"k":22}},"i":{"d":113,"m":6,"n":{"g":104,"n":{"i":124}},"t":{"a":128}},"k":{"a":{"l":6,"n":{"d":82}}},"o":{"f":0,"p":73,"r":{"g":0}},"p":{"a":{"c":73,"n":{"i":128},"r":104,"t":104},"e":{"c":82,"i":82,"r":{"b":82}},"h":73,"o":{"i":82},"r":{"ä":73,"o":73}},"s":12,"t":{"a":[{"b":{"l":1},"d":82,"f":73,"l":{"t":4},"n":82,"r":{"b":4},"u":86},217],"ä":{"u":86},"e":{"c":71,"i":71,"l":[{"e":89},71],"r":{"b":124,"n":124}},"i":[{"t":73},72],"o":[{"l":73,"r":73},71],"r":[{"e":{"u":128},"o":105},71],"u":{"m":1,"n":71},"ü":71},"u":[{"n":{"g":6}},104]},84],"t":[{"a":[{"b":[{"l":2},73],"d":289,"g":6,"k":{"t":{".":5,"e":5}},"l":{"l":73,"o":89,"p":73,"t":73},"m":234,"n":[{"e":1,"k":6},289],"p":73,"r":289,"s":[{"i":86,"y":73},232],"t":[{".":82,"e":82},86],"u":[{"m":82},73],"x":89},0],"ä":[{"r":73},0],"e":{"b":{"e":{"r":16}},"c":[{"h":{"a":4}},32],"d":113,"f":{"f":0},"h":{"e":32},"i":{"f":73,"g":104,"l":{"z":128},"m":104,"n":0,"s":104},"k":{"e":104},"l":{"a":{"s":128},"e":{"i":{".":46},"k":89},"f":{"e":128},"i":{"t":128}},"m":[{"i":104,"p":73},12],"n":{"g":{"a":89,"l":128},"t":{"a":128,"f":89,"s":89}},"r":{"d":{"e":{".":33}},"e":{"r":{"s":29}},"f":{"o":1,"ü":[{"l":164},1]},"g":{"e":{"b":164},"r":[{"i":33},1]},"h":[{"ä":{"l":33},"ö":{"h":{"u":30}}},0],"l":{"e":{"b":164,"u":338}},"n":{"e":{"u":164}},"s":{"p":{"a":[{"r":30},7]},"t":[{"a":164},1]},"t":{"r":{"a":33}},"w":{"ä":1},"z":{"e":1}},"s":{"e":296,"s":114},"t":{"a":73,"h":12},"u":104,"x":{"t":{"r":89}}},"h":[{"e":{"i":89,"r":{"a":82},"s":82},"o":89},104],"i":{"d":113,"m":104,"n":[{"e":1},339],"s":104,"t":136},"n":{"i":22},"o":{"b":104,"d":99,"f":113,"l":{"y":128},"p":{"e":73},"r":{"d":89}},"r":{"a":{"k":1,"n":[{"d":1},82],"s":128,"t":{"e":{"s":24}},"u":[{"b":89,"m":{"e":24}},1]},"e":{"c":[{"k":140},1],"i":1,"s":86},"i":{"c":1,"e":{"g":128},"n":128},"o":{"l":86,"s":86},"ö":{"m":1},"u":1,"ü":86},"s":[{"a":{"h":6,"l":6,"n":177},"c":{"r":6},"e":{"i":{"n":5},"l":6,"n":{"d":14,"g":5},"r":[{"i":14},163]},"h":{"a":[{"k":16},105]},"k":{"r":4},"o":21,"p":[{"a":{"r":4}},6],"t":{"ä":{"t":4},"i":{"e":12},"r":{"a":{"u":35}},"u":{"r":14},"ü":{"r":14}},"u":6},89],"t":[{"i":22},12],"u":{"b":82,"e":2,"r":{"s":104}},"ü":82,"z":3},189],"u":{"b":{"a":21,"e":{"i":21,"l":5,"n":340},"i":6,"l":23,"r":198,"u":6},"c":0,"f":{"a":6},"h":{"a":23,"i":21,"r":71,"u":71},"k":{"ä":6,"i":{"n":21},"o":48,"t":9},"l":{"a":[{"b":5},118],"ä":6,"e":[{"b":21,"i":21,"m":6,"n":{"g":14,"t":5},"r":21,"t":6},22],"i":{"d":6,"n":21},"l":37,"o":6,"ö":6,"s":37},"m":{"a":3,"h":71,"s":71},"n":[{"a":71,"d":{"e":[{"i":17,"s":17},37]},"e":2,"f":77,"g":[{"e":4,"s":[{"a":102},10]},22],"i":71,"m":71,"t":77},6],"p":{"s":71},"r":[{"g":37,"t":{"h":162}},77],"s":{"a":1,"o":6,"s":{"a":162,"e":[{"r":341},4],"o":11,"p":2,"t":2}},"t":{"a":{"b":6},"i":6,"o":21,"r":23,"t":[{"e":4},2],"z":{"e":{"n":12,"r":27},"u":2}}},"ü":[{"b":{"e":{"r":82},"s":89,"u":82},"f":[{"t":48},2],"h":{"n":{"e":19}},"s":4},73],"v":[{"i":{"l":22}},93],"w":[{"a":{"l":{"l":73}},"e":{"c":13,"i":{"b":71,"h":71,"n":{"s":[{"a":15},247]}}},"i":{"r":{"r":73}}},80],"y":{"d":[{"r":1},192],"l":{"o":{"r":6}},"m":{"n":75},"o":[{"s":1},71],"p":[{"e":{".":6}},75],"t":80},"z":[{"a":6,"o":79,"u":{"g":10},"w":79},93]},"i":{"a":{"d":{".":82,"a":2,"n":71,"o":1},"f":{"l":12},"g":{"o":73},"h":32,"i":71,"k":{".":82,"e":[{"i":6},82],"r":6,"t":71},"l":[{"a":[{"r":4,"s":4},125],"ä":6,"b":9,"d":9,"e":{"b":82,"f":82,"i":82,"k":1,"l":82,"n":{"g":82,"t":82},"r":{"b":82,"f":202,"h":82,"m":124},"t":342,"x":82},"i":{"a":79,"m":82,"n":79},"l":[{"e":{"r":12},"i":22},171],"o":[{"n":6,"p":6,"r":125},73],"p":4,"t":37,"u":254,"z":37},71],"m":{".":82,"a":1,"p":{"e":19},"s":71},"n":{".":71,"a":[{"l":[{"t":4},6],"u":6},217],"c":71,"d":256,"e":{"b":343,"r":2},"n":71,"s":[{"p":11},71],"t":82,"z":[{"a":19},82]},"o":[{"p":6},0],"p":1,"q":0,"r":[{".":82,"a":6,"e":73,"r":4},71],"s":[{".":82,"h":1,"i":73,"p":3,"s":4,"t":10},71],"t":{".":82,"h":[{"e":89},257],"r":75,"s":82},"u":[{"n":1},82],"z":73},"ä":[{"m":72,"p":71,"r":[{".":71,"m":4,"s":71,"z":4},2],"t":[{"e":{"m":124},"i":6,"r":5,"s":195},71],"v":71},77],"b":[{"a":{"r":{"t":0},"u":{"f":104,"s":104,"t":73}},"b":{"l":{"i":6}},"e":{"i":{"g":104,"s":104},"n":99,"r":{"g":{"e":{"b":336}},"l":{"a":344},"o":13}},"i":{"m":73,"n":104},"l":{"a":{"d":73},"e":{"u":73},"u":82},"o":79,"ö":73,"r":{"a":{"u":86},"i":{"c":1},"o":{"c":86}},"s":{"e":{"r":6},"t":{"e":5}},"u":{"n":[{"k":86,"t":86},6],"s":{"c":48}}},189],"c":[{"a":82,"c":0,"e":13,"h":{"a":[{"r":{"t":{".":26}}},100],"ä":13,"e":[{"i":13,"r":[{"i":{"n":279}},2]},71],"i":71,"l":[{"e":4,"i":4,"o":345},13],"m":35,"n":4,"o":[{"r":{"t":4}},71],"r":346,"s":{"e":{"l":{"e":26}},"i":11,"p":{"e":12},"t":{"i":{"e":26}}},"t":{"r":2},"u":71,"w":13},"i":71,"k":{"e":82,"t":22},"l":[{"a":1},71],"r":{"a":1},"u":82},77],"d":[{"a":[{"b":6,"c":79,"l":5,"n":[{"s":79},32],"t":124,"u":0,"x":6},77],"ä":13,"e":[{".":76,"a":73,"e":75,"i":{"s":1},"l":[{"ä":10},77],"m":{"u":{"l":89}},"n":{".":106,"o":99,"s":{"e":10}},"r":{"a":{"n":4},"i":{"n":{"n":{"u":64}}},"ö":13,"r":{"e":{"g":33}}},"s":[{"a":35,"o":4,"p":22},76]},6],"i":{"o":[{"n":12,"t":89},347]},"k":77,"n":{"i":25},"o":[{"l":73,"o":77},6],"ö":73,"r":[{"ä":5,"i":{"t":5},"o":5,"u":5},86],"s":{"p":21},"t":12,"y":85},71],"e":{"a":3,"b":{"ä":6,"l":6,"r":{"e":4,"i":6,"ü":14},"s":{"t":{"o":12}}},"c":[{"h":{"o":6,"t":25},"k":6},0],"d":{"a":{"n":23},"e":1,"r":6},"e":32,"f":{"a":{"k":{"t":4},"n":21,"r":6,"u":6},"ä":{"h":6},"e":{"m":22},"f":9,"i":2,"l":23,"o":{"n":{"k":5}},"r":[{"o":6},13]},"g":{"l":[{"i":35},6],"n":16,"r":{"e":23},"s":{"c":59,"e":12,"i":12,"t":12}},"h":{"e":{"r":1},"i":{"n":21},"r":37},"i":[{"n":{"d":0}},71],"l":{"a":[{"r":22},348],"ä":{"s":6},"d":9,"e":[{"b":176,"c":13,"i":{"d":4},"k":6,"n":[{"e":5,"g":5},89],"r":{"e":19,"f":{"i":15},"g":{"e":{"b":175}},"k":{"e":15},"l":{"a":15,"e":{"b":{"n":175}}},"w":12},"s":105},73],"i":[{"d":22},73],"l":241,"o":{"b":36,"p":6,"r":24},"s":[{"z":4},97],"t":22},"m":{"e":2,"i":{"s":105}},"n":[{".":82,"a":[{"g":13,"m":12,"s":5},82],"ä":82,"d":82,"e":[{"b":13,"c":82,"k":349,"r":{"f":{"o":15},"g":197,"l":{"a":15}},"x":82},73],"f":82,"g":[{"e":{"f":19,"z":19}},350],"h":82,"i":{"d":6,"m":6,"n":14},"j":82,"k":82,"l":{"a":82,"e":82},"m":82,"n":82,"o":79,"ö":82,"p":82,"r":82,"s":[{".":82,"a":82,"c":171,"e":328,"i":4,"k":37,"p":328,"t":{"e":{"r":58},"r":{"ä":54}},"z":171},2],"t":{"a":{"r":27},"h":82,"r":4,"y":82},"u":[{"m":5},1],"v":82,"w":82,"z":82},71],"o":120,"r":{"a":[{"d":36,"p":6},4],"b":[{"u":{"n":82}},10],"d":4,"e":[{"c":{"k":5},"i":{"n":{"s":55},"s":14},"r":[{"k":17,"z":14},3]},73],"f":10,"g":[{"i":71},10],"i":89,"k":22,"n":[{".":82,"a":22,"i":73},71],"ö":6,"r":{"e":{".":12}},"s":{"e":{"h":27,"i":4},"t":[{"a":4,"e":4},22]},"t":{"e":4,"i":22},"z":37},"s":[{"a":{"n":6},"c":73,"e":[{"n":{"s":149}},73],"p":{"a":16,"e":2,"u":6},"s":{"e":{"r":{"g":351,"l":26}},"t":2},"t":{"e":33,"i":{"n":5},"r":0},"u":1},77],"t":{"a":{"g":41,"k":21,"n":6,"p":21,"t":6,"u":6},"e":{"n":{"t":5},"r":{"h":14,"t":14}},"h":{"e":[{"r":4},89],"o":21,"y":6},"o":{"b":5},"ö":{"s":150},"r":{"i":23,"u":23},"s":{"e":2},"t":71,"z":{"w":4}},"u":{"e":2,"n":0},"w":{"u":23},"x":72},"f":[{"a":{"n":{"g":{"e":1}},"r":[{"m":86},0],"t":5,"u":104},"ä":{"n":0},"e":{"c":73,"f":104,"i":[{"n":0},12],"n":226,"r":{"g":104,"h":0}},"f":{"a":{"r":6},"l":23,"r":{"o":6},"s":[{"t":{"e":12}},2]},"l":[{"a":{"c":0},"ä":5,"o":[{"s":5},10],"ü":71},1],"r":[{"e":[{"g":73,"v":5},71]},1],"s":[{"a":1,"e":1,"p":1,"t":{"a":1}},6],"t":{"a":23,"e":{"d":6,"f":23,"i":41,"l":36,"p":6,"r":{"k":5},"s":[{"c":14},22]},"h":5,"o":{"p":21},"r":[{"i":14},21],"s":{"p":4,"t":22,"z":4},"u":{"r":6}},"y":71},77],"g":[{"a":{"n":{"b":73},"r":{"b":73,"t":0},"s":13,"t":{"t":86}},"d":2,"e":{"b":{"r":{"a":{"u":164}}},"f":{"a":{"r":89},"ü":{"g":12}},"l":{".":88,"a":{"u":35},"n":73},"m":{"e":12,"i":{"s":12}},"n":{"a":12,"e":{"n":{"e":26}},"i":{"d":12}},"o":2,"p":{"a":2},"r":{"a":2,"w":{"e":{"r":7}},"z":[{"e":10},0]},"s":{"e":{"l":12},"s":104},"t":{"r":{"a":12,"e":12}},"w":{"o":{"h":12}}},"i":{"m":73},"l":[{"a":{"u":0},"ä":82,"e":82,"i":{"m":1}},73],"n":{"a":5,"ä":89,"e":{"u":124},"o":5},"o":{"p":13},"r":{"a":{"d":1},"e":[{"n":5},86],"o":{"u":73}},"s":{"a":{"g":3,"l":5},"ä":1,"c":{"h":{"r":5}},"o":3,"p":[{"a":5},1],"t":{"e":{"i":1},"i":5,"o":14,"r":[{"a":{"s":24}},1],"ü":16}},"u":{"n":{"g":19}}},93],"h":[{"a":{"r":73},"e":[{"e":13,"l":{"t":0},"n":12,"u":4},82],"m":1,"n":1,"r":3,"s":2,"u":{"m":{".":0}},"w":0},93],"i":[{"a":16,"e":71,"g":82,"m":71,"n":82,"s":[{".":73},115],"t":[{".":71},1]},6],"j":[{"s":85},71],"k":[{"a":{"g":{"e":2},"k":{"a":0,"e":{"n":247},"t":104},"m":{"t":1},"n":{"g":104,"t":{"e":{"i":164,"n":{"n":66}}}},"r":{"t":0},"t":{"t":1},"u":104,"z":82},"ä":{"h":0,"r":73},"e":[{"b":[{"e":0},73],"c":2,"d":104,"f":104,"i":104,"l":99,"n":[{"s":83,"t":0},11],"r":{"a":2,"e":352,"f":[{"a":{"m":140}},117],"h":117,"l":97,"o":73,"u":346},"t":{"a":104}},84],"i":[{".":82,"d":32,"e":82,"n":[{"s":73},0],"s":13},84],"l":[{"ä":{"n":5},"e":{"r":{"i":124},"t":124},"i":{"m":5},"u":82},86],"n":{"e":73,"u":1},"o":{"b":{"e":4},"f":{"f":104},"p":100,"r":[{"i":2},0],"s":13},"ö":{"l":73},"r":{"ä":1,"e":[{"s":73},1],"i":{"s":5},"o":82,"ö":73},"s":[{"a":1,"t":{"e":1},"z":1},2],"t":{"e":{"r":{"k":4},"s":{"k":14}},"r":{"e":23},"u":2},"u":{"h":104,"p":73,"s":82},"ü":73},93],"l":{"a":[{"b":73,"c":104,"k":104,"m":{"a":32},"n":{"g":0,"m":104,"o":73,"s":0,"z":{"e":{"r":33}}},"r":{"b":73},"s":{"p":0},"u":[{"b":82,"f":{"b":124}},104]},71],"ä":[{"r":73},311],"b":[{"l":12},77],"c":[{"h":{"e":{"n":7}}},6],"d":{"a":6,"ä":6,"e":{"b":{"e":4},"n":{"t":39},"r":[{"p":12},1],"s":22},"i":22,"o":[{"r":6},13],"r":6},"e":[{"c":32,"i":{"n":0},"l":0,"m":{"b":73,"i":113},"n":{"t":[{"l":89,"s":89},0]},"r":{"d":104,"e":{"i":[{"g":164},10]},"f":[{"o":10},0],"g":97,"h":117,"k":{"l":278},"r":[{"i":89},0],"z":79},"t":{"h":12},"x":0},84],"f":[{"e":{"s":25},"l":23,"r":{"e":23},"s":27},2],"g":{"l":6},"h":77,"i":[{"e":{"n":353},"g":{"a":[{"b":27},105]},"k":10,"n":{"d":104,"i":{"t":128},"s":0},"p":[{"f":13},104]},77],"l":{"a":[{"n":2},1],"e":{"n":{"n":5},"r":3},"u":75},"m":{"a":{"k":6,"p":21,"u":21},"e":{"i":13},"i":{"n":6},"o":{"r":6}},"o":[{"b":0,"h":6,"p":6,"r":113,"u":82,"v":82,"x":0},77],"s":{"e":{"n":{"t":4}},"t":{"o":12}},"t":[{"h":1},2],"u":[{"m":73,"n":{"g":19},"r":104,"s":82},71],"ü":12,"v":158,"z":{"a":{"r":6,"u":6},"e":{"r":{"k":4}},"w":{"a":6}}},"m":{"a":{"d":22,"i":13,"l":6,"n":{"h":86,"s":0},"r":{"c":73,"e":{"n":1},"m":104,"t":104},"s":6,"t":[{"r":2,"s":{"c":55},"u":{"r":12}},5],"u":{"s":0,"t":73}},"b":[{"i":75},1],"e":{"g":73,"i":{"n":0},"j":73,"k":73,"l":{"e":73,"f":73},"n":6,"r":{"f":117,"l":117,"z":117},"s":{"h":95,"s":25},"t":{"i":73},"w":73},"h":{"a":{"u":105}},"i":{"d":[{"e":32},73],"m":73,"n":{"d":104,"f":73,"s":104}},"m":{"ä":6,"e":{"i":6,"n":[{"t":[{"h":24},4]},132]},"o":[{"r":6},75]},"o":[{"b":104,"p":289,"r":{"e":4}},77],"ö":73,"p":[{"f":{"a":2,"o":43},"s":[{"e":1},2]},75],"s":{"e":{"t":5},"p":{"h":1}},"t":[{"e":2,"i":3,"s":37,"u":22},77],"u":[{"m":6,"r":{"k":0}},84]},"n":{".":77,"a":{"b":{"e":2,"u":1},"c":[{"k":89},32],"d":0,"l":{"d":82,"e":{"r":[{"e":26},102]},"p":6},"m":104,"n":[{".":1,"a":1,"n":1},6],"r":{"b":73},"t":{"t":1},"u":354},"ä":[{"h":104,"r":6,"s":0},77],"d":{".":77,"a":[{"c":2,"l":6,"n":6},22],"ä":77,"e":{".":77,"n":77,"r":{"k":{"e":35},"t":17},"s":{"p":25},"x":75},"i":[{"k":75},2],"ö":1,"r":77,"s":{"e":4},"u":{"s":75},"ü":3},"e":[{"c":32,"e":82,"f":{"f":73},"l":{"e":{"n":5}},"n":[{"ä":4,"z":{"y":278}},11],"r":{".":140,"b":{"i":128},"h":{"a":5,"e":278},"k":82,"l":{"e":[{"b":336},355],"ö":10},"t":{"r":344}},"s":[{"k":89},82],"t":6,"u":[{"n":4},0]},77],"f":[{"e":{"k":75},"i":{"z":75},"o":75},16],"g":{"a":[{"f":21,"g":21,"l":21,"m":6,"r":13},77],"ä":77,"e":{"n":{"i":78},"r":[{"w":39},3],"s":19},"l":[{"a":1,"ä":1},80],"s":{"a":{"m":27},"p":{"o":{"r":33}}}},"h":{"a":{"b":75,"r":77,"u":77},"e":77},"i":{".":77,"d":[{"e":4},6],"e":77,"g":[{"a":22},77],"k":{"r":9},"s":[{"e":4},77],"t":[{"z":82},22]},"k":{"a":{"r":{"n":78},"s":75},"e":{"l":{"s":{"t":29}},"n":{"t":14},"r":12},"r":{"o":6},"ü":3},"m":{"a":{"l":{"e":10}}},"n":{".":77,"e":{"n":10,"r":{"m":42}},"l":77,"o":{"r":6},"t":{"a":75}},"o":[{"d":0,"e":9,"l":{"s":1},"r":0,"s":13,"t":171,"u":104},77],"ö":[{"d":32},71],"r":77,"s":{".":77,"a":{"m":[{"t":{".":24}},2]},"c":{"h":105},"e":{".":77,"b":6,"d":77,"n":77},"k":77,"o":{"f":1},"t":{"a":{"l":78},"ä":{"t":14},"e":144,"i":{"p":16,"t":78},"o":12,"r":{"a":84,"ü":5}},"u":{"f":75,"m":{"z":4},"r":6},"z":1},"t":{"a":77,"e":{".":77,"g":75,"i":1,"p":77},"h":[{"i":132},108],"o":2,"ö":77,"r":[{"ä":84,"i":[{"g":78},7]},223],"s":4},"u":[{"h":89,"n":{"z":1}},104],"v":{"e":{"r":{"m":84}},"i":{"l":105}},"y":217,"z":{"e":[{"l":{"l":{"e":{"r":175}}}},3],"i":3,"s":{"c":3},"u":2,"w":1}},"ñ":71,"o":[{"b":{"l":2},"c":0,"d":[{"a":1},6],"e":16,"f":[{"l":12},73],"h":73,"i":0,"k":{"r":356},"l":{".":82,"s":82},"m":{".":82,"e":1,"s":82},"n":[{".":82,"a":{"n":4,"u":23},"d":37,"e":{"e":5},"o":[{"r":6},82],"s":[{"a":12,"e":{"n":12}},357],"y":73},2],"o":73,"p":[{"f":124,"t":82},104],"r":[{".":82,"c":82,"e":[{"n":10},2],"h":32,"p":82,"s":82,"t":82},73],"s":[{".":82,"h":1,"p":2,"t":104,"u":2,"z":86},84],"t":[{".":82,"e":{"l":25},"r":12,"s":82},1],"u":73,"v":73,"x":82,"z":[{".":82},73]},93],"ö":{"k":72,"n":71,"s":{".":71,"t":71}},"p":{"a":[{"n":6},71],"e":[{"d":82,"r":82},71],"f":[{"a":{"n":82},"e":22},108],"h":2,"i":[{"a":4,"e":{"l":4,"n":4}},93],"l":{"u":5},"p":{"a":{"n":6},"e":1,"f":13,"l":5,"u":1},"r":71,"s":{"a":6,"e":{"i":6},"p":6,"t":[{"a":5,"ü":5},4]},"t":{"a":2,"i":2,"u":2},"u":77},"q":93,"r":{"a":[{".":82,"d":76,"s":82,"t":10},115],"ä":[{"h":0},71],"b":{"l":23},"c":[{"h":{"o":302}},0],"e":[{"e":82,"k":77,"n":{"a":12}},5],"é":82,"g":12,"h":{"e":6},"i":[{"g":255},6],"k":[{"e":{"n":[{"e":5},10]},"l":23,"s":{"c":27},"u":3},77],"l":{"i":{"n":10}},"m":{"a":{"g":21,"k":6,"u":13},"ä":6,"e":{"i":21,"n":160},"o":125,"t":{"h":12},"u":{"m":6,"n":{"t":5}}},"n":[{"a":[{"t":5},23],"o":6},77],"o":82,"ö":71,"p":{"l":{"a":105}},"r":{"e":{"l":10},"h":6},"s":{"c":{"h":{"e":1,"l":5,"m":5,"r":260,"w":260}},"e":121,"h":3,"t":6},"t":{"s":{"t":162}},"u":[{"m":32,"s":11},77],"ü":79},"s":{"a":{"c":73,"m":[{"p":89,"t":114},162],"p":6,"r":[{"e":1},2],"t":[{"t":1},82],"u":[{"f":1,"g":22},73]},"ä":{"h":73,"n":104},"b":77,"c":{"a":73,"h":{"a":{"r":89},"e":[{"f":89,"h":358,"i":25,"m":[{"i":164},19],"r":{"z":166}},79],"i":{"n":[{"g":140},89]},"l":157,"m":[{"a":25},73],"n":{"a":89},"r":{"e":165,"u":25},"u":82,"ü":{"b":89},"w":{"a":89,"i":{"r":164},"o":89,"u":25,"ü":89}},"r":73},"e":[{"a":4,"e":13,"h":{"a":22,"i":4},"i":{"n":{"d":5}},"l":{"i":5,"t":{"e":{"r":336}}},"n":[{"a":12,"d":6,"h":{"o":89},"s":25},11],"r":{"e":{"i":27},"g":0,"h":[{"e":10},73],"m":104},"s":{"s":129},"t":[{"a":{"t":128}},79],"u":79},77],"f":77,"h":84,"i":[{"a":2,"d":[{"e":12},113],"k":22,"m":73,"n":{"g":159},"s":13},77],"k":{"i":89,"u":89},"l":{"a":[{"m":78},1]},"m":{"a":77,"i":77,"u":22},"o":{"f":0,"h":82,"l":85,"n":[{"e":{"n":[{"d":26},102]},"o":105},359],"p":73,"r":{"t":0},"t":78,"u":104},"p":[{"a":[{"r":73,"t":6},0],"e":0,"i":{"c":0},"o":{"r":6},"r":{"o":73}},77],"s":{"a":[{"c":41,"u":5},1],"c":{"h":{"e":{"n":20}}},"e":{"r":{"f":19}},"p":{"o":2},"t":[{"a":1,"o":1,"r":[{"ä":1},4],"u":1},6],"u":{"m":6}},"t":{"a":{"b":5,"c":37,"n":[{"g":1},2],"t":71},"ä":{"u":1},"e":[{"l":71,"n":10,"s":17,"u":71},12],"i":{"l":71,"n":{"f":19}},"o":[{"c":5},356],"ö":{"r":1},"r":[{"a":12,"o":5,"u":5},1],"ü":71},"u":{"f":82,"m":[{"p":25},2]},"ü":73,"y":77},"ß":[{"e":{"r":{"s":[{"c":1},22]}}},71],"t":{"a":{"b":{".":0,"s":0},"l":{"a":48,"t":0},"m":0,"n":{"e":4,"r":1},"p":{"p":0},"r":{"e":32,"t":0},"t":82,"u":[{"c":82,"t":73},0]},"ä":[{"n":{"d":0},"s":104,"t":22},84],"e":{"f":{"f":0},"i":[{"c":6},104],"l":[{"a":99,"e":{"k":89}},77],"m":{"i":104,"p":73},"n":[{"s":266,"t":{"s":89}},2],"p":{"o":73},"r":{"e":{"i":{"g":164}},"f":{"o":344},"i":{"n":{"d":29}},"k":{"l":{"ä":33}},"ö":6,"s":{"c":{"h":{"e":360}}}},"s":{"k":114},"x":[{"t":82},104]},"h":{"r":140,"y":73},"i":{"c":140,"d":104,"g":140,"i":75,"n":298,"s":[{"o":89,"p":4},82],"v":{"a":361}},"l":{"e":7},"m":{"e":{"n":105}},"o":[{"b":0,"c":140,"d":4,"f":104,"p":2,"s":6},84],"r":[{"a":{"d":[{"i":82},86],"f":1,"s":1,"u":1},"ä":{"u":1},"e":[{"n":89,"t":5},1],"o":{"b":1,"m":1},"u":{"n":86,"t":1}},84],"s":[{"a":[{"g":13},6],"e":[{"h":110,"r":362},21],"h":5,"o":{"r":13},"t":{"r":{"a":{"s":24}}},"u":{"r":6}},77],"t":[{"a":{"n":6},"e":{"b":6},"h":{"ä":4},"o":{"b":6,"p":6},"r":{"i":[{"c":4},5]},"s":{"c":{"h":{"i":26}},"e":{"h":363,"i":12},"o":{"r":12},"p":2,"t":{"i":12}}},77],"u":{"h":0,"m":{"s":0},"n":{"g":6,"s":73},"r":{"a":{"n":102},"g":0},"t":10},"ü":82,"y":[{"l":22},101],"z":{"e":{"c":36,"r":[{"g":[{"r":24},4],"l":14},2]},"ö":6,"w":21}},"u":[{"l":128,"m":[{"a":22,"s":{"e":12,"t":{"e":12}}},14],"n":2,"p":89,"r":5,"s":{"t":4}},161],"ü":115,"v":[{"a":{"d":104,"k":104,"m":104,"n":0},"ä":104,"e":{"b":73,"f":104,"i":0,"l":{"t":0},"n":[{"e":0,"t":104},12],"p":104,"r":{"e":4,"h":0,"k":{"l":10},"l":0,"s":25},"s":4,"x":104},"i":{"m":104,"n":{"d":104,"t":0}},"o":{"l":82,"r":{"e":4}},"r":104,"u":{"n":73,"r":104},"ü":73},93],"w":93,"x":[{"a":73,"e":{"m":6},"i":82,"t":2},93],"y":71,"z":[{"a":[{"c":6,"g":73,"n":73,"p":73,"s":79,"u":73},0],"ä":73,"e":[{"i":[{"c":25,"t":{"s":102}},6],"l":{"e":73},"n":[{"e":{"r":89},"t":{"z":89}},2],"r":{"l":114}},82],"i":{"d":25,"r":0},"o":{"f":2},"ö":73,"u":{"n":{"a":73}},"w":[{"i":79},104]},189]},"í":{"l":71},"j":{"a":[{"b":12,"c":0,"h":{"r":{"e":{"i":27},"s":22}},"l":[{"a":2},1],"n":{"e":1,"i":[{"t":159},48]},"r":{"u":7},"s":{"o":2,"t":0},"t":2},73],"d":[{"a":4},205],"e":{"a":[{"n":{"s":22}},6],"g":6,"k":{"t":{"a":12,"e":{"r":12},"i":{"n":12},"o":[{"r":102},266],"r":364}},"n":{"a":1},"p":6,"r":[{"e":2},1],"s":{"t":4},"t":{"a":21,"h":14,"i":{"n":6},"o":{"r":5},"r":23,"s":37,"t":4,"u":125},"v":1,"w":{"o":1}},"i":{"v":6},"m":93,"o":{"a":4,"b":[{"r":4},21],"d":{"a":6},"i":6,"l":{"a":2},"n":{"g":22},"p":23,"r":{"a":32,"d":37},"s":[{"c":6,"t":22},120],"u":[{"l":2},78]},"t":[{"y":13},93],"u":[{"b":{"l":23},"g":{"e":{"n":[{"d":247},15]}},"i":0,"k":6,"l":{"i":2},"n":{"g":{"s":159},"i":1},"r":[{"a":12,"o":2},1],"s":{"t":4},"t":{"e":365}},73],"v":93},"k":{"a":[{".":78,"a":{"r":1},"b":{"b":[{"l":2},93],"d":77,"e":{"n":152},"f":77,"g":77,"h":77,"n":77,"o":161,"s":93,"t":93,"w":77,"z":77},"c":0,"d":{"e":{"r":22},"m":93,"r":161,"u":78,"v":77},"f":{"l":120,"r":0,"t":37},"g":[{"a":25,"e":93},2],"h":[{"o":0},78],"i":{"n":0},"k":{"e":{"n":105},"l":0,"t":{".":93}},"l":{"a":{".":77,"b":25,"d":125,"n":6},"d":4,"e":{"h":41,"n":{"s":5},"r":{"i":4}},"k":[{"a":[{"n":12},11],"l":162},88],"l":{"i":22,"t":93},"o":{"p":6,"s":21},"t":{"e":{"x":12},"h":12},"u":6},"m":{"t":73},"n":{"a":{"l":12,"s":176,"u":6},"b":77,"d":[{"a":77,"ä":77},37],"e":2,"f":77,"i":{"m":77},"k":10,"l":77,"o":{"m":77,"r":93},"s":[{".":73},93],"t":{"a":{"r":12},"e":{"n":{"n":209}},"h":93},"u":[{"m":2},1],"w":77,"z":{"u":93,"ü":77}},"o":21,"p":{"e":78,"o":1},"r":{"a":78,"b":{"e":77},"c":77,"d":[{"a":37},73],"e":{"a":71},"g":73,"i":[{"e":{"s":25}},3],"k":73,"m":93,"p":{"f":2},"s":73,"t":{"a":346,"i":[{"k":84},71]},"u":22,"w":73},"s":{"c":88,"e":[{"i":48},2],"i":48,"o":2,"p":5,"t":[{".":93,"e":5,"r":{"a":{"s":26}}},23],"u":78,"z":1},"t":{"a":{"n":6},"e":{"g":78,"l":82},"h":3,"r":14,"t":148},"u":{"f":{"e":{"r":12},"o":11,"s":{"a":{"g":58},"p":10,"t":{"e":{"m":63},"i":33}}},"s":{".":73,"s":93,"t":2,"w":77},"t":[{"o":77},37]},"v":{"e":1},"z":77},75],"ä":[{"l":4,"m":{"i":71},"n":{"d":93},"r":[{"g":93},2],"s":{"c":21,"e":25}},75],"b":[{"o":{"n":12},"u":{"s":2},"y":12},309],"c":76,"d":134,"e":{"b":{"e":{"n":6}},"c":111,"d":{"i":6},"f":{"f":93,"i":22},"g":{"e":22,"l":6},"h":{"e":{".":6,"n":6},"r":{"e":{"r":102},"s":[{"o":277},22]}},"i":{"c":93,"g":93,"l":{"i":2},"m":6,"n":[{"d":{"u":10},"e":10},93],"s":[{"e":77},311],"t":[{"s":132},22]},"l":{"a":[{"g":3,"m":14},21],"ä":6,"b":10,"d":10,"e":{"i":{"s":4},"k":80,"n":21,"r":21},"l":{"e":179,"i":22},"o":125,"ö":6,"s":{"k":4,"t":{"e":{"r":{"n":366}}}},"t":[{"e":10},89]},"m":{"i":152,"p":93},"n":{".":73,"a":[{"u":4},13],"ä":6,"d":[{"r":4},10],"e":{"b":125,"n":[{"e":5,"s":5},132],"r":{"n":19},"t":10},"g":{"a":{"g":225},"e":{"l":{".":329}}},"i":{"m":6,"n":4},"l":{"a":{"d":84},"ä":{"d":84}},"n":{"a":22,"e":22},"o":6,"s":{"a":73,"e":{"m":225},"i":4,"k":37,"t":{"e":{"i":327}},"z":4},"t":{"e":{".":275,"n":{".":26}},"f":77,"g":77,"h":4,"l":77,"s":93,"w":77,"z":77},"y":1,"z":196},"o":219,"p":[{"l":6},77],"r":{".":73,"a":[{"n":6,"u":6},0],"ä":21,"b":{"l":{"e":12}},"c":73,"d":77,"e":{"b":125,"c":6,"i":{"g":1,"n":4}},"f":{"a":{"h":84,"m":89},"o":2},"g":{"e":{"b":82},"u":77},"i":{"n":{"n":{"u":273},"s":{"t":15},"t":19}},"k":{"e":{"n":82},"o":73},"l":{"a":{"u":82},"e":{"b":[{"e":164},275]}},"n":{"a":2,"e":{"i":12,"u":[{"r":55},250]}},"o":[{"d":104,"s":77},71],"r":{"e":{"g":12}},"s":{".":73,"a":77},"t":22,"w":{"e":{"r":{"b":26}}},"z":[{".":71,"e":{"u":12},"i":321},22]},"s":{".":73,"a":6,"c":73,"e":[{"l":6},71],"s":{"a":2}},"t":{"a":[{"g":2},41],"e":[{"b":41,"l":5},10],"h":[{"a":4},152],"u":6},"u":{"s":{"c":{"h":{"l":26}}}},"v":{"a":152},"x":152},"f":309,"g":[{"a":{"s":11},"e":{"s":4}},161],"h":[{"e":82,"o":{"m":4},"u":82},205],"i":{"a":[{"d":6,"g":6,"k":1,"r":3},0],"c":0,"d":{"r":16,"s":73,"y":77},"e":{"l":[{"e":{"i":12},"o":25},6],"r":{"n":77,"s":[{"t":10},22]},"z":12},"f":{"l":120,"r":120},"k":16,"l":{"a":173,"ä":77},"m":77,"n":{".":78,"ä":6,"d":{"e":{"x":84},"i":93,"u":93},"f":93,"g":[{"a":2,"s":25},73],"h":77,"i":[{"k":105},157],"n":73,"o":[{"s":105},210],"s":[{"e":93,"t":71},4],"t":93},"o":{"r":1,"s":12},"r":78,"s":{"o":152,"p":2,"s":4,"t":[{"o":12},22]},"v":[{"e":10},2],"z":77},"j":76,"k":[{"a":{"b":10}},205],"l":[{".":84,"a":{".":84,"c":93,"n":[{"d":[{"u":25},77]},22],"r":89,"s":{"t":71},"u":{"f":71,"g":82}},"ä":{"d":77,"r":73},"e":[{".":106,"b":{"r":2},"g":82,"h":77,"i":{"e":22,"t":82},"m":{".":82},"o":2,"r":[{"a":2},76],"u":[{"s":4},76]},73],"i":{"c":77,"e":{"n":73},"f":73,"g":77,"m":88,"n":[{".":82,"a":147,"k":89},73],"p":73,"r":73,"s":{"c":73,"t":77},"t":{"s":22},"z":76},"o":{"c":76,"k":77,"p":147,"r":82,"s":{"t":15}},"ö":{"c":77,"f":77,"s":{"t":73},"t":89},"u":[{"b":12,"d":73,"g":73,"m":73,"n":{"g":19},"x":77},71],"ü":{"c":93},"y":77},5],"m":[{"a":[{"l":{"a":2}},84]},93],"n":[{"a":{"c":[{"h":255},89],"d":76,"h":77,"m":76},"ä":{"p":76},"e":[{"c":89,"e":13,"s":77,"t":{"z":77},"u":255,"y":84},82],"i":{"v":76},"o":{"b":{"l":162},"l":89,"r":{"m":77},"v":77},"u":{"m":76}},218],"o":[{"a":{"d":7,"l":6},"b":{"a":{"l":105},"j":77,"s":12},"f":{"f":[{"e":{"i":17}},37]},"h":{"l":{"e":[{"i":17},22],"u":4}},"k":{"a":25},"l":{"a":3,"e":1,"k":162},"m":[{"e":{"r":17},"n":84,"u":5},78],"n":[{"e":[{"m":6},22],"s":9,"t":{"e":33},"u":6},73],"o":{"n":1},"p":{".":77,"e":[{"r":77},0],"f":{"a":105,"e":{"n":12,"r":{"r":46}}},"s":4,"t":{"e":1}},"r":{"a":3,"b":{"a":2,"l":2,"r":2},"c":93,"d":{"e":{"r":[{"g":26},102]}},"e":{"l":6},"g":93,"k":{"a":11},"m":4,"n":{"a":{"c":12},"ä":162,"o":367},"p":{"i":77}},"s":[{".":89,"k":5,"p":6,"t":[{"ü":6},147]},73],"t":{"e":{"r":5},"i":1,"r":12,"s":37,"t":{"a":{"k":12}}},"u":[{"n":1},71],"w":[{"e":6},78],"x":93},75],"ö":[{"d":{"e":22},"f":73,"l":71},75],"p":152,"q":76,"r":[{"a":{"d":76,"h":76,"l":89,"t":{"s":82},"u":{"m":77},"w":89,"z":89},"ä":{"c":89,"d":77,"n":89,"u":{"m":76}},"e":{".":255,"a":{"k":76,"l":76},"b":89,"c":76,"d":{".":77,"e":76,"n":77,"u":77},"f":76,"g":77,"i":{"c":76,"e":[{"r":102},368],"f":82,"h":76,"m":77,"s":{"e":{"i":33},"t":10}},"l":{"i":132},"n":82,"s":{"u":77}},"h":76,"i":{"b":77,"c":76,"e":{"s":76},"p":77,"s":{"i":82}},"o":{"b":10,"c":{"h":89},"h":106,"k":89,"n":89,"p":89,"t":[{"h":78},77],"u":82},"ö":{"h":77},"u":{"f":77,"n":76}},218],"s":[{"a":{"b":3,"k":2,"m":{"t":114},"n":73,"r":3,"s":2,"u":[{"f":22},73],"v":73},"ä":{"h":73},"c":[{"h":10},79],"e":{"b":113,"c":104,"d":79,"i":[{"d":6,"f":6,"n":{"d":89}},0],"l":{"e":2},"n":{"g":104,"t":104},"r":[{"e":6,"f":73,"g":73,"k":73,"l":73,"s":73,"w":73},0],"v":113,"x":73},"h":{"a":1},"i":{"d":296,"m":6,"n":104,"s":104},"k":{"e":79,"l":1},"o":[{"n":5,"p":73,"r":289},0],"ö":73,"p":{"a":[{"l":73,"t":79},0],"ä":73,"e":[{"l":6,"n":6},82],"h":73,"o":{"r":6},"u":{"l":6}},"s":16,"t":[{"a":{"l":73,"n":{"z":128},"t":202},"ä":{"l":82},"e":{"l":5,"p":6},"i":{"e":{"r":89},"t":73},"o":{"l":5,"r":73},"r":{"o":{"p":89}},"u":{"c":73,"m":73,"r":73},"ü":{"t":73}},2],"u":[{"l":82},104],"z":{"e":{"n":6}}},189],"t":[{"a":{"b":{"r":0,"s":0},"d":104,"k":{"t":0},"l":82,"m":0,"n":[{"d":6},0],"r":[{"e":12,"i":4},113],"u":[{"g":1},104]},"ä":{"s":4},"e":{"i":{"n":0},"k":73,"l":{"a":114},"n":[{"s":266,"t":[{"f":89,"s":89},73],"z":25},99],"r":{"a":[{"n":4},2],"e":5,"f":{"o":128},"g":0,"h":104,"ö":73,"u":4},"x":73},"h":104,"i":{"d":113,"m":{"e":2},"n":{"d":1,"g":0,"i":0,"n":1,"t":73},"s":{"e":11,"o":73},"t":{"e":{"r":12}}},"o":{"b":4,"f":104,"r":{"e":{"n":{".":35}}}},"r":{"a":{"n":124,"s":1,"u":86},"e":{"f":89},"o":{"s":48},"u":{"n":1},"ü":1},"s":{"a":16,"ä":1,"e":[{"l":2,"n":132},1],"i":1,"o":[{"r":6},13],"z":3},"t":2,"u":{"b":82,"m":{"s":0},"n":{"s":73}},"ü":82,"z":3},189],"u":{"a":{"l":6},"c":0,"d":{"r":12},"g":78,"h":[{"r":93},6],"l":{"a":1,"e":3,"i":3,"p":84,"t":{"o":12,"r":2}},"m":{".":73,"e":237,"g":77,"l":77,"s":{"a":2,"p":2}},"n":{"a":167,"d":{"a":4,"e":[{"n":247},22]},"g":10,"s":[{"t":17},288],"t":77,"w":77},"p":{".":189},"r":{"b":{"l":2},"e":{"i":6},"i":{"e":[{"r":10},22]},"k":93,"o":6,"s":{"c":48,"p":2,"t":2},"t":[{"s":{"c":4}},369]},"s":{"a":{"r":37},"c":{"h":{"l":5}},"p":6,"t":370,"u":6},"t":{".":77,"a":2,"o":25}},"ü":[{"c":0,"n":{"e":78},"r":[{"s":12},78]},75],"v":76,"w":[{"a":82},93],"z":[{"e":{"l":4}},161]},"l":{"a":{".":78,"a":{"r":1},"b":[{".":88,"a":[{"d":6},2],"ä":73,"b":[{"r":2},77],"d":77,"e":[{"n":139},2],"f":84,"g":77,"h":77,"i":[{"t":79},78],"l":371,"n":77,"o":[{".":84},187],"r":{"a":16,"e":{"s":12},"i":6},"s":77,"u":{"s":6},"w":77,"z":77},71],"c":{"e":[{".":6},0],"h":{"e":128,"t":{"e":{"r":{"f":66}}}},"k":{"s":105}},"d":[{"a":321,"d":77,"e":{"n":78},"i":3,"j":77,"l":93,"m":77,"r":152,"u":88},75],"f":[{"a":6,"e":{"i":21,"r":21},"r":13,"s":4,"t":9,"u":6},77],"g":{"a":21,"d":4,"e":{"r":[{"i":{"n":279}},73]},"g":84,"i":{"o":6},"l":4,"n":14,"o":[{"b":6},10],"s":{"t":{"r":4}}},"h":{"o":107},"i":78,"k":{"e":22,"i":{"n":6},"k":73,"l":120,"r":{"o":6},"t":37},"l":[{"a":[{".":78},6],"i":78,"t":84},93],"m":{"i":{"t":25},"m":{"a":11,"f":75},"o":{"r":6},"p":73,"t":[{"s":10},93],"u":{"n":5}},"n":{"a":[{"n":1,"t":240,"u":5},6],"ä":80,"d":[{".":89,"a":[{"m":12,"u":25},2],"e":[{"r":{"h":26,"w":46,"z":46}},89],"i":{"n":{"n":46}},"r":[{"i":4,"ü":25},234]},88],"e":{"r":{"d":4,"f":19}},"f":77,"g":{"a":{"n":12},"e":{"s":{"c":46}},"s":159},"h":{"a":77,"e":73},"i":187,"l":84,"n":93,"o":[{"f":6},71],"p":93,"s":[{"i":71},154],"t":{"r":77,"w":77},"w":77,"z":{"w":11}},"o":78,"p":{"f":93,"h":6,"o":152,"p":{"l":2}},"r":{"a":{"n":21},"c":77,"e":{"b":100,"i":21,"l":6,"n":{"e":5}},"f":10,"g":4,"i":{"n":{"i":4}},"o":{"m":248},"t":[{".":77,"h":22,"i":82,"r":10},71],"u":78},"s":{".":73,"a":[{"m":5},6],"ä":5,"c":{"h":{"e":102}},"d":84,"e":{"b":1,"i":6,"l":125},"h":77,"i":{"n":6,"s":6},"o":6,"p":372,"s":{"e":{"r":78}},"t":[{"a":{"n":27},"e":5,"r":{"i":25},"u":5},218]},"t":{"e":[{"l":134},3],"i":47,"l":76,"m":77,"o":2,"ö":6,"r":{"a":23,"i":12},"s":[{"t":4},2],"t":{"a":[{"n":12},108],"e":{"x":12},"i":{"n":27},"r":162},"z":{"e":{"r":102}}},"u":{"b":{".":75,"e":{"n":{"s":373}},"r":162,"s":{"e":10}},"f":{"i":{"n":12},"n":77,"o":2,"r":{"i":12}},"g":[{"l":4},75],"n":{".":77},"s":[{".":88,"b":93,"c":{"h":{"a":26}},"d":77,"f":93,"g":77,"l":77,"r":77,"s":93,"t":2,"w":77,"z":77},5],"t":{"o":77,"r":2}},"v":{"a":1,"e":{"n":10}},"w":[{"a":10},75],"x":[{"e":{"l":5}},85],"y":[{"s":13},73]},"ä":{"c":0,"d":78,"f":84,"h":{"n":93},"m":{"t":77},"n":{"d":75},"p":{"f":93},"q":77,"r":{"m":{"a":2,"e":71},"z":77},"s":{"c":21},"t":77,"u":{"b":77,"c":77,"e":77,"f":75,"g":77},"x":77},"à":75,"b":[{"a":{"c":82,"n":{"t":73},"r":{"i":3},"u":{"c":48}},"ä":{"r":{"m":0}},"b":[{"y":10},12],"e":{"i":[{"n":{"k":128},"s":{"e":128}},6],"r":{"a":{"l":12},"i":{"n":53}},"s":263,"t":{"a":374}},"i":{"d":104,"n":{"s":104}},"l":{"a":{"d":5,"t":79},"ä":82,"e":[{"d":73},1],"i":{"c":73},"o":82,"ö":79,"u":79},"o":{"r":{"a":113}},"r":{"e":{"a":1}},"s":[{"a":1,"e":1,"i":1,"p":1,"t":[{"a":{"c":25},"e":{"i":25},"u":48},12]},6],"u":{"f":104,"m":82,"n":12},"z":{"e":{"i":105}}},93],"c":[{"a":82,"h":{"e":[{"i":89,"n":{"t":89}},82],"i":82,"l":{"e":4,"i":4,"o":82},"n":4,"r":4,"s":37,"ü":4,"w":13},"k":73,"l":82,"o":82},93],"d":[{"a":{"b":365,"c":[{"k":3},6],"f":73,"g":2,"h":104,"i":2,"k":104,"l":104,"n":183,"r":{"m":0},"s":{"s":0},"u":[{"s":1},104]},"ä":{"m":82,"r":0,"s":0,"t":0},"e":{".":82,"b":{"e":{"n":12}},"i":[{"n":63},73],"l":{"f":104},"m":{"i":113,"s":104},"n":{"a":12,"e":{"r":{"g":55}},"t":{"l":89}},"r":{".":82,"f":{"a":344},"g":{"e":{"b":336}},"h":[{"e":278},0],"l":[{"a":{"s":338}},79],"n":79,"p":117,"t":{"r":10}},"s":{"a":4,"s":117},"x":73},"i":{"d":104,"m":{"i":120},"o":{"n":86}},"o":{"b":2,"n":6,"p":73,"r":[{"i":104},2],"s":[{"t":55},6]},"ö":232,"r":[{"a":{"m":5,"n":73},"e":73,"i":{"s":124},"u":5,"ü":{"c":73}},1],"s":{"a":[{"n":12},1],"k":{"a":1},"t":1},"t":[{"h":1,"s":35,"u":1},12],"u":{"l":104,"m":104},"w":{"e":{"s":19}},"y":2},189],"e":[{"a":{"d":6,"r":1,"s":6},"b":{"a":78,"e":{"n":{"s":191}},"l":6,"r":[{"e":23},78],"s":22},"c":[{"h":{"a":48,"i":6,"t":{"e":375}}},77],"d":{"r":6},"e":{"r":[{"e":{"t":12}},6]},"f":{"a":3,"f":93,"o":12},"g":{"a":{"b":21,"s":13},"ä":6,"l":6,"r":12,"s":10},"h":[{"e":{".":84},"r":{"e":37},"s":84,"t":84},78],"i":{"b":{"l":{"e":12}},"d":73,"e":{"r":{"e":4}},"f":{"a":{"n":12},"e":{"i":12,"r":{"g":29}},"s":25},"g":[{"l":4},93],"h":[{"a":{"u":12}},78],"l":37,"m":{"p":25},"n":{".":88,"d":[{"u":10},73],"e":[{"r":{"b":26}},89],"f":6,"i":6,"k":77,"s":{"a":106},"t":77,"u":73},"s":[{"c":{"h":{"a":53,"e":{"i":52},"o":26}},"e":{"r":{"n":26}},"f":71,"s":{"e":{"r":58}},"t":[{"r":12},89]},6],"ß":{"e":{"r":12}},"t":[{"a":2,"o":12,"r":{"i":35},"s":[{"t":19},266]},73]},"k":{"o":78,"t":{"r":77},"z":77},"l":{"a":88,"e":[{"i":1,"k":77,"m":{"e":84},"n":1,"r":[{"s":19},105],"s":1},6],"f":{".":77,"e":93},"i":73},"m":{".":73,"a":{"l":1,"u":6},"e":{"i":21,"s":78,"t":78},"o":[{"r":6},100],"p":77,"s":4,"u":[{"n":5},6]},"n":{".":89,"a":[{"b":4,"d":110,"n":14,"t":177},13],"ä":6,"d":{"e":{"t":84},"p":71,"u":{"n":84}},"e":{"d":21,"r":{"g":84},"u":{"r":5,"v":84}},"g":{"a":{"g":12}},"k":{"a":{"u":12},"l":{"o":27,"u":12}},"n":{"i":71},"s":{"e":{"i":{"n":26},"m":225},"k":{"a":4},"z":4},"t":{"g":77,"k":93,"l":{"a":84},"n":77,"r":{"o":250},"w":[{"ä":10,"e":{"t":194}},106],"z":77},"z":{"y":77}},"o":{"f":2,"s":32},"p":[{"f":78,"i":248,"o":{"c":84},"r":78},77],"r":{".":73,"a":[{"g":6,"p":23,"s":36,"u":6},104],"ä":21,"e":{"b":125,"c":162,"i":{"g":82,"m":39,"s":14},"l":6,"n":{"g":5},"r":{"g":5,"s":5},"t":126},"f":{"a":{"s":106},"o":93,"r":73,"ü":73},"g":[{"a":73,"e":{"f":89,"h":78,"n":{".":221},"r":89,"s":89,"w":147},"i":77,"l":73,"r":73},71],"h":{"e":{"b":225},"o":{"l":84}},"i":{"n":{"s":19}},"k":[{"a":73,"e":77,"l":[{"ä":84,"e":89},71],"o":73,"r":4},22],"l":[{"e":{"b":{"e":376},"i":147}},4],"m":{"ä":77},"n":{"a":{"l":12,"r":12},"e":[{"i":12},147]},"ö":93,"r":{"a":88,"i":{"c":12}},"s":{".":89,"a":71,"t":[{"o":12},22]},"t":[{"r":{"ä":12}},22],"u":{"p":6},"w":{"a":89,"e":{"r":12},"o":108},"z":[{"ä":2,"e":{"u":82},"o":2},93]},"s":{".":89,"a":{"m":2},"e":[{"i":48,"l":93},2],"h":16,"i":48,"k":[{"i":12},3],"o":1,"p":{"o":6},"t":[{"a":0,"e":[{"r":{"i":29}},377],"o":0,"r":0},33],"u":78,"w":84,"y":77},"t":{"a":{"b":6,"p":80,"t":80},"h":[{"a":1,"i":77},72],"i":2,"s":{"c":{"h":{"e":312}}},"t":{"o":{"p":12},"r":48,"s":105}},"u":[{"e":84,"f":143,"l":93,"n":{"t":1},"r":{"o":77},"t":78},6],"v":{"o":{"l":72}},"x":[{"d":78,"i":{"k":78,"s":6}},77]},75],"é":75,"f":[{"a":{"h":82,"t":5},"e":{"c":104,"e":13,"i":{"n":{"h":1},"s":73},"n":6,"r":{"e":{"i":89,"l":12},"l":0}},"i":82,"l":{"ä":124,"e":{"d":1},"ö":5,"u":124},"r":{"a":{"m":1},"e":{"s":1},"u":5,"ü":5},"s":{"p":{"e":6},"t":{"i":6},"u":6},"u":{"n":22,"r":48}},93],"g":[{"a":{"s":82,"t":4},"e":{"n":{"a":22,"e":105},"r":{"ä":{"u":247}},"t":{"i":73}},"i":79,"l":{"ö":6},"o":82,"p":5,"r":{"a":82,"e":1,"o":82},"u":{"n":{"g":19}}},93],"h":[{"e":84,"i":{".":78},"u":84},161],"i":[{"a":[{"b":2,"d":6,"m":{".":5},"n":{"g":22},"s":{"t":6}},0],"b":[{"i":48},378],"c":[{"h":{"t":{"a":10,"o":10}},"k":[{"a":6},84],"l":6},0],"d":{"a":3,"o":71,"y":73},"e":{".":78,"b":{"e":{"s":191},"r":2},"f":{"a":0,"e":{"r":78},"k":0,"l":1},"n":{"a":294,"e":1,"s":25,"t":25},"r":{"e":{"i":12},"s":{"p":10}},"s":{"c":11}},"g":[{"a":{"s":25},"e":{"r":{"s":14}},"l":5,"n":12},78],"k":{"e":{"r":1},"o":[{"p":19},2],"s":{"p":2},"t":{"e":{"r":12},"i":2,"o":294},"u":2},"l":[{"a":2},1],"m":{"a":[{"s":19,"t":159},365],"m":77,"o":78,"p":77},"n":{"a":[{"r":1},2],"d":{"i":77,"u":93},"e":{"f":6,"h":6,"p":6,"s":6},"f":93,"h":93,"i":{"e":7,"t":13},"j":93,"k":{"a":{"n":12,"r":12},"s":22},"o":{"l":6},"s":{"a":73,"e":{"l":84},"p":77,"t":77,"u":77,"z":77},"t":93,"u":3,"v":93,"z":77},"o":[{"m":5,"s":{"t":3}},6],"p":{"f":78,"t":78},"s":{".":78,"a":3,"c":{"h":{"m":1,"u":5}},"h":[{"i":1},2],"k":78,"l":93,"o":152,"p":6,"s":10,"t":78},"t":{"a":[{"l":72},12],"ä":3,"e":[{"r":78},167],"r":14,"s":[{"e":4,"z":4},100],"u":[{"n":24,"r":5},1],"z":{"e":{"r":10}}},"u":78,"v":{"e":[{"a":6,"s":6},2],"i":{"e":25},"r":1},"x":{"i":77},"z":{"ä":14,"e":{"i":17}}},75],"j":76,"k":[{"a":{"l":{"e":82,"p":0},"n":79,"p":82,"r":{".":82}},"e":{"r":{"d":0,"e":37}},"l":[{"a":{"d":1,"s":124},"i":{"c":1},"u":124},6],"m":{"e":{"n":6}},"n":{"e":[{"r":7},5]},"o":{"f":[{"e":0},2],"r":{"b":163}},"r":{"o":{"c":1}},"s":[{"ä":{"n":1},"i":1,"p":{"e":5},"t":4},21],"t":2,"ü":6},93],"l":[{"a":{"b":{"k":73,"t":73,"u":82},"g":{"e":82,"l":4},"m":[{"a":2,"e":82,"i":6},104],"n":{"b":6,"e":{"r":12},"i":89,"s":{".":82},"w":{"a":5},"z":0},"p":{"p":{"l":128}},"r":{"m":0},"t":{"m":89,"t":1},"u":{"f":{"g":1},"s":0}},"ä":{"m":0,"r":73},"b":12,"c":{"h":10},"d":16,"e":{"b":{"e":{"n":{"e":7}}},"c":[{"h":0},82],"e":{"r":4},"f":104,"i":{"c":0,"m":0,"s":[{"e":89},6]},"l":{"a":2},"m":[{"i":104},2],"n":{".":82,"a":12,"d":{"r":25,"u":{"n":379}},"t":{"f":89,"s":89}},"p":82,"r":{".":82,"a":2,"e":[{"i":{"g":336}},6],"f":{"o":10},"g":{"e":{"b":33,"n":{"e":290}},"o":89},"h":{"o":1},"m":{"i":128},"n":{"t":128},"t":{"r":1}},"s":6,"t":{"h":12},"x":{"e":0}},"g":12,"i":{"g":{"a":{"n":12}},"m":{"b":73},"n":{"d":104,"f":89,"s":0}},"k":16,"l":3,"m":47,"n":3,"o":{"b":[{"e":73},0],"f":113,"l":1,"p":{"e":73,"f":0},"r":[{"b":164,"g":22,"i":289},0],"u":104,"w":82,"x":0},"s":{"ä":{"u":6},"e":{"s":21},"k":{"a":1},"p":{"r":6}},"t":[{"e":2,"i":[{"m":22},2],"r":123,"s":22},1],"u":{"r":0,"s":{"t":380}},"y":82,"z":3},189],"m":[{"a":{"b":167,"d":104,"g":{"e":32},"k":{"a":0},"m":113,"n":{"a":82},"p":{"f":0},"r":{"t":0},"t":{"t":1}},"ä":{"s":{"t":0}},"b":{"u":22},"c":0,"d":2,"e":{"d":{"i":{"t":16}},"f":104,"n":{"t":73},"p":113,"r":[{"f":104,"l":104,"z":104},22],"s":{"s":{"a":89}}},"i":{"d":113,"n":{"d":0,"s":0}},"o":{"f":73,"r":{"c":0}},"p":[{"f":10},3],"s":{"k":3,"t":[{"e":1},2],"z":3},"t":16,"u":{"m":73,"n":{"t":89}}},93],"n":[{"a":{"b":6,"r":[{"e":1},2]},"d":2,"e":[{"s":{"s":22}},79],"i":{"n":104},"u":{"s":22},"ü":71,"y":71},77],"o":[{"a":{"k":5},"b":{".":78,"a":73,"b":78,"e":{"s":22},"j":77,"l":72,"r":[{"i":12},73]},"c":{"h":{"e":{"l":5}}},"f":{"e":[{"n":6},71]},"g":{"h":5,"l":6,"o":{"r":6},"r":{"e":6}},"h":{"a":1,"e":2,"r":189},"i":{"r":12},"k":[{"k":106,"r":23,"s":194},78],"l":{"e":89,"y":161},"m":{"ä":25,"i":{"n":6}},"n":{"e":{"r":6},"i":{"n":5},"o":21},"o":6,"p":{"f":77,"p":{"a":11},"t":77},"r":{"a":{"m":4,"n":2},"ä":5,"b":194,"c":93,"d":93,"e":{"n":3},"g":381,"i":{"d":{"i":10}},"t":154},"s":{".":73,"a":5,"e":78,"k":{"e":5},"p":{"e":6,"r":6},"t":[{"e":5,"r":126},4]},"ß":84,"t":{"a":6,"h":{"a":1},"i":{"o":10}},"v":[{"e":6},93],"x":77},75],"ö":[{"b":23,"c":{"k":77},"d":77,"f":[{"e":76},6],"h":{"r":93},"k":77,"l":259,"p":77,"s":{"c":78,"u":78},"ß":84,"z":84},75],"p":[{"a":{"r":[{"k":163},6]},"ä":{"r":114},"f":6,"h":[{"ä":82,"i":{"r":73},"o":0,"r":82},12],"t":12,"u":82},93],"q":93,"r":[{"a":{"u":{"s":22}},"e":{"b":{"s":105}},"o":{"h":2},"ö":2},161],"s":[{"a":{"b":3,"d":113,"l":6,"m":{"b":114,"p":89,"t":6},"n":[{"e":1},73],"r":{"e":82,"i":3,"k":82},"u":[{"m":10,"r":10},22]},"ä":{"m":79,"u":{"g":6,"s":0}},"c":[{"h":{"i":{"n":89},"m":{"ü":89},"s":105}},6],"e":{"b":113,"l":{"e":6,"i":0},"n":{"t":73},"r":[{"f":73,"g":73,"h":73,"k":73,"l":73,"s":73,"w":73},0],"t":[{"a":0},2],"x":{"t":6}},"h":{"a":1},"i":{"d":104,"m":{"p":73}},"k":{"a":{"l":6},"e":{"l":{"e":124}},"y":6},"o":{"b":12,"p":73,"r":{"t":{".":128}}},"ö":{"l":79},"p":{"a":{"c":73},"e":6,"h":86,"i":{"r":104,"t":79},"o":6,"r":{"i":82},"u":[{"l":82},6]},"s":16,"t":{"a":[{"b":[{"l":1},15],"f":5,"h":{"l":247},"s":73,"t":{".":89,"e":89}},2],"ä":{"t":{"i":128}},"e":[{"a":82,"c":82,"h":82,"i":[{"l":89},82],"l":82,"m":{"p":82},"n":89,"r":{"k":14,"n":{"e":324,"s":324}}},73],"i":{"e":6,"t":73},"o":{"c":{"h":89},"i":5,"l":5},"r":{"u":5,"ü":86},"u":6,"ü":{"m":5}},"u":{"f":82,"m":0,"n":[{"d":6,"k":1},104]}},189],"t":[{"a":{"b":[{"s":0},73],"g":10,"m":[{"e":89,"p":{"e":102}},0],"n":{".":82,"d":25},"p":104,"r":{"a":0,"b":{"e":{"i":{"t":{"n":30}}}},"k":82,"t":[{"i":{"k":33},"u":82},0]},"u":[{"f":89,"t":1},0]},"ä":{"h":0},"b":{"a":{"u":132}},"e":{"c":2,"h":[{"u":82},0],"i":{"g":0,"n":0},"m":{"i":4},"n":[{"g":{"e":{"l":33}},"s":{"p":10},"t":{"s":1}},6],"r":{"a":{"l":12},"f":{"a":10},"g":79,"h":{"e":89},"k":{"e":{"n":33},"u":10},"n":{"ä":10},"o":2,"ö":6,"s":{"e":10}},"s":{"k":382,"t":[{"r":4},6]},"t":6},"h":[{"a":{"g":1,"s":82},"e":{"i":128},"o":{"l":105},"u":79},104],"i":{"d":{"e":0},"m":{"o":19},"n":{"e":82},"s":{"o":73},"t":383},"o":{"b":104,"f":113,"r":{"d":89,"g":89,"i":296},"w":2},"ö":{"l":0,"s":0,"t":114},"r":{"a":{"l":25},"ä":{"u":1},"e":{"c":1,"i":1},"i":{"s":1},"o":{"l":1},"ö":86,"u":{"s":86}},"s":[{"e":{"l":36},"o":{"r":{"t":14}},"p":{"e":21,"h":3},"t":{"i":6}},89],"t":1,"u":{"b":82,"h":0,"m":104,"r":{"a":{"n":102},"e":{"n":102},"i":2}},"ü":82},189],"u":{"a":{"n":0},"b":[{"a":22,"s":22},384],"d":{"r":6},"e":{"c":6,"s":6,"t":6},"f":[{"e":93,"f":77,"o":1,"t":{"a":48,"e":[{"i":12},25],"r":25}},385],"g":{"a":21,"e":{"b":125,"i":6,"n":132},"i":6,"l":4,"o":6,"r":23,"s":{"p":4},"u":6},"h":93,"i":{"d":{".":0},"g":5,"s":{".":0}},"l":{"ö":2},"m":{"d":77,"e":10,"f":77,"g":77,"h":93,"k":77,"l":77,"p":[{"e":75,"h":2},73],"r":77,"s":93,"u":1,"w":93,"z":77},"n":[{"a":93,"d":10,"f":93,"g":{"s":{"c":10}},"i":93,"r":77,"s":93,"t":77,"w":77},227],"o":84,"r":{"a":[{"n":21,"t":6},73],"e":{"i":6},"g":77,"i":[{"s":6},73],"n":71,"o":6,"s":77,"t":71,"u":5},"s":{"a":{"k":1},"e":77,"i":1,"p":6,"s":{"a":27,"c":11,"e":{"l":12,"r":386},"o":11,"p":99,"t":[{"ä":12,"r":55},162]},"t":[{"e":{"r":{"l":26}},"o":294,"r":{"e":25}},227],"u":21},"t":{"a":[{"s":5,"u":14},150],"ä":6,"e":{"g":150,"l":6,"r":[{"g":14,"s":[{"a":20},19]},105]},"h":{"y":6},"o":[{"b":6,"f":125,"p":6,"r":41},77],"r":14,"s":{"c":{"h":{"l":35}}}}},"ü":{"b":[{"d":78},77],"c":{"k":{"e":[{"r":247},387]}},"d":194,"f":{"t":{"e":4}},"h":{"e":{"l":6},"l":13}},"v":[{"a":4,"l":82,"r":1},152],"w":309,"x":77,"y":[{"a":32,"c":1,"e":{"s":1},"l":0,"m":{"p":77},"n":[{"o":1},78],"o":0,"t":1,"u":0},75],"z":[{"a":{"c":104,"g":104,"n":73,"p":104,"t":73,"u":{"s":0}},"ä":{"p":73,"r":73},"e":{"l":[{"e":73},2],"n":{"t":{"h":128}},"p":104,"r":{"h":117,"z":73}},"i":{"d":104,"m":[{"i":0},12]},"l":1,"o":{"f":2},"ö":73,"t":3,"u":{"f":{"e":131}},"v":{"o":{"l":105}},"w":[{"e":{"c":6},"u":73},0]},93]},"m":{"a":[{".":78,"a":2,"b":[{"a":{"r":79},"ä":73,"b":76,"e":73,"f":76,"g":77,"h":77,"k":77,"l":{"i":73},"m":77,"r":[{"a":183},6],"s":77,"t":77,"z":77},71],"c":{"h":{"a":{"n":1},"e":22,"t":{"e":{"r":{"h":30,"s":70}},"r":10}},"i":6,"k":{"s":22},"t":93},"d":{"a":{"m":22},"ä":73,"e":{"l":6},"j":1,"m":93,"r":388,"s":389},"e":12,"f":120,"g":{"a":2,"e":{".":6,"b":6,"f":6,"g":6,"k":6,"p":6,"s":{".":5},"t":6,"v":6,"w":6},"g":93,"i":{"e":{"r":{".":55,"s":55}}},"l":1,"n":16,"o":93},"h":{"a":1,"l":{"s":{"t":10}},"o":0},"i":{"s":{"e":27}},"k":{"e":{".":6},"t":93},"l":{"a":{"g":2,"k":[{"t":5},13],"n":6,"u":6},"ä":{"r":6},"d":{"e":108,"i":73},"e":[{"b":5,"r":2,"x":5},1],"i":{"e":48},"l":{"o":4,"t":77},"o":{"n":6,"p":6},"p":73,"t":4,"u":[{"t":23},10],"v":78},"m":{"i":{"d":6},"m":4},"n":{"a":{"l":152,"r":6,"t":390,"u":6},"ä":93,"b":77,"c":{"e":2},"d":391,"e":{"t":6},"f":73,"g":[{"a":96,"e":{"l":89},"r":93},22],"h":73,"i":{"p":78},"l":[{"e":73},77],"n":88,"o":{"d":77},"s":{"a":93,"ä":77},"t":{"h":11,"r":77},"u":[{"t":41},25],"w":77,"z":[{"a":71},77]},"o":{"r":6},"p":{"h":{"r":6},"o":6},"q":0,"r":{"a":[{"g":84,"n":2},73],"b":77,"g":37,"h":304,"i":3,"k":[{"r":2},73],"o":[{"d":25},269],"r":84,"s":{"c":{"h":{"l":26,"m":26,"r":26}},"p":2,"u":2},"t":{"i":93},"u":3,"z":71},"s":[{"a":16,"e":2,"p":3,"s":{"e":{"n":191}},"t":{"a":12,"e":{"l":12},"i":2,"o":12,"r":12},"z":14},78],"ß":78,"t":{"a":{"b":36,"n":6},"ä":6,"e":{"l":79,"r":{"d":14,"z":14}},"m":{"e":89,"o":77},"o":[{"r":{"t":5}},6],"s":{"e":4,"p":4},"t":{"r":10},"u":{"r":{"l":4}}},"u":{"f":321,"l":78,"n":1,"r":4,"s":77,"t":{"a":2}},"y":[{"o":0},89]},75],"ä":[{"h":{"n":93,"r":13},"n":{"d":189},"o":77,"p":93,"q":77,"r":[{"k":{"l":2},"z":11},13],"t":{"r":16},"u":{"s":{"c":11}}},75],"b":[{"e":{"e":2,"r":{"e":22,"i":4,"t":19}},"i":{"e":{"r":{".":4}}},"l":[{"e":{"i":48}},5],"r":5,"u":{"s":{"c":4}},"y":{"t":12}},152],"c":[{"h":82},77],"d":[{"a":{"n":73,"s":113},"ä":{"r":0},"e":{"a":2,"i":73,"m":[{"i":104},2],"n":{"t":104},"r":[{"l":104},22]},"ö":6,"r":{"a":{"s":1}},"s":{"e":3},"t":12,"u":{"m":104}},189],"e":[{"a":{"n":1,"t":1},"b":[{"e":{"n":6},"r":78},12],"c":0,"d":{"i":{"e":159}},"e":{"m":32,"n":2,"r":{"e":{"i":27}}},"f":{"f":93},"g":{"a":25,"e":{"l":5}},"h":[{"l":{"e":{"r":364}},"r":{"e":{"r":102}}},78],"i":{"f":93,"g":93,"l":196,"n":{"d":{"a":10,"e":247},"e":{"r":{"k":29,"l":26}},"u":88},"s":{"t":88}},"l":{"a":{"m":1,"n":{"t":16},"u":21},"b":22,"d":[{"e":{"i":17}},37],"e":{"k":6,"m":77,"r":6,"t":19},"f":{".":77},"k":[{"e":{"i":27}},78],"l":22,"o":[{"b":6},78],"s":{"e":2},"t":[{"e":{"r":{"n":305}}},195]},"m":{"i":{"s":152},"p":93,"u":152},"n":{".":73,"a":{"b":4,"g":{"e":1},"n":14,"r":4,"s":5,"u":4},"d":{"l":93},"e":{"n":132},"g":{"a":{"g":225},"e":4},"i":{"m":6},"k":9,"o":{"n":2},"s":{"e":{".":12,"m":[{"b":221},12],"n":12,"r":12,"s":12},"i":{"d":19},"o":2,"t":19},"t":{"a":[{"k":27},89],"e":{"i":[{"g":55},89],"r":{"s":46}},"n":77,"s":{"p":10}}},"o":[{"u":77},0],"ö":77,"p":{"a":77,"i":152},"r":{".":147,"a":[{"l":25,"s":392},0],"e":{"b":125,"n":{"s":5},"r":{"r":12,"w":12}},"g":{"ä":{"n":250}},"i":{"n":{"d":19,"t":19}},"k":{"l":{"ä":225}},"n":{"s":266},"s":{"h":89,"m":35,"t":{"e":{"l":26},"o":12}},"t":{"r":10},"z":{"e":{"n":{"g":33}}}},"s":[{"a":{"l":6},"ä":5,"e":{"r":84},"p":{"o":2,"r":13},"s":{"a":[{"n":25},158],"e":{"r":{"g":351}},"o":99,"p":2,"t":2},"t":{"a":4,"o":0},"u":1,"z":{"e":1}},78],"t":{"a":[{"s":48},1],"h":1,"o":48,"ö":6,"r":{"i":{"g":5}},"t":{"e":{"n":{"d":325}}},"u":1},"u":13,"x":[{"e":6},93]},75],"é":75,"f":[{"i":{"l":{"e":2}}},205],"g":[{"a":{"n":{"g":19}},"l":{"i":{"m":105}}},248],"h":248,"i":[{"a":[{"b":2,"m":6,"t":93},0],"ä":0,"b":{"i":48},"c":{"e":13,"h":0,"i":6},"d":{"a":1,"i":{".":6},"r":1,"y":77},"e":{"d":{"r":4},"l":{"e":1},"n":{"o":14,"s":25},"r":{"e":{"r":102}},"s":13,"t":{"i":2,"o":12,"r":2}},"f":120,"g":{"e":78},"h":1,"k":{"a":{"n":13},"e":[{"l":5,"n":{"s":5}},1],"l":16,"u":6},"l":[{"a":3,"c":{"h":[{"e":12},132]},"d":{"s":10},"i":3,"u":3,"z":84},78],"m":{"a":289,"m":93,"p":77},"n":{"a":{"c":2,"k":1,"n":{"z":{"e":35}}},"d":{"e":[{"s":19},73],"u":93},"e":{"f":6,"r":[{"i":177},132],"u":2},"f":{"o":77},"g":{"a":2,"s":25},"h":77,"i":[{"k":159},1],"o":{"d":1,"f":6},"s":{"e":93,"t":71},"u":1},"o":{"n":{"i":132}},"p":0,"r":{".":78,"i":78,"s":78,"w":78,"z":78},"s":{".":78,"a":6,"c":{"h":{"a":5,"w":17}},"e":393,"o":152,"p":{"a":2,"e":6},"s":{"a":{"r":35},"e":{"r":12},"t":12},"t":{"e":4,"o":0,"r":120},"u":78},"t":[{"a":6,"h":21,"o":6,"r":6,"s":[{"a":35},37],"t":{"a":4,"e":[{"s":17},37]},"u":21,"z":84},78],"v":3},75],"j":93,"k":[{"n":82},246],"l":[{"c":1,"e":82,"f":1,"k":1,"o":82,"p":1,"s":1},248],"m":[{"a":{"a":4,"k":104,"l":104,"n":{"s":104,"z":0},"p":104,"r":{"t":0},"s":{"t":13},"u":{"s":0}},"ä":{"u":0},"d":2,"e":{"b":113,"f":104,"i":{"n":0},"l":{"a":138,"i":{"n":12}},"n":{"e":6,"t":{"e":{".":33,"n":33},"l":89,"s":89,"w":89}},"r":{"a":162,"e":{"c":12},"g":{"e":{"b":33}}},"s":[{"c":4,"z":12},2],"u":104},"i":{"e":{"l":4},"n":{"b":0,"h":0,"s":104,"t":0},"s":[{"c":[{"h":102},4],"t":184},6],"t":{"w":35}},"m":3,"p":[{"f":10},3],"s":[{"a":1,"i":3,"o":1,"p":3,"t":{"a":1,"i":1}},6],"t":{"e":1},"u":{"m":73,"n":6,"r":4},"ü":{"l":[{"l":132},22]}},189],"n":[{"e":{"s":{"i":89}}},161],"o":[{"b":{"e":152,"i":78,"j":77},"d":[{"e":[{"s":48},1],"r":6},88],"f":[{"e":6},71],"g":[{".":77,"a":{"l":21}},78],"h":[{"a":2},88],"i":{"r":4},"k":{"l":21},"l":{"d":4},"m":[{"e":2},78],"n":[{"a":{"n":6},"ä":6,"d":{"a":{"c":12},"e":{"l":12},"o":2,"r":25},"e":{"r":6},"s":[{"a":4,"e":10,"u":9},162],"t":{"a":22,"h":4},"y":0},88],"o":394,"p":{"e":[{"r":6},127],"f":93,"t":77},"r":{"a":[{"n":2},0],"d":{"a":162,"r":2},"e":{"i":6},"g":[{"e":{"n":{"s":395}}},4],"t":37},"s":[{"k":{"a":5},"s":4,"t":{"e":{"r":102},"i":2}},78],"t":{"h":3,"o":7,"r":12},"u":{"s":10},"x":93,"y":0},75],"ö":[{"b":{"e":22},"c":6,"f":80,"k":84,"l":93},75],"p":[{"a":{"n":{"e":4}},"e":{"l":{"a":2,"i":{"n":12}},"n":[{"e":104},2]},"f":[{"e":{"f":13,"r":{"f":14,"g":[{"e":273},4],"p":[{"r":24},4],"r":14,"z":39}},"l":23,"o":{"r":13},"r":6},73],"h":{"a":{"f":0},"o":{"s":0}},"i":{"n":22},"l":{"ä":82,"e":{"i":1,"m":{".":128},"n":86,"s":86},"i":{"s":5}},"o":{"n":82,"r":{"t":{"a":{"g":33},"e":{"r":322}}}},"s":{"h":1,"t":{"r":1}},"u":82},189],"q":93,"r":134,"s":[{"a":{"m":73,"n":73,"p":89,"s":0,"t":82,"u":[{"e":25},73]},"ä":[{"n":114},82],"c":[{"h":22,"o":89},82],"e":[{"d":296,"f":114,"i":{"g":89,"n":89},"l":{"e":234},"n":[{"e":114,"t":89},2],"r":{"f":0,"h":6},"t":2,"u":114,"x":89},82],"o":{"d":113,"r":[{"i":0},2]},"p":{"ä":73,"e":{"d":73},"l":89,"o":[{"t":73},6],"r":{"o":73},"u":6},"s":16,"t":[{"a":{"g":164},"ä":82,"e":{"h":82,"i":82,"l":82},"i":[{"t":73},6],"o":124,"r":[{"ä":7},124],"u":79,"ü":5},2],"ü":73,"w":89,"y":82,"z":{"i":89}},189],"t":[{"a":{"b":0,"k":0,"m":2,"r":0,"u":{"g":1}},"e":{"d":113,"i":{"n":0,"s":0},"l":{"t":0},"m":{"i":0},"n":{"g":{"a":89,"l":128},"t":{"f":89,"g":89,"r":344,"s":89}},"r":[{"b":104,"e":{"i":128},"f":104,"g":104,"h":0,"i":396,"k":104,"l":104,"n":10,"s":104,"t":104},22],"t":{"a":73},"u":104,"v":104},"h":[{"o":1},104],"i":{"d":113,"m":73,"n":104,"r":113,"s":2},"m":{"e":{"n":105}},"o":{"b":0,"p":0},"ö":{"l":104,"s":0},"r":{"o":86,"ö":73},"s":[{"a":6,"c":{"o":1},"e":[{"n":{"d":1}},21],"k":{"a":3,"e":{"l":16}},"t":{"ä":{"t":4},"u":1}},89],"t":12,"u":{"m":0,"r":{"e":4}},"ü":82,"z":1},189],"u":[{"a":0,"c":{"k":{"e":[{"l":5},1]}},"h":93,"l":{"a":1,"d":78,"l":{"a":{"u":12}},"t":78},"m":{"i":78,"s":[{"p":11},71]},"n":[{"d":{"a":{"n":102},"e":{"r":{"f":26}}},"e":{"r":397},"f":189,"g":{"e":{"b":106}},"i":[{"n":5,"v":398},1],"w":84,"z":84},78],"r":{"u":{"f":176}},"s":[{"a":41,"o":21,"p":6,"t":[{".":84,"e":10},118],"u":6},147],"t":{"a":{"u":13},"s":{"t":2}}},75],"ü":[{"b":77,"h":[{"e":{"r":6},"l":{"a":48}},78],"l":{"l":{"e":{"n":12}}},"n":78,"t":[{"t":{"e":{"r":247}}},78]},75],"v":[{"o":{"l":{"l":132}}},93],"w":[{"a":[{"r":12},2],"e":{"g":{"s":10},"l":[{"t":17},10]},"u":13},152],"y":[{"a":{"l":0},"s":23},78],"z":[{"u":{"g":10}},152]},"n":{"a":[{".":78,"b":[{"a":78,"ä":6,"e":{"n":{"s":149}},"h":82,"i":78,"k":82,"l":23,"o":{"r":6},"r":[{"ü":12},6],"s":399,"u":{"s":6}},93],"c":[{".":89,"h":[{"e":{"n":[{".":7},29]},"s":{"e":82,"p":25},"t":{"e":{"r":{"s":{"c":70}}},"r":{"a":{"u":{"m":175}}}}},302]},78],"d":{"a":[{"b":1},71],"e":[{".":1,"l":132,"r":6},78],"l":189,"m":106,"r":72},"e":[{"l":1},78],"f":[{"r":{"a":0}},93],"g":{"a":2,"e":{".":1,"m":6},"g":189,"i":[{"n":1},72],"r":16},"h":[{"a":21,"m":89,"n":106,"o":106},88],"i":[{"e":2,"g":71,"r":[{"e":12},106],"s":73},78],"k":[{"ä":78,"o":78,"r":{"o":6},"t":84},93],"l":{".":73,"a":[{"m":4,"r":5},125],"ä":6,"b":{"k":93},"d":[{"a":4},73],"e":{"i":4,"n":{"t":14},"r":{"e":{"i":24},"g":42,"m":5,"w":14},"s":105,"t":13,"x":13},"g":22,"i":{"d":6},"o":{"p":6},"p":{"h":2},"s":{".":73},"t":[{"a":22,"r":35,"y":73},4],"u":6,"y":77},"m":{"a":{"t":6},"e":[{".":1,"i":139,"n":[{"s":247},128],"r":248},78],"i":{"d":6,"n":6},"n":16,"o":88,"p":71,"s":{"p":12},"t":[{"s":10},93],"y":5},"n":[{"a":[{"t":5},224],"ä":79,"b":106,"d":256,"e":{"u":13},"f":106,"g":106,"h":84,"i":77,"k":106,"l":106,"n":[{"a":106},88],"o":[{"b":162},84],"p":106,"r":77,"s":106,"t":{"r":77},"w":77,"z":{".":73,"e":{"n":[{"e":26,"g":26},102],"r":102}}},71],"o":{"t":1},"p":{"e":{"r":6},"f":{"e":[{"l":84},71]},"r":79},"q":71,"r":[{".":194,"a":21,"c":77,"d":73,"e":[{".":89},73],"i":78,"k":73,"l":{"e":73},"m":77,"o":[{"m":6},73],"r":73,"s":73,"t":[{"a":73,"h":73},77],"u":3},71],"s":[{".":89,"ä":1,"c":{"h":{"w":5}},"p":246,"s":{"c":11,"i":189},"t":{"a":12,"r":6},"y":[{"l":105},139]},78],"t":[{".":89,"a":{"u":14},"e":{"i":13,"m":6},"h":232,"m":84,"o":[{"m":84,"r":194},2],"r":13,"s":{"a":12,"e":48},"u":1},78],"u":[{"f":{"f":{"r":10},"r":2},"i":194,"l":88,"s":{"b":84,"d":84,"f":84,"g":84,"l":84,"o":73,"r":84,"s":106,"w":84,"z":84}},71],"v":[{"e":10,"i":{"e":{"r":{".":55,"s":55}}}},78]},75],"ä":[{"b":77,"c":147,"e":78,"f":93,"g":78,"h":{"i":6,"m":78,"n":93,"u":6},"m":152,"n":93,"p":{"f":{"e":{"l":84}}},"q":77,"r":{"s":{"t":59}},"s":{"c":6,"s":73},"u":[{"m":304},77]},75],"b":[{"a":{"i":{"s":19}},"e":{"i":{"n":2},"r":{"e":22},"s":10},"y":12},134],"c":[{"a":{"b":86,"n":82},"e":{"n":275,"s":{".":82}},"h":{"l":82,"m":4},"k":73,"o":{"r":22},"r":82,"u":82},93],"d":[{"a":{"f":13,"g":6,"i":82,"k":104,"n":{"a":73,"i":73,"z":73},"r":{"r":0},"t":[{"t":1},82],"u":[{"t":73},0],"x":73},"ä":{"n":{"g":0}},"c":0,"e":{"a":{"l":{".":12}},"d":{"e":104},"e":82,"i":73,"l":{"f":{"e":1},"l":25,"s":{"a":277,"e":{"n":58},"t":{"e":{"r":45}}}},"m":{"o":{"t":12}},"n":{"s":{"k":25},"t":{"l":89,"s":89}},"o":37,"r":{".":140,"e":{"n":140},"h":6,"i":140,"l":{"ä":{"s":33}},"o":{"b":12,"s":284},"s":{"a":{"t":336},"t":{"e":55}}},"s":[{"e":2,"s":25},400]},"i":{"a":162,"m":{"m":0}},"o":{"c":13,"f":73,"n":{"a":162},"p":{"t":73},"r":[{"i":289},0],"s":[{"t":13},6],"t":{"t":86}},"ö":[{"s":6},73],"r":{"a":{"m":5,"t":86,"u":1},"e":86,"i":{"f":73},"o":{"c":86,"d":73},"ö":86,"u":{"i":73,"n":86}},"s":{"e":{"n":{"e":5}},"p":{"r":6}},"t":{"h":1,"r":12},"u":{"n":{"s":73}},"w":{"a":{"r":{"e":55}}},"y":4},189],"e":[{".":78,"a":{"p":6,"s":78,"t":1,"u":1},"b":{"e":{"n":{"e":106}},"l":6,"n":93,"r":12},"c":[{"a":78,"e":78,"h":6,"k":[{"a":22},0]},77],"d":{"i":{"t":6}},"e":[{"i":[{"n":1,"s":1},22],"n":22,"r":[{"e":22},13]},77],"f":[{".":73,"a":167,"r":77},71],"g":{"g":93,"l":12,"o":72,"r":12},"h":{"e":[{".":80,"m":77,"n":401,"r":22},71],"m":78,"r":106},"i":[{"a":78,"c":84,"d":{"e":{"i":12},"r":12},"e":{"r":84},"g":{"t":78,"u":78},"l":{"a":12},"n":{"g":84,"h":84,"k":84,"l":84,"z":84},"p":84,"s":{"s":19}},93],"k":{"e":6,"s":93,"t":37,"z":77},"l":{"a":6,"b":4,"e":[{"k":84,"m":84,"n":1,"x":1},72],"i":[{"d":1,"t":6},2],"k":78,"l":[{"a":11,"e":{"i":12,"r":{"f":29}}},73],"o":143,"u":78},"m":{".":88,"b":189,"p":106,"s":93,"u":84},"n":[{".":89,"a":[{"m":12,"n":5},346],"ä":6,"b":73,"c":73,"d":{"a":{"r":12},"b":189,"d":189,"f":189,"g":71,"h":189,"k":189,"l":71,"p":189,"t":189,"w":189},"e":{"b":22,"i":4,"m":10,"n":[{"e":5},132],"r":{"b":4},"u":23},"f":73,"g":{"b":189,"e":{"n":12},"s":189,"t":189,"u":71},"h":73,"i":14,"j":73,"k":97,"m":73,"n":{"a":{"r":12}},"o":126,"s":{"e":9,"k":4,"p":37},"t":{"a":402,"b":189,"d":84,"f":84,"i":403,"l":189,"n":84,"r":194,"s":189,"w":106,"z":84},"u":14,"v":73,"w":73,"z":{"e":{"r":10}}},78],"o":{"b":23,"h":6,"r":6,"s":10},"p":{"e":{"n":6},"f":77,"i":80,"o":[{"s":6},77],"t":10},"r":{".":89,"a":[{"b":6,"c":6,"f":23,"g":6,"l":16,"m":6,"n":6,"p":23,"t":[{"i":{"o":24},"o":1},73],"u":6},0],"b":{"a":97,"e":{".":106,"n":106}},"d":{"b":77,"i":{"g":12}},"e":[{"b":21,"c":6},22],"f":[{"a":{"s":84},"r":78,"ü":77},71],"g":[{"r":78},404],"h":[{"ö":106},71],"i":78,"j":73,"k":[{"a":194,"ö":73},71],"l":{"i":73,"ö":93},"m":{"i":71},"n":{"ä":93,"e":{"u":106},"t":93},"o":{"s":71},"ö":{"f":71,"s":0},"s":{".":73,"a":93,"e":78,"k":12,"t":{"s":106}},"t":[{".":78},10],"u":{"p":6},"v":88,"w":{"a":{"r":84}},"z":93},"s":{".":73,"a":{"l":6,"n":2},"e":[{"i":6,"v":21},89],"h":107,"i":1,"k":{"a":1},"o":{"f":21,"r":21},"p":{"a":21},"s":{"i":[{"g":12},405]},"t":{"a":0,"e":6,"i":4,"r":245},"y":{"n":84}},"ß":78,"t":{"a":{"b":6,"g":372,"k":13,"n":21,"p":80,"t":80},"e":{"l":110},"h":[{"a":4},6],"i":[{"n":5},1],"o":{"b":5},"t":[{"a":4,"e":4,"r":4},73],"u":152,"z":{"e":{"r":12},"i":11}},"u":[{"c":13,"e":{"r":{"e":12,"f":19,"k":19,"r":19,"s":19,"w":19}},"g":9,"p":93,"r":[{"a":2},22],"t":4},6],"v":{"i":88},"w":[{"a":1},73],"x":[{"i":6},93],"y":194,"z":78},75],"é":78,"f":[{"a":{"l":[{"t":19},79],"n":{"g":79},"r":5},"ä":79,"e":{"i":2,"n":79,"r":79,"s":6,"x":89},"f":12,"i":[{"l":{"e":{".":12}}},82],"l":{"e":5},"o":[{"s":13},6],"r":5,"s":3,"t":{"a":{"n":6},"r":23,"s":{"t":[{"r":25},12]},"u":1},"u":104},93],"g":[{"a":{"b":{"e":82,"t":0},"c":113,"d":104,"k":104,"m":{"e":32},"n":{"d":{"a":1},"h":73,"l":89,"s":0,"t":0},"r":{"e":0,"s":79},"v":113},"ä":{"l":104},"d":1,"e":{"i":{"f":104,"n":104},"l":{"b":19,"e":{"i":9},"t":105},"n":[{"e":[{"r":{"w":35}},140],"s":{"a":25}},124],"r":{"a":{"m":12},"g":104,"z":{"ä":10}},"s":[{"a":4},124],"t":35},"g":{"s":4},"h":{"u":1},"i":{"d":104},"l":{"a":{"d":6},"ä":{"s":6},"i":{"c":73},"o":{"k":5,"t":82}},"n":[{"e":1,"i":128,"o":{"m":5},"u":6},73],"o":{"b":6,"p":104,"r":[{"i":2},104]},"ö":73,"r":{"a":{"i":86,"n":5,"t":86},"o":{"c":1,"s":{"t":1}}},"s":{"a":{"u":14},"c":{"r":5},"e":{"h":177,"k":5,"n":{"s":5}},"p":{"a":{"r":5}},"t":{"a":{"n":35},"e":{"u":12}}},"t":[{"s":1},89],"u":{"m":73,"n":{"g":19}},"z":{"e":{"i":{"t":19}}}},189],"h":[{"e":{"r":2}},243],"i":[{"a":[{"l":{"o":1},"r":6},88],"b":{"b":10},"c":[{"e":0},12],"d":[{".":88,"a":1,"e":[{"a":77},6],"r":16,"y":76},71],"e":[{"b":4,"l":[{"a":37},0],"n":[{"e":1,"i":1},27],"r":{"e":{"i":12},"n":{"a":5}},"s":{"a":2},"u":6},73],"f":{"e":{"s":277},"l":0},"g":{"a":[{"b":21,"m":21,"n":21},22],"e":{"l":243,"n":89,"t":77},"l":[{"i":4},5],"n":6,"s":{"p":12}},"h":{"i":25},"k":{"a":{"r":6},"e":[{"l":6,"r":{"h":1}},78],"i":[{"n":{"g":4}},6],"o":{"r":6},"r":23,"t":9},"l":[{"a":3,"i":3},88],"m":{"p":84},"n":[{".":78,"a":[{"c":2,"l":6},88],"b":88,"d":93,"f":77,"g":[{"s":10},88],"h":93,"k":406,"o":[{"r":6},78],"p":88,"s":[{"e":84,"u":84},93],"t":189,"u":1,"v":189,"w":88},13],"o":{"b":6,"k":1,"r":{"a":1}},"p":73,"r":{"o":{"n":5},"r":71},"s":[{"a":{"m":5,"n":6},"ä":6,"c":{"h":{"a":4,"w":5}},"e":21,"o":{"l":106,"m":6,"t":84},"p":[{"i":1},6],"s":9,"t":{"h":{"a":4}},"u":21},88],"t":[{"a":78,"i":[{"a":398},6],"o":2,"r":78,"s":4,"t":{"e":{"r":{"g":351,"k":325}},"r":{"a":12},"s":{"a":10}}},77],"u":78,"v":3,"x":78},75],"j":93,"k":[{"a":{"b":{"r":0},"c":104,"g":{"e":2},"l":[{"g":89},82],"n":{"g":0},"p":{"f":0},"r":{"t":{".":1}},"s":{"c":4},"t":{"m":73,"o":73},"u":{"s":0,"t":73}},"ä":{"h":104,"p":104},"e":{"c":2,"i":[{"l":6},0],"l":{"e":{"i":12,"m":89}},"n":{"a":12,"t":{"e":10}},"r":{"l":{"e":128},"o":{"s":12},"s":{"a":1}},"s":{"c":82},"t":[{"i":0,"u":73},2]},"i":{"d":[{"e":73},32],"n":{"h":0,"s":104}},"l":{"a":{"d":{"e":89},"g":82},"e":{"i":{"s":1},"n":86,"s":1},"i":{"n":82},"o":6},"n":{"e":{"b":5},"i":{"s":73,"t":73},"u":73},"o":{"b":{"e":131},"p":{"t":73},"r":[{"d":105,"i":0,"t":104},2]},"ö":{"l":73},"r":{"a":{"b":5},"ä":{"t":1},"e":{".":89,"l":86,"n":73,"p":1,"z":73},"o":[{"l":73},1]},"s":{"a":{"l":6},"e":[{"n":1},6],"o":6,"t":{"i":2},"z":3},"t":{"a":{"k":6,"n":6,"u":5},"e":{"n":{"t":5},"r":{"g":5,"n":14},"s":{"k":25},"t":2},"i":{"n":6,"t":13},"o":{"p":6},"r":[{"i":{"c":4},"o":6,"u":6},13],"s":{"e":{"n":12}}},"u":{"m":104,"n":2,"r":{"h":0}},"ü":{"b":73}},189],"l":[{"a":{"g":{"e":4}},"e":{"g":{"a":2}}},161],"m":[{"a":82,"ä":82,"e":{"n":{"s":22}},"i":140},152],"n":[{"a":{"d":{"a":73},"g":2,"l":{"g":73,"l":104},"m":4,"n":73,"s":{"t":4},"u":73},"e":{"c":82,"i":{".":6},"l":{"b":82,"e":12},"n":{"a":12,"s":6},"r":{"e":{"i":[{"g":338},10]},"f":{"ü":10},"g":{"e":{"b":33},"r":5},"h":6,"k":6,"l":{"a":10},"o":6,"ö":2,"w":{"a":[{"r":33},1]},"z":22},"s":{"e":99},"u":6,"x":6},"f":1,"g":12,"i":82,"k":2,"o":{"b":[{"l":1,"s":1},23],"f":73,"p":73,"r":[{"i":0},2]},"s":{"a":{"m":5},"e":{"r":1},"p":3,"t":[{"o":{"c":5},"ö":6},10]},"t":{"a":47,"h":6},"u":{"f":104,"n":{"f":104},"r":0},"v":{"o":{"l":{"l":[{"e":54},102]}}}},189],"o":[{".":78,"a":{"t":7},"b":{"a":88,"e":{"l":73},"j":77,"l":{"a":6,"e":73,"o":78,"ö":78},"s":321,"u":[{"t":17},22],"y":78},"c":[{"h":{"e":19,"r":10}},0],"d":[{"e":6},77],"e":{"d":6},"f":[{"e":6,"f":77},71],"h":[{"e":88},93],"k":{"e":{"l":6},"k":76,"r":1},"l":{"e":[{"u":6},82],"i":{"g":5,"v":6},"y":161},"m":{"e":407,"i":1,"p":78},"n":{"e":2,"k":71,"s":10,"t":71,"y":77},"o":6,"p":{"a":88,"ä":78,"e":{"r":6},"i":152,"s":93,"t":{"e":3}},"r":{".":78,"a":[{"d":6,"k":86,"l":1,"r":1},2],"c":77,"d":{"a":12,"b":78,"e":{"s":12},"r":162},"e":3,"g":93,"h":78,"l":88,"m":[{"a":[{"l":4},22]},78],"ö":78,"s":78,"t":93},"s":{".":88,"e":11,"h":1,"k":47,"p":23,"t":{"i":80,"r":48,"v":77},"u":2},"t":{"a":{"n":6,"r":{"t":1}},"ä":6,"e":{"i":176,"n":{"t":{"r":20}},"r":[{"b":247},408],"x":5},"h":[{"o":6},13],"i":{"n":23},"o":{"p":23},"r":23},"v":78,"x":152,"z":78},75],"ö":{"d":77,"f":139,"k":189,"l":189,"r":73,"t":85},"p":[{"a":{"g":{"e":2},"s":2},"f":12,"r":{"o":48},"s":{"y":25}},309],"q":93,"r":[{"a":{"n":22,"u":{"m":{"a":10}}},"ä":{"u":{"s":25}},"e":{"b":{"e":105},"l":{"i":132},"s":{"z":9}},"o":{"h":2},"ö":{"s":2},"ü":{"c":{"k":{"e":{"r":312}}}}},409],"s":[{"a":{"b":{"o":82},"d":113,"g":{"i":113},"k":{"r":2},"l":{"l":73,"p":5,"t":73},"n":{"a":{"t":5},"e":1,"m":73},"r":[{"g":6,"k":82},2],"s":2,"t":{"h":5},"u":{"r":10,"s":22,"t":73},"v":6,"x":6},"ä":{"n":104,"u":{"g":6,"s":104}},"c":{"h":{"e":{".":82,"f":89,"u":{"l":55}},"l":{".":89},"o":22,"t":19,"u":82,"w":{"e":{"r":{"d":45}}}},"r":6},"e":{"b":0,"e":{"i":{"n":12}},"h":[{"a":81,"e":{"r":{"e":55}}},6],"i":{"n":{"f":89}},"l":{"e":[{"m":1},6]},"m":{".":73},"n":{"e":73,"s":{"p":10}},"p":{"o":73},"r":{"f":104,"g":104,"h":73,"k":[{"o":5},104],"l":[{"e":89},0],"n":{"e":128},"ö":73,"s":[{"c":89},0],"t":{"r":1},"w":104,"z":73},"t":{"y":73},"u":104,"x":{"t":6}},"f":{"i":{"l":22}},"i":{"d":{"e":{"n":1}},"m":[{"p":89},82],"n":{"f":6,"i":73,"n":[{"s":247},105]},"s":[{"o":89},82],"t":{"e":12,"r":2}},"k":{"a":{"l":79},"e":{"l":79},"i":{"s":6},"l":{"e":82},"y":79},"m":{"a":{"r":{"a":140}}},"o":{"d":113,"f":[{"f":89},0],"m":5,"n":{"t":128},"p":104,"r":{"t":{".":128}}},"p":{"a":{"c":6,"g":22},"e":{"k":5,"l":6,"n":141,"r":{"i":89}},"h":73,"i":[{"e":5,"r":5},79],"o":73,"r":{"ä":73,"i":{"e":128},"o":73},"u":{"t":73}},"r":{"ü":22},"s":16,"t":{"a":{"b":{"l":1},"d":82,"g":{"e":{"n":{"t":31}}},"k":13,"l":{"e":89},"n":[{"d":82,"e":4},410],"r":124,"s":73,"t":{".":89,"e":{"n":164},"i":5,"s":89}},"ä":{"m":82,"n":124},"e":{"i":{"f":{"e":35},"n":{"h":{"e":263}}},"n":{"t":5},"p":6,"r":{"g":{"e":35},"n":{"e":324,"s":324}},"u":5},"i":[{"c":124,"f":82,"l":{"g":89},"m":82},6],"o":{"b":73,"p":{"f":{"e":35}},"r":5},"r":{"i":{"e":89,"k":89,"p":5},"u":{"n":5}},"u":[{"t":9},6],"ü":{"m":5}},"u":{"f":82,"m":6,"n":[{"g":6,"k":5,"w":6,"z":5},0],"r":{"s":0},"t":104},"y":82,"z":{"e":{"n":{"e":5}}}},189],"t":[{"a":{"c":383,"k":{"t":{"a":10}},"l":{"a":48,"i":{"n":12},"l":114,"o":2,"p":6},"m":171,"n":{"b":79,"e":4,"s":{"p":89},"t":0,"z":{"a":89}},"r":{"b":79,"k":0,"m":79,"t":[{"i":{"k":33},"u":1},0]},"s":{"s":104},"t":{"h":73,"l":82}},"ä":{"m":0,"u":104},"e":{"a":{"u":4},"e":13,"g":119,"h":[{"e":82},0],"i":{"g":73,"n":0,"s":104},"l":{"i":{"n":12}},"m":{"o":104},"n":[{"a":12,"t":{"e":{".":33}}},5],"r":{"a":105,"e":{"i":{"s":46}},"h":5,"k":5,"m":5,"n":[{"e":19},5],"s":5,"t":5},"s":{"a":4,"s":411,"t":[{"r":{"i":164}},2]},"t":{"a":237},"u":[{"e":{"r":{"i":33}}},25],"v":4},"h":{"e":{"l":0},"i":{"e":0},"o":{"t":73},"r":82,"u":[{"m":412},5],"y":5},"i":[{"c":4,"m":{"p":25},"n":{"d":128,"f":128,"h":128,"i":132}},79],"l":{"e":{"m":413}},"m":{"e":{"n":105},"o":10},"n":{"i":[{"s":132},22]},"o":{"r":{"e":4,"g":89,"i":{"e":122}}},"ö":{"l":104},"r":{"a":{"l":5,"u":[{"m":5},0]},"e":{"a":1,"c":1,"e":141,"i":{"f":1},"p":[{"r":5},140]},"i":{"c":{"h":1},"e":{"g":128}},"o":{"h":73,"p":[{"i":89},82]},"ü":86},"s":[{"a":{"h":2},"p":[{"a":{"r":4},"e":7},3],"t":2,"u":{"r":6}},89],"t":2,"u":{"b":82,"r":{"e":{".":12}},"s":13},"ü":82,"z":1},93],"u":[{"a":[{"l":{"e":5},"r":216},304],"b":{"i":48},"c":127,"d":[{"e":22},78],"e":[{"s":6},78],"f":{"e":6},"g":78,"h":[{"i":78},93],"i":78,"k":[{"l":1,"r":79},237],"l":{"l":{"a":48,"e":[{"b":25},105]}},"m":{".":73,"b":76,"e":73,"f":77,"g":84,"l":77,"m":88,"r":84,"s":93,"v":93,"z":76},"n":[{"a":84,"e":93,"g":[{"l":106},414],"i":189,"k":82,"r":77,"s":4,"t":84,"v":84,"z":78},5],"o":78,"p":77,"r":[{"i":2,"s":4,"z":2},80],"s":[{"c":1,"e":1,"p":[{"o":1},13],"s":{"e":{"r":[{"l":26},208]}}},215],"t":[{"a":21,"o":[{"p":5},82],"r":14},78],"u":78,"x":78,"z":78},75],"ü":{".":78,"b":372,"r":{"c":13},"s":78,"t":75},"v":[{"e":{"r":82},"l":82,"o":{"r":{"a":{"n":102}}}},152],"w":76,"y":{".":75,"a":[{".":73},93],"h":75,"o":71,"r":75,"s":75,"w":75},"z":[{"a":{"c":73,"g":113,"k":167,"n":[{"e":16,"i":82},73],"r":73,"s":2,"t":73,"u":104},"ä":{"n":73,"r":73},"e":{"l":{"a":12,"l":{"i":{"g":33}}},"n":{"e":{"r":{"g":164}},"i":82,"s":{"e":89},"t":{"l":89,"s":89}},"r":{"e":{"m":1},"h":104,"l":[{"ö":10},0],"r":141,"s":{"t":{"e":7}},"t":{"r":{"a":33}}},"s":[{"k":4},124],"t":[{"a":0},2],"u":{"t":9}},"i":{"d":104,"g":{"a":2},"n":{"h":73,"i":104,"t":0,"v":0}},"l":{"e":1},"o":{"p":104},"ö":{"l":73},"s":{"t":1},"t":{"r":12},"w":{"a":104,"ä":104,"e":{"t":73},"i":{"r":73},"ö":73,"u":104}},189]},"ñ":{"o":[{"r":2},0]},"o":{"a":[{"b":{"i":128},"c":[{"h":{"e":1,"i":1}},89],"d":[{"e":1,"s":{"t":12}},89],"i":{"n":1},"k":{"e":128,"l":198},"l":{"a":128},"m":{"i":128},"n":[{"a":12},5],"q":128,"r":206,"s":[{"e":87,"s":140},73],"t":[{"r":5},89],"u":140},161],"ä":93,"b":[{".":77,"a":{"l":79,"m":6,"r":6,"u":{"f":0}},"ä":161,"b":77,"e":[{".":77,"a":77,"c":76,"f":77,"i":{"n":86},"n":[{"a":12,"d":159},77],"r":[{".":76,"e":{"i":{"s":55}},"i":{"n":[{"g":29},25],"s":12}},85],"v":77,"z":77},6],"i":161,"j":78,"l":{"a":0,"e":{"i":1},"i":146,"o":154,"ö":80,"u":6},"o":[{"r":0},77],"ö":77,"r":{"e":{"i":1},"ü":77},"s":[{"h":3,"k":1,"p":2,"z":1},89],"u":[{"n":{"t":89},"s":2},76],"ü":[{"b":89},76],"y":[{"t":12},77]},71],"c":[{"a":82,"c":[{"l":78},0],"e":71,"h":{"a":[{"b":22,"r":22},13],"e":[{"b":10,"c":94,"h":13,"i":13,"l":22,"r":{"k":19}},71],"i":{"d":10},"l":4,"m":4,"o":13,"ö":{"f":22},"r":4,"s":13,"t":10,"u":[{"f":22,"t":9},71],"w":13},"i":71,"k":[{"a":{"r":73,"u":73},"e":[{"r":{"s":{"c":415}}},82],"i":82,"s":{"z":4},"t":{"a":4}},115],"l":71,"u":82},77],"ç":71,"d":[{"a":[{"k":1},80],"d":{"r":6},"e":{"c":82,"i":[{"n":17},383],"l":{"a":{"g":27}},"m":{"a":{"n":12}},"n":11,"r":82,"s":{"e":11,"p":4},"t":6,"x":82},"i":[{"a":76,"c":96,"f":77,"r":76},6],"n":77,"o":[{"n":73,"p":86,"s":12},6],"ö":6,"r":[{"e":73},77],"t":12,"u":76,"y":[{"m":2},82]},71],"e":[{"d":{"i":1},"m":5,"n":{"e":13},"r":{"i":1},"s":[{"c":5},86],"t":[{".":82,"s":82},167]},152],"f":{"a":[{"c":2,"d":32,"g":32,"n":6,"u":0},77],"ä":77,"e":{"b":113,"c":104,"e":77,"i":104,"m":77,"n":{"t":73},"r":[{"b":89},76],"s":161,"t":113,"u":[{"n":1},77]},"f":{"a":21,"e":{"r":{"z":4}},"i":{"n":21,"z":75},"l":23,"o":21,"r":23,"s":[{"h":4,"i":4,"p":4},22],"u":6},"i":[{"e":{"i":37},"k":{"l":9},"s":9},77],"l":[{"e":1,"i":1,"ö":5},93],"o":77,"ö":77,"r":[{"ä":1,"ü":5},93],"s":[{"a":{"m":5},"ä":1,"c":{"h":2},"e":{"n":5},"t":{"a":[{"f":5},1],"r":1}},21],"t":[{"a":2,"e":{"i":6},"h":1,"r":12},77],"u":[{"r":1},77]},"g":[{"a":{"b":104,"c":104,"d":4,"n":{"g":0,"s":0}},"e":{"i":113,"l":{"i":2},"n":{"e":{"r":102}},"r":{"ä":{"t":{"e":{"i":{"n":416}}}}},"t":{"h":104}},"g":{"l":6},"h":82,"i":{"e":{"r":2},"n":[{"i":104,"s":1},48]},"l":[{"e":1,"o":6},0],"n":124,"o":{"r":{"i":32}},"s":[{"p":1,"t":{"e":0,"i":1}},2]},93],"h":{"a":[{"l":{"k":0}},93],"ä":71,"e":[{".":82,"i":{"s":0},"m":82,"n":{".":82,"s":25},"r":{".":82,"e":82,"t":417,"z":83},"s":82},71],"i":93,"l":[{"a":[{"d":36},13],"ä":6,"e":{"c":1,"i":13,"p":1,"r":[{"g":5,"h":14,"w":5},105]},"o":[{"r":100},1],"s":{"e":22},"u":6},77],"m":{"i":75},"n":{"a":[{"c":5},13],"e":{"e":1},"i":6,"m":75,"o":21,"s":{"k":4}},"o":[{"l":{"e":11,"o":48},"p":32},93],"ö":[{"l":1},77],"r":{"a":4,"e":{"l":6,"m":6,"n":{"s":17},"r":[{"g":5},105]},"i":[{"n":5},1],"o":{"l":6},"t":{"r":195}},"s":[{"a":1},0],"t":1,"u":71,"w":0,"y":93},"i":[{"d":{".":71,"a":79,"s":71},"e":82,"m":72,"n":[{"e":89},71],"r":6,"s":{"c":{"h":{".":82,"e":89}},"m":71,"s":22},"t":{"h":0,"u":115}},77],"j":[{"e":{"k":{"t":{"o":{"r":{"i":30}}}}}},93],"k":[{"a":[{"b":37,"c":86,"i":4,"l":{"a":2,"e":[{"r":{"e":26}},105]},"s":{"t":10}},6],"e":6,"i":{"o":12},"l":{"a":[{"u":1},6],"ä":0,"i":6},"o":[{"p":{"t":12}},6],"s":{"o":6,"p":21},"t":47,"w":78},93],"l":[{"a":[{"b":{"u":1},"f":10,"m":113,"n":{"t":0},"r":[{"s":266},6],"s":[{"t":19},79],"v":32},71],"ä":[{"t":0},189],"c":{"h":{"r":6}},"d":{"a":{"m":41},"ä":6,"e":{"d":21,"n":{"g":14},"r":{"s":{"a":35}},"s":22,"u":6},"i":{"m":6},"o":23,"r":6},"e":{".":106,"f":104,"i":{"e":0,"s":104},"m":{"b":0},"r":[{"k":0,"t":418},22],"s":[{"s":0,"t":[{"i":12},2]},4],"u":37,"x":{"z":0}},"f":{"a":6,"e":{"m":6,"r":{"e":4}},"l":23,"r":[{"a":23},13],"t":10},"g":{"e":{"g":{"e":247},"n":{"e":10}},"l":6,"r":6},"i":[{"e":{"n":160,"r":2},"k":9,"t":{"u":35},"v":78},6],"k":{"e":1,"l":6,"r":{"e":23,"o":6},"s":[{"c":12,"i":12},25]},"l":{"a":{"c":21,"d":21,"k":21,"m":4,"n":{"g":5},"u":21},"e":{"b":125,"c":176,"i":21,"l":6,"r":{"h":14,"k":42,"l":4,"w":14},"s":{"s":14}},"o":{"p":6},"s":{"a":37,"p":4}},"o":[{"f":6,"p":13,"r":{"t":0},"v":6},84],"s":{"k":3,"t":{"e":{"r":5}}},"t":{"h":3},"u":[{"t":{"h":2}},71],"y":[{"s":106},6],"z":{"a":[{"n":1},125],"e":{"r":{"n":14}},"i":{"m":6},"o":6,"w":6,"y":6}},77],"m":[{"a":{"b":[{"l":2},73],"g":{"e":113},"l":{"g":0,"l":0},"n":{"e":{"r":27},"g":104,"r":6,"s":{"c":1},"t":{"e":89}},"p":104,"r":{"s":129,"t":[{"e":10},104]},"s":{"y":234},"t":{"i":22,"o":{"m":89}},"u":104},"e":{"b":[{"e":0},73],"f":104,"i":104,"l":[{"d":82},73],"n":{"t":{"a":{"n":380}}},"p":89,"r":[{"h":0,"u":73,"z":0},22]},"i":{"c":162,"e":{"t":132},"g":82,"n":{"d":0,"g":0,"s":0,"t":104}},"m":{"a":1,"e":2},"n":147,"o":[{"a":86,"r":{"g":104,"i":32}},84],"p":{"f":1},"s":[{"k":1},2],"t":3,"u":{"m":73,"n":{"t":89}}},77],"n":{"a":[{"b":3,"c":6,"g":4,"l":82,"n":{"n":1,"z":{"e":{"i":58}}},"p":104,"r":{"b":86},"t":{"h":4,"o":{"l":84},"s":22,"t":344},"u":6},77],"ä":[{"h":0},77],"c":77,"d":{"a":{"n":6},"e":{"r":{"e":{"r":{"s":30,"t":297}}}},"r":[{"a":6,"i":{"n":5}},13],"s":{"k":4}},"e":[{"c":[{"k":2},0],"e":82,"f":73,"i":{"g":82,"n":1},"m":{"a":0},"n":[{"d":{"s":128},"g":6,"s":266},11],"p":0,"r":{".":82,"b":0,"d":104,"f":{"a":10},"h":73,"k":{"a":5},"s":0},"s":82,"t":{"t":82},"u":6},77],"f":3,"g":{"l":[{"e":12},1],"r":12,"s":37,"u":{"e":6}},"i":[{"d":23,"e":{"g":25},"g":{"a":2},"k":[{"r":89},5],"m":89,"n":{"d":89,"h":89,"s":89}},106],"k":[{"e":78},16],"l":{"i":10,"o":{"c":22}},"n":{"a":[{"n":3},22],"e":3},"o":[{"d":82,"f":73,"i":2,"k":{"e":86},"m":82,"r":{"c":0,"d":1},"s":4,"t":37},137],"r":{"a":{"d":17}},"s":{"a":[{"m":5},13],"e":{"b":6,"n":132,"t":10},"i":{"d":22,"n":{"g":4}},"l":4,"p":[{"i":{"n":5}},13],"t":{"a":22,"r":[{"i":35},10]}},"t":{"a":1,"e":{"b":21,"l":36,"n":{"d":35},"r":{"l":14}},"h":6,"r":{"a":{"t":14}}},"u":{"k":77,"r":82,"t":77},"v":1,"y":[{".":82},75],"z":[{"e":{"i":{"n":25}}},3]},"ñ":71,"o":{"c":[{"h":22},0],"g":{"l":6},"k":{"l":23,"n":6},"m":{"o":6},"n":{"e":6},"p":[{"s":2},71],"r":[{"d":4},71],"s":{"k":5,"s":9,"u":6},"t":{"a":21,"e":{"i":41},"h":21,"r":6,"s":{"t":2},"t":4,"u":{"r":6}}},"ö":152,"p":{".":77,"a":[{"d":{"r":1},"k":{"t":0},"l":{"e":2},"n":{"g":0},"s":[{"t":9},35]},71],"ä":77,"e":[{"c":71,"d":93,"f":0,"i":93,"k":71,"l":77,"n":77,"p":77,"r":{"a":73,"h":0},"s":71},75],"f":{".":77,"a":[{"h":1},23],"ä":6,"e":[{"m":6},73],"i":{"n":6},"l":{"a":4,"ü":0},"o":6},"h":[{"e":82},269],"i":[{"a":195,"e":{"r":{".":4,"s":{".":35},"u":277}},"n":22},71],"l":[{"a":{"g":1},"e":412},77],"n":79,"o":[{"l":{"a":2}},77],"p":{"a":{"n":6},"l":5,"o":75,"r":23,"t":77},"r":93,"s":{"i":147,"z":1},"t":[{"e":77,"h":1},192],"u":{"m":73},"y":77},"q":93,"r":{".":77,"a":[{".":77,"a":71,"b":[{"b":73},173],"d":{"d":86,"r":1},"g":72,"k":[{"e":75},73],"l":[{"m":128,"t":5},71],"m":[{"i":3},6],"n":{"d":419,"e":5,"f":22,"m":22,"z":{"e":10}},"p":1,"r":77,"s":72,"t":{"t":73},"u":[{"s":{"w":{"a":15}}},148],"v":6,"w":93,"y":71},0],"ä":[{"n":{"d":0},"t":0},82],"b":{"l":2},"c":[{"a":77,"e":6},0],"d":{".":77,"a":[{"m":13,"r":6,"u":6},84],"b":77,"e":{"n":{"g":4},"s":10,"u":6},"i":{"n":{"g":14},"r":21,"t":6},"n":75,"o":36,"r":77,"s":{"t":37},"t":4,"u":77,"w":77},"e":[{"a":2,"b":113,"c":{"k":113},"d":{"i":2},"e":140,"f":[{"f":0},82],"h":2,"i":[{".":82,"e":82,"f":79,"s":79},0],"l":{"i":132},"m":{"s":105},"n":{"n":82},"p":82,"r":[{"e":79,"o":79},104],"t":{"h":12},"u":104},77],"f":[{"a":{"c":6,"r":6}},77],"g":{"a":12,"e":[{"t":77},2],"h":{"i":1},"i":{"a":77},"l":[{"a":1,"e":1},6],"n":[{"e":1},6],"r":77},"h":77,"i":{"a":76,"d":[{"i":25},161],"e":{".":106,"n":{".":82,"t":{"i":164}},"r":82},"l":82,"m":{"a":0,"i":12},"n":[{"d":114,"s":89},420],"o":372,"s":{"o":73},"t":77},"k":[{"r":12,"s":[{"h":4},2]},77],"m":[{"a":{"m":6,"n":{"g":5,"s":5},"s":{"p":4}},"e":{"b":21,"r":{"f":14,"g":39}},"o":{"r":[{"d":4},6]},"u":{"m":6,"n":[{"i":5,"t":5},10]},"w":{"a":54}},77],"n":{"a":{"c":125,"l":6,"n":6,"r":6},"e":{".":7},"i":[{"n":5},1],"o":393},"o":[{"b":104,"l":{"y":1},"n":{"a":37},"p":{"f":0},"r":289,"u":82,"x":0},93],"ö":93,"p":77,"q":77,"r":[{"a":12,"e":3},77],"s":[{"a":16,"h":1,"i":1,"k":1,"t":{"i":{"n":12}},"z":1},108],"t":{"a":{"k":21,"n":21,"r":22},"e":{"f":6,"n":[{"g":421},10],"r":{"b":4,"e":14,"f":4,"g":4,"k":5,"l":14,"s":{"c":15}},"v":118},"h":{"e":6},"i":{"n":6},"o":{"f":{"f":14},"r":176},"ö":6,"r":{"a":{"d":4,"u":5},"ä":{"u":14},"e":4},"u":{"m":21}},"u":[{"f":6,"h":0,"m":{"s":10},"n":128,"r":2,"s":140},76],"ü":73,"z":{"e":[{"l":54},3],"w":6}},"s":{"a":[{"d":1,"l":22,"m":{"i":128},"s":13},161],"c":[{"a":128,"h":{"a":{"r":25},"e":82,"l":{"e":25}},"o":5},77],"e":[{"e":13,"i":{"n":422},"l":6,"n":2,"r":{"k":117},"x":6},77],"h":[{"i":79,"o":6,"u":5},77],"i":[{"t":5},77],"k":[{"a":{"l":6},"i":89,"l":80,"o":80,"r":89,"y":89},82],"m":[{"o":{"g":5}},75],"o":[{"l":48},77],"ö":73,"p":[{"a":{"c":6},"e":[{"c":1,"r":{"o":1}},6],"h":{"ä":82},"o":[{"t":5},79],"r":{"a":6}},127],"s":[{"a":[{"c":423,"g":1,"l":{"a":4},"n":{"d":4}},6],"ä":5,"e":{"i":6,"n":{"k":{"e":35},"z":14},"p":21,"r":{"b":39,"e":19,"f":42}},"i":{"k":5,"m":5},"o":[{"n":5},125],"p":[{"a":13},6],"t":23},77],"t":{"a":[{"n":{"g":4},"r":{"r":7,"t":12},"t":5,"u":{"t":4}},13],"ä":5,"e":{"c":22,"n":22,"r":{"e":17,"w":{"e":[{"i":175},35]}},"s":{"s":54},"u":[{"r":4},5]},"h":21,"i":{"d":6,"l":1,"m":5,"n":[{"a":1},6],"t":6},"o":{"c":1,"r":5},"r":{"a":{"n":4},"ä":4,"e":4,"o":{"t":4}},"u":{"f":4,"g":6},"ü":{"c":5}},"u":[{"m":0},158],"y":76,"z":{"e":124}},"ß":[{"e":{"l":104,"n":{"t":104,"z":117},"r":[{"b":104,"e":104,"f":104},22]},"i":{"s":0}},77],"t":[{"a":{"b":{"e":82,"i":86},"h":104,"k":104,"l":82,"m":82,"n":{"t":0},"r":{"k":82,"z":73},"s":[{"t":0},2],"u":[{".":82},104]},"ä":0,"e":[{"b":89,"i":[{"b":114,"c":114,"n":10,"s":114},13],"l":[{"a":99,"i":{"n":12},"s":266},6],"m":{"i":114,"p":424},"n":{"a":12,"t":{"b":89}},"r":{"b":0,"l":425,"w":114},"s":232},82],"h":{"a":{"r":6},"e":{"m":73},"i":104,"r":73},"i":[{"l":73,"m":113,"n":[{"h":1},6]},84],"l":{"i":10},"o":[{"b":9,"f":{"f":1},"p":{"h":2}},6],"ö":104,"r":{"a":{"c":25,"n":124,"t":1,"u":5},"e":1,"i":{"c":1,"g":5,"n":1},"u":{"s":1}},"s":{"a":{"t":23},"c":{"h":1},"e":{"n":2},"o":13,"p":[{"e":2,"r":6},13],"t":{"a":{"u":4},"i":1,"r":{"a":1}},"u":6},"t":{"a":[{"n":5,"s":110},13],"e":{"b":6,"r":{"h":5,"k":42},"s":22},"h":21,"i":{"m":6},"o":2,"r":[{"a":16,"i":5,"u":16},23]},"u":{"r":{"l":0}},"ü":82},93],"u":{"f":{"f":33,"l":120},"g":[{"e":5,"l":1},2],"h":71,"i":{"s":{".":0}},"l":[{"e":{".":6,"s":6},"i":5},77],"m":93,"n":[{"g":{"e":{".":12}}},426],"r":[{"e":[{"t":6},22],"i":[{"e":19},10],"m":{"e":19},"n":{"e":{".":12}}},84],"s":{"a":1,"i":2},"t":{"i":1,"p":78,"s":37,"u":57}},"ü":93,"v":[{"a":6,"e":{"l":77,"n":82,"s":4},"i":{"s":{"o":17}},"o":77},71],"w":[{"a":{"l":86},"e":{"c":82},"h":73,"i":82,"u":73},93],"x":{".":77,"a":72,"e":[{"l":104},77],"k":77,"l":1,"o":71,"u":104,"y":85},"y":{"o":71,"s":32},"z":[{"a":82,"e":{"a":75,"n":[{"t":{"a":10}},76],"s":{"s":{"c":10}}},"i":[{"r":25},106],"o":{"n":{"a":48}},"y":77,"z":1},72]},"ó":{"r":[{"d":2},1]},"ö":{"b":[{"a":124,"l":[{"e":86},6],"r":86,"s":23},71],"c":[{"h":{"l":13,"r":73,"s":[{"t":{"e":[{"i":54},12],"r":17,"u":10}},2]},"k":{"e":82}},71],"d":[{"e":{"l":{"l":25},"r":13},"i":[{"e":{"n":17}},4],"s":{"t":6},"u":75},71],"e":71,"f":[{"f":{"l":6},"l":1},75],"g":[{"e":{"l":{"e":4},"n":{"s":163}},"l":86,"r":86},71],"h":{"e":[{"n":99},71],"l":{"e":271},"r":{"e":10,"i":1},"u":71},"i":{"g":{".":82},"s":{"c":{"h":{".":82}}}},"k":{"e":71,"o":427,"r":1,"s":6},"l":[{".":78,"a":32,"e":{"i":0,"m":0,"n":5},"f":{"e":{"i":21,"r":2}},"i":{"n":0},"k":{"e":12,"l":23,"s":10},"l":{"a":13,"e":1},"m":78,"n":{"a":{"r":6}},"o":32,"s":[{"a":1,"z":1},2],"t":{"u":1},"u":75,"z":{"w":2}},73],"m":[{"s":6},71],"n":{"e":6,"i":[{"z":{"i":132}},82],"n":{"e":2},"s":[{"c":1,"p":1},6]},"o":[{"t":{"a":6,"i":48}},0],"p":[{"e":71,"f":{"l":4},"s":{"t":14}},77],"r":{"a":3,"b":{"l":23},"c":0,"d":{"r":[{"a":1},6]},"e":{"c":104,"i":104,"l":113,"m":113,"n":[{"e":104,"t":73},2],"r":{"b":79,"e":117,"f":97,"g":97,"h":6,"l":97,"r":6,"w":6,"z":79},"s":{"s":0}},"f":{"l":23},"g":{"l":6},"i":{"m":73},"k":{"l":6},"n":{"e":[{"r":{"v":19}},2]},"o":0,"p":{"e":22},"s":{"e":2,"k":1},"t":{"e":2,"r":{"i":7}},"u":[{"n":{"e":104}},12]},"s":{"a":73,"c":[{"h":{"a":157,"e":[{"i":165,"r":[{"f":428,"i":428},102]},105],"i":73,"l":333,"m":157,"n":73,"w":73}},77],"e":{"i":[{"n":73},0],"s":{"t":{"r":4}},"t":82},"l":77,"p":73,"s":{"c":21,"t":6},"t":[{"a":100,"e":1,"h":6,"r":1},73],"u":82},"ß":[{"e":{"n":25},"t":{"i":6}},71],"t":[{"a":128,"e":{"n":99},"r":86,"s":[{"c":6},2],"t":{"r":6}},71],"v":72,"w":71,"z":[{"e":[{"s":10},4]},71]},"p":{"a":{".":75,"a":75,"b":[{"e":73,"l":2,"r":{"ü":12},"w":77},71],"c":75,"d":85,"e":[{"l":1,"s":6},2],"f":{"r":0},"g":[{"h":1},192],"h":{"o":0},"k":[{"e":1,"l":0,"t":{"o":12}},75],"l":{"a":[{"t":25},78],"ä":78,"e":187,"i":3,"m":[{"a":2,"ä":2,"o":11},75],"t":[{"a":11,"e":{"i":12},"r":2},77]},"m":{"a":23},"n":{"a":{"r":6,"t":14},"d":[{"a":22,"s":12},4],"e":{"u":6},"f":10,"g":10,"i":{"s":{"l":5}},"k":10,"l":77,"n":[{"e":[{"b":27},105],"u":84},77],"o":227,"s":{"l":4},"t":{"h":37,"o":75,"r":77},"z":[{"e":4},22]},"p":[{"i":[{"e":{"r":{"e":{"n":[{"d":61},62]}}}},22],"p":{"r":2},"s":[{"t":132},12]},75],"q":0,"r":{"a":[{"f":{"f":14},"k":{"t":4},"n":{"t":5},"p":1},75],"ä":6,"b":77,"c":85,"d":4,"e":{"r":{"g":{"e":{"b":175}}}},"f":[{"ö":77},75],"g":{"e":{"l":{"d":29}}},"k":{".":75,"a":{"m":25,"u":12},"r":12,"s":75},"m":37,"n":{"e":4},"o":227,"p":77,"r":77,"t":{"a":84,"e":{"i":78},"i":75,"n":75,"y":78},"z":4},"s":{"e":2,"p":[{"e":5},1],"s":{"e":{"r":[{"g":26},102]},"p":11},"t":5},"ß":77,"t":{"a":13,"c":12,"e":[{"l":77},429],"h":430,"i":75,"r":431},"u":[{"f":93,"n":{"i":1},"s":{"z":77}},75],"v":75},"ä":[{"c":[{"k":{"e":[{"r":186},1]}},215],"d":[{"e":[{"r":21},22]},78],"r":78,"s":78,"t":{"e":{"h":176,"n":{"t":5},"p":5,"r":{"b":14}},"h":21,"o":6,"r":5,"s":9}},75],"b":93,"c":76,"d":[{"a":12},152],"e":{".":75,"a":[{"r":12},232],"b":72,"c":{"h":48},"d":{"a":75},"e":{"l":75,"n":6},"f":[{"f":189},77],"g":[{"e":{"l":22}},75],"i":[{"c":84,"l":75,"m":73,"s":77,"t":75},13],"k":{"t":{"i":22}},"l":[{".":78,"a":{"b":14,"i":5,"u":21,"x":23},"ä":21,"b":22,"d":9,"e":[{"h":176,"r":21,"t":6,"u":6},78],"i":{"d":22,"n":[{"k":14,"n":4,"s":12},10]},"k":4,"l":{"a":37,"e":10,"i":22},"o":{"b":6},"s":[{"p":4},432],"t":{"a":37},"z":{"i":{"n":12}}},236],"m":75,"n":[{"a":{"r":22,"s":5},"ä":6,"d":{"a":37},"e":{"n":433},"i":{"t":110},"o":21,"s":{"a":22,"i":326,"o":306,"p":22,"z":4},"t":{"a":22,"w":77,"y":105},"u":22,"z":4},75],"p":[{"i":1},75],"r":{"a":[{"k":6,"m":2,"u":6},0],"ä":21,"e":{"b":100,"r":[{"z":17},105]},"i":{"d":3,"o":434},"l":{"e":75,"h":75},"r":{"a":{"n":27}},"s":[{"e":77,"i":77,"o":78,"p":78},75],"u":[{"n":1},22],"ü":75,"w":{"a":{"r":19}}},"s":{"a":3,"e":{"n":22},"s":435,"t":[{"e":{"r":12},"o":48},6]},"t":[{"r":12},78]},"é":75,"f":{".":84,"a":{"b":104,"d":73,"f":73,"i":0,"k":104,"m":0,"n":{"s":0},"r":[{"e":1},289],"u":104},"ä":[{"r":73,"u":104},75],"e":{".":84,"f":73,"i":[{"m":0,"n":0},73],"m":32,"n":{".":82,"e":{"r":89},"s":82,"t":82},"p":114,"r":{"a":55,"d":{"e":89},"p":{"r":{"o":33}}},"s":5,"t":104},"f":12,"i":{"d":113,"n":{"n":0,"s":436},"s":2},"l":{"a":{"m":0,"n":5},"e":{"g":5,"i":1},"o":1},"o":[{"b":73,"m":73,"r":[{"i":0},73]},2],"r":[{"a":0,"ü":5},1],"s":[{"a":1,"e":1,"l":1,"t":{"i":12},"z":1},108],"t":[{"r":12},173],"u":{"m":73}},"g":[{"r":{"a":22}},161],"h":[{".":84,"a":[{"l":{"t":{"e":437}},"n":{"d":71},"s":438,"u":71},6],"ä":[{"n":78,"r":84},13],"b":84,"d":77,"e":{"i":93,"n":{"d":266,"e":99,"s":266},"r":{"s":127}},"f":84,"g":84,"i":{"d":73,"k":{"a":[{"n":12},48]}},"k":77,"l":6,"m":84,"n":77,"o":{".":73,"b":73},"ö":77,"r":6,"s":84,"t":[{"h":{"e":77}},3],"u":{"s":12,"t":4},"ü":93,"y":88,"z":84},75],"i":{"a":[{"b":10,"k":4,"l":{"i":5},"n":4,"p":22},348],"c":{"e":0},"d":2,"e":{"i":21,"l":[{"a":25},6],"r":[{"a":2,"e":{"b":12,"i":12}},78]},"g":{"l":1},"l":[{"e":1,"o":78,"z":{"e":{"r":12},"w":2}},75],"m":73,"n":{".":78,"a":{"d":6},"g":[{"e":{"n":102},"s":25},78],"s":{".":78,"e":78,"p":37}},"o":[{"i":{"d":{"e":1}},"n":{"u":1},"s":1},6],"p":[{"e":6},75],"r":{"a":{"t":{"e":78}},"i":[{"n":78},1]},"s":[{"o":77},75],"t":{"a":2,"h":3,"s":2,"z":{"e":37}},"z":{"i":{"n":21}}},"j":93,"k":[{"u":2},152],"l":[{".":77,"a":[{"d":106,"h":71,"n":{"a":4},"u":89,"y":11},78],"e":{".":76,"c":13,"e":2,"g":89,"n":37,"r":76,"u":89},"i":{"g":77,"k":147,"z":89},"o":{"n":4},"u":[{"s":2},76]},233],"m":161,"n":152,"o":[{"b":2,"c":[{"k":78},127],"d":78,"e":[{"l":6},78],"h":77,"i":[{"d":{".":1,"s":1},"n":78},6],"l":[{"a":{"n":6,"u":21},"d":{"e":22},"i":1,"o":{"p":121},"z":37},78],"m":{"p":{"h":2}},"n":{"d":77,"t":22},"o":{"b":0},"p":{"a":{"k":21,"r":21},"l":23,"t":3},"r":{"a":{"u":0},"f":10,"s":4,"t":{"a":{"l":78},"h":11,"i":{"o":78},"o":{".":78,"s":78},"r":[{"e":12},78]}},"s":{"i":78,"s":22,"t":{"a":[{"g":12},6],"ä":6,"e":{"i":25,"l":4,"m":12},"r":[{"a":25},12]}},"t":{"a":[{"r":13},6],"ä":78,"e":78,"h":2,"i":{"n":23},"t":{"r":48},"u":21},"u":{"n":1},"w":[{"e":22},6],"x":1},85],"ö":{"b":{"l":6},"c":6},"p":[{"a":{"b":73,"n":{"s":0},"t":73,"u":0},"e":{"e":4,"i":104,"l":{"a":11,"i":{"n":{"e":54}},"s":25},"n":439,"r":{"z":104}},"f":[{"r":0},237],"h":[{"e":1},104],"l":[{"a":{"c":114,"n":89},"ä":104,"e":73},1],"o":{"h":1},"ö":131,"p":16,"r":{"a":86,"ä":412,"i":73,"o":{"l":1,"t":1},"u":86},"s":[{"a":16,"p":2,"y":1},89],"t":12,"u":{"m":114},"y":{"l":22}},189],"r":[{"a":{"k":75,"x":75},"ä":[{"d":75,"f":75,"g":75,"l":75,"m":78,"p":75,"s":78,"v":75},89],"e":{".":77,"c":77,"d":78,"e":[{"i":2},440],"g":77,"i":[{"s":[{"c":277,"e":{"i":33},"t":318},78],"z":77},75],"m":75,"n":{"g":{"a":10}},"r":76,"s":[{"a":4,"s":{"e":19}},75]},"i":{"e":12,"g":77,"l":11,"n":{"g":[{"s":102},77],"z":75},"t":[{"e":{"r":102},"t":441,"z":77},11],"v":75},"o":[{"b":[{"e":4},78],"c":77,"d":442,"g":147,"j":78,"s":{"s":84,"t":13},"t":{"e":22,"o":78,"t":77},"x":4},75],"ö":77,"ü":{"f":75,"g":75,"h":77,"n":77}},206],"s":[{".":84,"a":{"d":0},"h":{"i":6},"o":{"d":0},"ö":73,"p":{"i":5},"s":12,"t":[{"a":[{"u":13},82],"ä":82,"e":{"a":82,"l":82},"h":6,"i":79,"o":5,"ö":82,"u":6,"ü":82},73],"y":[{"s":84},88],"z":{"e":6}},93],"t":[{"a":[{"b":6,"g":2,"t":183},0],"e":{"b":113,"c":1,"f":0,"i":0,"m":{"i":0},"n":[{"g":425,"t":114},84],"p":0,"r":{"e":{"i":1},"w":0,"z":0},"t":[{"a":89,"i":296},82]},"h":104,"i":{"d":[{"e":2},0],"n":298},"o":{"m":{"o":2},"n":{"a":12},"p":2,"w":2},"r":[{"o":73},1],"s":[{"l":5,"t":12},3],"u":{"h":0,"m":0,"r":{"s":0}},"ü":12,"y":88,"z":3},93],"u":[{"a":0,"b":12,"c":77,"d":{"r":6},"h":93,"k":[{"l":6,"o":21},77],"l":{"i":{"n":6},"s":{"p":2,"t":2},"w":77},"m":{"p":{"l":2}},"n":[{"d":84,"e":2,"s":2,"t":84},78],"r":[{"a":6,"e":{"i":6}},77],"s":{"h":[{"e":1},2],"t":23},"t":{"e":47,"s":187,"z":78},"z":{"i":25}},75],"ü":{"f":75,"l":[{"l":37},77]},"v":93,"w":[{"a":{"r":12}},93],"y":[{"s":1,"t":1},443],"z":152},"q":{"u":[{"e":{"r":{"e":{"l":4},"n":55},"t":{"e":{".":12}},"u":75}},5]},"r":{"a":{".":75,"a":[{"b":6,"c":77,"l":77,"r":1,"s":104},71],"b":[{"a":{"r":21},"ä":73,"b":{"i":75,"l":162},"d":[{"r":{"u":102}},77],"e":{"i":6,"r":[{"d":4},2]},"f":77,"g":77,"h":77,"i":75,"k":77,"l":{"e":73,"i":6,"o":198},"r":80,"s":148,"t":77,"w":76,"y":75,"z":77},71],"c":{"e":[{"t":93},6],"h":{"e":{"b":5},"o":6,"s":77,"t":{"r":{"ä":58}},"u":6},"k":73},"d":[{".":89,"a":[{"c":6,"m":41,"n":6,"p":77,"r":78},22],"e":{"i":126},"f":78,"h":78,"i":{"o":78,"t":84},"o":78,"p":78,"r":[{"i":4},41],"t":195},85],"f":[{"a":{"h":{"n":4},"r":4},"e":[{"r":21},22],"r":4,"t":{"s":55}},73],"g":{"a":2,"e":{"i":{"n":102},"s":19},"g":77,"l":{"e":16},"m":84,"n":6,"o":73},"h":{"l":{"e":{"n":19}},"m":252,"n":71,"o":127,"t":84},"i":[{"c":77,"l":{"l":22},"r":76},73],"k":{"a":25,"e":444,"k":77,"l":445,"r":{"e":6,"o":6},"t":{"i":77},"ü":75,"z":77},"l":[{".":89,"a":[{"b":14,"k":13,"s":10},36],"ä":6,"b":9,"d":147,"e":{"n":{"d":14,"t":5},"r":{"n":198},"x":1},"i":[{"d":6,"e":{"r":25},"n":{"d":42,"g":14,"s":{"p":15},"t":19}},89],"k":{".":76},"m":{".":76},"p":{".":77,"e":84},"s":[{"k":4,"u":4},89],"t":[{"h":446},82],"u":23,"y":78},73],"m":{"a":{"s":25},"e":{"i":6,"r":6},"i":73,"m":[{"a":{"n":12},"e":{"n":{"s":26},"r":{"s":46}},"u":27},73],"n":77,"s":{"c":78},"t":[{"s":10},93],"u":77},"n":{"a":[{"d":[{"e":4},13],"l":72,"n":6,"r":6,"u":6},77],"b":[{"e":73},77],"d":{"a":89,"e":[{"p":12,"r":27},89],"i":88,"s":25},"e":{"r":75},"f":77,"g":{"a":77,"e":{"b":{"e":28}},"i":78,"l":73,"s":[{"p":25,"t":{"e":55}},105]},"i":{"e":25,"l":124},"k":{"a":4,"r":2,"ü":2},"l":84,"m":[{"i":73,"u":73},93],"n":{"a":77,"e":35},"p":93,"r":77,"s":[{".":73,"c":71,"p":{"a":12}},77],"t":{"e":{"i":214},"h":71,"o":73,"r":77},"u":75,"w":77,"z":{".":73}},"p":[{"a":[{"r":6},77],"f":77,"o":[{"k":6},77],"p":{"r":2},"r":{"i":161}},73],"q":93,"r":[{"a":447,"b":77,"e":[{"i":147,"n":132,"t":4,"v":100},73],"f":156,"i":{"e":1,"n":4,"s":[{"t":124},1],"t":106},"k":73,"o":[{"m":6},22],"t":77,"z":[{"w":4},77]},71],"s":{".":89,"a":[{"n":1},2],"c":{"h":{"l":5}},"m":73,"p":{"r":1},"t":[{"a":6,"e":{"i":27},"h":82,"o":12},73],"y":{"l":77}},"ß":77,"t":[{".":89,"a":{"n":21},"e":{"i":21,"l":79},"i":{"d":5},"m":77,"o":[{"m":77,"r":7},2],"r":12,"t":[{"a":77,"r":77},82],"z":[{"e":4},84]},75],"u":{".":84,"b":{".":78},"e":{"n":9},"f":[{"ä":4},77],"g":155,"m":[{"a":{"g":27},"e":{"s":35},"i":2},78],"p":78,"r":84,"s":{"b":77,"c":432,"d":77,"e":4,"f":77,"g":[{"e":{"w":{"ä":30}}},77],"h":77,"l":77,"p":2,"s":[{"c":{"h":{"e":30}},"e":55},77],"v":77,"w":77},"ß":{"e":4},"t":{"o":77,"r":[{"a":12,"o":12},48],"s":55}},"ü":75,"x":[{"i":22,"t":82},73],"y":[{"o":13},73],"z":73},"ä":{"c":{"h":{"s":22}},"d":88,"f":[{"r":0},84],"g":84,"h":77,"m":84,"n":{".":78,"i":78,"s":78},"p":77,"q":77,"r":[{".":73,"a":1,"o":0},93],"s":{"c":6,"e":22},"t":{"e":{"s":48},"s":{"e":78},"z":84},"u":[{"e":84,"s":[{"c":[{"h":{"e":{"n":{".":263}}}},10],"s":77},2],"ß":77,"t":84},6],"x":77},"b":[{"a":{"b":448,"c":82,"d":{"e":{"l":12}},"l":6,"m":82,"n":{"g":73,"t":73},"r":{"t":0,"z":73},"u":{"f":0}},"b":2,"e":{"c":{"h":0},"e":{"r":{"f":4}},"i":{"d":266,"n":{"f":4,"h":1,"t":4}},"l":{"ä":89,"o":22},"n":{".":82},"r":{"e":37,"g":{"i":{"n":33}},"u":{"m":4}},"s":{"l":4}},"i":{"m":73,"n":{"f":73},"t":[{"a":22,"u":4},82]},"l":{"a":{"d":110,"n":73,"s":{"s":{"e":{"r":290}},"t":128},"t":82,"u":82},"e":{".":86,"n":82,"r":1,"u":73},"i":{"n":6},"ö":6},"o":{"b":6,"n":{"k":73}},"r":{"a":{"s":1},"e":{"a":1,"c":{"h":{"t":{"s":360}}}}},"s":{"a":{"m":5},"e":{"i":6,"r":6},"o":21,"t":{"ä":5},"u":6},"u":6,"ü":{"b":12},"y":{"t":12}},189],"c":[{"e":71,"h":{"e":{".":71,"n":71},"i":217,"l":[{"o":82},4],"m":4,"r":[{"o":12},4],"s":[{"p":4},184],"t":{"a":37,"e":{"r":{"r":29}}},"w":13},"i":71,"k":73,"l":71},77],"ç":71,"d":[{"a":{"c":6,"f":73,"k":104,"l":113,"m":{"m":6},"n":{"i":132,"n":73,"t":0},"r":{"a":0,"k":0,"z":73}},"ä":{"r":22},"e":{".":82,"e":82,"i":[{".":6},73],"l":{"b":104,"e":289,"f":73},"m":33,"n":{"d":25,"g":{"l":89},"t":{"s":89}},"o":{"b":4,"n":{"o":4}},"r":{"e":{"r":9},"i":{"n":{"s":29}},"n":{"t":128}},"s":[{"p":4},82],"x":113},"i":{"n":{"n":104},"r":{"i":0},"t":{"a":0}},"o":{"f":73,"n":82,"s":{"s":1,"t":12},"z":104},"ö":73,"r":{"a":{"t":1,"u":73},"i":{"s":1},"ö":5,"ü":124},"s":{"ä":{"n":6},"k":3,"z":3},"t":[{"a":3,"h":1,"s":2},12],"u":{"k":104},"w":{"a":{"r":33}}},189],"e":[{".":78,"a":{"d":2,"l":{"e":{"r":{"w":46}}},"m":139,"t":{".":1,"s":1,"u":17}},"ä":77,"b":{"a":21,"l":21,"r":[{"a":4},13],"s":{"o":4}},"c":{"h":{"a":{"r":25},"s":84},"k":{".":77,"i":77}},"d":{".":78,"a":1,"d":84,"i":[{"k":6},77],"n":78,"u":78},"e":{"b":{"e":0},"l":0,"m":[{"i":12},0],"r":0},"f":{"e":78,"f":[{".":73},84],"l":78,"o":78},"g":[{"e":{"l":{"ä":277},"n":{"e":{"r":{"a":249}}}},"g":189,"i":1},78],"h":{"a":{"c":6,"r":21},"e":{"n":{"e":42,"t":14}},"i":6,"l":184,"o":[{"l":1},21],"ö":78,"t":{"h":12},"ü":6},"i":{".":73,"b":[{"e":{"l":12},"l":{"e":12}},73],"c":73,"d":77,"e":[{"r":{".":84}},73],"f":{"e":{"i":12,"l":84}},"g":[{"ä":78,"e":{"h":78,"l":89,"n":{"s":221}},"i":78,"n":84,"r":{"u":78}},77],"l":{"a":37,"i":37,"t":93},"m":[{"p":22},78],"n":[{"a":[{"l":4},154],"b":77,"d":{"u":10},"e":{"c":353,"n":53},"f":[{"e":10,"o":5},77],"g":77,"h":77,"n":84,"r":106,"s":[{"a":84,"e":{"l":33},"t":{"r":{"e":70}},"z":10},77],"t":[{"e":{"g":33}},77],"v":83,"w":77,"z":77},71],"s":{"a":{"r":84},"b":84,"e":{"s":102},"f":77,"h":77,"r":77,"t":{"e":{"r":312}},"u":84,"w":77},"t":{"s":266}},"k":[{"e":139,"k":84,"n":194,"z":77},78],"l":{".":73,"a":[{"t":1},73],"b":77,"e":[{"a":19,"i":7,"k":6,"m":84,"v":73},2],"f":77,"i":{"t":77,"x":77},"l":[{"a":{"r":12},"e":{"i":12}},73],"o":1,"s":73,"t":77,"u":22},"m":{".":88,"b":93,"d":{"a":2},"e":{"i":21,"n":1},"i":[{"g":1},77],"p":{"f":77},"s":{"c":48,"t":{"r":12}},"u":108},"n":{".":73,"a":[{".":77,"c":5,"d":1,"l":1,"n":14},73],"ä":6,"d":{"g":93,"i":78,"r":4},"e":{"r":{"g":84}},"g":{"a":{"g":84,"n":12},"p":77},"h":78,"i":6,"m":78,"n":{"a":{"r":12},"e":{"n":{"e":26}}},"r":{"ü":105},"s":{"e":{"i":{"n":26}},"p":22},"t":{"d":77,"e":{"r":{"a":221}},"f":[{"o":78},77],"g":77,"h":{"ä":82},"l":93,"s":93,"w":76,"z":77},"z":[{"e":{"r":{"f":325,"l":29,"s":325,"w":29}},"i":{"n":27},"w":2},73]},"o":{"b":6,"r":1},"p":{"e":[{"n":139},78],"i":[{"s":6},77],"o":{"c":77,"s":152},"p":84,"u":78},"r":{".":88,"a":22,"b":[{"e":{"r":147},"i":2},93],"d":93,"e":[{"i":{"g":106},"k":71,"p":21,"r":73},22],"f":[{"a":[{"h":84},82],"i":77,"o":77,"r":73,"ü":2},71],"g":[{"e":{"b":[{"ü":194},106],"n":89,"s":147},"o":108,"r":[{"u":89},2]},71],"h":[{"ö":2},71],"k":[{"a":{"n":12},"e":[{"n":106},2],"i":88,"o":88},71],"l":[{"a":[{"g":252},244],"e":{"b":82},"i":73,"ö":77},71],"m":93,"n":[{"ä":93,"e":71,"i":93,"s":106,"t":189},2],"o":[{"b":6,"s":{"i":5}},0],"ö":321,"r":{"e":[{"g":12,"i":12},71],"i":71},"s":{".":403,"a":93,"c":[{"h":{"i":164}},4],"e":73,"p":77,"t":[{"a":{"d":164}},2],"u":158},"t":[{"e":73,"r":77},449],"w":[{"a":[{"c":12},77],"e":{"c":12,"s":89}},71],"z":[{"ä":2,"y":88},93]},"s":{".":88,"a":[{"m":5},6],"c":{"h":{"e":102,"w":5}},"e":[{"h":110},78],"o":{"f":21,"l":78,"n":78},"p":{"a":6,"o":2},"s":[{"e":[{"i":4,"r":{"w":46}},84],"u":84},77],"t":{"a":[{"s":12},0],"e":{"n":{"t":26},"x":12},"u":158},"u":78},"t":{"a":{"k":21,"p":80,"u":6},"e":2,"h":152,"r":{"a":6,"o":{"l":5}}},"u":[{"e":{"r":{"i":12}},"g":37,"l":77,"n":{"i":1},"r":77,"u":84},6],"ü":77,"v":{"a":106,"i":{"d":93}},"w":{"a":{"r":10},"i":6,"o":77},"x":258,"z":[{"i":77},78]},75],"é":75,"f":[{"a":{"c":{"k":32},"m":82},"e":{"i":2,"n":{"t":73},"s":79},"f":[{"e":1},2],"i":{"l":{"e":{".":12}}},"l":{"a":{"n":{"d":89}},"ä":124,"i":{"c":1},"ö":5,"ü":82},"o":{"b":289,"l":{"g":{"s":19}}},"r":{"a":{"u":{"c":89}},"u":5,"ü":5},"s":{"a":[{"m":5},6],"ä":21,"u":6},"t":{"a":6,"r":12},"u":6,"z":{"u":25}},189],"g":[{"a":{"d":113,"h":104,"k":104,"n":{"e":{"r":12}},"p":104,"r":{"b":73,"t":{".":1}},"s":{"k":104}},"d":2,"e":{"a":{"n":12},"b":{"l":2},"c":113,"l":[{"e":{"f":89,"r":27}},82],"n":{"z":{"w":277}},"t":{"a":{"p":284},"o":73}},"i":{"s":{"e":{"l":12}}},"l":{"a":{"n":[{"z":82},73]},"e":{".":7,"u":73},"i":{"g":73,"t":86},"o":{"g":6},"u":6},"n":{"a":86,"e":73,"i":86,"o":86},"o":{"a":86,"b":73,"g":82,"p":1,"r":104},"ö":[{"d":104},2],"r":{"a":{"l":86,"u":5},"e":{"g":73,"s":86,"t":73},"i":{"n":1},"u":{"n":82},"ü":{"s":1}},"s":{"ä":1,"e":[{"i":2,"l":5},1],"i":3,"p":[{"e":2,"o":2},1],"t":[{"r":12,"u":2},1],"u":1}},93],"h":[{".":77,"a":{"g":73,"h":77,"k":77,"l":{"t":{"b":89}},"n":82,"u":77},"ä":76,"e":{".":88,"a":82,"b":77,"f":77},"i":77,"o":{"l":77,"p":82,"t":77},"ö":{"l":77},"s":77,"u":{"s":2},"ü":77},115],"i":[{"a":{"m":{"s":1},"n":[{"o":6},0],"s":[{"t":6},13]},"b":{"b":{"l":2}},"c":{"e":0,"h":{"a":0,"l":1,"t":{"s":{"p":{"o":175}},"u":78}},"o":{"n":6}},"d":{"a":{"u":6},"e":[{"l":118,"n":{"t":5}},77],"i":86,"o":{"l":77},"y":77},"e":[{"f":{"m":84,"r":162},"g":{"s":277},"i":[{"n":132},21],"l":[{"a":37,"s":1},0],"n":{"ä":5,"e":105,"i":1,"s":25,"u":12},"r":{".":0,"e":[{"n":19},37],"s":{".":1}},"s":{"a":4},"u":0},73],"f":{"a":21,"ä":6,"e":{"i":6,"r":6},"f":{"e":{"n":{"d":46},"r":12}},"o":21,"r":6,"s":4,"t":{"e":{"r":12}}},"g":[{"a":84,"e":{"l":243,"n":{"e":5}},"g":84,"j":194,"l":[{"ä":5},13],"o":216,"r":84},78],"j":84,"k":{"a":{"r":6},"ä":6,"i":{"n":6},"n":6,"o":{"n":{"e":5},"p":2,"r":6}},"m":{"a":[{"g":6},77],"e":{".":6},"m":77,"p":84,"s":[{"c":12,"t":12},2]},"n":{"a":1,"b":{"e":71},"c":2,"d":{"u":93},"e":[{"i":48},3],"f":[{"o":2,"r":88},93],"g":[{"a":2,"l":{"e":25},"r":2,"s":{"p":25}},73],"h":93,"i":{"t":77},"j":84,"k":[{"l":2,"o":2,"r":2},84],"l":77,"n":{"e":{"n":{"m":209},"r":106},"r":93,"u":71},"q":321,"s":[{"i":12,"o":2,"p":{"i":89},"y":88},93],"t":[{"e":[{"n":{"t":26}},84],"r":{"e":59}},77],"v":[{"a":2},93],"z":77},"o":{"b":6,"n":82,"s":{"t":3}},"p":{"l":6,"o":1},"r":189,"s":[{"a":[{"n":1},2],"c":{"h":{"o":260,"w":5}},"i":{"k":78},"k":{"o":3},"o":82,"p":14,"r":82,"s":78,"t":[{"e":{"r":{"s":46}},"h":12,"r":25},14]},73],"t":[{"a":{"l":79,"n":{"t":4}},"i":2,"r":223,"t":{"a":[{"u":12},25],"e":{"r":{"f":351}},"o":12,"r":162},"u":[{"m":115},2]},73],"x":13},75],"í":75,"j":93,"k":[{"a":{"b":{"l":162},"h":0,"k":104,"l":{"l":0},"m":6,"r":{"e":0},"s":{"p":0},"u":{"f":{"s":19}}},"ä":{"h":104},"e":{"l":[{"e":{"m":89}},82],"n":[{"e":{"r":10},"s":{"t":159}},11],"r":{"l":117,"s":{"t":{"a":7}},"w":129},"s":79,"t":82},"i":{"m":0},"l":{"a":{"s":5,"u":5},"i":{"m":5,"s":73},"o":6,"u":6},"n":{"e":5},"o":{"b":73,"l":82,"n":82,"p":6,"r":{"i":32},"u":73},"ö":6,"r":{"ä":{"u":1},"i":[{"n":1},82],"o":{"m":86,"u":73}},"s":{"a":{"l":6},"e":{"i":6,"l":6,"r":6},"o":6,"p":6,"t":{"a":{"t":{"i":312}},"e":{"c":5},"o":{"c":5}}},"t":{"a":6,"e":{"l":6,"n":{"g":14,"t":5},"r":{"f":14,"g":5,"l":14,"s":[{"c":24},4],"w":14,"z":14},"t":{"a":5}},"i":[{"n":23},2],"o":[{"b":10},176],"r":[{"i":5},23],"u":{"m":6}},"u":{"m":{"s":0},"n":2,"p":82,"r":{"s":25},"s":[{"a":2},82]},"ü":{"b":73}},93],"l":[{"a":{"b":6,"g":82,"n":{"d":[{"i":277},140]},"r":104,"s":{"c":113},"u":{"g":86}},"e":{"a":2,"c":82,"i":{".":140},"p":82,"t":6,"x":82},"g":12,"i":[{"n":{"e":{".":12}},"s":2},79],"o":[{"u":48},79],"ö":[{"s":{"s":25}},6],"s":{"a":2,"p":{"r":6},"t":{"e":1,"o":38}},"t":1,"u":79,"y":82,"z":2},93],"m":[{"a":{"b":73,"d":104,"l":{"a":2,"d":0},"m":{"i":0},"n":{"k":104,"z":0},"p":{"h":128},"r":{"c":73,"z":73},"s":{"p":{"e":27},"s":{"e":25}},"t":{"o":22}},"ä":{"r":6},"d":3,"e":{"f":0,"i":{"n":{"h":128}},"n":{"a":12,"e":6,"t":73},"o":73,"r":{"f":{"o":10},"h":104,"l":104,"p":104,"w":104},"s":[{"t":13,"z":10},6],"t":{"a":105}},"i":{"d":{"e":73},"n":{"a":{"n":{"z":26}},"e":{"n":[{"g":26},102]}}},"n":89,"o":{"b":104,"n":{"s":159},"r":{"i":32},"s":13},"p":3,"s":{"a":1,"k":3},"t":[{"a":2},1],"u":{"n":[{"a":89,"i":73},2]}},189],"n":[{"a":{"b":2,"d":[{"e":5},82],"g":{"e":82},"l":{"l":104},"n":[{"d":5,"i":1,"z":73},12],"r":[{"e":1,"i":128},2],"s":{"t":114},"t":{"t":128},"u":[{"g":1},73]},"d":[{"e":1,"r":1},12],"e":{"f":89,"i":{"d":6,"f":89,"s":89},"m":{"a":0},"n":[{"e":104,"g":6},2],"p":296,"r":{"g":114,"h":{"i":5},"k":{"e":10,"u":10},"l":114,"t":114,"w":114,"z":89},"s":140,"t":[{"e":[{"m":12,"r":12},48],"o":12},232],"u":[{"f":4},6],"x":89},"f":1,"g":[{"e":{"n":{"e":102}}},3],"i":{"d":73,"n":[{"f":89},104],"t":82},"k":2,"n":2,"o":{"d":82,"h":6,"p":104,"r":104},"ö":[{"d":2},0],"s":{"a":1,"ä":3,"e":{"h":{"a":10}},"p":16,"u":2,"z":3},"t":{"a":3,"e":3},"u":{"r":0},"ü":71,"y":71,"z":2},84],"o":{"b":{"a":73,"j":77,"o":[{"r":36},75],"r":[{"e":6},77],"s":77},"c":[{"h":{"a":22},"k":{".":78}},0],"d":{"e":86,"r":12},"e":12,"f":{"f":77,"l":1},"g":{".":84,"a":3,"g":78},"h":{"i":{"n":21},"l":100,"n":84,"ö":6,"r":78},"i":[{"n":1,"r":0},75],"k":{"l":2},"l":{"e":1,"i":{"v":6},"l":{"a":{"n":12},"e":[{"r":{"g":26}},19],"s":105},"s":4,"y":77},"m":{".":84,"a":{"d":6,"l":6,"n":{".":78}},"b":77,"e":{"n":{"e":17},"r":21},"m":84,"n":77,"s":4,"t":84},"n":[{"a":{"b":16,"n":6},"d":78,"e":{"r":{"b":5}},"k":84,"n":78,"s":22,"t":{"a":{"n":12},"e":{"n":{"d":26}},"r":27,"u":11},"y":0},73],"o":{"f":32},"p":{"a":2,"e":77,"f":77,"l":75,"t":77},"r":[{"a":{"l":23,"t":6},"c":77,"e":{"l":6},"o":6,"t":{"h":4,"s":22},"ü":2},71],"s":{"h":1,"i":47,"k":{"o":12},"s":{"a":{"l":12,"n":12},"c":11,"e":{"n":{"k":26}},"t":12},"t":{"a":0,"r":450},"u":{"m":6},"z":106},"ß":[{"e":{"n":[{"k":5},105]},"i":6},84],"t":{"a":{"n":6,"s":5,"u":14},"ä":6,"e":{"i":168},"h":{"o":21},"r":{"u":6},"s":[{"o":22},4],"t":{"a":2},"u":1},"u":{"l":78,"n":{"t":1},"t":78},"x":127,"y":84},"ö":{"b":{"l":23},"d":{"u":6},"f":80,"h":78,"k":93,"l":[{".":77,"e":1,"l":2,"p":71},75],"m":{"i":78},"r":71,"s":{".":73,"c":13,"e":73,"l":75},"t":{"u":78}},"p":[{"a":82,"e":[{"r":{"i":{"n":25}}},82],"f":12,"l":{"i":73,"u":5},"o":82,"r":{"o":48},"s":{"e":1,"t":4},"t":128,"u":82},152],"q":93,"r":[{"a":{"b":6,"t":[{"s":22},5],"u":{"f":0}},"ä":{"m":0},"b":2,"c":0,"e":{"g":{"a":140,"i":140},"i":6,"l":{"e":2},"p":{"a":2},"r":[{"h":73,"l":73,"s":10},22],"s":82,"v":{"e":2},"z":{"i":89}},"h":{"e":{"n":79},"o":{"s":6}},"i":[{"k":37},124],"m":2,"n":{"a":{"u":4}},"o":[{"b":{"s":1},"m":4,"r":{"e":2}},6],"r":2,"s":{"t":[{"r":1,"u":1},6]},"t":{"h":6},"u":79,"ü":79,"z":2},189],"s":[{"a":{"b":{"o":82},"d":113,"l":6,"m":{"p":89,"t":114},"n":[{"f":89,"g":86,"m":1,"p":89,"t":1,"z":1},6],"r":[{"k":5,"m":89},1]},"c":{"h":{"e":{"b":358,"r":{"l":164}},"u":82}},"e":{"b":{"e":104},"e":2,"f":104,"i":{"n":73},"n":[{"d":6,"e":12},2],"p":{"i":73},"r":{"e":0,"h":73,"s":0,"z":73},"t":[{"a":0},2],"x":{"t":6}},"h":{"a":{"v":79},"i":{"r":82},"o":[{"r":6},82],"u":89},"i":{"l":6},"k":{"a":6,"e":{"l":6},"i":[{"r":89},6],"l":6,"o":{"r":89},"r":{"i":124},"y":89},"m":{"o":{"g":5}},"n":{"o":124},"o":[{"b":89,"m":5,"p":114,"r":{"i":{"e":89},"t":{".":128}},"s":[{"t":0},2]},82],"p":[{"a":{"n":82},"e":82,"h":86,"i":82,"l":82,"o":{"r":5},"u":{"t":73}},6],"s":3,"t":{"a":{"b":{"l":4},"d":82,"l":{"a":4,"e":89},"n":{"s":89,"t":89},"s":73,"t":{"i":452,"u":452}},"ä":82,"e":{"i":{"n":{"g":35,"t":265}},"m":{"i":4,"p":5},"r":[{"b":240,"l":4,"n":124,"w":4},105],"v":6},"h":21,"i":[{"e":124,"n":[{"g":4,"k":82},73],"p":73,"t":73},6],"o":[{"b":5,"l":5,"r":5,"t":89},82],"r":[{"a":[{"n":{"g":164}},82],"e":{"n":7}},5],"u":[{"c":5},6],"ü":124},"u":{"c":{"h":{"s":19}},"f":82,"m":{"s":6}},"y":82},451],"ß":71,"t":[{"a":{"b":{"o":73,"s":0},"c":{"k":2},"d":113,"e":86,"k":{"r":0},"l":{"b":{"e":128},"e":37,"l":104,"s":{"e":277}},"m":[{"e":6},0],"n":{"n":0,"t":0,"w":73},"r":104,"t":{"t":1},"u":{"t":73}},"ä":{"h":1,"n":{"d":0},"r":{"m":0}},"e":{"e":100,"h":82,"i":{"n":[{"d":5,"h":128},0],"s":453},"l":{"f":73,"s":{"t":19}},"m":{"o":73},"n":[{"a":12,"s":159,"t":{"s":128},"z":25},11],"o":22,"r":{"e":{"i":[{"g":164},1]},"f":{"a":278,"o":278},"h":0,"k":0,"l":{"a":344},"m":{"i":{"t":33}},"n":{"ä":128},"ö":97,"r":{"e":10},"s":[{"p":5},0],"z":0},"s":{"k":4}},"h":{"e":[{"l":73},0],"i":104,"u":{"m":6}},"i":{"d":104,"k":22,"m":{"a":104},"n":{"f":128},"s":6,"t":6},"l":1,"m":1,"o":{"b":104,"p":{"f":13},"r":{"c":0,"g":89}},"r":{"a":{"k":89,"m":{"s":1},"n":{"d":1},"t":{"i":1}},"e":{"c":1,"s":48},"i":{"s":128},"o":{"l":1,"m":{"a":1},"p":82,"u":73},"ü":{"c":22}},"s":{"c":1,"e":{"h":41,"l":2,"x":1},"i":{"n":{"g":4}},"o":13,"p":{"a":13},"t":{"a":{"n":14},"i":{"e":12}},"u":6},"t":16,"u":{"m":{"b":0},"n":{"a":23},"r":{"t":104},"t":[{"e":86},12]},"ü":82,"y":13,"z":3},189],"u":[{"a":[{"l":{"e":5},"r":216},0],"b":{"e":[{"n":[{"s":102},17]},10],"i":2},"c":{"h":{"t":{"s":149}},"k":{"e":{"r":{"l":24}},"u":6}},"d":{"e":{"a":22},"r":6},"e":{"t":6},"f":[{"a":21,"f":10,"s":2,"t":{"e":{"r":12}}},78],"g":{"r":23},"h":{"m":78,"r":93},"i":{"n":[{"s":1},78],"s":0},"m":[{"a":22,"d":106,"f":106,"g":106,"i":6,"l":106,"s":{"a":106},"w":106,"z":84},77],"n":{"a":93,"d":[{"a":99,"e":{"n":{"e":53},"r":27}},77],"e":[{"i":105},2],"f":189,"g":{"a":2,"l":77},"i":[{"o":82,"s":{".":5}},248],"k":{"r":2},"l":189,"m":93,"n":84,"r":84,"s":{"e":71},"t":106,"w":84},"p":{"d":77,"r":1},"r":[{"a":6,"e":21,"o":194},189],"s":{".":89,"i":6,"p":2,"s":{"p":11,"t":12},"t":6},"t":{"a":{"b":6},"e":[{"i":5,"l":41,"r":21},10],"o":176,"r":23,"s":{"c":{"h":{"a":26}}}},"z":[{"w":21},84]},75],"ü":[{"b":[{"u":84},77],"c":{"h":0,"k":{"e":{"l":5}}},"h":{"e":{"l":6,"r":105},"l":13},"m":{"m":84},"n":{"z":4}},75],"v":[{"e":[{"l":6,"n":{"e":[{"n":102},99],"t":{"z":89}},"s":4},82],"o":79},93],"w":[{"e":{"g":{"e":{"l":12}},"i":82,"l":{"t":{"s":19}},"r":{"k":140,"t":140}},"o":{".":73,"h":82,"r":{"t":82}},"u":{"n":{"s":25}}},93],"x":189,"y":[{"a":93,"c":6,"g":{"i":25},"l":{"a":0,"e":6},"o":{"s":0},"s":{"t":{"h":1,"i":132}}},75],"z":[{"a":{"n":[{"t":1},6],"r":73,"t":73},"ä":{"n":6},"e":{"n":{"e":140,"g":0,"t":{"s":89}},"p":2,"r":{"a":2,"d":104,"f":104,"g":104,"k":0,"l":104,"w":104},"s":{"s":104}},"i":{"d":0,"n":{"t":0},"r":25},"o":{"f":79,"t":86},"t":{"a":{"n":6},"e":1,"h":6},"u":{"g":{"l":27}},"w":{"ä":73,"e":{"c":79},"i":{"r":73}}},93]},"s":{"a":[{".":78,"a":88,"b":[{"ä":2,"d":84,"e":[{"t":78},6],"i":{"t":6},"l":6,"m":84,"o":{"r":6},"r":6,"s":106},93],"c":[{"c":84,"h":{"e":194,"o":6,"s":105,"t":25},"k":73},78],"d":{"a":93,"e":{"r":6},"m":71,"r":152},"f":{"a":78,"e":5,"f":106,"r":120,"t":[{"r":12},88]},"g":{"a":78,"e":[{".":194,"n":{".":194,"t":106}},2],"g":93,"i":{"o":6},"n":12,"r":72},"h":{"s":73},"i":[{"k":365,"l":22,"r":12},88],"k":[{"a":6,"e":2,"i":78,"k":84,"o":78,"t":84},93],"l":{".":88,"a":[{"n":23,"r":6,"t":1},200],"b":[{"l":4},88],"d":88,"e":{"r":{"k":5}},"i":[{"d":21},78],"l":[{"a":4,"e":{".":12}},71],"o":[{"r":4},187],"s":{"e":2},"t":[{"h":196},71],"z":78},"m":[{"a":{"t":248},"e":{"i":248,"n":73},"i":{"n":6},"m":[{"a":451},194],"n":189,"p":[{"h":84},454],"t":{"a":12,"o":12,"s":{"t":25}}},78],"n":[{".":73,"a":[{"t":12},161],"ä":6,"b":76,"c":289,"d":[{".":89,"a":{"n":12},"r":{"i":27},"s":25},88],"e":{"r":6},"g":{".":78,"a":84},"h":76,"i":78,"k":{"e":{"n":78}},"l":76,"o":80,"p":76,"s":[{"e":89,"k":12,"p":4},76],"t":{"e":{"i":84},"r":106},"w":106,"z":77},71],"p":[{"e":6,"h":73,"p":4,"r":78},93],"q":93,"r":[{".":147,"a":78,"b":106,"d":88,"e":[{"a":82},73],"g":[{"a":2},78],"i":{"n":1},"k":73,"o":{"m":6},"s":73,"t":84,"u":176},93],"s":{".":78,"a":2,"c":71,"i":115,"p":205,"t":{"u":2},"y":139},"t":{"a":[{"n":[{"t":14},19]},2],"e":{"i":13,"m":134},"h":82,"i":187,"l":106,"m":84,"o":[{"l":5},2],"r":6,"s":1,"t":{"a":82,"r":106},"z":[{"a":194,"e":{"l":12,"n":27}},78]},"u":[{".":78,"c":78,"e":187,"f":[{"b":106},77],"g":[{"l":{"e":25},"r":2},78],"m":78,"r":[{"i":132},78],"s":[{".":78,"b":106,"f":106,"g":84,"p":2,"s":84,"t":{"e":78},"w":106},77],"ß":77},71],"v":[{"e":6},71],"x":{"i":6},"y":21},75],"ä":[{"b":78,"c":88,"g":88,"h":[{"n":106},71],"l":[{"t":189},78],"m":93,"n":{"d":106},"p":106,"q":77,"r":[{"g":88},93],"t":88,"u":{"l":78,"ß":84}},75],"b":[{"a":{"n":{"e":12},"u":{"m":{"e":{"n":33}}}},"e":{"r":{"e":22}}},309],"c":[{".":77,"a":{"b":77,"c":77,"l":77,"m":77,"r":77,"t":77},"e":[{"i":106},93],"h":{".":84,"a":{"l":147,"n":{"a":4,"c":84,"g":84},"o":84,"r":{"a":84,"m":455}},"ä":[{"q":77},73],"b":84,"c":84,"d":77,"e":[{"c":{"h":84},"f":[{".":221,"i":221,"s":221},22],"i":[{".":98,"n":{".":26}},89],"m":{"a":89,"p":84},"r":{"f":{"ü":35},"l":{"a":35}},"s":[{"s":84},78],"x":84},2],"f":77,"g":77,"h":77,"i":{"d":10,"e":10,"r":{"u":84},"s":78},"k":77,"l":[{"a":{"c":12,"g":12},"e":{".":84,"i":{"n":221}},"o":{"c":84},"ö":{"c":84}},89],"m":{"a":{"s":84},"e":{"d":84},"ö":77,"ü":{"h":84},"y":77},"n":{".":77,"e":{"b":84}},"o":{"b":{"j":84},"r":{"c":84}},"ö":{"r":84},"p":84,"q":77,"r":{"a":{"d":84},"e":{".":84},"i":{"n":84,"s":106},"o":{"m":4,"n":84,"u":84}},"s":[{"e":22,"k":37,"t":{"i":10}},84],"t":[{"a":22,"i":22},98],"u":[{"n":{"t":84}},89],"v":77,"w":{"e":{"b":12,"g":84,"r":{"k":221},"t":84},"i":{"d":84},"u":78},"z":77},"j":77,"l":106,"o":[{"a":84,"p":456},76],"r":{"e":{"m":10}},"s":77,"u":77,"y":77},75],"d":[{"a":{"m":{"e":4}},"e":{"s":100},"i":{"e":{"n":{"e":19}},"s":{"t":13}}},243],"e":[{".":78,"a":{"t":{".":1}},"b":[{"ä":78,"e":{"n":152}},2],"c":{"h":{"o":93,"s":{"t":10},"t":93},"k":152},"d":{"i":{"k":6}},"e":[{"i":[{"g":4},100],"l":[{"e":{"n":4}},6],"n":{".":1,"e":37,"p":1},"r":{".":1,"a":13,"e":22,"f":0,"i":365,"k":0,"s":0},"s":9},78],"f":{"f":76,"l":12},"g":[{"a":{"l":243},"l":6,"r":12},88],"h":[{"a":[{"g":6,"k":6},13],"e":{"l":6,"r":{"e":19,"k":5}},"i":{"n":21},"l":4,"ö":14,"r":{"a":4,"e":4,"i":136},"s":13,"ü":{"b":6}},78],"i":{".":77,"c":93,"d":{".":93,"a":4},"f":{"e":{"r":106}},"g":93,"l":78,"m":73,"n":[{".":252,"b":77,"d":{"u":10},"e":[{"i":17},155],"f":{"l":84,"o":10},"g":77,"h":76,"i":77,"k":77,"l":77,"n":[{"e":10},77],"r":76,"s":{".":89,"c":84,"p":84,"t":{"i":{"t":30},"r":33}},"t":[{"o":10,"r":84},77],"w":77,"z":76},71],"s":[{"m":88},93],"t":[{"s":22},88]},"k":[{"e":{"l":248},"z":84},78],"l":{".":73,"a":21,"b":88,"d":9,"e":{"c":13,"f":6,"g":161,"k":{"t":{"r":221}},"m":77,"r":[{"s":4},6]},"f":{".":77},"i":{"n":{"s":19},"t":79,"x":93},"l":73,"o":{"b":6},"s":[{"z":4},73],"t":{"e":22},"z":22},"m":{"e":2,"i":{"s":152},"p":76},"n":{".":89,"a":[{"d":5,"l":1,"s":5,"u":4},78],"ä":6,"b":73,"d":{"l":189,"r":9,"w":71},"e":{"n":132,"r":{"g":84,"s":5}},"f":73,"i":[{"d":6,"m":21},147],"k":[{"e":{"l":{"i":26}}},88],"o":[{"t":{"t":5},"z":5},6],"s":[{"a":73,"e":{"h":199,"m":84},"i":[{"d":363},89],"t":[{"u":{"r":{"m":67}}},105]},78],"t":{"a":22,"ä":4,"d":77,"f":84,"g":77,"l":{"a":84},"n":77,"o":73,"r":4,"s":189,"w":[{"u":84,"ü":84},77],"z":84},"u":315,"z":{"a":4,"e":{"r":12},"w":4}},"o":{"r":2},"p":{"e":{"n":6}},"q":78,"r":{".":89,"a":{"d":118,"l":4,"n":{"d":1}},"ä":{"u":{"s":4}},"b":[{"e":{".":82}},22],"d":22,"e":{"b":125,"i":{"e":1,"g":{"n":221},"m":14,"n":5},"m":22,"n":[{"k":14},252]},"f":{"e":89,"o":71,"r":73,"ü":[{"l":84},82]},"g":[{"a":4,"l":4,"r":73},22],"h":[{"ö":77},71],"i":[{"e":194},78],"k":10,"m":{"i":{"t":106}},"n":{".":73,"e":{"u":82},"t":76},"o":{"b":10,"s":152,"t":71},"ö":[{"f":77},71],"s":{".":73,"a":77,"e":{"h":[{"n":26},84],"t":225}},"u":[{"h":5,"m":2,"p":124},1],"v":457,"z":71},"s":{".":147,"a":16,"e":{"l":6},"k":1,"s":{"a":93},"t":{"a":0,"e":{"c":1,"i":1,"m":{"p":7}},"r":{"i":25}},"u":1},"t":{"a":{"p":309,"t":6},"h":152,"i":[{"k":248},2],"z":78},"u":{"c":78,"l":93,"m":10,"n":32},"x":[{".":78,"a":77,"e":[{"n":4},6],"i":73,"o":73,"p":84,"t":{"r":9},"z":77},71]},75],"é":75,"f":[{"a":{"l":{"l":{"e":{"r":58}}}}},309],"g":[{"a":{"n":{"g":19}},"e":{"s":{"a":4},"t":35}},309],"h":[{".":84,"a":[{".":78,"l":{"l":{"i":10},"t":[{"s":19},105]},"n":84},6],"ä":82,"e":6,"i":[{".":78,"p":73,"r":12},6],"n":1,"o":{"c":106,"f":106,"m":84,"p":78,"r":{"e":12},"w":147},"ö":106,"r":389,"s":84,"u":82},93],"i":[{".":78,"a":{"c":{"h":{".":1}},"t":77},"c":[{"h":{"a":6}},458],"d":{"e":{"a":93,"e":77,"o":93,"r":1},"o":86,"y":77},"e":[{"b":{"u":2},"g":{"e":{"s":19}},"n":[{"e":1},25],"r":{"r":0}},147],"f":120,"g":[{"a":125,"e":{"i":21},"n":12,"r":23,"s":{"t":12}},147],"k":{"a":{"b":21,"k":6,"r":6},"ä":21,"e":{"l":21,"n":{"s":5},"r":{"l":4}},"i":[{"n":132},23],"n":23,"r":23,"s":4,"t":37,"u":6},"l":{"b":[{"r":2},78],"e":2,"i":78,"l":71,"o":78},"m":{"m":93,"s":{"t":12},"u":78},"n":{"a":16,"d":93,"f":[{"e":106,"o":{"r":82}},93],"g":{"a":48,"l":{"e":9},"r":162,"s":[{"a":25,"o":25},105]},"h":93,"i":[{"e":48},311],"k":73,"n":{"e":{"r":102},"o":93},"q":189,"s":[{"o":84,"t":84},93],"t":93,"v":189},"o":{"n":10},"r":{"n":10,"r":77,"u":78},"s":{"a":[{"m":5},6],"c":[{"h":{"u":5}},73],"e":125,"i":6,"o":[{"r":13},72],"p":23,"s":9,"t":147,"u":6},"t":[{"a":{"l":6,"u":6},"r":{"a":6},"u":2},88],"v":{"a":6,"e":[{"r":[{"f":14},105]},25],"i":{"n":6},"o":[{"r":6},184]},"z":2},75],"í":75,"j":106,"k":[{".":84,"a":[{"b":106,"d":82,"l":{"k":84,"t":82},"m":106,"n":{"a":84,"ä":84,"d":{"a":78},"n":84},"p":84,"r":106,"s":106,"t":{"e":{".":12,"g":84,"s":12},"o":12},"u":84},5],"ä":106,"b":84,"e":{"l":{"i":2},"n":84,"p":78,"r":84,"t":106},"h":82,"i":{".":88,"f":88,"k":88,"m":82,"n":82,"s":[{".":73},13],"z":78},"l":[{"a":{"s":106,"v":88},"u":106},5],"n":398,"o":{"h":84,"l":84,"m":84,"n":106,"p":{".":78,"r":2},"s":84,"w":84},"ö":106,"r":[{"a":106,"e":82,"o":106},5],"s":84,"t":[{"o":22},181],"u":{"l":{"p":78},"n":84,"s":11},"ü":84,"v":84},152],"l":[{"a":[{"b":82,"l":78,"m":{"a":2},"v":{"e":2},"w":73},5],"ä":82,"b":1,"e":[{"r":{"s":25}},106],"i":[{"p":147},82],"o":{"b":{"e":4},"c":82,"g":{"a":89},"w":88},"y":82},152],"m":[{"a":{"b":9,"s":{"c":4}},"e":{"n":{"a":4}},"i":{"t":162}},309],"n":[{"a":{"b":10},"i":{"a":12,"e":{"r":{".":4,"s":4}}},"o":{"t":214}},161],"o":[{".":78,"a":{"s":76},"b":[{"a":193,"j":84,"o":106},152],"c":0,"d":{"i":6,"o":6},"e":{"t":1},"f":{"e":152,"f":{"i":77},"t":78},"g":[{"l":12},78],"h":{"e":72,"l":[{"e":105},78],"n":{"g":76},"r":93},"i":[{"d":1},187],"k":76,"l":{".":78,"a":[{"u":5},1],"d":78,"e":[{"i":21},78],"i":1,"l":{"a":2,"e":{"r":12}},"o":3,"y":243},"m":{"m":78},"n":[{"a":[{"u":4},2],"e":22,"g":{"l":12},"s":{"ä":4,"o":11}},88],"o":1,"p":{"e":77,"f":93,"r":78,"s":4},"r":{"d":106,"e":[{"i":6,"l":6},22],"g":{"a":189},"h":0,"i":{"e":152},"o":6,"p":78,"t":{"i":88},"u":5},"s":[{".":73,"k":398,"m":84,"t":228,"z":189},78],"ß":87,"t":[{"h":3,"t":78},77],"u":{"n":[{"d":[{"s":1},132],"t":1},22],"t":93},"v":78,"w":78,"x":152,"z":[{"e":71},78]},75],"ö":[{"c":6,"d":152,"f":80,"k":93,"l":93,"s":93},75],"p":[{".":77,"a":{"a":84,"c":{"e":73,"k":77},"g":77,"k":77,"l":{"a":77,"ä":77,"t":78},"m":2,"n":{".":73,"n":{"u":78},"s":73,"t":78,"z":77},"p":77,"r":{"a":76,"o":77,"t":{"e":{"n":376},"n":84,"y":84}},"ß":78,"t":{".":78,"i":77,"r":84},"u":77,"z":88},"ä":[{"d":77,"h":78,"r":77,"s":77},73],"e":{".":76,"g":77,"i":{"n":84},"n":{"s":{"i":84}},"p":9,"r":{"a":73,"g":88,"i":71,"l":{"e":84},"o":77,"r":73,"s":77,"ü":77},"t":84,"z":147},"f":250,"h":{"a":77,"ä":[{"r":78},73],"e":82,"i":{"n":89}},"i":{"e":[{"r":[{"r":19},84]},459],"k":2,"l":106,"o":78,"p":106,"s":106},"l":[{"a":84,"ä":106,"e":[{".":7},84],"i":88,"u":106},372],"n":76,"o":{"d":77,"e":84,"g":77,"i":73,"k":106,"l":84,"n":{"s":73},"o":84,"p":77,"r":{"e":73,"n":88,"t":{"a":{"g":33}}},"s":106,"t":{"e":84}},"r":{".":84,"a":{"c":88,"k":77,"x":77},"ä":{"m":77,"s":84},"e":{"c":147,"d":84,"i":{"s":84},"n":403,"s":76},"i":{"c":73,"n":{"g":78,"z":84}},"o":{"b":77,"g":77,"j":84,"p":84,"s":{"s":78},"t":77,"z":77},"ö":78,"u":88,"ü":{"c":78,"f":77,"n":78}},"s":106,"t":460,"u":{"b":77,"d":77,"k":78,"l":{"e":88},"n":77,"p":77,"r":[{"e":{"r":12}},147]},"y":77},227],"q":93,"r":[{"a":{"t":{"s":22}},"e":{"c":{"h":{"a":4}},"l":{"i":132}},"o":{"h":2},"ö":{"s":2},"ü":{"c":{"k":{"e":{"r":312}}}}},309],"s":[{"a":{"b":{"i":1,"o":4},"c":{"k":140},"g":{"i":5},"j":0,"l":[{"b":{"a":1},"l":89},82],"m":{"t":89},"n":{"f":73,"g":89,"o":89,"s":89,"t":6,"z":89},"r":{"a":6,"g":6,"s":82},"s":13,"t":{"t":86},"u":{"e":25,"r":10}},"ä":79,"c":{"e":89,"h":[{"a":{"n":{"k":{"e":{"r":416}}}},"w":82},22],"o":89,"r":73},"e":{"a":4,"c":0,"e":{"c":13},"h":{"a":22},"i":{"n":[{"d":5,"t":4},73]},"l":{"ö":2},"n":[{"k":{"e":{"l":33}},"s":{"e":{"m":33}}},82],"p":{"e":0},"r":{"a":{"t":{"t":26}},"e":{"i":{"g":7}},"g":{"r":5},"h":{"ö":10},"m":{"i":{"t":33}},"ö":{"f":10},"s":{"e":1},"u":5,"w":{"e":{"i":33}}},"s":{"s":{"a":10},"t":{"r":128}},"t":[{"a":4},82]},"i":[{"k":{"o":3},"l":{"l":89},"m":{"p":89},"n":{"d":89,"f":89,"g":{"s":17},"t":89},"s":{"r":114}},82],"k":{"a":{"l":{"a":82}}},"l":1,"m":{"u":{"t":19}},"o":{"f":{"f":0},"i":10,"l":82,"p":89},"p":{"e":{"n":6},"h":{"i":6},"i":82,"r":{"ä":82,"i":82,"o":73}},"q":{"u":{"e":{"t":102}}},"s":[{"a":{"u":19}},16],"t":{"a":[{"d":82,"g":89,"k":1},2],"ä":82,"e":[{"l":82,"p":79,"r":{"n":124},"u":5},2],"i":[{"e":6,"n":23},2],"o":{"f":82,"p":82},"ö":{"r":5},"r":{"a":{"n":82,"s":5,"t":124},"e":{"c":82},"o":{"m":82},"ö":82},"u":{"r":6},"ü":82},"u":{"m":{"g":73,"r":73},"r":6},"y":82},451],"t":[{".":84,"a":[{".":77,"a":78,"b":{".":78,"b":77,"e":{"l":84},"i":{"t":84},"l":77,"t":84},"c":6,"d":{"t":75},"f":{"f":75},"g":[{"l":78,"r":147},77],"h":147,"k":[{"s":78},77],"l":{"a":[{"k":4},77],"b":77,"i":328,"k":77,"p":0,"r":0},"m":{"i":0,"m":75},"n":[{"b":77,"d":164,"f":77,"g":6,"l":77,"m":89,"n":228,"o":89,"s":{"p":1},"w":77},75],"p":{"o":[{"s":102},291],"p":0},"r":{".":89,"e":{"n":{"s":26}},"i":84,"k":89,"s":461,"t":89},"s":{"i":{"e":12},"t":19},"t":{".":82,"b":77,"i":[{"s":89},78],"t":{"h":462}},"u":{".":89,"f":77,"r":147,"s":{"b":84,"g":84,"r":84,"s":84},"t":89},"v":{"e":296},"x":84},73],"ä":[{"b":78,"d":78,"g":84,"p":84,"r":252,"t":{"t":78},"u":{"s":76}},85],"b":77,"c":107,"d":77,"e":{".":214,"a":{"m":84},"c":{"h":{"n":84}},"d":[{"i":0},289],"e":77,"g":[{"r":162},88],"h":75,"i":[{".":5,"c":84,"d":0,"g":[{"r":10},78],"l":77,"n":{"a":10,"g":{"a":221},"s":[{"p":15},89]}},73],"l":[{".":77,"b":0,"e":82,"f":82,"l":[{"ä":{"n":58}},6],"n":77,"s":77},73],"m":[{"a":{"r":12},"e":{"n":{"t":26}},"m":78},77],"n":[{".":140,"a":12,"d":{"s":128},"s":413,"t":{"f":89,"s":89}},77],"p":{"o":32},"r":[{".":214,"a":162,"b":{"e":{"n":164},"o":78},"e":{"n":82,"o":78},"f":{"ü":1},"i":{"l":78},"m":84,"n":{"b":147},"z":{"o":10}},77],"s":[{"c":4,"s":{"e":10},"t":{"n":89}},463],"t":[{"a":{"b":12,"g":12},"i":88,"t":147},77],"u":[{"e":75,"f":84,"n":1},88],"v":0,"w":73,"x":[{"a":73},84]},"f":77,"g":77,"h":[{"e":{"n":6},"i":104,"o":1,"u":73,"y":0},77],"i":{"a":77,"b":77,"c":[{"h":75},73],"d":32,"e":{".":77,"f":{".":84,"l":84},"n":77},"f":85,"g":[{"e":{"l":12},"m":147},77],"k":76,"l":218,"m":[{"m":[{"a":84},78],"p":77},85],"n":{"b":0,"f":207,"n":82,"s":73,"t":74},"o":77,"p":{".":77,"p":77},"r":[{"a":0,"i":0,"o":0},289],"s":84,"t":{"e":77,"u":75},"v":77},"j":77,"k":77,"l":[{"e":1},84],"m":77,"n":77,"o":[{".":77,"b":{"l":2},"c":{"h":{"t":84}},"d":[{".":84},77],"f":[{"f":89},75],"k":77,"l":{"e":84,"l":89},"m":{"i":4},"n":[{"a":84,"e":464,"l":84},76],"o":84,"p":{"o":77},"r":{".":84,"b":89,"e":77,"f":77,"g":207,"i":77,"p":77,"s":77,"t":77},"s":{"t":22},"ß":75,"t":{"e":84,"r":77},"u":84,"w":77,"z":77},73],"ö":[{"c":{"h":84},"l":76,"n":77,"r":78,"t":77},85],"p":77,"q":77,"r":[{"a":{"c":77,"d":[{"e":5},106],"f":{"a":10},"g":106,"h":[{"i":84},78],"i":84,"k":84,"l":255,"n":{"k":82,"s":84},"p":75,"s":78,"ß":78,"u":{"m":84}},"ä":{"c":84,"g":214,"n":{"e":84}},"e":{".":77,"a":89,"f":84,"i":{"b":84,"f":465},"p":77,"t":77,"u":{"h":84}},"i":{"b":77,"e":{"s":149},"g":207,"k":236,"s":255},"o":[{"c":82,"g":82,"h":147,"m":{"e":89},"p":{"f":84},"s":[{"s":5},77]},75],"ö":{"p":77},"u":[{"a":77,"b":77,"d":89,"k":78,"n":77,"p":84,"t":77},75],"ü":75},73],"s":[{"i":{"d":10},"t":12},466],"t":223,"u":[{"b":75,"c":{"h":84},"d":147,"e":77,"f":78,"g":[{"a":1},77],"h":78,"k":86,"m":{"o":77,"s":[{"c":10},154],"t":77},"n":{".":77,"a":1,"d":194,"e":77,"g":77,"i":86,"n":84,"s":77,"t":77},"ö":77,"r":{"a":4,"e":35,"l":107,"n":84,"t":107,"z":88},"s":77,"t":85},6],"ü":{"c":[{"h":84,"k":147},75],"h":78,"r":{".":84,"e":84,"z":78},"t":[{"c":77},75]},"v":77,"w":[{"o":{"r":105}},77],"y":[{".":84,"l":85,"p":84,"s":84},77],"z":173},71],"u":[{"a":{"n":0},"b":[{"a":5,"i":84,"r":5},467],"c":[{"h":{"a":6,"o":6}},304],"d":78,"e":{"b":6},"f":[{"i":1},152],"h":93,"i":{"s":0,"t":{".":0}},"k":6,"l":{"i":3,"t":{"a":78}},"m":{"a":[{"n":6,"r":6},13],"e":[{"i":6,"l":6,"n":{"t":[{"s":24},102]},"t":21},88],"f":76,"i":{"d":21,"n":6},"m":88,"o":[{"r":6},100],"p":73,"s":[{"a":82,"e":77,"p":73,"t":76},71],"w":{"a":76}},"n":[{".":78,"a":93,"d":{"e":{"r":[{"h":46},102]}},"e":5,"f":93,"g":{"e":{"n":{"a":221}},"l":77,"s":10},"i":189,"m":93,"s":[{".":89,"t":89},93],"t":77,"w":[{"a":89},77]},6],"p":[{"d":84,"p":9},78],"r":{"a":6,"e":[{"i":6,"r":6},10],"f":78,"k":93,"o":21,"s":77,"t":71},"s":[{"a":3,"e":13,"i":4},6],"t":[{"e":5,"r":1},79],"v":78,"z":2},75],"ü":[{"b":372,"c":78,"d":[{"e":{"n":19}},21],"f":78,"n":78,"s":88,"ß":78},75],"v":[{"o":{"r":{"a":{"n":102}}}},243],"w":[{"e":[{"g":{"e":{"r":{"s":26}}},"h":22},106],"i":{"e":84,"l":84,"n":{"k":84},"s":84,"t":84},"ü":82},93],"y":[{"l":[{"o":6,"u":6},137],"m":4,"n":[{"d":78,"o":5},23],"s":468},236],"z":[{"a":106,"ä":84,"e":{"i":106,"l":84,"n":{"a":88,"e":469,"t":84},"r":84,"s":73,"t":84,"u":84,"w":88},"i":{"e":106},"o":106,"s":82,"u":106,"ü":106,"w":84},152]},"ß":{"a":134,"ä":93,"b":205,"c":93,"d":152,"e":[{"b":152,"c":93,"f":93,"g":152,"i":93,"k":93,"l":{"a":6,"e":[{"k":77},6]},"m":{"p":93},"n":{"a":315,"e":{"r":{"g":84}},"i":6,"k":{"e":71},"o":6,"t":{"e":88,"z":77}},"p":152,"r":{"b":4,"e":{"i":2},"l":{"a":2},"s":{"e":470},"t":4,"w":71},"s":{"s":321,"t":{"r":245}},"x":93},75],"f":205,"g":[{"e":{"b":{"l":2}}},161],"h":93,"i":[{"g":{"a":125,"s":12},"k":161,"l":93,"m":93,"n":93},75],"j":93,"k":134,"l":[{"e":{"r":{"s":25}}},93],"m":[{"u":{"t":10}},93],"n":161,"o":[{"s":2},161],"ö":152,"p":152,"q":71,"r":[{"ö":2},161],"s":[{"a":{"u":10},"c":{"h":22},"t":2},134],"t":[{"i":{"n":0},"ü":82},93],"u":{"m":93,"n":{"f":71,"t":77}},"ü":205,"v":93,"w":93,"z":161},"t":{"a":[{".":78,"a":[{"n":194},84],"b":{".":84,"a":[{"n":23},78],"b":93,"d":84,"e":{"l":78,"n":77},"f":77,"g":77,"h":77,"i":{"t":161},"k":77,"l":{"a":77},"m":84,"n":76,"r":372,"s":[{"t":71},84],"t":76,"u":78,"w":84,"z":84},"c":[{"h":{"s":84},"u":78},93],"d":{"a":71,"d":77,"e":{"r":6},"i":[{"o":441},25],"m":71,"o":{"l":6},"r":152,"s":3,"t":[{"r":12},84]},"e":{"r":6},"f":{".":78,"e":[{"t":84},78],"f":84,"g":71,"r":71},"g":[{"a":6,"e":{"i":125,"n":{"t":82},"s":22},"g":189,"l":220,"o":248,"s":{"a":{"n":12},"c":25,"t":12}},78],"h":[{"l":{"s":{"t":19}}},2],"i":{"k":3,"l":11,"n":{"s":0},"r":[{".":0},12],"s":32},"k":{"a":152,"e":{"s":1},"k":93,"r":{"o":6},"t":{"o":294,"u":73},"z":77},"l":{".":88,"a":[{"d":1,"g":1,"u":4},6],"b":{"r":78},"d":10,"e":[{"n":[{"d":14,"g":4,"s":14},2],"r":[{"g":260},105],"t":6},78],"g":{"a":2},"i":{"e":{"n":{"e":33}}},"l":{"a":{"c":27},"e":{"i":25},"ö":453,"s":266},"m":{".":93},"o":[{"p":6,"r":125},78],"t":{"a":71,"h":4,"r":10},"u":6},"m":[{".":78,"e":[{"n":73,"r":72},78],"i":6,"m":{"a":48,"e":{"r":27}},"p":{"l":71},"s":78,"t":189},77],"n":{"a":[{"b":4,"l":84,"t":5},72],"ä":152,"b":77,"c":78,"d":{"a":{"r":9},"r":162,"s":{"t":10}},"e":{"r":{"f":5}},"f":84,"g":[{".":78,"e":{"h":82},"o":73,"r":{"a":12}},93],"h":[{"o":73},77],"i":89,"j":78,"k":[{"l":2,"r":84},78],"l":106,"m":71,"n":{"a":93,"e":88},"o":[{"m":77},71],"p":77,"s":[{".":73,"i":84},71],"t":{"a":{"n":12},"e":{".":89,"i":84},"r":77},"w":{"a":77,"ä":77},"z":{".":73,"a":71,"e":{"i":84},"k":78,"r":78,"u":93,"ü":77,"w":11}},"o":[{"r":1},2],"p":{"e":[{"s":6},89],"f":77,"l":6,"o":{"k":{"a":5}},"p":{"e":73}},"r":{"a":[{"b":[{"b":78},77],"k":1,"l":471,"m":77,"p":4,"s":1,"u":73},6],"b":[{"a":78,"e":{"k":78,"r":78},"i":78,"l":326},77],"c":[{"h":{"l":78,"r":78}},77],"d":88,"e":{"l":6,"r":21},"g":4,"h":32,"i":78,"k":[{"l":472,"o":88},77],"l":73,"m":[{"ä":73},93],"o":{"m":6,"t":77},"t":[{"a":88,"e":{"i":78,"r":{"e":351},"x":78},"h":88,"i":[{"s":147},71],"o":12,"r":2,"y":78},77],"u":6,"z":[{"t":77},71]},"s":{".":88,"a":3,"c":78,"p":189,"s":{"i":76},"t":[{"e":{"m":12},"o":12},78],"y":73},"t":{".":89,"a":{"b":36,"n":6},"b":78,"e":[{"i":13,"l":413,"m":6,"n":78,"r":21},89],"l":76,"o":{"m":77},"r":80,"s":{"a":78},"t":77},"u":{"b":{"a":11,"h":78,"l":2,"r":162},"c":{"h":{"s":[{"p":54},102]}},"d":84,"f":[{"e":{".":78},"k":84,"l":[{"i":9},106],"m":84,"o":299,"p":84,"s":105,"w":84},93],"g":[{"e":106},78],"k":71,"m":{"e":78},"s":{"b":189,"c":[{"h":{"a":26,"m":26,"r":26,"w":26}},78],"d":77,"e":97,"f":189,"g":106,"k":71,"l":84,"r":77,"s":106,"ü":77,"w":255,"z":106},"u":84},"v":[{"a":[{"n":6},84]},78],"x":[{"t":189},78],"z":78},75],"ä":[{"ä":77,"b":84,"c":0,"d":84,"f":73,"g":[{"ä":84,"y":84},78],"h":77,"l":{"l":84,"t":93},"m":[{"t":71},139],"n":{"g":{"s":71},"z":78},"p":189,"q":77,"r":{"e":{"n":{"g":5}},"u":6,"z":77},"s":6,"t":[{"i":{"g":{"k":78}},"t":84},73],"u":{"g":77,"ß":77},"x":77},75],"à":75,"b":[{"a":{"u":{"e":{"r":102}}},"e":{"r":{"e":22}},"l":{"o":{"c":{"k":{"e":{"n":62}}}}},"y":{"t":12}},309],"c":[{"h":{"a":82,"e":82,"i":2,"l":4,"r":82,"u":447,"w":13},"k":89,"l":82,"o":{"r":22},"r":82},189],"d":[{"a":{"r":{"m":163}},"u":{"n":22}},243],"e":[{".":78,"a":[{"b":1,"c":4,"g":1,"k":77,"l":1,"m":78,"n":1,"r":1,"s":12},232],"b":{"a":78,"b":89,"e":{"n":152}},"c":{"h":[{"d":77,"e":77,"k":77,"m":77,"n":78,"t":77,"u":6},73],"k":[{"e":{"r":1},"i":6},77],"u":93},"d":{"i":{"t":6}},"e":{"m":0,"n":48,"r":{".":6,"w":0},"s":6},"f":{"a":78,"f":77},"g":{"g":93},"h":[{"a":[{"c":6},78],"ä":78,"i":[{"m":6},78],"ö":78,"r":71,"u":1},77],"i":{".":78,"c":78,"f":{"l":13},"g":{"n":77},"k":10,"l":[{"e":{"n":{"t":26}}},88],"m":22,"n":[{"e":{"n":[{"s":26},102]},"h":{"a":{"b":33}},"k":{"ü":82}},77],"s":{".":93,"b":71,"c":{"h":{".":7}}},"t":10,"w":71,"z":4},"k":{"e":{"l":6},"o":78,"t":10},"l":{".":78,"a":[{"b":4,"c":13,"n":[{"t":5},1],"u":13},215],"ä":6,"b":[{"r":78},10],"d":391,"e":{"c":13,"h":{"r":4},"m":77,"n":{"g":4},"r":6,"s":25,"u":6},"f":{".":106},"g":78,"h":78,"i":{"n":13,"t":6},"k":78,"l":{"e":[{"i":{"n":26}},4],"i":4,"u":84},"n":78,"o":{"b":6,"m":1,"s":{"t":5}},"ö":21,"p":78,"s":[{"k":37},78],"t":[{"a":4},472],"w":78},"m":{".":78,"a":[{"n":6,"p":21,"u":6},88],"b":{"o":108},"e":{"i":21,"r":21},"i":[{"m":37,"n":{"g":4}},6],"m":77,"o":[{"r":100},6],"p":{"e":{"r":78},"f":[{"i":84},77]},"s":119,"u":[{"n":5},6]},"n":[{".":164,"a":[{"d":5,"n":14,"r":4,"s":5,"t":5,"u":4},100],"ä":23,"d":{"a":[{"l":106,"n":10,"p":84},4],"f":214,"l":189,"o":164,"p":214,"r":9},"e":{"b":125,"f":6,"h":6,"i":[{".":16,"d":19},4],"m":10,"n":[{"d":14,"e":5,"g":5,"s":5},132],"r":{"g":106,"n":14}},"f":10,"g":{".":189,"a":[{"g":12},22],"l":{"a":106}},"i":[{"l":5,"m":13,"n":14},6],"k":10,"n":37,"o":{"l":6,"s":6},"ö":1,"s":{"e":{"m":473},"p":22,"t":{"h":25}},"t":{"b":71,"d":84,"l":106,"n":106,"s":71,"w":214,"z":84},"z":[{"e":{"r":27}},73]},78],"o":{"f":2},"p":{".":77,"i":152,"p":{"u":77},"t":22},"r":{".":147,"a":[{"c":37,"d":6,"l":[{"g":4},0],"n":{"e":16},"p":23,"s":10},89],"b":{"o":{"s":84},"s":93,"t":93},"c":78,"d":{"e":{".":106},"s":37},"e":{".":78,"b":125,"c":6,"i":{"g":82},"k":7,"m":[{"a":5},432],"n":{"d":14,"e":5,"g":5,"t":[{"h":54},14]},"o":77,"r":[{"k":[{"u":15},17],"l":17,"p":14,"s":5,"w":5},78],"s":78},"f":{"r":89},"g":[{"a":4,"e":{"b":{"n":221},"m":164,"s":164,"w":164},"l":4,"r":{"e":{"i":221},"u":89}},22],"h":{"a":{"l":{"l":164},"u":164},"ä":{"u":89},"e":{"i":89},"i":474,"o":73,"ö":{"h":{"u":221}},"u":73},"i":{"a":1,"i":84,"k":{"o":4},"l":77,"o":10,"t":[{"a":10},23]},"k":{"l":{"ä":84}},"l":{"ä":89,"i":89,"ö":{"s":12}},"m":78,"n":{".":73,"a":{"r":12},"c":475},"o":[{"b":[{"e":12},0],"s":77},89],"ö":285,"p":89,"r":{"a":89,"e":{".":12},"o":89},"s":{".":89,"e":73,"t":{".":89,"a":{"d":164,"t":26},"ä":89,"i":89,"r":89,"u":89,"ü":89}},"t":[{"a":4,"r":{"ä":12}},22],"u":[{"f":41,"n":{"g":1}},283],"v":89,"w":{"ä":{"h":106}},"z":{"a":37,"b":93,"e":{"i":89,"u":84},"w":4}},"s":[{".":73,"a":{"k":22},"c":2,"k":{"a":2},"p":{"e":{"n":12},"r":6},"s":{"a":93},"t":{"a":{"n":4},"e":{"i":1,"l":12,"r":[{"g":26,"h":46,"k":26},102]},"n":77,"o":17,"r":{"i":357}},"u":6},78],"t":[{".":78,"a":[{"b":{"l":5},"p":80,"t":80},71],"e":[{"n":17},78],"h":[{"o":1},152],"l":84,"t":{"i":4}},2],"u":{"f":78,"m":78,"n":[{"u":84},476],"p":93,"r":{".":78}},"v":{"a":6,"i":6},"w":{"a":{"s":22},"o":78},"x":{"a":{"m":77},"e":152,"i":152,"p":84,"t":{"a":12},"z":93}},75],"è":6,"f":477,"g":[{"a":{"s":{"e":{"r":27},"u":2}},"e":[{"n":{"e":{"n":478}},"r":{"a":22,"i":22}},82],"r":5},248],"h":{".":84,"a":[{".":78,"g":88,"k":84,"l":{".":78,"h":78,"i":89,"s":73},"n":{".":73,"d":82},"p":82,"u":106},152],"ä":[{"i":78,"l":84},93],"b":77,"e":[{".":75,"a":147,"b":93,"f":93,"i":[{"n":13,"t":84},93],"k":73,"m":{"a":78,"d":77,"m":77},"n":[{"n":71},75],"o":78,"r":{"d":71,"o":132,"r":71,"z":93},"s":{"s":189},"u":73},6],"f":77,"i":[{".":78,"c":{"k":159},"e":{"r":{".":4}},"l":93,"m":93,"n":[{"u":4},93],"r":93},227],"k":77,"l":107,"m":[{"u":22},220],"n":173,"o":[{"b":93,"c":{"h":{"r":4}},"f":71,"h":93,"l":{"t":71,"z":77},"n":73,"p":{"s":84},"s":[{"e":71},13],"t":[{"e":84},71],"u":77,"v":71},75],"ö":84,"p":77,"r":385,"s":77,"t":108,"u":[{"b":77,"h":77,"n":106,"t":77},71],"ü":93,"v":77},"i":[{"a":[{"c":1,"g":0,"l":{"l":22,"o":1},"m":32},89],"b":78,"c":{"c":78,"e":0,"k":{"e":{"t":78}}},"d":{".":73,"e":{"e":77,"n":{"d":39}},"y":1},"e":{"f":{".":78,"e":{"l":84},"l":78,"r":2},"g":148,"h":77,"i":21,"l":[{".":6,"a":25},0],"n":[{"s":25},479],"r":[{"e":{"i":12,"u":12},"n":6},78],"s":{"t":37},"ß":77,"u":0},"f":{".":78,"e":1,"r":120,"t":{"e":{"r":{"k":29}}}},"g":[{"e":{"r":{"z":5}},"i":{"t":6},"s":{"t":{"r":10}}},78],"h":2,"j":78,"k":{"a":{"m":6,"r":6},"e":{"n":[{"t":5},105],"r":{"e":16,"l":1}},"i":{"n":6},"l":{"u":5},"n":6,"o":{"p":6},"r":[{"a":6,"ä":6,"e":{"i":5}},13],"t":35},"l":{"a":{"r":6},"d":4,"e":{"i":6,"l":6},"g":78,"l":{"u":77},"ö":6,"t":10,"u":6},"m":{"a":{"g":36},"m":{"a":{"n":12,"t":82},"e":{"r":[{"g":26},102]}},"o":78,"p":77,"s":2},"n":{".":78,"a":[{"f":1,"k":1,"n":23},89],"d":71,"e":[{"i":48},47],"f":93,"g":[{"a":2,"l":25,"s":25},78],"h":93,"i":{"s":78,"t":311},"k":{"a":71,"l":11,"n":2,"r":2,"u":71},"n":73,"o":{"r":6},"s":[{".":78,"a":82,"ä":73,"e":106,"p":{"a":12},"u":{"m":12}},71],"t":[{"e":{".":78}},71],"u":[{"m":2},1],"v":189},"o":[{"s":{"k":6},"x":{"i":17}},78],"p":{".":78,"e":77,"l":16,"p":78,"s":78},"q":{"u":{"e":{".":5}}},"r":{"a":{"d":78},"h":0,"o":{"n":5}},"s":{"c":[{"h":{"e":{"i":24},"u":5,"w":17}},88],"e":{"i":6,"l":2},"k":1,"l":93,"o":71,"p":6,"r":71,"s":10,"t":{"h":3,"i":4,"r":120},"u":21},"t":{"a":[{"l":6},217],"e":87,"h":0,"i":78,"u":107},"u":[{"m":{"s":10}},78],"v":[{"a":{"n":6},"e":{"l":6,"n":{"e":5},"r":[{"h":5,"k":5,"l":5},105]},"o":21,"r":14},78],"z":{"a":6,"i":{"r":6}}},75],"j":93,"k":309,"l":[{"a":{"n":{"g":22}},"e":[{"f":73,"i":{"d":{"e":{"r":33}}},"r":{"a":2}},5],"i":[{"n":{"g":{"s":53}},"t":48},473],"o":82,"ö":140,"u":{"n":{"g":19}}},248],"m":[{"a":{"l":22,"s":{"t":2}},"e":{"n":{"s":{"c":{"h":{"l":30}}},"t":[{"s":102},58]}},"o":[{"d":{"e":{"s":12}}},82]},246],"n":[{"a":140,"e":{"s":22}},309],"o":[{".":78,"a":{"s":5,"t":7},"b":{"a":73,"j":84,"l":2,"s":71,"t":78},"c":[{"h":{"s":82,"t":78},"k":{"e":{"n":{"t":212}}}},0],"d":[{"e":{"r":422},"u":{"n":5}},147],"f":{"f":{"a":12,"e":{"n":{"t":46},"r":27},"i":77,"s":25}},"g":78,"h":{"r":76},"i":[{".":84,"r":12,"z":84},78],"j":194,"k":378,"l":[{"e":1,"p":84,"z":84},78],"m":{"a":{"r":{"b":19}},"e":{"n":{"e":5}},"i":[{"n":6},78],"o":78,"u":[{"n":5},21]},"n":{"a":{"n":6,"u":4},"d":22,"e":{"h":232,"r":{"k":{"e":15}}},"o":{"b":6},"y":77},"o":78,"p":{".":78,"a":{"d":6,"k":6,"n":6,"s":1,"t":6},"h":{"i":13},"o":78,"t":372},"r":[{".":89,"a":{"g":22},"ä":{"n":5},"c":84,"d":[{"i":73,"n":106},71],"e":[{"i":6,"l":6,"m":6,"n":{"n":{"a":24}}},89],"f":{"a":{"n":12}},"g":[{"a":84},238],"i":{"e":{"n":{"t":140}},"n":{"s":19,"t":4}},"k":194,"ö":6,"s":89,"t":{".":189,"a":37,"h":71,"n":84,"s":144},"u":5,"ü":[{"b":5},1],"y":84},78],"s":{"c":1,"e":3,"h":3,"k":{"a":5},"p":3,"s":84,"t":480},"ß":[{"u":0},84],"t":{"ä":6,"e":78,"h":{"o":6},"r":78,"s":22},"u":[{"i":{"l":105},"n":1},403],"w":78,"x":0,"z":78},75],"ö":[{"c":{"h":78,"k":84},"d":152,"f":80,"k":189,"l":{".":77},"n":78,"r":73,"s":{"t":71},"t":78},75],"p":[{"f":12,"i":{"n":2}},134],"q":93,"r":[{".":77,"a":{".":194,"c":[{"h":{"a":4,"l":4}},78],"d":{".":76,"e":[{"m":12},77],"i":{"e":106}},"f":{"a":{"h":12,"r":12}},"g":89,"h":{"i":78,"l":84,"m":77},"i":252,"k":[{"e":106,"t":89},78],"l":[{"l":25},78],"n":{".":147,"d":84,"g":84,"n":82,"s":252},"s":{"t":2},"ß":84,"u":{"b":{".":84},"c":84,"e":89,"f":89,"p":77,"ß":84}},"ä":{"c":194,"d":77,"g":78,"n":{"e":78,"g":84},"s":84,"ß":84,"u":{"c":77,"s":84,"ß":84}},"e":{".":214,"a":[{"k":82},77],"b":[{"r":2},84],"c":[{"h":82,"k":[{".":194,"e":35},89]},84],"d":76,"f":[{"e":84,"f":194,"l":84,"o":84},78],"g":84,"h":82,"i":{".":89,"b":147,"c":84,"f":84,"g":76,"h":76,"m":77,"n":106,"s":[{"c":{"h":{".":263}}},76],"t":84,"z":82},"k":77,"l":106,"m":89,"n":{".":89,"d":[{"i":84},78],"n":{"u":78},"t":82},"p":{"e":77,"o":76,"p":78,"r":82},"r":89,"s":{".":252},"t":{"a":2,"e":89,"r":25,"t":76},"u":{"h":78},"v":106,"x":89,"z":84},"é":252,"h":76,"i":[{"b":89,"c":[{"k":89},84],"d":283,"e":{"b":194,"f":{"r":25},"n":{"a":12},"r":[{"s":12},2],"s":48},"g":{".":84,"g":194,"l":4},"k":[{"e":{".":12,"s":12},"o":194},89],"n":{"d":106,"g":84,"i":4,"n":106},"p":[{"t":84},89],"v":106,"x":2,"z":{"i":132}},78],"o":{".":194,"b":9,"c":{"k":{".":84}},"e":78,"k":{"e":{"s":12}},"l":{"l":{"a":10}},"m":{".":221,"e":{"n":12},"i":2,"k":84,"s":84,"v":84},"n":[{"a":4},78],"p":[{"e":13,"f":78},89],"s":{".":194,"m":35,"t":78},"t":{".":71},"u":{"t":77},"y":78},"ö":{"c":106,"h":77,"m":221,"p":78,"s":[{"s":106},78],"t":78},"u":{"a":78,"b":78,"c":76,"f":84,"k":84,"m":[{"ä":82,"s":132},22],"n":{"d":82,"k":78},"p":252,"s":{"s":82},"t":[{"h":2},440],"w":84},"ü":{"b":{"e":13,"u":13},"c":[{"k":{"e":{"r":312}}},76],"g":89,"m":{"m":78}},"y":13},481],"s":[{".":84,"a":{"b":1,"c":{"h":{"s":89}},"d":113,"h":{"n":0},"l":{"l":73,"t":73},"m":{"p":89,"t":114},"n":[{"e":1},73],"r":[{"e":1,"i":1},2],"s":482,"u":73,"v":6},"ä":{"h":73,"n":0,"u":{"s":0}},"c":{"h":{"a":{"m":89,"r":{"t":164}},"e":[{"f":89},82],"l":[{"i":10},82],"r":{"o":89},"ü":82},"o":{"r":5}},"e":{"b":113,"e":2,"f":73,"h":{"e":{".":12}},"i":{"l":6},"m":{"e":82},"n":{"g":0,"s":6,"t":104},"p":104,"r":104,"s":{"s":{"e":{"n":338}}},"t":[{"a":0,"i":104},2],"v":113,"x":[{"i":82},73]},"h":{"e":1},"i":{"d":113,"k":167,"m":73,"n":{"g":19,"i":73},"r":0},"k":[{"a":{"l":82},"e":{"l":{"e":5}},"i":22,"o":128},84],"l":{"a":{"l":71}},"o":{"f":{"f":0},"p":104,"r":[{"c":0,"i":104,"t":{".":1}},2]},"ö":73,"p":{"a":{"c":73,"l":73,"s":0,"t":[{"e":1},73]},"ä":73,"e":{"d":82,"i":82,"k":79,"n":{"d":5}},"h":73,"i":[{"c":128,"n":{"s":89}},79],"l":{"e":1},"o":[{"n":79,"r":79},73],"r":{"o":73},"u":{"l":6,"t":6}},"s":16,"t":[{"a":{"b":{"e":89},"f":73,"g":89,"k":1,"l":{"e":89},"n":{"z":128},"s":89,"t":{".":89}},"ä":{"t":{"i":128}},"e":{"a":73,"i":{"n":82},"r":{"b":5,"n":124,"o":124}},"h":89,"i":{"f":82,"m":82,"t":89},"o":{"c":{"h":89},"i":89,"l":5,"n":89},"r":{"e":{"c":82,"n":89},"i":{"e":89}},"u":[{"b":140},6],"ü":{"m":5},"y":89},483],"u":[{".":73,"b":{"i":194},"m":{"g":73,"s":73,"v":73,"z":73},"n":86},0],"w":{"a":{"s":22}},"y":82},77],"t":[{"a":{"b":0,"c":[{"h":{"s":1}},6],"d":0,"g":[{"e":{"s":{"s":46}}},6],"h":114,"k":{"e":2},"l":6,"n":{"a":278,"m":73,"t":6},"p":114,"r":{"t":0},"t":{"r":1}},"ä":{"h":0},"e":{"b":{"e":0},"i":{"f":0,"n":0,"s":104},"l":{"a":294,"e":{"b":199,"n":12},"i":{"n":12},"o":48,"s":{"t":[{"e":55},19]}},"m":{"u":73},"n":{"a":12,"s":{"e":{"m":33}},"t":{"b":89,"e":25,"f":89,"s":89},"z":25},"o":73,"r":{"e":5,"f":{"o":1},"i":{"k":12},"o":2,"ö":6},"s":[{"a":485,"ä":485,"o":2,"t":{"r":19}},484]},"h":{"ä":{"u":6},"i":0,"o":104},"i":{"d":237,"g":{"i":128},"n":{"s":73,"t":6},"s":{"o":73}},"l":{"a":486},"o":{"r":{"g":89}},"r":{"o":{"u":73},"ü":1},"s":{"c":{"h":{"i":102}},"e":{"h":13,"n":6},"p":[{"e":6,"r":6},13],"t":{"ä":{"t":14}},"u":{"m":6},"z":3},"t":47,"u":{"f":32},"ü":82,"z":3},189],"u":[{"a":[{"l":{"e":5,"m":0,"v":0},"n":{"t":1}},78],"b":[{"a":{"b":25}},108],"c":[{"h":{"i":6,"o":0}},78],"d":[{"i":{"e":{"n":191}}},77],"e":[{"r":{"e":6}},78],"f":[{"e":[{"n":1,"r":79},2],"f":78},77],"g":{"a":{"n":6}},"h":[{"l":{"e":{"r":12}}},84],"i":{"s":{"t":0}},"k":{"r":6},"l":{"i":2},"m":{".":78,"b":{"l":361},"e":78,"f":106,"g":76,"h":93,"k":76,"l":77,"o":88,"r":76,"s":{"a":{"t":106},"c":93,"i":2,"o":2,"t":{"r":59}},"t":76,"w":93,"z":76},"n":{".":78,"a":93,"d":[{"e":22},93],"e":{"n":2},"f":76,"g":[{"a":82,"s":318},78],"i":{"f":77,"o":80,"v":77},"m":93,"n":78,"o":72,"s":[{".":78},82],"t":106,"v":93},"p":{".":93,"g":71},"r":{"a":{"g":21,"n":[{"l":19},6],"s":6,"u":6},"ä":6,"c":13,"e":{"b":125,"i":[{"s":4},6],"n":{"e":5},"r":21,"s":5,"t":126,"v":118},"f":9,"g":37,"i":{"n":487},"m":{"u":{"n":12}},"n":78,"o":23,"u":5},"s":[{"a":6,"c":{"h":{"l":5}},"e":6,"o":6},78],"t":{"a":3,"o":[{"r":{"e":25}},55]}},75],"ü":[{"b":[{"e":{"r":{".":1}}},84],"c":{"h":78,"k":{"s":22}},"f":78,"h":84,"m":78,"r":{".":78,"c":13,"e":78,"g":78,"s":326,"w":78,"z":84},"t":{"c":78,"e":78,"z":84}},77],"v":[{"o":[{"r":{"a":{"n":102}}},82]},248],"w":[{"a":488,"i":{"e":12,"s":{"t":89}}},309],"y":[{"a":93,"p":[{"a":21},78],"s":32},75],"z":[{"a":[{"g":0,"r":1,"u":0},289],"ä":[{"h":82},104],"e":{"c":0,"d":113,"h":{"r":0},"i":{"e":104,"s":114},"m":[{"i":0},2],"n":[{"e":6,"s":{"t":441},"t":{"a":25,"g":89,"l":89,"s":89}},99],"r":{"e":{"b":12},"g":{"r":{"e":33}},"w":0,"z":[{"i":1},168]},"s":162,"t":32},"i":{"d":113,"m":[{"i":0},12],"n":{"t":0,"v":0}},"o":{"m":86,"p":73},"t":{"h":6,"i":{"n":5}},"u":{"g":{"u":2},"n":{"i":73}},"w":{"a":{"n":{"d":191}},"ä":0,"i":[{"e":82},0],"u":0}},93]},"u":{"a":[{"b":79,"c":79,"d":{"a":{"n":6},"r":12},"g":6,"l":{".":71,"a":285,"ä":285,"b":71,"d":71,"e":{"b":82,"n":{"t":124},"r":[{"g":5,"k":4},489],"t":79},"f":71,"g":71,"h":71,"i":{"d":79},"n":71,"o":125,"p":71,"r":71,"s":71,"t":490,"u":6,"w":71,"z":71},"m":71,"n":{"a":2,"s":71},"r":{".":82,"a":{"b":22},"s":71,"t":{"a":{"n":27}}},"s":{"a":1,"i":48},"t":{"h":6,"i":2,"o":2},"u":82,"y":71},77],"ä":{"m":71,"s":6,"u":71},"b":[{"a":{"r":{"b":73}},"b":{"l":12},"e":{"b":{"e":2},"e":2,"h":{"e":104},"i":{"n":{"s":128}},"m":113,"n":{"a":99,"o":25},"r":[{"d":{"e":128},"t":19},6],"s":5,"u":{"l":0}},"i":{"t":82},"l":[{"ä":{"u":1},"i":{"c":1},"u":[{"t":5},1]},6],"o":{"b":73,"p":73,"z":73},"r":{"i":{"t":86},"ü":5},"s":{"a":{"n":6,"u":105},"c":{"h":{"e":14}},"o":21,"p":6,"t":22},"t":{"h":3}},93],"c":[{"c":0,"h":{"a":[{".":71},13],"ä":13,"e":[{"c":13,"d":73,"i":13,"r":{"i":{"n":{"t":66}}},"s":82},71],"i":[{"m":4,"n":13},71],"l":4,"m":4,"n":4,"o":{"p":13},"r":346,"s":{"e":{"l":12},"o":2,"p":2},"t":{"a":[{"n":4},2],"e":{"r":{"f":46,"t":46}}},"u":71,"ü":4,"w":13},"i":71,"k":{"e":{"l":{"f":4},"m":73,"n":{"t":89},"r":[{"g":{"e":{"b":175}}},2]},"i":346,"s":{"t":{"i":12}}},"l":71},84],"d":[{"a":[{"d":4},124],"e":[{"i":[{"n":63},9],"n":[{"e":25,"s":266},11],"r":{"t":19},"s":22},6],"i":{"e":{"n":4},"t":{"i":19}},"o":[{"b":82,"n":86},6],"r":{"a":1,"u":82}},93],"e":[{"b":{"l":12},"c":{"h":0,"k":6},"d":73,"e":{"n":126},"g":73,"h":73,"k":{"e":6},"l":{"a":89,"e":{"k":6},"i":10,"l":{"a":2},"n":82},"m":{"i":6},"n":[{".":82,"a":315,"ä":6,"d":82,"e":[{"b":6,"r":6},22],"g":{"a":{"g":12},"e":[{"m":19,"n":{"e":297},"s":19},105],"l":2},"i":79,"k":10,"o":6,"z":{"e":{"n":{"e":26}},"u":2}},13],"p":73,"r":{"a":[{"t":10},118],"ä":21,"b":[{"a":{"u":{"t":26}}},22],"d":37,"e":[{"c":6,"i":{"n":{"n":140},"s":4},"l":{"a":4},"m":{"p":82},"n":{"t":491},"r":{"b":16,"f":82,"g":42,"h":19,"k":19,"m":19,"s":{"c":24,"p":15,"t":24}},"s":{"k":4},"t":126,"x":82},22],"g":[{"e":{"b":12}},37],"h":82,"i":{"d":22,"m":150,"n":{"t":202}},"l":{".":82},"n":[{"a":{"n":12,"r":12},"e":12,"s":{"t":159}},82],"o":254,"ö":2,"r":{"ü":82},"s":{"c":4,"t":15},"t":37,"u":{"h":82,"m":82,"n":{"f":82,"t":82}},"z":37},"t":{"a":6,"e":{"k":5},"i":{"k":6},"y":22},"v":73,"x":21},189],"f":{"a":{"b":0,"c":[{"k":2},82],"h":82,"l":[{"l":19},82],"m":82,"n":[{"e":1},2],"r":167,"s":82,"ß":0,"t":2,"u":0},"ä":{"n":104,"s":104,"ß":113},"e":{"i":104,"l":{"s":{"a":277}},"m":104,"n":[{".":82,"t":73},84],"r":{"f":73,"h":104,"l":{"a":89,"e":89},"n":{"e":89}},"t":104},"f":[{"e":1,"l":12,"r":{"o":6}},77],"i":{"d":104,"m":73,"n":{"s":104}},"l":1,"o":{"b":73,"r":[{"i":0},2]},"r":1,"s":{"ä":7,"p":{"o":6},"t":{"a":{"b":5}}},"t":[{"a":{"b":22},"e":{"b":13,"r":{"d":4,"g":197,"l":19}},"s":9},77],"u":{"m":73}},"g":[{"a":{"b":{"e":6,"t":{"e":89}},"d":32,"k":0,"n":{"a":73,"b":73,"i":73,"s":104,"t":73},"p":0,"r":104,"s":2,"u":0},"d":3,"e":{".":82,"c":104,"i":[{"g":73,"n":73},32],"l":{"o":{"b":12}},"m":{"i":0},"n":{"e":105,"s":266},"r":{"f":104,"l":104,"r":73,"v":73},"s":{".":82,"k":104},"t":6},"g":[{"e":{"s":{"t":10}},"l":6,"t":12},2],"h":{"u":1},"i":{"d":113,"m":73,"n":0},"l":[{"ä":89,"e":{"i":{"t":{"b":164,"u":164}}},"i":{"c":89,"s":89,"z":1},"o":128,"u":89},104],"n":128,"o":[{"b":237,"c":1,"n":82,"p":12,"r":120,"s":82},4],"ö":73,"r":{"ä":86,"e":{"g":73,"i":{"s":128},"s":73},"i":{"e":86},"o":[{"u":73},1],"ü":{"s":1}},"s":{"p":{"a":{"n":1},"e":5,"o":{"r":12},"r":5,"u":5},"t":[{"a":1,"ä":1,"o":12,"r":16,"u":[{"r":5},1],"ü":16},22]},"u":{"m":73,"t":{"e":4}},"ü":73},93],"h":[{"a":6,"e":[{"a":37,"e":100,"s":13},76],"i":77,"l":[{"a":[{"r":6},0],"ä":0,"e":{"n":{"t":14},"r":{"b":4}},"i":6,"ö":2},77],"m":[{"e":22},77],"r":{"a":13,"e":{"i":{"s":19},"r":492},"i":[{"n":5},107],"o":23,"u":6,"ü":5},"s":12,"t":3,"u":73,"ü":77,"w":0},71],"i":[{"a":6,"c":{"h":[{"e":6},0],"k":{"e":{"r":5}}},"d":{"d":71},"e":[{"m":0},71],"g":[{"e":89},82],"l":{"l":{"e":{"s":12}}},"m":71,"n":{".":82},"s":{"c":{"h":{".":82,"s":82}},"e":2,"i":{"n":10},"t":4},"t":{"s":4}},77],"j":[{"i":4},71],"k":{"a":6,"ä":[{"h":0,"u":82},2],"e":[{"n":11},72],"i":71,"l":[{"e":48},72],"n":5,"o":{"b":104,"m":[{"a":25},11]},"ö":6,"r":115,"t":{"a":6,"e":{"l":21,"n":{"t":5},"r":21},"i":{"n":6},"o":{"r":{"i":177}},"r":14,"u":{"m":6}},"u":[{"s":2},71],"ü":6},"l":[{"a":{"m":0,"n":{"e":22},"r":6,"s":2},"ä":{"m":0},"b":{"l":12},"d":{"a":{"n":5},"r":6,"s":{"e":2}},"e":[{"l":104,"m":{"b":0},"n":12,"r":{"h":83},"s":{"t":25},"t":[{"a":0},2]},77],"f":223,"g":12,"i":[{"d":0,"k":2,"n":{"s":0},"p":13},77],"k":{"a":1,"n":6},"l":{"a":{"u":13},"e":{"n":1},"i":3,"o":6,"s":37},"m":{"e":2},"n":{"i":22},"o":{"i":2,"p":73,"r":104},"p":{"h":[{"a":6},13]},"s":{"a":[{"m":5},6],"e":{"c":21,"i":6,"r":6},"t":{"h":2},"u":{"m":6}},"t":{"a":[{"n":1,"r":4,"u":6},269],"e":{"r":{"m":19}},"i":1,"r":{"i":5},"s":4},"ü":73,"v":{"r":6},"z":{"w":2}},71],"m":{"a":{".":77,"a":157,"b":73,"d":104,"k":113,"l":{"l":0},"n":{"g":0,"z":0},"p":104,"r":[{"c":73,"m":73,"t":73},0],"t":{"l":73,"m":73},"u":{"s":0,"t":73}},"ä":{"h":104},"d":430,"e":{".":82,"f":104,"i":{"n":104},"n":{"e":11,"g":{"e":{"l":7}}},"r":{"a":22,"f":104,"g":0,"k":82,"l":104,"w":0},"s":{"t":22}},"f":[{"i":84},75],"g":75,"i":{"n":{"d":0,"h":0},"r":0,"t":[{"e":0},2]},"k":75,"l":75,"m":{"e":[{"i":6},77],"i":1},"o":{"b":0,"l":82,"t":1},"p":{"f":{"a":2,"i":{"n":12},"l":{"i":10}},"h":{"o":6}},"r":75,"s":{"a":{"n":14,"t":75},"e":{"r":41},"i":{"m":6},"k":5,"p":{"e":21},"u":{"m":6}},"t":3,"u":{"m":73,"r":113},"z":75},"n":[{".":84,"a":{".":77,"b":[{"r":23},75],"g":6,"l":6,"m":79,"n":86,"p":73,"r":{"b":73},"s":493,"t":1},"ä":{"r":6},"d":{".":77,"a":[{"b":22},6],"ä":{"n":6},"d":75,"e":[{".":1,"r":{"e":{"r":312},"f":4,"ö":4,"t":{"e":{"n":[{"d":175},62]}},"z":4},"x":6},77],"f":75,"g":77,"i":{"d":6,"m":6},"n":75,"o":{"b":22,"p":6,"r":6},"r":384,"s":[{".":84,"c":77},4],"u":{"m":21},"ü":10,"v":75,"z":75},"e":[{"i":{"d":1,"n":1},"m":{"i":6},"n":[{"t":22},99],"r":{"e":4,"i":4,"k":89,"z":{".":128}},"s":126},257],"f":[{"a":1,"t":{"s":10}},2],"g":{"a":{"b":6,"m":6,"t":6},"e":{"n":{"a":78},"r":{"e":19},"t":75,"w":75},"h":35,"l":[{"u":6},75],"o":6,"r":[{"i":4},6],"s":[{"a":12,"t":{"r":55}},25]},"i":{"c":82,"d":[{"e":1},6],"e":84,"f":88,"k":9,"m":6,"o":75,"r":[{"o":1},6],"s":{"l":1},"t":79,"v":85},"k":[{"a":125,"e":{"r":1,"s":21,"t":6},"n":{"e":6},"o":{"p":36},"r":{"o":6},"s":37,"t":{"i":{"t":12},"r":2}},77],"l":{"ö":22},"n":{"a":[{"d":41},22],"e":[{"n":10},2]},"o":{"b":73,"r":12,"s":6},"r":75,"s":[{".":77,"c":{"h":{"e":{"l":54}}},"e":1,"i":146,"k":[{"i":5},1],"p":1,"t":{"a":{"g":19},"e":{"c":19},"r":99},"y":84,"z":84},2],"t":[{"a":1,"e":[{"r":{"i":10}},1],"i":84,"r":1,"s":4,"u":77,"y":78},75],"u":[{"c":82},74],"v":{"o":{"l":[{"l":247},105]}},"w":[{"ä":84,"e":78},75],"y":73,"z":[{"a":3,"e":2},77]},0],"o":[{"b":72,"f":82,"r":[{".":82,"a":23,"c":4,"e":{"t":82},"i":{"s":6},"s":82,"t":35},71],"s":[{".":71},2],"t":{"e":22},"x":71},77],"ö":{"d":6,"k":71},"p":{"a":71,"d":78,"e":[{"r":[{"e":{"r":102}},48]},217],"f":{"a":6,"e":97,"i":73,"u":6},"i":124,"l":{"u":5},"o":82,"p":[{"l":6},77],"r":[{"a":[{"s":86},25]},71],"t":{"a":315,"e":{"n":[{"e":5},132],"r":{"f":4,"g":4,"k":4,"s":4}},"i":{"n":5},"o":41,"r":5}},"q":71,"r":{".":84,"a":[{"b":[{"a":82,"e":2},73],"k":{"t":104},"l":{"t":156},"m":104,"n":{"a":12,"d":82,"f":{"ä":{"n":33}},"g":[{"e":10},0],"h":6,"s":55,"z":0},"p":1,"r":[{"i":12},86],"s":{"c":82,"p":0,"t":{"r":12}},"t":{"e":5,"t":104},"u":0},71],"ä":[{"l":0,"m":32,"n":0},93],"b":{"a":3},"c":[{"h":[{"t":{"e":17}},48]},77],"d":[{"a":1,"i":1},2],"e":{"e":13,"f":{"f":0},"i":{"g":0},"l":{"e":73},"n":[{"a":12,"s":{"e":278},"t":{"n":89}},2],"p":104,"r":{"h":25,"k":25,"t":6,"w":73},"t":{"a":0,"h":23},"u":4},"f":[{"l":23,"r":{"o":6},"s":{"p":{"r":12}},"t":4},77],"g":{"e":{"n":{"s":{"e":24}}},"i":{"n":{"n":4}},"l":[{"a":6},13],"r":{"i":6,"o":{"s":102}},"s":184},"i":{"c":2,"d":{"e":0},"e":{"n":4},"n":{"d":104,"s":{"e":{"k":33},"t":{"i":{"n":30}}}},"s":{"o":289}},"k":{"u":1},"l":1,"m":{"a":{"t":{"t":5},"u":21},"e":{"i":2,"r":{"n":5},"t":132},"u":{"m":6,"n":6}},"n":{"e":3},"o":[{"b":{"l":22},"f":{"f":0},"h":22,"s":[{"t":105},184]},93],"ö":93,"p":16,"r":[{"e":1,"h":6},77],"s":{"a":{"c":78,"n":6,"u":19},"e":{"r":21},"o":{"f":41},"p":{"a":6},"z":{"e":1}},"t":[{"a":[{"i":6},77],"e":{"i":{"n":4}},"r":{"o":6},"s":{"c":22}},2],"u":[{"f":10},82],"ü":2,"z":{"a":125,"ä":6,"e":{"c":21,"p":6},"i":6,"o":{"p":21},"t":10,"w":21}},"s":[{"a":{"b":3,"g":{"i":2},"m":{"b":114,"t":89},"n":{"g":73,"n":6},"r":{"k":1},"s":[{"t":0},162]},"ä":{"h":73,"s":104},"c":{"h":{"a":{"b":89,"k":89},"e":{".":82,"f":89,"i":{"c":55},"u":165},"i":82,"m":{"ü":25},"u":82,"w":{"e":{"r":55}}}},"e":{"b":383,"c":104,"e":{"i":2},"i":104,"n":{"s":{"e":278},"t":{"l":89}},"p":82,"r":{"e":{"c":12},"l":104,"p":73,"w":0},"s":{"e":104},"x":73},"i":{"d":73,"e":{"r":{".":4,"s":{".":35}}},"k":[{"a":{"t":12}},82],"n":{"n":0}},"k":{"l":1},"o":{"c":1,"h":0,"l":82,"p":73,"r":{"c":0},"u":0},"p":{"a":{"c":73,"r":{"t":1},"s":104},"e":{"c":82,"k":82},"h":73,"i":{"c":0,"t":82,"z":124},"o":[{"r":6},73],"u":73},"r":{"i":{"c":{"h":249}}},"s":{"a":{"d":21},"e":{"b":23,"g":10,"n":10,"p":6,"r":{".":7,"f":4,"z":19},"s":{"p":5},"z":6},"k":4,"o":{"f":6},"u":{"m":6}},"t":{"a":{"d":71,"l":71,"u":1},"e":{"i":{"n":5},"l":71,"r":{"l":4}},"h":[{"e":{"r":1}},6],"i":{"n":1},"r":[{"a":{"s":5},"i":{"s":24}},1],"u":[{"n":73,"r":73},71]},"u":{"m":{"d":73,"g":73,"z":73},"r":82,"s":78},"ü":73},77],"ß":[{"u":0},77],"t":[{".":84,"a":{"f":82,"l":{"t":104},"m":296,"n":{"s":6},"p":104,"r":104,"s":2,"u":{"t":73}},"ä":{"h":0,"r":73},"c":1,"e":{"d":32,"h":82,"i":{".":0,"e":0,"n":0},"k":82,"l":{"a":0},"m":82,"n":[{"a":22,"t":[{"f":89},73]},11],"r":{"a":[{"l":12},105],"e":{"r":195},"i":{"n":{"g":26}},"k":25,"o":{"s":12}},"s":6,"t":6,"v":218,"x":104},"f":{"i":22},"h":{"a":{"l":1},"e":{"i":1,"l":0},"i":104,"o":104,"u":73},"i":{"d":104,"g":{"e":{"l":89}},"v":{"i":2}},"l":{"i":{"n":10}},"o":{"c":4,"m":169,"p":[{"a":4,"s":73},13],"r":{"a":22,"d":89,"e":2,"i":{"n":12}},"s":37,"u":84},"ö":{"l":73},"r":[{"e":{"a":1},"o":{"u":73},"ü":1},84],"s":[{"a":{"u":105},"ä":{"u":6},"c":{"h":{"l":5,"m":5,"o":5,"ö":5}},"e":{"r":1},"k":3,"p":2,"t":{"a":1}},84],"t":{"e":{"r":12},"l":47,"s":22},"u":{"b":2,"m":73,"n":[{"e":104},12],"r":{"e":12,"o":4,"u":35}},"ü":82,"z":[{"e":{"h":6,"n":{"g":4},"r":2,"t":6},"i":{"n":21,"s":6},"ö":6,"w":21},164]},93],"u":[{"f":{"e":22},"m":[{"a":10,"e":22},13]},205],"ü":72,"v":[{"e":{".":73,"r":{"ä":4}}},205],"w":71,"x":[{"e":6,"o":[{"e":1},6],"t":16},93],"y":[{"o":73},71],"z":[{"e":[{"c":104,"n":{"e":104},"r":6},2],"o":{"f":2,"t":1},"w":{"e":0},"z":3},93]},"ü":{"b":[{"ä":0,"c":77,"d":77,"e":[{"c":4,"l":{"e":4},"n":{"a":12,"e":4},"r":48,"t":89},2],"l":1,"r":7,"s":{"t":23}},75],"c":[{"h":{"e":71,"l":4,"s":{"c":11},"t":{"e":10}},"k":{"e":{"n":350,"r":[{"i":4,"k":{"e":15},"s":89},13]},"i":{"n":73},"u":{"m":73}}},77],"d":{"a":122,"e":{"c":2,"l":2,"n":{".":82,"g":22,"s":79}},"o":16,"r":1,"s":3,"t":16,"u":2},"e":[{"b":4,"i":71},6],"f":[{"a":104,"ä":104,"e":{"i":104,"n":{"t":73},"r":[{"g":104},22]},"f":{"l":6},"i":104,"l":1,"o":73,"u":{"m":73}},77],"g":[{"e":[{"l":{"a":138,"ä":2,"e":{"c":12,"i":{"s":351}},"o":2},"n":{"s":25}},6],"l":86,"n":73,"s":[{"t":14},3]},71],"h":{"a":3,"e":[{"i":104,"m":[{".":82},183],"n":{"g":104,"t":104},"r":{"f":104,"k":117,"z":117},"x":73},71],"i":120,"l":{"a":22,"ä":0,"e":{"l":6,"r":2},"ö":6,"s":{"k":12,"t":{"a":12,"i":12}}},"m":{"o":1},"n":{"e":1,"s":2},"o":32,"r":{"e":[{"i":{".":4},"n":[{"s":149},163]},3],"o":0,"t":{"a":4}},"s":[{"p":2},0],"t":[{"a":2,"r":12},1],"u":71,"w":0},"k":72,"l":{"a":0,"c":6,"e":[{"f":128,"r":{"a":494}},79],"l":{"a":125,"e":{"i":21,"r":2},"i":{"d":6},"o":6,"ö":6,"s":22},"ö":73,"u":71},"m":{"a":73,"e":{"n":{"t":73},"r":{"a":2}},"i":{"d":104,"n":104},"u":104},"n":[{"a":334,"d":{"a":6,"r":6,"s":4},"e":{"r":{"d":104}},"f":[{"l":{"i":4}},13],"g":{"l":23},"s":[{"c":1,"e":1,"p":1,"t":{"a":1,"e":{"r":247},"r":1}},6],"z":{"a":6,"i":21,"u":[{"n":6},22],"w":6}},77],"p":{"e":71,"f":{"l":4},"i":71,"p":{"l":6}},"r":[{"a":0,"e":{"i":104,"l":113},"f":{"e":{"r":21},"l":6,"r":6},"g":{"e":{"n":{"g":39},"r":{"a":10}}},"k":{"e":2},"o":[{"m":22,"r":22},383],"r":2,"s":[{"c":1,"e":1,"i":1,"p":1,"t":{"a":1}},6],"t":{"e":{"l":330},"h":2},"z":{"i":{"n":21},"ö":6,"w":21}},77],"s":{"a":6,"c":{"h":{"l":73}},"e":[{"e":100,"l":37,"n":12,"r":9,"s":13},79],"s":{"a":14,"c":21,"e":2,"o":14,"t":6},"t":{"a":4,"e":{"n":22}}},"ß":93,"t":[{"a":{"l":104},"e":{"m":4,"n":[{"s":25,"t":19,"z":266},12],"r":{"a":2,"e":11,"i":{"c":{"h":312}},"n":25}},"h":104,"r":86,"s":{"e":6,"t":6},"t":{"e":{"n":10},"r":6},"z":{"e":{"n":1},"w":6}},77],"v":71,"z":71},"v":{"a":{".":78,"b":[{"r":12},93],"c":0,"f":120,"g":[{"a":2,"h":5},1],"l":{"a":6,"u":77},"n":{".":73,"b":77,"g":77,"s":73},"r":{"b":77,"m":71},"s":[{"s":93,"t":0},2],"t":[{"a":[{"g":24,"n":5},150],"e":{"i":6,"n":{"g":14},"s":{"s":5}},"h":23,"i":{"d":5,"k":266,"m":5,"n":41,"o":{"n":{"s":{".":30}}}},"o":{"r":{"d":5}},"r":14,"s":9,"u":21},89],"u":93},"b":93,"c":93,"d":152,"e":[{"a":{"n":1,"r":1,"u":[{"s":48},25]},"b":16,"d":1,"f":{"a":1},"g":1,"h":3,"i":{"g":77,"l":73,"n":77,"t":[{"s":17},22]},"l":{"a":[{"n":77,"r":2,"u":41},1],"e":[{"i":1},71],"i":3,"o":[{"p":11},1]},"m":{"a":1,"e":1,"p":93,"u":77},"n":{"a":{"l":1,"s":5},"c":2,"e":1,"i":[{"n":5},1],"ö":1,"t":{"a":{"g":364},"s":{"k":10}}},"o":[{"f":1},77],"p":{"i":5},"r":[{"a":[{"d":1,"l":77,"n":{"d":1,"e":16},"s":10},4],"b":{"a":{"r":{"t":26}},"l":37},"d":37,"e":22,"f":10,"g":9,"i":[{"n":5},1],"k":4,"n":22,"s":{"e":{"p":12}},"t":[{"e":35},10],"u":[{"s":1},9]},13],"s":[{"a":1,"c":173,"e":173,"t":{"i":4}},13],"t":{"a":1,"e":[{"r":25},48],"i":1,"r":1,"s":3},"ü":77,"v":1,"w":1},227],"f":205,"g":93,"h":93,"i":{"a":{"n":0,"r":1,"t":14},"ä":6,"c":6,"d":{"e":1,"s":{"t":37}},"e":[{"h":{"a":11},"l":[{"a":105,"e":105},6],"r":[{"e":{"c":12}},6],"w":11},78],"g":2,"i":77,"l":[{"a":21,"ä":6,"e":{"h":176,"i":6,"r":[{"s":5},19]},"i":{"n":21}},73],"m":{"a":36},"n":{"a":5,"d":4,"g":[{"s":19},25],"s":71},"s":{"a":1,"e":10,"i":3,"o":3,"p":6,"u":2},"v":2,"z":[{"e":55},2]},"k":93,"l":[{"e":82,"i":{"e":73}},205],"m":[{"e":6},93],"n":152,"o":[{"b":[{"e":6,"l":12},93],"g":{"e":{"l":330},"u":6},"l":{"a":2,"l":{"a":99,"e":{"n":[{"d":26},29],"r":{"t":351}},"i":2}},"p":93,"r":[{"a":[{"n":{"s":{"c":{"h":{"l":175}}}}},14],"g":4,"i":[{"e":5,"g":7},1],"m":[{"e":{"n":102}},22],"o":4,"t":10},21],"t":{"a":2},"y":13},75],"ö":{"c":6},"p":93,"r":[{"a":71,"e":{"e":73},"i":88},6],"s":[{"c":6,"e":6,"p":6,"t":{"a":71,"e":{"u":71}},"z":79},77],"t":93,"u":{"e":[{"n":{"u":6},"t":6},4],"m":{"f":77,"g":77,"k":77}},"ü":71,"v":93,"w":93,"z":93},"w":{"a":[{"a":75,"b":{"b":{"l":2}},"c":{"h":{"e":1,"s":{"t":{"u":{"b":30}}},"t":{"r":307}},"k":75},"f":{"f":{"e":[{"l":247},105]}},"g":[{"e":[{"n":472},7],"n":23,"o":1},75],"h":[{"l":{"e":{"n":{"t":55},"r":12},"i":11}},75],"l":[{"a":{"r":6},"b":77,"d":{"a":27,"i":{"n":12},"r":2},"e":{"s":6},"i":1,"m":11,"s":22,"t":{"a":48,"e":{"r":{"e":26,"l":26}},"o":12,"u":{"r":12}},"z":78},75],"n":{"a":1,"d":{"a":138,"e":{"l":{"s":312}},"r":2},"f":82,"g":[{"e":37,"s":10},77],"n":75,"z":{"e":{"n":{"d":325},"r":12}}},"p":6,"r":{"e":[{"i":48,"n":7},430],"n":[{"i":12},75],"t":{"e":10,"h":2},"z":{"a":2}},"s":[{"a":1,"c":[{"h":{"a":5,"e":1,"l":260,"w":5}},2],"e":1,"h":1,"s":[{"e":387},4],"u":1},75]},73],"ä":[{"h":75,"l":75,"n":{"g":77},"s":[{"c":2,"s":{"e":10}},75],"u":76},73],"b":[{"u":2},152],"c":93,"d":93,"e":{"a":6,"b":{"a":21,"e":{"i":48},"l":23,"o":6,"r":23,"s":{"c":22}},"c":{"k":{"e":{".":1,"n":{".":7},"s":1}}},"e":[{"d":25},232],"f":{"l":6},"g":[{"a":21,"e":{"i":41,"r":{"s":{"c":35}}},"l":14,"n":5,"o":125,"r":14,"s":[{"t":10},37]},75],"h":[{"r":{"e":{"r":386}}},75],"i":{"b":{"l":2,"r":10},"e":77,"f":{"e":{"l":{"d":29}},"r":{"e":12}},"g":{"r":2,"s":19},"k":9,"l":78,"n":{"s":{"a":{"u":312}}},"s":{"c":4,"s":{"e":{"l":33},"p":{"i":33}}},"t":{"r":11},"z":{"e":35}},"l":{"l":{"e":495},"s":{"c":{"h":{"l":26,"r":26}}},"t":[{"a":485,"e":[{"n":{"d":325}},19],"h":12,"i":25,"o":12,"r":364},11]},"n":{"a":37,"d":{"e":{"s":102}},"g":{"l":2},"i":3,"k":{"a":2,"l":{"a":12},"r":{"i":27}}},"r":{"a":118,"b":{"e":[{"i":17},35],"l":2,"s":22,"u":75},"d":[{"e":{"n":{"s":194}},"u":75},37],"e":{"r":105},"f":{"l":2},"g":[{"a":2,"e":{"l":{"s":26}},"o":162,"r":2},77],"i":{"n":[{"s":1},105],"o":126},"k":{".":75,"a":11,"e":75,"i":2,"l":162,"n":2,"o":162,"r":{"e":27},"u":2},"ö":6,"s":[{"p":4},2],"t":{"a":11,"ä":2,"e":{"i":[{"g":26},25],"r":{"m":46}},"h":2,"i":{"n":12},"o":294,"r":{"e":12,"i":364},"u":{"m":12}}},"s":{"e":430,"p":6,"t":[{"a":99,"e":[{"i":25,"n":{"d":351},"x":12},105],"i":2,"o":294,"r":27,"u":12},5]},"t":[{"s":77,"t":{"s":25}},75],"y":76},"f":93,"g":93,"h":{"i":12,"o":82},"i":[{"c":{"h":{"t":{"s":19}},"k":{"a":0}},"d":75,"e":[{"b":77,"d":75,"l":4,"n":{"e":37}},6],"k":2,"l":{"d":75},"m":{"m":{"a":2,"e":{"n":{"t":26}},"u":27}},"n":{"a":2,"d":{"e":{"c":199,"l":4,"r":{"z":46}},"r":496},"g":[{"r":162},77],"k":{"l":2},"n":{"e":{"r":{"s":{"c":267}}},"o":2},"s":4,"t":22},"r":[{"e":25},497],"s":{"e":47,"p":6,"s":[{"z":10},75]},"t":{"h":1,"z":{".":75,"l":75}},"z":2},73],"k":93,"l":93,"m":93,"n":[{"s":{"a":2,"h":1}},77],"o":{"c":[{"h":{"a":6,"e":498}},92],"h":[{"l":{"e":{"i":12}},"n":{"a":12}},75],"l":{"f":[{"s":330},75],"l":{"a":2,"e":{"r":12}}},"r":{"a":4,"d":4,"i":14,"n":22,"t":{"a":48,"e":{"l":12,"r":{"h":26}},"r":27,"s":266},"u":14,"ü":4},"s":78,"t":2},"ö":{"c":75,"l":{"f":{"o":2}},"r":{"t":{"h":22}}},"p":93,"r":[{"e":82,"o":82},73],"s":[{"e":6,"h":79,"k":79,"t":6,"u":114},93],"t":[{"i":2},93],"u":[{"c":[{"h":{"s":{"c":10,"t":10}}},75],"f":79,"l":[{"s":{"e":4}},2],"n":{"d":{"e":10},"g":{"r":25,"s":19},"s":[{"c":{"h":{"l":53}}},2]},"r":{".":84,"f":{"a":2,"o":11,"r":2},"s":[{"t":75},2]},"s":[{"t":{"e":4}},2],"t":499},73],"ü":{"h":75,"l":2,"n":4,"r":{"f":75,"s":{"t":75}}},"w":93,"z":93},"x":{"a":[{".":75,"b":80,"c":85,"d":85,"e":75,"f":{"l":0},"g":500,"l":[{"l":2},77],"m":6,"n":{"e":75,"i":75,"t":196,"z":73},"r":6,"s":85,"z":6},71],"b":205,"c":{"e":71,"h":71,"l":71},"d":[{"a":12,"y":2},189],"e":[{".":78,"g":205,"k":77,"l":[{".":78,"e":[{"i":1},71]},6],"m":[{".":88,"p":77,"s":73},71],"n":[{".":78,"s":37},73],"r":{".":88,"e":73,"l":[{"a":2},93],"n":73,"s":[{".":73},22]},"s":78,"u":93,"x":93},75],"f":93,"g":93,"h":93,"i":{"c":[{"h":22},0],"d":[{"a":{"n":6},"e":[{"i":6,"m":23},22],"o":72},77],"e":[{"l":4},88],"g":1,"l":{"e":{"r":6},"i":{"a":25},"o":6,"u":21},"m":2,"n":{"s":37},"s":[{"a":6,"e":21,"p":6,"s":37,"t":[{"ä":12},4],"u":6},73],"t":[{"e":1,"u":115},78],"v":{"e":10}},"j":71,"k":[{"a":{"l":22}},248],"l":[{"ä":82,"e":82},501],"m":93,"n":93,"o":{"d":77,"e":158,"r":72,"s":2},"ö":152,"p":[{"o":{"r":{"t":{"e":{"r":33},"r":277}}}},189],"q":71,"r":71,"s":161,"t":[{"a":[{"b":162,"n":[{"t":6},82],"s":82},0],"ä":[{"t":82},104],"b":{"l":{"o":[{"c":{"k":279}},19]}},"e":{"d":113,"i":{"n":0},"l":104,"n":{"t":89},"r":{"f":117},"v":104},"f":{"i":22},"h":104,"i":{"d":104,"l":{"a":2,"l":97}},"o":[{"r":89},131],"r":{"a":{"b":159,"n":86,"u":73},"e":{"c":1}},"s":3,"u":{"m":104,"n":104}},189],"u":[{"a":0,"n":[{"t":77},6],"s":[{"a":22,"s":10},23]},75],"v":77,"w":93,"y":{".":78},"z":71},"y":{"a":{"b":93,"c":[{"h":73},227],"h":0,"l":{".":71},"n":{"g":2,"k":71},"q":0,"r":{"a":1},"s":[{"t":4},2]},"ä":{"t":71},"b":[{"e":{"r":2}},71],"c":[{"h":{"i":[{"s":82},73],"n":4}},71],"d":[{"o":6,"r":{"i":[{"d":17},22],"o":25}},71],"e":[{"c":73,"d":6,"f":73,"l":289,"n":{"n":12},"r":{"a":22,"e":73,"n":11},"s":[{".":89,"p":2},73],"t":{"h":6}},71],"f":72,"g":[{"i":[{"e":25},2],"l":6},71],"h":[{"o":82,"r":2},71],"i":205,"j":71,"k":[{"e":{"n":4},"l":5,"s":3},72],"l":{"a":[{"g":23,"k":72,"l":12,"m":73,"n":{"e":1,"t":[{"e":5,"i":5},71]},"s":6,"u":22},32],"c":1,"e":[{".":73,"m":0,"s":436,"t":131},2],"i":{"n":12},"o":{"i":[{"d":17},100],"n":{"i":132},"p":6,"r":{"a":0}},"s":3,"t":7},"m":{"a":[{"n":5,"r":5,"s":5},6],"e":5,"p":[{"h":{"a":6},"i":{"e":48}},12]},"n":{"ä":{"r":12},"e":{"u":6},"k":2,"o":[{"t":12,"z":6},113],"t":3},"o":{"b":2,"d":73,"g":{"a":25},"m":2,"n":{"a":2,"t":71},"p":{"e":6},"s":[{"t":73},0],"u":71},"p":[{"a":{"b":162,"n":2},"e":[{"r":{"o":485}},232],"f":73,"i":{"d":113,"n":104},"l":{"o":73},"o":171,"s":128,"t":{"h":1},"u":[{"m":104},2]},93],"q":71,"r":[{"e":79,"i":[{"e":[{"n":4},13]},82],"o":[{"s":{"t":25}},82],"r":2},71],"s":[{"a":{"n":6},"c":{"h":10},"e":[{"i":{"n":105}},21],"l":128,"m":{"e":25},"p":{"o":6,"r":0},"t":{"e":2,"h":[{"e":6},2],"o":1,"r":[{"a":5,"o":89},1],"y":79},"u":[{"r":104},2],"z":79},77],"t":[{"e":{".":73,"s":73},"h":[{"e":48},6],"o":[{"s":22},211],"r":128},71],"u":{"r":[{"e":162},6]},"v":71,"w":71,"y":71,"z":[{"e":{"r":{"i":37}}},72]},"z":{"a":{"b":[{"l":4},152],"c":[{"h":[{"s":22},93]},0],"d":152,"f":93,"g":{"r":1},"h":[{"l":{"e":{"n":4}},"n":{"e":{"r":341}}},88],"k":[{"k":106},71],"l":[{"d":106,"i":78},93],"m":152,"n":[{"a":502,"b":76,"e":1,"f":76,"g":{"s":76},"k":[{"a":2},88],"l":82,"r":76,"t":{"i":132}},72],"p":{"f":5},"q":71,"r":[{".":78,"b":77,"e":1,"m":77,"o":88,"r":73,"t":{"r":11}},71],"s":[{"c":6,"t":10},93],"t":[{"e":2,"o":6},82],"u":{"b":78,"f":321,"g":76,"n":78,"r":82,"t":93}},"ä":[{"c":93,"h":[{"i":1,"n":78},73],"m":93,"n":71,"p":71,"r":71,"u":{"s":93,"ß":77}},6],"b":[{"e":{"r":{"e":22}},"ü":{"b":[{"e":17},13]}},309],"c":76,"d":[{"a":{"n":22},"ä":13,"i":{"s":{"t":13}}},161],"e":{".":78,"a":77,"b":{"e":{"n":152}},"c":[{"h":{"o":152}},0],"e":[{"u":25},32],"f":{"f":93},"g":{"a":72},"h":{"e":[{"n":132},10],"l":2,"o":1},"i":{"f":184,"k":10,"l":[{"a":4,"e":19},22],"n":[{".":1,"d":104,"e":12,"h":106,"s":{"e":1}},93],"s":[{"k":4},150],"t":[{"a":11,"e":{"r":27},"o":12,"r":[{"i":25},2]},78]},"k":12,"l":{"a":[{"d":22,"n":37},21],"ä":21,"d":9,"e":{"k":139,"m":84,"n":6,"r":21},"i":{"n":21,"t":152},"l":{"a":[{"b":12,"c":27,"r":12},4],"e":{"i":{"n":26},"r":{"t":351,"z":29}},"s":266},"m":10,"o":21,"s":[{"a":4,"z":4},22],"t":{"i":2}},"m":{"b":{"e":105},"p":93},"n":{".":194,"a":{"c":41,"s":5,"u":4},"ä":6,"e":{"m":3,"n":132},"g":{"e":{".":84},"l":89,"p":77},"i":[{"d":6},77],"k":22,"n":4,"o":[{"t":5},23],"s":{"e":{"m":225,"r":12},"p":22},"t":{"n":73,"s":71,"w":77,"z":77},"z":{"e":{"r":27},"w":2}},"o":{"r":12},"r":{".":88,"a":{"d":6,"l":0,"t":6},"e":[{"k":7,"m":2},73],"f":{"e":73,"ü":{"l":82}},"g":{"ä":93,"e":{"b":106,"s":89},"l":89,"o":{"n":12},"u":189},"h":{"e":88,"ö":76},"i":{"n":{"t":{"e":15}}},"k":{"o":73},"l":{".":78,"a":{"u":12},"e":{".":12,"b":84,"n":12},"ö":77},"n":[{"a":{"n":12},"e":{"b":199,"i":12}},88],"ö":[{"f":2},93],"q":93,"r":{"e":{"g":106}},"s":[{".":73,"a":470},22],"t":{"a":[{"g":27,"n":10},105],"e":{"n":{"g":26},"r":{"e":26,"l":26}},"i":{"n":12},"o":2,"r":{"a":{"g":209,"u":26}}},"w":{"e":[{"i":84},71]},"z":[{"e":2},71]},"s":{".":88,"ä":6,"c":{"h":1},"e":13,"p":[{"o":5},6],"s":{"a":2,"e":{"n":[{"d":46,"t":26},102],"r":341},"p":2,"t":2},"t":{"a":[{"u":1},0],"r":0}},"t":{".":73,"a":77,"h":80,"r":6,"t":{"s":77}},"u":{"g":{"e":{"m":12},"r":162},"l":93,"r":0},"x":258},"f":[{"e":{"u":{"e":105}}},309],"g":[{"e":{"r":{"a":22,"s":277}}},134],"h":[{"e":{"n":73},"i":{"r":25}},152],"i":{"a":{"l":{"o":1},"r":6},"c":{"h":{"o":22}},"d":{"e":{"i":6}},"e":{"l":{"e":{"r":12},"i":11},"n":{"s":25},"r":{"h":0},"s":[{"s":1},0]},"g":{"s":12},"l":[{"e":2},73],"m":{"p":77,"t":27},"n":{"d":93,"e":[{"i":4},2],"f":93,"h":71,"i":{"n":14,"t":13},"j":93,"n":{"a":12},"o":12,"s":{"a":2,"e":{"r":12},"u":{"f":84}},"t":77},"o":23,"r":{"k":[{"s":33},22]},"s":{"o":71,"p":6,"s":{"e":19},"z":3},"t":{"h":[{"e":105},0],"o":176,"u":2},"v":2},"j":93,"k":246,"l":[{"e":{"i":{"t":{"i":25}},"s":13},"y":82},152],"m":[{"e":{"e":2}},161],"n":161,"o":{"a":{"s":82},"b":93,"f":93,"g":{"l":6,"s":27},"h":93,"l":{"l":{"a":2,"e":{"r":[{"l":26,"t":26},102]}}},"n":{"a":{"l":105,"u":4},"s":195,"t":{"e":{"r":27}}},"o":6,"p":{"e":77},"r":[{"e":1,"n":[{"e":12},88]},152],"s":{"z":93},"u":93,"z":152},"ö":{"f":80,"k":93,"l":[{".":77,"l":88,"s":77},71],"n":77},"p":309,"q":93,"r":243,"s":[{"a":[{"u":22},82],"h":82,"k":82,"p":{"o":{"r":105}},"t":269,"z":82},205],"t":[{"a":{"n":[{"e":1},2],"u":104},"e":{"h":{"e":89},"i":{"n":[{"s":1},132]},"l":6,"m":{"a":4},"n":{"t":114},"r":{"z":114},"s":{"t":{"r":4}},"t":6},"h":{"e":[{"m":82,"r":79},0],"i":0,"o":1,"r":82,"y":82},"i":82,"r":{"e":{"c":1},"i":{"c":1}},"s":3,"ü":82},93],"u":[{"a":1,"b":12,"c":[{"h":{"e":22,"t":{"r":17}}},78],"d":[{"i":10},12],"e":{"l":6,"r":365,"t":2},"f":16,"g":{"e":{"m":2,"n":{"t":5}},"i":2,"l":[{"a":5,"ö":5},1],"o":6},"h":{"r":93,"u":1},"i":2,"k":1,"l":2,"m":{".":93,"a":2,"b":93,"e":{"n":105},"f":77,"g":77,"i":2,"k":77,"l":77,"r":77,"s":93,"u":2},"n":{"a":{"b":77},"e":[{"m":93},2],"f":10,"g":[{"e":{"t":84},"l":77},10],"i":[{"o":80,"v":77},71],"r":77,"s":93,"t":77},"o":2,"p":{"f":{"i":2},"l":1},"r":{"a":3,"k":93,"l":93,"n":93,"s":93,"t":93},"s":[{"c":{"h":19}},16],"t":[{"r":12,"u":12,"z":4},47],"z":2},0],"ü":{"b":372,"c":78,"r":{"c":13}},"v":93,"w":[{"a":{"c":71,"g":77,"h":84,"p":84,"r":71,"s":108},"ä":{"s":77},"e":{"d":93,"g":77,"h":77,"i":{"g":73,"l":77,"t":{"e":{"r":312}}},"l":93,"n":93,"r":93,"s":93},"i":{"c":73,"e":12,"n":{"g":78},"r":{"t":77},"s":{"c":73,"s":77},"t":73},"o":93,"ö":{"r":71},"u":{"r":71},"ü":93},6],"y":{"a":{"n":{".":0}},"l":{"e":6}},"z":[{"a":[{"b":9,"l":128,"t":5},79],"i":{"d":104,"n":503,"s":184},"ö":6,"u":{"g":{"s":10}}},93]}}',
      []
    ];
  });
})(js);
var $0 = js.exports, H0 = to(
  $0
), qo = H0, Us = { exports: {} };
(function(t) {
  (function(e, a) {
    t.exports ? t.exports = a() : e.hyphenationPatternsEnUs = a();
  })(va, function() {
    return [
      "0004,004,001,003,005,0005,00005,000005,0002,002,0000005,0003,00003,00505,00034,0001,00055,00004,4,05,0055,04,42,03,02,2,404,3,044,01,0505,55,5,045,041,0033,000004,22,00504,5504,0042,1,21,41,402,405,4004,43,23,000054,303,3005,022,5004,000003,252,45,25,2004,000505,054,403,401,3002,0025,144,432,00054,34,12,234,0022,014,0304,012,143,503,0403,101,052,414,212,011,043,00002,0041,0024,05005,03003,00102,0404,04303,01004,0034,025,0044,00404,00025,0103,042,0205,412,104,54,344,433,5005,253,055,0402,3004,0043,204,505,454,0000004,00303,04004,552,201,4005,0255,52,444,14,44,02004,033,05004,00045,00013,0021,0405,00044,0054,50055,000303,00001,304,0204,11,301,232,122,00305,504,000043,0104,00052,000045,50004,0023,00033,00032,00202,5003,202,0401,0000505,214,102,032,000161,004101,00501,00301,0036,0052,00023,006101,006,00401,000521,0014,0063,00012,000501,000006,000604,000601,005001,005005,0010305,00006,003012,003005,0003011,0061,013,000021,000022,000105,00211,00062,00051,000112,006013,000011,0200306,1021,0050001,003003,2102,305,000015,01030005,000035,001011,00021,16330001,0234,030006,5020001,000001,00016,0031,021,21431,002305,0350014,0000012,000063,00101,106,105,00435,00063,0300061,00041,100306,003602,023,0503,0010011,10003,1005,30011,00031,0001001,0000061,0030003,30305,001201,0301,5000101,500101,00015,000401,000065,000016,0000402,0500002,000205,030201,500301,00014,5001,000002,00030011,01034,0300006,030213,00400304,050001,05003,000311,0634,00061,0006,00000604,00050013,00213,0030001,100003,000033,30002,00003632,0003004,050003,0000021,006303,0000006,00005005,30451,03001,00231,00056,00011,6,001001,00500001,03005,503005,0000010001,1002,003001,001065,300001,32011,32,0000003,0213001,0500053,021005,10001,0000011,0001041,0020016,100032,50011,0606,5002,3001,03002,0015001,0102,00003001,000000033,0000001,300101,300015,0101003,00000101,0100501,0101,0010033,00000362,000014,0005001,031",
      '{".":{"a":{"c":{"h":0},"d":{"d":{"e":{"r":1}}},"f":{"t":2},"l":{"t":3},"m":{"a":{"t":4}},"n":{"c":4,"g":0,"i":{"m":5},"t":[{"e":3,"i":{"s":6}},0]},"r":{"s":4,"t":{"i":{"e":1},"y":1}},"s":{"c":3,"p":2,"s":2,"t":{"e":{"r":7}}},"t":{"o":{"m":6}},"u":{"d":2},"v":{"i":1},"w":{"n":0}},"b":{"a":{"g":1,"n":{"a":4},"s":{"e":0}},"e":{"r":[{"a":4},0],"s":{"m":3,"t":{"o":4}}},"r":{"i":8},"u":{"t":{"t":{"i":0}}}},"c":{"a":{"m":{"p":{"e":0}},"n":{"c":5},"p":{"a":{"b":6}},"r":{"o":{"l":5}},"t":1},"e":{"l":{"a":1}},"h":[{"i":{"l":{"l":{"i":7}}}},1],"i":[{"t":{"r":5}},9],"o":{"e":3,"r":[{"n":{"e":{"r":5}}},1],"n":{"g":{"r":5}}}},"d":{"e":{"m":{"o":{"i":1}},"o":3,"r":{"a":3,"i":[{"v":{"a":4}},3]},"s":{"c":0}},"i":{"c":{"t":{"i":{"o":10}}}},"o":{"t":1},"u":{"c":1,"m":{"b":6}},"r":{"i":{"v":67}}},"e":{"a":{"r":{"t":{"h":7}},"s":{"i":11}},"b":1,"e":{"r":0},"g":9,"l":{"d":4,"e":{"m":3}},"n":{"a":{"m":12},"g":3,"s":3},"q":{"u":{"i":{"t":13}}},"r":{"r":{"i":1}},"s":3,"u":[{"l":{"e":{"r":1}}},3],"y":{"e":5},"t":{"h":{"y":{"l":162}}},"v":[{"e":{"r":{"s":{"i":{"b":158}}}}},9]},"f":{"e":{"s":11},"o":{"r":{"m":{"e":{"r":5}}}}},"g":{"a":[{"s":{"o":{"m":163}}},9],"e":[{"n":{"t":14},"o":{"g":4,"m":{"e":1},"t":164}},9],"i":{"a":4,"b":1},"o":{"r":1}},"h":{"a":{"n":{"d":{"i":6},"k":5}},"e":[{"r":{"o":{"i":6,"e":3}},"s":11,"t":11,"m":{"o":165},"p":{"a":166}},9],"i":{"b":3,"e":{"r":3}},"o":{"n":{"e":{"y":5},"o":11},"v":5}},"i":{"d":{"l":1,"o":{"l":12}},"m":{"m":3,"p":{"i":{"n":4}}},"n":[{"c":{"i":3},"e":8,"k":9,"s":3,"u":{"t":167}},2],"r":{"r":4},"s":{"i":1}},"j":{"u":{"r":3}},"l":{"a":{"c":{"y":1},"m":1,"t":{"e":{"r":5},"h":6}},"e":[{"g":{"e":5},"n":0,"p":5,"v":15,"i":{"c":{"e":{"s":170}}}},9],"i":{"g":[{"a":5},1],"n":9,"o":3,"t":1}},"m":{"a":{"g":{"a":16},"l":{"o":5},"n":{"a":5},"r":{"t":{"i":5}}},"e":[{"r":{"c":11},"t":{"e":{"r":4},"a":{"l":{"a":0}}},"g":{"a":{"l":171}}},9],"i":{"s":[{"t":{"i":6},"e":{"r":{"s":173}}},15],"m":{"i":{"c":172}}},"o":{"n":{"e":11},"r":{"o":3}},"u":{"t":{"a":[{"b":6},4]}}},"n":{"i":{"c":1},"e":{"o":{"f":174}},"o":{"e":{"t":{"h":15}},"n":{"e":{"m":175}}}},"o":{"d":[{"d":5},9],"f":{"t":{"e":4}},"r":{"a":{"t":{"o":4}},"c":3,"d":2,"t":3},"s":[{"t":{"l":1}},3],"t":{"h":11},"u":{"t":11}},"p":{"e":{"d":{"a":{"l":5}},"t":{"e":4,"i":{"t":4}}},"i":{"e":1,"o":{"n":5},"t":9},"r":{"e":{"m":11,"a":{"m":15}}},"o":{"l":{"y":{"s":137}},"s":{"t":{"a":{"m":137}}}}},"r":{"a":{"c":1,"n":{"t":0},"t":{"i":{"o":{"n":{"a":7}}}},"v":{"e":{"n":{"o":176}}}},"e":{"e":[{"c":173},8],"m":{"i":{"t":4}},"s":[{"t":{"a":{"t":4}}},8]},"i":{"g":1,"t":{"u":5}},"o":{"q":1,"s":{"t":5},"w":{"d":5}},"u":{"d":1}},"s":{"c":{"i":{"e":11}},"e":{"l":{"f":6,"l":6},"n":9,"r":{"i":{"e":4}},"m":{"i":[{"c":0,"d":177,"p":36,"r":36,"s":178,"v":36},6]}},"h":9,"i":[{"n":{"g":17}},9],"t":[{"a":{"b":{"l":5}}},1],"y":9,"p":{"h":{"i":{"n":179}},"i":{"n":{"o":137}}}},"t":{"a":[{"p":{"e":{"s":{"t":{"r":180}}}}},1],"e":[{"n":{"a":{"n":5}},"l":{"e":{"g":{"r":3}}}},1],"h":9,"i":[{"l":0,"m":{"o":16},"n":{"g":17,"k":5}},9],"o":{"n":{"a":0},"p":[{"i":5,"o":{"g":170}},1],"u":{"s":5},"q":9},"r":{"i":{"b":{"u":{"t":6}}}}},"u":{"n":{"a":[{"t":{"t":144}},2],"c":{"e":3},"d":{"e":{"r":7}},"e":[{"r":{"r":181}},2],"k":4,"o":4,"u":3},"p":3,"r":{"e":11},"s":{"a":4}},"v":{"e":{"n":{"d":{"e":0}},"r":{"a":4}},"i":{"c":{"a":{"r":151}}}},"w":{"i":{"l":{"i":5}},"e":{"b":{"l":131}}},"y":{"e":1},"k":{"i":{"l":{"n":{"i":168}}},"o":{"r":{"t":{"e":169}}}}},"a":{"b":{".":18,"a":{"l":19,"n":19},"e":[{"r":{"d":4}},8],"i":{"a":5,"t":{"a":{"b":13}}},"l":{"a":{"t":4}},"o":{"l":{"i":{"z":20,"c":19}}},"r":[{"o":{"g":4}},18],"u":{"l":3}},"c":{"a":{"r":[{"d":4,"o":4},21],"b":{"l":24}},"e":{"o":{"u":19},"r":2},"h":{"e":{"t":19}},"i":[{"e":23,"n":2,"o":23},22],"r":{"o":{"b":4}},"t":{"i":{"f":5}},"u":{"l":3,"m":1}},"d":[{"d":{"i":{"n":1}},"e":{"r":{".":4}},"i":[{"a":23,"c":{"a":3},"e":{"r":0},"o":23,"t":23,"u":19},25],"l":{"e":1},"o":{"w":3},"r":{"a":{"n":4}},"s":{"u":1},"u":[{"c":23,"m":4},18]},24],"e":{"r":[{"i":{"e":17}},1]},"f":[{"f":[{"i":{"s":{"h":170}}},0]},24],"g":{"a":{"b":21,"n":0},"e":{"l":{"l":4},"o":0,"u":18},"i":2,"l":26,"n":2,"o":[{"g":27,"n":{"i":3}},24],"u":{"e":{"r":19},"l":4},"y":21},"h":{"a":23,"e":23,"l":1,"o":23},"i":[{"a":19,"c":{".":23},"l":{"y":4},"n":[{"i":{"n":5},"o":5},28],"t":{"e":{"n":5}}},9],"j":29,"k":{"e":{"n":2}},"l":{"a":{"b":4,"d":3,"r":21},"d":{"i":18},"e":[{"n":{"d":3,"t":{"i":21}},"o":30},25],"i":[{"a":{".":1},"e":0},2],"l":{"e":{"v":4},"i":{"c":18}},"m":18,"o":{"g":{".":19}},"y":{".":21,"s":[{"t":31},18],"t":32,"z":27}},"m":{"a":[{"b":4,"g":3,"r":{"a":5},"s":{"c":4},"t":{"i":{"s":21},"o":33}},18],"e":{"r":{"a":4},"n":{"t":{"a":{"b":182}}}},"i":{"c":3,"f":4,"l":{"y":4},"n":[{"o":0},2]},"o":[{"n":19,"r":{"i":6}},24],"p":{"e":{"n":5}}},"n":[{"a":{"g":{"e":3},"l":{"y":[{"s":183},27]},"r":[{"c":3,"i":17},23],"t":{"i":23}},"d":[{"e":{"s":17},"i":{"s":3},"l":2,"o":{"w":1}},18],"e":{"e":19,"n":23,"s":{"t":{".":4}},"u":23},"g":[{"i":{"e":5},"l":2},25],"i":{"c":34,"e":{"s":23},"f":35,"m":{"e":1,"i":19},"n":{"e":19},"o":3,"p":23,"s":{"h":3},"t":3,"u":23},"k":{"l":{"i":1}},"n":{"i":{"z":32}},"o":[{"t":[{"h":7},4],"a":{"c":148}},0],"s":{"a":9,"c":{"o":1},"n":1,"p":[{"o":11},9],"t":1,"u":{"r":1},"g":{"r":5},"v":11},"t":{"a":{"l":36},"i":{"e":1,"d":137,"n":184,"r":{"e":137}},"o":18,"r":9,"w":1},"u":{"a":3,"l":3,"r":19}},24],"o":18,"p":{"a":{"r":17,"t":4},"e":{"r":{"o":4},"a":{"b":{"l":{"e":132}}}},"h":{"e":{"r":23},"i":18},"i":{"l":{"l":{"a":[{"r":4},21]}},"n":3,"t":{"a":3,"u":23}},"l":24,"o":{"c":6,"l":{"a":4},"r":{"i":6},"s":{"t":12}},"s":{"e":{"s":5}},"u":23},"q":{"u":{"e":6}},"r":[{"a":{"c":{"t":3},"d":{"e":19,"i":{"s":4}},"l":3,"m":{"e":{"t":{"e":19}}},"n":{"g":17},"p":11,"t":[{"i":{"o":19,"v":4}},1],"u":19,"v":38,"w":17},"b":{"a":{"l":36}},"c":{"h":{"a":{"n":1},"e":{"t":185}}},"d":{"i":{"n":{"e":4}},"r":1},"e":{"a":{"s":4},"e":23,"n":{"t":3},"s":{"s":19}},"f":{"i":1,"l":1},"i":[{"a":{"l":4,"n":3},"e":{"t":23},"m":1,"n":{"a":{"t":4}},"o":3,"z":9},2],"m":{"i":9},"o":{"d":20,"n":{"i":19},"o":23},"p":9,"q":3,"r":{"e":17,"a":{"n":{"g":{"e":9}}}},"s":{"a":1,"h":9}},37],"s":{".":18,"a":{"b":1,"n":{"t":3}},"h":{"i":17},"i":{"a":{".":19},"b":23,"c":23,"t":39},"k":{"i":11},"l":1,"o":{"c":21},"p":{"h":4},"s":{"h":1},"t":{"e":{"n":3},"r":2},"u":{"r":{"a":6}},"y":{"m":{"p":{"t":{"o":{"t":4}}}}}},"t":{"a":[{"b":{"l":3},"c":4,"l":{"o":3},"p":4},24],"e":{"c":[{"h":4},5],"g":{"o":3},"n":{".":3},"r":{"a":3,"n":[{"a":19},6]},"s":{"t":3},"v":4},"h":[{"e":{"m":5,"n":19,"r":{"o":{"s":186}}},"o":[{"m":5},1]},18],"i":{".":18,"a":19,"b":20,"c":2,"f":3,"o":{"n":{"a":{"r":7}}},"t":{"u":3}},"o":{"g":21,"m":[{"i":{"z":4}},24],"p":21,"s":21},"r":[{"o":{"p":4}},29],"s":{"k":1},"t":{"a":{"g":1},"e":[{"s":{".":170}},4],"h":1},"u":[{"a":4,"e":4,"l":3,"r":{"a":3}},24],"y":24},"u":{"b":1,"g":{"h":[{"t":{"l":17}},12],"u":3},"l":[{"i":{"f":13}},40],"n":{"d":5},"r":3,"s":{"i":{"b":4}},"t":{"e":{"n":5},"h":2}},"v":{"a":[{"g":3,"n":19},24],"e":{"n":{"o":0},"r":{"a":3,"n":4,"y":4}},"i":[{"e":{"r":0},"g":3,"o":{"u":3}},2],"o":{"c":4,"r":29}},"w":{"a":{"y":27},"i":3,"l":{"y":1},"s":0},"x":{"i":{"c":1,"d":1}},"y":{"a":{"l":4},"e":0,"s":0},"z":{"i":{"e":{"r":0}},"z":{"i":5}}},"b":{"a":{".":32,"d":{"g":{"e":{"r":5}}},"g":{"e":1},"l":{"a":15},"n":{"d":{"a":{"g":5}},"e":0,"i":11},"r":{"b":{"i":7},"i":{"a":17},"o":{"n":{"i":{"e":187}}}},"s":{"s":{"i":0}},"t":[{"h":{"y":2}},41],"z":1,"c":{"k":{"e":{"r":{".":84}}}}},"b":[{"e":[{"r":23},24],"i":{"n":{"a":0},"t":0}},42],"d":43,"e":{".":18,"a":{"k":17,"t":12},"d":[{"a":3,"e":3,"i":3},44],"g":{"i":3,"u":4},"l":[{"i":2,"o":3},41],"m":45,"n":{"i":{"g":4},"u":4},"s":[{"p":3,"t":{"r":4}},46],"t":[{"i":{"z":5},"r":4,"w":3},27],"w":3,"y":{"o":4},"v":{"i":{"e":9}}},"f":25,"h":47,"i":{"b":9,"d":[{"i":{"f":167}},1],"e":[{"n":4,"r":1},27],"f":48,"l":[{"i":{"z":3},"l":{"a":{"b":8}}},41],"n":{"a":{"r":49},"d":0,"e":{"t":4}},"o":{"g":{"r":3},"u":4,"m":5,"r":{"b":2,"h":15}},"t":[{"i":{"o":50,"v":{"e":188}},"r":3,"u":{"a":51},"z":19},9]},"j":29,"k":1,"l":[{"a":{"t":{"h":7},"n":{"d":189}},"e":{".":21,"n":17,"s":{"p":32}},"i":{"s":23,"n":{"d":189}},"o":[{"n":{"d":190}},21],"u":{"n":{"t":17}}},52],"m":43,"n":[{"e":{"g":5}},47],"o":{"d":[{"i":11},27],"e":1,"l":{"i":{"c":11}},"m":{"b":{"i":0}},"n":{"a":[{"t":5},0]},"o":27,"r":{".":32,"a":43,"d":5,"e":32,"i":32,"n":{"o":191}},"s":53,"t":{"a":19,"h":6,"o":1,"u":{"l":192}},"u":{"n":{"d":54}}},"p":18,"r":{"i":{"t":18},"o":{"t":{"h":54}},"u":{"s":{"q":17}}},"s":[{"o":{"r":17}},55],"t":[{"l":1,"o":21,"r":23},25],"u":{"f":{"f":{"e":{"r":0}}},"g":{"a":1},"l":{"i":3},"m":{"i":17},"n":[{"t":{"i":17}},1],"r":{"e":3},"s":{"i":{"e":[{"r":193,"s":193},5]},"s":{"e":17,"i":{"n":{"g":17}}},"t":32},"t":{"a":18,"i":{"o":27},"o":19,"e":{"d":{".":8}},"t":{"e":{"d":0}}}},"v":29,"w":56,"y":{".":32,"s":0}},"c":{"a":[{"b":{"i":{"n":11},"l":2},"c":{"h":17},"d":{"e":{"n":4,"m":194}},"g":46,"h":57,"l":{"a":{"t":3},"l":{"a":0,"i":{"n":6}},"o":18},"n":{"d":5,"e":0,"i":{"c":0,"s":5,"z":11},"t":{"y":0},"y":17},"p":{"e":{"r":4}},"r":{"o":{"m":5}},"s":{"t":{"e":{"r":6},"i":{"g":5}},"y":18},"t":{"h":1,"i":{"v":18},"a":{"s":195}},"v":{"a":{"l":5}}},41],"c":[{"h":{"a":6},"i":{"a":0},"o":{"m":{"p":{"a":10}},"n":17,"u":{"t":12}}},23],"e":{".":25,"d":{".":18,"e":{"n":18}},"i":27,"l":{".":32,"l":27},"n":[{"c":27,"e":58,"i":18,"t":27},41],"p":27,"r":{"a":{"m":4}},"s":{"a":18,"s":{"i":[{"b":59},27]},"t":5},"t":[{"a":60},0],"w":0},"h":[{".":18,"a":{"b":61,"n":{"i":{"c":32,"s":20}}},"e":[{"a":{"p":54},"d":18,"l":{"o":5},"m":{"i":27},"n":{"e":4},"r":{".":3,"s":3}},8],"i":{"n":[{"e":{".":32,"s":{"s":4}},"i":32},62],"o":32,"t":27,"z":8,"e":{"v":{"o":6}}},"o":63,"t":{"i":1},"s":{".":18,"h":{"u":11}}},25],"i":[{"a":[{"b":64,"r":5},27],"c":4,"e":{"r":18},"f":{"i":{"c":{".":32}}},"i":18,"l":{"a":1,"i":27},"m":25,"n":[{"a":[{"t":27},21],"e":{"m":11},"g":[{".":19},29],"o":32,"q":8},25],"o":{"n":17},"p":{"e":18,"h":3,"i":{"c":18}},"s":{"t":{"a":18,"i":18}},"t":[{"i":{"z":11}},42],"z":32,"g":{"a":{"r":152}}},41],"k":[{"i":3},2],"l":[{"a":{"r":[{"a":{"t":{"i":{"o":19}}},"e":32},18]},"e":{"m":0,"a":{"r":0}},"i":{"c":18,"m":17},"y":0},65],"n":19,"o":[{"a":{"g":4},"e":8,"g":[{"r":1},25],"i":[{"n":{"c":3}},0],"l":{"i":5,"o":[{"r":11},32]},"m":{"e":{"r":5}},"n":{"a":0,"e":21,"g":11,"t":5},"p":{"a":3,"i":{"c":11},"l":1,"h":{"o":{"n":196}}},"r":{"b":18,"o":{"n":12}},"s":{"e":0},"v":[{"e":17},15],"w":{"a":5},"z":{"e":5,"i":4},"u":{"s":{"t":{"i":84}}}},41],"q":29,"r":{"a":{"s":{"t":6},"t":{".":32,"i":{"c":32}}},"e":{"a":{"t":11},"d":32,"t":{"a":47},"v":0},"i":[{"f":5,"n":21,"s":17,"t":{"i":[{"e":11},32]}},8],"o":{"p":{"l":0,"o":6},"s":{"e":17},"c":{"o":{"d":197}},"e":{"c":{"o":148}}},"u":{"d":0}},"s":66,"t":[{"a":{"b":0,"n":{"g":4,"t":19}},"e":[{"r":23},24],"i":{"c":{"u":21},"m":{"i":12}},"u":{"r":0},"w":21,"r":{"o":{"m":{"e":{"c":198}}}}},42],"u":{"d":5,"f":21,"i":[{"t":{"y":4}},21],"l":{"i":32,"t":{"i":{"s":0},"u":27}},"m":{"a":9,"e":23,"i":1},"n":27,"p":{"i":3,"y":4},"r":{"a":{"b":67,"n":{"c":{"e":199}}},"i":{"a":4}},"s":[{"s":{"i":17}},41],"t":[{"i":{"e":1,"v":56},"r":18},68]},"y":41,"z":{"e":0}},"d":{"a":[{".":32,"b":70,"c":{"h":17},"f":18,"g":25,"m":71,"n":{"g":11},"r":{"d":6,"k":6,"y":18},"t":[{"i":{"v":18},"o":18,"a":{"b":137}},27],"v":[{"e":5},53],"y":32,"l":{"o":{"n":{"e":48}}}},69],"b":29,"c":19,"d":[{"a":{"b":20},"i":{"b":94}},72],"e":{".":25,"a":{"f":6,"l":{"s":{".":1}}},"b":{"i":{"t":5},"o":{"n":1}},"c":{"a":{"n":36},"i":{"l":1},"o":{"m":4},"l":{"a":{"r":200},"i":{"n":{"a":64}}}},"d":42,"e":{".":18},"i":{"f":4},"l":{"i":{"e":17,"q":16},"o":4},"m":[{".":32,"i":{"c":[{".":5},27],"l":4},"o":{"n":{"s":1},"r":7,"s":9}},21],"n":[{"a":{"r":1},"o":3,"t":{"i":{"f":7}},"u":3},41],"p":[{"a":3,"i":17,"u":9},2],"q":23,"r":{"h":21,"m":32,"n":{"i":{"z":6}},"s":5},"s":[{".":24,"c":2,"o":64,"t":{"i":11,"r":3},"u":1,"i":{"c":11}},8],"t":[{"o":9,"i":{"c":9}},2],"v":[{"i":{"l":11}},2],"y":18,"f":{"i":{"n":{"i":{"t":{"i":201}}}}}},"f":43,"g":{"a":21,"e":{"t":73},"i":2,"y":24},"h":74,"i":{".":32,"a":[{"b":5},75],"c":{"a":{"m":1,"i":{"d":15}},"e":21,"t":27},"d":27,"e":{"n":76},"f":[{"f":{"r":{"a":5}}},29],"g":{"e":3},"l":{"a":{"t":{"o":1}}},"n":[{"a":41,"e":{".":27},"i":[{"z":4},32]},29],"o":[{"g":5},41],"p":{"l":1},"r":[{"e":[{"n":9,"r":9},2],"t":{"i":6}},8],"s":[{"i":32,"t":77},15],"t":{"i":24},"v":78,"m":{"e":{"t":{"h":{"y":141}}}}},"j":29,"k":79,"l":{"a":56,"e":{".":27,"d":27,"s":{".":27,"s":18},"a":{"d":42}},"o":48,"u":56,"y":25,"i":{"e":202}},"m":29,"n":80,"o":[{".":27,"d":{"e":4},"e":32,"f":57,"g":21,"l":{"a":1,"i":17,"o":{"r":4}},"m":{"i":{"z":5}},"n":{"a":{"t":3},"i":17},"o":{"d":11},"p":{"p":0},"r":21,"s":27,"u":{"t":56},"v":1,"x":27,"w":{"o":{"r":{"d":203}}}},41],"p":29,"r":[{"a":{"g":{"o":{"n":6}},"i":18},"e":[{"a":{"r":6},"n":[{"a":{"l":204}},32]},0],"i":{"b":0,"l":17,"f":{"t":{"a":189}},"p":{"l":{"e":{"g":205}}}},"o":{"p":0,"w":18,"m":{"e":{"d":206}}},"u":{"p":{"l":{"i":32}}},"y":18},41],"s":[{"p":1,"w":21,"y":21},81],"t":{"h":24,"a":{"b":23}},"u":[{"a":[{"l":{".":9}},82],"c":[{"a":29,"e":{"r":5},"t":{".":18,"s":18}},9],"e":{"l":4},"g":1,"l":{"e":23},"m":{"b":{"e":0}},"n":1,"p":[{"e":1},18],"o":{"p":{"o":{"l":207}}}},41],"v":29,"w":29,"y":[{"n":32,"s":{"e":1,"p":5}},24]},"e":{"a":{"b":72,"c":{"t":23},"d":[{"i":{"e":5}},15],"g":{"e":[{"r":4},1]},"l":[{"e":{"r":5},"o":{"u":11}},1],"m":{"e":{"r":11}},"n":{"d":19,"i":{"e":{"s":111}}},"r":{"a":11,"c":0,"e":{"s":5},"i":{"c":0,"l":0},"k":5,"t":[{"e":12},8]},"s":{"p":4,"s":23,"t":12},"t":[{"e":{"n":5},"h":{"i":12},"i":{"f":19},"u":83},9],"v":[{"e":{"n":11},"i":5,"o":5},9]},"b":[{"e":{"l":{".":21,"s":21},"n":21},"i":{"t":21},"r":23},42],"c":{"a":{"d":21,"n":{"c":6}},"c":{"a":6},"e":[{"s":{"s":{"a":4}}},29],"i":[{"b":21,"f":{"i":{"c":{"a":{"t":4}},"e":4},"y":4},"m":3,"t":[{"e":19},0]},9],"l":{"a":{"m":21},"u":{"s":21}},"o":{"l":24,"m":{"m":21,"p":{"e":21}},"n":{"c":21},"r":[{"a":3,"o":5},24]},"r":[{"e":{"m":21}},29],"t":{"a":{"n":1},"e":1},"u":[{"l":[{"a":3},21]},29],"h":{"a":{"s":23}}},"d":{"a":37,"d":61,"e":{"r":34,"s":0},"i":[{"a":23,"b":3,"c":{"a":3},"m":3,"t":2,"z":5},18],"o":[{"l":21,"n":84},18],"r":{"i":21},"u":{"l":[{"o":4,"i":{"n":{"g":2}}},21]},"g":{"l":15}},"e":{"c":9,"d":{"i":11},"f":9,"l":{"i":11,"y":1},"m":9,"n":{"a":1},"p":85,"s":[{"t":17},86],"t":{"y":1},"x":19},"f":[{"e":{"r":{"e":83}},"f":41,"i":{"c":[{"i":32},21],"l":17,"n":{"e":23,"i":{"t":{"e":20}}},"t":27},"o":{"r":{"e":{"s":6}}},"u":{"s":{"e":{".":21}}}},29],"g":{"a":{"l":18},"e":{"r":17},"i":{"b":4,"c":1,"n":{"g":4},"t":87},"n":4,"o":{".":21,"s":21},"u":{"l":2,"r":19},"y":32},"h":[{"e":{"r":17}},72],"i":[{"c":19,"d":4,"g":[{"l":4},8],"m":{"b":23},"n":{"f":23,"g":29,"s":{"t":19}},"r":{"d":0},"t":{"e":11,"h":3,"y":19}},9],"j":[{"u":{"d":[{"i":4},21]}},29],"k":{"i":{"n":0},"l":{"a":1}},"l":{"a":[{".":21,"c":21,"n":{"d":17},"t":{"i":{"v":4}},"w":21,"x":{"a":36}},29],"e":{"a":23,"b":{"r":{"a":4}},"c":32,"d":21,"g":{"a":3},"n":19,"r":34,"s":29},"f":9,"i":[{"b":{"e":23},"c":{".":33,"a":3},"e":{"r":23},"g":{"i":{"b":4}},"m":19,"n":{"g":83},"o":23,"s":[{"h":4},24],"v":88,"t":{"i":{"s":208}}},9],"l":{"a":[{"b":1},18],"o":17},"o":{"c":19,"g":4,"p":{".":3},"a":29},"s":{"h":9},"t":{"a":1},"u":{"d":19,"g":4}},"m":{"a":{"c":21,"g":21,"n":[{"a":4},19]},"b":4,"e":[{"l":24,"t":21},29],"i":{"c":{"a":3},"e":0,"g":{"r":{"a":4}},"n":[{"e":4,"i":35},89],"s":[{"h":4,"s":19},21],"z":3},"n":{"i":{"z":32}},"o":{"g":0,"n":{"i":{"o":7}}},"p":{"i":3},"u":{"l":[{"a":4},21],"n":11},"y":23},"n":{"a":{"m":{"o":4},"n":{"t":21}},"c":{"h":{"e":{"r":17}}},"d":{"i":{"c":3,"x":2}},"e":{"a":19,"e":19,"m":3,"r":{"o":4},"s":{"i":4,"t":4},"t":{"r":3},"w":23},"i":{"c":{"s":4},"e":19,"l":19,"o":23,"s":{"h":3},"t":3,"u":19,"z":32},"n":18,"o":[{"g":0,"s":21,"v":3},18],"s":{"w":1},"t":{"a":{"g":{"e":5}},"h":{"e":{"s":18}}},"u":{"a":3,"f":4},"y":{".":23},"z":61},"o":{"f":19,"g":[{"r":{"a":{"p":3}}},9],"i":90,"l":23,"p":{"a":{"r":11}},"r":[{"e":3,"o":{"l":4}},29],"s":0,"t":[{"o":1},21],"u":{"t":19},"w":19},"p":{"a":[{"i":23,"n":{"c":4}},24],"e":{"l":19,"n":{"t":23},"t":{"i":{"t":{"i":{"o":4}}}}},"h":{"e":17},"l":{"i":21},"o":29,"r":{"e":{"c":[{"a":4},21],"d":21,"h":3},"o":[{"b":21},23]},"s":{"h":1},"t":{"i":{"b":13}},"u":{"t":[{"a":4},21]},"i":{"n":{"e":{"p":{"h":209}}}}},"q":[{"u":{"i":{"l":12,"s":91}}},29],"r":{"a":[{"b":0,"n":{"d":18},"r":3,"t":{"i":{".":18}}},2],"b":[{"l":1},25],"c":{"h":[{"e":1},3]},"e":{".":25,"a":{"l":23},"c":{"o":5},"i":{"n":11},"l":{".":4},"m":{"o":3},"n":{"a":4,"c":{"e":4},"e":18,"t":3},"q":0,"s":{"s":4,"t":3},"t":17},"h":2,"i":[{"a":[{"n":{".":210}},92],"c":{"k":32},"e":{"n":23,"r":0},"n":{"e":3},"o":29,"t":18,"u":1,"v":[{"a":21},0]},2],"m":93,"n":{"i":{"s":1,"t":18,"z":32},"o":3},"o":[{"b":4,"c":19,"r":0,"u":2},25],"s":[{"e":{"t":3}},2],"t":{"e":{"r":11},"l":18,"w":3},"u":[{"t":0},18],"w":{"a":{"u":32}}},"s":{"a":[{"g":{"e":{".":21,"s":21}}},72],"c":[{"a":[{"n":4},24],"r":23,"u":4},9],"e":[{"c":[{"r":4},24],"n":{"c":4},"r":{"t":{".":21,"s":21},"v":{"a":21}}},74],"h":[{"a":23,"e":{"n":5}},18],"i":[{"c":24,"d":[{"e":{"n":4}},24],"g":{"n":{"a":4}},"m":94,"n":95,"s":{"t":{"e":17}},"u":0},29],"k":{"i":{"n":19}},"m":{"i":1},"o":{"l":[{"u":3},24],"n":[{"a":4},24]},"p":[{"e":{"r":3},"i":{"r":{"a":4}},"r":{"e":1},"a":{"c":{"i":211}}},29],"s":[{"i":{"b":96}},25],"t":{"a":{"n":36},"i":{"g":3,"m":4},"o":[{"n":23},44],"r":[{"o":19,"u":{"c":10}},25]},"u":{"r":[{"r":4},24]},"w":1},"t":{"a":{"b":0},"e":{"n":{"d":17},"o":23},"h":{"o":{"d":54},"y":{"l":{"e":{"n":{"e":162}}}}},"i":{"c":2,"d":{"e":19},"n":[{"o":0},17],"r":19,"t":{"i":{"o":19,"v":4}}},"n":18,"o":{"n":{"a":4}},"r":{"a":23,"e":23,"i":{"c":3,"f":4},"o":{"g":3,"s":4}},"u":{"a":3},"y":{"m":4},"z":4},"u":[{"n":19,"p":23,"r":{"o":3},"s":0,"t":{"e":17,"i":{"l":6},"r":4},"c":{"l":{"i":{"d":212}}}},18],"v":{"a":{"p":97,"s":[{"t":4},24]},"e":{"a":19,"l":{"l":3,"o":12},"n":{"g":19,"i":17},"r":[{"b":19},2]},"i":[{"d":3,"l":0,"n":21,"v":0},29],"o":{"c":19},"u":19},"w":{"a":[{"g":21},29],"e":{"e":19},"h":23,"i":{"l":6,"n":{"g":3},"t":23}},"x":{"p":41},"y":{"c":32,"e":{".":32},"s":0}},"f":{"a":[{"b":{"l":3,"r":11},"c":{"e":1},"g":18,"i":{"n":17},"l":{"l":{"e":6}},"m":{"a":26,"i":{"s":5}},"r":[{"t":{"h":5}},32],"t":{"a":3,"h":{"e":3},"o":18},"u":{"l":{"t":7}}},41],"b":56,"d":18,"e":{".":18,"a":{"s":17,"t":{"h":54}},"b":[{"r":{"u":{"a":15}}},1],"c":{"a":18,"t":32},"d":25,"l":{"i":3},"m":{"o":1},"n":{"d":[{"e":6},8]},"r":[{"r":32,"m":{"i":{"o":213}}},15],"v":0},"f":[{"e":{"s":21},"i":{"e":21,"n":{".":19},"s":94},"l":{"y":21},"y":24},43],"h":18,"i":[{"a":3,"c":{".":48,"a":{"l":47,"n":23,"t":{"e":18}},"e":{"n":23,"r":3},"i":[{"a":32,"e":32},0],"s":18,"u":3,"h":27},"d":{"e":{"l":4}},"g":{"h":{"t":7}},"l":{"i":5,"l":{"i":{"n":6}},"y":18},"n":[{"a":32,"d":97,"e":9,"g":98,"n":0},25],"s":{"t":{"i":0}},"t":{"t":{"e":{"d":{".":5}}}}},41],"l":[{"e":{"s":{"s":19}},"i":{"n":17},"o":{"r":{"e":11},"w":{"e":{"r":{".":84}}}},"y":100,"a":{"g":{"e":{"l":214}}},"u":{"o":{"r":27}}},99],"m":18,"n":18,"o":[{"n":[{"d":{"e":0},"t":0},32],"r":[{"a":{"t":4,"y":5},"e":{"t":6},"i":0,"t":{"a":6}},9],"s":5},41],"p":56,"r":{"a":{"t":0},"e":{"a":19,"s":{"c":6}},"i":[{"l":17},8],"o":{"l":6}},"s":48,"t":[{"o":21,"y":24},25],"u":[{"e":{"l":4},"g":18,"m":{"i":{"n":1}},"n":{"e":4},"r":{"i":3},"s":{"i":17,"s":0},"t":{"a":18}},27],"y":41},"g":{"a":[{"f":0,"l":{".":32,"i":27,"o":3},"m":[{"e":{"t":4},"o":19},25],"n":{"i":{"s":5,"z":[{"a":6},3]},"o":18},"r":{"n":67},"s":{"s":17},"t":{"h":12,"i":{"v":18}},"z":18},41],"b":23,"d":1,"e":{".":25,"d":25,"e":{"z":17},"l":{"i":{"n":0,"s":4,"z":4},"y":18},"n":[{"a":{"t":1},"i":{"z":4},"o":18,"y":18,"c":{"y":{".":8}}},41],"o":[{"m":3,"d":215},41],"r":{"y":21},"s":{"i":32},"t":{"h":6,"o":18,"y":1,"i":{"c":{".":8}}},"v":1},"g":[{"e":[{"r":23},24],"l":{"u":6},"o":0},101],"h":{"i":{"n":3},"o":{"u":{"t":4}},"t":{"o":1,"w":{"e":15}}},"i":{".":32,"a":[{"r":5},102],"c":[{"i":{"a":32},"o":21},29],"e":{"n":6,"s":{".":32}},"l":0,"m":{"e":{"n":23}},"n":{".":68,"g":{"e":5},"s":103},"o":32,"r":[{"l":0},27],"s":{"l":23},"u":1,"v":32,"z":27},"l":[{"a":[{"d":{"i":6},"s":32},0],"e":[{"a":{"d":29}},41],"i":{"b":0,"g":23,"s":{"h":43}},"o":[{"r":11,"b":{"i":{"n":106}}},27]},9],"m":[{"y":21},29],"n":{"a":[{".":21,"c":69},1],"e":{"t":{"t":17,"i":{"s":{"m":137}}}},"i":[{"n":24,"o":21},29],"o":[{"n":21,"m":{"o":5},"r":{".":216,"e":{"s":{"p":24}}}},29]},"o":[{".":27,"b":5,"e":32,"g":104,"i":{"s":3},"n":[{"a":105,"d":{"o":7},"i":[{"z":{"a":217}},3]},8],"o":32,"r":{"i":{"z":4},"o":{"u":5}},"s":{".":32},"v":15},41],"p":23,"r":[{"a":{"d":{"a":18},"i":21,"n":84,"p":{"h":{".":32,"e":{"r":[{".":7},19]},"i":{"c":32},"y":18}},"y":18},"e":{"n":0,"s":{"s":{".":18}}},"i":{"t":18,"e":{"v":213}},"o":21,"u":{"f":17}},41],"s":[{"t":{"e":19}},9],"t":{"h":11},"u":{"a":[{"r":{"d":27}},1],"e":25,"i":{"t":106},"n":27,"s":27,"t":[{"a":{"n":29}},26]},"w":23,"y":[{"n":107,"r":{"a":4}},41]},"h":{"a":{"b":{"l":73},"c":{"h":17},"e":{"m":0,"t":0},"g":{"u":19},"l":{"a":[{"m":12},3]},"m":1,"n":{"c":{"i":0,"y":0},"d":{".":32},"g":[{"e":{"r":6},"o":6},0],"i":{"z":108},"k":0,"t":{"e":0}},"p":{"l":11,"t":5,"a":{"r":{"r":218}}},"r":{"a":{"n":3,"s":4},"d":[{"e":12},8],"l":{"e":0},"p":{"e":{"n":6}},"t":{"e":{"r":5}}},"s":{"s":5},"u":{"n":17},"z":[{"a":11},32],"i":{"r":{"s":137}},"t":{"c":{"h":213}}},"b":29,"e":{"a":{"d":41,"r":27},"c":{"a":{"n":1,"t":19}},"d":[{"o":13},21],"l":{"i":93,"l":{"i":{"s":0},"y":0},"o":19},"m":{"p":0},"n":[{"a":[{"t":5},17]},9],"o":{"r":5},"p":5,"r":{"a":[{"p":12},21],"b":{"a":0},"e":{"a":6},"n":23,"o":{"u":19},"y":23},"s":[{"p":64},29],"t":[{"e":{"d":0}},1],"u":0,"x":{"a":168}},"f":29,"h":29,"i":{"a":{"n":4},"c":{"o":1},"g":{"h":6},"l":109,"m":{"e":{"r":36}},"n":{"a":21},"o":{"n":{"e":17}},"p":[{"e":{"l":{"a":219}}},1],"r":{"l":0,"o":3,"p":0,"r":0},"s":{"e":{"l":11},"s":0},"t":{"h":{"e":{"r":6}},"e":{"s":{"i":{"d":12}}}},"v":9},"k":18,"l":[{"a":{"n":17},"o":[{"r":{"i":11}},24]},80],"m":[{"e":{"t":17}},43],"n":[{"a":{"u":{"z":12}}},42],"o":{"d":{"i":{"z":19},"s":19},"g":[{"e":17},1],"l":{"a":{"r":5},"e":110},"m":{"a":1,"e":12},"n":{"a":0,"y":4},"o":{"d":27,"n":17},"r":{"a":{"t":5},"i":{"s":4,"c":{".":187}},"t":{"e":12},"u":4},"s":{"e":[{"n":4},0],"p":15},"u":{"s":[{"e":54},41]},"v":{"e":{"l":5}}},"p":56,"r":[{"e":{"e":6},"o":{"n":{"i":{"z":5}},"p":{"o":11}}},26],"s":[{"h":21},101],"t":{"a":{"r":21},"e":{"n":2,"s":4,"o":{"u":216}},"y":21},"u":{"g":1,"m":{"i":{"n":1}},"n":{"k":{"e":5},"t":0},"s":{"t":14},"t":1},"w":[{"a":{"r":{"t":21}}},29],"y":{"p":{"e":3,"h":3,"o":{"t":{"h":{"a":137}}}},"s":9}},"i":{"a":[{"l":24,"m":[{"e":{"t":{"e":5}}},0],"n":[{"c":18,"i":11,"t":46},24],"p":{"e":4},"s":{"s":17},"t":{"i":{"v":21},"r":{"i":{"c":1}},"u":21}},42],"b":{"e":[{"r":{"a":3,"t":4}},0],"i":{"a":4,"n":3,"t":{".":4,"e":4}},"l":[{"i":3},29],"o":19,"r":[{"i":94},29],"u":{"n":19}},"c":{"a":{"m":18,"p":32,"r":[{".":21,"a":21},18],"s":6,"y":21},"c":{"u":17},"e":{"o":18},"h":18,"i":[{"d":19,"n":{"a":4},"p":[{"a":3},24]},25],"l":{"y":21},"o":{"c":94},"r":[{"a":32,"y":21},43],"t":{"e":1,"u":[{"a":111},84]},"u":{"l":{"a":3},"m":1,"o":4,"r":23}},"d":[{"a":{"i":21,"n":{"c":4}},"d":4,"e":{"a":{"l":11},"s":0},"i":[{"a":{"n":4,"r":0},"e":19,"o":[{"u":5,"s":1},3],"t":2,"u":4},24],"l":{"e":23},"o":{"m":21,"w":3},"r":21,"u":[{"o":4},24]},25],"e":[{"d":{"e":0},"g":{"a":113},"l":{"d":12},"n":{"a":67,"e":0,"n":19,"t":{"i":23}},"r":{".":29},"s":{"c":23,"t":29},"t":23},112],"f":{".":18,"e":{"r":{"o":4}},"f":{"e":{"n":5},"r":1},"i":{"c":{".":18},"e":23},"l":23,"t":18,"a":{"c":{"e":{"t":137}}}},"g":[{"a":{"b":5},"e":{"r":{"a":3}},"h":{"t":{"i":12}},"i":[{"b":23,"l":3,"n":3,"t":3},18],"l":28,"o":[{"r":3,"t":4},24],"r":{"e":19},"u":{"i":5,"r":2},"n":{"i":{"t":[{"e":{"r":213}},0]}}},25],"h":23,"i":114,"j":[{"k":21},23],"k":18,"l":{"a":[{"b":93,"d":{"e":21},"m":94,"r":{"a":5}},29],"e":{"g":23,"r":2,"v":17},"f":4,"i":[{"a":3,"b":9,"o":3,"s":{"t":1},"t":25,"z":9},2],"l":{"a":{"b":5}},"n":18,"o":{"q":3},"t":{"y":1},"u":{"r":4},"v":3},"m":{"a":{"g":[{"e":3},21],"r":{"y":5}},"e":{"n":{"t":{"a":{"r":10}}},"t":18},"i":[{"d":{"a":4},"l":{"e":5},"n":{"i":19},"t":18},2],"n":{"i":1},"o":{"n":23},"u":[{"l":{"a":3}},24],"p":{"e":{"d":{"a":201}}}},"n":{".":25,"a":{"u":83,"v":18},"c":{"e":{"l":36,"r":3}},"d":[{"l":{"i":{"n":{"g":4}}}},18],"e":[{"e":23,"r":{"a":{"r":17}},"s":{"s":19}},25],"g":{"a":18,"e":[{"n":4},18],"i":18,"l":{"i":{"n":{"g":4}}},"o":18,"u":18},"i":[{".":19,"a":21,"o":3,"s":2,"t":{"e":{".":19,"l":{"y":{".":19}}},"i":{"o":32},"y":3}},25],"k":18,"l":18,"n":25,"o":[{"c":90,"s":0,"t":21},42],"s":[{"e":3,"u":{"r":{"a":7}}},25],"t":{".":25,"h":112},"u":[{"s":19},2],"y":18,"f":{"r":{"a":{"s":220}}}},"o":[{".":18,"g":{"e":17,"r":9},"l":29,"m":1,"n":{"a":{"t":11},"e":{"r":{"y":0}},"i":11},"p":{"h":4},"r":{"i":11},"s":21,"t":{"h":4,"i":19,"o":1},"u":{"r":21}},25],"p":[{"e":0,"h":{"r":{"a":{"s":115}}},"i":[{"c":1},3],"r":{"e":96},"u":{"l":3}},25],"q":{"u":{"a":23,"e":{"f":4},"i":{"d":3,"t":116}}},"r":[{"a":[{"b":0,"c":21},29],"d":{"e":5},"e":{"d":{"e":0},"f":21,"l":117,"s":21},"g":{"i":4},"i":[{"d":{"e":5},"s":1,"t":{"u":11},"z":118},2],"m":{"i":{"n":1}},"o":{"g":0,"n":{".":32}},"u":{"l":4},"r":{"e":{"v":{"o":{"c":221}}}}},18],"s":{".":25,"a":{"g":4,"r":3,"s":6},"c":[{"h":3},119],"e":[{"r":3},18],"f":27,"h":{"a":{"n":4},"o":{"n":3,"p":5}},"i":{"b":3,"d":0,"s":19,"t":{"i":{"v":4}}},"k":26,"l":{"a":{"n":36}},"m":{"s":18},"o":[{"m":{"e":{"r":5}}},24],"p":[{"i":9,"y":1},2],"s":[{"a":{"l":1},"e":{"n":36,"s":1}},62],"t":{"a":{".":1},"e":2,"i":2,"l":{"y":0},"r":{"a":{"l":18}}},"u":[{"s":4},24]},"t":{"a":{".":18,"b":{"i":0},"g":21,"m":120,"n":23,"t":23},"e":[{"r":{"a":3,"i":19},"s":[{"i":{"m":{"a":29}}},1]},25],"h":[{"i":{"l":148}},25],"i":[{"a":18,"c":[{"a":3,"k":31},22],"g":3,"l":{"l":4},"m":24,"o":25,"s":[{"m":21},18],"n":{"e":{"r":{"a":{"r":158}}}}},29],"o":{"m":121,"n":18},"r":{"a":{"m":21},"y":4},"t":18,"u":{"a":{"t":3},"d":19,"l":3},"z":{".":18}},"u":29,"v":[{"e":{"l":{"l":3},"n":{".":3},"r":{".":83,"s":{".":21}}},"i":{"l":{".":4},"o":4,"t":2},"o":{"r":{"e":19,"o":35},"t":83}},25],"w":56,"x":{"o":1},"y":18,"z":{"a":{"r":18},"i":0,"o":{"n":{"t":32}}}},"j":{"a":[{"c":{"q":0},"p":[{"a":{"n":{"e":{"s":220}}}},1],"n":{"u":{"a":12}}},32],"e":[{"r":{"s":5,"e":{"m":222}},"s":{"t":{"i":{"e":18},"y":18}},"w":11},41],"o":{"p":1},"u":{"d":{"g":32}}},"k":{"a":{".":27,"b":23,"g":19,"i":{"s":17},"l":0},"b":29,"e":{"d":24,"e":41,"g":1,"l":{"i":[{"n":{"g":223}},4]},"n":{"d":73},"r":29,"s":[{"t":{".":23}},0],"t":{"y":1}},"f":23,"h":1,"i":[{".":32,"c":122,"l":{"l":21,"o":6},"m":21,"n":{".":21,"d":{"e":0},"e":{"s":{"s":19},"t":{"i":{"c":224}}},"g":0},"p":1,"s":[{"h":19},0]},29],"k":1,"l":[{"e":{"y":18},"y":18},29],"m":29,"n":{"e":{"s":19},"o":69},"o":{"r":4,"s":{"h":17},"u":23,"v":{"i":{"a":{"n":41}}}},"r":{"o":{"n":5}},"s":[{"c":21,"l":1,"y":21,"h":{"a":23}},101],"t":19,"w":29},"l":{"a":{"b":{"i":{"c":11},"o":21},"c":{"i":[{"e":225},17]},"d":{"e":21,"y":3},"g":{"n":0},"m":{"o":11},"n":{"d":[{"l":0},27],"e":{"t":5},"t":{"e":0}},"r":{"g":0,"i":11,"c":{"e":{"n":176}}},"s":{"e":0},"t":{"a":{"n":4},"e":{"l":{"i":18}},"i":{"v":18}},"v":[{"a":95},18],"i":{"n":{"e":{"s":{"s":226}}}}},"b":[{"i":{"n":17}},42],"c":[{"e":0,"i":23,"h":{"a":{"i":23},"i":{"l":{"d":227}}}},101],"d":[{"e":[{"r":{"e":1,"i":1}},24],"i":[{"s":4},0],"r":[{"i":21},23]},25],"e":{"a":[{"d":{"e":{"r":{".":183}}},"s":{"a":228}},9],"b":{"i":1},"f":{"t":6},"g":{".":32,"g":32,"e":{"n":{"d":{"r":{"e":230}}}}},"m":{"a":{"t":[{"i":{"c":5}},1]}},"n":{".":18,"c":27,"e":{".":32},"t":41,"o":{"i":{"d":78}}},"p":{"h":3,"r":1},"r":{"a":{"b":6},"e":0,"g":27,"i":68,"o":21},"s":[{"c":{"o":4},"q":32,"s":[{".":32},27]},8],"v":{"a":23,"e":{"r":{".":0,"a":0,"s":0}}},"y":[{"e":18},27],"c":{"t":{"a":{"b":229}}}},"f":[{"r":19},25],"g":[{"a":[{"r":12},19],"e":{"s":21},"o":11},80],"h":48,"i":{"a":{"g":1,"m":9,"r":{"i":{"z":6}},"s":1,"t":{"o":1}},"b":{"i":4},"c":{"i":{"o":32},"o":{"r":1},"s":18,"t":{".":18},"u":21,"y":23},"d":{"a":23,"e":{"r":5},"i":27},"f":{"e":{"r":11},"f":21,"l":1},"g":{"a":{"t":{"e":32}},"h":27,"r":{"a":1}},"k":27,"l":123,"m":{"b":{"l":0},"i":11,"o":1,"p":90},"n":{"a":21,"e":[{"a":11},124],"i":11,"k":{"e":{"r":6}}},"o":{"g":4},"q":125,"s":{"p":0},"t":[{".":24,"i":{"c":{"a":32,"s":108}},"h":{"o":{"g":204}}},29],"v":{"e":{"r":11}},"z":29},"j":18,"k":{"a":[{"l":23,"t":0},11]},"l":[{"a":{"w":21},"e":[{"a":19,"c":23,"g":23,"l":23,"n":73,"t":73},24],"i":[{"n":[{"a":19},126],"s":{"h":231}},9],"o":[{"q":{"u":{"i":10}},"u":{"t":4},"w":19},1],"f":{"l":2}},29],"m":[{"e":{"t":19},"i":{"n":{"g":3}},"o":{"d":21,"n":[{"e":{"l":{"l":232}}},17]}},25],"n":81,"o":{".":27,"b":{"a":{"l":5},"o":{"t":{"o":233}}},"c":{"i":1},"f":18,"g":{"i":{"c":27},"o":19,"u":27,"e":{"s":{".":9}}},"m":{"e":{"r":11}},"n":{"g":32,"i":[{"z":127},0]},"o":{"d":6},"p":{"e":{".":32},"i":11,"m":23},"r":{"a":[{"t":{"o":1}},17],"i":{"e":4},"o":{"u":5}},"s":{".":32,"e":{"t":5},"o":{"p":{"h":{"i":{"z":32},"y":32}}},"t":0},"t":{"a":1},"u":{"n":{"d":6},"t":25},"v":18,"a":{"d":{"e":{"d":{".":17},"r":{".":183}}}}},"p":[{"a":{"b":5},"h":{"a":23,"i":19},"i":{"n":{"g":4},"t":23},"l":21,"r":19},25],"r":43,"s":[{"c":21,"e":24,"i":{"e":21}},81],"t":[{"a":{"g":4,"n":{"e":7}},"e":[{"n":17,"r":{"a":36},"a":23},29],"h":{"i":[{"l":{"y":148}},11]},"i":{"e":{"s":{".":19}},"s":17},"r":29,"u":[{"r":{"a":12}},8]},18],"u":{"a":4,"b":{"r":3},"c":{"h":17,"i":3},"e":{"n":3,"p":15},"f":0,"i":{"d":4},"m":{"a":1,"i":32,"n":{".":19,"i":{"a":32}},"b":{"i":{"a":{".":235}}}},"o":[{"r":11},3],"p":18,"s":{"s":17,"t":{"e":11}},"t":41,"n":{"k":{"e":{"r":234}}}},"v":{"e":{"n":19,"t":128}},"w":42,"y":[{"a":18,"b":18,"m":{"e":4},"n":{"o":3},"s":[{"e":19,"t":{"y":{"r":4}}},58],"g":{"a":{"m":{"i":236}}}},41]},"m":{"a":[{"b":25,"c":{"a":9,"h":{"i":{"n":{"e":4}}},"l":1},"g":{"i":{"n":5},"n":32},"h":25,"i":{"d":6},"l":{"d":18,"i":{"g":3,"n":4},"l":{"i":0},"t":{"y":0},"a":{"p":222}},"n":{"i":{"a":32,"s":5,"z":11},".":24,"u":{"s":{"c":237}}},"p":[{"h":{"r":{"o":244}}},18],"r":{"i":{"n":{"e":{".":4}},"z":4},"l":{"y":0},"v":11,"g":{"i":{"n":238}}},"s":{"c":{"e":4},"e":0,"t":15},"t":{"e":32,"h":12,"i":{"s":3,"z":{"a":18}}}},41],"b":[{"a":{"t":129},"i":{"l":19,"n":{"g":83},"v":0}},43],"c":56,"e":{".":18,"d":[{".":18,"i":{"a":32,"e":3,"c":[{"i":{"n":152}},84],"o":{"c":239}},"y":108},25],"g":[{"r":{"a":{"n":240}}},9],"l":{"o":{"n":5},"t":0},"m":[{"o":130},9],"n":[{"a":[{"c":5},0],"d":{"e":0},"e":18,"i":0,"s":[{"u":7},17],"t":[{"e":0},27],".":24},41],"o":{"n":4},"r":{"s":{"a":19}},"s":[{"t":{"i":27}},25],"t":{"a":[{"l":11},1],"e":2,"h":{"i":4},"r":[{"i":{"c":32,"e":4},"y":3},21]},"v":1},"f":43,"h":25,"i":{".":32,"a":3,"d":{"a":[{"b":241},0],"g":0},"g":0,"l":{"i":{"a":27,"e":108,"t":{"a":27}},"l":[{"a":{"g":208},"i":{"l":{"i":59}}},21]},"n":{"a":0,"d":27,"e":{"e":19},"g":{"l":[{"i":5,"y":19},21]},"t":0,"u":[{"t":{"e":{"r":242,"s":{"t":242}}}},21],"i":{"s":{".":174}}},"o":{"t":17},"s":[{"e":{"r":{".":0}},"l":5,"t":{"i":0,"r":{"y":19}}},24],"t":{"h":18},"z":24},"k":18,"l":43,"m":[{"a":{"r":{"y":5},"b":243}},29],"n":[{"a":1,"i":{"n":21},"o":1},43],"o":[{"c":{"r":[{"a":{"t":[{"i":{"z":32}},245]}},18]},"d":131,"g":{"o":1},"i":{"s":[{"e":5},84]},"k":18,"l":{"e":{"s":{"t":4},"c":246}},"m":{"e":3},"n":{"e":{"t":5,"y":{"l":247}},"g":{"e":5},"i":{"a":12,"s":{"m":0,"t":0},"z":3},"o":{"l":36,"c":{"h":12},"e":{"n":171},"s":249},"y":{".":3}},"r":[{"a":{".":18},"o":{"n":{"i":{"s":248}}}},9],"s":[{"e":{"y":4},"p":3},8],"t":{"h":[{"e":{"t":250}},12]},"u":{"f":19,"s":[{"i":{"n":98}},27]},"v":9,"e":{"l":{"a":{"s":167}}}},41],"p":[{"a":{"r":{"a":[{"b":5},7],"i":6}},"e":{"t":23},"h":{"a":{"s":36}},"i":[{"a":0,"e":{"s":4},"n":34,"r":19,"s":4},24],"o":{"r":{"i":11},"s":{"i":{"t":{"e":6}}},"u":{"s":21},"v":6},"t":{"r":1},"y":24},43],"r":47,"s":[{"h":[{"a":{"c":{"k":251}}},21],"i":19},101],"t":18,"u":[{"l":{"a":{"r":49},"t":[{"i":[{"u":252},54]},32]},"m":27,"n":8,"p":18,"u":1,"d":{"r":{"o":9}}},41],"w":18},"n":{"a":[{"b":[{"u":21},81],"c":{".":18,"a":1,"t":19},"g":{"e":{"r":{".":5}}},"k":0,"l":{"i":[{"a":4},1],"t":18},"m":{"i":{"t":4}},"n":[{"c":{"i":36},"i":{"t":0},"k":17},24],"r":{"c":[{"h":{"s":{".":73}}},11],"e":18,"i":11,"l":0,"m":19},"s":[{"c":0,"t":{"i":5}},21],"t":[{"a":{"l":3},"o":{"m":{"i":{"z":6}}}},24],"u":[{"s":{"e":11},"t":27},24],"v":{"e":0}},41],"b":80,"c":{"a":{"r":6},"e":{"s":{".":21}},"h":{"a":23,"e":{"o":19,"s":{"t":253}},"i":{"l":19,"s":23}},"i":{"n":2,"t":1},"o":{"u":{"r":{"a":7}}},"r":29,"u":29},"d":{"a":{"i":21,"n":19},"e":[{"s":{"t":{".":4}}},29],"i":{"b":0,"f":79,"t":29,"z":23,"e":{"c":{"k":29}}},"u":{"c":19,"r":0},"w":{"e":9},"t":{"h":{"r":3}}},"e":{".":25,"a":{"r":23},"b":[{"u":11,"a":{"c":{"k":3}}},9],"c":[{"k":32},9],"d":25,"g":{"a":{"t":[{"i":{"v":5}},1]},"e":32},"l":{"a":1,"i":{"z":5}},"m":{"i":4,"o":1},"n":[{"e":18},41],"o":27,"p":{"o":1},"q":9,"r":[{"a":{"b":6,"r":21},"e":24,"i":132,"r":0},29],"s":[{".":25,"p":18,"t":25,"w":18,"k":{"i":119}},41],"t":{"i":{"c":27}},"v":[{"e":19},1],"w":1},"f":[{"i":{"n":{"i":{"t":{"e":{"s":226}}}}}},23],"g":{"a":{"b":21},"e":{"l":23,"n":{"e":[{"s":5},133]},"r":{"e":19,"i":23}},"h":{"a":4,"o":2},"i":{"b":23,"n":2,"t":19},"l":{"a":21},"o":{"v":17},"s":{"h":4,"p":{"r":2}},"u":[{"m":21},29],"y":24},"h":[{"a":[{"b":12},0],"e":0},80],"i":{"a":[{"n":[{".":114},3],"p":1},68],"b":{"a":3,"l":1},"d":[{"i":4},1],"e":{"r":1},"f":{"i":[{"c":{"a":{"t":4}}},9]},"g":{"r":19},"k":0,"m":[{"i":{"z":3}},29],"n":[{"e":{".":32},"g":0},29],"o":1,"s":{".":32,"t":{"a":0}},"t":[{"h":21,"i":{"o":27},"o":{"r":23},"r":3},24]},"j":29,"k":[{"e":{"r":{"o":19},"t":23},"i":{"n":3},"l":29,"r":{"u":{"p":3}}},44],"l":[{"e":{"s":{"s":19}}},43],"m":[{"e":[{"t":17},0]},19],"n":[{"e":0,"i":{"a":{"l":11},"v":0}},101],"o":{"b":{"l":[{"e":3},0]},"c":{"l":19,"e":{"r":{"o":{"s":254}}}},"d":66,"e":27,"g":[{"e":17},18],"i":{"s":{"i":6}},"l":{"i":134,"o":{"g":{"i":{"s":32}}}},"m":{"i":{"c":27,"z":108,"s":{"t":82}},"o":1,"y":3,"a":{"l":214},"e":{"n":{"o":194}}},"n":[{"a":{"g":0},"i":[{"z":19,"s":{"o":255}},5],"e":{"q":15}},1],"p":[{"o":{"l":{"i":135,"y":{".":256}}}},18],"r":{"a":{"b":5,"r":{"y":1}}},"s":{"c":18,"e":0,"t":5},"t":{"a":4},"u":[{"n":27},41],"v":{"e":{"l":136,"m":{"b":2}}},"w":{"l":12}},"p":[{"i":0,"r":{"e":{"c":17}}},72],"q":29,"r":[{"u":0},29],"s":[{"a":{"b":4,"t":{"i":36}},"c":[{"e":{"i":{"v":4}}},1],"e":[{"s":83},24],"i":{"d":137,"g":17},"l":24,"m":[{"o":{"o":1}},3],"o":{"c":21},"p":{"e":1,"i":19},"t":{"a":{"b":{"l":6}}}},81],"t":[{"a":{"b":0},"e":{"r":{"s":12}},"i":[{"b":19,"e":{"r":0},"f":8,"n":{"e":23,"g":83},"p":0},9],"r":{"o":{"l":{"l":{"i":7}}},"e":{"p":137}},"s":1,"u":{"m":{"e":11}}},29],"u":{"a":2,"d":1,"e":{"n":4},"f":{"f":{"e":0}},"i":{"n":23,"t":50},"m":[{"e":2,"i":19},21],"n":138,"o":23,"t":{"r":3}},"v":74,"w":72,"y":{"m":0,"p":0},"z":[{"a":23},18]},"o":{"a":[{"d":11,"l":{"e":{"s":108}},"r":{"d":12},"s":{"e":0,"t":{"e":6}},"t":{"i":5}},18],"b":{"a":{"b":35,"r":19},"e":{"l":0},"i":[{"n":[{"g":4},24]},29],"r":23,"u":{"l":3},"l":{"i":{"g":189}}},"c":{"e":29,"h":[{"e":{"t":23},"a":{"s":23}},0],"i":{"f":12,"l":21},"l":{"a":{"m":21}},"o":{"d":21},"r":{"a":{"c":3,"t":{"i":{"z":4}}},"e":12,"i":{"t":32}},"t":{"o":{"r":{"a":7}}},"u":{"l":{"a":3},"r":{"e":19}}},"d":{"d":{"e":{"d":4}},"i":{"c":3,"o":11,"t":{"i":{"c":137}}},"o":[{"r":12},139],"u":{"c":{"t":{".":4,"s":4}}},"e":{"l":{"l":{"i":12}}}},"e":{"l":21,"n":{"g":19},"r":[{"s":{"t":257}},23],"t":{"a":1},"v":23},"f":{"i":[{"t":{"e":4,"t":17}},24]},"g":{"a":{"r":121,"t":{"i":{"v":4},"o":21}},"e":[{"n":{"e":19},"o":19,"r":21},29],"i":{"e":23,"s":140,"t":3},"l":[{"y":79},21],"n":{"i":{"z":27}},"r":{"o":21},"u":{"i":5},"y":[{"n":25},41]},"h":[{"a":{"b":6}},74],"i":[{"c":{"e":{"s":11}},"d":{"e":{"r":3}},"f":{"f":17},"g":0,"l":{"e":{"t":4}},"n":{"g":23,"t":{"e":{"r":6}}},"s":{"m":19,"o":{"n":4},"t":{"e":{"n":6}}},"t":{"e":{"r":3}}},9],"j":19,"k":[{"e":{"n":23,"s":{"t":15}},"i":{"e":4}},25],"l":{"a":[{"n":21,"s":{"s":36}},29],"d":[{"e":15},9],"e":{"r":3,"s":{"c":23,"t":{"e":{"r":88}}},"t":23},"f":{"i":1},"i":[{"a":23,"c":{"e":23},"d":{".":4},"f":73,"l":19,"n":{"g":3},"o":19,"s":{".":19,"h":3},"t":{"e":19,"i":{"o":19}},"v":19,"g":{"o":{"p":{"o":258}}}},9],"l":{"i":{"e":17}},"o":{"g":{"i":{"z":4}},"r":0,"n":{"o":{"m":259}}},"p":{"l":4},"t":9,"u":{"b":3,"m":{"e":3},"n":3,"s":19},"v":9,"y":24},"m":{"a":{"h":4,"l":5,"t":{"i":{"z":4}}},"b":{"e":9,"l":1},"e":[{"n":{"a":3},"r":{"s":{"e":4}},"t":[{"r":{"y":4}},21],"c":{"h":{"a":260}}},24],"i":{"a":23,"c":{".":3,"a":3},"d":19,"n":[{"i":19},2]},"m":{"e":{"n":{"d":32}}},"o":{"g":{"e":0},"n":21},"p":{"i":3,"r":{"o":7}}},"n":[{"a":[{"c":1,"n":23},2],"c":[{"i":{"l":27}},2],"d":[{"o":4},25],"e":{"n":23,"s":{"t":4}},"g":{"u":1},"i":{"c":2,"o":23,"s":2,"u":19},"k":{"e":{"y":3}},"o":{"d":{"i":1},"m":{"y":3,"i":{"c":137}},"r":{"m":{"a":23}},"t":{"o":{"n":261}},"u":23},"s":[{"p":{"i":[{"r":{"a":10}},36]},"u":17},3],"t":{"e":{"n":36},"i":[{"f":7},93]},"u":{"m":4},"v":{"a":6}},24],"o":[{"d":{"e":5,"i":5},"k":1,"p":{"i":11},"r":{"d":23},"s":{"t":6}},9],"p":{"a":24,"e":{"d":5,"r":[{"a":[{"g":18},27]},2]},"h":[{"a":{"n":19},"e":{"r":19}},25],"i":{"n":{"g":3},"t":23,"s":{"m":{".":2}}},"o":{"n":19,"s":{"i":21}},"r":29,"u":2,"y":5},"q":29,"r":{"a":[{".":19,"g":83,"l":{"i":{"z":4}},"n":{"g":{"e":4}}},29],"e":{"a":[{"l":19},5],"i":3,"s":{"h":5,"t":{".":4}},"w":17},"g":{"u":1},"i":{"a":56,"c":{"a":3},"l":19,"n":2,"o":29,"t":{"y":3},"u":23},"m":{"i":9},"n":{"e":8},"o":{"f":19,"u":{"g":3}},"p":{"e":4},"r":{"h":27},"s":{"e":[{"n":5},1],"t":17},"t":{"h":{"i":3,"y":3,"o":{"n":{"i":{"t":262}}},"r":{"i":137}},"y":1,"i":{"v":{"e":{"l":{"y":4}}}}},"u":{"m":19},"y":29},"s":{"a":{"l":3},"c":[{"e":1,"o":{"p":[{"i":18},23]},"r":19},9],"i":{"e":95,"t":{"i":{"v":4},"o":3,"y":3},"u":0},"l":1,"o":24,"p":{"a":1,"o":1,"h":{"e":{"r":83}}},"t":{"a":[{"t":{"i":19}},9],"i":{"l":4,"t":4}}},"t":{"a":{"n":21},"e":{"l":{"e":{"g":36}},"r":{".":3,"s":4},"s":[{"t":{"e":{"r":263},"o":{"r":264}}},21]},"h":[{"e":{"s":{"i":5},"o":{"s":265}},"i":14},18],"i":{"c":{".":3,"a":4,"e":23},"f":23,"s":23},"o":{"s":5}},"u":[{"b":{"l":3,"a":{"d":{"o":116}}},"c":{"h":{"i":6}},"e":{"t":4},"l":1,"n":{"c":{"e":{"r":6}},"d":8},"v":4},9],"v":{"e":{"n":1,"r":{"n":{"e":17},"s":12,"t":1}},"i":{"s":23,"t":{"i":36},"a":{"n":{".":266}}},"o":{"l":60}},"w":{"d":{"e":{"r":3}},"e":{"l":3,"s":{"t":4}},"i":2,"n":{"i":5},"o":21},"y":{"a":2},"x":{"i":{"d":{"i":{"c":267}}}}},"p":{"a":[{"c":{"a":1,"e":1,"t":0},"d":21,"g":{"a":{"n":32,"t":23}},"i":[{"n":17},21],"l":[{"m":{"a":{"t":268}}},21],"n":{"a":0,"e":{"l":11},"t":{"y":0},"y":3},"p":[{"u":1},2],"r":{"a":{"b":{"l":6},"g":{"e":5,"r":{"a":269}},"l":{"e":228},"m":[{"e":12},36]},"d":{"i":5},"e":[{"l":5},27],"i":[{"s":0},28]},"t":{"e":[{"r":4},9],"h":{"i":{"c":32},"y":4},"r":{"i":{"c":1}}},"v":0,"y":27},41],"b":43,"d":1,"e":{".":18,"a":[{"r":{"l":17}},138],"c":9,"d":[{"e":27,"i":[{"a":36,"c":0},27]},37],"e":[{"d":0,"v":208},21],"k":0,"l":{"a":1,"i":{"e":17}},"n":{"a":{"n":1},"c":21,"t":{"h":0}},"o":{"n":4},"r":{"a":{".":21,"b":{"l":6},"g":21},"i":[{"s":{"t":6}},21],"m":{"a":{"l":0},"e":7},"n":21,"o":11,"t":{"i":11},"u":4,"v":15},"t":[{"e":{"n":4},"i":{"z":4}},9]},"f":18,"g":18,"h":{".":18,"a":{"r":{"i":6}},"e":{"n":{"o":11},"r":1,"s":{".":1}},"i":{"c":2,"e":32,"n":{"g":4},"s":{"t":{"i":32}},"z":27,"l":{"a":{"n":{"t":168},"t":{"e":{"l":270}}}}},"l":9,"o":{"b":27,"n":{"e":27,"i":32},"r":0},"s":18,"t":3,"u":32,"y":41},"i":{"a":[{"n":17},3],"c":{"i":{"e":1},"y":1,"a":{"d":271}},"d":[{"a":19,"e":3,"i":32},21],"e":{"c":27,"n":3},"g":{"r":{"a":{"p":1}}},"l":{"o":3},"n":[{".":21,"d":17,"o":21},9],"o":[{"n":17},141],"t":{"h":[{"a":4},23],"u":9}},"k":142,"l":[{"a":{"n":27,"s":{"t":6}},"i":{"a":11,"e":{"r":5},"g":18,"n":[{"a":{"r":5}},0],"c":{"a":{"b":208}}},"o":{"i":17},"u":{"m":[{"b":17},0]}},143],"m":43,"n":48,"o":{"c":1,"d":{".":32},"e":{"m":4,"t":144},"g":145,"i":{"n":[{"t":32,"c":{"a":12}},84]},"l":{"y":{"t":6,"e":137,"p":{"h":{"o":{"n":{"o":272}}}}},"e":{".":41}},"n":{"i":1},"p":1,"r":[{"y":1},124],"s":[{"s":15},41],"t":[{"a":1},21],"u":{"n":32}},"p":[{"a":{"r":{"a":5}},"e":[{"d":21,"l":19,"n":23,"r":23,"t":23},24],"o":{"s":{"i":{"t":{"e":5}}}}},43],"r":[{"a":{"y":{"e":17}},"e":{"c":{"i":32,"o":5},"e":{"m":11},"f":{"a":{"c":6}},"l":{"a":0},"r":11,"s":{"e":23,"s":27,"p":{"l":{"i":84}}},"t":{"e":{"n":5}},"v":11,"m":{"a":{"c":273}},"n":{"e":{"u":15}}},"i":{"e":53,"n":{"t":146},"s":[{"o":12},0]},"o":{"c":{"a":23,"e":{"s":{"s":8}},"i":{"t":{"y":{".":274}}}},"f":{"i":{"t":6}},"l":11,"s":{"e":12},"t":15,"g":{"e":208}}},9],"s":[{"e":[{"u":{"d":[{"o":{"d":276,"f":276}},275]}},24],"h":1,"i":{"b":21}},81],"t":[{"a":{"b":134},"e":24,"h":24,"i":{"m":11},"u":{"r":0},"w":21,"o":{"m":{"a":{"t":277}}},"r":{"o":{"l":278}}},42],"u":{"b":[{"e":{"s":{"c":181}}},11],"e":0,"f":0,"l":{"c":11},"m":1,"n":9,"r":{"r":0},"s":32,"t":[{"e":[{"r":11},32],"r":3,"t":{"e":{"d":0},"i":{"n":0}}},9]},"w":23},"q":{"u":[{"a":{"v":5,"i":{"n":{"t":{"e":279}}},"s":{"i":[{"r":281,"s":281},280]}},"e":{".":25,"r":27,"t":27},"i":{"n":{"t":{"e":{"s":{"s":282}}}},"v":{"a":{"r":14}}}},9]},"r":{"a":{"b":[{"i":3,"o":{"l":{"i":{"c":29},"o":{"i":236}}}},25],"c":{"h":{"e":17,"u":3},"l":19},"f":{"f":{"i":5},"t":0},"i":24,"l":{"o":1},"m":{"e":{"t":[{"r":{"i":{"z":283}}},11],"n":24},"i":24,"o":{"u":3}},"n":{"e":{"o":6},"g":{"e":0},"i":21,"o":4,"h":{"a":{"s":167}}},"p":{"e":{"r":11},"h":{"y":27}},"r":{"c":5,"e":[{"f":5},17],"i":{"l":18}},"s":24,"t":{"i":{"o":{"n":115}}},"u":{"t":0},"v":{"a":{"i":4},"e":{"l":11}},"z":{"i":{"e":4}},"d":{"i":{"g":127,"o":{"g":249}}},"o":{"r":2}},"b":[{"a":{"b":21,"g":21},"i":[{"f":0,"n":[{"e":19,"g":{".":4,"e":284}},24]},8],"o":1},29],"c":[{"e":[{"n":17},24],"h":{"a":23,"e":{"r":0}},"i":{"b":90,"t":1},"u":{"m":12}},29],"d":{"a":{"l":21},"i":[{"a":0,"e":{"r":0},"n":[{"g":3},17]},9]},"e":{".":25,"a":{"l":2,"n":3,"r":{"r":4},"v":32,"w":1},"b":{"r":{"a":{"t":19}}},"c":{"o":{"l":{"l":5},"m":{"p":{"e":5}}},"r":{"e":1},"i":{"p":{"r":285}},"t":{"a":{"n":{"g":286}}}},"d":[{"e":2,"i":{"s":3,"t":5}},37],"f":{"a":{"c":1},"e":[{"r":{".":4}},9],"i":3,"y":1},"g":{"i":{"s":11}},"i":{"t":4},"l":{"i":2,"u":4},"n":{"t":{"a":90,"e":0}},"o":2,"p":{"i":{"n":4},"o":{"s":{"i":1}},"u":2},"r":[{"i":21,"o":17,"u":4},147],"s":{".":21,"p":{"i":1},"s":{"i":{"b":6}},"t":[{"a":{"l":4},"r":3},8]},"t":{"e":{"r":1},"i":{"z":96},"r":{"i":[{"b":{"u":85}},3]}},"u":[{"t":{"i":4}},8],"v":[{"a":{"l":1},"e":{"l":11,"r":{".":30,"s":4,"t":4}},"i":{"l":4},"o":{"l":{"u":5}}},8],"w":{"h":1}},"f":[{"u":0,"y":21},29],"g":[{"e":{"r":3,"t":23},"i":{"c":23,"n":[{"g":3},0],"s":19,"t":19},"l":29,"o":{"n":0},"u":23},9],"h":[{".":18,"a":{"l":18}},1],"i":{"a":[{"b":0,"g":1,"l":{".":23}},3],"b":[{"a":11},21],"c":{"a":{"s":5},"e":21,"i":[{"d":32,"e":1},18],"o":21},"d":{"e":{"r":5}},"e":{"n":{"c":3,"t":3},"r":2,"t":4},"g":{"a":{"n":5},"i":32},"l":{"i":{"z":11}},"m":{"a":{"n":32},"i":5,"o":27,"p":{"e":0}},"n":{"a":[{".":32},24],"d":0,"e":0,"g":0},"o":2,"p":{"h":[{"e":6},32],"l":[{"i":{"c":5}},9]},"q":21,"s":[{".":21,"c":0,"h":23,"p":0},24],"t":{"a":{"b":116},"e":{"d":{".":19},"r":{".":5,"s":5}},"i":{"c":11},"u":[{"r":5},9]},"v":{"e":{"l":5,"t":11},"i":11,"o":{"l":287}}},"j":23,"k":{"e":{"t":23},"l":{"e":1,"i":{"n":1}},".":288,"h":{"o":2},"r":{"a":{"u":29}},"s":{".":288}},"l":[{"e":[{"d":24,"q":{"u":30}},0],"i":{"g":21,"s":[{"h":4},21]},"o":73},29],"m":[{"a":{"c":5},"e":[{"n":23,"r":{"s":4}},24],"i":{"n":{"g":[{".":21},3]},"o":21,"t":23},"y":21},29],"n":{"a":{"r":21},"e":{"l":23,"r":21,"t":19,"y":23},"i":{"c":19,"s":92,"t":23,"v":23},"o":[{"u":21},0],"u":23},"o":{"b":{"l":11,"o":{"t":289}},"c":[{"r":3},24],"e":[{"l":{"a":{"s":167}},"p":{"i":{"d":{"e":290}}}},1],"f":{"e":2,"i":{"l":4}},"k":[{"e":{"r":4}},8],"l":{"e":{".":32}},"m":{"e":{"t":{"e":5},"s":{"h":3}},"i":0,"p":0},"n":{"a":{"l":0},"e":0,"i":{"s":134},"t":{"a":0}},"o":{"m":41,"t":32},"p":{"e":{"l":3},"i":{"c":11}},"r":{"i":11,"o":4},"s":{"p":{"e":{"r":5}},"s":0},"t":{"h":{"e":1},"y":1,"r":{"o":{"n":2}}},"v":{"a":1,"e":{"l":5}},"x":5},"p":[{"e":{"a":21,"n":{"t":19},"r":{".":4},"t":23},"h":95,"i":{"n":{"g":3}},"o":23,"a":{"u":{"l":{"i":291}}}},29],"r":[{"e":{"c":0,"f":0,"o":21,"s":{"t":0}},"i":{"o":0,"v":0},"o":{"n":17,"s":17},"y":{"s":17}},72],"s":[{"a":[{"t":{"i":5}},29],"c":1,"e":[{"c":[{"r":0},23],"r":{".":4,"a":{"d":{"i":238}}},"s":3,"v":148},24],"h":[{"a":19},29],"i":[{"b":90},29],"o":{"n":12},"p":29,"w":19},44],"t":{"a":{"c":{"h":36},"g":21},"e":{"b":23,"n":{"d":17},"o":5},"i":[{"b":4,"d":0,"e":{"r":21},"g":23,"l":{"i":12,"l":17,"y":21},"s":{"t":21},"v":21},29],"r":{"i":23,"o":{"p":{"h":115}},"e":{"u":29}},"s":{"h":1},"h":{"o":{"u":29}}},"u":{"a":3,"e":{"l":93,"n":3},"g":{"l":1},"i":{"n":3},"m":{"p":{"l":11}},"n":[{"k":6,"t":{"y":0}},9],"s":{"c":19},"t":{"i":{"n":6}}},"v":{"e":[{"l":{"i":17},"n":23,"r":{".":4},"s":{"t":19},"y":23,"i":{"l":29}},1],"i":{"c":23,"v":0},"o":23},"w":29,"y":{"c":1,"n":{"g":{"e":32}},"t":3},"z":{"s":{"c":2}}},"s":{"a":[{"b":42,"c":{"k":32,"r":{"i":11},"t":23},"i":32,"l":{"a":{"r":36},"m":0,"o":4,"t":0,"e":{"s":{"c":54,"w":7}}},"n":{"c":27,"d":{"e":0}},"p":[{"a":{"r":{"i":{"l":292}}}},29],"t":{"a":4,"i":{"o":76},"u":11},"u":0,"v":{"o":{"r":4}},"w":32},9],"b":56,"c":{"a":{"n":{"t":149},"p":[{"e":{"r":267}},0],"v":6,"t":{"o":{"l":208}}},"e":{"d":21,"i":18,"s":21},"h":[{"o":21,"i":{"t":{"z":21}},"r":{"o":{"d":{"i":{"n":{"g":293}}}}}},8],"i":{"e":68,"n":{"d":150},"u":{"t":{"t":294}}},"l":{"e":6,"i":21},"o":{"f":17,"p":{"y":18},"u":{"r":{"a":7}}},"u":29,"r":{"a":{"p":{"e":{"r":{".":36}}}}},"y":{"t":{"h":247}}},"d":56,"e":{".":18,"a":[{"s":17,"w":5},1],"c":{"o":151,"t":27},"d":[{"e":95,"l":19},125],"g":[{"r":11},9],"i":32,"l":{"e":2,"f":32,"v":32},"m":{"e":[{"s":{"t":295}},18],"o":{"l":1},"a":{"p":{"h":287}},"i":{"t":{"i":{"c":296}}}},"n":{"a":{"t":5},"c":18,"d":0,"e":{"d":19},"g":5,"i":{"n":19},"t":{"d":18,"l":18}},"p":{"a":152,"t":{"e":{"m":{"b":11}}}},"r":{".":43,"l":21,"o":0,"v":{"o":18}},"s":[{"h":4,"t":5},72],"u":{"m":113},"v":[{"e":{"n":11}},32],"w":{"i":0},"x":32},"f":47,"g":48,"h":[{".":25,"e":{"r":2,"v":32},"i":{"n":2,"o":3,"p":27,"v":6},"o":[{"l":{"d":4},"n":12,"r":[{"t":7},17],"e":{"s":{"t":137}}},0],"w":18},24],"i":{"b":2,"c":{"c":19},"d":{"e":{".":27,"s":[{"t":6,"w":6},32],"d":{".":8}},"i":[{"z":4},32]},"g":{"n":{"a":18}},"l":{"e":0,"y":18},"n":[{"a":24,"e":{".":32},"g":23},42],"o":[{"n":[{"a":6},32]},41],"r":[{"a":5,"e":{"s":{"i":{"d":4}}}},9],"s":41,"t":{"i":{"o":27}},"u":32,"v":41,"z":32},"k":[{"e":[{"t":23},18],"i":{"n":{"e":4,"g":4}},"y":{"s":{"c":15}}},9],"l":[{"a":{"t":23},"e":24,"i":{"t":{"h":7}},"o":{"v":{"a":{"k":{"i":{"a":297}}}}}},74],"m":[{"a":[{"l":{"l":54},"n":12},23],"e":{"l":17,"n":19},"i":{"t":{"h":32}},"o":{"l":{"d":49}}},42],"n":72,"o":[{"c":{"e":1},"f":{"t":12},"l":{"a":{"b":1},"d":153,"i":{"c":3},"v":32,"u":{"t":{"e":9}}},"m":27,"n":{".":68,"a":17,"g":0},"p":[{"h":{"i":{"c":32,"z":19},"y":19}},21],"r":{"c":5,"d":5},"v":[{"i":4},18],"g":{"a":{"m":{"y":298}}}},41],"p":{"a":[{"i":32,"n":0,"c":{"e":299,"i":{"n":69}}},25],"e":{"n":{"d":17},"o":57,"r":25,"c":{"i":{"o":11}}},"h":{"e":[{"r":[{"o":213},27]},24],"o":6},"i":{"l":17,"n":{"g":4},"o":18,"c":{"i":{"l":208}}},"l":{"y":21},"o":{"n":21,"r":[{"t":{"s":{"c":300,"w":300}}},17],"t":18,"k":{"e":{"s":{"w":10}}}}},"q":{"u":{"a":{"l":{"l":36}},"i":{"t":{"o":88}}}},"r":29,"s":[{"a":[{"s":12,"c":{"h":{"u":301}}},29],"c":94,"e":{"l":23,"n":{"g":19},"s":{".":21},"t":19},"i":[{"e":[{"r":0},21],"l":{"y":4},"a":{"n":{".":210}},"g":{"n":{"a":{"b":302}}}},29],"l":[{"i":1},21],"n":21,"p":{"e":{"n":{"d":115}}},"t":9,"u":{"r":{"a":6}},"w":4,"h":{"a":{"t":3}}},25],"t":{".":25,"a":{"g":24,"l":24,"m":{"i":17,"p":69},"n":{"d":32,"t":{"s":{"h":{"i":303}}}},"p":90,"t":{".":32,"i":15},"r":{"t":{"l":{"i":12}}}},"e":{"d":21,"r":{"n":{"i":7},"o":19},"w":[{"a":6},8]},"h":{"e":23},"i":[{".":21,"a":19,"c":[{"k":32},29],"e":21,"f":23,"n":{"g":3},"r":32},9],"l":{"e":29},"o":{"c":{"k":32},"m":{"a":12},"n":{"e":32},"p":21,"r":{"e":27,"a":{"b":304}}},"r":[{"a":{"d":21,"t":{"u":32,"a":{"g":305}},"y":21},"i":{"d":21,"b":{"u":{"t":7}}},"y":18},1],"w":61,"y":[{"l":{"i":{"s":137}}},24],"b":4,"s":{"c":{"r":4}},"u":{"p":{"i":{"d":306}}}},"u":[{"a":{"l":2},"b":111,"g":151,"i":{"s":4,"t":12},"l":21,"m":[{"i":11},9],"n":9,"r":9,"p":{"e":{"r":{"e":307}}}},41],"v":18,"w":[{"o":18,"i":{"m":{"m":177}}},9],"y":[{"c":18,"l":27,"n":{"o":5,"c":41},"r":{"i":{"n":4}},"t":{"h":{"i":308}}},21]},"t":{"a":[{".":27,"b":[{"l":{"e":{"s":4}},"o":{"l":{"i":{"z":32,"s":{"m":309}}}}},25],"c":{"i":18},"d":{"o":4},"f":46,"i":{"l":{"o":5}},"l":[{"a":4,"e":{"n":5},"i":11,"k":[{"a":204},18],"l":{"i":{"s":0}},"o":{"g":4}},9],"m":{"o":4,"i":{"n":82}},"n":{"d":{"e":0},"t":{"a":54}},"p":{"e":{"r":4},"l":4,"a":{"t":{"h":310}}},"r":{"a":0,"c":18,"e":18,"i":{"z":3},"r":{"h":311}},"s":{"e":0,"y":4},"t":{"i":{"c":18},"u":{"r":1}},"u":{"n":17},"v":0,"w":25,"x":{"i":{"s":0}},"g":{"o":{"n":{".":3}}}},41],"b":42,"c":[{"h":[{"e":{"t":5},"c":15,"i":{"e":{"r":237}}},21],"r":29},18],"d":43,"e":{".":18,"a":{"d":{"i":17},"t":18,"c":{"h":{"e":{"r":{".":36}}}}},"c":{"e":17,"t":32},"d":[{"i":4},42],"e":41,"g":[{"e":{"r":4},"i":4},0],"l":{".":27,"i":17,"s":32,"e":{"g":84,"r":{"o":249}}},"m":{"a":[{"t":11},154]},"n":{"a":{"n":27},"c":27,"d":27,"e":{"s":18},"t":[{"a":{"g":0}},41]},"o":41,"p":[{"e":4},1],"r":{"c":11,"d":155,"i":[{"e":{"s":5},"s":11,"z":{"a":6},"c":{".":8}},41],"n":{"i":{"t":32}},"v":5,"g":{"e":{"i":312}}},"s":{".":18,"s":[{".":23,"e":{"s":313}},18]},"t":{"h":{"e":6}},"u":27,"x":27,"y":18},"f":42,"g":43,"h":{".":25,"a":{"n":17,"l":{"a":{"m":228}}},"e":[{"a":[{"s":3,"t":5},18],"i":{"s":11},"t":27},9],"i":{"c":{".":4,"a":4},"l":18,"n":{"k":32}},"l":18,"o":{"d":{"e":4,"i":{"c":32},"o":{"n":11}},"o":18,"r":{"i":{"t":6,"z":5}},"g":{"e":{"n":{"i":314}}},"k":{"e":{"r":175}}},"s":25,"y":{"l":{"a":{"n":228}},"s":{"c":11}}},"i":{"a":[{"b":1,"t":{"o":1},"n":{".":70}},41],"b":156,"c":{"k":18,"o":21,"u":157},"d":{"i":32},"e":{"n":27},"f":[{"y":4},8],"g":[{"u":32},25],"l":{"l":{"i":{"n":6}}},"m":[{"p":18,"u":{"l":5}},41],"n":[{"a":24,"e":{".":27},"i":27,"o":{"m":285}},42],"o":[{"c":4,"n":{"e":{"e":6}}},41],"q":32,"s":{"a":3,"e":27,"m":0,"o":4,"p":0,"t":{"i":{"c":{"a":32}}}},"t":{"l":3},"u":1,"v":[{"a":0},41],"z":[{"a":3,"e":{"n":3}},41]},"l":[{"a":[{"n":17},19],"e":{".":27,"d":27,"s":{".":27},"t":{".":19}},"o":19,"i":{"e":{"r":315}}},25],"m":[{"e":0},43],"n":81,"o":[{"b":3,"c":{"r":{"a":{"t":4}}},"d":{"o":18},"f":25,"g":{"r":9},"i":{"c":4},"m":{"a":9,"b":0,"y":3},"n":{"a":{"l":{"i":0},"t":3},"o":18,"y":18},"r":{"a":9,"i":{"e":3,"z":5}},"s":8,"u":{"r":32,"t":18},"w":{"a":{"r":3}},"l":{"o":{"g":{"y":84}}},"t":{"i":{"c":11}}},41],"p":43,"r":{"a":[{"b":11,"c":{"h":5,"i":[{"t":17},36],"t":{"e":17}},"s":17,"v":{"e":{"n":5,"s":158,"r":{"s":[{"a":{"b":317}},15]}}},"i":{"t":{"o":{"r":316}}}},41],"e":{"f":5,"m":[{"i":6},0],"a":{"c":{"h":{"e":318}}}},"i":{"a":[{"l":{".":1}},32],"c":{"e":{"s":5},"i":{"a":32},"s":18},"m":25,"v":0},"o":{"m":{"i":5},"n":{"i":6,"y":18},"p":{"h":{"e":5},"i":{"s":175},"o":{"l":{"e":{"s":320},"i":{"s":320,"t":321}}}},"s":{"p":11},"v":11,"l":{"e":{"u":{"m":319}}},"f":{"i":{"c":{".":17},"t":11}}},"u":{"i":5,"s":17}},"s":[{"c":[{"h":{"i":{"e":12}}},21],"h":0,"w":21},101],"t":[{"e":{"s":21},"o":19,"u":0,"r":{"i":{"b":{"u":{"t":322}}}}},66],"u":[{"a":[{"r":3},2],"b":{"i":1},"d":8,"e":18,"f":46,"i":76,"m":27,"n":{"i":{"s":1}},"p":{".":48},"r":{"e":27,"i":[{"s":11},32],"o":5,"y":4,"n":{"a":{"r":12}}},"s":27},41],"v":18,"w":[{"a":43,"i":{"s":17},"o":18,"h":29},1],"y":[{"a":18,"l":25,"p":{"e":12,"h":4,"a":{"l":64}}},41],"z":[{"e":1},18]},"u":{"a":{"b":18,"c":0,"n":{"a":4,"i":0},"r":{"a":{"n":{"t":5}},"d":8,"i":11,"t":11},"t":29,"v":0,"d":{"r":{"a":{"t":{"i":3,"u":15}}}}},"b":{"e":[{"l":21,"r":[{"o":21},23]},1],"i":[{"n":{"g":33}},72],"l":{"e":{".":23}}},"c":{"a":23,"i":{"b":0,"t":1},"l":{"e":12},"r":23,"u":23,"y":21},"d":{"d":4,"e":{"r":3,"s":{"t":4},"v":17},"i":{"c":29,"e":{"d":3,"s":3},"s":4,"t":19},"o":{"n":[{"y":232},21]},"s":{"i":1},"u":21},"e":{"n":{"e":21,"s":17,"t":{"e":0}},"r":{"i":{"l":0}},"a":{"m":15}},"f":{"a":27,"l":23},"g":{"h":{"e":{"n":11}},"i":{"n":4}},"i":[{"l":{"i":{"z":5}},"n":[{"g":29},1],"r":{"m":0},"t":{"a":17},"v":[{"e":{"r":{".":0}}},11]},156],"j":19,"k":18,"l":{"a":[{"b":5,"t":{"i":19}},29],"c":{"h":[{"e":32},17]},"d":{"e":{"r":3}},"e":[{"n":29},1],"g":{"i":1},"i":[{"a":19,"n":{"g":3},"s":{"h":4}},9],"l":{"a":{"r":1},"i":{"b":96,"s":1}},"m":61,"o":72,"s":[{"e":{"s":5}},18],"t":{"i":2,"r":{"a":54},"u":18},"u":[{"l":4},23],"v":4},"m":{"a":{"b":4},"b":{"i":1,"l":{"y":1}},"i":[{"n":{"g":83}},29],"o":{"r":{"o":6}},"p":9},"n":{"a":{"t":17},"e":[{"r":1},24],"i":[{"m":1,"n":24,"s":{"h":4},"v":11},29],"s":[{"w":1},93],"t":{"a":{"b":11},"e":{"r":{".":1},"s":1}},"u":0,"y":4,"z":4},"o":{"r":{"s":21},"s":19,"u":29},"p":{"e":[{"r":{"s":6}},29],"i":{"a":19,"n":{"g":3}},"l":23,"p":[{"o":{"r":{"t":10}}},3],"t":{"i":{"b":5},"u":17}},"r":{"a":[{".":18,"g":21,"s":21,"l":{".":216}},29],"b":{"e":1},"c":0,"d":2,"e":{"a":{"t":5}},"f":{"e":{"r":1},"r":1},"i":{"f":[{"i":{"c":0}},23],"n":2,"o":23,"t":29,"z":3,"a":{"l":{".":0}}},"l":[{"i":{"n":{"g":{".":5}}}},9],"n":{"o":1},"o":{"s":17},"p":{"e":1,"i":1},"s":{"e":{"r":5}},"t":{"e":{"s":4},"h":{"e":3},"i":[{"e":1},17]},"u":23},"s":[{"a":{"d":19,"n":19,"p":1},"c":[{"i":3},8],"e":{"a":5,"r":{".":9}},"i":{"a":19,"c":23},"l":{"i":{"n":1}},"p":2,"s":{"l":4},"t":{"e":{"r":{"e":4}},"r":2},"u":[{"r":17},24]},25],"t":{"a":{"b":0,"t":23},"e":{".":18,"l":18,"n":[{"i":17},18]},"i":[{"l":{"i":{"z":5}},"n":{"e":23,"g":3},"o":{"n":{"a":7}},"s":21,"z":31},101],"l":34,"o":{"f":4,"g":5,"m":{"a":{"t":{"i":{"c":5}}}},"n":19,"u":21},"s":0},"u":[{"m":1},23],"v":74,"x":{"u":11},"z":{"e":1}},"v":{"a":[{".":32,"b":159,"c":{"i":{"l":5},"u":11},"g":[{"e":1,"u":{"e":{"r":170}}},0],"l":{"i":{"e":4},"o":5,"u":15},"m":{"o":4},"n":{"i":{"z":4}},"p":{"i":4},"r":{"i":{"e":{"d":5}}},"t":[{"i":{"v":29}},27],"u":{"d":{"e":{"v":54}}}},41],"e":{".":18,"d":18,"g":11,"l":{".":23,"l":{"i":11},"o":1,"y":21},"n":{"o":{"m":11},"u":{"e":19}},"r":{"d":21,"e":{".":32,"l":[{"y":{".":41}},21],"n":[{"c":5},23],"s":21,"i":{"g":324}},"i":{"e":11},"m":{"i":{"n":36}},"s":{"e":27},"t":{"h":11}},"s":[{".":18,"t":{"e":0,"i":{"t":{"e":15}}}},99],"t":{"e":[{"r":11},1],"y":1}},"i":{"a":{"l":{"i":4},"n":32},"d":{"e":{".":32,"d":32,"n":47,"s":32},"i":32},"f":23,"g":{"n":4},"k":0,"l":[{"i":{"t":32,"z":127}},25],"n":[{"a":26,"c":24,"d":5,"g":18},29],"o":{"l":11,"r":73,"u":2},"p":1,"r":{"o":4},"s":{"i":{"t":11},"o":3,"u":3},"t":{"i":18,"r":11,"y":18},"v":[{"i":{"p":{"a":{"r":325}}}},27]},"o":{".":32,"i":[{"r":{"d":{"u":323}},"c":{"e":{"p":213}}},0],"k":27,"l":{"a":1,"e":19,"t":32,"v":27},"m":{"i":5},"r":{"a":{"b":5},"i":17,"y":1},"t":{"a":1,"e":{"e":18}}},"v":26,"y":21},"w":{"a":{"b":{"l":19},"c":25,"g":{"e":{"r":4},"o":5},"i":{"t":6},"l":{".":19},"m":0,"r":{"t":0},"s":{"t":[{"e":{"w":{"a":326}}},0]},"t":{"e":2},"v":{"e":{"r":4,"g":327}}},"b":29,"e":{"a":{"r":{"i":{"e":5}},"t":{"h":54}},"d":{"n":0},"e":{"t":12,"v":5,"k":{"n":137}},"l":{"l":0},"r":29,"s":{"t":12},"v":23},"h":{"i":0},"i":[{"l":[{"l":{"i":{"n":6}}},8],"n":{"d":{"e":0},"g":0},"r":0,"s":{"e":27},"t":{"h":12},"z":5,"d":{"e":{"s":{"p":6}}}},9],"k":21,"l":{"e":{"s":1},"i":{"n":3}},"n":{"o":21},"o":[{"m":15,"v":{"e":{"n":4}},"k":{"e":{"n":85}}},160],"p":19,"r":{"a":[{"p":{"a":{"r":{"o":12}}}},0],"i":[{"t":{"a":36,"e":{"r":{".":183}}}},0]},"s":{"h":23,"l":1,"p":{"e":1},"t":60},"t":18,"y":1,"c":23},"x":{"a":[{"c":{"e":5},"g":{"o":21},"m":11,"p":21,"s":5},29],"c":161,"e":[{"c":{"u":{"t":{"o":1}}},"d":24,"r":{"i":0,"o":4}},29],"h":[{"i":[{"l":6},8],"u":0},29],"i":[{"a":4,"c":4,"d":{"i":4},"m":{"e":21,"i":{"z":4}}},23],"o":[{"b":21},23],"p":[{"a":{"n":{"d":17}},"e":{"c":{"t":{"o":10}},"d":11}},23],"t":[{"i":23},74],"u":[{"a":3},29],"x":1,"q":[{"u":{"i":{"s":54}}},29]},"y":{"a":{"c":19,"r":110,"t":19},"b":29,"c":[{"e":[{"r":4},24],"h":[{"e":[{"d":264},0]},23],"o":{"m":17,"t":17}},29],"d":29,"e":{"e":19,"r":[{"f":21},29],"s":[{"t":{"e":{"r":{"y":328}}}},0],"t":1},"g":{"i":19},"h":47,"i":29,"l":{"a":23,"l":{"a":{"b":{"l":6}}},"o":23,"u":19},"m":{"b":{"o":{"l":7}},"e":[{"t":{"r":{"y":20}}},0],"p":{"a":12}},"n":{"c":{"h":{"r":3}},"d":4,"g":4,"i":{"c":4},"x":32},"o":[{"d":4,"g":33,"m":0,"n":{"e":{"t":4},"s":21},"s":21},72],"p":{"e":{"d":21,"r":6},"i":3,"o":[{"c":21},23],"t":{"a":9},"u":19},"r":{"a":{"m":5},"i":{"a":4},"o":23,"r":1},"s":{"c":1,"e":161,"i":{"c":{"a":3},"o":3,"s":27},"o":21,"s":0,"t":[{"a":3,"r":{"o":29}},2],"u":{"r":17}},"t":{"h":{"i":{"n":23}},"i":{"c":3}},"w":29},"z":{"a":[{"b":79,"r":8},2],"b":18,"e":[{"n":1,"p":1,"r":[{"o":3},29],"t":0},25],"i":[{"l":21,"s":21,"a":{"n":{".":23}}},42],"l":32,"m":18,"o":[{"m":1,"o":{"l":4},"p":{"h":{"r":329}}},41],"t":{"e":0},"z":[{"y":21,"w":231},101]}}',
      [
        "as-so-ciate",
        "as-so-ciates",
        "dec-li-na-tion",
        "oblig-a-tory",
        "phil-an-thropic",
        "present",
        "presents",
        "project",
        "projects",
        "reci-procity",
        "re-cog-ni-zance",
        "ref-or-ma-tion",
        "ret-ri-bu-tion",
        "ta-ble"
      ]
    ];
  });
})(Us);
var Z0 = Us.exports, J0 = to(
  Z0
), Ss = { exports: {} };
(function(t) {
  (function(e, a) {
    t.exports ? t.exports = a() : e.hyphenationPatternsEs = a();
  })(va, function() {
    return [
      "1,4,02,2,21,04,002,202,232,00045,000045,0102,0012,22,0034,40004,004,5,43,403,443,4303,4303003,054,0543,44,00001,000012,0022,0003,003,0032,,0005,00003,00004,00032,000001,0000012,000023,0000002,0000043,000003,000004,043,0023,001,0000001,00000012,00002,04003,00043,000434,0001,00012,000005,423,42,0043,00202,3,00234,0004,00303,002304,0222,0000212,00343,0000343,003003,0030023,0034030023,430303,440454,003034,000034,00004444,000005005,000054,000034004,0002,00434,00000003,005,000006,03,23,32,00414,0041,000043,0000004,000222,0303,000303,00023,00022,200001,2000012,00222,0045,00212,0021,0000344,4343,0054,00000056,0006,000202,000323,0000202,000021,0000303",
      '{"b":[{".":1,"b":3,"c":[{"t":8,"n":8,"z":8},3],"d":3,"f":[{"t":8},3],"g":[{"n":8},3],"h":4,"j":3,"k":3,"m":[{"n":8},3],"n":3,"p":[{"t":8,"s":8,"n":8},3],"q":3,"s":3,"t":[{"z":8,"s":8},3],"v":3,"w":3,"x":3,"y":3,"z":3,"l":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7},2],"r":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7},2],"i":{"b":{"l":{"i":{"o":{"h":47,"a":48,"e":48,"i":48,"o":48,"u":48,"á":48,"é":48,"í":48,"ó":48,"ú":48}}}},"e":{"n":[{"h":34,"v":34,"q":34,"m":34,"t":34,"d":{"o":{".":50},"a":{"s":{".":50}}}},49]},"o":{"h":53,"a":54,"e":54,"i":54,"o":54,"u":54,"á":54,"é":54,"í":54,"ó":54,"ú":54},"u":{"n":{"í":12}}}},0],".":{"b":[{"i":{"a":{"n":{"u":{"a":{"l":46}}},"u":{"r":46}},"o":{"x":46},"ó":{"x":12},"u":{"n":46},"e":{"n":{"a":{"n":{"d":51},"p":{"a":52},"v":{"e":52}},"e":{"s":{"t":51}},"i":{"n":{"t":51}},"o":{"l":{"i":{"e":52}}}}}}},2],"c":[{"o":{"a":[{"c":{"r":{"e":{"e":30}}},"g":{"e":{"n":30},"u":{"l":29}},"l":{"i":{"c":29}},"r":{"r":{"e":{"n":{"d":30}}}},"u":{"t":{"o":30}}},28],"e":[{"d":{"i":{"c":30,"t":30},"u":{"c":30}},"f":{"i":{"c":{"i":30}}},"t":{"á":29},"x":{"i":{"s":30}}},28],"i":[{"m":{"p":{"u":{"t":30}}},"t":{"o":29}},28],"o":[{"p":{"e":{"r":58},"é":{"r":58},"t":16},"r":{"d":{"e":{"n":16},"i":{"n":16},"í":{"n":16}}}},14],"u":28,"á":[{"g":{"u":{"l":29}}},28],"é":28,"í":28,"ó":[{"p":{"t":16}},28],"ú":28,"n":{"u":{"r":{"b":6}}}},"a":{"u":{"t":33}}},2],"d":[{"e":{"s":{"a":59,"e":59,"i":[{"n":{"t":{"e":{"r":{"e":{"s":{"a":71,"e":71,"o":71,"á":71,"é":71,"ó":71}}}}}}},59],"o":59,"u":59,"á":59,"é":59,"í":59,"ó":59,"ú":59},"u":{"t":33}},"i":{"e":{"c":{"i":{"o":40}}}}},2],"f":2,"g":2,"j":2,"k":2,"l":2,"m":[{"a":{"l":{"e":{"d":{"u":81},"s":{"t":53}},"a":{"c":{"o":{"n":53,"s":53}},"e":26,"n":{"d":{"a":{"n":{"t":53,"z":53}}}}},"i":{"n":{"t":53}}}},"i":{"l":{"i":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}}},2],"n":2,"p":[{"a":{"n":{"a":{"m":{"e":{"r":{"i":88}}},"f":{"r":{"i":89}}},"e":{"u":{"r":{"o":{"p":89}}}},"h":{"i":{"s":{"p":89}}},"ó":{"p":{"t":{"i":89}}}}},"o":{"s":{"t":{"a":92,"e":[{"r":{"g":29,"i":94},"l":{"e":{"c":34}}},92],"i":[{"n":[{"e":94,"d":34},29],"g":{"o":94},"l":{"a":94},"z":{"a":94,"o":94},"m":{"p":{"r":34}}},92],"o":[{"p":{"e":34}},92],"u":[{"r":{"a":94},"l":{"a":94,"á":94,"e":94,"é":94}},92],"á":92,"é":92,"í":[{"n":29},92],"ó":[{"n":{"i":94}},92],"ú":92,"r":{"e":{"v":95},"o":{"m":95}}}}},"r":{"e":{"a":96,"e":96,"i":96,"o":96,"u":96,"á":96,"é":96,"í":96,"ó":96,"ú":96,"h":54},"o":{"a":[{"b":{"o":{"r":{"t":29}}}},96],"e":96,"i":96,"o":96,"u":96,"á":96,"é":96,"í":96,"ó":96,"ú":96}}},2],"q":2,"r":[{"e":{"i":[{"n":{"a":29,"c":30,"g":30,"s":30,"t":30},"m":31},28],"a":[{"b":{"r":30},"f":{"i":{"r":{"m":30}},"í":{"r":{"m":30}}},"j":{"u":{"s":{"t":30}},"ú":{"s":{"t":29}}},"l":{"i":{"z":{"a":29,"á":29},"m":30,"s":{"m":29,"t":29}},"í":{"z":{"a":29}}},"n":{"i":{"m":30},"í":{"m":30}},"p":{"a":{"r":{"e":{"c":30}}}},"e":{"g":31},"q":31,"z":31,"g":{"r":{"u":{"p":31}}}},28],"e":14,"o":[{"b":31,"c":30,"j":30,"r":{"g":{"a":30}}},28],"u":[{"b":{"i":{"c":{"a":30}},"í":{"c":{"a":30}}},"m":{"a":{"t":{"i":29}},"á":{"t":{"i":29}}},"n":{"i":{"r":30},"í":{"r":30},"t":30},"s":{"a":{"r":30},"á":{"r":30}},"t":{"i":{"l":{"i":{"z":30},"í":{"z":30}}}}},28],"á":[{"b":{"r":30}},28],"é":28,"í":28,"ó":28,"ú":28}},2],"s":[{"u":{"b":{"i":[{"e":{"n":14},"l":{"l":95},"m":{"i":{"e":{"n":95}}},"n":{"s":{"p":29}},"é":{"n":30},"r":30},99],"a":[{"f":{"l":{"u":{"e":29}}},"r":{"r":29},"l":{"t":{"e":{"r":29}}},"m":30,"c":{"u":{"á":29}}},99],"e":[{"n":{"t":{"e":{"n":29}}},"s":{"t":{"i":{"m":29},"í":{"m":29},"a":29},"p":{"e":29}}},99],"o":[{"f":{"i":{"c":{"i":29}}},"r":{"d":{"i":{"n":30},"í":{"n":30}}}},99],"u":[{"r":{"b":{"a":29,"i":30}}},99],"á":99,"é":99,"í":[{"n":{"d":29},"m":{"i":29}},99],"ó":99,"ú":99,"r":{"a":{"y":58},"e":{"i":{"n":100}}}},"d":{"a":{"f":{"r":101},"m":{"e":101}},"e":{"s":{"t":{"e":102}}}},"r":{"a":{"m":{"e":101}},"e":{"s":{"t":102}},"o":{"e":{"s":102}}}},"o":{"a":{"s":14}}},2],"t":[{"e":{"l":{"e":{"i":{"m":{"p":26}},"o":{"b":{"j":26},"l":{"ó":{"t":90}}}}}},"r":{"a":{"s":{"a":108,"e":108,"i":108,"o":[{"ñ":109},108],"u":108,"á":108,"é":108,"í":108,"ó":108,"ú":108}},"i":{"ó":{"x":54}}}},2],"v":2,"w":2,"x":2,"y":2,"z":2,"h":{"u":{"m":{"e":{"a":16,"o":16}}},"e":{"m":{"e":{"e":16}},"p":{"t":{"a":{"e":37}}}}},"a":[{"n":{"a":[{"l":{"i":29},"e":{"r":{"o":30}}},28],"e":[{"p":{"i":{"g":{"r":31}}},"x":{"a":29,"á":29,"e":29,"é":29,"i":{"o":29,"ó":29}}},28],"i":[{"m":[{"a":{"d":29},"á":{"d":29}},29],"d":{"a":{"r":29}},"l":{"l":29},"ñ":{"a":32},"q":29,"s":{"o":31,"ó":31},"v":{"e":{"l":29}}},28],"o":[{"c":{"h":{"e":33}},"d":{"i":{"n":33}},"m":{"a":{"l":33}},"n":{"a":{"d":33},"i":{"m":33}},"t":{"a":33,"á":29}},28],"u":[{"a":{"l":[{"m":35},34]},"b":{"l":29},"d":{"a":29},"l":29},28],"á":[{"l":{"i":29}},28],"é":28,"í":28,"ó":[{"n":{"i":{"m":29}},"m":{"a":{"l":33}}},28],"ú":{".":28},"h":30,"t":{"e":{"o":{"j":{"e":39},"n":{"e":{"s":42}}}},"i":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}}},2],"e":{"n":{"a":[{"c":{"e":{"i":{"t":30}}},"r":{"b":30}},65],"e":[{"m":{"i":{"s":{"t":29}},"í":{"s":{"t":29}}}},65],"i":65,"o":[{"j":{"a":{"r":29}}},65],"u":[{"m":{"e":{"r":{"a":29,"á":29,"e":29}}}},65],"á":65,"é":65,"í":65,"ó":65,"ú":65},"x":{"a":65,"e":65,"i":65,"o":65,"u":65,"á":65,"é":65,"í":65,"ó":65,"ú":65}},"i":{"n":{"a":[{"b":{"o":{"r":{"d":30}},"a":{"r":{"c":30}}},"c":{"e":{"n":{"t":30}}},"g":{"u":{"a":{"n":{"t":30}}}},"d":{"a":{"p":{"t":30}}},"m":{"o":{"v":{"i":{"b":29}}}},"n":{"a":{"l":{"i":{"z":30}}},"i":{"c":29,"m":30}},"p":{"e":{"l":30},"l":{"i":{"c":30}},"r":{"e":{"n":{"s":30},"c":{"i":30}}}},"r":{"r":{"u":{"g":30}}},"s":{"i":{"s":{"t":30}}}},65],"e":[{"f":{"i":{"c":[{"i":30},30]}},"l":{"u":{"d":{"i":30}}},"n":{"a":{"r":{"r":29}}}},65],"i":[{"c":{"u":{"o":29,"a":29}}},65],"o":[{"c":{"u":{"o":29,"a":29,"l":{"a":29,"á":29,"e":29}}}},65],"u":[{"t":{"i":{"l":{"i":{"z":29}}}}},65],"á":[{"n":{"i":{"m":29}}},65],"é":[{"d":{"i":{"t":29}}},65],"í":65,"ó":65,"ú":[{"t":{"i":{"l":29}}},65],"t":{"e":{"r":{"r":[{"o":{"g":74},"u":{"p":{"c":74,"t":74},"m":{"p":74}}},39],"a":66,"e":[{"s":{"a":70,"e":70,"o":70,"á":70,"é":70,"ó":70}},66],"i":66,"o":66,"u":66,"á":66,"é":66,"í":66,"ó":66,"ú":66}}}}}},"c":[{".":1,"b":3,"c":[{"t":8,"n":8,"z":8},3],"d":3,"f":[{"t":8},3],"g":[{"n":8},3],"j":3,"k":3,"m":[{"n":8},3],"n":[{".":1,"i":{"c":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"e":{"o":{"r":87}}},3],"p":[{"t":8,"s":8,"n":8},3],"q":3,"s":3,"t":[{".":1,"z":8,"s":8},3],"v":3,"w":3,"x":3,"y":3,"z":[{".":1},3],"h":[{".":1,"b":3,"c":3,"d":3,"f":3,"g":3,"h":3,"j":3,"k":3,"l":6,"m":3,"n":3,"p":3,"q":3,"r":6,"s":3,"t":3,"v":3,"w":3,"x":3,"y":3,"z":3},5],"l":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7},2],"r":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7,"i":{"p":{"t":{"o":{"h":47,"a":48,"e":48,"i":48,"o":48,"u":48,"á":48,"é":48,"í":48,"ó":48,"ú":48}}}},"o":{"n":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},2],"a":{"c":{"a":15},"g":{"o":15,"a":[{"s":{".":1}},15]},"r":{"d":{"i":{"o":{"h":47,"a":48,"e":48,"i":48,"o":48,"u":48,"á":48,"é":48,"í":48,"ó":48,"ú":48}}}}},"u":{"l":{"o":15}},"e":{"f":{"a":{"l":{"o":{"h":47,"a":48,"e":48,"i":48,"o":48,"u":48,"á":48,"é":48,"í":48,"ó":48,"ú":48}}}},"n":{"t":{"i":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":[{"r":{"e":{"a":55}}},38],"é":38,"í":38,"ó":38,"ú":38}}}},"i":{"c":{"l":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"t":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}},"o":{"n":{"t":{"r":{"a":{"h":47,"a":48,"e":48,"i":48,"o":48,"u":48,"á":48,"é":48,"í":48,"ó":48,"ú":48}}}}}},0],"d":[{".":1,"b":3,"c":[{"t":8,"n":8,"z":8},3],"d":3,"f":[{"t":8},3],"g":[{"n":8},3],"h":4,"j":3,"k":3,"l":3,"m":[{"n":8},3],"n":3,"p":[{"t":8,"s":8,"n":8},3],"q":3,"s":3,"t":[{"z":8,"s":8},3],"v":3,"w":3,"x":3,"y":3,"z":3,"r":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7},2],"e":{"c":{"a":{"h":26,"a":27,"e":27,"i":[{"m":{"i":{"e":{"n":{"t":39}}}}},27],"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}},"s":{"ó":{"r":{"d":{"e":45}}},"o":{"r":{"d":{"e":45},"e":{"j":45},"i":{"e":{"n":{"t":45}}},"t":{"i":{"j":30}},"g":{"a":{"n":{"i":45}}}},"b":{"e":{"d":{"e":{"c":45}}},"l":{"i":{"g":45}},"s":{"t":{"r":45}}},"c":{"u":{"p":30}},"d":{"o":{"r":45}},"l":{"a":{"c":30,"d":30},"l":30},"n":{"c":{"e":30}},"v":{"i":45},"x":{"i":45},"y":{"e":45,"é":45},"s":{"e":{"g":14}}},"a":{"b":{"a":{"s":{"t":45}},"o":{"l":{"l":45},"t":{"o":45}},"r":[{"i":{"d":51},"o":{"c":{"h":45}}},45]},"c":{"e":{"i":{"t":45},"l":{"e":{"r":45}},"r":{"t":34}},"i":{"e":{"r":{"t":34}}},"o":{"b":{"a":{"r":45}},"m":{"o":{"d":45},"p":45},"n":{"s":45},"p":{"l":45},"r":{"r":45},"s":{"t":{"u":{"m":45}}},"t":45},"r":{"a":{"l":{"i":{"z":34}}},"e":{"d":{"i":{"t":45}}}},"t":{"i":{"v":45}},"u":{"a":{"r":{"t":45}}}},"d":{"e":{"r":{"e":{"z":45}},"u":{"d":45}},"o":{"r":{"a":{"r":45},"m":{"e":{"c":45}},"n":45}},"v":{"e":{"r":{"t":45}}}},"f":{"e":{"r":{"r":45}},"i":{"c":45,"l":45,"n":45},"o":{"r":45}},"g":{"u":[{"i":{"s":51}},45],"ú":34,"a":{"r":{"r":34}},"r":{"a":{"c":{"i":45},"d":45,"v":{"i":45}},"e":{"g":45},"u":{"p":45}}},"h":{"e":{"r":{"r":45}},"i":{"j":45}},"j":{"u":{"s":{"t":45}}},"l":{"a":{"g":{"a":{"r":45}}},"e":{"n":{"t":45}},"f":{"o":{"m":45,"r":45}},"i":{"e":{"n":45},"n":{"e":61,"é":61},"ñ":45,"v":34},"m":[{"i":{"d":45}},45],"o":{"j":45},"q":{"u":{"i":{"l":45}}},"t":{"e":{"r":45}},"u":{"m":{"b":{"r":45}}}},"m":{"a":{"r":{"r":34}},"o":{"b":{"l":34},"l":{"d":45},"r":{"t":45}},"u":{"e":{"b":{"l":45}}},"p":{"a":45}},"n":{"d":45,"g":{"e":{"l":45},"r":30},"i":{"d":45,"m":45},"í":{"m":45},"u":{"d":45}},"p":{"a":{"ñ":34,"c":{"i":{"b":34}},"d":{"r":45},"r":{"e":[{"c":45},45],"i":{"c":45}}},"e":{"g":45,"r":{"c":{"i":{"b":45}}},"s":45},"l":{"i":{"c":45}},"o":{"l":{"i":{"l":{"l":45}}},"y":45},"r":{"e":{"n":{"d":45},"t":45},"i":{"e":{"t":45}},"o":{"b":45,"p":{"i":45},"v":{"e":{"c":{"h":45}}}}}},"r":{"b":{"o":{"l":45}},"e":{"n":45},"m":[{"e":62},45],"r":{"a":{"i":{"g":45}},"e":{"g":{"l":45},"n":{"d":45}},"i":{"m":45},"o":{"l":{"l":34},"p":45},"u":{"g":45}},"t":{"i":{"c":{"u":{"l":45}}}}},"s":{"e":{"n":{"t":45}},"i":{"s":{"t":45}},"n":45},"t":{"e":{"n":{"c":45,"d":45,"t":45}},"i":{"e":{"n":{"d":45}},"n":34},"o":{"r":{"n":45}},"r":{"a":{"n":{"c":45}}}},"u":{"t":{"o":{"r":45}}},"v":{"i":{"s":45}},"y":{"u":{"n":34}},"z":{"ó":{"n":34},"o":{"n":34}}},"e":{"m":{"b":{"a":{"l":45,"r":[{"g":45},45]},"á":{"l":45,"r":45},"o":{"l":{"s":45},"r":{"r":45},"s":{"c":45},"t":45},"r":{"a":{"g":45,"v":{"e":45}},"á":{"g":45,"v":{"e":45}},"o":{"l":{"l":45}},"ó":{"l":{"l":45}},"u":{"j":45},"ú":{"j":45}}},"e":{"j":30},"p":{"a":{"ñ":45,"c":45,"q":{"u":{"e":{"t":45},"é":{"t":45}}},"r":{"e":{"j":45,"n":{"t":45}},"é":{"j":45}},"t":45},"á":{"ñ":45},"é":45,"e":{"d":{"r":45},"g":45,"o":{"r":45},"r":{"e":{"z":45},"n":45}},"l":{"e":45},"o":{"l":{"v":45},"t":{"r":45},"z":45}}},"n":{"a":{"m":45},"c":{"a":{"b":45,"d":45,"j":45,"l":{"l":45},"m":45,"n":{"t":30},"p":45,"r":45},"á":{"j":45,"l":{"l":45},"r":45},"h":45,"l":45,"o":45,"r":45,"u":45},"d":45,"f":{"a":{"d":30},"á":{"d":30},"i":45,"o":45,"ó":45,"r":{"e":{"n":30}},"u":{"n":{"d":45},"r":45}},"g":{"a":{"ñ":30,"n":{"c":{"h":45}},"r":45,"s":45},"á":{"ñ":30},"o":{"m":45,"z":45},"r":{"a":45}},"h":{"e":{"b":{"r":45}}},"j":45,"l":{"a":{"d":45,"z":45},"o":45},"m":45,"r":45,"s":45,"t":{"a":45,"e":{"n":{"d":30},"r":45},"i":{"e":{"n":30,"r":45},"é":{"n":30,"r":45}},"o":45,"r":45,"u":45},"v":{"a":{"i":{"n":45}},"o":{"l":{"v":{"i":{"m":30}}}}}},"o":30,"q":45,"r":{"c":{"i":14},"t":14},"s":{"p":{"a":45,"e":{"r":{"a":{"c":30,"n":{"z":45}}}}},"t":{"a":{"b":{"i":{"l":45}}},"i":{"m":45}}}},"é":{"r":{"t":14}},"i":{"d":{"e":{"r":30},"i":{"a":30,"o":30}},"e":{"r":{"t":30}},"g":{"n":30,"u":{"a":{"l":30}}},"l":{"u":{"s":{"i":30}}},"m":{"a":{"g":{"i":{"n":45}},"n":45},"p":{"o":{"n":45},"r":{"e":{"s":45}}}},"n":{"c":{"e":{"n":{"t":45}},"l":{"i":{"n":45}},"o":{"r":{"p":45}},"r":{"u":{"s":{"t":45}}}},"e":{"n":{"c":30}},"f":{"e":{"c":30},"l":[{"a":{"m":45}},45],"o":{"r":{"m":45}}},"h":{"i":{"b":45}},"s":{"e":{"c":{"t":45}},"t":{"a":{"l":45}}},"t":{"e":{"g":{"r":14},"r":14},"o":{"x":45}},"v":{"e":{"r":45}}},"s":{"t":{"e":{"n":30}}}},"u":{"d":{"a":{"r":63,"s":63,"n":63}},"e":{"l":{"l":30}},"b":{"s":{"t":{"a":{"n":14}}},"i":{"c":64}},"s":{"t":{"a":{"n":14}}},"n":{"i":{"r":45,"e":{"r":45},"m":45}}}},"i":{"s":{"t":{"i":30}}}}},0],"f":[{".":1,"b":3,"c":3,"d":3,"f":3,"g":3,"h":4,"j":3,"k":3,"m":3,"n":3,"p":3,"q":3,"s":3,"t":[{".":1},3],"v":3,"w":3,"x":3,"y":3,"z":3,"l":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7},2],"r":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7},2],"o":{"n":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}},"t":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}},"a":{"m":{"i":{"l":{"i":{"a":{"r":{"i":82}}}}}}}},0],"g":[{".":1,"b":3,"c":3,"d":3,"f":3,"g":3,"h":4,"j":3,"k":3,"m":3,"n":[{".":1},3],"p":3,"q":3,"s":3,"t":3,"v":3,"w":3,"x":3,"y":3,"z":3,"l":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7,"u":{"c":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},2],"r":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7},2],"o":{"n":{"o":{".":60,"s":{".":60}},"a":{"l":{".":60,"e":{"s":{".":60}}}}}},"u":{"a":{".":60,"s":{".":60}},"o":{".":60,"s":{".":60}}},"a":{"s":{"t":{"r":{"o":{"h":47,"a":48,"e":48,"i":48,"o":48,"u":48,"á":48,"é":48,"í":48,"ó":48,"ú":48}}}}},"e":{"o":{"h":53,"a":54,"e":54,"i":54,"o":54,"u":54,"á":54,"é":54,"í":54,"ó":54,"ú":54}},"i":{"g":{"a":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}}},0],"h":{".":1,"b":3,"c":3,"d":3,"f":3,"g":3,"h":4,"j":3,"k":3,"l":3,"m":3,"n":3,"p":3,"q":3,"r":3,"s":3,"t":3,"v":3,"w":3,"x":3,"y":3,"z":3,"e":{"c":{"t":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"l":{"i":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"m":{"a":{"t":{"o":{"h":47,"a":48,"e":48,"i":48,"o":48,"u":48,"á":48,"é":48,"í":48,"ó":48,"ú":48}}},"i":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27},"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}},"x":{"a":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}},"i":{"d":{"r":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"p":{"e":{"r":{"r":39,"a":66,"e":66,"i":[{"c":{"í":{"n":{"e":68}}}},66],"o":[{"n":{"i":{"m":{"i":68}},"í":{"m":{"i":68}}},"x":{"i":{"a":68}}},66],"u":66,"á":66,"é":66,"í":66,"ó":[{"n":{"i":{"m":{"o":68}}}},66],"ú":66}},"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}},"s":{"t":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"o":{"m":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}},"a":{"b":{"l":{"a":{"n":{"t":{"e":60}}}},"i":{"e":{"n":{"t":{"e":60}}}}}}},"j":[{".":1,"b":3,"c":3,"d":3,"f":3,"g":3,"h":4,"j":3,"k":3,"l":3,"m":3,"n":3,"p":3,"q":3,"r":3,"s":3,"t":3,"v":3,"w":3,"x":3,"y":3,"z":3},0],"k":[{".":1,"b":3,"c":3,"d":3,"f":3,"g":3,"h":4,"j":3,"k":3,"m":3,"n":3,"p":3,"q":3,"s":3,"t":3,"v":3,"w":3,"x":3,"y":3,"z":3,"l":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7},2],"r":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7},2],"i":{"l":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}}},0],"l":[{".":1,"b":3,"c":[{"t":8,"n":8,"z":8},3],"d":3,"f":[{"t":8},3],"g":[{"n":8},3],"h":4,"j":3,"k":3,"m":[{"n":8},3],"n":3,"p":[{"t":8,"s":8,"n":8},3],"q":3,"r":3,"s":3,"t":[{"z":8,"s":8},3],"v":3,"w":3,"x":3,"y":3,"z":3,"l":[{".":1,"b":3,"c":3,"d":3,"f":3,"g":3,"h":3,"j":3,"k":3,"l":3,"m":3,"n":3,"p":3,"q":3,"r":3,"s":3,"t":3,"v":3,"w":3,"x":3,"y":3,"z":3},5],"i":{"á":{"r":{"e":{"a":83}}}},"o":{"g":{"í":{"a":60}}}},0],"m":[{".":1,"b":3,"c":[{"t":8,"n":8,"z":8},3],"d":3,"f":[{"t":8},3],"g":[{"n":8},3],"h":4,"j":3,"k":3,"l":3,"m":[{"n":8},3],"n":[{".":1},3],"p":[{"t":8,"s":8,"n":8},3],"q":3,"r":3,"s":3,"t":[{"z":8,"s":8},3],"v":3,"w":3,"x":3,"y":3,"z":3,"e":{"o":{".":1},"a":{"b":{"l":{"e":{".":1,"s":{".":1}}}}},"n":{"t":{"e":{".":17}}},"g":{"a":{"l":{"o":{"h":47,"a":48,"e":48,"i":48,"o":48,"u":48,"á":48,"é":48,"í":48,"ó":48,"ú":48}},"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}},"l":{"a":{"n":{"o":{"h":47,"a":48,"e":48,"i":48,"o":48,"u":48,"á":48,"é":48,"í":48,"ó":48,"ú":48}}}}},"a":{"n":{"t":{"e":{"a":43}}},"c":{"r":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"l":[{"h":58,"b":29,"c":29,"d":29,"f":29,"g":29,"m":29,"p":29,"q":29,"s":29,"t":29,"v":29},80],"x":{"i":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}},"i":{"c":{"r":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"l":{"i":{"a":{"r":35}}},"n":{"i":{"h":26,"a":[{"t":{"u":{"r":10}}},27],"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}},"r":{"i":{"a":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"u":{"l":{"t":{"i":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"o":{"n":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}}},0],"n":[{".":1,"b":3,"c":[{"t":8,"n":8,"z":8},3],"d":3,"f":[{"t":8},3],"g":[{"n":8},3],"h":4,"j":3,"k":3,"l":3,"m":[{"n":8},3],"n":3,"p":[{"t":8,"s":8,"n":8},3],"q":3,"r":3,"s":3,"t":[{"z":8,"s":8,"e":{"r":{"i":{"n":[{"s":{"u":73}},72]}}}},3],"v":3,"w":3,"x":3,"y":3,"z":3,"o":{".":3,"r":{"t":{"e":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"a":{"m":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}},"e":{"c":{"r":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"o":{"h":53,"a":54,"e":54,"i":54,"o":54,"u":54,"á":54,"é":54,"í":54,"ó":54,"ú":54},"t":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}}},0],"p":[{".":1,"b":3,"c":3,"d":3,"f":3,"g":3,"h":4,"j":3,"k":3,"m":3,"n":[{".":1},3],"p":3,"q":3,"s":[{".":1,"i":{"c":[{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}},87],"q":87}},3],"t":[{".":1},3],"v":3,"w":3,"x":3,"y":3,"z":3,"l":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7,"a":{"n":{"c":{"t":10}}},"u":{"r":{"i":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},2],"r":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7,"e":{"e":{"l":{"i":{"j":29,"g":29}},"x":{"i":{"s":29}},"m":{"i":{"n":29}}},"o":{"c":{"u":{"p":34},"ú":{"p":49}},"l":{"í":29},"p":{"i":{"n":29}}}},"o":{"t":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},2],"u":{"t":{"a":15,"o":15}},"e":{"d":{"o":15},"r":{"e":{"m":{"i":{"a":67}}},"a":{"n":{"t":{"e":105}}},"p":{"o":{"n":{"d":{"r":106}}}}},"n":{"t":{"a":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"a":{"n":{"t":{"e":{"o":{"n":41}}}},"l":{"e":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"r":{"a":{"h":26,"a":27,"e":27,"i":[{"s":{".":49}},27],"o":27,"u":[{"l":{"a":{"t":{"a":35}}}},27],"á":27,"é":27,"í":[{"s":{"o":35}},27],"ó":27,"ú":27}}},"i":{"e":{"z":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"o":{"l":{"i":{"h":26,"a":[{"r":{"q":35,"c":{"a":35}},"n":{"d":{"r":35},"t":{"e":{"a":35}}}},27],"e":27,"i":27,"o":[{"m":{"i":{"e":10}}},27],"u":[{"r":90},27],"á":[{"r":{"q":35}},27],"é":[{"s":{"t":{"e":35}}},27],"í":27,"ó":27,"ú":27}},"s":{"t":{"a":{".":29,"s":{".":29}}}}}},0],"q":[{".":1,"b":3,"c":3,"d":3,"f":3,"g":3,"h":4,"j":3,"k":3,"l":3,"m":3,"n":3,"p":3,"q":3,"r":3,"s":3,"t":3,"v":3,"w":3,"x":3,"y":3,"z":3,"u":{"e":{"t":{"e":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}}},0],"r":[{".":1,"b":3,"c":[{"t":8,"n":8,"z":8},3],"d":3,"f":[{"t":8},3],"g":[{"n":8},3],"h":4,"j":3,"k":3,"l":3,"m":[{"n":8,"a":{"n":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},3],"n":3,"p":[{"t":8,"s":8,"n":8},3],"q":3,"s":3,"t":[{"z":8,"s":8},3],"v":3,"w":3,"x":3,"y":3,"z":3,"r":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7},2],"e":{"i":{"n":{"i":{"c":{"i":{"a":69,"á":69,"e":69}}},"í":{"c":{"i":{"a":69}}}}},"t":{"r":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"a":{"d":{"i":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"n":{"c":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"r":{"a":83,"á":83,"e":83,"é":83,"í":83,"o":83}},"o":{"m":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}}},0],"s":[{".":1,"b":3,"c":[{"t":8,"n":8,"z":8},3],"d":3,"f":[{"t":8},3],"g":[{"n":8},3],"h":4,"j":3,"k":3,"l":3,"m":[{"n":8},3],"n":3,"p":[{"t":8,"s":8,"n":8,"a":{"n":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},3],"q":3,"r":3,"s":3,"t":[{"z":8,"s":8,"e":{".":85,"s":{".":85}},"a":{"l":{".":85,"e":{"s":{".":93}}}},"i":{"l":{"l":{"a":{".":93,"s":{".":93}},"ó":{"n":{".":93}},"o":{"n":{"e":{"s":{".":93}}}}}}},"o":{"r":{".":85,"a":{".":85,"s":{".":85}},"e":{"s":{".":85}}}}},3],"v":3,"w":3,"x":3,"y":3,"z":3,"a":{"n":{"c":{"t":9}},".":60,"s":{".":60}},"e":{"m":{"i":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}},"u":{"d":{"o":{"h":97,"a":98,"e":98,"i":98,"o":98,"u":98,"á":98,"é":98,"í":98,"ó":98,"ú":98}}}},"o":{"b":{"r":{"e":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"c":{"i":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"u":{"d":{"o":{"e":{"s":58}}},"p":{"e":{"r":{"r":39,"a":[{"r":103},66],"e":66,"i":[{"o":{"r":43}},66],"o":66,"u":66,"á":[{"r":103,"v":{"i":{"t":{".":68,"s":{".":68}}}}},66],"é":66,"í":66,"ó":66,"ú":66}},"r":{"a":[{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38},107]}}}},0],"t":[{".":1,"b":3,"c":[{"t":8,"n":8,"z":8},3],"d":3,"f":[{"t":8},3],"g":[{"n":8},3],"h":4,"j":3,"k":3,"m":[{"n":8},3],"n":3,"p":[{"t":8,"s":8,"n":8},3],"q":3,"t":[{"z":8,"s":8},3],"v":3,"w":3,"y":3,"r":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7,"a":{"s":{"a":{"n":{"t":{"e":{"a":34}}}}},"n":{"s":{"a":[{"l":{"p":111},"n":{"d":111},"t":{"l":111},"c":{"c":{"i":34}}},110],"e":[{"ú":{"n":34},"x":{"u":112}},110],"i":[{"c":{"i":{"o":{"n":112},"ó":{"n":112}}},"g":{"i":112,"í":112,"e":112},"j":{"a":112,"á":112,"o":112},"s":{"t":{"o":34}},"t":{"a":112,"á":112,"e":112,"é":112,"o":[{"r":{"i":112}},112],"ó":112,"i":{"v":112}}},110],"o":[{"c":{"e":111}},110],"u":[{"r":111,"b":{"s":{"t":34}},"s":{"t":34}},110],"á":110,"é":110,"í":110,"ó":110,"ú":110}}},"o":{"p":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},2],"z":[{".":1,"s":{"c":{"h":14}}},13],"s":[{".":1},13],"l":13,"x":13,"e":{"t":{"a":{".":1,"s":{".":1}},"r":{"a":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"l":{"e":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}},"r":{"m":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"i":{"o":{"q":{"u":45},"c":{"o":45}}},"a":{"l":{"m":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"o":{"p":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}}},0],"v":[{".":1,"b":3,"c":3,"d":3,"f":3,"g":3,"h":4,"j":3,"k":3,"m":3,"n":3,"p":3,"q":3,"s":3,"t":3,"v":3,"w":3,"x":3,"y":3,"z":3,"l":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7},2],"r":[{".":1,"b":7,"c":7,"d":7,"f":7,"g":7,"h":7,"j":7,"k":7,"l":7,"m":7,"n":7,"p":7,"q":7,"r":7,"s":7,"t":7,"v":7,"w":7,"x":7,"y":7,"z":7},2],"i":{"c":{"e":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}},"d":{"e":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}}},0],"w":[{".":1,"b":3,"c":3,"d":3,"f":3,"g":3,"h":4,"j":3,"k":3,"l":3,"m":3,"n":3,"p":3,"q":3,"r":3,"s":3,"t":3,"v":3,"w":3,"x":3,"y":3,"z":3,"a":{"s":{"h":14}}},0],"x":[{".":1,"b":3,"c":[{"t":8,"n":8,"z":8},3],"d":3,"f":[{"t":8},3],"g":[{"n":8},3],"h":4,"j":3,"k":3,"l":3,"m":[{"n":8},3],"n":3,"p":[{"t":8,"s":8,"n":8},3],"q":3,"r":3,"s":3,"t":[{"z":8,"s":8},3],"v":3,"w":3,"x":3,"y":3,"z":3,"e":{"n":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}}},0],"y":[{".":1,"b":3,"c":[{"t":8,"n":8,"z":8},3],"d":3,"f":[{"t":8},3],"g":[{"n":8},3],"h":4,"j":3,"k":3,"l":3,"m":[{"n":8},3],"n":3,"p":[{"t":8,"s":8,"n":8},3],"q":3,"r":3,"s":3,"t":[{"z":8,"s":8},3],"v":3,"w":3,"x":3,"y":3,"z":3},0],"z":[{".":1,"b":3,"c":3,"d":3,"f":3,"g":3,"h":4,"j":3,"k":3,"l":3,"m":3,"n":3,"p":3,"q":3,"r":3,"s":3,"t":3,"v":3,"w":3,"x":3,"y":3,"z":3,"o":{"o":{"h":53,"a":54,"e":54,"i":54,"o":54,"u":54,"á":54,"é":54,"í":54,"ó":54,"ú":54}}},0],"ñ":[{".":1},0],"o":{"e":{"u":11,"ó":11},"a":{"e":11},".":1,"i":{"d":{"e":{"a":{".":44,"s":{".":44}},".":56,"s":{".":56}},"a":{"l":{".":44,"e":{"s":{".":44}}}}},"c":{"o":{".":57,"s":{".":57}},"a":{".":57,"s":{".":57}}}},"l":{"ó":{"g":{"i":{"c":{"o":{".":18,"s":{".":18}},"a":{".":18,"s":{".":18},"m":{"e":{"n":{"t":{"e":{".":18}}}}}}}}}},"o":{"g":{"í":{"a":{".":18,"s":{".":18}}}}},"i":{"g":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"s":{".":3,"o":{".":86,"s":{".":86}},"a":{".":86,"s":{".":86},"m":{"e":{"n":{"t":{"e":{".":86}}}}}}},"c":{"t":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27},"a":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}},"m":{"n":{"i":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}},"o":{"s":{".":2}},"n":{"e":{"s":{".":1}}}},"a":{"a":{"e":11,"ó":11},"i":{"g":{"a":{"n":{".":20}}}},"s":{".":1,"t":{"e":{".":1,"s":{".":1},"i":{"s":{".":1}}}},"e":{".":18,"s":{".":18},"i":{"s":{".":18}},"n":{".":18}},"u":{"b":36}},".":1,"m":{"o":{"s":{".":18}},"i":{"l":{"i":{"a":84}}}},"n":{".":1,"d":{"o":1},"a":{"l":{"í":29}},"f":{"i":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}},"g":{"l":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"t":{"e":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}},"t":{"e":{"s":{".":1}}},"r":{"o":{"n":{".":18},"s":{".":18}},"í":{"a":{".":18,"s":{".":18},"m":{"o":{"s":{".":18}}},"i":{"s":18},"n":{".":18}},"s":{".":18}},"é":{".":18,"s":{".":18},"i":{"s":{".":18}}},"á":{"s":{".":18},".":18,"n":{".":18}},"e":{"m":{"o":{"s":{".":18}}},".":18,"s":{".":18},"i":{"s":{".":18}},"n":{".":18}},"a":{".":18,"s":{".":18},"i":{"s":{".":18}},"n":{".":18}},".":1,"m":{"e":{".":25}},"t":{"e":{".":20}},"l":{"e":{".":20,"s":{".":20}},"a":{".":20,"s":{".":20}},"o":{".":20,"s":{".":20}}},"s":{"e":{".":20}},"n":{"o":{"s":{".":20}}},"c":{"h":{"i":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"i":{"o":[{".":85,"s":{".":85}},85],"a":85}},"b":{"a":{".":18,"s":{".":18},"i":{"s":{".":18}},"n":{".":18}}},"d":{".":1,"m":{"e":{".":1}},"t":{"e":{".":1}},"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{"s":{".":1}}},"n":{"o":{"s":{".":1}}},"o":{".":18,"s":{".":18},"r":{".":18,"a":{".":18,"s":{".":18}},"e":{"s":{".":18}}}},"a":{".":18,"s":{".":18}}},"o":{"s":{".":1}},"c":{"t":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}},"a":{"n":{"t":{"e":40}}},"i":{"ó":{"n":{".":18}},"o":{"n":{"e":{"s":{".":18}}}}}},"e":{"r":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}},"f":{"r":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}},"i":{"c":{"i":{"o":{"n":{"a":{"d":60}}}}}}},"u":{"t":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}},"l":{".":3,"e":{"s":{".":3}}},"í":{"s":{"o":{".":83,"s":{".":83}}}}},"e":{"o":{"á":12,"e":12,"s":{".":1}},"s":{".":1},".":1,"m":{"o":{"s":{".":18}},"b":{"o":{"c":{"a":1}}},"i":{"o":96}},"n":{".":1,"d":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}},"t":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27},"r":{"e":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"r":{"é":{".":18,"s":{".":18},"i":{"s":{".":18}}},"á":{"s":{".":18,"e":{"m":{"o":{"s":{".":24}}}}},".":18,"n":{".":18},"i":{"s":{".":23}},"b":{"a":{"m":{"o":{"s":{".":24}}}}},"r":{"a":{"m":{"o":{"s":{".":24}}}},"e":{"m":{"o":{"s":{".":24}}}}}},"í":{"s":{".":18},"a":{".":18,"s":{".":18},"m":{"o":{"s":{".":18}}},"i":{"s":{".":18}},"n":{".":18}}},"e":{"m":{"o":{"s":{".":21}}}},".":1,"m":{"e":{".":1}},"t":{"e":{".":1}},"l":{"e":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}}},"s":{"e":{".":1}},"n":{"o":{"s":{".":1}}},"o":{"s":{".":18}},"a":{"s":{".":23,"t":{"e":{".":23,"s":{".":23},"i":{"s":{".":23}}}},"e":{".":24,"s":{".":24},"i":{"s":{".":24}},"n":{".":24}}},"m":{"o":{"s":{".":24}}},"n":{".":23},"t":{"e":{"s":{".":23}}},"r":{"o":{"n":{".":24}},"í":{"a":{".":24,"s":{".":24},"m":{"o":{"s":{".":24}}},"i":{"s":24},"n":{".":24}},"s":{".":24}},"é":{".":24,"s":{".":24},"i":{"s":{".":24}}},"á":{"s":{".":24},".":24,"n":{".":24}},"e":{"m":{"o":{"s":{".":24}}},".":24,"s":{".":24},"i":{"s":{".":24}},"n":{".":24}},"a":{".":24,"s":{".":24},"i":{"s":{".":24}},"n":{".":24}}},"b":{"a":{".":24,"s":{".":24},"i":{"s":{".":24}},"n":{".":24}},"l":{"e":{".":104,"s":{".":104},"m":{"e":{"n":{"t":{"e":{".":104}}}}}}}},"d":{".":23,"o":{".":24,"s":{".":24},"r":{".":24,"a":{".":24,"s":{".":24}},"e":{"s":{".":24}}}},"a":{".":24,"s":{".":24}}}},"i":{"o":{"r":{".":18,"e":{"s":{".":18}},"a":{".":18,"s":{".":18}},"m":{"e":{"n":{"t":{"e":{".":18}}}}},"i":{"d":{"a":{"d":{".":18,"e":{"s":{".":18}}}}}}}}}},"d":{".":1,"m":{"e":{".":1}},"t":{"e":{".":1}},"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{"s":{".":1}}},"n":{"o":{"s":{".":1}}},"r":{"o":{".":18,"s":{".":18}}}},"e":{"d":{"l":{"a":{".":1}}}},"a":{"d":{"l":{"a":{".":1}}},"m":{"i":{"e":{"n":{"t":{"o":44}}}}},"c":{"i":{"o":{".":30,"s":{".":30}},"a":{".":30,"s":{".":30}}}}},"á":{"n":{"d":{"o":5}}},"c":{"a":{"n":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"o":{"h":53,"a":54,"e":54,"i":54,"o":54,"u":54,"á":54,"é":54,"í":54,"ó":54,"ú":54},"t":{"r":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"u":{"c":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}},"r":{"o":{"h":26,"a":27,"e":27,"i":27,"o":27,"u":27,"á":27,"é":27,"í":27,"ó":27,"ú":27}}},"x":{"á":{"m":{"e":{"n":29}},"r":{"i":29}},"é":{"g":{"e":29}},"ó":{"t":{"i":29}},"a":{"c":{"e":{"r":{"b":29}}},"g":{"e":{"r":29}},"m":{"i":{"n":29}}},"e":{"c":{"r":29},"g":{"é":{"t":{"i":29}}},"q":{"u":{"i":{"a":29}}}},"i":{"j":{"a":29,"á":29,"o":29},"g":{"e":29,"i":29,"í":29},"l":{"i":{"a":29,"á":29,"e":29,"é":29,"o":29,"ó":29},"a":{"r":29}},"m":{"a":29,"á":29,"i":29,"í":29,"e":29,"é":29,"o":29,"ó":29},"t":{"o":{"s":29}}},"í":{"j":{"a":29,"o":29},"g":{"e":29},"l":{"i":{"a":29,"e":29,"o":29}},"m":{"a":29,"i":29,"e":29,"o":29}},"o":{"n":{"e":{"r":29}},"c":{"r":{"i":{"n":29}}},"t":{"é":{"r":29},"i":{"c":29,"q":29,"s":{"m":29}}},"g":{"a":{"m":{"i":29}},"á":{"m":{"i":29}}}},"u":{"b":{"e":{"r":29}},"d":{"a":{"r":29,"t":29,"c":29}}},"t":{"r":{"a":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"p":{"o":{"l":{"i":91}}}}},"i":{"g":{"o":{".":18},"a":{".":18,"s":{".":18},"m":{"o":{"s":{".":18}}}},"á":{"s":{".":18},"i":{"s":{".":18}},"m":{"o":{"s":{"m":{"e":{".":21,"l":{"e":{".":21,"s":{".":21}},"o":{".":21,"s":{".":21}},"a":{".":22,"s":{".":22}}}}},"t":{"e":{".":21,"l":{"e":{".":21,"s":{".":21}},"o":{".":21,"s":{".":21}},"a":{".":22,"s":{".":22}}}}},"l":{"e":{".":21,"s":{".":21}},"a":{".":21,"s":{".":21}},"o":{".":21,"s":{".":21}}},"e":{"l":{"e":{".":21,"s":{".":21}},"o":{".":21,"s":{".":21}},"a":{".":21,"s":{".":21}}}}},"n":{"o":{"s":{".":21,"l":{"e":{".":21,"s":{".":21}},"o":{".":21,"s":{".":21}},"a":{".":21,"s":{".":21}}}}}},"o":{"s":{".":21,"l":{"e":{".":21,"s":{".":21}},"o":{".":21,"s":{".":21}},"a":{".":21,"s":{".":21}}}}}}}}},"d":{"a":{"l":{".":57,"e":{"s":{".":57}}}},"e":{"o":{".":18,"s":{".":18}}}},"n":{"i":{"c":{"i":[{"a":29,"á":29,"e":29},29]}},"í":{"c":{"i":[{"a":29},29]}},"f":{"r":{"a":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}},"t":{"e":{"r":{"é":{"s":43},"e":{"s":{"a":{"r":75}}},"i":{"n":[{"s":{"t":77}},76],"o":{"r":79}},"r":{"e":{"g":{"n":{"o":78}}}}}},"r":{"a":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"b":{"e":{"r":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}},"c":{"o":{"n":{"o":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}},".":86,"s":{".":86}},"a":{".":86,"s":{".":86}}},"a":{"n":{"o":{".":25,"s":{".":25}},"a":{".":25,"s":{".":25}}},"r":{"e":{"s":{".":83}}},".":2,"s":{".":2}},"s":{"o":{"h":53,"a":54,"e":54,"i":54,"o":54,"u":54,"á":54,"é":54,"í":54,"ó":54,"ú":54}},"o":{".":2,"s":{".":2}},"e":{"r":{".":25}}},"é":{"s":1,"i":{"s":{".":1}},".":1,"d":{"m":{"e":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":19,"s":{".":19}}}}},"t":{"e":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":19,"s":{".":19}}}}},"s":{"e":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}}}}},"n":{"o":{"s":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}}}}}},"r":{"i":{"c":{"o":{".":18,"s":{".":18}},"a":{".":18,"s":{".":18}}}}}},"o":{"s":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}}}}},"r":{"m":{"e":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":19,"s":{".":19}}}}},"t":{"e":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":19,"s":{".":19}}}}},"s":{"e":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}}}}},"n":{"o":{"s":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}}}}}},"o":{"s":{"l":{"e":{".":18,"s":{".":18}},"o":{".":18,"s":{".":18}},"a":{".":18,"s":{".":18}}}}}}},"í":{"a":{".":1,"s":{".":1},"m":{"o":{"s":{".":19}}},"i":{"s":{".":1}},"n":{".":1}},".":1,"s":{"t":{"e":{".":20,"s":{".":20},"i":{"s":{".":19}}},"a":{".":1,"s":{".":1}},"i":{"c":{"o":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}}}}},"m":{"o":{".":1,"s":{".":1}}}},"t":{"e":{"s":{".":18}}},"m":{"o":{"s":{".":18}}},"d":{"o":{".":18,"s":{".":18}},"a":{".":18,"s":{".":18}}},"b":{"l":{"e":{".":18,"s":{".":18}}}}},"á":{"s":{".":1,"e":{"m":{"o":{"s":{".":18}}}}},"i":{"s":{".":1}},"b":{"a":{"m":{"o":{"s":{".":18}}}}},"r":{"a":{"m":{"o":{"s":{".":18}}}},"e":{"m":{"o":{"s":{".":18}}}},"m":{"e":{"l":{"e":{".":25,"s":{".":20}},"o":{".":25,"s":{".":20}},"a":{".":20,"s":{".":20}}}}},"t":{"e":{"l":{"e":{".":20,"s":{".":20}},"o":{".":20,"s":{".":20}},"a":{".":20,"s":{".":20}}}}},"s":{"e":{"l":{"e":{".":20,"s":{".":20}},"o":{".":20,"s":{".":20}},"a":{".":20,"s":{".":20}}}}},"n":{"o":{"s":{"l":{"e":{".":20,"s":{".":20}},"o":{".":20,"s":{".":20}},"a":{".":20,"s":{".":20}}}}}},"o":{"s":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}}}}}},"d":{"m":{"e":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":19,"s":{".":19}}}}},"t":{"e":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":19,"s":{".":19}}}}},"s":{"e":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}}}}},"n":{"o":{"s":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}}}}}}},"o":{"s":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}}}}},"n":{"d":{"o":{"l":{"e":{".":1,"s":{".":1}},"o":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}}},"n":{"o":{"s":{".":1}}},"o":{"s":{".":1}},"m":{"e":{".":1,"l":{"o":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}},"e":{".":1,"s":{".":1}}}}},"t":{"e":{".":1,"m":{"e":{".":1}},"l":{"o":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}},"e":{".":1,"s":{".":1}}},"n":{"o":{"s":{".":1}}}}},"s":{"e":{".":1,"m":{"e":{".":1}},"l":{"o":{".":1,"s":{".":1}},"a":{".":1,"s":{".":1}},"e":{".":1,"s":{".":1}}},"n":{"o":{"s":{".":1}}}}}}}}},"ó":{".":1,"l":{"o":{"g":{"o":{".":18,"s":{".":18}},"a":{".":18,"s":{".":18}}}}},"t":{"i":{"c":3}},"n":{".":1},"s":{"t":{"e":{"o":{".":1,"s":{".":1}}}}}},"u":{"t":{"e":{"r":{"i":5}}},"l":{"t":{"r":{"a":{"h":37,"a":38,"e":38,"i":38,"o":38,"u":38,"á":38,"é":38,"í":38,"ó":38,"ú":38}}}}}}',
      []
    ];
  });
})(Ss);
var G0 = Ss.exports, Q0 = to(
  G0
);
As(2);
const ec = As(3);
function As(t) {
  if (typeof t != "number" || Number.isNaN(t) || t < 1 || t === Number.POSITIVE_INFINITY)
    throw new Error("`" + t + "` is not a valid argument for `n-gram`");
  return e;
  function e(a) {
    const n = [];
    if (a == null)
      return n;
    const i = typeof a.slice == "function" ? a : String(a);
    let o = i.length - t + 1;
    if (o < 1)
      return n;
    for (; o--; )
      n[o] = i.slice(o, o + t);
    return n;
  }
}
const tc = /\s+/g, ac = /[\t\n\v\f\r ]+/g;
function nc(t, e) {
  e ? typeof e == "string" && (e = { style: e }) : e = {};
  const a = e.preserveLineEndings ? ic : oc;
  return String(t).replace(
    e.style === "html" ? ac : tc,
    e.trim ? sc(a) : a
  );
}
function ic(t) {
  const e = /\r?\n|\r/.exec(t);
  return e ? e[0] : " ";
}
function oc() {
  return " ";
}
function sc(t) {
  return e;
  function e(a, n, i) {
    return n === 0 || n + a.length === i.length ? "" : t(a);
  }
}
const Is = {}.hasOwnProperty;
function rc(t) {
  return t == null ? "" : nc(String(t).replace(/[\u0021-\u0040]+/g, " ")).trim().toLowerCase();
}
function lc(t) {
  return ec(" " + rc(t) + " ");
}
function cc(t) {
  const e = lc(t), a = {};
  let n = -1;
  for (; ++n < e.length; )
    Is.call(a, e[n]) ? a[e[n]]++ : a[e[n]] = 1;
  return a;
}
function uc(t) {
  const e = cc(t), a = [];
  let n;
  for (n in e)
    Is.call(e, n) && a.push([n, e[n]]);
  return a.sort(fc), a;
}
function fc(t, e) {
  return t[1] - e[1];
}
const dc = {
  cmn: /[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFA6D\uFA70-\uFAD9]|\uD81B[\uDFE2\uDFE3\uDFF0\uDFF1]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF]/g,
  Latin: /[A-Za-z\u00AA\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uAB66-\uAB69\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A]|\uD801[\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]/g,
  Cyrillic: /[\u0400-\u0484\u0487-\u052F\u1C80-\u1C88\u1D2B\u1D78\u2DE0-\u2DFF\uA640-\uA69F\uFE2E\uFE2F]|\uD838[\uDC30-\uDC6D\uDC8F]/g,
  Arabic: /[\u0600-\u0604\u0606-\u060B\u060D-\u061A\u061C-\u061E\u0620-\u063F\u0641-\u064A\u0656-\u066F\u0671-\u06DC\u06DE-\u06FF\u0750-\u077F\u0870-\u088E\u0890\u0891\u0898-\u08E1\u08E3-\u08FF\uFB50-\uFBC2\uFBD3-\uFD3D\uFD40-\uFD8F\uFD92-\uFDC7\uFDCF\uFDF0-\uFDFF\uFE70-\uFE74\uFE76-\uFEFC]|\uD803[\uDE60-\uDE7E\uDEFD-\uDEFF]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uDEF0\uDEF1]/g,
  ben: /[\u0980-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09FE]/g,
  Devanagari: /[\u0900-\u0950\u0955-\u0963\u0966-\u097F\uA8E0-\uA8FF]|\uD806[\uDF00-\uDF09]/g,
  jpn: /[\u3041-\u3096\u309D-\u309F]|\uD82C[\uDC01-\uDD1F\uDD32\uDD50-\uDD52]|\uD83C\uDE00|[\u30A1-\u30FA\u30FD-\u30FF\u31F0-\u31FF\u32D0-\u32FE\u3300-\u3357\uFF66-\uFF6F\uFF71-\uFF9D]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00\uDD20-\uDD22\uDD55\uDD64-\uDD67]|[\u3400-\u4DB5\u4E00-\u9FAF]/g,
  jav: /[\uA980-\uA9CD\uA9D0-\uA9D9\uA9DE\uA9DF]/g,
  kor: /[\u1100-\u11FF\u302E\u302F\u3131-\u318E\u3200-\u321E\u3260-\u327E\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/g,
  tel: /[\u0C00-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3C-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C5D\u0C60-\u0C63\u0C66-\u0C6F\u0C77-\u0C7F]/g,
  tam: /[\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BFA]|\uD807[\uDFC0-\uDFF1\uDFFF]/g,
  guj: /[\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AF1\u0AF9-\u0AFF]/g,
  kan: /[\u0C80-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDD\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1-\u0CF3]/g,
  mal: /[\u0D00-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4F\u0D54-\u0D63\u0D66-\u0D7F]/g,
  mya: /[\u1000-\u109F\uA9E0-\uA9FE\uAA60-\uAA7F]/g,
  pan: /[\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A76]/g,
  amh: /[\u1200-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u137C\u1380-\u1399\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]/g,
  tha: /[\u0E01-\u0E3A\u0E40-\u0E5B]/g,
  sin: /[\u0D81-\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2-\u0DF4]|\uD804[\uDDE1-\uDDF4]/g,
  ell: /[\u0370-\u0373\u0375-\u0377\u037A-\u037D\u037F\u0384\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03E1\u03F0-\u03FF\u1D26-\u1D2A\u1D5D-\u1D61\u1D66-\u1D6A\u1DBF\u1F00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FC4\u1FC6-\u1FD3\u1FD6-\u1FDB\u1FDD-\u1FEF\u1FF2-\u1FF4\u1FF6-\u1FFE\u2126\uAB65]|\uD800[\uDD40-\uDD8E\uDDA0]|\uD834[\uDE00-\uDE45]/g
}, li = {
  Latin: {
    spa: " de|de |os | la| a |la | y |ón |ión|es |ere|rec|ien|o a|der|ció|cho|ech|en |a p|ent|a l|aci|el |na |ona|e d| co|as |da | to|al |ene| en|tod| pe|e l| el|ho |nte| su|per|a t|ad | ti|ers|tie| se|rso|son|e s| pr|o d|oda|te |cia|n d| es|dad|ida| in|ne |est|ion|cio|s d|con|a e| po|men| li|n e|nci|res|su |to |tra| re| lo|tad| na|los|a s| o |ia |que| pa|rá |pro| un|s y|ual|s e|lib|nac|do |ra |er |a d|ue | qu|e e|sta|nal|ar |nes|ica|a c|ser|or |ter|se |por|cci|io |del|l d|des|ado|les|one|a a|ndi| so| cu|s p|ale|s n|ame|par|ici|oci|una|ber|s t|rta|com| di|dos|e a|imi|o s|e c|ert|las|o p|ant|dic|nto| al|ara|ibe|enc|o e|s l|cas| as|e p|ten|ali|o t|soc|y l|n c|nta|so |tos|y a|ria|n t|die|a u| fu|no |l p|ial|qui|dis|s o|hos|gua|igu| ig| ca|sar|l t| ma|l e|pre| ac|tiv|s a|re |nad|vid|era| tr|ier|cua|n p|ta |cla|ade|bre|s s|esa|ntr|ecc|a i| le|lid|das|d d|ido|ari|ind|ada|nda|fun|mie|ca |tic|eli|y d|nid|e i|odo|ios|o y|esp|iva|y e|mat|bli|r a|drá|tri|cti|tal|rim|ont|erá|us |sus|end|pen|tor|ito|ond|ori|uie|lig|n a|ist|rac|lar|rse|tar|mo |omo|ibr|n l|edi|med| me|nio|a y|eda|isf|lo |aso|l m|ias|ico|lic|ple|ste|act|tec|ote|rot|ele|ura| ni|ie |adi|u p|seg|s i|un |und|a n|lqu|alq|o i|inc|sti| si|n s|ern",
    eng: "the| th| an|he |nd |ion|and| to|to |tio| of|on |of | in|al |ati|or |ght|igh|rig| ri|ne |ent|one|ll |is |as |ver|ed | be|e r|in |t t|all|eve|ht | or|ery|s t|ty | ev|e h|yon| ha|ryo|e a|be |his| fr|ng |d t|has| sh|ing| hi|sha| pr| co| re|hal|nal|y a|s a|n t|ce |men|ree|fre|e s|l b|nat|for|ts |nt |n a|ity|ry |her|nce|ect|d i| pe|pro|n o|cti| fo|e e|ly |es | no|ona|ny |any|er |re |f t|e o| de|s o| wi|ter|nte|e i|ons| en| ar|res|ers|y t|per|d f| a | on|ith|l a|e t|oci|soc|lit| as| se|dom|edo|eed|nti|s e|t o|oth|wit| di|equ|t a|ted|st |y o|int|e p| ma| so| na|l o|e c|ch |d a|enc|th |are|ns |ic | un| fu|tat|ial|cia| ac|hts|nit|qua| eq| al|om |e w|d o|f h|ali|ote|n e| wh|r t|sta|ge |thi|o a|tit|ual|an |te |ess| ch|le |ary|e f|by | by|y i|tec|uni|o t|o o| li|no | la|s r| su|inc|led|rot|con| pu| he|ere|imi|r a|ntr| st| ot|eli|age|dis|s d|tle|itl|hou|son|duc|edu| wo|ate|ble|ces|at | at| fa|com|ive|o s|eme|o e|aw |law|tra|und|pen|nde|unt|oun|n s|s f|f a|tho|ms | is|act|cie|cat|uca| ed|anc|wor|ral|t i| me|o f|ily|pri|ren|ose|s c|en |d n|l c|ful|rar|nta|nst| ag|l p|min|din|sec|y e| tr|rso|ich|hic|whi|cou|ern|uri|r o|tic|iti|igi|lig|rat|rth|t f|oms|rit|d r|ee |e b|era|rou|se |ay |rs | ho|abl|e u",
    por: "de | de| se|ão |os |to |em | e |do |o d| di|er |ito|eit|ser|ent|ção| a |dir|ire|rei|o s|ade|dad|uma|as |no |e d| to|nte| co|o t|tod| ou|men|que|s e|man| pr| in| qu|es | te|hum|odo|e a|da | hu|ano|te |al |tem|o e|s d|ida|m d| pe| re|o a|ou |r h|e s|cia|a e| li|o p| es|res| do| da| à |ual| em| su|açã|dos|a p|tra|est|ia |con|pro|ar |e p|is | na|rá |qua|a d| pa|com|ais|o c|ame|erá| po|uer|sta|ber|ter| o |ess|ra |e e|das|o à|nto|nal|o o|a c|ido|rda|erd| as|nci|sua|ona|des|ibe|lib|e t|ado|s n|ua |s t|ue | so|ica|ma |lqu|alq|tos|m s|a l|per|ada|oci|soc|cio|a n|par|aci|s a|pre|ont|m o|ura|a s| um|ion|e o|or |e r|pel|nta|ntr|a i|io |nac|ênc|str|ali|ria|nst| tr|a q|int|o n|a o|ca |ela|uçã|lid|e l| at|sen|ese|r d|s p|egu|seg|vid|pri|sso|ém |ime|tic|dis|raç|eci|ara| ca|nid|tru|ões|ass|seu|por|a a|m p| ex|so |r i|eçã|teç|ote|rot| le| ma|ing|a t|ran|era|rio|l d|eli|ça |sti| ne|cid|ern|utr|out|r e|e c|tad|gua|igu| ig| os|s o|ruç|ins|çõe|ios| fa|e n|sse| no|re |art|r p|rar|u p|inc|lei|cas|ico|uém|gué|ngu|nin| ni|gur|la |pen|nça|na |içã|ião|cie|ist|sem|ta |ele|e f|om |tro| ao|rel|m a|s s|tar|eda|ied|uni|e m|s i|a f|ias| cu| ac|r a|á a|rem|ei |omo|rec|for|s f|esc|ant|à s| vi|o q|ver|a u|nda|und|fun",
    ind: "an |ang|ng | da|ak | pe|ata| se| ke| me|dan| di| be|ber|kan|ran|hak|per|yan| ya|nga|nya|gan| at|ara| ha|eng|asa|ora|men|n p|n k|erh|rha|n d|ya |ap |at |as |tan|n b|ala|a d| or|a s|san|tas|eti|uk |pen|g b|set|ntu|n y|tia|iap|k m|eba|aan| un|n s|tuk|k a|p o|am |lam| ma|unt| de|ter|bas|beb|dak|end|i d|pun|mem|tau|dal|ama|keb|aka|ika|n m| ba|di |ma | sa|den|au |nda|n h|eri| ti|ela|k d|un |n a|ebe|ana|ah |ra |ida|uka| te|al |ada|ri |ole|tid|ngg|lak|leh|dap|a p|dil|g d|ena|eh |gar|na |ert|apa|um |tu |atu|a m|sam|ila|har|n t|asi|ban|erl|t d|bat|uat|ta |lan|adi|h d|neg| ne|kum|mas|nan|pat|aha| in|l d|emp|sem|rus|sua|ser|uan|era|ari|erb|kat|man|a b|g s|rta|ai |nny|n u|ung|ndi|han|uku|huk| hu|sa |ers|in | la|ka | su|ann|car|kes|aku|dip|i s|a a|erk|n i|lai|rga|aru|k h|i m|rka|a u|us |nak|emb|gga|nta|iba| pu|ind|s p|ent|mel|ina|min|ian|dar|ni |rma|lua|rik|ndu|lin|sia|rbu|g p|k s|da |aya|ese|u d|ega|nas|ar |ipe|yar|sya|ik |aga| ta|ain|ua |arg|uar|iny|pem|ut |si |dun|eor|seo|rak|ngs|ami|kel|ini|g t|dik|mer|emu|aks|rat|uru|ewa|il |enu|any|kep|pel|asu|rli|ia |dir|jam|mba|mat|pan|g m|ses|sar|das|kuk|bol|ili|u k|gsa|u p|a k|ern|ant|raa|t p|ema|mua|idi|did|t s|i k|rin|erm|esu|ger|elu|nja|enj|ga |dit",
    fra: " de|es |de |ion|nt |tio|et |ne |on | et|ent|le |oit|e d| la|e p|la |it | à |t d|roi|dro| dr| le|té |e s|ati|te |re | to|s d|men|tou|e l|ns | pe| co|son|que| au| so|e a|onn|out| un| qu| sa| pr|ute|eme| l’|t à| a |e e|con|des| pa|ue |ers|e c| li|a d|per|ont|s e|t l|les|ts |tre|s l|ant| ou|cti|rso|ou |ce |ux |à l|nne|ons|ité|en |un | en|er |une|n d|sa |lle| in|nte|e t| se|lib|res|a l|ire| d’| re|é d|nat|iqu|ur |r l|t a|s s|aux|par|nal|a p|ans|dan|qui|t p| dé|pro|s p|air| ne| fo|ert|s a|nce|au |ui |ect|du |ond|ale|lit| po|san| ch|és | na|us |com|our|ali|tra| ce|al |e o|e n|rté|ber|ibe|tes|r d|e r|its| di|êtr|pou|été|s c|à u|ell|int|fon|oci|soc|ut |ter| da|aut|ien|rai| do|iss|s n| ma|bli|ge |est|s o| du|ona|n p|pri|rs |éga| êt|ous|ens|ar |age|s t| su|cia|u d|cun|rat| es|ir |n c|e m| ét|t ê|a c| ac|ote|n t|ein| tr|a s|ndi|e q|sur|ée |ser|l n| pl|anc|lig|t s|n e|s i|t e| ég|ain|omm|act|ntr|tec|gal|ul | nu| vi|me |nda|ind|soi|st | te|pay|tat|era|il |rel|n a|dis|n s|pré|peu|rit|é e|t é|bre|sen|ill|l’a|d’a| mo|ass|lic|art| pu|abl|nta|t c|rot| on| lo|ure|l’e|ava|ten|nul|ivi|t i|ess|ys |ays| fa|ine|eur|rés|cla|tés|oir|eut|e f|utr|doi|ibr|ais|ins|éra|’en|iét|l e|s é|nté| ré|ssi| as|nse|ces|é a",
    deu: "en |er |der|ein| un|nd |und|ung|cht|ich| de|sch|ng | ge|ine|ech|gen|rec|che|ie | re|eit| au|ht |die| di| ha|ch | da|ver| zu|lic|t d|in |auf| ei| in| be|hen|nde|n d|uf |ede| ve|it |ten|n s|sei|at |jed| je| se|and|rei|s r|den|ter|ne |hat|t a|r h|zu |das|ode| od|as |es | an|fre|nge| we|n u|run| fr|ere|e u|lle|ner|nte|hei|ese| so|rde|wer|ige| al|ers|n g|hte|d d| st|n j|lei|all|n a|nen|ege|ent|bei|g d|erd|t u|ren|nsc|chu| gr|kei|ens|le |ben|aft|haf|cha|tli|ges|e s| si|men| vo|lun|em |r s|ion|te |len|gru|gun|tig|unt|uch|spr|n e|ft |ei |e f| wi| sc|r d|n n|geh|r g|dar|sta|erk| er|r e|sen|eic|gle| gl|lie|e e|tz |fen|n i|nie|f g|t w|des|chl|ite|ihe|eih|ies|ruc|st |ist|n w|h a|n z|e a| ni|ang|rf |arf|gem|ale|ati|on |he |t s|ach| na|end|n o|pru|ans|sse|ern|aat|taa|ehe|e d|hli|hre|int|tio|her|nsp|de |mei| ar|r a|ffe|e b|wie|erf|abe|hab|ndl|n v|sic|t i|han|ema|nat|ber|ied|geg|d s|nun|d f|ind| me|gke|igk|ieß| fa|igu|hul|r v|dig|rch|urc|dur| du|utz|hut|tra|aus|alt|bes|str|ell|ste|ger|r o|esc|e g|rbe|arb|ohn|r b|mit|d g|r w|ntl|sow|n h|nne|etz|raf|dlu| ih|lte|man|iem|erh|eru| is|dem|lan|rt |son|isc|eli|rel|n r|e i|rli|r i| mi|e m|ild|bil| bi|eme| en|ins|für| fü|gel|öff| öf|owi|ill|wil|e v|ric|f e",
    jav: "ng |an | ka|ang|ing|kan| sa|ak |lan| la|hak| pa| ha|ara|ne |abe| in|n k|ngg|ong|ane|nga|ant|won|uwo| an| uw|nin|ata|n u|en |ra |tan| da|ran|ana| ma|nth|ake|ben|beb|hi |ke |sab|nda| ng|adi|thi|nan|a k| ba|san|asa|ni |e h|e k|g k| ut|pan|awa| be|eba|gan|g p|dan| wa|bas|aka|dha|yan|sa |arb|man| di|wa |g d| na|g n|ban| tu|n s|ung|wen|g s|rbe|dar|dak|di |g u|ora|aya|be |ah |a s|eni| or|han|as | pr|a n|na |iya|a a|kar|at |a l|mar|uwe|duw|uta|und|n p|asi|pa | si|ala|n n| un|kab|oni|ya |i h|gar|g b|yat|tum|ta |n m|i k|apa|taw| li|ani| ke|al |ka |kal|ngk|ega| ne|nal|n i|g a|ggo|ina|we |ena|dad|iba|awi|aga|a p| ta|sar|adh|awe|and|uju|ind|min|sin|ndu|uwa|gge|n l|ggu|ngs|n b|a b|pra|iji|n a|ha | bi|kat|go | ku|e p|ron|kak|ngu|a u|gsa|war|nya|g t|pad|bis|k b|i w|ae |wae| nd|ali|a m|er |sak|e s|ku |liy|ama|i l|eh |isa|arg|n t|a d|kap|i s|ayo|gay| pe|ndh|bad|pri|neg|tow|uto|eda|bed|il |ih | ik|ur |k k|rta|art|i p|rga|lak|ami|ro |aro|yom|r k|e d|a w|kon|rib|eng|ger|g l|ras|dil| ti|k l|rap|mra|uma| pi|k h|n d|gaw|wat|ga |k n|ar |per| we|oma|k p|jro|ajr|saj|ase|ini|ken|saw|ona|nas|kas|h k|i t| um|tin|wo | me|aba|rak|pag|yar|sya|t k| te| mu|ngl| ni|i b|men|ate|a i|aku|ebu|a t| du|g m|owo|mat| lu|amp",
    vie: "ng |̣c |́c | qu|à | th|nh | ng|̣i |̀n |và| va| nh|uyê| ph|quy| ca|ền|yề|̀nh|̀i |̣t | ch|ó | tr|ngư|i n| gi|gươ|ời|ườ|́t | co|ượ| cu|ác|ự |ợc| kh| đư|đươ| tư|có| ha|ông|c t| đê|n t|i đ|ìn|̀u |cá|gia|́i |ọi|mọ| mo|ều|iệ|đề|u c|như|pha| ba| bi|ất|̉a |ủa|củ|hôn| đô|g t|́ q|̃ng| ti|tự|t c|̣n | la|n đ|n c|n n|hiê|ch |ay |hay| vi|ân | đi| na|bả| ho|do | do| tô| hi|ội|há|ị |nà|̀ t|ới|hân| mô|́p |àn|̣ d|́ch|̣p |̀o |ào|khô|́n |ột|mộ| hô|ia |ốc|c h|hữ|i v|g n|́ng|uố|quô|h t|ôn |ên |n v|nhâ|̣ t| bâ|i c|g v|̉ng|iế|c c|ật|thư|hư |ướ|̉n | vơ| cô|c đ| đo| sư|t t|ộc|ữn|vớ| vê|ả |̣ng|g đ|̉o |ảo|uậ| đa|bị|là|sự|bấ|hà|hộ|i t|ản|hươ|̀ng|tro|̉m |o v| mi|ể |ục|i h|ức|áp|g c|̃ h|iá|n b|̉i |a m|h c|côn|ện|ớc|hạ|độ| du| cư|a c|n h|tha|ã | xa|́o |áo|ín|̀y |g b| hư|g h|ong|ron|̀ c|cho|̀ n|mì|ực|h v|c b| lu|i b|ệ |ai |ế |̣ c|xã|kha|c q|iể|tộ|ối|đố|á |hoa|o h|h đ|cả|n l|họ|tiê|y t|̉ c|ại|án|̀ đ|oà|y đ|chi|̉ n|phâ|ề |thu|iên|dụ|o c|i m|luâ|c p|ốn|c l|́ c|ũn|cũ|c g|c n|qua|n g|c m|o n|ải|hả|́ t|ho |về| tâ| hơ|o t|ở |hứ|hì|viê|̀m |̉ t|đó|thô|ứ |cứ|hí|́nh|ày|ởn|ưở| bă|tri| ta|m v|c v|ợp|hợ|h m| nư|ết|thi|ặc|ngh|uy ",
    ita: " di|to | in|ion|la | de|di |re |e d|ne | e |zio|rit|a d|one|o d|ni |le |lla|itt|ess| al|iri|dir|tto|ent|ell|i i|del|ndi|ere|ind|o a| co|te |tà |ti |a s|uo |e e|gni|azi| pr|idu|ivi|duo|vid|div|ogn| og| es|i e| ha|all|ale|nte|e a|men|ser| su| ne|e l|za |i d|per|a p|ha | pe| un|con|no |sse|li |e i| o | so| li| la|pro|ia |o i|e p|o s|i s|in |ato|o h|na |e s|a l|e o|nza|ali|tti|o p|ta |so |ber|ibe|lib|o e|un | a | ri|ua |il | il|nto|pri|el | po|una|are|ame| qu|a c|ro |oni|nel|e n| ad|ual|gli|sua|ond| re|a a|i c|ri |o o|sta|ita|i o| le|ad |i a|ers|enz|ssi|à e|ità|gua|i p|e c|io | pa|ter|soc|nal|ona|naz|ist|cia|rso|ver|a e|i r|tat|lle|sia| si|rio|tra|che| se|rtà|ert|anz|eri|tut|à d|he | da|al |ant|qua|on |ari|o c| st|oci|er |dis|tri|si |ed | ed|ono| tu|ei |dei|uzi|com|att|a n|opr|rop|par|nes|i l|zza|ese|res|ien|son| eg|n c|ont|nti|pos|int|ico|rà |sun|ial|lit|sen|pre|tta|dev|nit|era|eve|ll |l i| l |nda|ina|non| no|o n|ria|str|d a|art|se |ssu|ica|raz|ett|sci|gio|ati|egu| na|i u|utt|ve | ma|do |e r|ssa|sa |a f|n p|fon| ch|d u|rim| fo|a t| sc|trà|otr|pot|n i| cu|l p|ra |ezz|a o|ini|sso|dic|ltr|uni|cie| ra|i n|ruz|tru|ste| is|der|l m|a r|pie|lia|est|dal|nta| at|tal|ntr| pu|nno|ann|ten|vit|a v",
    tur: " ve| ha|ve |ir |ler|hak| he|her|in |lar|r h|bir|ya |er |ak |kkı|akk|eti| ka| bi|eya|an |eri|iye|yet|ara|ek | ol|de |vey|ın |ır |nda|arı|esi|ını|dır| ta|tle|e h|ası|etl|e k| va|ı v|sın|ile|ne |rke|erk|ard|ine| sa|ınd|ini|k h|kın|ama|le |tin|rdı|var|a v| me|e m|na |sin|ere|k v| şa| bu|lan|kes|dir|rin|dan| ma|kı |mak|şah|da | te|mek| ge|nı | hi|nin|en |n h| se|lik|rle|ana|lma|e a|ı h|r ş|ill|si | de|aya|zdi|izd|aiz|hai|ret|hiç|ına| iş|e b| ba|kla|et | hü|rın|n k|ola|nma|e t| ya|eme|riy|n v|e i|a h|li |mil|eli|ket|ik |kar|irl|hür|im |evl|mes|e d|ahs|ma |rak|ala|let|lle|un | ed|rri|ürr|bu | mi|i v|dil| il| eş|n i|la |el |mal| mü| ko|e g|se | ki|mas|lek|mle|mem|n b|ili|e e|ser| iç|n s|din| di|es |mel|eke|tir|şit|eşi|r b|akl|yla|n m|len| ke|edi|oru|nde|re |ele|ni |tür|a k|eye|ık |ken|uğu| uy|eml|erd|ede|ame| gö|e s|i m|tim|i b|rde|rşı|arş|a s|it |t v|siy|ar |rme|est|bes|rbe|erb|te |alı| an|ndi|end|hsı|unm|rı |kor|nın| ce|maz|mse|ims|kim|iç | ay|a m|lam|ri |sız|a b|ade|n t|nam|lme|ilm|k g|il |tme|etm|r v|e v|n e|ğre|öğr| öğ|al |ıyl|olm|vle|şma|i s|ger|me | da|ind|lem|i o|may|cak|çin|içi|nun|kan|ye |e y|r t|az |ç k|ece|sı |eni| mu|ulu|und|den|lun| fa|şı |ahi|l v|r a|san|kat| so|enm| ev|iş ",
    pol: " pr|nie|pra| i |nia|ie |go |ani|raw|ia | po|ego| do|wie|iek|awo| ni|owi|ch |ek |do | ma|wo |a p|ści|ci |ej | cz| za| w |ych|ośc|rze|prz| ka|wa |eni| na| je|ażd|każ|ma |zło|czł|noś|o d|łow|y c|dy |żdy|i p|wol| lu|ny |oln| wy|stw| wo|ub |lub|lno|rod|k m|twa|dzi|na | sw|rzy|ają|ecz|czn|sta| sp|owa|o p|spo|i w|kie|a w|zys|obo|est|neg|ać |mi |cze|e w|nyc|nic|jak| ja|wsz| z |jeg|wan|ńst|o s|a i|awa|e p|yst|pos|pow| ró|o o|jąc|ony|nej|owo|dow|ów | ko|kol|aki|bez|rac|sze|iej| in|zen|pod|i i|ni | ro|cy |o w|zan|eńs|no |zne|a s|lwi|olw|ez |odn|rów|odz|o u|ne |i n|i k|czy| be|acj|wob|inn| ob|ówn|zie| ws|aln|orz|nik|o n|icz|zyn|łec|ołe|poł|aro|nar|a j|i z|tęp|stę|ien|cza|o z|ym |zec|ron|i l|ami| os|kra| kr|owe| od|ji |cji|mie|a z|bod|swo|dni|zes|ełn|peł|iu |edn|iko|a n|raj| st|odo|zna|wyc|em |lni|szy|wia|nym|ą p|ją |zeń|iec|pie|st |jes| to|sob|któ|ale|y w|ieg|och|du |ini|war|zaw|nny|roz|i o|wej|ię |się| si|nau| or|o r|kor|e s|pop|zas|niu|z p|owy|w k|ywa| ta|ymi|hro|chr| oc|jed|ki |o t|ogo|oby|ran|any|oso|a o|tór| kt|w z|dne|to |tan|h i|nan|ejs|ada|a k|iem|aw |h p|wni|ucz|ora|a d| wł|ian| dz| mo|e m|awi|ć s|gan|zez|mu |taw|dst|wią|w c|y p|kow|o j|i m|y s|bow|kog|by |j o|ier|mow|sza|b o|ju |yna",
    swh: "a k| ya|na |wa |ya | ku|a m| na| ha|i y| wa|a h|a n|ana|aki|ki |la |hak| ka|kwa|tu | kw| ma|li |a a|ila|i k| ki|ni |a w|ali|a u| an| mt|ke |mtu|a y|ake|ati|kil|ka |ika|kat|ili|te |ote|we |a s|e k|ia |zi |u a|za |azi|ifa|ma |yak|yo |i n|ama| yo|au | au|e a|kut|amb|o y|ha |asi|fa |u w|hal|ara|sha|ish|ata|ayo| as|tik|u k| za|i z|ina|u n|mba|uhu|hi |hur|cha|yot|ru |uru|wat| ch|eri|ngi|e y|u y|i a|aif|tai| sh|nay|chi|ra |ani| bi| uh|sa | hi|i h|awa|iwa|a j|ti |mu |o k|ja |kan|uli|iwe|any|i w| am|e n|end|atu|kaz|o h|ria|her|she|shi|nch| nc|uta|ye |wak|ii |ele|ami|adh|eza| wo|iki|oja|moj|jam| ja|aka|bu |kam|kul|mat|fan|a l|agu|ind|ne |iri|lim|wen|da |kup|uto|i m|a b|ini|wan|bil| ta|sta|dha| sa| ni|ao | hu|e w|wot| zi|rik|kuf|aji|ta |wez|nya|har| ye|e m|si |lin| ut|ine|gin|ing| la|a t|zim|imu|ima|tak|e b|uni|ibu|azo|kos|yan|nye|uba|ari|ahi|nde|asa|ri |ham|dhi|eli|hir|ush|pat| nd|kus|maa|di |nda|oa |bar|bo |mbo|oka|tok|ndw|ala|wal| si|uzi|hii|tah|i s|o n|liw| el|upa|zin|hag|a c|ndi|ais|mai|eny|mwe|aa |ewe| al|ndo|e h|lo |umi|kuh|jib|osa|mam|a z|ufu|dwa|u i| in|iyo|nyi| ny|u m|sil|ang|o w|guz|zwa|uwa|kuw|hil|saw|uch|ufa|laz|und|aha|ua | mw|bal| lo|o l|a i|del|nun|anu|nji| ba|lik|le |uku|i i",
    sun: "an |na |eun|ng | ka|ana| sa| di|ang|ung|un |nga|ak | ha|keu| ba|a b| an|nu |hak| bo|anu|ata|nan|a h|ina| je|aha|ga |ah |awa|jeu| na|ara|ing|oga|bog|gan| ng|asa|kan|a s|ha |ae |bae|n k|a k| pa|a p|sah|g s|sar| si|sin|a n|din|n s|ma | at|aga|a a|tan| ku| ma|n a|san|man|wa |lah|pan|taw|u d|ra |ari|eu | pi|gar| pe|kat| te|n p|sa |per|a d|a m|e b|aan|ban|ran|ala|ike|n n|kum| ti|ama|a j|pik|ima|n d|al |at | ja|ila|ta |nda|bas|rim|teu|n b|eba|beb|udu|aya|ika|ngg|nag|kab|rta|art| me|ola|k n|uma|atu|aba|g k|adi|aca| po|ngt|nar|una|ate|oh |boh|awe|di |tin|asi|uku|n h|dan|aka|iba|car|sac|gaw|are|ent|um |jen|abe|u s|dil|pol|ar |ku |kud|u m|upa|han| hu|ake|bar|ur |hna|aru|h s|a t|sak|wat|kaw| so|n t|pa |mpa|du |ngk|g d|ena|huk| mi|mas|ngs|ti |n j|ka |aku|ren|n m| ta|law|isa| tu|und|a u|h a|tay|ula|aja|ali|nte|gsa|en |gam| wa|ieu|ere|k h|jal|h b|il |dit|ngu|lan|asu|yun|ayu|gta|k d|a r|g n|mah|uda|dip|kas|rup|geu| be|ter|sej|min|ri |ern|u p|k k|amp|ura|kal|e a|k a|ut |g b|nak|bis| bi|k p|tes|end|we |h k|tun|uan| un| de|u n|h t|ksa|u k|ian|wil|u b|ona|nas|uka|rak|eje| se|ami| ke|war| ra| ie|k j|eh |ya |lma|alm|pen|tur|wan|lak|h j|g a|ean|up |rga|arg|r k|u t| ne|deu|gal|gke|e t|h p| ge|g t| da|i n",
    ron: " de|re | în|și |are|de | și|te |ul | sa|rep|e d|ea |ept|dre|tul|e a| dr|ie |în |ptu|le |ate|la |e p| la| pe|ori| pr|ce |e s| or|au |tat| ar|ice|ii |or |a s| fi| a |ric|ale|per| co|nă |ă a|rea|ers|i s| li|sau| ca|rso|ent|lor|ați|al |a d|e o|men|l l|ei |e c|pri|ană| ac| re|uri|ber|ibe|lib|a p|oan|soa| in|i l|ter| al| să|tea|lă |car|tăț|să |tur|i a|i d|nal| ni|ri |ita|e î|e ș|se |ilo|in |ia |ție|pre|fie|ții|ăți|con|ere|e f|a o|eni|nte| nu| se|ace|ire|ici| cu|i î|a c|i n|a l|pen|ui |nu |ări|ală|ona|l d|ră |ert|ril| su|ntr|n c|rin| as|ni |i o|eri|tă |că |ile|ă d|i c|e n|ele|sa | mo|i p|fi |sal|tor|va |oci|soc|nic|pro| un| tr|est|inț|a î|uni|n m|a a| di|ecu|lui|sta|lit| po|tre|gal|ega|oat|ra |act|ă î|leg|u d|e l|nde|int|a f|n a| so|naț|ara|i f|uie|iun| to|tar|ste|ces|rar|at | ce|eme|i ș|rec|dep| că| o | îm|bui|ebu|reb| eg| na|mân|ntu|ili|văț|ând|iei|r ș|bil|pli|od |mod|res|din|e e|cți| au|ali|ă p|ă f|împ|ial|cia|ion|ă c|dec|nta| om|ită| fa|ță |cu |tra|ăță|nvă|înv|ât |ite|i i|lic| pu| ex|riv|tri|rot|ța |ți |l c|rta|imi|ulu|țio|ică|lig|rel|ta |cla|t î|nt |nit|e m|ânt|ămâ|țăm|ger|nța|ru |tru|gur|u c|bli|abi|ată|art|par|ar |rim|iva|l ș| sc|ime|nim|era|sup|ind|u a|dic|ic | st| va|ini|igi|e r",
    hau: "da | da|in |a k|ya |a d| ya|an |a a| ko| wa|na | a |sa | ha|kin|wan|ta | ba|a s| ta|a y|a h|wa |ko | na|n d|a t|ba |ma |n a| ma|iya|hak|asa| sa|ar |ata|yan| za|akk|a w|ama| ka|i d|iki|a m|owa|a b| ci| mu| sh|anc|nci|kow|a z|ai |nsa|a c|shi| ƙa|cik|ne |ana|i k|ci |kki|e d|a ƙ| ku|su |n y|uma|ka |uwa|kum|hi |a n|utu| yi|ani| ga| ra|aka|ali|mut|‘ya|tar| do|ɗan|ars| ‘y|sam|ƙas|nda|ane|man|tum|i a|yi |ni | du|ada| su|and|a g|cin| ad|a i|ke | ɗa|n k|yin|um |e m| ab|ins|nan|ki |mi |ami|yar|min|oka|re |i b|kam|mas|i y|mat|za |ann|en |aɗa| ja|m n|li |duk|dai|e s|n s|ra |n w|n h|aik| ai|ida|ga |san|rsa|aba|sar|ce |nin| la|o n|ban|nna|kan|abi|una|dam|me |ara|i m|hal|a r|add|are|n j|abu| ne|zai|a ɗ|wat|ari| ƙu|on |ans|waɗ|ame|ake|kar|din|zam| fa|a l|ƙun|buw|r d| hu|oki|kok|a ‘|u d|n t|abb|aur| id|rin|yak|dok|kiy|ray|jam|n b|ubu|bub|n m|i s| an|am |ili|bba|omi|dan|gam|ayu|ash|nce|tsa|ayi|har|yya|ika|bin|han|kko|rsu|aif|imi|fa | am|i i|dom| ki|yuw|dun|o a|fan|n ƙ|aya|fi |n r|she|uni|bay|riy|n ‘|sab| iy|bat|tab|aga| ir|mar|o w|i w|sha|awa| ak|uns|unc|tun|u k| il|ɗin|mfa|amf|aci|ewa|kas|lin|n n|don|n i|ure|ifi|lai|dda| ts|iri|aye|un |tan|wad|gwa|afi| ay|ace|mba|amb|aid|nta|ant|war|lim|kya| al|aɗi",
    fuv: "de | e |e n| ha|nde|la | wa|ina| ka|akk| nd|ɗo |na | in|e e|hak|al |di |i h|kke|ii |um |ko |ala|ndi| mu| ne|lla| jo|wal|eɗɗ|neɗ|all|mum| fo|kal|jog|ke |aaw|taa| ko|eed|ɗɗo|aa | le|ji |ade|aad|laa|o k| ng|e h| ta|re |ogi|a j|e w|e m|nnd|gii|e l|ley|awa|aag|ede|waa|e k|gu |e d| go|gal|ɓe |ti |fot|aan|eyd|ydi|ɗe |ee | re|ol |oto|i e|oti|m e|taw|nga|a i|kee|to |ann|eji|am |ni | wo|een|goo|eej|e f| he|enn|gol|agu|pot| po|dee|ay | fa|ka |a k|ond|oot| de|a f|o f|a n|wa |maa|ota|le |hay|i k|o n|ngo|e j|o t| ja|ñaa|hee|nka|i w|awi|a w|ngu|der| to|e t|dim|i n|fof|i f|e g|tee|naa|aak| do|too|a e|ndo|ren|dii|oor|er |o e|i m|of | sa| so|gaa|ani|kam| ma| ña|o w|i l|u m|kaa|ima|dir| ba|igg|lig| li|aar| ɓe|o i|e s| o |e r|so |ooj| nj| la|won|awo|dow|woo|faw|and|e i|ore|nge|nan|are|a t|tin|aam| mo|ɗee|ita|ira|aaɗ|e p|nng|ma |ank|yan|nda|oo |e ɓ|njo|ude|nee|e y|e a|je | ya|en |ine|iin| di|ral| na|ɗi |und| hu|inn|ŋde|aŋd|jaŋ|a d|den| fe| te|go | su|a h|haa|tal|eɗe|e b|y g|baa|tde| yi|ɗɗa|o h|iiɗ|ow | da|do |l n|alt| ho|l e|aga|mii| aa|a a|ama|nna|m t| ke|edd|oga|m w|l m|o j|aɗe|ree|oje|yee| no|ele|ne |ago| pa| al|guu|wi |ge |aaɓ|daa|ind|dew|i j|jey| je|ent|tan|o ɗ|geɗ| ge|ñee|a l| ɗu|kko|mak|a s| ga",
    bos: " pr| i |je |rav|na |ma |pra| na|ima| sv|a s|da |a p|vo |nje|ko |ako|anj|o i| po|avo|ja |e s|a i|ti | im| da| u |sva|no |ju | za|o n|va |i p|ili|vak|li | ko|ne | il|koj| ne|nja| dr|ost| sl|van|im |i s|u s|i i|a n|ava|ije|a u| bi|stv|se |a d|om |jed|bod|obo|lob|slo| se| ra|ih |sti| ob| je|pri|enj|dru|u i|o d|iti|voj|raz|ova|dje| os|e i|lo |e p| nj|uje|i d|bra|tre| tr| su|jeg|i n|u z|a k|og |u p|oje|cij|reb|a o|a b|lju|i u|ran|mij|ni |nos|jen|ba |edn|svo| iz|jel|pro|e d|žav|bit| ni|i o|sta|a z|avn|vje| ka|bil|ovo|a j|aju|ist|nih|tu |red|gov| od|e o|oji| sm|lje|o k|ilo|ji |aci|e u|e n|pre|o p|eba|u o|su |vim|ičn| sa|u n| dj|a t|ija|čno|jem|rža|drž|elj|stu|dna|odn|eni|za |iva|olj|šti|nom|em |du |vno|smi|jer|e b|de |pos|m i| do|u d|nak|a r|obr| mo|lja|nim|ego| kr|tit|kri|ve |nju|an |iko|nik|nu |i m|nog|eno|sno| st|e k|tup|rug|ka |oda|riv|vol|aln|m s|itu|ašt|zaš|ani|sam|akv|ovi|osn|rod|aro| mi|tva|dno|nst|jan|ak |ite|vič|rad|u m| ta|dst|tiv|nac|rim|kon|ku |odu|živ|amo|tvo|tel|pod|g p|nov|ina|nar| vj|o s|i b|oj | ov|ave|vu |ans|oja|zov|azo|ude|bud| bu|e t|i v|din|edi|nic|tan|nap|mje| is|jal|slu|pun|eds|o o|zak|jav|i k|m p|tno|ivo|ere|nič|m n|jim|kak|ada|vni|ugi| ro|mov|ven|pol|to |te | vr",
    hrv: " pr| i |ma |rav|ima|pra|je |na | sv|ti | na|a p|vo |vat|ko |a s|nje| po|anj|avo|o i|tko| im|a i|sva|no |i p|e s|ja |o n| za|ju |ili| u |va |li | bi|ne |i s|atk| il|iti|da | ne| ko| dr| sl|van|nja|koj|ije| ra|ova| os|u s|i i|ost|bod|obo|lob|slo|pri|a n|om |jed|ati|ih |im |voj|ava| ob|stv|se | mo|i u|bit|dru| je| se|dje|i o|enj| ka|i n|sti|lo |u i|svo|mij|ni |e i|raz|a o|e n|bra|o p| su|a b|u p|ran|a k|og |i d|bil|ako|e p|a d|edn|aju|mor|eni| nj|iva|jel|žav| ni|a z|avn|ovi|eno|ra |oje|a j| da|a u|ora|jeg| iz|nih|rža|drž|oji|sno|nit|jen|vje|ilo|cij|oda|nim| dj|pro|tit|u z|e d|red|nom|jem| od|nos|sta|nov|osn| sm|lje|o s|ji |ovo|stu|pos|vim| do|odn|rad|ist| sa|e o|tu |nju|em |gov|o d|rod|i m|jer|aci|oj |pre|m i|nak|dna|a r|lju|uje|e m|obr|za |olj|ve |o o|m s|an |nu |du |aro|vno|smi|aln|e k|o k|i b|e u|tva|u u|tup|rug|dno|u o|su |u d|ka |vol| ta|ija|itu|šti|ašt|zaš|itk|živ|ani|sam|elj| st|sob|oso|nar|akv|ada| mi|te |ona|nst|jan|lja|i v|ite|ego|elo|rim|ku |odu|amo|tvo|tel|jim|pod|nog|vi |ina| vj|to |e b|ans|zov|azo|ak | sk|edi|tan|oju|pun|pot|oti|kon|zak|i k|m p|tno|ivo|ere|nič|kak|vni|ugi| ro|mov|ven|štv| be|ara|kla|ave|u b|avi|oja|jal|u m|dni|mje|rak|din|ći |juč|klj|nic|u k|nap|obi|atn",
    nld: "en |an |de | de| he|ing|cht| en|der|van| va|ng |een|et |ech| ge| ee|n e|rec| re|n v|n d|nde|ver| be|er |ede|den| op|het|n i| te|lij|gen|zij| zi|ht |ijk|eli| in|t o| ve|op |and|ten|ke |ijn|e v|jn |ied| on|eft| ie|sch|n z|n o|aan|ft |eid|te |oor| we|ond|eef|ere|hee|id |in |rde|n w|t r|aar|rij|ord|wor|ens|of | of|hei|n g| vr| vo| aa|r h|hte| wo|n h|al |nd |vri|e o|ren|le |or |n a|jke|lle|eni|n b|ij |e e|g v| st|ige|die|e g|men|nge|t h|e b| za|e s|om |t e|ati|wel|erk|sta|ers| al| om|n t|zal|dig| me|ste|voo|ter|gin|re |ege|ge |g e|bes|nat| na|eke|che|ig |gel|nie|nst|e a|nig|est|e w|erw|r d|end|ona|d v|jhe|ijh|d e|ele| di|ie | do|del|n n|at |it | da|tie|e r|elk|ich|jk |vol|ijd|tel|min|len|str|lin|n s|per|t d|han| zo|hap|cha|wet| to|ven| ni|aat|ion|tio|taa|lke|eze|met|ard|waa|uit|sti|e n|doo|pen|eve|el |toe|ale|ien|ach|st |ns | wa|eme|nin|e d|bij| gr|n m|p v|esc|t w|ont|ite|man|ema| ma|nal|g o|rin|hed|t a|t v|beg|all|ijs|wij|rwi|e h| bi|gro|p d|rmi|erm|her|oon| pe|eit|kin|t z|iet|iem|e i|gem|igi| an|d o|r e|ete|e m|js | hu|oep|g z|edi|arb|zen|tin|ron|daa|teg|g t|raf|tra|eri|soo|nsc|t b| er|lan| la|ern|ar |lit|zon|d z|ze |dez|eho|d m|tig|loo|mee|ger|ali|gev|ije|ezi|gez|nli|l v|tij|eer| ar",
    srp: " pr| i |rav|na |pra| na|ma | sv|ima|da |ja |a p|vo |je |ko |ti |avo| po|a i|ako|a s| za| u |ju |o i| im|nje|i p|va |sva|anj|vak| da|o n|nja|e s|ost| ko|a n|li |ili|ne |om | ne|i s| sl| il| dr|no |koj|u s|ava| ra|og |slo|im |enj|sti|bod|obo|lob|iti|a o|stv|i u|a d|ni |jed|u p|pri|edn| bi|i i|a k|o d|sta|ih |dru|a u| je| os| ni|nos|pro|aju|i o|ran| de| su|u i|se |van|ova|i d|cij| ob|uje|red|žav|e i|i n|voj|e p|a j|dna| se| od|ve | ka|eni|rža|drž|a z|avn|aci|ovo|u u|m i|oja| iz|lja| nj|ija|u z|e o|rod|jen|lje|e b|raz|jan|lju|svo|za |gov|ičn| st|nov|sno|osn|du |ji |pre| tr|su |vu |odn|a b|jeg|nim|nih|tu |tit|šti|ku |nom|bit|e d|me |iko|čno|oji|lo |vno|nik|e n|đen|ika|bez|ara|de |u o|vim|nak| sa|u n|riv|ave|an |olj|vol| kr|o p|sme|e k|nog| ov|e u|tva|bra|rug|reb|tre|u d|oda| mo| vr|vlj|avl|ego|jav|del|m s|kri|o k|ašt|zaš|nju| sm|ani| li|dno|eđu|aln|la |akv|oj |šen|kom|stu|ugi|avi|a r|ka |rad|oju|tan|odi|vič|tav|itu|ude|bud| bu|pot|odu|živ|ere|m n|tvo|ilo|bil|aro|ovi|por|eno|štv|nac|ove|m p|tup|pos|rem|dni|ba |nst|a t|ast|iva|e m|vre|nu |beđ|ist|pun|en |te |dst|rot|zak|ao |kao|i k|juć|o s|st |sam|ter|nar| me|i m|kol|e r|ušt|ruš|ver|kak| be|i b|kla|ada|eba|ena|ona| on|tvu|ans| do|rak|slu",
    ckb: " he| û |ên | bi| ma|na |in |maf| di|an |xwe| xw|ku | ku|kes| de| ji|her|kir|iya|ya |rin|iri|ji |bi |es | ne|ye |yên|e b|er |afê|tin|ke | an|iyê|eye|rke|erk|we | be|e h|de | we|hey|fê |i b|yê |ina| bê| li|diy|ber|li |re |î û|nê |ê d| se| ci|eke|di |wî | na|î y|af |ete|hem| wî|sti| ki|rî |kî |î a|yek|n d|kar| te|ne |yî |i h|e k|tî |tê |a w|e d|î b|s m|ast|n b|be |yan|ser|tew|net| tu| ew|hev|aza|ara|û b|n k|adi|ev |zad| az|ras|est|anê| ya|n h|n û|wed| tê|wek|bat|bo | bo| yê|st |n n|ê k|dan|ê h|ema|ê b|iye|î h|din|bûn|r k|ekî| me|par|ûna|ta |wle|ewl|î m| ke|nav|ewe|man|ê t|dî |û m|mû |emû|a m|ika|e û|n w|a x|ê m|e n| ta|ela|n j|eyê|n x|civ|wey|ana| re|khe|ekh|bik|kê |jî |f h|erî| pa|îna|bin|erb|vak|iva|a s| ni|cih|vê |e j|ari| pê|î d|nên|ike|e t|a k|ê x| ye|n a|eyî|n e|ama|bê |ar |ewa|atê|bes|rbe|av |ibe|ist|mî |tem|awa|are|hî |geh|nge|ing|nek|nûn|anû|qan| qa|vî |rti|uke|tuk| şe|eza| da|u d|û a|f û|edi| ra|tu |tiy|tên| mi|xeb| ge|hîn| hî|etê|î j|stî|mal|bib|ra |i d|e m|mam|i a|nik|i m|î k| wi|ûn | ko|a ş|ê j|riy|lat|wel|e e|ine|ane|û h|în |a d|siy|end|aye| za|ija|a n|î n|ek |tek|yet|mbe|emb|û d|rov|iro|mir|eba| xe|mên| ên| hu|nîn|anî|t û|ten|n m|dem|ê û|enê|te |art|i r| jî|u j|ekê|dew",
    yor: " ní|ti |ọ́ |ní | lá| ẹ̀|àn |ẹ́ |kan|tí | tí|an |ẹ̀ |tọ́|ọ̀ | ẹn|ọn |wọn|í ẹ|bí |áti|lát|̀tọ|ẹ̀t| gb| àt| àw|n l|àti| a |lẹ̀|ẹnì| ó |kọ̀| ló|ì k|sí |ọ̀k| kọ|ra |ni |àbí|tàb| tà|nì | sí|̀ka|ọ̀ọ|n ẹ|àwọ|n t|ó n|̀ọ̀|ílẹ|orí|ló | wọ|tó |dè |ìyà|ún | tó| or|í ì|èdè|kò |‐èd|̀‐è|ẹ̀‐|ríl|í ó|rẹ̀|í à| sì|yàn|gbo|ṣe | kò|í a| rẹ| jẹ|sì | bá|ràn| ṣe|wọ́|nìy|fún| fú|n à|ba |n n|gbà|gbọ|jẹ́|un |ìí | kí|gba|ènì| èn|bá |́ l|a k| ka|dọ̀|kí | òm|in | fi|bò |fi |bẹ́|ọdọ|bọd|́ s|hun|nú |nín|wà |ira|nir|òmì|ìgb| ìg|́ t|ẹni|ínú|i l|ìni|mìn|bà |áà |i ì|ohu| oh|í i|ara| ti|bo |ò l| pé|rú |írà| ọ̀|í ò|ogb|kọ́|pọ̀|ó b|à t|i n|lọ́|ẹ́n| ìb|yìí|gbé|gẹ́|bog|óò |yóò| yó|n k|pé |dá |́wọ|ọ́w|à l|í k| wà|n o|jọ | ir|ọ̀r|ú ì|́ à|ó s|i t|ṣẹ́|̀kọ|í t|yé |lè | lè|fin|àbò| lọ|à n|ùjọ|wùj|irú|ó j| ar|í w|a w| ìm|ú à|̀ t|òfi| òf| àà|fẹ́|àwù|́ni|wù |ìír|mìí| mì|láì| yì|í g|ọ́n|n s|i ẹ|ẹ̀k|àgb|ígb|níg|a n| kú|láà|í o|náà| ná|kẹ́|ípa|níp|ìn | ìk|bé |i g|ọmọ| ọm|i à|iṣẹ|̀ à|ìmọ|n a|n f|jẹ |yí |́ ọ|ó d|́ ò| dá| mú|ààb|ábẹ|láb|ìbá|ò g|jú |i o|lú | èt|̀ ẹ|tọ̀|de |̀ n|i ò| ìy|kàn|́n | bí| iṣ|mọ̀|e ẹ|̀ l| fà|èyí| èy| ìd|mọ́|dé |̀ k|́ p|ò t|mú | fẹ| ìj|rí |ìkẹ|nìk|ìní|n ì|n è|sìn|è ẹ| i |rọ̀| àn|́ b|ùn |́gb|ọ́g|dọ́| dọ|í n|rin|̀ j",
    uzn: "ish|an |lar|ga |ir | bi|ar | va|da |iga| hu|va |bir|sh |uqu|quq|huq| ha|shi| bo|r b|gan|a e|ida| ta|ini|lis|adi|ng |dir|lik|iy |ili|oʻl|har|ari| oʻ|uqi|ins|lan|hi |ing|dan|nin|kin| yo|son|nso| in| mu|on |qig| ma|ega|r i|boʻ| eg|oʻz|ni |gad|ash|i b|ki |oki|ila|yok|a b|n b|osh|ala|at |in |r h|erk| er|lga| qa|rki|h h| sh|i h|ara|n m| ba|nis|ik |igi|lig|bos|ri |qil|a t|bil|las|eti| et|n o|ani|nli|kla|i v|a q|a h|a o|yat| qo|im |a s|i m|iya|atl|oli|osi|siy|qla|cha|til| ol|ati|a y|mas|qar|inl|lat| qi|taʼ|ham|gi |ib |ʻli|mla|h v|ʻz |hun|n e|mum| da| bu| to|un |mki|umk|sha|tla|ris|iro|ha |rch|bar|iri|oya|ali| be|i o|asi|aro| ke|i t|rla| te|arc|hda|shu|tis|n h|tga| sa| xa|rak|lin|ada|ola|imo|hqa|shq|li | tu|aml|lla|sid| as|nid|a i| ki|ch |n t|nda|k b|era|siz|or |hla|a m|r v|eng|ten|mat|mda|amd|lim|miy|y t|ayo|i a|ino|ilg|tni| is|ana|as |ema| em|ech|a a|tar|kat|aka|ak |rat| de|aza|ill| si| so|gʻi|uql|n q|oda|ʼli|aʼl|nik| ni|tda|uch|gin|a u|him|uni|sit|ay |qon| ja|atn|kim|h k|hec| he|ʻzi|lak|ker|ikl| ch|liy|lli|chi|ur |zar|shl|rig|irl|dam|koh|iko|a d|am |n v|rti|tib|yot|tal|chu| uc|sla|rin|sos|aso| un|na | ka|muh|dig|asl|lma|ra |bu |ush|xal|ʻlg|i k|ekl|r d|qat|aga|i q|oiy|mil| mi|qa |i s|jin",
    zlm: "an |ang| ke|ng | se| da|ada|ara|dan| pe|ran| be|ak |ber|hak|ata|ala|a s|ah |nya| me|da |per|n s|ya | di|kan|lah|n k|aan|gan|dal|pad|kep|a p|n d|erh|eba|nga|yan|rha| ya|nda|ora|tia|asa| ha|ama|epa| or|iap|ap |a b| at| ma|eti|ra |tau|n a|set|au | ba|pa | ad|n p|tan|p o|eng|a d|men|apa|h b|h d|dak|man|a a|ter| te|k k| sa|n b|ana|g a|end|leh|ole|a k|am |n y|aka|eh |lam|bas|beb|n m| un|pen|sa |keb|sam|n t| ti|ela|san|car|uan|ma |di |han|ega|ban|eri|at |sia|a m|ika|kes|ian|gar|seb|ta |mas|und|neg|nan|ngs|i d|erl|na |epe|emb|bar| la|atu|kla|pem|mem|emu|eca|sec|ngg|nny|any|bol|al |aha|gsa|ebe|ind|akl|n h|erk|ung|ena| bo|a t| ap|ers| de|in |tu |pun|as |agi|ann|g b|bag| ne|ain|hen| he|era|rat|sem| su|adi|lan|g s|dia|mat|ses|iad| ta|iha|g t|tin|k m|k h|i k|gi |i s|ing|uka|enu|den|lai|k d|ert|ti |rka|aja|rga|lua|ker|mel|dun|ndu|lin|rli|nak|ntu|esi|aya|un |uat|jua| in|rma|erm|ai |emp|kem|ri |dil|ua |uk |h m|l d|g m|mba|kat|ese|tik|ni |ini| an|mpu|ka |dar|mar|rja|erj|arg|u k|sua| ol|esa|dap|ar |g u|si |ent|g d| pu|awa|iri|dir|sal|gam|mbe|n i|har|a h|raa|ema|tar|i a|saa|ira|ari|pel|jar|laj|uju|tuj|rak|ura|uar|elu|t d|unt|il |wen|asi|gga|ipa|ksa|tuk|ula|sek|sas|ibu|rta|sep|rsa|nta|ati|ila|mua|yar",
    ibo: "a n|e n|ke | na| ọ |na | bụ|ọ b|nwe|nye|ere|re | n |ya |la | nk|ye | nw| ma|e ọ| ya| ik|a o|a ọ|ma |ụla|bụl|ike| on|nke|e i|a m|ony|ụ n|kik|iki|bụ | a |ka |wer|ta |i n|do |di | nd| ga|a a|e a|a i|he |kwa| ok| ob|e o|hi |any|ga‐|ha |dụ | mm|ndi|ọ n|wa |rụ |e m|che|a e|oke|wu |aka|ite|o n|a g|odo|bod|obo| dị| ez|ara|we | ih|a‐e|hị |ri |n o|zi |mma|chi|dị |ghi|ụta|iri|ihe| an| oh|a y|gba|ụ ọ| ọz| ak| iw|nya|te |iwu| nt|ro |oro|e ị|zọ |ezi|me |e e|u n|her|ohe| si|a‐a|i m|ala|ụ i| ka|akw| in|ghị|kpe|n e|pụt| e |i i|i o|ide|inw|ụ o|hụ |ahụ|weg|ra |o i|kpa|adụ|mad|si |sit|a s| me|sor|i ọ|gid|edo|u o|e y|n a| en|tar|ozu|toz|bi |be |ụ m|ụrụ|ọrụ| ọr|mak|uso|ama|de |ị o| ọn|ọzọ|chị|egh|enw|apụ|ru | to|i a|a ụ|osi|rị |wet|hed|nch| nc| eb| al|nọd|ọnọ|uru|sir| kw|yer|ji |eny| mk|ịrị|eta| us|tu |ọ d|u ọ| o |ba | mb|ọdụ|ịch| ch|a d|pa | ag|kwe| ha|a u|e s|mkp|n u|nta|ebe|n ọ|o m|kwu|nkw|nwa|obi| ịk|esi|i e|nha| nh|le |ile|nil| ni|eme| og|e k|n i|chọ|o y|asị|otu| ot|ram|u m|ịgh|dịg|zu |nọ |mba| gb|e g|ị m|ọch|ich|pe |agb|i ị|uch|zụz|uny|wun|ọrọ| nn|na‐| di|ge |oge|iji| ij|ọha| ọh|ikp|egi|meg|o o|ụhụ|hụh|mah|n ụ|ọ g|ọta|ekọ|ị n|kwụ|agh|ụmụ|ban|kpu|okp| ah|ịkp|a k|ime| im|zụ |ụzụ|ọzụ| ụz|lit|ali|nat",
    ceb: "sa | sa|ng |ang| ka| pa|an |ga |nga| ma|pag| ng|on |a p|od |kat|ay | an|g m|a k|ug |ana| ug|ung|ata|ngo|atu|n s|ala|san|d s|tun|ag |a m|god|g s|a a|a s|g k|g p|yon|n u|ong|tag|usa|pan|ing|una|mat|g u|mga| mg|y k| us|ali|syo| o |aga|tan|iya|kin|dun|nay|man|nan|a i| na|ina|nsa|isa|bis|a b|adu| ad|n n| bi|asy|asa|lay|awa|lan|non|a n|nas|o s|al |agp|lin|nal|wal| wa|ili|was|gaw|han| iy| ki|nah|ban|nag|yan|ahi|n k|gan| gi|him| di|a u| ba| un|ini|ama|ya |kas|asu|n a|g a|gka|agk|kan|ags|agt|l n|a g|kag| ta|imo|uns|sam| su|g n|n o|gal|kal|og |taw|aho|uka|gpa|ipo|ika|o p|a t| og| si|gsa|g t|aba|ano|gla|y s|o a|aki|hat|kau|sud|gpi|a w|g i|aha|ot |ran|i s|n m|bal|lip|gon|ud | ga|li |uba|ig |ara|g d|na |kab|aka|gba|ngl|ayo| la| hu|a h|ati|d a|d n| pu| in|uga|ok |ihi|d u|ma |may|awo|agb|ami|say|apa|pod|uha|t n|agh|buh|ins|ad | ub| bu|at |iin|a d|ip |uta|sal|hon|wo |ho |tra|lak|iko|as |aod|bah|mo |aug|ona|dil|gik|sos|lih|pin| pi|k s|nin|oon|abu|la |rab|hun| ti|mah|tar|t s|ngb|uma|hin|bat|lao|mak|it | at|s s|sno|asn|ni |aan|ahu| hi|agi|n p|inu|ulo|y p| ni|iha|mag|o n|duk|edu| ed|a e|til|ura|tin|kip|agl|gay|g h|g b|ato|ghi|nab|kon|in |ter|o u|o o|yal|sya|osy| so|tik| re| tr|hig|a o|ha |but|pak|aya",
    tgl: "ng |ang| pa|an |sa | ka| sa|at | ma| ng|apa|ala|ata|g p|pan|pag|ay | an| na|ara| at|tan|a p|pat|n a| ba|ga |awa|rap|kar|g k|aya|lan|g m|n n|g b|nga|mga| mg|a k|na |ama|n s|a a|gan|yan|gka| ta|may|tao|agk|asa|man|aka|ao |y m|ana|g a|nan|aha|kan|y k|baw|kal|a m|g n|ing|wat| y |t t|pam|a n|o y|ban| la|ali|san|wal|mag| o |g i|aga|lay|any|g s|in |nya|yon|kas|a s|isa|una|ong|aan|kat|t p| wa|ina|tay|ya |on |o m|ila|ag |nta|t n|aba|ili| ay|o a| ga|no |a i|gal|ant|han|t s|kap|kak|lah|ari|agt|agp|ran|g l|lin|as |lal|gaw|ans|to |ito| it|hay|wa |t m| is|pap|mam|nsa|ahi|nag|bat|lip|gta| di|gay|gpa|pin| si|ngk|ung|aki|y n|iti|tat|ano|yaa|y s|mal|hat|kai|sal|hin|uma|mak|di |agi|pun|ihi|a l|i a|ira|gga|nah|s n|ap | ha|usa|nin|o p|gin|ipu|ika|ngi|i n|lag|la |y p|ini|g t|uka|nap| tu|a g|tas|aru|ipa| ip|li |al |n o|a o|t k|alo| pi|sin|syo|asy|ita|aho|nar|par|o s|pak|t a|uha|sas|gsa|ags|kin|a h|iba|lit|ula|o n|nak|a t| bu|duk|kab|sam|g e|ain|ami|mas|lab|ani|kil|it | al|agb|buh|a b|g g|ba | ib|iyo|ri |yag|ad | da|edu| ed|anl|ma |ais|iga|mba|tun|ipi| ki|od |ayu| li|lih|sar|gi |g w|pah|wir|oob|loo|agg|nli|bay|map|git|mil|ok |hon|ngg|sah|iya|pas|g h|agl|tar|ngu|amb|uku|ayo|s a|p n|n m|rus|i m|l a|abu| aa",
    hun: "en | sz| va| a |és |min|ek | és| mi|jog| jo|an |ind|nek|sze|ság|nde|a v|den|oga|sza|val|ga |mél|ala|emé|gy |n a|van|zem|ele| me|egy|ély| eg|zab|tás| az|n s|bad|aba|ni |az |gye| el|ak | se|meg|sen|ény|ség|k j|yne|lyn| ne|ben|lam|tt |t a|et |agy|oz |hoz|vag|zet| te|n m|ez |nak|int|re |eté|tet|mel|tel|s a|em |ely|let|hez| al|s s| ki|ete|atá|z a| le|yen|es |ra |tés|ell|nt |sem|t s|len|nem|a s|ese|nki|enk|a m|ásá|i m|ban|kin|k m|szt| ál|ame|köz|k a|dsá|ads|ló | kö|ás |ly |on |ébe|tat|a t|n v|áll|mén| vé|nye|kül|lő |a n| cs|i é|ok |ész|ért|lla|lap|ágo|gok|nyi|tek| ke|nd |éte|ami|zés|yes|szo|t m|a a|het|fel|lat|lem|lle|el |z e|s e|k é|mbe|emb|elé|ot |lis|vet|kor|ág |olg| am|szá|ehe|leh|ogo|ott|ül |nte|éle|i v|ogy|hog| ho|kel|n k|tes|nlő|enl|ssá|áza|ház|ég |vel|ába|lek|ége| ha|a h|rés| fe|ány|del|elő|át |alá|art|tar|zto|zás|tő |yil|koz|tko|aló|s k|i e|árs|tár|mze|emz| ny|más|ett|ny |fej|ass|zas| há|d a|t é|is |ésé|ezé|téb| mu|áso|sít|lye|elm|éde|véd|ine|t k|os |it |izt|biz| bi|y a|m l|tot|a j|atk|nél|t n|ti | má|ai |lás|eve|nev|zte| bá|sel|ll |al |ere|n e|unk|mun|t e| ak|ife|kif|ako|s é| ér|ána| es|s t|got|sül| be|vál|csa|se |ése|ad |ges|tos|ja | gy|asz|ten|lmé| tá|eze|árm|bár|ess|l s|üle",
    azj: " və|və |ər |ir | hə| bi| hü| ol|üqu|hüq|quq|na |in |lar|hər|də | şə|bir|lər|lik|mal|r b|lma|r h| tə|əxs|şəx|ən |dir|uqu|una|an |ali|a m| ma|ikd|ini|r ş|dən|ar |ilə|qun|aq |ası| ya|mək|yət| mə| mü|kdi|əsi|ək |ilm|nin|ndə|olm|əti|ə y|sin|xs |nda|lmə|yyə|i v| qa| az|olu|iyy|ya |ind|zad|qla|ün |ni |lə |tin|n m|aza|arı|ət |n t|maq|lun|lıq|ə b|un |nun|q v|n h|dan|ın | et|tmə|ərə| öz|da |ə v| on|ə a|ına|ını|bil|a b|sı |il |əmi|ara|si | di|ə m|əri|rlə| va|ə h|etm|ığı|ama|dlı|adl|rin|bər|rın|n i|müd|nın| he|mas|ik |n a|dil|alı|irl|ələ|üda|sın|ınd|xsi|li |ə d|nə | bə|əya| in|ə i|lət| sə|nı | iş|anı|eç |heç|q h|eyn|ə e|dır| da|asi|rı |iş |ifa|lığ|i s|fiə|afi|daf| ed|məz|u v|kil| ha|ola|n v|əni|ır |uq |unm| bu| as|sia|osi|sos|ili|ıdı|lıd|nma|ıq |inə|əra|sil|xil|axi|dax|adə|man|a h|ə o|onu|a q|əz | ki|seç| se|ı h|min|lan|ədə|bu |raq|lı |ılı|al |ə q|r v|nla|hsi|əhs|təh|öz |ist| is|məs| əs|ina|ə t|ətl|a v|iə |n b|tər| ta| cə|edi|ala|kim|qu |i t|ulm|məh|n o|aya|ı o|ial| so|ill|siy| də|var|ins|mi |ğı |nik|r i|aql|k h|təm|tam|çün|üçü| üç|ğın|sas|əsa|z h|əmə|zam| za|sti|rəf|n e|r a|ild|həm|ıql|yan|may|n ə|mən|mil| mi|əqi|din|n d|tün| dö|miy|kah|ika| ni|fad|tif|l o|sər|yni| ey|ana|lən|am |ril|ayə|aşı",
    ces: " pr|ní | a | ne|prá|ráv|na |ost| po|ho | sv|o n| na|vo |neb|ávo|bo |ebo|nos|má | má|ažd|kaž| ka| ro|ch |dý |ždý|ti |ou |a s| př| za|ání|á p| je| v |svo|ého| st|ý m|sti|ně | by|obo|vob|ter|pro|ení|bod| zá| sp|í a|rod|kte|by |mu |u p|o p| ná|ván|jak| ja|a p|o v|í n|ová|oli|ví |spo|roz| kt|mi |í p|ny | ma|ím |i a|do | so|odn|áro|nár|li |né |tví|at |ých|a z| vy|byl|vol|en |ýt |být| bý|t s|tní|stn|o s|í b|to | do|své|vé |ran|ejn|zák|eho|jeh|nes|pří|mí |čin|kol|ají|sou| vš|ích|it |ným|ým |nu |hra|nou|u s|ému| k |du |žen|pod| ze|kla|a v|stv|pol|dní|eré|m p|stá|je |ci |ečn| ni|néh|a n|aké|áva|maj|em |rov|í m|ké |ole|nýc|ova| ve|ako| ta|i k|chr|och| oc|kon|i p|í v|smí|esm|kdo|st |i n|o z|ave|odu|bez| to|sta|ech|jí |o d|sob|se | se|í s|ými|i s| i |i v| vz|ním|pra|lně|při|tát|ste|a j|aby| ab| s |oln|a o|m n|čen|slu|řís| os|zem|mez| či|lní|áln|oci|jin| ji|y b|í z|y s|va |vše|t v|ovn|chn|děl|níc|leč| pl|vat| vo|vin|rav|vou|lad|inn|é v|anu|tej|u k|stu|est| tr|ky |ikd|nik|ivo|nit|zen|u o|ném|nez|iál|ího|len|ens|ože|oko|kéh|rac|ven|í k|e s|lán|ělá|zdě|vzd|t k|din|odi|tí | od|ré |tup|pov|pln|ště|ákl|nno|tak|erá|řed|o a|a t|res|jíc| mu|u z|rok| ob|čno|u a|y k|i j|é n|luš|ísl|oso|ciá|soc|níh|o j|cké",
    run: "ra |we |wa |e a| mu|a k|se | n | um| ku|ira|ash|tu |ntu|a i|mu |umu|mun|unt|ere|zwa|ege|ye |ora|teg|a n|a a|ing|ko | bi|sho|iri| ar| we|shi|aba|e n|ese|go |a m|o a|gu |uba|ngo|nga|hir| ca|ugu|obo|hob|za |ndi|ish|gih| at|ara|wes| kw|ger|ate|a b| ba| gu|e k|can|ama|ung|bor|u w|mwe|di | ab|nke|ke |kwi|ka |ank|yo |ezw|n u|na |iwe|e m|rez|ri |a g|gir| am|igi|e i|ro |a u|ngi|e b|ban| ak| in|ari|n i|hug|ihu|e u|riz|ang|nta| vy|ata| ub|and|aka|rwa| nt|kur|ta |iki|kan|iza|u b|ran|sha|o n|i n| ig|ivy| iv|ahi|bah|u n|ana| bu| as|aku|ga |uko|o u|ho | ka|ose|ubu|ako|guk|ite|o y|ba |i b|any|kir|o k|aho|iye|kub|amw|nye|aha| ng|o m|nya| it|re | im|o b|izw|kun|hin|e c|vyo|o i|vyi|ngu|uri|imi|imw|gin|ene|u m|zi |ha |kug|bur|uru|jwe| zi|u g|era|aga|ron|abi| y |e y| uk|gek|ani| gi|eye|ind|wo |u a|i a| ib|i i|ras|bat|gan|amb|n a|onk|rik|ne |ihe|agi|kor| ic|ze |tun|ibi|wub|nge|o z|tse|nka|he |rek|twa|gen|eko|mat|ber| ah|ni |ush|umw| bw|mak|bik|ury|yiw|bwo| nk|ma |no |kiz|uro|gis|aro|ika| ya|gus|y i|wir|ugi|uki| ki|a c|ryo|bir| ma| yi|iro|bwa|mur|eng|ukw|hat|tan|utu|wit|w i| mw|y a|mbe| ha|uza|ham|rah| is|irw|o v|umv|ura|eny|him|eka|bak|bun| ny|bo |yig|kuv|wab|key|eke|yer|vye|i y|ita|ya |a r| ko|kwa|o c",
    plt: "ny |na |ana| ny|a n|sy |y f|a a|aha|ra | ma|nan|n n|any|y n|a m|y m|y a| fi|an |tra|han|ara| fa| am|ka | ts| na|in |ami| mi|a t|olo|min|man|iza|lon| iz|fan| ol| ha| sy|aka|a i|reh|ay |ian|tsy|ina| ar|on |o a|etr|het|ona|y o|o h|zan|y t|a h|ala| hi|a f|y h|ehe|ira|a s|zo |y i|ndr|jo | jo|n j| an| az|ran|dia| dr|y s|fah|ena|ire|tan|dre| zo|mba| ka|m p|afa| di|n d|and|azo|zy |amp|ia |ren|iny|rah|y z|ry |ika|oan|ao |amb|lal|ho | ho|isy|ony|tsa|asa|a d|ha |fia|mis|ava|ray| pi|am |dra| to|rin| ta|ant|eo |zay|rai|tsi|itr|sa | fo| ra|van|ova|nen|azy| vo|mpi|ari|o f|tok|a k| ir|kan|oto|mah|ly |sia| la|n i|voa|haf|a r|ito|y k|oka|y r|y l|ano|ita|ene|its|ial|zon|aza|ain| re| as|fot|aro|fit|nat|nin|aly|har| ko|ham| no|fa |ary|atr|ila|ata|iha|nam|kon|oko| sa|elo|nja|anj|ive|isa|oa |dy |y d|o m|nto|ank|o n|otr|pan|fir|air|sir|ty |a v|sam|o s|tov|mit|rak|reo|o t|pia|tao| ao|no |y v|iar|a e|a z|hit|hoa| it|to |za |ton|eha|end|vy |idi|tin|ati|adi|lna|aln|rov|ban| za|nga|hah|oni|osi|sos|vah|ino|ity| at|hia|pir|ifa|omb|ame|era|vel|kar|va |tso|jak|fid|ifi|ais|o i|idy|la |ama|ba | pa|tot|ani|rar|mpa|haz|kam| eo| il|iva|aho|nao|n k|ato|lah|ovy| te|dro|lan|ela| mo| si|fin|miv|san|koa| he|aso| mb|sak|kav",
    qug: "ta | ka|ka |na |una|cha|ash|ari|a k|ana|pak|ish|ach|hka|shk|mi |kta|hay|man| ch|apa|ak |rin|ata|kun|har|akt|ita| ha|ami|lla| pa|ama|pas|shp| ma|tak|ayñ|yñi|in |sh |ina|uku|nka|chi|aka|a c|yta|kuy|all|tap|a h|kan| tu|ñit|tuk| ru|run|chu|an |pay|ayt|ris| ki|aku|hpa|ank|a p|kam| sh|nam|a s|uy |i k|ayp|nak|pi |nta|a m| li|ay |lia|hin|kaw|nap|ant|tam|a t|iri|nat| wa|y r|kay|aws| ya|n t|ypa|wsa|pa |lak|shi|a a|lli|iku|hu |n k|iak|yay|kis| al|shu|a w|ipa| sa| il|api|kas|yku|yac|kat|a r|huk|i c|wan|hik|a i|ill|ush| ti|ayk|hpi| ku|kac|say|hun|uya|ila|ika|yuy|pir|ich|mac|ima|a y|yll|ayl|i p|kin|a l| wi|kus| yu|lan|tan|llu|kpi| ta| pi|aya|la |yan|awa| ni|kak|lat|rik|war|ull|kll|li |ink|nch|un |akp|n s|may| ay|uch|i s|nac|sha|iki|kik|h m|ukt|pip|tin|n p|iya|nal|aki| ri|ura|tik|mak|ypi|i m|i w|n m|his|k i|riy|iwa|y h| hu|han|akl|k t|mas|pik|kap| ña|u t|nmi|nis|k a|i y|k l|kar| im|i i|wil|yma|aym|ksi|iks|uma| su|h k|has| ak|unk|huc|kir|anc|k m|pal|k k|ik |iñi| iñ|ma |n y|mun| mu|mam|tac|a n|i t|k r|sam|ian|asi|k h|was|ywa|iyt|llp|san|sum|ray|si |pan|nki|tar| ii|u k|ñik|uk |iña|kuk|wpa|awp|akk|a u|wat|uri| mi|yar|uyk|ayw|h c|ha |tay|rmi|arm|uta|las|yka|llk|kul|wiñ|ati|ska| ll|kit|n h|uti|kic|mat",
    mad: "an |eng|ng |ban| sa| ka|dha|ren| se| ba|ak | ha|adh|hak| dh|ang|se | pa|aba|a s|na |aga|ha | or|n s|ore|ara| ag|gad|are|ana|n o|ngg|ale|gan|a k|ala|dhu|tab|sar|ota|asa|eba| ot| ke|sab|ba |wi |uwi|abb|i h|huw|aan|n k|a b|bba| ta| ma|pan|hal|bas|ako|dhi|ra |kab|em |beb|ka |lak|gi |lem|g a|eka|n b|ama|nga|san|at |ong|ran|nge|a o|ggu|sa |a d|ane|n p|ken|par|aja|man|gar|ata|nek|apa| na|agi|abe| ga|e e|sal|a a|tan|g s|al |kal|gen|ta |i s|aka|e a|a p|a e| la| pe|nan| an|era|e d| e | be|n a| al|ena|uy |guy|n n|ate| bi|mas|e k|kat|uan|oan|kon|k k|a m|i d|g e|n t|g k|ada|koa|lan|ela| da|bad|ma |ne |as |lab|ega| mo|ar |car|one|i p|bi |kaa|bat|ri |on |pon| so|e b|le |ah |abi|ase|adi|epa| ep|k h|and|pam|te |ok |ste|aon|om |oko|aha|ari|ona|asi|ter| di|di |pad|e s|sad|yar|neg|ton|set|rga|ost|mos|gap|nda|a l|har|i k|ina| a | ng|kom|isa|si |a t|a h| kl|jan|daj|iga|hig|idh|hid|ndh|n m|ngs|tto|ett|arg|la |k b|ler|k d|nna| to|nao|n d|mat| ca|tad|bis|aya|epo|aen| po|bin|nya|kas|k s|n h|sya|nta|gsa|en |ant|n g|kar|i e|das|e t|e p|iba| pr|g p| ho| el|i a|hi |os |sao|uwa|tes| ja|nag|nas|lae|sia|t s|k o|nto|int|yat|arn|m p|duw|adu|eta| ko|i b|ni |g n|kla|rak|ame|mpo|jua|sok|aso|ggi|eja|pel|jam|ele| et|dil",
    nya: "ali|ndi|a m|a k| nd|wa |na | al|yen| ku|nth|ra |di |se |nse| mu|a n|thu|hu |nga| wa|la |mun|u a|unt|iye| ka|ce |ace| lo|a l|ang|e a| la| pa|liy|a u|ens| ma|idw|ons|dwa|e m|i n|ala|kha|lo |li |ira|era|ene|ga |ana|za |o m| mo|yo |o w| ci|we |dzi|ko |o l|and|dan|hal|zik|chi|oyo|pa |ner|ulu|ena|moy| um|a p| da|ape|kap|ka |iko| an|pen|a c|to |ito|hit|nch| nc|iri|lir|wac|umo|e k|lu |a a|aye| dz|kuk|a z|dwe|tha|mal| za|ing|ufu|mu |ro |ful| uf|o c|i d|lin|e l|zo |edw| zo|o a|mwa|u w|iro|o n|lan|amu|ere| mw|nzi|dza|alo|ri | li|fun|lid|gan|so | ca|kul|ofu|nso|o z|ulo|unz|o k|mul|lam|i c|san|a b|kwa| na|a d| a |una|u k|i l|nkh|ant|aku|ca |cit|oli|ipo|dip|ama|lac|wir|han|yan|osa|uli|tsa|i m|pon|kup|u d|ti |gwi|ukh|ung|hun|lon|ank|nda|iki|ina| ko|ao |diz|phu|ati|oma|i a|tsi|pat|iya|siy|kut| ya|zid|eze|ma |i k|mer|ome|mol|u n|u o|aph|ogw|izo|mba|sid|ku |sam|awi|adz| ad|izi|ula|say|e n|khu| kh|rez|vom|bvo|okh|lok|win|akh|o o| am| on|zir|map| zi|eza|ja |go |ngo|ika|its|ats|osi|gwe| co|isa|ya |haw|ani|o p|zi |ndu|kho|ezo|kir|uni|i u| ay|lal|gal|sa |bom| bo|ola|amb|wak|ha |ba |nja|anj|ban| ba|iza| bu|udz|ngw|bun|oye|o d|nal|kus|i p|i o|i y|wi | nt|e p| si|aka|ne |men|jir|nji|sed|ets|end|eka|uma|du ",
    zyb: "bou|iz |aeu|enz|eng|uz | bo|ih |oux|nz | di|ing|z g|ux |uq |dih|ngh| ca|ng |gen|ung|z c| mi|miz|ij |cae|z d| gi| de| ge|euq|you| ci|ngz|ouj|aen|uj | yi|ien|gya| gu|ngj|mbo| mb|zli|dae|gij|cin|ang|j d|nae| se| ba|z y|euz| cu|de |x m|oz |j g|ouz|x b|li |z b|h g| da| yo|nj |xna|oxn|rox| ro|h c|nzl|vei|yau|wz |z m|ix | si|i c|iq |gh |j b| cw|nda|yin| hi| nd|dan|vun|inh| ga|can|ei |cun|yie|q g|hoz|bau| li| gy|wyo|cwy|z h|gue|gz |gun|faz|unz|yen|uh |den|ciz| go|q c|gj | bi|ej |aej| fa|hin|zci| wn|j n|goz|gai|au |z s|q d| vu|h m|gva|hu |auj|ouq|az |h d|ya |uek|ci |nh |u d|ou |sou|jso|gjs|din|awz|enj| do|h s|eve|sev|z r|nq |sin|nhy|g g|g b|liz|kgy|ekg|sen|eix|wng|lij|ngq|bin|i d|ghc| ha|bae|hix|h y|j c|ghg|i b|ouh|en |n d|h f|j s|z v|j y|law|hci|anh|inz|q y|nei|anj|ozc|ez |enh|q s|aiq|uen|zsi|zda|hye|ujc|e c|siz|eiz|anz|g y|i g|q n|bie| ne| ae|giz|u c|hgy|g d|gda|ngd|cou| la|z l|auy|ai |in |iuz|zdi|jhu|ujh|yuz| du|j m| fu|cuz|eiq|g c|gzd| co|uyu|coz|zbi|biu| dw|i s|i n|aw |dun|yun|izy|daw| he|nho| ho|enq|x l|cie|q b|cij|uzl|x d|iuj|awj| ya|eij|dei|nde|sae|izc|wnq|wnh|sei|h b|aih|gzs|bwn|a d|u g|ngg|jca|e b|ran| ra|hcu| me|iet|van| bu|guh|hen|si |wnj| ve|u b|azl|inj|gak|gan|ozg|siu|yaw|i m",
    kin: "ra | ku|se | mu|a k|ntu|tu |nga|umu|ye | um|unt|mun|e n| gu|we |ira|a n| n |wa |ere|mu |ko |gom|a b|e a| ab|li |e k|mba|a a|e b|aba|ga |e u|ba |omb|o k| ba|a u|ose|u b|o a| cy|ash|eng| ag|kwi| bu|za |gih|ren|ndi| ub|ang|yo |aka|gu |igi| ib|a g|a m| nt|uli|o b|ama|ihu|e i|nta| ak|ago|ro |ora| ka|ugu|hug|di |iye|ban| am|cya|ku |ta | bw|and|sha|re | ig|gan|ubu|na | kw|obo| by| bi|a i|yan|ka |sho|kub|era|ese| we|kan|aga|hob|bor|ana|byo|ura|uru|ibi|rwa|wes|u w|no |uko|i m|mo |u a|ure|ili|uba|o n|uha|uga|n a| im|ish|bwa|bwo|wiy|ali|ber|ze |ne |ush|are|o i|u m|ger|bur|ran| ki| no|ane|bye| y |ege|teg|guh| uk|n i|rag|i a|ya |u g|e m|anz|bo |abo|gar|wo |y i|ho |age|ind|o m|eke|a s|ara|zir|ite|kug|kim|aci| as|u n|ani|kir|mbe| gi|yos|kur|ugo|gir|e c|iza|aho|i b|tur|ata|o u| se|u u|zo |i i|aha|nge|mwe|iro|akw|any|eza|uki|imi|o y|ate|u k|iki|atu|bat| in|go |tan|n u|bos| bo| na|hak|iby| at|ihe|ung|ha |bul|kar|eye|eko|gek|nya|o g|shy|e y|awe|ngo|bit|mul|nzi|rer|bag|ge |imw|bah|cir|gac|bak|je |gez|imu|eze|tse|ets|mat| ru|irw|he | ni| ur| yi|ako|ngi| ng|i n|rez|ubi|gus|fit|afi|ugi|uka|amb|o c|utu|ufa|ruk|mug|bas|bis|uku|hin|e g|ige|amo|ing| af|yem|ni | ry|a r|gaz|te |erw|bwe|ubw|hwa|iko| al|ant|zi ",
    zul: "nge|oku| ng|a n|lo |ung|nga|la |le | no|elo|lun| um|e n|wa |we |gel|e u|ele|nel|thi|ke |nom|ezi|ma |ntu|oma|hi |o n|ngo|tu |nke|onk|o l|uth|ni |a u|lek|unt| wo|o e| lo|mun|umu|pha| ku|ang|ho |kwe|ulu| ne|won|une|lul|elu| un|a i|gok|kul|ath|hla|lok|khe|eni|tho|ela|zwe|akh|kel|a k|enz|ana|ban|aka|u u|ing|ule|elw|kho|uku|ala|lwa|gen| uk|wen|ama|na |e k|ko |gan|a e|he |zin|enk|o y| ez|kat| kw|lan|eth|het|o o| ok|okw|i n|nzi|aba|e a|hak|lel|lwe|eko|ane|ka |so |yo |ayo|o a|uhl|nku|nye| na|thu|mph|do |ben|ise|kut|ike|kun| is| im|hol|obu|fan|i k|e w|nhl|nok|ini|and|kuh|ukh|kuk| ak|e i|isi|aph|zi |ile|eki|ekh| ba|eka|the|a a| le| ye|kwa|e e|fut| fu|za |mal| ab|ebe|isa| em|o w|kub|mth|i w|ndl|emp|any|olo|ga | ko|nen|nis|alu|ith|eli|ndo|seb|nda| ya|i i|eke|vik|ake|uba|abe|ezw|yok|ba |ale|zo |olu|ume|ye |esi|kil|khu|yen|emi|nez|hlo|a l|ase|ula|kek|a o|iph|o u|no |azw|kan|mel|uny|ne |ufa|ahl|lin|hul|ant|und|sa |enh|kus|kuv|lak| in|o i|din|kom|amb|zis|ind|ola|uph|wez|eng|yez|phe|phi|mba|nya|han|kuf|nem|isw|ani|iyo| iy|fun| yo|uvi|i a|ene|izi| el|cal|i e|eze|ano|nay|hwe|kup|lal|uyo|ubu|kol|oko|ulo| la|e l|tha|nan|mfu|hon|nza|hin| ey|omp|da |bo |ilu|wak|lon|iso|kug|nka|ink|i l|sek|eku| ek|thw|gez",
    swe: "ar |er |tt |ch |och| oc|ing|ätt|ill|rät|en | ti|til|för|ll | rä|nde| fö|var|et |and| en|ell| ha|om |het|lle|lig|de |nin| de|ng | in| fr|as |ler| el|gen|nva|und|att|env|r h| i |r r|ska|fri| so|har|der| at|ör |ter|all|t t| ut|den|ka |lla|som|av |sam|ghe|ga | sk| vi| av|ete|la |ens|t a| si|r s|iga|igh|tig| va|ig |a s| st|ion|ra |tti|a o| är|ten|ns |t e|na | be|han| un| an| sa|a f| la| gr| må|nge|n s|vis|lan|må |ati|nat| åt|an |nna| li| al|t f|ans|nsk|sni|gru|äll|tio|ad | me|isk|kli|s f|t i|stä|t s|ri |med|sta|h r|lik|da |dig|ta |r o|run|on | re|lag|tta|är |kap|a i|a r|änd|erv|n e|kte|n f|rvi|nom|itt|id | mo|sky|r e|ver|äns|vil|gt |igt| na|tan|uta|dra|t o|ro |isn| fa|kal|ihe|rih|erk|r u|e s|per|l v|vid|one|rel|ber|ran|ot |mot|ndl|d f|ed |ika|män|l s|bet|t b|dd |ydd|kyd|n o|s s|str|n m|tet|sin|r f| om|rna|int|r i|end|nad|l a|ap |ers|nda|t v|ent|rbe|arb| hä|ets|häl|amh|ckl|gar|nga|r m|je |rje|arj|n i|s e|lin|r t|i s|rän| pe|ilk|t l|ern|på | på|täl|d e|dom|ege|g e|tni|r a|lit|ras| så|lln|kil|ski|enn|i o|a d|erä|n a|ara| ge|äro|a m| ar|t d|ilj|els|yck| ve|g o|frå|nas|tra|ess|del|m s|liv|l l|in |v s|g a|ast|e e|val|son|rso|e t|age|nd | eg|ial|cia|oci|soc|upp|igi|eli|g s|rkl|gad|ndr|nte|öra",
    lin: "na | na| ya|ya |a m| mo|to | ko|li |a b| li|o n| bo|i n|a y|a n|ki |a l|kok|la | ma|zal|i y|oki| pe|ngo|ali|pe |so |nso|oto|ons| ba|ala|mot|a k|eng|nyo|eko|o e|nge|yon| ny|kol|lik|iko|a e|o y|ang|ye | ye|oko|ma |o a|go | ek|ko |e m|aza|te |olo|sal|ama|si | az|mak|e b|lo | te|ta |isa|ako|amb|sen|ong|e n|ela|oyo|i k|ani| es|o m|ni |osa| to|ban|bat|a t|mba|ing|yo | oy|eli|a p|mbo|o p|mi | mi| nd|ba |i m|bok|i p|isi|mok|lis|nga|ge |nde|koz|bo |gel|ato|o t|mos|aka|oba|ese|lam|kop| ez|lon|den|omb|o b|ota|sa |ga |e a|e y|eza|kos|lin|esa|e e|kob|e k|sam|kot|kan|bot|ika|ngi|kam|ka | po|gom|oli|ope|yan|elo| lo|ata| el|bon|oka|po |bik|ate| bi|a s|i t|i b|omi|pes|wa | se|oza|lok|bom|oke|som|zwa|mis|i e|bek|iki| at|ola|ti |ozw|lib|o l|osu|oso|e t|nda|ase|ele|kel|omo|bos|su |usu|sus|bal|i l|ami|o o|bak| nz|pon|tel|mob|mu | ep|nza|asi|mbi|ati|kat|le |gi |ana|oti|ndi|tan|a o|wan|obe|kum|nya|mab|bis|nis|opo|tal|mat| ka|bol|and|aye|baz|u y|eta| ta|ne |ene|emb|sem|e l|gis|ben| ak| en|mal|obo|gob|ike|se |ibo|’te| ’t|umb| so|mik|oku|be |mbe|bi |i a|eni|i o| mb|tey|san| et|abo|ebe|geb|eba|yeb|bu | as|ote|sik|ema|eya|ibe|mib|ai |pai|mwa|kes|da |may|boz|amu|a a|kom|mel|ona|ebi|ia |ina|tin| ti|bwa|sol|son",
    som: " ka|ka |ay |uu |an |yo |oo |aan|aha| wa|da | qo| in| u |sha| xa|a i|ada|iyo| iy|ma |ama| ah| la|qof|aa |hay|ga |a a|a w|ah | dh|a s| da|in |xaq| oo|a d|aad|yah|eey| le|isa|lee|u l|q u|aq | si|taa|eya|ast|la |of |iya|sa |y i|u x|sta|kas|xuu|uxu|wux| wu|iis|nuu|inu|ro | am| ma|a q|wax|dha|ala|kal|nay|f k|a k|le |ku | ku| sh|o i|a l|ta |maa|a u|dii|loo| lo|o a|ale|ara|ana|iga|o d| uu|ha |lo |o m|o x|doo|aro|kar|yaa|gu |si |ima|na | xo| fa|adk|do |a x|ad |aas| qa| so|a o| ba|lag| aa| he|dka|adi|soo|o k|aqa| is|ash|u d|had| ga|eed|san|u k|a m|iin|i k| ca|u s|n l|yad|rka|axa|elo|hel|aga|hii|o h|o q| ha|id |n k| mi|baa| xu|har|xor|aar|ax |mad|add|nta|mid|aal|waa|haa|ina|qaa|daa|agu|ark|o w|nka|u h|dad|ihi| bu| ho|naa|n a|ays|haq|a h|o l| gu|o s|aya|saa|lka| ee| sa|dda|ab |nim|quu|gga|ank|kii|rci|arc|n s|a g| ji|gel| ge|eli|ysa|a f|siy|int|laa|uuq|uqu|xuq| mu|i a|uur|mar|ra |iri|o u| ci|riy|ya |ado|alk|dal|ee |al |rri|ayn|asa| di|ooc|aam|ofk|oon|to |ayo|dar| xi|dhi|jee|a c| ay|yih|a j|ban|caa|lad|sho|d k|ida|uqd|agg|sag|ras|bar|ar | ko| ra|o f|gaa|gal|fal|u a| de| ya|o c|ii |xay|eel|aab|sig|aba|orr|hoo|u q|y d|ed |ho |sad|qda|h q|fka|n i|xag|n x|qay|lsh|uls|bul|u w|jin| do|raa| ug|ido|ood",
    hms: "ang|gd |ngd|ib | na|nan|ex | ji|eb |id |d n|b n|ud | li|nl |ad | le|jid|leb|l l| ga|ot | me|x n|anl|aot|mex|d g|b l|d d|ob |gs |ngs|jan| ne|ul | ni|nja| nj|lib|ong|nd | zh|jex| je|b j| sh|ngb| gh|gb | gu|gao|l n|han| ad|gan| da|t n| wu|il |x g|nb |b m| nh|she|is |l j|d l|nha|l g|d j|b g|el |end|wud|nex|gho|d s|d z|oul|hob|ub |nis| ch| ya|it |b y|eib| gi|s g|lie| yo| zi|oud|s j|d b|nx | de|es |d y| hu|uel|gue|ies|aob|you| ba|d m|chu|gia|dao|b d|s n|zib| go|zha|eit|hei|al |hud| do|nt |ol | fa|t g|hen|ut |gx |ngx|ab |fal|x j|b z|ian|d h|don|b w|t j|iad|nen| xi|gou|d c|b h|hao|x z|nib|anx|ant|gua| mi|s z|dan|ox |inl|hib|lil|uan|and| xa|b x| se|x m|uib|hui|d x|anb|enl| we|od |enb| du|at |ix |s m|bao| ho|hub| ng|zhi|jil|l s|yad|t m|t l|yan| ze| ju|heb|had|os |aos|t h|l d|nga| he|b a|xan|b s|sen|xin|dud|jul|d a|lou| lo|dei|d w| bi|b c| di|zhe|gt |ngt|x l|bad|x b| ja|hon|zho|blo| bl|d k| ma|deb|l z|wei| yi| qi|b b|x d|d p|eud| ge|x a|can| ca|t w|lol| si|hol|s w|aod|pao| pa|ren| re|x s|eut|pud| pu|aox|mis|gl |ngl|x w|zei|gon|enx|gha|s a|b f|l y|oub|eab|hea| to|did| ko|unb|ghu|t p|x c|geu|t s|x x|jao|ed |t c|l m|l h|jib|ax |l c|d f|nia| pi|eul|d r| no|min|l t|heu|ux |tou|ns |s y|iel|s l|hun",
    hnj: "it | zh| ni|ab |at |ang| sh|nit| do|uat|os |ax |ox |ol |nx |ob | nd|t d|zhi|nf |x n|if |uax| mu|d n|tab| ta| cu|mua|cua|as |ad |ef |uf |id |dos|gd |ngd|hit|ib |us |enx|f n|she|s d|t l|nb |ux |x z|ed |inf|b n|l n|t n|aob|b z| lo|ong|ix |dol| go|zhe|f g| ho| yi|t z|d z|b d| le|euf|d s|ut |yao| yo| zi|gb |ngb|ndo|enb|len| dr|zha|uab|dro|hox| ge|nen| ne|han| ja|das|x d|x c|x j|f z|shi|f h|il | da|oux|nda|s n|nd |s z|b g| ny|heu| de|gf |ngf| du|od |gox| na|uad| gu|inx|b c| ya|uef| xa| ji|ous| ua| hu|xan|hen|zhu|nil|jai|rou|t g|f d| la|enf|ged|ik | bu|nya|you|f y|lob|af |bua|uk |is |yin|out|of |l m|ud |hua| qi|ot |t s| ba|ait| kh|s s|nad| di|aib|x l|lol| id|dou|ex |aod|bao| re| ga|d d|b y|las|hed|b h|b s|f b|t y|jua| ju| dl|x s|hue|b l| xi|zif|dus|b b|x g|hif|x y|hai| nz|sha| li|x t| be|d j|und|hun|ren|d y|hef|xin| ib|b t|l d|aos|s l| ha|gai|nzh|gx |ngx| ao|s b|s x|el |gt |ngt|hik|aid|s t|x m|f l|f t| pi|aof|t r|eb | gh|s y|d l|gua| bi| za| fu|t h| zu|hou|deu|lb | lb|d g| mo|b k| bo|iao|ros|gon|eut|x h|al |uaf|hab|t t|k n|f x|hix|pin|yua| no|t b|ak | zo|s m| nb| we|d b|gha|f s|mol|euk|dax|l b|nof| ko|lou|guk|end|uas|t k|dis|dan|yol|uan|d t|x b|lan|t m| ch|jix|x x| hl|aox|zis|x i|et | ro",
    ilo: "ti |iti|an |nga|ga | ng| it| pa|en | ma| ka| a | ke| ti|ana|pan|ken|ang|a n|agi|a k|n a|gan|a m|a a|lin|ali|aya|man|int|teg|n t|i p|nte| na|awa|a p|na |kal|ng |dag|git|ega|sa |da |add|way|n i|n n|no |ysa|al |dda|n k|ada|aba|nag|nna|ngg|eys| me|a i|i a|mey|ann|pag|wen|i k|gal|gga| tu|enn| da| sa|nno| we|ung| ad|tun|mai| ba|l m| ag|ya |i s|i n|yan|nan|ata|nak| si|aka|kad|aan|kas|asa|wan|ami|aki|ay |li |i m|apa|yaw|a t|mak| an|i t|g k|a s|ina|eng|ala|ika|ama|ong|ara|ili|dad| aw|gpa|nai|et |yon|ani|aik|on |at |oma|sin|bal|ipa|n d|uma|g i|ket|ag |in |aen|n p|ram|sab|aga|nom|ino|lya|ily|syo|i b| ki|nia|agp|gim|kab|asi|kin|iam|ags|bab|oy |toy|n m|agt| ta|bag|sia|g a|gil|mil| um|o p|ngi|n w|i i|pad|pap|daa|iwa|naa|eg |ias|ed |nat|bae|o k|saa|san|pam|gsa|ta |kit|ma |dum|yto|tan|i e|t n|uka|t k|apu|lan|sta|sal| li|a b|ari|g n|den|mid|ad |o i|y a|ida|ar |aar|y n|dey| de| wa|a d|ak |bia|ao |tao|min|asy|mon|imo| gi|maa|sap|abi|i u|aib|kni|i l|gin|ged|o a| ar|kap|pul|eyt|abs|ibi| am|akn|i g|kip|isu|g t|bas|nay|ing|i d|kar|ban|iba|nib|t i|as |d n|y i|ura|a w|nal|aad|i w|lak|adu|kai|bsa|duk|edu| ed|may|agb|agk|tra|gge|sol|aso|agr|ngs|ian|ila|dde|edd|tal|aip|kua|umi|pay|sas|ita|pak|g d|ulo|inn|aw "
  },
  Cyrillic: {
    rus: " пр| и |рав| на|пра|ств|го |ени|во |ове| ка|на |ть | по|ия |о н| об|ет | в |сво| св|аво|ани|ост|ого|ый |ажд|лов|т п| им|ния| че| со|ело|име| не|льн|ли |чел|каж|ест|век|ать|ова|или| ра|ек |й ч|дый|жды| до|ие |еет|мее|но | ил|ии |ся |его|обо|и п|ние|к и| бы|и с|и и|ми |бод|воб|ван| за|ой |ых |ом |лен|аци|енн|о с|о п|ьно|тва|тво|при|ног|аль|ако|ва |и н|сти|ных|то |бра|олж|дол|сто|и в|ным|ое | ег|нов|их |ель|тел|ти |нос|не |пол|раз| вс|и о| ли|и р|ыть|быт|вле|ред|ию |тор| ос|ься|тьс|оди|щес|я и|как|про|жен|ым |пре|а с|сно|е д|нно|о и|ий | ко|о в| ни| де|сту|лжн|сов|е в|ном|оль|ран|оже|иче|ей |аст|нны| от|туп|м и|одн|зов|рес| мо|осу|ля |осн|а о|вен| то|о б|шен|тве|общ|а и|е м|ьны|обр|вер|чен|я н|жно|чес|ак |лич|нии|е и|все|бще|ват|есп|мож|й и|ное|о д|бес| во|я в|ду | ст|дно|она|нац|ден|ежд|х и| бе|и д|ны |дос|для| дл| та|льс|ате|ции|я п|ую |ите|е о|ной|под|ото|стр|ста| ме|ели| ре|я к|тоя|ами|ен |ь в|ю и|азо|гос|м п|ь п|т б|жет|уча|суд|ьст|дст|щит|ащи|защ|кон|нию|ам |оду|ере|гра|печ|о о|оро|кот|и к|тра|ник|уще|циа|оци|соц|нал|еск|о р|ког|дру| др|ни |ава|нст|ем |авн|ыми|едс|дин|дов| го| вы|в к|ые |обе|му |я е|слу|уда|так|кой|ту |иту|зак|ход|вол|раб|кто|икт|ичн|нич|от |ина| к |тер|род|нар",
    ukr: "на | пр|пра| і |рав| на| по|ня |ння| за|ого|ти |во |го | ко|аво| ма|люд|о н| не| лю|юди|ожн|кож|льн|жна|дин|ати|ає |их |ина|пов|сво| св|анн|є п|має|або|а л| бу|не |енн|бо | аб|а м|ови|ні | ви| ос|аці|вин| та|без|обо| ві| як|ере| до|і п|ува|о п|аль|них|ом |ми |іль|ног|та |ий |при|ою |ть |ста| об|ван|инн|ті |ост| у |ся |ват|бут|ист| мо|езп|ути|нов|пер|ії |и п|бод|воб|ств| в |о в|від| бе|ако|під|тис|кон|но |ва |нні|і с|а п|сті| сп|ний|ду |ьно|она| ін|дно|ним|ій |а з|ну |мож|її | її|ля |соб|му |ої |яко| пе| ра|ід | де|і в|и і|чин|вно|ому|ном|у п|і н|а с| су|а о|нен|ися|ово|нан|одн|у в|і д|ава|ідн|рів| рі|і р|ими|віл|им |ції|о д|а в|сту|оду|буд|ова| пі| ні|я н|е п|нац|и с|нна| од| ро|нос|ьни|ють|и з|ки |і з|а б|спр|чен|же |оже|е м|овн|рим|е б|то |ніх|осо|удь|ві | ре| ст|рац|до | со|роз|лен|вни|івн|род| вс|спі|ков|зпе|ів |для| дл|ї о|хис|ахи|зах|‐як|ь‐я|дь‐|я і|так|зна|заб|сть|ту |ною|а н|тор|сно|о с|жен|ціа|оці|соц|інш|і м|кла|и в|тер| ді|іст|ові|у с|я в|аро|сі |віт|сві|осв|роб|піл|рес|за |печ|абе|ку |лив|ерж|дер|в і|авн|тав|ав |ами|ком|вле|о б|ь п| що|їх |тво|хто|іхт|ког| кр|ано|тан|іал|нал|нь |х п|жно|леж|але|про|тва|рат|о о|х в|нар|льс|цій|кор|час|ржа|ї с|ину|дст|о з|раз|мін|а р|зак",
    bos: " пр| и |рав|на |ма |пра| на|има| св|а с|да |а п|во |је |ко |ако|о и| по|аво|е с|а и|ти | им| да| у |сва|но | за|о н|ва |и п|или|вак|ли | ко|не | ил|кој| не| др|ост| сл|ња |им |и с|у с|и и|ава|ије|а у| би|ств|се |вањ|а д|ом |јед|бод|обо|лоб|сло| се| ра|их |сти|а н|ње | об| је|при|дру|у и|ју |о д|ити|вој|раз|ање|ова|дје| ос|е и|ло |е п|ања|ује|и д|бра|тре| тр| су|у з|а к|ог |у п|оје|циј|реб|а о|а б| ње|и у|миј|ни |нос|ба |едн|сво|њег| из|про|е д|жав|бит| ни|и о|ста|а з|авн|вје| ка|бил|ово|а ј|ају|ист|и н|них|јел|ту |ред|гов| од|е о|оји| см|ја |о к|ило|аци|е у|пре|о п|еба|у о|су |вим|ичн| са| дј|а т|ија|шти|чно|ржа|држ|сту|дна|одн|ени|за |ива|ном|ем |ду |ран|вно|сми|јер|е б|е н|де |пос|м и| до|у д|нак|а р|обр| мо|ним|его| кр|тит|кри|ве |ан |ико|ник|ну |и м|ног|ено|сно|е к|туп|руг|ка |ода|рив|вољ|алн|м с|иту|ашт|заш|ани|сам| ст|акв|ови|осн|род|аро| ми|ји |тва|дно|нст|ак |ите|љу |вич|рад|у н|у м| та|дст|тив|нац|рим|кон|ку |њу |оду|жив|амо|тво|тељ|под|ећу|г п|нов|ина|нар| вј|и б|ој | ов|аве|ву |анс|оја|зов|азо|уде|буд| бу|е т|и в|ења|еди|ниц|нап|мје| ис|слу|едс|о о|зак|и к|м п|тно|иво|ере|нич|как|ада|вни|уги| ро|мов|вен|о с|то |те | вр| бе|ара|кла| бр|у б|у у|и т|она| он|ави|јал|дни| ск",
    srp: " пр| и |рав|на |пра| на|ма | св|има|да |а п|во |ко |ти |аво| по|а и|ако|а с| за| у |о и| им|и п|ва |сва|вак| да|о н|е с|ост| ко|ња |ли |или|не |ом | не|а н| сл| ил|је | др|и с|но |кој|у с|ава| ра|ог |сло|ју |им |сти|бод|обо|лоб|ити|а о|ств|и у|а д|ни |јед|у п|при|едн| би|и и|а к|о д|ста|их |дру|а у| је|ања| ос| ни|нос|про|ају|и о| де| су|у и|се |ње |ја |ова|и д|циј| об|ује|ред|жав|е и|е п|а ј|дна| се| од|ве | ка|ени|ржа|држ|а з|авн|ења|аци|вој|ово|у у|м и|оја|вањ| из|ија|у з|ање|ран|е о|род|и н|е б|раз|за | ње|гов|ичн| ст|нов|сно|осн|ду |пре| тр|су |ву |одн|а б|сво|њег|ним|них|ту |тит|шти|ку |ном|бит|е д|ме |ико|чно|оји|ло |вно|ник|ика|без|ара|де |у о|вим|нак| са|рив|аве|ан |вољ| кр|о п|сме|е к|ног|ји | ов|е у|тва|бра|руг|реб|тре|у д|ода| мо| вр|ављ|у н|его|дел|м с|кри|о к|ашт|заш|њу | см|ани| ли|дно|еђу|алн|ла |акв|ој |ком|сту|уги|ави|а р|ка |рад|оди|вич|тав|иту|уде|буд| бу|пот|оду|жив|ере|тво|ило|бил|аро|е н|ови|пор|ено|штв|нац|ове|м п|туп|пос|рем|дни|ба |нст|а т|оју|аст|ива|е м|вре|вља|ну |беђ|ист|ен |те |дст|рот|зак|ао |као|и к|јућ|о с|ст |сам|м н|тер|нар| ме|и м|кол|е р|ушт|руш|вер|как| бе|и б|кла|ада|еба|ена|она| он|тву|анс| до|рак|слу|и в|ниц|у к|мен|врш|еме|едс|иви|о о|јав",
    uzn: "ан |лар|га |ир | би|ар | ва|да |ига| ҳу|ва |бир|уқу|қуқ|ҳуқ| ҳа|р б|ган|иш |ида| та|а э|ини|ади|нг |дир|иши|лик|лиш|ий |или|ари|уқи|ҳар|лан|инг|ши |дан|нин|инс|кин|сон|нсо| ин| му|қиг| ма|он |р и| бў|эга| эг| ўз|ни |бўл|гад|и б|ки |ила|ёки| ёк|а б|н б|ин |р ҳ|ала|эрк| эр|лга| қа|рки|ш ҳ|и ҳ|н м| бо| ба|ик |ара|иги|лиг|ри |қил|а т|бил| эт|ниш|нли|кла|и в|бош|эти|ани|им |и м|оли|қла|а ҳ|лаш|атл|тил|а қ| ол|оси|мас|қар|инл|лат| қи|таъ|ҳам|ги |иб |мла|ўз |н э|мум| да| бу|ат |ш в|ун |ати|мки|умк|тла|иро|ўли|бар|ири|риш|ият|али| бе| қо|а ш|аро| ке|и т|рла| те|ча |рча|арч|а ў| шу|тиш|н ҳ|тга| са|аси| ха|рак|лин|ола|имо|шқа|ли | ту|амл|лла|сид|н ў| ас|нид|а и| ки|н т|нда|к б|ера|ошқ|сиз|ор |а м|р в|енг|тен|мат|мда|амд|лим|й т|ят |и а|ино|илг| то|тни|ана|ас |эма| эм|а ё| ша|аш |а а|тар|кат|ака|ак | де|аза|илл|сий| си| со|уқл|н қ|ода|ъли|аъл|ник|ада| ни|тда|гин|уни|сит|ай |қон|н о| жа|ким|еч |ҳеч| ҳе|ўзи|лак|кер|икл|лли|ур |зар|шла|риг|ирл|дам|коҳ|ико|а д|ам |н в|рти|тиб|тал| иш|чун|учу| уч|сла|а у|рин|сос|асо| ун|на | ка|муҳ|диг|ч к|асл|лма|ра |бу |хал|ўлг|и к|екл|р д|қат|ага|и қ|оий|мил| ми|қа |и с|жин| жи|син|рор|а в|лад|а о|тли|мия|н и|аб |тир|з м|дав|рга|аги|а к|нла|ақт|вақ|арт|аёт|лаб",
    azj: " вә|вә |әр |ир | һә| би| һү| ол|үгу|һүг|гуг|на |ин |лар|һәр|дә | шә|бир|ләр|лик|мал|р б|лма|р һ| тә|әхс|шәх|ән |дир|угу|уна|ан |али|а м| ма|икд|ини|р ш|дән|ар |илә|гун|аг |асы| ја|мәк|јәт| мә| мү|кди|әси|әк |илм|нин|ндә|олм|әти|ә ј|син|хс |нда|лмә|јјә|и в| га| аз|олу|ијј|ја |инд|зад|гла|үн |ни |лә |тин|н м|аза|ары|әт |н т|маг|лун|лыг|ә б|ун |нун|г в|н һ|дан|ын | ет|тмә|әрә| өз|да |ә в| он|ә а|ына|ыны|бил|а б|сы |ил |әми|ара|си | ди|ә м|әри|рлә| ва|ә һ|етм|ығы|ама|длы|адл|рин|бәр|рын|н и|мүд|нын| һе|мас|ик |н а|дил|алы|ирл|әлә|үда|сын|ынд|хси|ли |ә д|нә | бә|әја| ин|ә и|ләт| сә|ны | иш|аны|еч |һеч|г һ|ејн|ә е|дыр| да|аси|ры |иш |ифа|лығ|и с|фиә|афи|даф| ед|мәз|у в|кил| һа|ола|н в|әни|ыр |уг |унм| бу| ас|сиа|оси|сос|или|ыды|лыд|нма|ыг |инә|әра|сил|хил|ахи|дах|адә|ман|а һ|ә о|ону|а г|әз | ки|сеч| се|ы һ|мин|лан|әдә|бу |раг|лы |ылы|ал |ә г|р в|нла|һси|әһс|тәһ|өз |ист| ис|мәс| әс|ина|ә т|әтл|а в|иә |н б|тәр| та| ҹә|еди|ала|ким|гу |и т|улм|мәһ|н о|аја|ы о|иал| со|илл|сиј| дә|вар|инс|ми |ғы |ник|р и|агл|к һ|тәм|там|чүн|үчү| үч|ғын|сас|әса|з һ|әмә|зам| за|сти|рәф|н е|р а|илд|һәм|ыгл|јан|мај|н ә|мән|мил| ми|әги|дин|н д|түн| дө|миј|каһ|ика| ни|фад|тиф|л о|сәр|јни| еј|ана|лән|ам |рил|ајә|ашы",
    koi: "ны |ӧн | бы|да | пр|лӧн|рав| мо|пра| да|быд| ве|орт|лӧ |ӧй |мор|ӧм |аво| не|во |ыд |ыс |нӧй|ын |м п|д м|ыны|тны| ас|тӧм|льн| эм|вер|сь |ьнӧ|эм |н э|тлӧ| кы|сӧ | по|ерм|сьӧ|ртл|аль| кӧ|эз | ӧт|ӧ в|то |ето|нет|ылӧ| ко|тшӧ| от| и |ы с|бы |ӧ б|ств|кӧр| вӧ|шӧм|кыт|та |на |з в| се| до|вол|ӧс | сы|ы а|ола|рмӧ|ас |оз | оз| сі|а с|тво|с о| вы|ліс|ӧ к|ытш|ӧ д|ис |ісь|ӧтн|ась| ол| на|аци| эт|а в|злӧ|сет| во| чу|лас|лан|мӧ |тыс|рты|ӧрт|ы п|ӧтл|о с|эта|дз |кӧт|ӧдн|вны| мы|н н|удж| уд|выл|ӧ м|рті|орй|ись| со|воэ|ыдӧ|й о|кол| го|с с|сси|сыл|ысл|йын|кин|олӧ|тӧн| сь|ана|ӧр |ция|а д|ӧмӧ| ви|з к| эз|ы б|тӧг|ӧт |мӧд|ест|ост|ӧны|тир|оти|укӧ|чук|н п|онд|пон|слӧ|кер| ке| об|сис|суд|а н|дор|кон|нек|н б|лӧт|с в|ті |ьӧр|тра| ст|нал|она|нац|н к|кӧд|ӧг |скӧ|ть |етӧ|дӧс|быт|рны|ӧ н|тсӧ|рре|а б|нда|с д|асс|ы к|асл| ло|ьны|сьн|ы м|еки|ы д| мӧ|ь м|ы н|ытӧ| ме|рйӧ|иал|й д|итӧ|а к|ӧсь|мӧс|овн|зын|а п|отс| ли|оля|ӧ а|осу|ӧя |нӧя|езл|рез|мед|с м| сэ|ь к|рйы|ако|зак| за|ьын|ннё|мӧл|умӧ| ум|ы у|н в|м д|н с| дз|н о|ран|стр|озь|поз|з п|о д|циа|оци|соц|ион|а м|еск|чес|нӧ |з д|тсь|бӧр| бӧ| ов|вес|кыд|ӧ с|воы|код|тко|ӧтк|оль|дбы|едб|сьы|чын|тчы|ӧтч|тла|мӧн|сла|йӧз| йӧ|т в|ы и|ез |о в|оны|йӧ |анн|ӧль| пы|ан |нӧс|нит| су|м с",
    bel: " пр|пра| і |ава|на |рав| на| па|ны |ва |або|ць | аб|ае | ма|аве|анн|ацы|сва| св|е п|льн| ча|не |ння|ала|а н|ай |лав|чал| ко| ад| не|га |ожн|кож|век|ня | як|жны|ы ч|мае|а п|ага|бо |ек |а а|ца |цца| ў | за|ых |пав|а с|го |він|дна|бод|мі |ваб|ван|ам | вы| са| да|ста|аві|нне|асц|най|цыя|наг|ара|і н|к м|яго| яг|ьна|пры|аць|і п|одн|ств|ама|ных| бы|тва|дзе|аль| ра|ні |і с|і а|ыць|а б|енн|лен|ці |оўн|ым |рац|інн|іх | ас| та|то |нас|які| дз|чын|оль|і д|аво|ад | ні|сці|ымі|ным|быц|я п|ьны|ыя |аро|ана|іна|і і|рад| гр|ля |ўле|о п|а ў|рым|пад|ыі | ін|амі|дзя|рам|цыі|аба|а і|ду |жна|ўна|нал|нац|ры |эта|гэт| гэ|нен|да |ах |гра|кац|ука|а з|кі |адс|ў і|нст|энн|я а|нні|оду|а р|нна|ход|нан|пер|х п| у |адз|і р|мад|м п|е м|аду|дст|для| дл|оў |нае|і м|ако| ка|ы ў|бар|е а|ацц|ую |ыцц|сам|яўл|але|род|раб| пе|што| ўс|адн| су|роў| ро|дук|люб|ь с| шл|раз|нав|зна|вол|удз|ада|жыц|чна|ве |а т|асн|сац|ера| рэ|яко|кла|аны| шт|ь у|аюц|нар| ус|соб|асо|пам|я ў|авя|чэн|воў|так|ну |ю а|ь п|зак|кар|е і|ь а|бес|ія |кія|х і|заб|аса|ім |жав|і з|леж|тан|ахо|яль|ыял|о с|яна|кан|ака|інш|алі|вы | мо|нах|я я|м н|ога| бе|й д|о а| ст|ены|і ў|а д|есп|шлю|цця|ы і|ыст|рыс|люч|клю|тац|уль|ынс|ачы|спр| сп|аў |ыма|ары|кам|е ў|і к|кон",
    bul: " на|на | пр|то | и |рав|да | да|пра|ств|ва |а с|а п|во |но |ите|та |о и|ени| за|не | не|а н| вс|ван|аво|ото|е н|о н|а и|ки |ие |те |ни |има| им|ли |или|ия | по|ове|ане|чов|ма | чо|и ч|а д|ние|и д|ест| ил|ани|век|все| об|ек |еки|сек|ава|тво|сво| св|вот|а в|и с|ост| ра|ова|а о|е и|ват|и н|е п|к и|а б| в |и п|лно|о д| се|раз|ето|ъде|бъд| бъ|при|ата| ко| тр| ос| съ|бод|обо|воб|ат |за |тел| е |аци|о с|де |о п|ен |бра|и в| от|се |ния|алн| де|его|нег| из|от |ран|ята|как|оди|е с|и и|ден|пре|бва|ябв|ряб|тря|нит| ка|ява|про|ст |а з|гов|вен|тве|о о|а р|акв|о в|и з|ред|нос|ият|е д|щес|нов| ни|ция| до|йст|о т|е т|ржа|ърж|дър|ено|пол| с |обр|тва|нот|рес|ейс|и о|е в|кой|общ|лен|она|нац|иче|ез |без| бе|ежд|ува|вит|ри |зак|и к| ли|а е|под|ели|ник|си |е о|а т|авн|и р|т с|ка |оет|елн|нен|ой |гра|жен|дру| ре|а к|сно|осн|лич|зи | та|са |нст|вни|чки|ичк|сич|вси|люч|клю|дно| мо|еме|а у|изв|тви|дей|я н|кри|ато|о р|й н|ико|ичн|жав| дъ| то|бще|иал| со|лит|т н| си|т и|одн|жда|зов|азо|уча| гр|кое|тъп|стъ|вол|лни|сре| ср|ква|кон|тно|ака|и у|ко |ган|ода|чен|лст|елс|стр| къ|ста|род|нар|и м|нал|руг| др|чес|въз|ди | са| те|сто|дос|раж|рез|чре|гат|еоб|а м|о е|ине|аст|ово|чно|аве|му | му|ано|ита|ими|ако|нак|лаг|ови",
    kaz: "не | құ|ен |ұқы| ба| қа|құқ|ық |ға | жә|әне|жән| не| бо|де |дам|ада|а қ|тар|ына| ад|ылы| әр|ың |ан |ін |қыл|ар |еме|на |р а|лық|уға|ала|ықт| өз|мес|әр | жа|мен|ығы|лы | де|қта|ның|н қ|ған|іне|бас|ары| ме| қо|еке|ын |да |е қ|ды |асы|се |есе|ам |бол|анд|нем| бі|ара|ы б|ста|тан|нды|н б|ің |е б|ілі|тиі| ти|бар|ғы |нде|етт|иіс|қығ|іс |лар|ге |ы т|інд|ік |бір| бе| ке|алу|е а|алы|луы|а ж|ері|олы| те|қық|н к| та|н ж|ғын|тті|іні|тын| ер|нда|ім | са|е ж|аты| ар|рға|еті|ана|ы ә|уын|лға|өзі|ост|егі|тік|қа |сқа|рын|кін|луғ|ң қ|нің|уы |бос|асқ|қар|дық|нан|мыс|мны|амн|ы м|айд|ке | же|зін|рде|рін|е т|ген|ып |ры |ті |сын|қам|ден|і б|гіз|рал|е ө|лан|сы |ама|тта|тық|бер|ді |біл|ркі|өз |зде|кет|қор|дай|уге|ы е|ынд|нег|оны|ей |мет|аны|а т|жас|ауы|лге|аса|еге|дар|ру |ау |ерк|ы ж|рыл| то|н н|е н|тін|ір |сіз|тер|лма|і т|кім| ал|р м|лік| мү|е м|түр| тү|кел|лып|ең |тең|рлы|лім|рды|ард|атт|с б|ыры|сыз|ыс |елг|дал|йда|орғ|рқы|арқ| жү|тал|ылм|а б|ігі|лде|із |қты| еш|дей|ай |жағ|кті|ікт|гін| әл|тты|ұлт| ұл|е д|ыны|лін|р б|еле|кұқ| кұ|амд|м б| ет|оға|құр| кө|аға|тол|шін|айы| қы|қал|жек|і н|ес |ағы|е о|елі| ел|н е|зі |шкі|ешк|олу|ция|мас|ғда|ағд|лтт|імд|ным| да|а д|әсі|с ә|қат|ірі| со|ң б|аза|мда|айл| ас|ғам|қоғ"
  },
  Arabic: {
    arb: " ال|ية |في | في|الح| أو|أو | وا|وال|حق |ة ا|لحق|الت|كل |الم|لكل| لك|لى |ق ف|ته |و ا|ة و|شخص|ة ل|ات |الأ|ي أ|ون | شخ|م ا|أي | أي|ان |أن |مة |ي ا|الا|لا |ها |اء | أن| عل|خص |ن ا| لل|د ا|من |فرد|ما |الع|ت ا|حري|على|ل ف|رد |ل ش| لا|رية| إل|ة أ|ا ا|ن ي| ول|ا ل|ا ي| فر| من|ة م|الق|جتم|ن أ|ق ا|الإ| حر|له |ه ل|اية|لك |ه ا| دو|دة |اً |ين |ه و|لة |ي ح| عن|ماع|ي ت|ذا | حق|قوق|حقو|، و|ن ت|مع |ص ا|ام |د أ| كا|هذا|الو| إن|مل |امة|ع ا|إلى|ة ع|ماي|حما|ن و|لتع| وي|ير |نون|ي و|اسي|الج| هذ|نسا|وق |ترا|عية|ه أ| له|سية| يج| با|دول|انو|قان|لقا|ة ب|ة ت|تما|الد|يات|ع ب|سان|إنس|هم |علي| مت|لمج|ذلك|عمل|لأس|وز |جوز|يجو|بال|غير|ك ا|كان|ساس|أسا|دم |لاد|اعي|الر|تمي|دون|تمت|لتم| يع|ليه|ساو|اجت|ي م|لعا|لجم|تعل|ر و|تمع|مجت| مع|يه |ى أ|فيه|ى ا| كل|لات|ملا|ود |انت|الف|يها|ي إ|تي |الب|لي |قدم|ال |اد |ل ا|يز |ييز|ميي| تم|لحر|تع |متع|ا ب|عام|ا و|ق و|رام|ل ل|لاج|را |الش| وإ|يم |ليم|شتر|ا ح|واج|لزو|ول |ا ف|ولة|لحم|أسر| ذل|ه ف|اته|مسا|لمس| تع|عن |ه ع|وله|يته|ن ل|رة | وس|اة |يد | تح| مس|ي ي|لتي|عة |ولي|لدو| أس| وف|ل و|أية|ني |الس|لان|لإع|ة ف|ريا|ل إ|م ب|امل|كرا|تسا|ميع|جمي| جم|أول|بية|عيش|تحق|ادة|س ا| مم|معي|جما|عات|اعا|ارس|مار|مما|م و|راك|اشت|الط|اج |زوا|الز| وم|حدة|تحد|لمت|مم |لأم|ده |بلا| بل|ار |يار|تيا|ختي|اخت|ن م| مر",
    urd: "ور | او|اور|کے | کے| کی| کا|یں | حق|کی |کا | کو|ئے |ے ک|یا |سے |کو |شخص| شخ|نے | اس| ہے|میں|حق | ہو| می|خص |ے ا| جا|اس | سے| یا|ہر |ی ا| کر| ہر|ے۔ |سی |ہیں|ا ح|ص ک|وں |ے م| ان|ر ش|۔ ہ|ائے|زاد|آزا| آز|ام |ر ا|ق ہ|ادی|جائ|ں ک|ہے۔|م ک| کس|ا ج|ی ک|س ک|کسی| پر|ے گ|ہے |ار |ت ک|دی |پر |و ا| حا| جو| ہی|ان |ی ج|ری | نہ| مع|جو |ل ک|ی ت|ن ک|کرن|ئی |ل ہ|تی |ہو |ہ ا| ای|صل |اصل|حاص|رنے|ی ش|نہ |۔ ا|ں۔ |یں۔|ر ک|ر م| مل|وہ |معا|رے |ں ا|نہی|ے ہ|ے ب|ایس|ے ل| تع| گا|یت |ی ح|ا ا|ی م|اپن| اپ|کیا|می |ی س| جس|ہ ک|نی |اشر|عاش| دو|لئے| لئ|انہ|وق |قوق|حقو|مل | قا|کہ | گی|ر ب|ہ م| وہ| بن|ی ب|ملک|جس |ا۔ |ریق|ر ن|ے ج|اد |ات |گی |د ک|ے ح|دار|ر ہ|گا۔|قوم| قو|ے، |ا س|دوس|ر پ| و | شا|ی آ|ں م|ق ح| پو| با|خلا|انے|یم |لیم|و ت|ون | کہ|ی، |۔ ک|ا پ|ن ا|لک |علا|ا م|ق ک|ائی|وسر|ی ہ|وئی|یر |ا ہ|علی|و گ|وری|دگی|ندگ|و ک|یسے| من|ائد|رائ| مر|پور| طر|ومی|ے خ|سب |نون|انو|قان| سک|وام|ین | رک|تعل|لاق|غیر|دان|، ا| بی| مس|یوں|نا | بھ| بر|رتی|ادا|امل|یہ | یہ|ہ و| عا|ی پ| بچ|اف |لاف| خل|ی۔ |گی۔| دی|ھی |بھی|دہ |جا |پنی|قوا|اقو|رکھ|ے ی| عل|کوئ|، م| چا|ے س|ر ع| پی|برا|ر س|ر ح|سان|م ا|کام|شرت| را|شام|من |زند| زن|ب ک|ت م|اہ |اری|س م|ر ج| مح|ورا|ے پ|طری|ہوں|ال |ں س|ی ن|کرے| مق|ت س|تحف| تح|و۔ |ہو۔|بند| اق|د ہ| ام|امی|الا|لت |شرے|ے ع|ا ک|فری",
    pes: " و | حق| با|ند |رد |دار| دا|که |هر | در| که|در | هر|ر ک|حق |د ه|از |یت | از|یا |کس |ود |ارد| یا| کس|ای |د و| بر| خو|ق د|باش|شد |د ک|ار |د ب| را|ه ب|ان |آزا| آز|را |اشد|ی و|ه ا|ین |ید |زاد|س ح|خود|ی ب| اس|ده |دی |ور |اید|ه د|ری |و ا|تما|ات | نم|ی ک|ادی|نه |رای|د ا| آن|است|ر ا|ر م| اج|مای|ون |قوق|حقو|و م| ان|انه| هم|وق |ایت| شو|ی ا| مو| بی|با | تا|ورد|انو|ست |وان|برا|ام |شود|آن |جتم|ی ی| کن|ر ب|کند| مر|ت م|های|ت ا| مس|ی، |ماع|اجت|توا|یگر|و ب|دان|ت و|ا م| بد|عی |کار| من|مور| مق|ی د| زن|ی م|ن ب|ر خ|اه |ا ب|اری|د آ|مل | به|اعی|د، |دیگ|ت ب|بای|این| می|ن و|ق م| عم| کا|ن ا|و آ| حم|نون|ه و|و د|د ش| ای|شور|کشو| کش|لی |نی |ه م|بعی|ر ش|یه | مل|میت|ی ر|رند| شر|می |وی |ساو|قان| قا|مقا|او | او|د م|گی |نمی| اح| مح|مین|ئی |ادا| آم|خوا|گرد| گر|مند| شد|ائی| دی|ز ح|هیچ| هی|اده| مت|نما|ت ک|ران| بم|ن ح|ر ت|حما|ارن|مسا|دگی|ومی|ن ت|ملل|بر |هد |واه|بهر| اع|‌ها|ق و|، ا|عیت|یتو|ا ر|ن م| عق|همه|ا ه|زش |وزش|موز|آمو|انت|تی |جام|موم|عمو|تخا| فر|طور|د د|ه ح|ردا|اوی|نوا|انی|رار| مج|ی ن|حدی|احد|ندگ|زند|شخص| شخ|‌من|ه‌م|ره‌|هره|شده|ع ا|و ه|اسی|هٔ |یده|عقی|ا ا|مه | بش|اد |دیه|ا د|دوا|ی ح|ابع|ی ت|خاب|نتخ|رور|و ر|شرا| خا|ٔمی|أم|تأ|اً |امل|له |د ر|اسا|خور|بل |ابل|قاب|یک |سان|قرا|ا ن|خصی| ام| بو|یر |الم|بین|اهد|تبع| تب",
    zlm: " دا|ان |دان| بر| او|ن س|رڠ |دال| ڤر|له |كن | كڤ|ن ا|ن ك|ن د|يڠ | يڠ|ڤد |حق |ورڠ|تيا|ياڤ|ارا|كڤد|اور|رحق|برح|اله|أن |ولي| ات|اتا|ڠن |تاو|اڤ |ستي|ليه|او | ست|ڤ ا|يه |را |ه ب|ه د|عدا| عد|ن ڤ|ن ب|ين | تر|ق ك|ن ي|يبس|بيب| تي| سو| كب| سا|ن م|ن ت|لم |الم|د س|ڠ ع| من|چار|د ڤ|رن |سام| ما|ڽ س|ن، | بو| اي|ندق| حق|ڬار|نڬا|بول|سبا| سب|اتو|ا س|قله| ڤم| مم|وان|سچا| سچ| كس|ا ب|سن | سم|ڤرل|اون|نڽ |تن | با|هن |سيا|ا ڤ|ارڠ|بار|ڤا |بسن|كبي|ام |يند|ي د|اڬي|ڠ ب|باڬ|ي ا|مان| لا| د |دقل|هند| هن|ت د|ادي|وين|يكن| نڬ|، ك|ن٢ | ڤو|بڠس|ق٢ |ات |اول|اكن|اڽ | سس|ون |اد | كو|اين|دڠن| دڠ|ائن|تو |تي |ن ه|ڬي |سي |ق م|وڠن|دوڠ|ندو|لين|رلي|نتو|ڤون|وات|ياد|تيك|ڠسا|ڤمب|ترم|٢ د|حق٢|وا |لوا|ماس|وق |ه م|ل د| مل|وند| ڤڠ|ا، |، ت|لائ|اي |مڤو|يك |ي ك|رات|مرا| بي|سمو|و ك|، د|سوا|ڠ م|ڠ س|ڠ٢ |ڤري|يري|دير|ا ا|اسا|ڤ٢ |تا |سوس|، س|جوا|ڠ ت|رأن| ان|سأن|ريك|يأن|ري | در|امر|كرج| ڤل|ا د|جرن|اجر|ارك|لاج|د ك|وار|برس|ونت|منو|سال|ينڠ|دڠ٢|ندڠ| مڠ|اڤا|سسي|ساس|نن |ڤول|اڬا| بڠ| سڤ|مبي| اڤ|ڠ ا|ارأ|ڤرا|ي س|بس | دل|ا م|موا|ڤلا|ملا|ڤرك|كور|وبو| كأ|وكن|أنڽ|كسا|ڠڬو|ادڤ|هاد|رها|تره|كوم|توق|م س|ڠ د|دي | دي|٢ س|ندي|اس |ادا|بوا| دب|ڠ ڤ|ڽ، |اڤ٢|رتا|ال |يال|وسي| كت|أن،|نڤا|تنڤ| تن|م ڤ|رسا|ممڤ| مر|ن ح| كم|نسي|جأن|ؤي |لؤي|الؤ|لال|كڤر|كت |ركت|شار|مشا| مش|جاد|رڬا",
    skr: "تے |اں |دی |دے | ۔ |وں | تے| دا| کو|کوں| حق|دا | دی|یاں| دے|یں |ے ا|شخص| شخ|ہر |ے ۔|اصل| حا|حق |خص | ہر|صل |حاص|ہے | ہے|ال |ق ح|ل ہ| نا| کی| وچ|۔ ہ|یا |سی |ے م| او|وچ |اتے|کیت|ا ح|ادی|نال|ص ک| ات|ر ش|ہیں| یا|ں د| ای|یسی| مل|وند|کہی| کہ|ی ت|زاد|ازا| از|ندے|ں ک|ار | وی|ے ک|ئے | ان|ڻ د|نہ | کر|اون|ے و|دیا|ی د|ں ا|ے ب|ویس|وڻ |ی ن| ہو|تی |ی ۔| نہ|ی ا|یند|و ڄ|آپڻ| آپ|ا و|ے ج| کن|ے ن|ندی|ت د|ے ح|ی ک|ئی |ملک|یتے|ن ۔|تھی| تھ|ون |ں م| بچ|۔ ا|نوں|کنو|ڻے |اری|ا ا|ے ہ|ل ت| ڄئ|وق |قوق|حقو|ل ک|خلا| جی|لک |دار|یت |کرڻ|انہ|کو |ہکو| ہک|ن ا|مل | وس|ں و|پڻے| تع|ی م|اف |ے خ|نون|قنو| قن| لو|۔ ک|ری |لے |تا |یتا| قو| چا|ہاں|ڄئے|ق ت|ایہ|رڻ |ے د|ر ک| و |لاف| خل| جو|ی و|او |ہو |ئو |چئو|بچئ|یر |ہوو|ا م|ی ج|الا|ین | جا|می |نہا|ان |ات |سڱد| سڱ|یب |سیب|وسی| شا|ب د|یوڻ|ام |اوڻ|ے ت|ڻ ک| مط|ں ت| ون| کم|ن د|رکھ| رک|ڻی |ں آ|ریا|ی ہ|اد |یاد|علا|ر ہ|ں س|ی ح|جھی|ائد|ہی |لوک| ڋو| سم| سا| من| مع|بق |ابق|طاب|مطا|ھیو|ں ف|ہن | ہن|جو |و ک|ں ش|ر ت|کار|م د|ھیا| ٻا|غیر|و ل|وئی|جیا|وام|قوا|ی س| جھ|ل ا|قوم| سی|ذہب|مذہ| مذ|اے | اے|دن |ا ت|سان|نسا|انس|رے |لیم|علی|تعل|امل|ہ د|ے ر|د ا|کم |یہو|فائ|چ ا| کھ|م ت|را |ورا|پور|ں ب|ق د|ے ق|وکو|کھی|ا ک|و د|ے ذ|پڻی|بند| فر|کوئ|امی|ی ی|ائی|لاق|ایں|ہ ا| نظ|سما|ومی|ی، |ے س|ت و|ھین|ے ع|یم |سہو| سہ",
    pbu: " د | او|او |په | په|ي۔ | حق|چې | چې|ره |ي ا|ې د| هر|نه |هر |حق | څو|وک |څوک|و ا|ه د|ه ا|۔ ه|ه و| شي| لر|ي چ|و د|ري |لري|ق ل| کښ|وي |ښې |کښې|ه ک|غه |لو |ر څ|سره| سر|ه پ| ټو|و پ|له |يت |ټول|يا |کړي| کو|خه |ي، |دي | له| از|د م| هي| وا| يا| څخ|ازا|د ا|ولو|ه ت|څخه| کړ|ول |هغه|ه ش|ي د| هغ|کول|زاد|نو | وي|و ي|ه ب|شي۔|دې |يو | دي|ته |خپل| پر|اد |د د|ک ح| تو|ه م|ګه |ه ه|قوق|حقو|و م|ه ح|د ه| تر| مس|شي | نه|ړي۔|ني |د پ|واد|ې پ|ادي|ولن| يو|د ت|ونو|وګه|ي و|لي | دا|يد | با|تون| خپ|ي پ|توګ|ار |اند|يوا|ې و|دان| بر|ړي | عم|انه| ده|يڅ |هيڅ|امي|لني|بعي|ډول| ډو|ه ل|ايد|باي|اتو|ه ګ| تا|پل | مل|ايت|وم |ون | لا|هيو| شو| دغ|م د|ده |ې ا|ان | ته|کار|تو |مي |اره|اوي|ساو|مسا|نون|دهغ|و ت|ي ش|انو| مح|ين |اخل| ګټ|شوي|دغه|و ح|وي،|نيز|سي |اسي|وند|قو |وقو|و ک|ونه|ومي| وک|ي ت| ان|قان|ندې|و ر|ک د|ه ي|مين|پر |ټه |لام|غو |هغو|د ټ|و ه|ل ت|لے |ولے|وون|کي |رو |ن ک|موم|وکړ|پار|ن ش|من | نو| وړ| قا|ې چ| وس|څ څ|شخص| شخ|ژون| ژو|تر |ګټه|و څ|هم |عقي|رته| ور|بل | بل|و ب|ه س|ښوو| ښو| کا|ې ک|و س|اده|ونک| غو|دو |و ن|ت ک|مل |عمو|ل ه| پي|وسي|ړان|وړا|يز |خصي|ي م|ا ب|ادا|ه ن|خلي|واخ|ديو|، د|د ق| هم|ا د| بي|تبع| تب|ه چ| عق|پلو|و ل| را|د ب|راي| دخ|نې |نکي|ت د|ابع| مق|د خ|وره|شرا| شر|ر م|رسر|تام|ه ټ| من|طه |سطه|اسط|واس|لې | اس|۔ د|برخ|ې ن"
  },
  Devanagari: {
    hin: "के |प्र| प्| का| के| । |और | और|का | को|कार|ार |ति |या |को |ने |ों |िका|्रत| है| कि|ं क|है |धिक|व्य|अधि| अध|्ति| सम|्यक|ि क|क्त|ा अ|की |ा क| व्|ें | हो|यक्|सी |से |े क| या| की|में|न्त| मे|त्य|ै ।|ता |रत्|क्ष|ेक |येक|्ये|िक |र ह|भी |किस| जा| स्|क व|ा ज|िसी|मान| वि|र स|त्र|ी स|। प| कर|्रा|गा |ित | अप| पर|स्व|ी क| से|ा स|्य | अन|्त्|िया|ा ह| सा|ना |्त |प्त|समा|ान |र क|ाप्|तन्| भी| उस|राप|वतन|्वत|रों|वार|े स|था |हो |े अ|ा ।|न क| न |देश| रा|षा |अन्|त ह|्षा|्वा|जाए|ी प|करन|ा प|अपन|ष्ट| सं|े व|होग|िवा|ट्र|्ट्|ाष्|राष|सके| मा|ओं |ाओं|री |क स|े प| नि|ीय |रक्|ो स|ाएग|रने| इस|व क|पर |रता|र अ| सभ|तथा| तथ| ऐस|रा |पने|्री|िक्|किय|ा व|माज|ं औ|र उ|द्ध|सभी|श्य| जि|ाने|ार्|ारा|द्व| द्|एगा|सम्|ेश |िए |ाव |र प| दे|्तर|ा औ|ारो|यों|परा|पूर|चित|्ध |रूप| रू| सु| लि|त क|ो प|ं स|े ल|शिक| शि|वाह|े औ|जो |राध|जिस|ूर्|ी भ|ूप |ोगा|स्थ|रीय|तिक|्र |। इ|इस | उन|ले |े म|लिए|म क|कता|े य| जो|न म|अपर| पू|ो क|ा उ|ाह |नून|ानू|गी |दी |ारी|ं म|। क|तर्|ी र|श क|परि|स्त|ोई |कोई|र्य|ी अ|हित|भाव| भा|ताओ|ास |साम|विक|विव|म्म| सक|कर |ाना|ध क|निक|य क|उसक|कृत| क़ा|न स|जीव|्या|रका|्रक|ाज |न्य|्म |र्ण|क़ ह|हक़ | हक़|ी म|जिक|ाजि|ामा|क औ|मिल|ेने|लेन| ले|ये |ो अ|े ज|रिव|मय |समय|वश्|आवश| आव|ऐसी|ाध |र द|र्व|सार|प स|बन्| सह|िधा|विध|ी न|ून |क़ान",
    mar: "्या|या |त्य|याच|चा |ण्य|ाचा| व |कार|प्र| प्|िका|धिक|ार | अध|अधि|च्य|आहे| आह|ा अ|हे |ा क|ास |वा |्ये|्रत| स्|ता |ा स| अस| कर|स्व| का|ल्य|रत्|ाहि|कोण| को|िक |येक|्वा|ा व| त्|र आ|्य |त्र|ेका|क्ष|ा न| सं|ामा|ाच्|ंवा|िंव|किं| कि|ात |ष्ट|कास| या|यां|ांच|र्य|मिळ| मि| सा|व्य|ोणत|ने |े प|काम| सम|ंत्|ये | रा|समा|तंत|करण|ा आ|े क|हि |े स|ना |िळण|ून |ा प|ट्र|्ट्|ाष्|राष|ीय |व स|क्त|मान|र्व| आप|ळण्|्र्|ातं|वात|चे | वि|्षण|रण्| दे| व्|आपल|ही |ार्|नये| नय|मा |यास| जा|लेल| नि|े अ| पा|ा म|ले |ाही|बंध|े व|्यक| मा|शिक| शि|देश|ा द|माज|्री|ली |ान |ांन|पल्| हो|ा ह|षण |जे |िजे|हिज|पाह|ारा|यात|सर्| सर|रां|असल|ंबं|संब|िक्|ी प|ंच्|रक्|णत्| आण|ला |स्थ|रीय|ीत |ंना|त व|्व |क व|णे |ाचे|न क|त क|रता|्रा|याह|्त |ची |य क|द्ध|्वत|यक्|णि |आणि|स स|ंधा|क स|च्छ|य अ|त स|ीने|ोणा|करत|त्व|ील |ी अ|सार|र व|भाव|व त|थवा|अथव| अथ|े त|े ज|याय|ंचा|ेल्|ाने|ेण्|क आ|क्क|हक्| हक|ण म|ंरक|संर|न्य|ायद|ा त|त आ| उप|वस्|िवा|ेशा|साम|े य|े आ|ी व|व म|तीन|व आ|ध्य| अश|धात|कृत|्क |द्य|ित |सले|ेश |तो |ेल |ती |्ती|असे|इतर| इत|स्त|र्ण|ा ब|ेले| के|हीर|जाह|ा ज|ेत |ूर्|पूर|ेच | वा|ाजा|ी स|शा |य व| न्|याव|द्द|्ध |रून|यद्|काय|ा श|गण्|क क|राध| शा|यत्|ल अ|्यव|ी क|ाव |ा य|त्त|जिक|ाजि|रणा| धर|ा ध|भेद| बा|रका|्रक|केल|ि व|िष्|तील|योग|साध|ांत|विव|श्र| धे| मु|वतः",
    mai: "ाक |प्र|कार| प्|ार |िका|्यक|धिक|क अ|्रत|्ति|व्य| अध|ेँ |अधि|िक | व्|आʼ | आʼ|क्त|यक्|तिक|केँ|क व|बाक|क स|छैक| छै|त्य|मे |ेक | सम|क्ष|हि |रत्|र छ|येक|्ये|न्त|वा |िके|क। |ैक।|। प| अप| स्| वि| जा|ित |सँ | हो|कोन| को|त्र|स्व| वा|क आ|ष्ट| कर|अपन|मान| का| अन|ति |्त्|नो |नहि| पर|ट्र|्य | एह|ि क|्ट्|ाष्|राष| रा|समा|ोनो|ल ज| नह|ताक|ार्|पन |तन्|वतन|्वत|्षा| कए| सा|्री| नि|ा आ|िवा| सं| दे|जाए|ीय |करब|था |एबा|ा प|ना |्वा|देश|त। |रक |क ह|ँ अ| सभ| आ |त क|चित|्त |वार|ता |ारक|माज|ा स|रीय|न्य|रता|ान |्रा|्या|रक्|ारण|परि|एल |कएल|अन्|रबा|क प|ओर |आओर| आओ|अछि| अछ|िर्|ान्|नक |होए|कर |धार|स्थ|ा अ|िमे|र आ|एहि| एक|े स|तथा| तथ| मा|िक्|शिक| शि|प्त|र्व|निर|च्छ|र्य|ँ स|क क|हो |ाहि|एत।|र प|ामा|साम|षा |ʼ स|ँ ए|ैक |द्ध|र अ|क ज|स्त|ाप्|ँ क| सक|यक |कान|हन |एहन|ेल |ोएत|त आ|ा व|। क|्तर|ाएत|्रक|हु |क उ|पूर|विव|ʼ अ|छि | ले|न प|ास |राप|धक |पएब| पए|रा |यता|रूप|न व| के|षाक|य प|त ह|जाह| ओ |भाव|पर |थवा|अथव| अथ|सम्|जिक|ाजि|ूर्|रति| दो|सभक|। स| जन|सभ |बाध|अनु|िसँ| सह|ँ व|ए स|रिव|तु |ेतु|हेत| हे|ाध |ेबा|न स|िष्|राध| अव|ित्|वास|चार| उच|ारा|न क|वक |ा क|नून|ानू|एत |री |ेओ |केओ|रण |्रस|ि द|ओ व| भे|नहु|ोनह|्थि|पत्|म्प|राज| भा|हिम| हक|ामे|्ण |र्ण|हार|ि स|क द|न अ|त अ|लेब| अभ|िश्|जक |ाजक|न आ|वाह|काज|श्य|वस्|ओहि| ओह|योग|। ए|कए |े ओ|अपर",
    bho: " के|के |े क|ार |कार|िका|धिक|अधि| अध|ओर |आओर| आओ|े अ|े स|ा क| सं|िक |र ह|ा स| हो|र स|ें |में| मे| कर| से|नो |क्ष|से | का|। स|खे |ा। |रा | सम| सब|्रा| सक|र क|न क|वे |ौनो|कौन| कौ|चाह| चा| बा|प्र| प्|था |ि क|ति | जा| सा|े आ|पन |करे|ता |होख|त क|े। |े ब|तथा| तथ| आप|केल|सके| स्|रे |सबह|कर |आपन|े ओ|जा | पर|ष्ट| रा|ना |हवे| हव|ला |ेला|बहि| ओक|ोखे|र ब|ह। | ह।|न स|ाष्|राष|्त | और|े च|। क|संग|र आ|ट्र|्ट्|षा |मान|ा आ|ं क|ा प|्षा|रक्|हे |ाहे|ाति|ावे| जे|ही |ओकर|मिल|ित |ो स|ल ज|इखे|नइख| नइ|त्र|माज| बि|वे।|े ज|क स|िं |हिं|करा|और |े म|समा|हु | ओ |पर |े न|स्थ|रीय|्री|ला।|ाज |ान |कान|े त|िर |तिर|खात| खा|े उ|नून|ानू|ाम | सु| दे|ी क| मा|र म|प्त|िया|ाही|बा।|योग|ी स|ल ह|ून |व्य|ु क|ए क|े व|ंत्|स्व|केह|ीय |खल |साम|यता|तिक|े ह|ाप्|राप|र प|र अ| लो| सह|जे |ोग |म क|ले | नि|ेकर|ा ह|पूर|र न|ेहु|्य |या | या|देश|दी |ा म|ाव | दो|े द| पा|हि |िक्|शिक| शि|बा |िल | उप|्रत| वि| ही| ले|रो |े ख|ठन |गठन|ंगठ| मि|षण |्षण|ंरक|संर| आद| एक|ने | अप|तंत|वतं|्वत|्तर|्या|ेश |ादी|्ति|जिक|ाजि|क आ|्म |चार| उच| शा|री |ाह |याह|बिय|चित|क्त|पयो|उपय|रता|र व|न म|लोग|ह क|न प|काम| पू| इ |आदि|ईल | कई| व्|मी |ुरक|सुर| जी|धार|य स|तर्|भे |सभे| सभ|भाव|्थि|ामा|सर |र्म| को| बे|ोसर|दोस|ण क|ास |े प|जाद|आजा| आज|उचि|ग क|ारी| जर|गे |ज क|ी ब|सन |हो |ा त",
    npi: "को |ने | र |ार |क्त|कार|प्र| प्|्यक|व्य| गर|िका| व्|्रत|धिक|्ति|यक्|अधि| अध|ाई |मा |लाई|त्य|िक | । | सम|वा | वा|क व|्ने|र्न|गर्|न्त|छ ।|तिल|रत्|त्र|ेक |येक|्ये|िला|र स|ो स| स्|मान|क्ष| वि|हुन|ा स| हु| छ |र छ|्त्|समा|स्व|। प| सं|नेछ|ुने|हरु|तन्|वतन|े अ|िने|ो अ|्वत| का|े छ|गरि| रा|्र |ति |ाको| कु|ष्ट|ना |स्त|क स|ुनै|कुन|ट्र|ले | नि|ान |छैन| छै|्ट्|ाष्|राष|तिक|छ। |ार्|ता |ित |नै |ा अ| सा|ा व|रु | मा| अन|ा र|रता|र र|हरू|ेछ |ा प|रक्|्त | पर|था | ला|परि|देश|सको| यस|माज|ामा|्रा|िवा|ाहर|ो प|्य |वार|न स|। क|नि |्षा| त्|द्ध|र ह|तथा| तथ|यस्|्यस|री |र व|पनि|रिन|ंरक|संर|भाव|ै व|सबै| सब| शि| सह|ताक|े र|त र|लाग| सु|्षण|द्द| अप|ैन |ो व|िक्|ाव |धार|्या|्रि|ा भ|एको|र म|न अ|ो ल| उस|शिक|ात्|स्थ|वाह|ूर्|श्य|ित्|रको|ारक|ुद्|तो |्तो|ाउन|कान|िएक|ा न| पन|न। |ैन।|का |ेछ।| भे|र्य|सम्|त्प|साम|रिय|चार|निज|ुन |गि |ागि|उसक| मत| अभ|पूर|र त| सक|सार|राध|परा|अपर|ुक्|जको| उप|रा |ारा|्वा|विध|्न |ा त|न ग|णको| पा| दि|क र|र प|अन्|भेद|ारम|ो आ| अर|जिक|ाजि|िय |षा |ाट |बाट| बा|ि र| छ।|त्व|त स|रू |छ र|रका|विक|र उ|ोग |्दे|रिव|सकि|ै प|रति|अनु| आव|युक|ा ग|नमा|योग|ग ग|क अ|द्व|्ध |रुद| बि|। स|उने|ान्|ा म|िको|र्द|ारी|्तर|ो ह|हित| दे|रिक|ा क| आध|राज|र्म|्ण |र्ण|ि व|्यव|विच|बै |सहि|रोज|र्स|ई उ|्प |रात|निक|मिक|च्छ|्था|विव|कता|अभि|्धा",
    mag: " के|के |ार | हई|कार|ई। |हई।|िका|े अ|धिक|अधि| अध|र ह|े क|और | और|ा क|े स|सब | सब| कर|ें |था |में| मे|तथा| तथ|िक | हो| सम|क्ष|ना |ब क|र स| सं|ा स|कर | भी|। स| सा| से| का| अप|्रा|प्र| प्|से |भी | को|त क| पर|रा |क ह|पन |अपन| सक|या |ति |र क|ी क| या|करे| जा|रे | ओक|्त |सक |नो |ान |मान|ओकर|ा प|न क|ेल | ना|। क|रक्| स्|ही |होए| एक|पर |दी |ट्र|ता |व्य|हई | शा|े उ| दे|त्र|ादी| रा| ही|कान|ित |म क|ल ज|ाम |ी स|े भ|न स|माज|ष्ट|षा | ले|क स|बे |वे |ावे|मिल|र म|्य |ा ह|ला |प्त|नून|ानू|जा |ेकर|्षा|्रत|ंत्|र औ|ोई |कोई|्ट्|ाष्|राष| मा|रो | जे|करा|ोए |ाप्|राप|समा|ून |ो स|स्व|्ति|साम|ोनो|कोन| व्|र अ|्म | वि| सह|े म|क्त|योग|र व|काम|ल ह| नि|देश|पूर|वार| इ |ंरक|संर|ए क|र प| सु|तंत|वतं|्वत|ा म|व क|े व|ाथ |साथ| दो|होब| पा|ो क|े ब|ोग | उप|स्त|परि|न प|े त|्तर|लेल|े ओ|चाह| चा|य क|वा |ेश |य स|न ह|षण |ा ब|। त|एक |एल |ीय |केक|े ह|र आ|ि क|स्थ|जिक|ाजि|ामा|रीय|्री|तिक|ाति| बि|चार|े आ|ास | उच|ा त|यक्|्यक|िल |मय |समय|शाद|पयो|उपय|े ख|रिव| पू|े ल|े च|ौनो|कौन| कौ|ं क|संग|न द|ं स|ण प|्षण|र न|े न|ो भ|करो|ा औ|रता|ाव |भाव|क औ|र्म|ोसर|दोस|ण क|े प|न औ|ब ह|िक्|शिक| शि|ाबे|निय|चित|उचि|ित्|ग क|े। |त स|ी श|ं श|एकर|। ए|तन | ओ |री |्र |जे |क क| सी|सन |िवा| अन|ूरा| बच|ए। | बे|त ह| तक| मि|धार|थवा|अथव| अथ|िला|्वा|ि म| आद|ने |कएल| कए|्या"
  }
}, mc = 2048, pc = 10, Ds = 300, Rn = {}.hasOwnProperty;
let Oa;
const On = {};
for (Oa in li)
  if (Rn.call(li, Oa)) {
    const t = li[Oa];
    let e;
    On[Oa] = {};
    for (e in t)
      if (Rn.call(t, e)) {
        const a = t[e].split("|"), n = {};
        let i = a.length;
        for (; i--; )
          n[a[i]] = i;
        On[Oa][e] = n;
      }
  }
function Ei(t, e = {}) {
  const a = [...e.whitelist || [], ...e.only || []], n = [...e.blacklist || [], ...e.ignore || []], i = e.minLength !== null && e.minLength !== void 0 ? e.minLength : pc;
  if (!t || t.length < i)
    return Ti();
  t = t.slice(0, mc);
  const o = gc(t, dc);
  return !o[0] || !(o[0] in On) ? !o[0] || o[1] === 0 || !Bs(o[0], a, n) ? Ti() : Rs(o[0]) : hc(
    t,
    yc(uc(t), On[o[0]], a, n)
  );
}
function hc(t, e) {
  const a = e[0][1], n = t.length * Ds - a;
  let i = -1;
  for (; ++i < e.length; )
    e[i][1] = 1 - (e[i][1] - a) / n || 0;
  return e;
}
function gc(t, e) {
  let a = -1, n, i;
  for (i in e)
    if (Rn.call(e, i)) {
      const o = bc(t, e[i]);
      o > a && (a = o, n = i);
    }
  return [n, a];
}
function bc(t, e) {
  const a = t.match(e);
  return (a ? a.length : 0) / t.length || 0;
}
function yc(t, e, a, n) {
  e = kc(e, a, n);
  const i = [];
  let o;
  if (e)
    for (o in e)
      Rn.call(e, o) && i.push([o, vc(t, e[o])]);
  return i.length === 0 ? Ti() : i.sort(wc);
}
function vc(t, e) {
  let a = 0, n = -1;
  for (; ++n < t.length; ) {
    const i = t[n];
    let o = Ds;
    i[0] in e && (o = i[1] - e[i[0]] - 1, o < 0 && (o = -o)), a += o;
  }
  return a;
}
function kc(t, e, a) {
  if (e.length === 0 && a.length === 0)
    return t;
  const n = {};
  let i;
  for (i in t)
    Bs(i, e, a) && (n[i] = t[i]);
  return n;
}
function Bs(t, e, a) {
  return e.length === 0 && a.length === 0 ? !0 : (e.length === 0 || e.includes(t)) && !a.includes(t);
}
function Ti() {
  return Rs("und");
}
function Rs(t) {
  return [[t, 1]];
}
function wc(t, e) {
  return t[1] - e[1];
}
const xc = (t) => ({
  deu: "de",
  // German
  eng: "en",
  // English
  spa: "es",
  // Spanish
  cat: "es",
  // Catalan -> Spanish
  por: "es",
  // Portuguese -> Spanish
  fra: "en",
  // French -> English
  ita: "en",
  // Italian -> English
  nld: "en"
  // Dutch -> English
})[t] || "de", _c = (t) => {
  if (!t || t.trim().length < 10)
    return "de";
  const e = Ei(t);
  if (e.length > 0) {
    const [a, n] = e[0];
    if (n > 0.8 && t.trim().length > 10)
      return xc(a);
  }
  return "de";
}, Os = (t = "", e = 14, a = !1) => {
  const [n, i] = vt(t);
  return kt(() => {
    (async () => {
      if (t) {
        let s = null, r = null;
        if (s = _c(t), a) {
          const l = Ei(t);
          l.length > 0 && (r = l[0][1]);
        }
        let c = t;
        try {
          switch (s) {
            case "de":
              c = await qo.hyphenate(t, {
                minWordLength: e
              });
              break;
            case "en":
              c = await J0.hyphenate(t, {
                minWordLength: e
              });
              break;
            case "es":
              c = await Q0.hyphenate(t, {
                minWordLength: e
              });
              break;
            default:
              c = await qo.hyphenate(t, {
                minWordLength: e
              });
          }
        } catch (l) {
          console.warn(`Hyphenation failed for language ${s}:`, l), c = t;
        }
        a && console.log("Language detection:", {
          detected: s,
          confidence: r,
          francResults: Ei(t).slice(0, 3)
        }), i(c);
      }
    })();
  }, [t, e, a]), n;
}, Fc = ({
  header: t,
  title: e,
  textColor: a,
  blobColor: n,
  headerSize: i,
  fontFamily: o,
  orientation: s,
  isPrintView: r
}) => {
  const c = Os(e, 10), l = X0(s), {
    size: f,
    boxMargins: m
  } = K0(s), v = r ? L0(e == null ? void 0 : e.length, s) : void 0, k = ws(e);
  return /* @__PURE__ */ h.jsxs(q0, { orientation: s, children: [
    /* @__PURE__ */ h.jsxs(W0, { headerLength: t == null ? void 0 : t.length, headerHeight: l, color: a, size: f, boxMargins: m, children: [
      t && /* @__PURE__ */ h.jsx(Cs, { headerSize: i, headerHeight: l, fontFamily: o, children: t }),
      /* @__PURE__ */ h.jsx(Es, { children: /* @__PURE__ */ h.jsx(Kn, { as: zs, mode: k, minFontSizePx: v, maxFontSizePx: v, fontFamily: o, children: c }) })
    ] }),
    /* @__PURE__ */ h.jsx(O0, { blobColor: n, orientation: s })
  ] });
}, Cc = q.svg.withConfig({
  displayName: "VerticalLayout",
  componentId: "sc-1qmco8l-0"
})(["width:100%;border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;height:auto;position:absolute;bottom:0;left:0;z-index:8;"]), Wo = q.svg.withConfig({
  displayName: "HorizontalLayout",
  componentId: "sc-1qmco8l-1"
})(["height:100%;border-top-right-radius:inherit;border-bottom-right-radius:inherit;width:auto;position:absolute;bottom:0;left:0;z-index:8;"]), zc = ({
  waveColor: t,
  orientation: e
}) => e === "portrait" ? /* @__PURE__ */ h.jsx(Wo, { width: "137", height: "250", viewBox: "0 0 137 250", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx("path", { d: "M105.213 52.9603C128.972 -6.79549 70.4075 -53.1324 58.666 -62.1482L-145.904 -62.1482L-161 275.629L128.972 275.629C133.585 256.13 149.504 224.679 113.247 183.794C83.6838 150.456 79.5657 117.462 105.213 52.9603Z", fill: t }) }) : e === "landscape" ? /* @__PURE__ */ h.jsx(Wo, { width: "143", height: "180", viewBox: "0 0 143 180", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx("path", { d: "M115.03 42.0577C136.096 -10.9231 84.171 -52.0064 73.7608 -60L-107.616 -60L-121 239.481L136.096 239.481C140.186 222.192 154.3 194.308 122.154 158.058C95.9421 128.5 92.2909 99.2464 115.03 42.0577Z", fill: t }) }) : /* @__PURE__ */ h.jsx(Cc, { xmlns: "http://www.w3.org/2000/svg", width: "252", height: "193", viewBox: "0 0 252 193", fill: "none", children: /* @__PURE__ */ h.jsx("path", { d: "M84.0577 27.7027C31.0769 6.63672 -10.0064 58.5616 -18 68.9719V250.348L281.481 263.733V6.63672C264.192 2.54697 236.308 -11.5672 200.058 20.579C170.5 46.7905 141.246 50.4417 84.0577 27.7027Z", fill: t }) }), Ec = q.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-iqu8jy-0"
})(["position:relative;overflow:hidden;width:100%;height:100%;flex-shrink:0;z-index:1;"]), Tc = q.div.withConfig({
  displayName: "Container",
  componentId: "sc-iqu8jy-1"
})(["position:relative;width:100%;height:100%;border-radius:inherit;z-index:0;display:flex;flex-direction:column;justify-content:center;align-items:center;"]), jc = q.div.withConfig({
  displayName: "Header",
  componentId: "sc-iqu8jy-2"
})(["position:absolute;top:0;left:0;z-index:8 !important;width:100%;height:200px;background:linear-gradient(180deg,rgba(0,0,0,0.4) 0%,rgba(0,0,0,0) 100%);"]);
u.object({
  orientation: u.enum(["portrait", "vertical", "landscape"]).optional(),
  backgroundImage: u.string().url(),
  text: u.string().optional(),
  secondaryText: u.string().default("Bist du bereit?").optional(),
  headerSize: u.number().default(3).optional(),
  titleSize: u.number().default(4).optional(),
  CTAText: u.string().optional(),
  CTASize: u.number().default(4).optional(),
  imageVertical: u.number().default(50).optional(),
  imageHorizontal: u.number().default(50).optional(),
  zoom: u.number().min(0.1).step(0.1).default(1).optional(),
  secondaryTextColor: W().optional(),
  primaryBackgroundColor: W().optional(),
  secondaryBackgroundColor: W().optional(),
  textColor: W().optional(),
  blobColor: W().optional(),
  waveColor: W().optional(),
  logo: u.string().url().optional(),
  logoFormat: u.enum(["square", "landscape"]).optional(),
  logoPosition: u.enum(["top-left", "top-right", "bottom-left", "bottom-right"]).optional(),
  logoSize: u.enum(["small", "mid", "big"]).optional(),
  width: u.number().default(400).optional(),
  isPrintView: u.boolean().default(!1).optional(),
  fontFamily: u.string().optional(),
  customFont: u.object({
    name: u.string(),
    url: u.string()
  }).optional()
});
const Ps = ({
  orientation: t = "portrait",
  imageVertical: e,
  imageHorizontal: a,
  backgroundImage: n,
  zoom: i,
  logo: o,
  text: s = "Wir suchen Dich",
  secondaryText: r = "Bist du bereit?",
  header: c,
  title: l,
  headerSize: f,
  CTAText: m = "Jetzt bewerben",
  CTASize: v,
  secondaryTextColor: k = "#198E93",
  primaryBackgroundColor: C = "#25414B",
  secondaryBackgroundColor: E = "#F8F8F8",
  textColor: b,
  waveColor: D,
  blobColor: j,
  logoFormat: x = "square",
  logoPosition: _,
  logoSize: y = "small",
  width: H,
  isPrintView: $ = !1,
  fontFamily: Y = "Rubik",
  customFont: ae,
  isVideo: ve = !1
}) => {
  const de = t || "portrait", N = b || k, P = D || C, M = j || E, V = c || r, be = l || s, Z = _ || (t === "vertical" ? "bottom-left" : "top-left"), {
    aspectRatio: oe,
    width: ke,
    height: we
  } = Ie[de], re = Math.round(H / oe), A = Wt(ke, we, H, re);
  qt(Y, ae);
  const w = (ae == null ? void 0 : ae.name) === Y, I = Lt(w ? null : Y), B = w ? Y : I;
  return /* @__PURE__ */ h.jsx(Yt, { originalWidth: ke, originalHeight: we, scaleFactor: A, children: /* @__PURE__ */ h.jsx(Tc, { children: /* @__PURE__ */ h.jsxs(Ec, { children: [
    /* @__PURE__ */ h.jsx(jc, {}),
    /* @__PURE__ */ h.jsx(la, { logo: o, logoPosition: Z, offset: 2, elementSize: y, logoFormat: x, orientation: de }),
    /* @__PURE__ */ h.jsx(xs, { src: n, orientation: de, imageVertical: e, imageHorizontal: a, zoom: i, isVideo: ve }),
    /* @__PURE__ */ h.jsx(Fc, { textColor: N, header: V, title: be, blobColor: M, headerSize: f, fontFamily: B, orientation: de, isPrintView: $ }),
    /* @__PURE__ */ h.jsx(eo, { blobColor: P, CTASize: v, CTAText: m, orientation: de }),
    /* @__PURE__ */ h.jsx(zc, { waveColor: P, orientation: de })
  ] }) }) });
}, Uc = (t) => t === "portrait" || t === "landscape" ? 64 : 38, Sc = (t) => t === "portrait" ? 560 : t === "landscape" ? 450 : 380, Yo = {
  portrait: [{
    max: 20,
    size: 126
  }, {
    max: 30,
    size: 116
  }, {
    max: 40,
    size: 102
  }, {
    max: 50,
    size: 90
  }, {
    max: 60,
    size: 80
  }, {
    max: 1 / 0,
    size: 65
  }],
  landscape: [{
    max: 20,
    size: 100
  }, {
    max: 30,
    size: 90
  }, {
    max: 40,
    size: 80
  }, {
    max: 50,
    size: 70
  }, {
    max: 60,
    size: 60
  }, {
    max: 1 / 0,
    size: 55
  }],
  vertical: [{
    max: 20,
    size: 75
  }, {
    max: 30,
    size: 70
  }, {
    max: 40,
    size: 58
  }, {
    max: 50,
    size: 46
  }, {
    max: 60,
    size: 40
  }, {
    max: 1 / 0,
    size: 36
  }]
}, Ac = (t = 30, e) => (Yo[e] || Yo.landscape).find(({
  max: i
}) => t < i).size, Ns = q.p.withConfig({
  displayName: "TextHeader",
  componentId: "sc-1h5ebm-0"
})(["opacity:0.7;font-weight:400;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:95%;flex-shrink:0;font-weight:400;line-height:normal;font-size:", ";font-family:", ',"Rubik",sans-serif;&&&{font-family:', ',"Rubik",sans-serif;}'], ({
  headerSize: t,
  headerHeight: e
}) => `${t || e}px`, ({
  fontFamily: t
}) => t, ({
  fontFamily: t
}) => t), ao = q.h1.withConfig({
  displayName: "Title",
  componentId: "sc-1h5ebm-1"
})(["line-height:1.2;font-weight:500;overflow-wrap:break-word;font-family:", ',"Rubik",sans-serif;&&&{font-family:', ',"Rubik",sans-serif;}'], ({
  fontFamily: t
}) => t, ({
  fontFamily: t
}) => t), Ms = q.div.withConfig({
  displayName: "TitleContainer",
  componentId: "sc-1h5ebm-2"
})(["width:100%;"]), wn = q.div.withConfig({
  displayName: "TextBox",
  componentId: "sc-1h5ebm-3"
})(["display:flex;flex-direction:column;z-index:6;text-align:left;height:", ";", ",", "{color:", ";margin:0;font-style:normal;}", "{height:", ";}"], ({
  boxHeight: t
}) => `${t}px`, ao, Ns, ({
  color: t
}) => t, Ms, ({
  headerHeight: t,
  boxHeight: e
}) => `${e - t}px`), Ic = q.div.withConfig({
  displayName: "TextPositioner",
  componentId: "sc-1h5ebm-4"
})(["position:absolute;z-index:4;display:flex;flex-direction:column;", ""], ({
  orientation: t
}) => t === "portrait" ? Se(["width:55%;top:600px;right:0;bottom:0;padding:0 50px 0 100px;", "{gap:30px;}"], wn) : t === "landscape" ? Se(["width:55%;top:400px;right:0;bottom:0;padding:0 150px 0 100px;", "{gap:35px;}"], wn) : Se(["width:540px;bottom:300px;padding:0;", "{gap:20px;}", "{line-height:1.2;}"], wn, ao)), Dc = ({
  header: t,
  title: e,
  textColor: a,
  headerSize: n,
  fontFamily: i,
  orientation: o,
  isPrintView: s
}) => {
  const r = Os(e), c = Uc(o), l = Sc(o), f = s ? Ac(e == null ? void 0 : e.length, o) : void 0, m = ws(e);
  return /* @__PURE__ */ h.jsx(Ic, { orientation: o, children: /* @__PURE__ */ h.jsxs(wn, { headerLength: t == null ? void 0 : t.length, headerHeight: c, orientation: o, color: a, boxHeight: l, children: [
    /* @__PURE__ */ h.jsx(Ns, { headerSize: n, headerHeight: c, fontFamily: i, children: t }),
    /* @__PURE__ */ h.jsx(Ms, { children: /* @__PURE__ */ h.jsx(Kn, { as: ao, mode: m, minFontSizePx: f, fontFamily: i, children: r }) })
  ] }) });
}, Bc = q.div.withConfig({
  displayName: "Container",
  componentId: "sc-1xwcg6r-0"
})(["position:relative;width:100%;height:100%;border-radius:inherit;z-index:0;display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:", ";"], ({
  backgroundColor: t
}) => t), Rc = q.div.withConfig({
  displayName: "ImgWrapper",
  componentId: "sc-u2peyg-0"
})(["position:absolute;overflow:hidden;height:100%;width:100%;z-index:2;", ";img{width:100%;height:100%;object-fit:cover;object-position:", ";transform:scale(", ");border-radius:inherit;}"], ({
  orientation: t
}) => Se(t === "landscape" ? ["bottom:0;left:0;width:45%;height:900px;border-top-right-radius:150px;"] : t === "portrait" ? ["bottom:0;left:0;width:45%;height:1760px;border-top-right-radius:150px;"] : ["width:70%;height:1130px;top:0;border-bottom-left-radius:96px;border-bottom-right-radius:96px;"]), ({
  imageHorizontal: t,
  imageVertical: e
}) => t && e ? `${t}% ${e}%` : "center", ({
  zoom: t
}) => t || 1.1), Oc = q(Vn).withConfig({
  displayName: "VideoRemotionPlayer",
  componentId: "sc-u2peyg-1"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:100%;object-fit:cover;"]), Pc = ({
  src: t,
  orientation: e,
  imageVertical: a,
  imageHorizontal: n,
  zoom: i,
  isVideo: o
}) => t ? /* @__PURE__ */ h.jsx(Rc, { orientation: e, imageVertical: a, imageHorizontal: n, zoom: i, children: o ? /* @__PURE__ */ h.jsx(Oc, { src: t, alt: "background video" }) : /* @__PURE__ */ h.jsx(pt, { src: t, alt: "background image" }) }) : null;
u.object({
  orientation: u.enum(["portrait", "vertical", "landscape"]).optional(),
  backgroundImage: u.string().url(),
  text: u.string().optional(),
  secondaryText: u.string().default("Bist du bereit?").optional(),
  headerSize: u.number().default(80).optional(),
  primaryTextColor: W().optional(),
  primaryBackgroundColor: W().optional(),
  titleColor: W().optional(),
  waveColor: W().optional(),
  CTAText: u.string().optional(),
  CTASize: u.number().default(4).optional(),
  imageVertical: u.number().default(50).optional(),
  imageHorizontal: u.number().default(50).optional(),
  zoom: u.number().min(0.1).step(0.1).max(2.5).default(1).optional(),
  logo: u.string().url().optional(),
  logoFormat: u.enum(["square", "landscape"]).optional(),
  logoPosition: u.enum(["top-left", "top-right", "bottom-left", "bottom-right"]).optional(),
  logoSize: u.enum(["small", "mid", "big"]).optional(),
  width: u.number().optional(),
  isPrintView: u.boolean().default(!1).optional(),
  fontFamily: u.string().optional(),
  customFont: u.object({
    name: u.string(),
    url: u.string()
  }).optional()
});
const Vs = ({
  orientation: t = "portrait",
  text: e = "Wir suchen Dich",
  secondaryText: a = "Bist du bereit?",
  headerSize: n,
  primaryTextColor: i = "#F8F8F8",
  primaryBackgroundColor: o = "#198E93",
  titleColor: s,
  waveColor: r,
  CTAText: c = "Jetzt bewerben",
  CTASize: l,
  imageVertical: f,
  imageHorizontal: m,
  backgroundImage: v,
  zoom: k,
  logo: C,
  logoFormat: E = "landscape",
  logoPosition: b,
  logoSize: D = "small",
  width: j,
  isPrintView: x = !1,
  fontFamily: _ = "Rubik",
  customFont: y,
  isVideo: H = !1
}) => {
  const $ = t || "portrait", Y = s || i, ae = r || o, ve = b || (t === "vertical" ? "bottom-left" : "top-right"), {
    aspectRatio: de,
    width: N,
    height: P
  } = Ie[$], M = Math.round(j / de), V = Wt(N, P, j, M);
  qt(_, y);
  const be = (y == null ? void 0 : y.name) === _, Z = Lt(be ? null : _), oe = be ? _ : Z, ke = /* @__PURE__ */ h.jsxs(Bc, { backgroundColor: ae, children: [
    /* @__PURE__ */ h.jsx(la, { logo: C, logoPosition: ve, offset: 2, elementSize: D, logoFormat: E, orientation: $ }),
    /* @__PURE__ */ h.jsx(Pc, { src: v, orientation: $, imageVertical: f, imageHorizontal: m, zoom: k, isVideo: H }),
    /* @__PURE__ */ h.jsx(Dc, { textColor: Y, header: a, title: e, headerSize: n, fontFamily: oe, orientation: $, isPrintView: x }),
    /* @__PURE__ */ h.jsx(eo, { blobColor: ae, CTASize: l, CTAText: c, orientation: $ })
  ] });
  return /* @__PURE__ */ h.jsx(Yt, { originalWidth: N, originalHeight: P, scaleFactor: V, children: ke });
}, Nc = {
  portrait: [{
    max: 30,
    size: 115
  }, {
    max: 40,
    size: 110
  }, {
    max: 50,
    size: 105
  }, {
    max: 1 / 0,
    size: 95
  }],
  landscape: [{
    max: 30,
    size: 100
  }, {
    max: 40,
    size: 90
  }, {
    max: 50,
    size: 80
  }, {
    max: 1 / 0,
    size: 70
  }],
  vertical: [{
    max: 30,
    size: 85
  }, {
    max: 40,
    size: 80
  }, {
    max: 50,
    size: 75
  }, {
    max: 1 / 0,
    size: 70
  }]
}, Mc = {
  portrait: [{
    max: 60,
    size: 120
  }, {
    max: 1 / 0,
    size: 90
  }],
  landscape: [{
    max: 60,
    size: 70
  }, {
    max: 1 / 0,
    size: 60
  }],
  vertical: [{
    max: 60,
    size: 75
  }, {
    max: 1 / 0,
    size: 50
  }]
}, Vc = (t = 30, e, a) => {
  const n = a ? Mc : Nc;
  return (n[e] || n.portrait).find(({
    max: s
  }) => t < s).size;
}, Xc = (t) => t === "portrait" ? {
  min: 85,
  max: 110
} : t === "landscape" ? {
  min: 60,
  max: 66
} : {
  min: 45,
  max: 65
}, Tt = q.span.withConfig({
  displayName: "JobTitle",
  componentId: "sc-hi4c2g-0"
})(["font-size:", "px;font-style:normal;color:", ";background-color:", ";&&&{font-family:", ',"Nunito",sans-serif;}'], ({
  titleSize: t
}) => t, ({
  color: t
}) => t || "white", ({
  backgroundColor: t
}) => t || "white", ({
  fontFamily: t
}) => t), xn = q.div.withConfig({
  displayName: "SubText",
  componentId: "sc-hi4c2g-1"
})(["font-style:normal;font-weight:500;margin:0;line-height:1.3;max-width:100%;color:", ";background-color:", ";> div{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}&&&{font-family:", ",sans-serif;}"], ({
  subColor: t
}) => t || "#F8F8F8", ({
  subBgColor: t
}) => t || "#000000", ({
  fontFamily: t
}) => t), Kc = q.div.withConfig({
  displayName: "NewTitleWrapper",
  componentId: "sc-hi4c2g-2"
})(["position:absolute;right:0;bottom:0;display:flex;flex-direction:column;align-items:flex-end;", "{border-radius:0;font-weight:500;line-height:1.5;text-align:left;}", ""], Tt, ({
  orientation: t
}) => Se(t === "landscape" ? ["bottom:100px;width:1000px;", "{padding:40px 50px 45px 60px;}", "{padding:30px 50px;min-width:590px;}"] : t === "vertical" ? ["bottom:360px;width:960px;", "{padding:40px 50px 45px 60px;}", "{padding:20px 50px;min-width:520px;}"] : ["bottom:240px;width:1700px;", "{padding:50px 90px 55px 100px;}", "{padding:40px 80px;min-width:900px;}"], Tt, xn)), Lc = q.div.withConfig({
  displayName: "TitleWrapper",
  componentId: "sc-hi4c2g-3"
})(["position:absolute;right:0;bottom:0;text-align:right;", "{border-radius:30px 0 0 30px;text-align:right;box-decoration-break:clone;font-weight:700;line-height:1.6;}", ""], Tt, ({
  orientation: t
}) => Se(t === "landscape" ? ["transform:translateY(-50%);min-width:75%;max-width:90%;", "{padding:20px 30px;}"] : t === "vertical" ? ["transform:translateY(-80%);min-width:75%;max-width:95%;", "{padding:25px 40px;}"] : ["transform:translateY(-40%);min-width:75%;max-width:90%;", "{padding:25px 40px;}"], Tt)), qc = ({
  text: t,
  secondaryText: e,
  primaryTextColor: a,
  primaryBackgroundColor: n,
  secondaryTextColor: i,
  secondaryBackgroundColor: o,
  fontFamily: s,
  orientation: r,
  isNewCampaign: c
}) => {
  if (!t) return null;
  const l = Vc(t == null ? void 0 : t.length, r, c), {
    min: f,
    max: m
  } = Xc(r), v = /* @__PURE__ */ h.jsx(Tt, { color: a, backgroundColor: n, titleSize: l, textLength: t == null ? void 0 : t.length, fontFamily: s, orientation: r, children: Kt(t) });
  return c ? /* @__PURE__ */ h.jsxs(Kc, { orientation: r, children: [
    v,
    e && /* @__PURE__ */ h.jsx(xn, { subColor: i, subBgColor: o, fontFamily: s, children: /* @__PURE__ */ h.jsx(Kn, { mode: "oneline", minFontSizePx: f, maxFontSizePx: m, children: Kt(e) }) })
  ] }) : /* @__PURE__ */ h.jsx(Lc, { orientation: r, children: v });
}, Wc = q.div.withConfig({
  displayName: "MainWrapper",
  componentId: "sc-yfux5s-0"
})(["position:relative;width:100%;height:100%;border-radius:inherit;"]), Yc = q(pt).withConfig({
  displayName: "BackgroundImage",
  componentId: "sc-yfux5s-1"
})(["width:100%;height:100%;object-fit:cover;"]);
u.object({
  orientation: u.enum(["portrait", "vertical", "landscape"]).optional(),
  backgroundImage: u.string().url(),
  primaryTextColor: W().optional(),
  primaryBackgroundColor: W().optional(),
  secondaryTextColor: W().optional(),
  secondaryBackgroundColor: W().optional(),
  textColor: W().optional(),
  backgroundColor: W().optional(),
  text: u.string().optional(),
  textSize: u.number().optional(),
  secondaryText: u.string().default("Bist du bereit?").optional(),
  logo: u.string().url().optional(),
  logoFormat: u.enum(["square", "landscape"]).optional(),
  logoPosition: u.enum(["top-left", "top-right", "bottom-left", "bottom-right"]).optional(),
  logoSize: u.enum(["small", "mid", "big"]).optional(),
  width: u.number().default(400).optional(),
  isVideo: u.boolean().default(!0).optional(),
  isNewCampaign: u.boolean().default(!0).optional(),
  fontFamily: u.string().optional(),
  customFont: u.object({
    name: u.string(),
    url: u.string()
  }).optional()
});
const Ln = ({
  orientation: t = "portrait",
  backgroundImage: e,
  primaryTextColor: a,
  primaryBackgroundColor: n,
  secondaryTextColor: i,
  secondaryBackgroundColor: o,
  textColor: s,
  backgroundColor: r,
  text: c,
  secondaryText: l,
  textSize: f,
  logo: m,
  logoFormat: v = "square",
  logoPosition: k = "top-left",
  logoSize: C = "small",
  width: E,
  isVideo: b = !1,
  isNewCampaign: D,
  fontFamily: j = "Rubik",
  customFont: x
}) => {
  const _ = t || "portrait", {
    aspectRatio: y,
    width: H,
    height: $
  } = Ie[_], Y = Math.round(E / y), ae = Wt(H, $, E, Y);
  qt(j, x);
  const ve = (x == null ? void 0 : x.name) === j, de = Lt(ve ? null : j), N = ve ? j : de, P = /* @__PURE__ */ h.jsxs(Wc, { children: [
    /* @__PURE__ */ h.jsx(la, { logo: m, logoPosition: k, offset: 2, elementSize: C, logoFormat: v, orientation: _ }),
    e ? /* @__PURE__ */ h.jsx(Yc, { src: e }) : null,
    /* @__PURE__ */ h.jsx(qc, { text: c, secondaryText: l, primaryTextColor: s || a, primaryBackgroundColor: r || n, secondaryTextColor: s || i, secondaryBackgroundColor: r || o, textSize: f, fontFamily: N, orientation: _, isNewCampaign: D })
  ] });
  return b ? P : /* @__PURE__ */ h.jsx(Yt, { originalWidth: H, originalHeight: $, scaleFactor: ae, children: P });
};
u.object({
  logoUrl: u.string().url(),
  logoFormat: u.enum(["square", "landscape"]).optional(),
  logoPosition: u.enum(["top-left", "top-right", "bottom-left", "bottom-right"]).optional(),
  logoSize: u.enum(["small", "mid", "big"]).optional(),
  text: u.string().optional(),
  textSize: u.number().default(45).optional(),
  primaryTextColor: W().optional(),
  primaryBackgroundColor: W().optional(),
  textColor: W().optional(),
  backgroundColor: W().optional(),
  backgroundImage: u.string(),
  audioUrl: u.string().url().optional(),
  duration: u.number().positive().optional(),
  fontFamily: u.string().optional(),
  customFont: u.object({
    name: u.string(),
    url: u.string()
  }).optional()
});
const $c = ({
  logoUrl: t,
  logoFormat: e = "square",
  logoPosition: a = "top-left",
  logoSize: n = "mid",
  text: i,
  textSize: o,
  backgroundImage: s,
  primaryTextColor: r = "#1e1e1e",
  primaryBackgroundColor: c = "#ebebeb",
  textColor: l,
  backgroundColor: f,
  audioUrl: m,
  fontFamily: v = "Nunito",
  customFont: k
}) => /* @__PURE__ */ h.jsxs(gt, { name: "Landscape Sequence", from: 0, children: [
  m && /* @__PURE__ */ h.jsx(ra, { src: m, volume: 1, startFrom: 0 }),
  /* @__PURE__ */ h.jsx(Ln, { orientation: "landscape", backgroundImage: s, primaryTextColor: l || r, primaryBackgroundColor: f || c, text: i, textSize: o, logo: t, logoFormat: e, logoPosition: a, logoSize: n, isVideo: !0, fontFamily: v, customFont: k })
] });
u.object({
  logoUrl: u.string().url(),
  logoFormat: u.enum(["square", "landscape"]).optional(),
  logoPosition: u.enum(["top-left", "top-right", "bottom-left", "bottom-right"]).optional(),
  logoSize: u.enum(["small", "mid", "big"]).optional(),
  text: u.string().optional(),
  textSize: u.number().default(110).optional(),
  primaryTextColor: W().optional(),
  primaryBackgroundColor: W().optional(),
  textColor: W().optional(),
  backgroundColor: W().optional(),
  backgroundImage: u.string(),
  audioUrl: u.string().url().optional(),
  duration: u.number().positive().optional(),
  fontFamily: u.string().optional(),
  customFont: u.object({
    name: u.string(),
    url: u.string()
  }).optional()
});
const Hc = ({
  logoUrl: t,
  logoFormat: e = "square",
  logoPosition: a = "top-left",
  logoSize: n = "mid",
  text: i,
  textSize: o,
  backgroundImage: s,
  primaryTextColor: r = "#1e1e1e",
  primaryBackgroundColor: c = "#ebebeb",
  textColor: l,
  backgroundColor: f,
  audioUrl: m,
  fontFamily: v = "Nunito",
  customFont: k
}) => /* @__PURE__ */ h.jsxs(gt, { name: "Portrait Sequence", from: 0, children: [
  m && /* @__PURE__ */ h.jsx(ra, { src: m, volume: 1, startFrom: 0 }),
  /* @__PURE__ */ h.jsx(Ln, { orientation: "portrait", backgroundImage: s, primaryTextColor: l || r, primaryBackgroundColor: f || c, text: i, textSize: o, logo: t, logoFormat: e, logoPosition: a, logoSize: n, isVideo: !0, fontFamily: v, customFont: k })
] });
class Zc {
  /**
      Simple ["Least Recently Used" (LRU) cache](https://en.m.wikipedia.org/wiki/Cache_replacement_policies#Least_Recently_Used_.28LRU.29).
  
      The instance is an [`Iterable`](https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Iteration_protocols) of `[key, value]` pairs so you can use it directly in a [`for…of`](https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Statements/for...of) loop.
  
      @example
      ```
      import { QuickLRU } from 'quick-lru-ts';
  
      const lru = new QuickLRU({maxSize: 1000});
  
      lru.set('🦄', '🌈');
  
      lru.has('🦄');
      //=> true
  
      lru.get('🦄');
      //=> '🌈'
      ```
      */
  constructor(e) {
    if (!(e.maxSize && e.maxSize > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    if (typeof e.maxAge == "number" && e.maxAge === 0)
      throw new TypeError("`maxAge` must be a number greater than 0");
    this.maxSize = e.maxSize, this.maxAge = e.maxAge || Number.POSITIVE_INFINITY, this.onEviction = e.onEviction, this.cache = /* @__PURE__ */ new Map(), this.oldCache = /* @__PURE__ */ new Map(), this._size = 0;
  }
  _emitEvictions(e) {
    if (typeof this.onEviction == "function")
      for (const [a, n] of e)
        this.onEviction(a, n.value);
  }
  _deleteIfExpired(e, a) {
    return a === void 0 ? !0 : typeof a.expiry == "number" && a.expiry <= Date.now() ? (typeof this.onEviction == "function" && this.onEviction(e, a.value), this.delete(e)) : !1;
  }
  _getOrDeleteIfExpired(e, a) {
    if (this._deleteIfExpired(e, a) === !1)
      return a.value;
  }
  _getItemValue(e, a) {
    if (a !== void 0)
      return a.expiry ? this._getOrDeleteIfExpired(e, a) : a.value;
  }
  _peek(e, a) {
    const n = a.get(e);
    return this._getItemValue(e, n);
  }
  _set(e, a) {
    this.cache.set(e, a), this._size++, this._size >= this.maxSize && (this._size = 0, this._emitEvictions(this.oldCache), this.oldCache = this.cache, this.cache = /* @__PURE__ */ new Map());
  }
  _moveToRecent(e, a) {
    this.oldCache.delete(e), this._set(e, a);
  }
  *_entriesAscending() {
    for (const e of this.oldCache) {
      const [a, n] = e;
      this.cache.has(a) || this._deleteIfExpired(a, n) === !1 && (yield e);
    }
    for (const e of this.cache) {
      const [a, n] = e;
      this._deleteIfExpired(a, n) === !1 && (yield e);
    }
  }
  /**
      Get an item.
  
      @returns The stored item or `undefined`.
      */
  get(e) {
    if (this.cache.has(e)) {
      const a = this.cache.get(e);
      return this._getItemValue(e, a);
    }
    if (this.oldCache.has(e)) {
      const a = this.oldCache.get(e);
      if (this._deleteIfExpired(e, a) === !1)
        return this._moveToRecent(e, a), a.value;
    }
  }
  set(e, a, { maxAge: n = this.maxAge } = {}) {
    const i = typeof n == "number" && n !== Number.POSITIVE_INFINITY ? Date.now() + n : void 0;
    this.cache.has(e) ? this.cache.set(e, {
      value: a,
      expiry: i
    }) : this._set(e, { value: a, expiry: i });
  }
  has(e) {
    return this.cache.has(e) ? !this._deleteIfExpired(e, this.cache.get(e)) : this.oldCache.has(e) ? !this._deleteIfExpired(e, this.oldCache.get(e)) : !1;
  }
  peek(e) {
    if (this.cache.has(e))
      return this._peek(e, this.cache);
    if (this.oldCache.has(e))
      return this._peek(e, this.oldCache);
  }
  delete(e) {
    const a = this.cache.delete(e);
    return a && this._size--, this.oldCache.delete(e) || a;
  }
  clear() {
    this.cache.clear(), this.oldCache.clear(), this._size = 0;
  }
  resize(e) {
    if (!(e && e > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    const a = [...this._entriesAscending()], n = a.length - e;
    n < 0 ? (this.cache = new Map(a), this.oldCache = /* @__PURE__ */ new Map(), this._size = a.length) : (n > 0 && this._emitEvictions(a.slice(0, n)), this.oldCache = new Map(a.slice(n)), this.cache = /* @__PURE__ */ new Map(), this._size = 0), this.maxSize = e;
  }
  *keys() {
    for (const [e] of this)
      yield e;
  }
  *values() {
    for (const [, e] of this)
      yield e;
  }
  *[Symbol.iterator]() {
    for (const e of this.cache) {
      const [a, n] = e;
      this._deleteIfExpired(a, n) === !1 && (yield [a, n.value]);
    }
    for (const e of this.oldCache) {
      const [a, n] = e;
      this.cache.has(a) || this._deleteIfExpired(a, n) === !1 && (yield [a, n.value]);
    }
  }
  /**
  Iterable for all entries, starting with the newest (descending in recency).
  */
  *entriesDescending() {
    let e = [...this.cache];
    for (let a = e.length - 1; a >= 0; --a) {
      const n = e[a], [i, o] = n;
      this._deleteIfExpired(i, o) === !1 && (yield [i, o.value]);
    }
    e = [...this.oldCache];
    for (let a = e.length - 1; a >= 0; --a) {
      const n = e[a], [i, o] = n;
      this.cache.has(i) || this._deleteIfExpired(i, o) === !1 && (yield [i, o.value]);
    }
  }
  *entriesAscending() {
    for (const [e, a] of this._entriesAscending())
      yield [e, a.value];
  }
  get size() {
    if (!this._size)
      return this.oldCache.size;
    let e = 0;
    for (const a of this.oldCache.keys())
      this.cache.has(a) || e++;
    return Math.min(this._size + e, this.maxSize);
  }
}
const Pn = new Zc({ maxSize: 30 }), Jc = /* @__PURE__ */ new Map(), Pa = (t, e, a = {}, n = a) => {
  if (Array.isArray(e))
    e.forEach((i) => Pa(t, i, a, n));
  else if (typeof e == "function")
    e(t, a, n, Pa);
  else {
    const i = Object.keys(e)[0];
    Array.isArray(e[i]) ? (n[i] = {}, Pa(t, e[i], a, n[i])) : n[i] = e[i](t, a, n, Pa);
  }
  return a;
}, Gc = (t, e) => function(a, n, i, o) {
  const s = [];
  let r = a.pos;
  for (; e(a, n, i); ) {
    const c = {};
    if (o(a, t, n, c), a.pos === r)
      break;
    r = a.pos, s.push(c);
  }
  return s;
}, oa = (t, e) => (a, n, i, o) => {
  e(a, n, i) && o(a, t, n, i);
}, Qc = (t) => ({
  data: t,
  pos: 0
}), ot = () => (t) => t.data[t.pos++], Xs = (t = 0) => (e) => e.data[e.pos + t], _t = (t) => (e) => e.data.subarray(e.pos, e.pos += t), qn = (t) => (e) => e.data.subarray(e.pos, e.pos + t), ji = (t) => (e) => Array.from(_t(t)(e)).map((a) => String.fromCharCode(a)).join(""), Qt = (t) => (e) => {
  const a = _t(2)(e);
  return (a[1] << 8) + a[0];
}, Ks = (t, e) => (a, n, i) => {
  const o = typeof e == "function" ? e(a, n, i) : e, s = _t(t), r = new Array(o);
  for (let c = 0; c < o; c++)
    r[c] = s(a);
  return r;
}, e7 = (t, e, a) => {
  let n = 0;
  for (let i = 0; i < a; i++)
    n += Number(t[e + i] && 2 ** (a - i - 1));
  return n;
}, no = (t) => (e) => {
  const a = ot()(e), n = new Array(8);
  for (let i = 0; i < 8; i++)
    n[7 - i] = !!(a & 1 << i);
  return Object.keys(t).reduce((i, o) => {
    const s = t[o];
    return s.length ? i[o] = e7(n, s.index, s.length) : i[o] = n[s.index], i;
  }, {});
}, Wn = {
  blocks: (t) => {
    const a = [], n = t.data.length;
    let i = 0;
    for (let r = ot()(t); r !== 0 && r; r = ot()(t)) {
      if (t.pos + r >= n) {
        const c = n - t.pos;
        a.push(_t(c)(t)), i += c;
        break;
      }
      a.push(_t(r)(t)), i += r;
    }
    const o = new Uint8Array(i);
    let s = 0;
    for (let r = 0; r < a.length; r++)
      o.set(a[r], s), s += a[r].length;
    return o;
  }
}, t7 = oa({
  gce: [
    { codes: _t(2) },
    { byteSize: ot() },
    {
      extras: no({
        future: { index: 0, length: 3 },
        disposal: { index: 3, length: 3 },
        userInput: { index: 6 },
        transparentColorGiven: { index: 7 }
      })
    },
    { delay: Qt() },
    { transparentColorIndex: ot() },
    { terminator: ot() }
  ]
}, (t) => {
  const e = qn(2)(t);
  return e[0] === 33 && e[1] === 249;
}), a7 = oa({
  image: [
    { code: ot() },
    {
      descriptor: [
        { left: Qt() },
        { top: Qt() },
        { width: Qt() },
        { height: Qt() },
        {
          lct: no({
            exists: { index: 0 },
            interlaced: { index: 1 },
            sort: { index: 2 },
            future: { index: 3, length: 2 },
            size: { index: 5, length: 3 }
          })
        }
      ]
    },
    oa({
      lct: Ks(3, (t, e, a) => 2 ** (a.descriptor.lct.size + 1))
    }, (t, e, a) => a.descriptor.lct.exists),
    { data: [{ minCodeSize: ot() }, Wn] }
  ]
}, (t) => Xs()(t) === 44), n7 = oa({
  text: [
    { codes: _t(2) },
    { blockSize: ot() },
    {
      preData: (t, e, a) => _t(a.text.blockSize)(t)
    },
    Wn
  ]
}, (t) => {
  const e = qn(2)(t);
  return e[0] === 33 && e[1] === 1;
}), i7 = oa({
  application: [
    { codes: _t(2) },
    { blockSize: ot() },
    {
      id: (t, e, a) => ji(a.blockSize)(t)
    },
    Wn
  ]
}, (t) => {
  const e = qn(2)(t);
  return e[0] === 33 && e[1] === 255;
}), o7 = oa({
  comment: [{ codes: _t(2) }, Wn]
}, (t) => {
  const e = qn(2)(t);
  return e[0] === 33 && e[1] === 254;
}), s7 = [
  { header: [{ signature: ji(3) }, { version: ji(3) }] },
  {
    lsd: [
      { width: Qt() },
      { height: Qt() },
      {
        gct: no({
          exists: { index: 0 },
          resolution: { index: 1, length: 3 },
          sort: { index: 4 },
          size: { index: 5, length: 3 }
        })
      },
      { backgroundColorIndex: ot() },
      { pixelAspectRatio: ot() }
    ]
  },
  oa({
    gct: Ks(3, (t, e) => 2 ** (e.lsd.gct.size + 1))
  }, (t, e) => e.lsd.gct.exists),
  // content frames
  {
    frames: Gc([t7, i7, o7, a7, n7], (t) => {
      const e = Xs()(t);
      return e === 33 || e === 44;
    })
  }
], r7 = (t, e) => {
  const a = new Array(t.length), n = t.length / e, i = function(c, l) {
    const f = t.slice(l * e, (l + 1) * e);
    a.splice(...[c * e, e].concat(f));
  }, o = [0, 4, 2, 1], s = [8, 8, 4, 2];
  let r = 0;
  for (let c = 0; c < 4; c++)
    for (let l = o[c]; l < n; l += s[c])
      i(l, r), r++;
  return a;
}, l7 = (t, e, a) => {
  const o = a;
  let s, r, c, l, f;
  var y;
  let m, v;
  var _, H, $, ae, Y;
  const k = new Array(a), C = new Array(4096), E = new Array(4096), b = new Array(4097), D = t, j = 1 << D, x = j + 1;
  for (s = j + 2, f = -1, c = D + 1, r = (1 << c) - 1, m = 0; m < j; m++)
    C[m] = 0, E[m] = m;
  var _, y, H, $, Y, ae;
  for (_ = y = H = $ = Y = ae = 0, v = 0; v < o; ) {
    if ($ === 0) {
      if (y < c) {
        _ += e[ae] << y, y += 8, ae++;
        continue;
      }
      if (m = _ & r, _ >>= c, y -= c, m > s || m === x)
        break;
      if (m === j) {
        c = D + 1, r = (1 << c) - 1, s = j + 2, f = -1;
        continue;
      }
      if (f === -1) {
        b[$++] = E[m], f = m, H = m;
        continue;
      }
      for (l = m, m === s && (b[$++] = H, m = f); m > j; )
        b[$++] = E[m], m = C[m];
      H = E[m] & 255, b[$++] = H, s < 4096 && (C[s] = f, E[s] = H, s++, !(s & r) && s < 4096 && (c++, r += s)), f = l;
    }
    $--, k[Y++] = b[$], v++;
  }
  for (v = Y; v < o; v++)
    k[v] = 0;
  return k;
}, c7 = (t) => {
  const e = new Uint8Array(t);
  return Pa(Qc(e), s7);
}, u7 = (t, e) => {
  var a, n, i, o;
  if (!t.image)
    return console.warn("gif frame does not have associated image."), null;
  const { image: s } = t, r = s.descriptor.width * s.descriptor.height;
  let c = l7(s.data.minCodeSize, s.data.blocks, r);
  return !((a = s.descriptor.lct) === null || a === void 0) && a.interlaced && (c = r7(c, s.descriptor.width)), {
    pixels: c,
    dims: {
      top: t.image.descriptor.top,
      left: t.image.descriptor.left,
      width: t.image.descriptor.width,
      height: t.image.descriptor.height
    },
    colorTable: !((n = s.descriptor.lct) === null || n === void 0) && n.exists ? s.lct : e,
    delay: ((o = (i = t.gce) === null || i === void 0 ? void 0 : i.delay) !== null && o !== void 0 ? o : 10) * 10,
    disposalType: t.gce ? t.gce.extras.disposal : 1,
    transparentIndex: t.gce && t.gce.extras.transparentColorGiven ? t.gce.transparentColorIndex : -1
  };
}, f7 = (t) => t.frames.filter((e) => "image" in e).map((e) => u7(e, t.gct)).filter(Boolean).map((e) => e), d7 = (t) => {
  let e = null;
  for (const a of t.frames)
    e = a.gce ? a.gce : e, "image" in a && !("gce" in a) && e !== null && (a.gce = e);
}, m7 = ({ typedArray: t, dx: e, dy: a, width: n, height: i, gifWidth: o }) => {
  const s = a * o + e;
  for (let r = 0; r < i; r++)
    for (let c = 0; c < n; c++) {
      const l = s + r * o + c;
      t[l * 4] = 0, t[l * 4 + 1] = 0, t[l * 4 + 2] = 0, t[l * 4 + 3] = 0;
    }
}, p7 = (t, e, a) => {
  const { width: n, height: i, top: o, left: s } = e.dims, r = o * a.width + s;
  for (let c = 0; c < i; c++)
    for (let l = 0; l < n; l++) {
      const f = c * n + l, m = e.pixels[f];
      if (m !== e.transparentIndex) {
        const v = r + c * a.width + l, k = e.colorTable[m];
        t[v * 4] = k[0], t[v * 4 + 1] = k[1], t[v * 4 + 2] = k[2], t[v * 4 + 3] = m === e.transparentIndex ? 0 : 255;
      }
    }
}, h7 = (t, { signal: e }) => fetch(t, { signal: e }).then((a) => {
  var n;
  if (!(!((n = a.headers.get("Content-Type")) === null || n === void 0) && n.includes("image/gif")))
    throw Error(`Wrong content type: "${a.headers.get("Content-Type")}"`);
  return a.arrayBuffer();
}).then((a) => c7(a)).then((a) => (d7(a), a)).then((a) => Promise.all([
  f7(a),
  { width: a.lsd.width, height: a.lsd.height }
])).then(([a, n]) => {
  const i = [], o = n.width * n.height * 4;
  let s = new Uint8ClampedArray(o);
  for (let r = 0; r < a.length; ++r) {
    const c = a[r], l = a[r].disposalType === 3 ? s.slice() : null;
    if (p7(s, c, n), i.push(s.slice()), a[r].disposalType === 2)
      m7({
        typedArray: s,
        dx: c.dims.left,
        dy: c.dims.top,
        width: c.dims.width,
        height: c.dims.height,
        gifWidth: n.width
      });
    else if (a[r].disposalType === 3) {
      if (!l)
        throw Error("Disposal type 3 without previous frame");
      s = l;
    } else
      s = i[r].slice();
  }
  return {
    ...n,
    loaded: !0,
    delays: a.map((r) => r.delay),
    frames: i
  };
}), Ls = (t) => ({
  ...t,
  frames: t.frames.map((e) => {
    const a = new ImageData(t.width, t.height);
    return a.data.set(new Uint8ClampedArray(e)), a;
  })
}), g7 = (
  // eslint-disable-next-line no-template-curly-in-string
  '"use strict";(()=>{var P=(t,r,e={},n=e)=>{if(Array.isArray(r))r.forEach(o=>P(t,o,e,n));else if(typeof r=="function")r(t,e,n,P);else{let o=Object.keys(r)[0];Array.isArray(r[o])?(n[o]={},P(t,r[o],e,n[o])):n[o]=r[o](t,e,n,P)}return e},M=(t,r)=>function(e,n,o,c){let i=[],a=e.pos;for(;r(e,n,o);){let s={};if(c(e,t,n,s),e.pos===a)break;a=e.pos,i.push(s)}return i},g=(t,r)=>(e,n,o,c)=>{r(e,n,o)&&c(e,t,n,o)};var W=t=>({data:t,pos:0}),m=()=>t=>t.data[t.pos++],U=(t=0)=>r=>r.data[r.pos+t],f=t=>r=>r.data.subarray(r.pos,r.pos+=t),k=t=>r=>r.data.subarray(r.pos,r.pos+t),v=t=>r=>Array.from(f(t)(r)).map(e=>String.fromCharCode(e)).join(""),b=t=>r=>{let e=f(2)(r);return t?(e[1]<<8)+e[0]:(e[0]<<8)+e[1]},E=(t,r)=>(e,n,o)=>{let c=typeof r=="function"?r(e,n,o):r,i=f(t),a=new Array(c);for(let s=0;s<c;s++)a[s]=i(e);return a},$=(t,r,e)=>{let n=0;for(let o=0;o<e;o++)n+=Number(t[r+o]&&2**(e-o-1));return n},I=t=>r=>{let e=m()(r),n=new Array(8);for(let o=0;o<8;o++)n[7-o]=!!(e&1<<o);return Object.keys(t).reduce((o,c)=>{let i=t[c];return i.length?o[c]=$(n,i.index,i.length):o[c]=n[i.index],o},{})};var z={blocks:t=>{let e=[],n=t.data.length,o=0;for(let a=m()(t);a!==0&&a;a=m()(t)){if(t.pos+a>=n){let s=n-t.pos;e.push(f(s)(t)),o+=s;break}e.push(f(a)(t)),o+=a}let c=new Uint8Array(o),i=0;for(let a=0;a<e.length;a++)c.set(e[a],i),i+=e[a].length;return c}},q=g({gce:[{codes:f(2)},{byteSize:m()},{extras:I({future:{index:0,length:3},disposal:{index:3,length:3},userInput:{index:6},transparentColorGiven:{index:7}})},{delay:b(!0)},{transparentColorIndex:m()},{terminator:m()}]},t=>{let r=k(2)(t);return r[0]===33&&r[1]===249}),H=g({image:[{code:m()},{descriptor:[{left:b(!0)},{top:b(!0)},{width:b(!0)},{height:b(!0)},{lct:I({exists:{index:0},interlaced:{index:1},sort:{index:2},future:{index:3,length:2},size:{index:5,length:3}})}]},g({lct:E(3,(t,r,e)=>2**(e.descriptor.lct.size+1))},(t,r,e)=>e.descriptor.lct.exists),{data:[{minCodeSize:m()},z]}]},t=>U()(t)===44),J=g({text:[{codes:f(2)},{blockSize:m()},{preData:(t,r,e)=>f(e.text.blockSize)(t)},z]},t=>{let r=k(2)(t);return r[0]===33&&r[1]===1}),Q=g({application:[{codes:f(2)},{blockSize:m()},{id:(t,r,e)=>v(e.blockSize)(t)},z]},t=>{let r=k(2)(t);return r[0]===33&&r[1]===255}),V=g({comment:[{codes:f(2)},z]},t=>{let r=k(2)(t);return r[0]===33&&r[1]===254}),K=[{header:[{signature:v(3)},{version:v(3)}]},{lsd:[{width:b(!0)},{height:b(!0)},{gct:I({exists:{index:0},resolution:{index:1,length:3},sort:{index:4},size:{index:5,length:3}})},{backgroundColorIndex:m()},{pixelAspectRatio:m()}]},g({gct:E(3,(t,r)=>2**(r.lsd.gct.size+1))},(t,r)=>r.lsd.gct.exists),{frames:M([q,Q,V,H,J],t=>{let r=U()(t);return r===33||r===44})}];var X=(t,r)=>{let e=new Array(t.length),n=t.length/r,o=function(s,l){let u=t.slice(l*r,(l+1)*r);e.splice(...[s*r,r].concat(u))},c=[0,4,2,1],i=[8,8,4,2],a=0;for(let s=0;s<4;s++)for(let l=c[s];l<n;l+=i[s])o(l,a),a++;return e};var Z=(t,r,e)=>{let c=e,i,a,s,l,u;var w;let d,p;var C,y,h,_,G;let x=new Array(e),B=new Array(4096),T=new Array(4096),F=new Array(4096+1),R=t,S=1<<R,O=S+1;for(i=S+2,u=-1,s=R+1,a=(1<<s)-1,d=0;d<S;d++)B[d]=0,T[d]=d;var C,w,y,h,G,_;for(C=w=y=h=G=_=0,p=0;p<c;){if(h===0){if(w<s){C+=r[_]<<w,w+=8,_++;continue}if(d=C&a,C>>=s,w-=s,d>i||d===O)break;if(d===S){s=R+1,a=(1<<s)-1,i=S+2,u=-1;continue}if(u===-1){F[h++]=T[d],u=d,y=d;continue}for(l=d,d===i&&(F[h++]=y,d=u);d>S;)F[h++]=T[d],d=B[d];y=T[d]&255,F[h++]=y,i<4096&&(B[i]=u,T[i]=y,i++,!(i&a)&&i<4096&&(s++,a+=i)),u=l}h--,x[G++]=F[h],p++}for(p=G;p<c;p++)x[p]=0;return x};var j=t=>{let r=new Uint8Array(t);return P(W(r),K)},D=(t,r)=>{var i,a,s,l;if(!t.image)return console.warn("gif frame does not have associated image."),null;let{image:e}=t,n=e.descriptor.width*e.descriptor.height,o=Z(e.data.minCodeSize,e.data.blocks,n);return(i=e.descriptor.lct)!=null&&i.interlaced&&(o=X(o,e.descriptor.width)),{pixels:o,dims:{top:t.image.descriptor.top,left:t.image.descriptor.left,width:t.image.descriptor.width,height:t.image.descriptor.height},colorTable:(a=e.descriptor.lct)!=null&&a.exists?e.lct:r,delay:((l=(s=t.gce)==null?void 0:s.delay)!=null?l:10)*10,disposalType:t.gce?t.gce.extras.disposal:1,transparentIndex:t.gce&&t.gce.extras.transparentColorGiven?t.gce.transparentColorIndex:-1}};var L=t=>t.frames.filter(r=>"image"in r).map(r=>D(r,t.gct)).filter(Boolean).map(r=>r);var Y=t=>{let r=null;for(let e of t.frames)r=e.gce?e.gce:r,"image"in e&&!("gce"in e)&&r!==null&&(e.gce=r)},ee=({typedArray:t,dx:r,dy:e,width:n,height:o,gifWidth:c})=>{let i=e*c+r;for(let a=0;a<o;a++)for(let s=0;s<n;s++){let l=i+a*c+s;t[l*4]=0,t[l*4+1]=0,t[l*4+2]=0,t[l*4+3]=0}},te=(t,r,e)=>{let{width:n,height:o,top:c,left:i}=r.dims,a=c*e.width+i;for(let s=0;s<o;s++)for(let l=0;l<n;l++){let u=s*n+l,d=r.pixels[u];if(d!==r.transparentIndex){let p=a+s*e.width+l,x=r.colorTable[d];t[p*4]=x[0],t[p*4+1]=x[1],t[p*4+2]=x[2],t[p*4+3]=d===r.transparentIndex?0:255}}},N=(t,{signal:r})=>fetch(t,{signal:r}).then(e=>{var n;if(!((n=e.headers.get("Content-Type"))!=null&&n.includes("image/gif")))throw Error(`Wrong content type: "${e.headers.get("Content-Type")}"`);return e.arrayBuffer()}).then(e=>j(e)).then(e=>(Y(e),e)).then(e=>Promise.all([L(e),{width:e.lsd.width,height:e.lsd.height}])).then(([e,n])=>{let o=[],c=n.width*n.height*4,i=new Uint8ClampedArray(c);for(let a=0;a<e.length;++a){let s=e[a],l=e[a].disposalType===3?i.slice():null;if(te(i,s,n),o.push(i.slice()),e[a].disposalType===2)ee({typedArray:i,dx:s.dims.left,dy:s.dims.top,width:s.dims.width,height:s.dims.height,gifWidth:n.width});else if(e[a].disposalType===3){if(!l)throw Error("Disposal type 3 without previous frame");i=l}else i=o[a].slice()}return{...n,loaded:!0,delays:e.map(a=>a.delay),frames:o}});var A=new Map;self.addEventListener("message",t=>{let{type:r,src:e}=t.data||t;switch(r){case"parse":{if(!A.has(e)){let n=new AbortController,o={signal:n.signal};A.set(e,n),N(e,o).then(c=>{self.postMessage(Object.assign(c,{src:e}),c.frames.map(i=>i.buffer))}).catch(c=>{self.postMessage({src:e,error:c,loaded:!0})}).finally(()=>{A.delete(e)})}break}case"cancel":{A.has(e)&&(A.get(e).abort(),A.delete(e));break}default:break}});})();\n'
), b7 = () => {
  const t = new Blob([g7], { type: "application/javascript" }), e = URL.createObjectURL(t), a = new Worker(e);
  return URL.revokeObjectURL(e), a;
}, y7 = async ({ src: t, controller: e }) => {
  const a = await h7(t, { signal: e.signal });
  return Ls(a);
}, v7 = (t) => {
  const e = b7();
  let a = null;
  return {
    prom: new Promise((i, o) => {
      a = (s) => {
        const r = s.data || s;
        if (r.src === t)
          if (r.error)
            o(new Error(r.error));
          else {
            const c = r.error ? r : Ls(r);
            i(c), e.terminate();
          }
      }, e.addEventListener("message", a), e.postMessage({ src: t, type: "parse" });
    }),
    cancel: () => {
      e.postMessage({ src: t, type: "cancel" }), e.removeEventListener("message", a), e.terminate();
    }
  };
};
let ci = [];
const k7 = (t) => {
  const [e, a] = vt(null), n = Ho(() => typeof ResizeObserver > "u" ? null : new ResizeObserver((o) => {
    const { contentRect: s } = o[0], r = o[0].target.getClientRects();
    if (!(r != null && r[0])) {
      a(null);
      return;
    }
    const c = r[0].width / s.width, l = r[0].width * (1 / c), f = r[0].height * (1 / c);
    a({
      width: l,
      height: f
    });
  }), []), i = $o(() => {
    if (!t.current)
      return;
    const o = t.current.getClientRects();
    if (!o[0]) {
      a(null);
      return;
    }
    a({
      width: o[0].width,
      height: o[0].height
    });
  }, [t]);
  return kt(() => {
    if (!n)
      return;
    i();
    const { current: o } = t;
    return t.current && n.observe(t.current), () => {
      o && n.unobserve(o);
    };
  }, [n, t, i]), kt(() => (ci.push(i), () => {
    ci = ci.filter((o) => o !== i);
  }), [i]), e;
}, w7 = (t, e, a) => {
  switch (t) {
    case "fill":
      return [
        0,
        0,
        e.width,
        e.height,
        0,
        0,
        a.width,
        a.height
      ];
    case "contain": {
      const n = Math.min(a.width / e.width, a.height / e.height), i = (a.width - e.width * n) / 2, o = (a.height - e.height * n) / 2;
      return [
        0,
        0,
        e.width,
        e.height,
        i,
        o,
        e.width * n,
        e.height * n
      ];
    }
    case "cover": {
      const n = Math.max(a.width / e.width, a.height / e.height), i = (a.width - e.width * n) / 2, o = (a.height - e.height * n) / 2;
      return [
        0,
        0,
        e.width,
        e.height,
        i,
        o,
        e.width * n,
        e.height * n
      ];
    }
    default:
      throw new Error("Unknown fit: " + t);
  }
}, x7 = () => {
  if (typeof document > "u")
    return null;
  const t = document.createElement("canvas"), e = t.getContext("2d");
  return t.width = 0, t.height = 0, e;
}, qs = Nn(({ index: t, frames: e, width: a, height: n, fit: i, className: o, style: s }, r) => {
  const c = Nt(null), [l] = vt(() => x7()), f = k7(c);
  return Zs(r, () => c.current, []), kt(() => {
    var m;
    if (!f)
      return;
    const v = e[t], k = (m = c.current) === null || m === void 0 ? void 0 : m.getContext("2d");
    v && l && k && ((l.canvas.width < v.width || l.canvas.height < v.height) && (l.canvas.width = v.width, l.canvas.height = v.height), f.width > 0 && f.height > 0 && (k.clearRect(0, 0, f.width, f.height), l.clearRect(0, 0, l.canvas.width, l.canvas.height)), l.putImageData(v, 0, 0), k.drawImage(l.canvas, ...w7(i, v, { width: f.width, height: f.height })));
  }, [t, e, i, l, f]), h.jsx("canvas", { ref: c, className: o, style: s, width: a ?? (f == null ? void 0 : f.width), height: n ?? (f == null ? void 0 : f.height) });
}), Ws = (t) => (
  // Chrome
  t.message.includes("Failed to fetch") || // Safari
  t.message.includes("Load failed") || // Firefox
  t.message.includes("NetworkError when attempting to fetch resource")
), Ys = (t) => new URL(t, typeof window > "u" ? void 0 : window.origin).href;
function $s({ delays: t, loopBehavior: e, playbackRate: a }) {
  const n = sa(), i = za(), o = Ho(() => t.length !== 0 ? t.reduce((l, f) => l + (f ?? 0), 0) : 1, [t]);
  if (t.length === 0)
    return 0;
  const r = n / (1 / a) / i.fps * 1e3;
  if (e === "pause-after-finish" && r >= o)
    return t.length - 1;
  if (e === "unmount-after-finish" && r >= o)
    return -1;
  let c = r % o;
  for (let l = 0; l < t.length; l++) {
    const f = t[l];
    if (c < f)
      return l;
    c -= f;
  }
  return 0;
}
const _7 = Nn(({ src: t, width: e, height: a, onError: n, loopBehavior: i = "loop", playbackRate: o = 1, onLoad: s, fit: r = "fill", ...c }, l) => {
  const f = Ys(t), [m, v] = vt(() => {
    var x;
    const _ = (x = Pn.get(f)) !== null && x !== void 0 ? x : Jc.get(f);
    return _ === void 0 ? {
      delays: [],
      frames: [],
      width: 0,
      height: 0
    } : _;
  }), [k, C] = vt(null), [E] = vt(() => Ma(`Rendering <Gif/> with src="${f}"`)), b = Nt(s), D = Nt(n);
  if (b.current = s, D.current = n, kt(() => {
    let x = !1, _ = !1;
    const { prom: y, cancel: H } = v7(f), $ = Ma("Loading <Gif /> with src=" + f);
    return y.then((Y) => {
      var ae;
      (ae = b.current) === null || ae === void 0 || ae.call(b, Y), v(Y), Pn.set(f, Y), x = !0, bt($), bt(E);
    }).catch((Y) => {
      if (_) {
        bt($);
        return;
      }
      D.current ? D.current(Y) : C(Y);
    }), () => {
      x || (_ = !0, H()), bt($);
    };
  }, [E, f]), k)
    throw console.error(k.stack), Ws(k) ? new Error(`Failed to render GIF with source ${t}: "${k.message}". You must enable CORS for this URL.`) : new Error(`Failed to render GIF with source ${t}: "${k.message}".`);
  const j = $s({
    delays: m.delays,
    loopBehavior: i,
    playbackRate: o
  });
  return j === -1 ? null : h.jsx(qs, { fit: r, index: j, frames: m.frames, width: e, height: a, ...c, ref: l });
}), F7 = Nn(({ src: t, width: e, height: a, onLoad: n, onError: i, loopBehavior: o = "loop", playbackRate: s = 1, fit: r = "fill", ...c }, l) => {
  const f = Ys(t), [m, v] = vt(() => {
    const x = Pn.get(f);
    return x === void 0 ? {
      delays: [],
      frames: [],
      width: 0,
      height: 0
    } : x;
  }), [k, C] = vt(null), [E] = vt(() => Ma(`Rendering <Gif/> with src="${f}"`));
  kt(() => () => {
    bt(E);
  }, [E]);
  const b = $s({
    delays: m.delays,
    loopBehavior: o,
    playbackRate: s
  }), D = Nt(n), j = Nt(i);
  if (D.current = n, j.current = i, kt(() => {
    const x = new AbortController();
    let _ = !1, y = !1;
    const H = Ma("Loading <Gif /> with src=" + f);
    return y7({ controller: x, src: f }).then(($) => {
      var Y;
      (Y = D.current) === null || Y === void 0 || Y.call(D, $), v($), Pn.set(f, $), _ = !0, bt(H), bt(E);
    }).catch(($) => {
      if (y) {
        bt(H);
        return;
      }
      j.current ? j.current($) : C($);
    }), () => {
      _ || (y = !0, x.abort()), bt(H);
    };
  }, [E, f]), k)
    throw console.error(k.stack), Ws(k) ? new Error(`Failed to render GIF with source ${t}: "${k.message}". You must enable CORS for this URL.`) : new Error(`Failed to render GIF with source ${t}: "${k.message}". Render with --log=verbose to see the full stack.`);
  return b === -1 ? null : h.jsx(qs, { fit: r, index: b, frames: m.frames, width: e, height: a, ...c, ref: l });
}), C7 = Nn((t, e) => Gs().isRendering ? h.jsx(F7, { ...t, ref: e }) : h.jsx(_7, { ...t, ref: e }));
u.object({
  logoUrl: u.string().url().optional(),
  logoFormat: u.enum(["square", "landscape"]).optional(),
  logoPosition: u.enum(["top-left", "top-right", "bottom-left", "bottom-right"]).optional(),
  logoSize: u.enum(["small", "mid", "big"]).optional(),
  text: u.string().optional(),
  textSize: u.number().default(80).optional(),
  primaryTextColor: W().optional(),
  primaryBackgroundColor: W().optional(),
  textColor: W().optional(),
  backgroundColor: W().optional(),
  backgroundImage: u.string(),
  audioUrl: u.string().url().optional(),
  fontFamily: u.string().optional(),
  customFont: u.object({
    name: u.string(),
    url: u.string()
  }).optional()
});
const z7 = ({
  logoUrl: t,
  logoFormat: e = "square",
  logoPosition: a = "top-left",
  logoSize: n = "mid",
  text: i,
  textSize: o,
  backgroundImage: s,
  primaryTextColor: r = "#1e1e1e",
  primaryBackgroundColor: c = "#ebebeb",
  textColor: l,
  backgroundColor: f,
  audioUrl: m,
  fontFamily: v = "Nunito",
  customFont: k
}) => {
  const C = s == null ? void 0 : s.toLowerCase().endsWith(".gif"), E = Nt(null), {
    width: b,
    height: D,
    durationInFrames: j
  } = za();
  return /* @__PURE__ */ h.jsxs(gt, { name: "Vertical Sequence", from: 0, durationInFrames: j, children: [
    m && /* @__PURE__ */ h.jsx(ra, { src: m, volume: 1, startFrom: 0 }),
    C ? /* @__PURE__ */ h.jsx(C7, { ref: E, src: s, width: b, height: D, fit: "cover" }) : /* @__PURE__ */ h.jsx(Ln, { orientation: "vertical", backgroundImage: s, primaryTextColor: l || r, primaryBackgroundColor: f || c, text: i, textSize: o, logo: t, logoFormat: e, logoPosition: a, logoSize: n, isVideo: !0, fontFamily: v, customFont: k })
  ] });
};
u.object({
  orientation: u.enum(["portrait", "vertical", "landscape"]).optional(),
  backgroundImage: u.string().url(),
  text: u.string().optional(),
  secondaryText: u.string().default("Bist du bereit?").optional(),
  headerSize: u.number().default(80).optional(),
  primaryTextColor: W().optional(),
  primaryBackgroundColor: W().optional(),
  titleColor: W().optional(),
  waveColor: W().optional(),
  CTAText: u.string().optional(),
  CTASize: u.number().default(4).optional(),
  imageVertical: u.number().default(50).optional(),
  imageHorizontal: u.number().default(50).optional(),
  zoom: u.number().min(0.1).step(0.1).max(2.5).default(1).optional(),
  logo: u.string().url().optional(),
  logoFormat: u.enum(["square", "landscape"]).optional(),
  logoPosition: u.enum(["top-left", "top-right", "bottom-left", "bottom-right"]).optional(),
  logoSize: u.enum(["small", "mid", "big"]).optional(),
  width: u.number().optional(),
  isPrintView: u.boolean().default(!1).optional(),
  duration: u.number().positive().optional(),
  fontFamily: u.string().optional(),
  customFont: u.object({
    name: u.string(),
    url: u.string()
  }).optional()
});
const E7 = (t) => {
  const {
    orientation: e = "portrait",
    primaryTextColor: a = "#F8F8F8",
    primaryBackgroundColor: n = "#198E93",
    fontFamily: i = "Rubik",
    customFont: o,
    audioUrl: s
  } = t;
  return /* @__PURE__ */ h.jsxs("div", { style: {
    width: "100%",
    height: "100%"
  }, children: [
    s && /* @__PURE__ */ h.jsx(ra, { src: s, volume: 1, startFrom: 0 }),
    /* @__PURE__ */ h.jsx("div", { style: {
      position: "relative",
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }, children: /* @__PURE__ */ h.jsx(Vs, { ...t, orientation: e, primaryTextColor: t.textColor || a, primaryBackgroundColor: t.backgroundColor || n, isVideo: !0, fontFamily: i, customFont: o }) })
  ] });
};
u.object({
  video: u.string().url(),
  audioUrl: u.string().url().optional(),
  duration: u.number().positive().optional(),
  muteVideo: u.boolean().optional()
});
const T7 = ({
  video: t,
  audioUrl: e,
  muteVideo: a = !1
}) => /* @__PURE__ */ h.jsxs(gt, { name: "Raw Sequence", from: 0, children: [
  e && /* @__PURE__ */ h.jsx(ra, { src: e, volume: 1, startFrom: 0 }),
  /* @__PURE__ */ h.jsx(Qs, { children: /* @__PURE__ */ h.jsx(Vn, { src: t, muted: a, startFrom: 0 }) })
] });
u.object({
  orientation: u.enum(["portrait", "vertical", "landscape"]).optional(),
  backgroundImage: u.string().url(),
  text: u.string().optional(),
  secondaryText: u.string().default("Bist du bereit?").optional(),
  headerSize: u.number().default(3).optional(),
  titleSize: u.number().default(4).optional(),
  CTAText: u.string().optional(),
  CTASize: u.number().default(4).optional(),
  imageVertical: u.number().default(50).optional(),
  imageHorizontal: u.number().default(50).optional(),
  zoom: u.number().min(0.1).step(0.1).default(1).optional(),
  secondaryTextColor: W().optional(),
  primaryBackgroundColor: W().optional(),
  secondaryBackgroundColor: W().optional(),
  textColor: W().optional(),
  blobColor: W().optional(),
  waveColor: W().optional(),
  logo: u.string().url().optional(),
  logoFormat: u.enum(["square", "landscape"]).optional(),
  logoPosition: u.enum(["top-left", "top-right", "bottom-left", "bottom-right"]).optional(),
  logoSize: u.enum(["small", "mid", "big"]).optional(),
  width: u.number().default(400).optional(),
  isPrintView: u.boolean().default(!1).optional(),
  duration: u.number().positive().optional(),
  fontFamily: u.string().optional(),
  customFont: u.object({
    name: u.string(),
    url: u.string()
  }).optional()
});
const j7 = (t) => {
  const {
    orientation: e = "portrait",
    secondaryTextColor: a = "#198E93",
    /// <<<--- blobText
    primaryBackgroundColor: n = "#25414B",
    secondaryBackgroundColor: i = "#F8F8F8",
    fontFamily: o = "Rubik",
    customFont: s,
    audioUrl: r
  } = t;
  return /* @__PURE__ */ h.jsxs("div", { style: {
    width: "100%",
    height: "100%"
  }, children: [
    r && /* @__PURE__ */ h.jsx(ra, { src: r, volume: 1, startFrom: 0 }),
    /* @__PURE__ */ h.jsx("div", { style: {
      position: "relative",
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }, children: /* @__PURE__ */ h.jsx(Ps, { ...t, orientation: e, secondaryTextColor: t.textColor || a, primaryBackgroundColor: t.backgroundColor || n, secondaryBackgroundColor: t.blobColor || i, isVideo: !0, fontFamily: o, customFont: s }) })
  ] });
}, U7 = {
  portrait: [{
    max: 30,
    size: 115
  }, {
    max: 40,
    size: 110
  }, {
    max: 50,
    size: 105
  }, {
    max: 1 / 0,
    size: 95
  }],
  landscape: [{
    max: 30,
    size: 100
  }, {
    max: 40,
    size: 90
  }, {
    max: 50,
    size: 80
  }, {
    max: 1 / 0,
    size: 70
  }],
  vertical: [{
    max: 30,
    size: 85
  }, {
    max: 40,
    size: 80
  }, {
    max: 50,
    size: 75
  }, {
    max: 1 / 0,
    size: 70
  }]
}, S7 = {
  portrait: [{
    max: 60,
    size: 120
  }, {
    max: 1 / 0,
    size: 90
  }],
  landscape: [{
    max: 60,
    size: 70
  }, {
    max: 1 / 0,
    size: 60
  }],
  vertical: [{
    max: 60,
    size: 75
  }, {
    max: 1 / 0,
    size: 50
  }]
}, A7 = (t = 30, e, a) => {
  const n = a ? S7 : U7;
  return (n[e] || n.portrait).find(({
    max: s
  }) => t < s).size;
}, I7 = (t) => t === "portrait" ? {
  min: 85,
  max: 110
} : t === "landscape" ? {
  min: 60,
  max: 66
} : {
  min: 45,
  max: 65
}, jt = q.span.withConfig({
  displayName: "JobTitle",
  componentId: "sc-3vbq3-0"
})(["font-size:", "px;font-style:normal;color:", ";background-color:", ";&&&{font-family:", ',"Nunito",sans-serif;}'], ({
  titleSize: t
}) => t, ({
  color: t
}) => t || "white", ({
  backgroundColor: t
}) => t || "white", ({
  fontFamily: t
}) => t), _n = q.div.withConfig({
  displayName: "SubText",
  componentId: "sc-3vbq3-1"
})(["font-style:normal;font-weight:500;margin:0;line-height:1.3;max-width:100%;color:", ";background-color:", ";> div{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}&&&{font-family:", ",sans-serif;}"], ({
  subColor: t
}) => t || "#F8F8F8", ({
  subBgColor: t
}) => t || "#000000", ({
  fontFamily: t
}) => t), D7 = q.div.withConfig({
  displayName: "NewTitleWrapper",
  componentId: "sc-3vbq3-2"
})(["position:absolute;right:0;bottom:0;display:flex;flex-direction:column;align-items:flex-end;", "{border-radius:0;font-weight:500;line-height:1.5;text-align:left;}", ""], jt, ({
  orientation: t
}) => Se(t === "landscape" ? ["bottom:100px;width:1000px;", "{padding:40px 50px 45px 60px;}", "{padding:30px 50px;min-width:590px;}"] : t === "vertical" ? ["bottom:360px;width:960px;", "{padding:40px 50px 45px 60px;}", "{padding:20px 50px;min-width:520px;}"] : ["bottom:240px;width:1700px;", "{padding:50px 90px 55px 100px;}", "{padding:40px 80px;min-width:900px;}"], jt, _n)), B7 = q.div.withConfig({
  displayName: "TitleWrapper",
  componentId: "sc-3vbq3-3"
})(["position:absolute;right:0;bottom:0;text-align:right;", "{border-radius:30px 0 0 30px;text-align:right;box-decoration-break:clone;font-weight:700;line-height:1.6;}", ""], jt, ({
  orientation: t
}) => Se(t === "landscape" ? ["transform:translateY(-50%);min-width:75%;max-width:90%;", "{padding:20px 30px;}"] : t === "vertical" ? ["transform:translateY(-80%);min-width:75%;max-width:95%;", "{padding:25px 40px;}"] : ["transform:translateY(-40%);min-width:75%;max-width:90%;", "{padding:25px 40px;}"], jt)), R7 = ({
  text: t,
  secondaryText: e,
  primaryTextColor: a,
  primaryBackgroundColor: n,
  secondaryTextColor: i,
  secondaryBackgroundColor: o,
  fontFamily: s,
  orientation: r,
  isNewCampaign: c
}) => {
  if (!t) return null;
  const l = A7(t == null ? void 0 : t.length, r, c), {
    min: f,
    max: m
  } = I7(r), v = /* @__PURE__ */ h.jsx(jt, { color: a, backgroundColor: n, titleSize: l, textLength: t == null ? void 0 : t.length, fontFamily: s, orientation: r, children: Kt(t) });
  return c ? /* @__PURE__ */ h.jsxs(D7, { orientation: r, children: [
    v,
    e && /* @__PURE__ */ h.jsx(_n, { subColor: i, subBgColor: o, fontFamily: s, children: /* @__PURE__ */ h.jsx(Kn, { mode: "oneline", minFontSizePx: f, maxFontSizePx: m, children: Kt(e) }) })
  ] }) : /* @__PURE__ */ h.jsx(B7, { orientation: r, children: v });
}, O7 = q.div.withConfig({
  displayName: "ImgWrapper",
  componentId: "sc-1gtkl5z-0"
})(["position:relative;overflow:hidden;height:100%;width:100%;"]), P7 = q(Vn).withConfig({
  displayName: "VideoRemotionPlayer",
  componentId: "sc-1gtkl5z-1"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:100%;object-fit:cover;"]), N7 = ({
  src: t,
  orientation: e
}) => t ? /* @__PURE__ */ h.jsx(O7, { orientation: e, children: /* @__PURE__ */ h.jsx(P7, { src: t, alt: "background video" }) }) : null, M7 = q.div.withConfig({
  displayName: "MainWrapper",
  componentId: "sc-1nxxezh-0"
})(["position:relative;width:100%;height:100%;border-radius:inherit;"]);
q(pt).withConfig({
  displayName: "BackgroundImage",
  componentId: "sc-1nxxezh-1"
})(["width:100%;height:100%;object-fit:cover;"]);
u.object({
  orientation: u.enum(["portrait", "vertical", "landscape"]).optional(),
  backgroundImage: u.string().url(),
  primaryTextColor: W().optional(),
  primaryBackgroundColor: W().optional(),
  secondaryTextColor: W().optional(),
  secondaryBackgroundColor: W().optional(),
  textColor: W().optional(),
  backgroundColor: W().optional(),
  text: u.string().optional(),
  textSize: u.number().optional(),
  secondaryText: u.string().default("Bist du bereit?").optional(),
  logo: u.string().url().optional(),
  logoFormat: u.enum(["square", "landscape"]).optional(),
  logoPosition: u.enum(["top-left", "top-right", "bottom-left", "bottom-right"]).optional(),
  logoSize: u.enum(["small", "mid", "big"]).optional(),
  width: u.number().default(400).optional(),
  isVideo: u.boolean().default(!0).optional(),
  isNewCampaign: u.boolean().default(!0).optional(),
  fontFamily: u.string().optional(),
  customFont: u.object({
    name: u.string(),
    url: u.string()
  }).optional()
});
const V7 = ({
  audioUrl: t,
  orientation: e = "portrait",
  backgroundImage: a,
  textColor: n,
  backgroundColor: i,
  text: o,
  secondaryText: s,
  textSize: r,
  logo: c,
  logoFormat: l = "square",
  logoPosition: f = "top-left",
  logoSize: m = "small",
  width: v,
  isNewCampaign: k,
  fontFamily: C = "Rubik",
  customFont: E,
  primaryTextColor: b = "#F8F8F8",
  primaryBackgroundColor: D = "#25414B",
  secondaryTextColor: j = "#198E93",
  secondaryBackgroundColor: x = "#F8F8F8"
}) => {
  const _ = e || "portrait", {
    aspectRatio: y,
    width: H,
    height: $
  } = Ie[_], Y = Math.round(v / y), ae = Wt(H, $, v, Y);
  qt(C, E);
  const ve = (E == null ? void 0 : E.name) === C, de = Lt(ve ? null : C), N = ve ? C : de, P = /* @__PURE__ */ h.jsxs(M7, { children: [
    /* @__PURE__ */ h.jsx(la, { logo: c, logoPosition: f, offset: 2, elementSize: m, logoFormat: l, orientation: _ }),
    a ? /* @__PURE__ */ h.jsx(N7, { src: a, orientation: _ }) : null,
    /* @__PURE__ */ h.jsx(R7, { text: o, secondaryText: s, primaryTextColor: n || b, primaryBackgroundColor: i || D, secondaryTextColor: n || j, secondaryBackgroundColor: i || x, textSize: r, fontFamily: N, orientation: _, isNewCampaign: k })
  ] });
  return /* @__PURE__ */ h.jsxs("div", { style: {
    width: "100%",
    height: "100%"
  }, children: [
    t && /* @__PURE__ */ h.jsx(Audio, { src: t, volume: 1, startFrom: 0 }),
    /* @__PURE__ */ h.jsx("div", { style: {
      position: "relative",
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }, children: /* @__PURE__ */ h.jsx(Yt, { originalWidth: H, originalHeight: $, scaleFactor: ae, children: P }) })
  ] });
}, ca = [{
  value: "portrait",
  label: "Portrait"
}, {
  value: "landscape",
  label: "Landscape"
}, {
  value: "vertical",
  label: "Vertical"
}], X7 = (
  /** @type {const} */
  {
    type: "image",
    id: "WaveImage",
    preview: "/images/mediaTemplatePreviews/preview__ImageLogoText.svg",
    label: "Wavey",
    height: Ie.portrait.height,
    width: Ie.portrait.width,
    aspectRatio: 1,
    orientation: "multi",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [{
        key: "orientation",
        type: "select",
        label: "Orientation",
        options: ca
      }, {
        key: "backgroundImage",
        type: "image",
        label: "Hintergrund Bild"
      }, {
        key: "logo",
        type: "image",
        label: "Logo",
        isLogo: !0
      }, {
        key: "logoPosition",
        type: "select",
        label: "Logo Position",
        options: It
      }, {
        key: "logoSize",
        type: "select",
        label: "Logo Size",
        options: At
      }, {
        key: "text",
        type: "text",
        label: "Title"
      }, {
        key: "secondaryText",
        type: "text",
        label: "Überschrift"
      }, {
        key: "CTAText",
        type: "text",
        label: "CTA"
      }, {
        key: "primaryTextColor",
        type: "color",
        label: "Text Farbe"
      }, {
        key: "primaryBackgroundColor",
        type: "color",
        label: "Hintergrund Farbe"
      }, {
        key: "secondaryBackgroundColor",
        type: "color",
        label: "Sekundär Farbe"
      }]
    }]
  }
), K7 = (
  /** @type {const} */
  {
    type: "image",
    id: "OneToneImage",
    preview: "/images/mediaTemplatePreviews/preview__ImageLogoText.svg",
    label: "One Tone",
    height: Ie.portrait.height,
    width: Ie.portrait.width,
    aspectRatio: 1,
    orientation: "multi",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [{
        key: "orientation",
        type: "select",
        label: "Orientation",
        options: ca
      }, {
        key: "backgroundImage",
        type: "image",
        label: "Hintergrund Bild"
      }, {
        key: "logo",
        type: "image",
        label: "Logo",
        isLogo: !0
      }, {
        key: "logoPosition",
        type: "select",
        label: "Logo Position",
        options: It
      }, {
        key: "logoSize",
        type: "select",
        label: "Logo Size",
        options: At
      }, {
        key: "text",
        type: "text",
        label: "Title"
      }, {
        key: "secondaryText",
        type: "text",
        label: "Überschrift"
      }, {
        key: "CTAText",
        type: "text",
        label: "CTA"
      }, {
        key: "primaryTextColor",
        type: "color",
        label: "Text Farbe"
      }, {
        key: "primaryBackgroundColor",
        type: "color",
        label: "Hintergrund Farbe"
      }]
    }]
  }
), L7 = (
  /** @type {const} */
  {
    type: "image",
    id: "DefaultImage",
    preview: "/images/mediaTemplatePreviews/preview__ImageLogoText.svg",
    label: "Default",
    height: Ie.portrait.height,
    width: Ie.portrait.width,
    aspectRatio: 1,
    orientation: "multi",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [{
        key: "orientation",
        type: "select",
        label: "Orientation",
        options: ca
      }, {
        key: "backgroundImage",
        type: "image",
        label: "Hintergrund Bild"
      }, {
        key: "logo",
        type: "image",
        label: "Logo",
        isLogo: !0
      }, {
        key: "logoPosition",
        type: "select",
        label: "Logo Position",
        options: It
      }, {
        key: "logoSize",
        type: "select",
        label: "Logo Size",
        options: At
      }, {
        key: "text",
        type: "text",
        label: "Title"
      }, {
        key: "secondaryText",
        type: "text",
        label: "Überschrift"
      }, {
        key: "primaryTextColor",
        type: "color",
        label: "Text Farbe"
      }, {
        key: "primaryBackgroundColor",
        type: "color",
        label: "Hintergrund Farbe"
      }, {
        key: "secondaryTextColor",
        type: "color",
        label: "Sekundäre Textfarbe"
      }, {
        key: "secondaryBackgroundColor",
        type: "color",
        label: "Sekundär Farbe"
      }]
    }]
  }
), ru = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DefaultImage: L7,
  LandscapeImage: ga,
  OneToneImage: K7,
  PortraitImage: ha,
  ShapeImage: ya,
  VerticalImage: ba,
  WaveImage: X7
}, Symbol.toStringTag, { value: "Module" })), q7 = (
  /** @type {const} */
  [{
    key: "imageUrl",
    type: "image",
    label: "Main Image"
  }, {
    key: "logoUrl",
    type: "image",
    label: "Logo",
    isLogo: !0
  }]
), W7 = (
  /** @type {const} */
  [{
    key: "audioUrl",
    type: "audio",
    label: "Musik"
  }]
), Y7 = (
  /** @type {const} */
  [{
    key: "primaryBackgroundColor",
    type: "color",
    label: "Hintergrund Farbe"
  }, {
    key: "primaryTextColor",
    type: "color",
    label: "Text Farbe"
  }]
), $7 = [{
  key: "benefits1",
  type: "text",
  label: "Benefits 1",
  maxCharacters: 55
}, {
  key: "benefits2",
  type: "text",
  label: "Benefits 2",
  maxCharacters: 55
}, {
  key: "benefits3",
  type: "text",
  label: "Benefits 3",
  maxCharacters: 55
}], H7 = [{
  key: "benefits",
  type: "array",
  label: "Benefits",
  elements: $7
}], Z7 = (
  /** @type {const} */
  [{
    key: "title",
    type: "text",
    label: "Title",
    maxCharacters: 104
  }, {
    key: "CTAText",
    type: "text",
    label: "Call to Action Text",
    maxCharacters: 28
  }, {
    key: "outroText",
    type: "text",
    label: "Outro Text",
    maxCharacters: 30
  }]
), J7 = (
  /** @type {const} */
  {
    type: "video",
    id: "TikTokVideo",
    preview: "/images/mediaTemplatePreviews/preview__ImageLogo.svg",
    // to do: replace with actual preview
    label: "TikTok Video",
    height: 764,
    width: 385,
    aspectRatio: 1,
    orientation: "vertical",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [...q7, ...Y7, ...Z7, ...W7, ...H7]
    }]
  }
), G7 = (
  /** @type {const} */
  {
    type: "video",
    id: "RawVideo",
    preview: "/images/mediaTemplatePreviews/preview__ImageLogoText.svg",
    label: "Upload Video",
    width: 1920,
    height: 1080,
    aspectRatio: 1.78,
    orientation: "multi",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [{
        key: "video",
        type: "video",
        label: "Uploaded Video"
      }, {
        key: "orientation",
        type: "select",
        label: "Orientation",
        options: ca
      }, {
        key: "audioUrl",
        type: "audio",
        label: "Music"
      }]
    }]
  }
), Q7 = (
  /** @type {const} */
  {
    type: "video",
    id: "PortraitVideo",
    preview: "/images/mediaTemplatePreviews/preview__ImageLogoText.svg",
    label: "Portrait Video",
    height: Ie.portrait.height,
    width: Ie.portrait.width,
    aspectRatio: 1,
    orientation: "portrait",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [{
        key: "backgroundImage",
        type: "image",
        label: "Hintergrund Bild"
      }, {
        key: "logoUrl",
        type: "image",
        label: "Logo",
        isLogo: !0
      }, {
        key: "text",
        type: "text",
        label: "Title"
      }, {
        key: "primaryTextColor",
        type: "color",
        label: "Text Farbe"
      }, {
        key: "primaryBackgroundColor",
        type: "color",
        label: "Hintergrund Farbe"
      }]
    }]
  }
), eu = (
  /** @type {const} */
  {
    type: "video",
    id: "LandscapeVideo",
    preview: "/images/mediaTemplatePreviews/preview__LandscapeLogo.svg",
    label: "Landscape Video",
    height: Ie.landscape.height,
    width: Ie.landscape.width,
    aspectRatio: 1.91,
    orientation: "landscape",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [{
        key: "backgroundImage",
        type: "image",
        label: "Hintergrund Bild"
      }, {
        key: "logoUrl",
        type: "image",
        label: "Logo",
        isLogo: !0
      }, {
        key: "text",
        type: "text",
        label: "Title"
      }, {
        key: "primaryTextColor",
        type: "color",
        label: "Text Farbe"
      }, {
        key: "primaryBackgroundColor",
        type: "color",
        label: "Hintergrund Farbe"
      }]
    }]
  }
), tu = (
  /** @type {const} */
  {
    type: "video",
    id: "VerticalVideo",
    preview: "/images/mediaTemplatePreviews/preview__ImageLogoText.svg",
    label: "Vertical Video",
    height: Ie.vertical.height,
    width: Ie.vertical.width,
    aspectRatio: 0.5625,
    orientation: "vertical",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [{
        key: "backgroundImage",
        type: "image",
        label: "Hintergrund Bild"
      }, {
        key: "logoUrl",
        type: "image",
        label: "Logo",
        isLogo: !0
      }, {
        key: "text",
        type: "text",
        label: "Title"
      }, {
        key: "primaryTextColor",
        type: "color",
        label: "Text Farbe"
      }, {
        key: "primaryBackgroundColor",
        type: "color",
        label: "Hintergrund Farbe"
      }]
    }]
  }
), au = (
  /** @type {const} */
  {
    type: "video",
    id: "OneToneVideo",
    preview: "/images/mediaTemplatePreviews/preview__ImageLogoText.svg",
    label: "One Tone",
    height: Ie.portrait.height,
    width: Ie.portrait.width,
    aspectRatio: 1,
    orientation: "multi",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [{
        key: "orientation",
        type: "select",
        label: "Orientation",
        options: ca
      }, {
        key: "backgroundImage",
        type: "image",
        label: "Hintergrund Bild"
      }, {
        key: "logo",
        type: "image",
        label: "Logo",
        isLogo: !0
      }, {
        key: "logoPosition",
        type: "select",
        label: "Logo Position",
        options: It
      }, {
        key: "logoSize",
        type: "select",
        label: "Logo Size",
        options: At
      }, {
        key: "text",
        type: "text",
        label: "Title"
      }, {
        key: "secondaryText",
        type: "text",
        label: "Überschrift"
      }, {
        key: "CTAText",
        type: "text",
        label: "CTA"
      }, {
        key: "primaryTextColor",
        type: "color",
        label: "Text Farbe"
      }, {
        key: "primaryBackgroundColor",
        type: "color",
        label: "Hintergrund Farbe"
      }]
    }]
  }
), nu = (
  /** @type {const} */
  {
    type: "video",
    id: "WaveVideo",
    preview: "/images/mediaTemplatePreviews/preview__ImageLogoText.svg",
    label: "Wavey",
    height: Ie.portrait.height,
    width: Ie.portrait.width,
    aspectRatio: 1,
    orientation: "multi",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [{
        key: "orientation",
        type: "select",
        label: "Orientation",
        options: ca
      }, {
        key: "backgroundImage",
        type: "image",
        label: "Hintergrund Bild"
      }, {
        key: "logo",
        type: "image",
        label: "Logo",
        isLogo: !0
      }, {
        key: "logoPosition",
        type: "select",
        label: "Logo Position",
        options: It
      }, {
        key: "logoSize",
        type: "select",
        label: "Logo Size",
        options: At
      }, {
        key: "text",
        type: "text",
        label: "Title"
      }, {
        key: "secondaryText",
        type: "text",
        label: "Überschrift"
      }, {
        key: "CTAText",
        type: "text",
        label: "CTA"
      }, {
        key: "primaryTextColor",
        type: "color",
        label: "Text Farbe"
      }, {
        key: "primaryBackgroundColor",
        type: "color",
        label: "Hintergrund Farbe"
      }, {
        key: "secondaryBackgroundColor",
        type: "color",
        label: "Sekundär Farbe"
      }]
    }]
  }
), iu = (
  /** @type {const} */
  {
    type: "video",
    id: "DefaultVideo",
    preview: "/images/mediaTemplatePreviews/preview__ImageLogoText.svg",
    label: "Default Video",
    height: Ie.portrait.height,
    width: Ie.portrait.width,
    aspectRatio: 1,
    orientation: "multi",
    scenes: [{
      timeRange: {
        start: null,
        end: null
      },
      inputs: [{
        key: "orientation",
        type: "select",
        label: "Orientation",
        options: ca
      }, {
        key: "backgroundImage",
        type: "video",
        label: "Hintergrund Video"
      }, {
        key: "logo",
        type: "image",
        label: "Logo",
        isLogo: !0
      }, {
        key: "logoPosition",
        type: "select",
        label: "Logo Position",
        options: It
      }, {
        key: "logoSize",
        type: "select",
        label: "Logo Size",
        options: At
      }, {
        key: "text",
        type: "text",
        label: "Title"
      }, {
        key: "secondaryText",
        type: "text",
        label: "Überschrift"
      }, {
        key: "primaryTextColor",
        type: "color",
        label: "Text Farbe"
      }, {
        key: "primaryBackgroundColor",
        type: "color",
        label: "Hintergrund Farbe"
      }, {
        key: "secondaryTextColor",
        type: "color",
        label: "Sekundäre Textfarbe"
      }, {
        key: "secondaryBackgroundColor",
        type: "color",
        label: "Sekundär Farbe"
      }]
    }]
  }
), lu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DefaultVideo: iu,
  LandscapeVideo: eu,
  OneToneVideo: au,
  PortraitVideo: Q7,
  RawVideo: G7,
  TikTokVideo: J7,
  VerticalVideo: tu,
  WaveVideo: nu
}, Symbol.toStringTag, { value: "Module" })), cu = {
  DefaultImage: Ln,
  OneToneImage: Vs,
  WaveImage: Ps,
  PortraitImage: l0,
  LandscapeImage: p0,
  VerticalImage: k0,
  ShapeImage: R0
}, uu = {
  RawVideo: T7,
  TikTokVideo: A1,
  LandscapeVideo: $c,
  PortraitVideo: Hc,
  VerticalVideo: z7,
  OneToneVideo: E7,
  WaveVideo: j7,
  DefaultVideo: V7
};
export {
  Ie as DIMENSIONS_BY_ORIENTATION,
  Ln as DefaultImage,
  V7 as DefaultVideo,
  cu as IMAGE_TEMPLATES,
  ru as IMAGE_TEMPLATES_INFO,
  p0 as LandscapeImage,
  $c as LandscapeVideo,
  Vs as OneToneImage,
  E7 as OneToneVideo,
  l0 as PortraitImage,
  Hc as PortraitVideo,
  T7 as RawVideo,
  R0 as ShapeImage,
  A1 as TikTokVideo,
  uu as VIDEO_TEMPLATES,
  lu as VIDEO_TEMPLATES_INFO,
  k0 as VerticalImage,
  z7 as VerticalVideo,
  Ps as WaveImage,
  j7 as WaveVideo
};
